
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8b74"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8b74"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gGb7Q", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $c24932dc0da5935c$export$ffb0004e005737fa, (v) => $c24932dc0da5935c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $c24932dc0da5935c$export$34b9dba7ce09269b, (v) => $c24932dc0da5935c$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $c24932dc0da5935c$export$25062201e9e25d76, (v) => $c24932dc0da5935c$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c24932dc0da5935c$export$ffb0004e005737fa;
var $c24932dc0da5935c$export$34b9dba7ce09269b;
var $c24932dc0da5935c$export$25062201e9e25d76;
"use strict";

var $eFMZj = parcelRequire("eFMZj");
var $c24932dc0da5935c$var$k = Symbol.for("react.element"), $c24932dc0da5935c$var$l = Symbol.for("react.fragment"), $c24932dc0da5935c$var$m = Object.prototype.hasOwnProperty, $c24932dc0da5935c$var$n = $eFMZj.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c24932dc0da5935c$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c24932dc0da5935c$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c24932dc0da5935c$var$m.call(a, b) && !$c24932dc0da5935c$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c24932dc0da5935c$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c24932dc0da5935c$var$n.current
    };
}
$c24932dc0da5935c$export$ffb0004e005737fa = $c24932dc0da5935c$var$l;
$c24932dc0da5935c$export$34b9dba7ce09269b = $c24932dc0da5935c$var$q;
$c24932dc0da5935c$export$25062201e9e25d76 = $c24932dc0da5935c$var$q;

});
parcelRegister("eFMZj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4jvq2"));

});
parcelRegister("4jvq2", function(module, exports) {

$parcel$export(module.exports, "Children", () => $32414eef17a49ce2$export$dca3b0875bd9a954, (v) => $32414eef17a49ce2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $32414eef17a49ce2$export$16fa2f45be04daa8, (v) => $32414eef17a49ce2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $32414eef17a49ce2$export$ffb0004e005737fa, (v) => $32414eef17a49ce2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $32414eef17a49ce2$export$e2c29f18771995cb, (v) => $32414eef17a49ce2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $32414eef17a49ce2$export$221d75b3f55bb0bd, (v) => $32414eef17a49ce2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $32414eef17a49ce2$export$5f8d39834fd61797, (v) => $32414eef17a49ce2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $32414eef17a49ce2$export$74bf444e3cd11ea5, (v) => $32414eef17a49ce2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $32414eef17a49ce2$export$ae55be85d98224ed, (v) => $32414eef17a49ce2$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $32414eef17a49ce2$export$3ba232387fd5d6dd, (v) => $32414eef17a49ce2$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $32414eef17a49ce2$export$e530037191fcd5d7, (v) => $32414eef17a49ce2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $32414eef17a49ce2$export$fd42f52fd3ae1109, (v) => $32414eef17a49ce2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $32414eef17a49ce2$export$c8a8987d4410bf2d, (v) => $32414eef17a49ce2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $32414eef17a49ce2$export$d38cd72104c1f0e9, (v) => $32414eef17a49ce2$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $32414eef17a49ce2$export$7d1e3a5e95ceca43, (v) => $32414eef17a49ce2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $32414eef17a49ce2$export$257a8862b851cb5b, (v) => $32414eef17a49ce2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $32414eef17a49ce2$export$a8257692ac88316c, (v) => $32414eef17a49ce2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $32414eef17a49ce2$export$488013bae63b21da, (v) => $32414eef17a49ce2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $32414eef17a49ce2$export$7c73462e0d25e514, (v) => $32414eef17a49ce2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $32414eef17a49ce2$export$7568632d0d33d16d, (v) => $32414eef17a49ce2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $32414eef17a49ce2$export$88948ce120ea2619, (v) => $32414eef17a49ce2$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $32414eef17a49ce2$export$35808ee640e87ca7, (v) => $32414eef17a49ce2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $32414eef17a49ce2$export$fae74005e78b1a27, (v) => $32414eef17a49ce2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $32414eef17a49ce2$export$dc8fbce3eb94dc1e, (v) => $32414eef17a49ce2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $32414eef17a49ce2$export$6a7bc4e911dc01cf, (v) => $32414eef17a49ce2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $32414eef17a49ce2$export$6d9c69b0de29b591, (v) => $32414eef17a49ce2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $32414eef17a49ce2$export$f680877a34711e37, (v) => $32414eef17a49ce2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $32414eef17a49ce2$export$d5a552a76deda3c2, (v) => $32414eef17a49ce2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $32414eef17a49ce2$export$aaabe4eda9ed9969, (v) => $32414eef17a49ce2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $32414eef17a49ce2$export$e5c5a5f917a5871c, (v) => $32414eef17a49ce2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $32414eef17a49ce2$export$1538c33de8887b59, (v) => $32414eef17a49ce2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $32414eef17a49ce2$export$13e3392192263954, (v) => $32414eef17a49ce2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $32414eef17a49ce2$export$b8f5890fc79d6aca, (v) => $32414eef17a49ce2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $32414eef17a49ce2$export$60241385465d0a34, (v) => $32414eef17a49ce2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $32414eef17a49ce2$export$306c0aa65ff9ec16, (v) => $32414eef17a49ce2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $32414eef17a49ce2$export$7b286972b8d8ccbf, (v) => $32414eef17a49ce2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $32414eef17a49ce2$export$83d89fbfd8236492, (v) => $32414eef17a49ce2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $32414eef17a49ce2$export$dca3b0875bd9a954;
var $32414eef17a49ce2$export$16fa2f45be04daa8;
var $32414eef17a49ce2$export$ffb0004e005737fa;
var $32414eef17a49ce2$export$e2c29f18771995cb;
var $32414eef17a49ce2$export$221d75b3f55bb0bd;
var $32414eef17a49ce2$export$5f8d39834fd61797;
var $32414eef17a49ce2$export$74bf444e3cd11ea5;
var $32414eef17a49ce2$export$ae55be85d98224ed;
var $32414eef17a49ce2$export$3ba232387fd5d6dd;
var $32414eef17a49ce2$export$e530037191fcd5d7;
var $32414eef17a49ce2$export$fd42f52fd3ae1109;
var $32414eef17a49ce2$export$c8a8987d4410bf2d;
var $32414eef17a49ce2$export$d38cd72104c1f0e9;
var $32414eef17a49ce2$export$7d1e3a5e95ceca43;
var $32414eef17a49ce2$export$257a8862b851cb5b;
var $32414eef17a49ce2$export$a8257692ac88316c;
var $32414eef17a49ce2$export$488013bae63b21da;
var $32414eef17a49ce2$export$7c73462e0d25e514;
var $32414eef17a49ce2$export$7568632d0d33d16d;
var $32414eef17a49ce2$export$88948ce120ea2619;
var $32414eef17a49ce2$export$35808ee640e87ca7;
var $32414eef17a49ce2$export$fae74005e78b1a27;
var $32414eef17a49ce2$export$dc8fbce3eb94dc1e;
var $32414eef17a49ce2$export$6a7bc4e911dc01cf;
var $32414eef17a49ce2$export$6d9c69b0de29b591;
var $32414eef17a49ce2$export$f680877a34711e37;
var $32414eef17a49ce2$export$d5a552a76deda3c2;
var $32414eef17a49ce2$export$aaabe4eda9ed9969;
var $32414eef17a49ce2$export$e5c5a5f917a5871c;
var $32414eef17a49ce2$export$1538c33de8887b59;
var $32414eef17a49ce2$export$13e3392192263954;
var $32414eef17a49ce2$export$b8f5890fc79d6aca;
var $32414eef17a49ce2$export$60241385465d0a34;
var $32414eef17a49ce2$export$306c0aa65ff9ec16;
var $32414eef17a49ce2$export$7b286972b8d8ccbf;
var $32414eef17a49ce2$export$83d89fbfd8236492;
"use strict";
var $32414eef17a49ce2$var$l = Symbol.for("react.element"), $32414eef17a49ce2$var$n = Symbol.for("react.portal"), $32414eef17a49ce2$var$p = Symbol.for("react.fragment"), $32414eef17a49ce2$var$q = Symbol.for("react.strict_mode"), $32414eef17a49ce2$var$r = Symbol.for("react.profiler"), $32414eef17a49ce2$var$t = Symbol.for("react.provider"), $32414eef17a49ce2$var$u = Symbol.for("react.context"), $32414eef17a49ce2$var$v = Symbol.for("react.forward_ref"), $32414eef17a49ce2$var$w = Symbol.for("react.suspense"), $32414eef17a49ce2$var$x = Symbol.for("react.memo"), $32414eef17a49ce2$var$y = Symbol.for("react.lazy"), $32414eef17a49ce2$var$z = Symbol.iterator;
function $32414eef17a49ce2$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $32414eef17a49ce2$var$z && a[$32414eef17a49ce2$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $32414eef17a49ce2$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $32414eef17a49ce2$var$C = Object.assign, $32414eef17a49ce2$var$D = {};
function $32414eef17a49ce2$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $32414eef17a49ce2$var$D;
    this.updater = e || $32414eef17a49ce2$var$B;
}
$32414eef17a49ce2$var$E.prototype.isReactComponent = {};
$32414eef17a49ce2$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$32414eef17a49ce2$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $32414eef17a49ce2$var$F() {}
$32414eef17a49ce2$var$F.prototype = $32414eef17a49ce2$var$E.prototype;
function $32414eef17a49ce2$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $32414eef17a49ce2$var$D;
    this.updater = e || $32414eef17a49ce2$var$B;
}
var $32414eef17a49ce2$var$H = $32414eef17a49ce2$var$G.prototype = new $32414eef17a49ce2$var$F;
$32414eef17a49ce2$var$H.constructor = $32414eef17a49ce2$var$G;
$32414eef17a49ce2$var$C($32414eef17a49ce2$var$H, $32414eef17a49ce2$var$E.prototype);
$32414eef17a49ce2$var$H.isPureReactComponent = !0;
var $32414eef17a49ce2$var$I = Array.isArray, $32414eef17a49ce2$var$J = Object.prototype.hasOwnProperty, $32414eef17a49ce2$var$K = {
    current: null
}, $32414eef17a49ce2$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $32414eef17a49ce2$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$32414eef17a49ce2$var$J.call(b, d) && !$32414eef17a49ce2$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $32414eef17a49ce2$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $32414eef17a49ce2$var$K.current
    };
}
function $32414eef17a49ce2$var$N(a, b) {
    return {
        $$typeof: $32414eef17a49ce2$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $32414eef17a49ce2$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $32414eef17a49ce2$var$l;
}
function $32414eef17a49ce2$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $32414eef17a49ce2$var$P = /\/+/g;
function $32414eef17a49ce2$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $32414eef17a49ce2$var$escape("" + a.key) : b.toString(36);
}
function $32414eef17a49ce2$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $32414eef17a49ce2$var$l:
                case $32414eef17a49ce2$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $32414eef17a49ce2$var$Q(h, 0) : d, $32414eef17a49ce2$var$I(c) ? (e = "", null != a && (e = a.replace($32414eef17a49ce2$var$P, "$&/") + "/"), $32414eef17a49ce2$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($32414eef17a49ce2$var$O(c) && (c = $32414eef17a49ce2$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($32414eef17a49ce2$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($32414eef17a49ce2$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $32414eef17a49ce2$var$Q(k, g);
        h += $32414eef17a49ce2$var$R(k, b, e, f, c);
    }
    else if (f = $32414eef17a49ce2$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $32414eef17a49ce2$var$Q(k, g++), h += $32414eef17a49ce2$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $32414eef17a49ce2$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $32414eef17a49ce2$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $32414eef17a49ce2$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $32414eef17a49ce2$var$U = {
    current: null
}, $32414eef17a49ce2$var$V = {
    transition: null
}, $32414eef17a49ce2$var$W = {
    ReactCurrentDispatcher: $32414eef17a49ce2$var$U,
    ReactCurrentBatchConfig: $32414eef17a49ce2$var$V,
    ReactCurrentOwner: $32414eef17a49ce2$var$K
};
function $32414eef17a49ce2$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$32414eef17a49ce2$export$dca3b0875bd9a954 = {
    map: $32414eef17a49ce2$var$S,
    forEach: function(a, b, e) {
        $32414eef17a49ce2$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $32414eef17a49ce2$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $32414eef17a49ce2$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$32414eef17a49ce2$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$32414eef17a49ce2$export$16fa2f45be04daa8 = $32414eef17a49ce2$var$E;
$32414eef17a49ce2$export$ffb0004e005737fa = $32414eef17a49ce2$var$p;
$32414eef17a49ce2$export$e2c29f18771995cb = $32414eef17a49ce2$var$r;
$32414eef17a49ce2$export$221d75b3f55bb0bd = $32414eef17a49ce2$var$G;
$32414eef17a49ce2$export$5f8d39834fd61797 = $32414eef17a49ce2$var$q;
$32414eef17a49ce2$export$74bf444e3cd11ea5 = $32414eef17a49ce2$var$w;
$32414eef17a49ce2$export$ae55be85d98224ed = $32414eef17a49ce2$var$W;
$32414eef17a49ce2$export$3ba232387fd5d6dd = $32414eef17a49ce2$var$X;
$32414eef17a49ce2$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $32414eef17a49ce2$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $32414eef17a49ce2$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$32414eef17a49ce2$var$J.call(b, f) && !$32414eef17a49ce2$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $32414eef17a49ce2$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$32414eef17a49ce2$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $32414eef17a49ce2$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $32414eef17a49ce2$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$32414eef17a49ce2$export$c8a8987d4410bf2d = $32414eef17a49ce2$var$M;
$32414eef17a49ce2$export$d38cd72104c1f0e9 = function(a) {
    var b = $32414eef17a49ce2$var$M.bind(null, a);
    b.type = a;
    return b;
};
$32414eef17a49ce2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$32414eef17a49ce2$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $32414eef17a49ce2$var$v,
        render: a
    };
};
$32414eef17a49ce2$export$a8257692ac88316c = $32414eef17a49ce2$var$O;
$32414eef17a49ce2$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $32414eef17a49ce2$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $32414eef17a49ce2$var$T
    };
};
$32414eef17a49ce2$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $32414eef17a49ce2$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$32414eef17a49ce2$export$7568632d0d33d16d = function(a) {
    var b = $32414eef17a49ce2$var$V.transition;
    $32414eef17a49ce2$var$V.transition = {};
    try {
        a();
    } finally{
        $32414eef17a49ce2$var$V.transition = b;
    }
};
$32414eef17a49ce2$export$88948ce120ea2619 = $32414eef17a49ce2$var$X;
$32414eef17a49ce2$export$35808ee640e87ca7 = function(a, b) {
    return $32414eef17a49ce2$var$U.current.useCallback(a, b);
};
$32414eef17a49ce2$export$fae74005e78b1a27 = function(a) {
    return $32414eef17a49ce2$var$U.current.useContext(a);
};
$32414eef17a49ce2$export$dc8fbce3eb94dc1e = function() {};
$32414eef17a49ce2$export$6a7bc4e911dc01cf = function(a) {
    return $32414eef17a49ce2$var$U.current.useDeferredValue(a);
};
$32414eef17a49ce2$export$6d9c69b0de29b591 = function(a, b) {
    return $32414eef17a49ce2$var$U.current.useEffect(a, b);
};
$32414eef17a49ce2$export$f680877a34711e37 = function() {
    return $32414eef17a49ce2$var$U.current.useId();
};
$32414eef17a49ce2$export$d5a552a76deda3c2 = function(a, b, e) {
    return $32414eef17a49ce2$var$U.current.useImperativeHandle(a, b, e);
};
$32414eef17a49ce2$export$aaabe4eda9ed9969 = function(a, b) {
    return $32414eef17a49ce2$var$U.current.useInsertionEffect(a, b);
};
$32414eef17a49ce2$export$e5c5a5f917a5871c = function(a, b) {
    return $32414eef17a49ce2$var$U.current.useLayoutEffect(a, b);
};
$32414eef17a49ce2$export$1538c33de8887b59 = function(a, b) {
    return $32414eef17a49ce2$var$U.current.useMemo(a, b);
};
$32414eef17a49ce2$export$13e3392192263954 = function(a, b, e) {
    return $32414eef17a49ce2$var$U.current.useReducer(a, b, e);
};
$32414eef17a49ce2$export$b8f5890fc79d6aca = function(a) {
    return $32414eef17a49ce2$var$U.current.useRef(a);
};
$32414eef17a49ce2$export$60241385465d0a34 = function(a) {
    return $32414eef17a49ce2$var$U.current.useState(a);
};
$32414eef17a49ce2$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $32414eef17a49ce2$var$U.current.useSyncExternalStore(a, b, e);
};
$32414eef17a49ce2$export$7b286972b8d8ccbf = function() {
    return $32414eef17a49ce2$var$U.current.useTransition();
};
$32414eef17a49ce2$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("v6beo", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $05d7b09d19157401$export$ae55be85d98224ed, (v) => $05d7b09d19157401$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $05d7b09d19157401$export$d39a5bbd09211389, (v) => $05d7b09d19157401$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $05d7b09d19157401$export$882461b6382ed46c, (v) => $05d7b09d19157401$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $05d7b09d19157401$export$466bfc07425424d5, (v) => $05d7b09d19157401$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $05d7b09d19157401$export$cd75ccfd720a3cd4, (v) => $05d7b09d19157401$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $05d7b09d19157401$export$fa8d919ba61d84db, (v) => $05d7b09d19157401$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $05d7b09d19157401$export$757ceba2d55c277e, (v) => $05d7b09d19157401$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $05d7b09d19157401$export$b3890eb0ae9dca99, (v) => $05d7b09d19157401$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $05d7b09d19157401$export$502457920280e6be, (v) => $05d7b09d19157401$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $05d7b09d19157401$export$c78a37762a8d58e1, (v) => $05d7b09d19157401$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $05d7b09d19157401$export$dc54d992c10e8a18, (v) => $05d7b09d19157401$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $05d7b09d19157401$export$83d89fbfd8236492, (v) => $05d7b09d19157401$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $05d7b09d19157401$export$ae55be85d98224ed;
var $05d7b09d19157401$export$d39a5bbd09211389;
var $05d7b09d19157401$export$882461b6382ed46c;
var $05d7b09d19157401$export$466bfc07425424d5;
var $05d7b09d19157401$export$cd75ccfd720a3cd4;
var $05d7b09d19157401$export$fa8d919ba61d84db;
var $05d7b09d19157401$export$757ceba2d55c277e;
var $05d7b09d19157401$export$b3890eb0ae9dca99;
var $05d7b09d19157401$export$502457920280e6be;
var $05d7b09d19157401$export$c78a37762a8d58e1;
var $05d7b09d19157401$export$dc54d992c10e8a18;
var $05d7b09d19157401$export$83d89fbfd8236492;
"use strict";

var $eFMZj = parcelRequire("eFMZj");

var $fwoBu = parcelRequire("fwoBu");
function $05d7b09d19157401$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $05d7b09d19157401$var$da = new Set, $05d7b09d19157401$var$ea = {};
function $05d7b09d19157401$var$fa(a, b) {
    $05d7b09d19157401$var$ha(a, b);
    $05d7b09d19157401$var$ha(a + "Capture", b);
}
function $05d7b09d19157401$var$ha(a, b) {
    $05d7b09d19157401$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$05d7b09d19157401$var$da.add(b[a]);
}
var $05d7b09d19157401$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $05d7b09d19157401$var$ja = Object.prototype.hasOwnProperty, $05d7b09d19157401$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $05d7b09d19157401$var$la = {}, $05d7b09d19157401$var$ma = {};
function $05d7b09d19157401$var$oa(a) {
    if ($05d7b09d19157401$var$ja.call($05d7b09d19157401$var$ma, a)) return !0;
    if ($05d7b09d19157401$var$ja.call($05d7b09d19157401$var$la, a)) return !1;
    if ($05d7b09d19157401$var$ka.test(a)) return $05d7b09d19157401$var$ma[a] = !0;
    $05d7b09d19157401$var$la[a] = !0;
    return !1;
}
function $05d7b09d19157401$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $05d7b09d19157401$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $05d7b09d19157401$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $05d7b09d19157401$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $05d7b09d19157401$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $05d7b09d19157401$var$z[b] = new $05d7b09d19157401$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $05d7b09d19157401$var$ra = /[\-:]([a-z])/g;
function $05d7b09d19157401$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($05d7b09d19157401$var$ra, $05d7b09d19157401$var$sa);
    $05d7b09d19157401$var$z[b] = new $05d7b09d19157401$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($05d7b09d19157401$var$ra, $05d7b09d19157401$var$sa);
    $05d7b09d19157401$var$z[b] = new $05d7b09d19157401$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($05d7b09d19157401$var$ra, $05d7b09d19157401$var$sa);
    $05d7b09d19157401$var$z[b] = new $05d7b09d19157401$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$05d7b09d19157401$var$z.xlinkHref = new $05d7b09d19157401$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $05d7b09d19157401$var$z[a] = new $05d7b09d19157401$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $05d7b09d19157401$var$ta(a, b, c, d) {
    var e = $05d7b09d19157401$var$z.hasOwnProperty(b) ? $05d7b09d19157401$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $05d7b09d19157401$var$qa(b, c, e, d) && (c = null), d || null === e ? $05d7b09d19157401$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $05d7b09d19157401$var$ua = $eFMZj.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $05d7b09d19157401$var$va = Symbol.for("react.element"), $05d7b09d19157401$var$wa = Symbol.for("react.portal"), $05d7b09d19157401$var$ya = Symbol.for("react.fragment"), $05d7b09d19157401$var$za = Symbol.for("react.strict_mode"), $05d7b09d19157401$var$Aa = Symbol.for("react.profiler"), $05d7b09d19157401$var$Ba = Symbol.for("react.provider"), $05d7b09d19157401$var$Ca = Symbol.for("react.context"), $05d7b09d19157401$var$Da = Symbol.for("react.forward_ref"), $05d7b09d19157401$var$Ea = Symbol.for("react.suspense"), $05d7b09d19157401$var$Fa = Symbol.for("react.suspense_list"), $05d7b09d19157401$var$Ga = Symbol.for("react.memo"), $05d7b09d19157401$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $05d7b09d19157401$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $05d7b09d19157401$var$Ja = Symbol.iterator;
function $05d7b09d19157401$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $05d7b09d19157401$var$Ja && a[$05d7b09d19157401$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $05d7b09d19157401$var$A = Object.assign, $05d7b09d19157401$var$La;
function $05d7b09d19157401$var$Ma(a) {
    if (void 0 === $05d7b09d19157401$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $05d7b09d19157401$var$La = b && b[1] || "";
    }
    return "\n" + $05d7b09d19157401$var$La + a;
}
var $05d7b09d19157401$var$Na = !1;
function $05d7b09d19157401$var$Oa(a, b) {
    if (!a || $05d7b09d19157401$var$Na) return "";
    $05d7b09d19157401$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $05d7b09d19157401$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $05d7b09d19157401$var$Ma(a) : "";
}
function $05d7b09d19157401$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $05d7b09d19157401$var$Ma(a.type);
        case 16:
            return $05d7b09d19157401$var$Ma("Lazy");
        case 13:
            return $05d7b09d19157401$var$Ma("Suspense");
        case 19:
            return $05d7b09d19157401$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $05d7b09d19157401$var$Oa(a.type, !1), a;
        case 11:
            return a = $05d7b09d19157401$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $05d7b09d19157401$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $05d7b09d19157401$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $05d7b09d19157401$var$ya:
            return "Fragment";
        case $05d7b09d19157401$var$wa:
            return "Portal";
        case $05d7b09d19157401$var$Aa:
            return "Profiler";
        case $05d7b09d19157401$var$za:
            return "StrictMode";
        case $05d7b09d19157401$var$Ea:
            return "Suspense";
        case $05d7b09d19157401$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $05d7b09d19157401$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $05d7b09d19157401$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $05d7b09d19157401$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $05d7b09d19157401$var$Ga:
            return b = a.displayName || null, null !== b ? b : $05d7b09d19157401$var$Qa(a.type) || "Memo";
        case $05d7b09d19157401$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $05d7b09d19157401$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $05d7b09d19157401$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $05d7b09d19157401$var$Qa(b);
        case 8:
            return b === $05d7b09d19157401$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $05d7b09d19157401$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $05d7b09d19157401$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $05d7b09d19157401$var$Ua(a) {
    var b = $05d7b09d19157401$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $05d7b09d19157401$var$Va(a) {
    a._valueTracker || (a._valueTracker = $05d7b09d19157401$var$Ua(a));
}
function $05d7b09d19157401$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $05d7b09d19157401$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $05d7b09d19157401$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $05d7b09d19157401$var$Ya(a, b) {
    var c = b.checked;
    return $05d7b09d19157401$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $05d7b09d19157401$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $05d7b09d19157401$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $05d7b09d19157401$var$ab(a, b) {
    b = b.checked;
    null != b && $05d7b09d19157401$var$ta(a, "checked", b, !1);
}
function $05d7b09d19157401$var$bb(a, b) {
    $05d7b09d19157401$var$ab(a, b);
    var c = $05d7b09d19157401$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $05d7b09d19157401$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $05d7b09d19157401$var$cb(a, b.type, $05d7b09d19157401$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $05d7b09d19157401$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $05d7b09d19157401$var$cb(a, b, c) {
    if ("number" !== b || $05d7b09d19157401$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $05d7b09d19157401$var$eb = Array.isArray;
function $05d7b09d19157401$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $05d7b09d19157401$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $05d7b09d19157401$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($05d7b09d19157401$var$p(91));
    return $05d7b09d19157401$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $05d7b09d19157401$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($05d7b09d19157401$var$p(92));
            if ($05d7b09d19157401$var$eb(c)) {
                if (1 < c.length) throw Error($05d7b09d19157401$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $05d7b09d19157401$var$Sa(c)
    };
}
function $05d7b09d19157401$var$ib(a, b) {
    var c = $05d7b09d19157401$var$Sa(b.value), d = $05d7b09d19157401$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $05d7b09d19157401$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $05d7b09d19157401$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $05d7b09d19157401$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $05d7b09d19157401$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $05d7b09d19157401$var$mb, $05d7b09d19157401$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $05d7b09d19157401$var$mb = $05d7b09d19157401$var$mb || document.createElement("div");
        $05d7b09d19157401$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $05d7b09d19157401$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $05d7b09d19157401$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $05d7b09d19157401$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $05d7b09d19157401$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($05d7b09d19157401$var$pb).forEach(function(a) {
    $05d7b09d19157401$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $05d7b09d19157401$var$pb[b] = $05d7b09d19157401$var$pb[a];
    });
});
function $05d7b09d19157401$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $05d7b09d19157401$var$pb.hasOwnProperty(a) && $05d7b09d19157401$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $05d7b09d19157401$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $05d7b09d19157401$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $05d7b09d19157401$var$tb = $05d7b09d19157401$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $05d7b09d19157401$var$ub(a, b) {
    if (b) {
        if ($05d7b09d19157401$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($05d7b09d19157401$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($05d7b09d19157401$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($05d7b09d19157401$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($05d7b09d19157401$var$p(62));
    }
}
function $05d7b09d19157401$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $05d7b09d19157401$var$wb = null;
function $05d7b09d19157401$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $05d7b09d19157401$var$yb = null, $05d7b09d19157401$var$zb = null, $05d7b09d19157401$var$Ab = null;
function $05d7b09d19157401$var$Bb(a) {
    if (a = $05d7b09d19157401$var$Cb(a)) {
        if ("function" !== typeof $05d7b09d19157401$var$yb) throw Error($05d7b09d19157401$var$p(280));
        var b = a.stateNode;
        b && (b = $05d7b09d19157401$var$Db(b), $05d7b09d19157401$var$yb(a.stateNode, a.type, b));
    }
}
function $05d7b09d19157401$var$Eb(a) {
    $05d7b09d19157401$var$zb ? $05d7b09d19157401$var$Ab ? $05d7b09d19157401$var$Ab.push(a) : $05d7b09d19157401$var$Ab = [
        a
    ] : $05d7b09d19157401$var$zb = a;
}
function $05d7b09d19157401$var$Fb() {
    if ($05d7b09d19157401$var$zb) {
        var a = $05d7b09d19157401$var$zb, b = $05d7b09d19157401$var$Ab;
        $05d7b09d19157401$var$Ab = $05d7b09d19157401$var$zb = null;
        $05d7b09d19157401$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$05d7b09d19157401$var$Bb(b[a]);
    }
}
function $05d7b09d19157401$var$Gb(a, b) {
    return a(b);
}
function $05d7b09d19157401$var$Hb() {}
var $05d7b09d19157401$var$Ib = !1;
function $05d7b09d19157401$var$Jb(a, b, c) {
    if ($05d7b09d19157401$var$Ib) return a(b, c);
    $05d7b09d19157401$var$Ib = !0;
    try {
        return $05d7b09d19157401$var$Gb(a, b, c);
    } finally{
        if ($05d7b09d19157401$var$Ib = !1, null !== $05d7b09d19157401$var$zb || null !== $05d7b09d19157401$var$Ab) $05d7b09d19157401$var$Hb(), $05d7b09d19157401$var$Fb();
    }
}
function $05d7b09d19157401$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $05d7b09d19157401$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($05d7b09d19157401$var$p(231, b, typeof c));
    return c;
}
var $05d7b09d19157401$var$Lb = !1;
if ($05d7b09d19157401$var$ia) try {
    var $05d7b09d19157401$var$Mb = {};
    Object.defineProperty($05d7b09d19157401$var$Mb, "passive", {
        get: function() {
            $05d7b09d19157401$var$Lb = !0;
        }
    });
    window.addEventListener("test", $05d7b09d19157401$var$Mb, $05d7b09d19157401$var$Mb);
    window.removeEventListener("test", $05d7b09d19157401$var$Mb, $05d7b09d19157401$var$Mb);
} catch (a) {
    $05d7b09d19157401$var$Lb = !1;
}
function $05d7b09d19157401$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $05d7b09d19157401$var$Ob = !1, $05d7b09d19157401$var$Pb = null, $05d7b09d19157401$var$Qb = !1, $05d7b09d19157401$var$Rb = null, $05d7b09d19157401$var$Sb = {
    onError: function(a) {
        $05d7b09d19157401$var$Ob = !0;
        $05d7b09d19157401$var$Pb = a;
    }
};
function $05d7b09d19157401$var$Tb(a, b, c, d, e, f, g, h, k) {
    $05d7b09d19157401$var$Ob = !1;
    $05d7b09d19157401$var$Pb = null;
    $05d7b09d19157401$var$Nb.apply($05d7b09d19157401$var$Sb, arguments);
}
function $05d7b09d19157401$var$Ub(a, b, c, d, e, f, g, h, k) {
    $05d7b09d19157401$var$Tb.apply(this, arguments);
    if ($05d7b09d19157401$var$Ob) {
        if ($05d7b09d19157401$var$Ob) {
            var l = $05d7b09d19157401$var$Pb;
            $05d7b09d19157401$var$Ob = !1;
            $05d7b09d19157401$var$Pb = null;
        } else throw Error($05d7b09d19157401$var$p(198));
        $05d7b09d19157401$var$Qb || ($05d7b09d19157401$var$Qb = !0, $05d7b09d19157401$var$Rb = l);
    }
}
function $05d7b09d19157401$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $05d7b09d19157401$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $05d7b09d19157401$var$Xb(a) {
    if ($05d7b09d19157401$var$Vb(a) !== a) throw Error($05d7b09d19157401$var$p(188));
}
function $05d7b09d19157401$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $05d7b09d19157401$var$Vb(a);
        if (null === b) throw Error($05d7b09d19157401$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $05d7b09d19157401$var$Xb(e), a;
                if (f === d) return $05d7b09d19157401$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($05d7b09d19157401$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($05d7b09d19157401$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($05d7b09d19157401$var$p(190));
    }
    if (3 !== c.tag) throw Error($05d7b09d19157401$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $05d7b09d19157401$var$Zb(a) {
    a = $05d7b09d19157401$var$Yb(a);
    return null !== a ? $05d7b09d19157401$var$$b(a) : null;
}
function $05d7b09d19157401$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $05d7b09d19157401$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $05d7b09d19157401$var$ac = $fwoBu.unstable_scheduleCallback, $05d7b09d19157401$var$bc = $fwoBu.unstable_cancelCallback, $05d7b09d19157401$var$cc = $fwoBu.unstable_shouldYield, $05d7b09d19157401$var$dc = $fwoBu.unstable_requestPaint, $05d7b09d19157401$var$B = $fwoBu.unstable_now, $05d7b09d19157401$var$ec = $fwoBu.unstable_getCurrentPriorityLevel, $05d7b09d19157401$var$fc = $fwoBu.unstable_ImmediatePriority, $05d7b09d19157401$var$gc = $fwoBu.unstable_UserBlockingPriority, $05d7b09d19157401$var$hc = $fwoBu.unstable_NormalPriority, $05d7b09d19157401$var$ic = $fwoBu.unstable_LowPriority, $05d7b09d19157401$var$jc = $fwoBu.unstable_IdlePriority, $05d7b09d19157401$var$kc = null, $05d7b09d19157401$var$lc = null;
function $05d7b09d19157401$var$mc(a) {
    if ($05d7b09d19157401$var$lc && "function" === typeof $05d7b09d19157401$var$lc.onCommitFiberRoot) try {
        $05d7b09d19157401$var$lc.onCommitFiberRoot($05d7b09d19157401$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $05d7b09d19157401$var$oc = Math.clz32 ? Math.clz32 : $05d7b09d19157401$var$nc, $05d7b09d19157401$var$pc = Math.log, $05d7b09d19157401$var$qc = Math.LN2;
function $05d7b09d19157401$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($05d7b09d19157401$var$pc(a) / $05d7b09d19157401$var$qc | 0) | 0;
}
var $05d7b09d19157401$var$rc = 64, $05d7b09d19157401$var$sc = 4194304;
function $05d7b09d19157401$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $05d7b09d19157401$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $05d7b09d19157401$var$tc(h) : (f &= g, 0 !== f && (d = $05d7b09d19157401$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $05d7b09d19157401$var$tc(g) : 0 !== f && (d = $05d7b09d19157401$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $05d7b09d19157401$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $05d7b09d19157401$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $05d7b09d19157401$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $05d7b09d19157401$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $05d7b09d19157401$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $05d7b09d19157401$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $05d7b09d19157401$var$yc() {
    var a = $05d7b09d19157401$var$rc;
    $05d7b09d19157401$var$rc <<= 1;
    0 === ($05d7b09d19157401$var$rc & 4194240) && ($05d7b09d19157401$var$rc = 64);
    return a;
}
function $05d7b09d19157401$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $05d7b09d19157401$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $05d7b09d19157401$var$oc(b);
    a[b] = c;
}
function $05d7b09d19157401$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $05d7b09d19157401$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $05d7b09d19157401$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $05d7b09d19157401$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $05d7b09d19157401$var$C = 0;
function $05d7b09d19157401$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $05d7b09d19157401$var$Ec, $05d7b09d19157401$var$Fc, $05d7b09d19157401$var$Gc, $05d7b09d19157401$var$Hc, $05d7b09d19157401$var$Ic, $05d7b09d19157401$var$Jc = !1, $05d7b09d19157401$var$Kc = [], $05d7b09d19157401$var$Lc = null, $05d7b09d19157401$var$Mc = null, $05d7b09d19157401$var$Nc = null, $05d7b09d19157401$var$Oc = new Map, $05d7b09d19157401$var$Pc = new Map, $05d7b09d19157401$var$Qc = [], $05d7b09d19157401$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $05d7b09d19157401$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $05d7b09d19157401$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $05d7b09d19157401$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $05d7b09d19157401$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $05d7b09d19157401$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $05d7b09d19157401$var$Pc.delete(b.pointerId);
    }
}
function $05d7b09d19157401$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $05d7b09d19157401$var$Cb(b), null !== b && $05d7b09d19157401$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $05d7b09d19157401$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $05d7b09d19157401$var$Lc = $05d7b09d19157401$var$Tc($05d7b09d19157401$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $05d7b09d19157401$var$Mc = $05d7b09d19157401$var$Tc($05d7b09d19157401$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $05d7b09d19157401$var$Nc = $05d7b09d19157401$var$Tc($05d7b09d19157401$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $05d7b09d19157401$var$Oc.set(f, $05d7b09d19157401$var$Tc($05d7b09d19157401$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $05d7b09d19157401$var$Pc.set(f, $05d7b09d19157401$var$Tc($05d7b09d19157401$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $05d7b09d19157401$var$Vc(a) {
    var b = $05d7b09d19157401$var$Wc(a.target);
    if (null !== b) {
        var c = $05d7b09d19157401$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $05d7b09d19157401$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $05d7b09d19157401$var$Ic(a.priority, function() {
                        $05d7b09d19157401$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $05d7b09d19157401$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $05d7b09d19157401$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $05d7b09d19157401$var$wb = d;
            c.target.dispatchEvent(d);
            $05d7b09d19157401$var$wb = null;
        } else return b = $05d7b09d19157401$var$Cb(c), null !== b && $05d7b09d19157401$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $05d7b09d19157401$var$Zc(a, b, c) {
    $05d7b09d19157401$var$Xc(a) && c.delete(b);
}
function $05d7b09d19157401$var$$c() {
    $05d7b09d19157401$var$Jc = !1;
    null !== $05d7b09d19157401$var$Lc && $05d7b09d19157401$var$Xc($05d7b09d19157401$var$Lc) && ($05d7b09d19157401$var$Lc = null);
    null !== $05d7b09d19157401$var$Mc && $05d7b09d19157401$var$Xc($05d7b09d19157401$var$Mc) && ($05d7b09d19157401$var$Mc = null);
    null !== $05d7b09d19157401$var$Nc && $05d7b09d19157401$var$Xc($05d7b09d19157401$var$Nc) && ($05d7b09d19157401$var$Nc = null);
    $05d7b09d19157401$var$Oc.forEach($05d7b09d19157401$var$Zc);
    $05d7b09d19157401$var$Pc.forEach($05d7b09d19157401$var$Zc);
}
function $05d7b09d19157401$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $05d7b09d19157401$var$Jc || ($05d7b09d19157401$var$Jc = !0, $fwoBu.unstable_scheduleCallback($fwoBu.unstable_NormalPriority, $05d7b09d19157401$var$$c)));
}
function $05d7b09d19157401$var$bd(a) {
    function b(b) {
        return $05d7b09d19157401$var$ad(b, a);
    }
    if (0 < $05d7b09d19157401$var$Kc.length) {
        $05d7b09d19157401$var$ad($05d7b09d19157401$var$Kc[0], a);
        for(var c = 1; c < $05d7b09d19157401$var$Kc.length; c++){
            var d = $05d7b09d19157401$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $05d7b09d19157401$var$Lc && $05d7b09d19157401$var$ad($05d7b09d19157401$var$Lc, a);
    null !== $05d7b09d19157401$var$Mc && $05d7b09d19157401$var$ad($05d7b09d19157401$var$Mc, a);
    null !== $05d7b09d19157401$var$Nc && $05d7b09d19157401$var$ad($05d7b09d19157401$var$Nc, a);
    $05d7b09d19157401$var$Oc.forEach(b);
    $05d7b09d19157401$var$Pc.forEach(b);
    for(c = 0; c < $05d7b09d19157401$var$Qc.length; c++)d = $05d7b09d19157401$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $05d7b09d19157401$var$Qc.length && (c = $05d7b09d19157401$var$Qc[0], null === c.blockedOn);)$05d7b09d19157401$var$Vc(c), null === c.blockedOn && $05d7b09d19157401$var$Qc.shift();
}
var $05d7b09d19157401$var$cd = $05d7b09d19157401$var$ua.ReactCurrentBatchConfig, $05d7b09d19157401$var$dd = !0;
function $05d7b09d19157401$var$ed(a, b, c, d) {
    var e = $05d7b09d19157401$var$C, f = $05d7b09d19157401$var$cd.transition;
    $05d7b09d19157401$var$cd.transition = null;
    try {
        $05d7b09d19157401$var$C = 1, $05d7b09d19157401$var$fd(a, b, c, d);
    } finally{
        $05d7b09d19157401$var$C = e, $05d7b09d19157401$var$cd.transition = f;
    }
}
function $05d7b09d19157401$var$gd(a, b, c, d) {
    var e = $05d7b09d19157401$var$C, f = $05d7b09d19157401$var$cd.transition;
    $05d7b09d19157401$var$cd.transition = null;
    try {
        $05d7b09d19157401$var$C = 4, $05d7b09d19157401$var$fd(a, b, c, d);
    } finally{
        $05d7b09d19157401$var$C = e, $05d7b09d19157401$var$cd.transition = f;
    }
}
function $05d7b09d19157401$var$fd(a, b, c, d) {
    if ($05d7b09d19157401$var$dd) {
        var e = $05d7b09d19157401$var$Yc(a, b, c, d);
        if (null === e) $05d7b09d19157401$var$hd(a, b, d, $05d7b09d19157401$var$id, c), $05d7b09d19157401$var$Sc(a, d);
        else if ($05d7b09d19157401$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($05d7b09d19157401$var$Sc(a, d), b & 4 && -1 < $05d7b09d19157401$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $05d7b09d19157401$var$Cb(e);
                null !== f && $05d7b09d19157401$var$Ec(f);
                f = $05d7b09d19157401$var$Yc(a, b, c, d);
                null === f && $05d7b09d19157401$var$hd(a, b, d, $05d7b09d19157401$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $05d7b09d19157401$var$hd(a, b, d, null, c);
    }
}
var $05d7b09d19157401$var$id = null;
function $05d7b09d19157401$var$Yc(a, b, c, d) {
    $05d7b09d19157401$var$id = null;
    a = $05d7b09d19157401$var$xb(d);
    a = $05d7b09d19157401$var$Wc(a);
    if (null !== a) {
        if (b = $05d7b09d19157401$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $05d7b09d19157401$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $05d7b09d19157401$var$id = a;
    return null;
}
function $05d7b09d19157401$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($05d7b09d19157401$var$ec()){
                case $05d7b09d19157401$var$fc:
                    return 1;
                case $05d7b09d19157401$var$gc:
                    return 4;
                case $05d7b09d19157401$var$hc:
                case $05d7b09d19157401$var$ic:
                    return 16;
                case $05d7b09d19157401$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $05d7b09d19157401$var$kd = null, $05d7b09d19157401$var$ld = null, $05d7b09d19157401$var$md = null;
function $05d7b09d19157401$var$nd() {
    if ($05d7b09d19157401$var$md) return $05d7b09d19157401$var$md;
    var a, b = $05d7b09d19157401$var$ld, c = b.length, d, e = "value" in $05d7b09d19157401$var$kd ? $05d7b09d19157401$var$kd.value : $05d7b09d19157401$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $05d7b09d19157401$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $05d7b09d19157401$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $05d7b09d19157401$var$pd() {
    return !0;
}
function $05d7b09d19157401$var$qd() {
    return !1;
}
function $05d7b09d19157401$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $05d7b09d19157401$var$pd : $05d7b09d19157401$var$qd;
        this.isPropagationStopped = $05d7b09d19157401$var$qd;
        return this;
    }
    $05d7b09d19157401$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $05d7b09d19157401$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $05d7b09d19157401$var$pd);
        },
        persist: function() {},
        isPersistent: $05d7b09d19157401$var$pd
    });
    return b;
}
var $05d7b09d19157401$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $05d7b09d19157401$var$td = $05d7b09d19157401$var$rd($05d7b09d19157401$var$sd), $05d7b09d19157401$var$ud = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$sd, {
    view: 0,
    detail: 0
}), $05d7b09d19157401$var$vd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$ud), $05d7b09d19157401$var$wd, $05d7b09d19157401$var$xd, $05d7b09d19157401$var$yd, $05d7b09d19157401$var$Ad = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $05d7b09d19157401$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $05d7b09d19157401$var$yd && ($05d7b09d19157401$var$yd && "mousemove" === a.type ? ($05d7b09d19157401$var$wd = a.screenX - $05d7b09d19157401$var$yd.screenX, $05d7b09d19157401$var$xd = a.screenY - $05d7b09d19157401$var$yd.screenY) : $05d7b09d19157401$var$xd = $05d7b09d19157401$var$wd = 0, $05d7b09d19157401$var$yd = a);
        return $05d7b09d19157401$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $05d7b09d19157401$var$xd;
    }
}), $05d7b09d19157401$var$Bd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Ad), $05d7b09d19157401$var$Cd = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$Ad, {
    dataTransfer: 0
}), $05d7b09d19157401$var$Dd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Cd), $05d7b09d19157401$var$Ed = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$ud, {
    relatedTarget: 0
}), $05d7b09d19157401$var$Fd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Ed), $05d7b09d19157401$var$Gd = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $05d7b09d19157401$var$Hd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Gd), $05d7b09d19157401$var$Id = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $05d7b09d19157401$var$Jd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Id), $05d7b09d19157401$var$Kd = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$sd, {
    data: 0
}), $05d7b09d19157401$var$Ld = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Kd), $05d7b09d19157401$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $05d7b09d19157401$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $05d7b09d19157401$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $05d7b09d19157401$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $05d7b09d19157401$var$Od[a]) ? !!b[a] : !1;
}
function $05d7b09d19157401$var$zd() {
    return $05d7b09d19157401$var$Pd;
}
var $05d7b09d19157401$var$Qd = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $05d7b09d19157401$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $05d7b09d19157401$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $05d7b09d19157401$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $05d7b09d19157401$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $05d7b09d19157401$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $05d7b09d19157401$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $05d7b09d19157401$var$Rd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Qd), $05d7b09d19157401$var$Sd = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $05d7b09d19157401$var$Td = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Sd), $05d7b09d19157401$var$Ud = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $05d7b09d19157401$var$zd
}), $05d7b09d19157401$var$Vd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Ud), $05d7b09d19157401$var$Wd = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $05d7b09d19157401$var$Xd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Wd), $05d7b09d19157401$var$Yd = $05d7b09d19157401$var$A({}, $05d7b09d19157401$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $05d7b09d19157401$var$Zd = $05d7b09d19157401$var$rd($05d7b09d19157401$var$Yd), $05d7b09d19157401$var$$d = [
    9,
    13,
    27,
    32
], $05d7b09d19157401$var$ae = $05d7b09d19157401$var$ia && "CompositionEvent" in window, $05d7b09d19157401$var$be = null;
$05d7b09d19157401$var$ia && "documentMode" in document && ($05d7b09d19157401$var$be = document.documentMode);
var $05d7b09d19157401$var$ce = $05d7b09d19157401$var$ia && "TextEvent" in window && !$05d7b09d19157401$var$be, $05d7b09d19157401$var$de = $05d7b09d19157401$var$ia && (!$05d7b09d19157401$var$ae || $05d7b09d19157401$var$be && 8 < $05d7b09d19157401$var$be && 11 >= $05d7b09d19157401$var$be), $05d7b09d19157401$var$ee = String.fromCharCode(32), $05d7b09d19157401$var$fe = !1;
function $05d7b09d19157401$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $05d7b09d19157401$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $05d7b09d19157401$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $05d7b09d19157401$var$ie = !1;
function $05d7b09d19157401$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $05d7b09d19157401$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $05d7b09d19157401$var$fe = !0;
            return $05d7b09d19157401$var$ee;
        case "textInput":
            return a = b.data, a === $05d7b09d19157401$var$ee && $05d7b09d19157401$var$fe ? null : a;
        default:
            return null;
    }
}
function $05d7b09d19157401$var$ke(a, b) {
    if ($05d7b09d19157401$var$ie) return "compositionend" === a || !$05d7b09d19157401$var$ae && $05d7b09d19157401$var$ge(a, b) ? (a = $05d7b09d19157401$var$nd(), $05d7b09d19157401$var$md = $05d7b09d19157401$var$ld = $05d7b09d19157401$var$kd = null, $05d7b09d19157401$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $05d7b09d19157401$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $05d7b09d19157401$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $05d7b09d19157401$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$05d7b09d19157401$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $05d7b09d19157401$var$ne(a, b, c, d) {
    $05d7b09d19157401$var$Eb(d);
    b = $05d7b09d19157401$var$oe(b, "onChange");
    0 < b.length && (c = new $05d7b09d19157401$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $05d7b09d19157401$var$pe = null, $05d7b09d19157401$var$qe = null;
function $05d7b09d19157401$var$re(a) {
    $05d7b09d19157401$var$se(a, 0);
}
function $05d7b09d19157401$var$te(a) {
    var b = $05d7b09d19157401$var$ue(a);
    if ($05d7b09d19157401$var$Wa(b)) return a;
}
function $05d7b09d19157401$var$ve(a, b) {
    if ("change" === a) return b;
}
var $05d7b09d19157401$var$we = !1;
if ($05d7b09d19157401$var$ia) {
    var $05d7b09d19157401$var$xe;
    if ($05d7b09d19157401$var$ia) {
        var $05d7b09d19157401$var$ye = "oninput" in document;
        if (!$05d7b09d19157401$var$ye) {
            var $05d7b09d19157401$var$ze = document.createElement("div");
            $05d7b09d19157401$var$ze.setAttribute("oninput", "return;");
            $05d7b09d19157401$var$ye = "function" === typeof $05d7b09d19157401$var$ze.oninput;
        }
        $05d7b09d19157401$var$xe = $05d7b09d19157401$var$ye;
    } else $05d7b09d19157401$var$xe = !1;
    $05d7b09d19157401$var$we = $05d7b09d19157401$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $05d7b09d19157401$var$Ae() {
    $05d7b09d19157401$var$pe && ($05d7b09d19157401$var$pe.detachEvent("onpropertychange", $05d7b09d19157401$var$Be), $05d7b09d19157401$var$qe = $05d7b09d19157401$var$pe = null);
}
function $05d7b09d19157401$var$Be(a) {
    if ("value" === a.propertyName && $05d7b09d19157401$var$te($05d7b09d19157401$var$qe)) {
        var b = [];
        $05d7b09d19157401$var$ne(b, $05d7b09d19157401$var$qe, a, $05d7b09d19157401$var$xb(a));
        $05d7b09d19157401$var$Jb($05d7b09d19157401$var$re, b);
    }
}
function $05d7b09d19157401$var$Ce(a, b, c) {
    "focusin" === a ? ($05d7b09d19157401$var$Ae(), $05d7b09d19157401$var$pe = b, $05d7b09d19157401$var$qe = c, $05d7b09d19157401$var$pe.attachEvent("onpropertychange", $05d7b09d19157401$var$Be)) : "focusout" === a && $05d7b09d19157401$var$Ae();
}
function $05d7b09d19157401$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $05d7b09d19157401$var$te($05d7b09d19157401$var$qe);
}
function $05d7b09d19157401$var$Ee(a, b) {
    if ("click" === a) return $05d7b09d19157401$var$te(b);
}
function $05d7b09d19157401$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $05d7b09d19157401$var$te(b);
}
function $05d7b09d19157401$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $05d7b09d19157401$var$He = "function" === typeof Object.is ? Object.is : $05d7b09d19157401$var$Ge;
function $05d7b09d19157401$var$Ie(a, b) {
    if ($05d7b09d19157401$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$05d7b09d19157401$var$ja.call(b, e) || !$05d7b09d19157401$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $05d7b09d19157401$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $05d7b09d19157401$var$Ke(a, b) {
    var c = $05d7b09d19157401$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $05d7b09d19157401$var$Je(c);
    }
}
function $05d7b09d19157401$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $05d7b09d19157401$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $05d7b09d19157401$var$Me() {
    for(var a = window, b = $05d7b09d19157401$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $05d7b09d19157401$var$Xa(a.document);
    }
    return b;
}
function $05d7b09d19157401$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $05d7b09d19157401$var$Oe(a) {
    var b = $05d7b09d19157401$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $05d7b09d19157401$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $05d7b09d19157401$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $05d7b09d19157401$var$Ke(c, f);
                var g = $05d7b09d19157401$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $05d7b09d19157401$var$Pe = $05d7b09d19157401$var$ia && "documentMode" in document && 11 >= document.documentMode, $05d7b09d19157401$var$Qe = null, $05d7b09d19157401$var$Re = null, $05d7b09d19157401$var$Se = null, $05d7b09d19157401$var$Te = !1;
function $05d7b09d19157401$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $05d7b09d19157401$var$Te || null == $05d7b09d19157401$var$Qe || $05d7b09d19157401$var$Qe !== $05d7b09d19157401$var$Xa(d) || (d = $05d7b09d19157401$var$Qe, "selectionStart" in d && $05d7b09d19157401$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $05d7b09d19157401$var$Se && $05d7b09d19157401$var$Ie($05d7b09d19157401$var$Se, d) || ($05d7b09d19157401$var$Se = d, d = $05d7b09d19157401$var$oe($05d7b09d19157401$var$Re, "onSelect"), 0 < d.length && (b = new $05d7b09d19157401$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $05d7b09d19157401$var$Qe)));
}
function $05d7b09d19157401$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $05d7b09d19157401$var$We = {
    animationend: $05d7b09d19157401$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $05d7b09d19157401$var$Ve("Animation", "AnimationIteration"),
    animationstart: $05d7b09d19157401$var$Ve("Animation", "AnimationStart"),
    transitionend: $05d7b09d19157401$var$Ve("Transition", "TransitionEnd")
}, $05d7b09d19157401$var$Xe = {}, $05d7b09d19157401$var$Ye = {};
$05d7b09d19157401$var$ia && ($05d7b09d19157401$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $05d7b09d19157401$var$We.animationend.animation, delete $05d7b09d19157401$var$We.animationiteration.animation, delete $05d7b09d19157401$var$We.animationstart.animation), "TransitionEvent" in window || delete $05d7b09d19157401$var$We.transitionend.transition);
function $05d7b09d19157401$var$Ze(a) {
    if ($05d7b09d19157401$var$Xe[a]) return $05d7b09d19157401$var$Xe[a];
    if (!$05d7b09d19157401$var$We[a]) return a;
    var b = $05d7b09d19157401$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $05d7b09d19157401$var$Ye) return $05d7b09d19157401$var$Xe[a] = b[c];
    return a;
}
var $05d7b09d19157401$var$$e = $05d7b09d19157401$var$Ze("animationend"), $05d7b09d19157401$var$af = $05d7b09d19157401$var$Ze("animationiteration"), $05d7b09d19157401$var$bf = $05d7b09d19157401$var$Ze("animationstart"), $05d7b09d19157401$var$cf = $05d7b09d19157401$var$Ze("transitionend"), $05d7b09d19157401$var$df = new Map, $05d7b09d19157401$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $05d7b09d19157401$var$ff(a, b) {
    $05d7b09d19157401$var$df.set(a, b);
    $05d7b09d19157401$var$fa(b, [
        a
    ]);
}
for(var $05d7b09d19157401$var$gf = 0; $05d7b09d19157401$var$gf < $05d7b09d19157401$var$ef.length; $05d7b09d19157401$var$gf++){
    var $05d7b09d19157401$var$hf = $05d7b09d19157401$var$ef[$05d7b09d19157401$var$gf], $05d7b09d19157401$var$jf = $05d7b09d19157401$var$hf.toLowerCase(), $05d7b09d19157401$var$kf = $05d7b09d19157401$var$hf[0].toUpperCase() + $05d7b09d19157401$var$hf.slice(1);
    $05d7b09d19157401$var$ff($05d7b09d19157401$var$jf, "on" + $05d7b09d19157401$var$kf);
}
$05d7b09d19157401$var$ff($05d7b09d19157401$var$$e, "onAnimationEnd");
$05d7b09d19157401$var$ff($05d7b09d19157401$var$af, "onAnimationIteration");
$05d7b09d19157401$var$ff($05d7b09d19157401$var$bf, "onAnimationStart");
$05d7b09d19157401$var$ff("dblclick", "onDoubleClick");
$05d7b09d19157401$var$ff("focusin", "onFocus");
$05d7b09d19157401$var$ff("focusout", "onBlur");
$05d7b09d19157401$var$ff($05d7b09d19157401$var$cf, "onTransitionEnd");
$05d7b09d19157401$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$05d7b09d19157401$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$05d7b09d19157401$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$05d7b09d19157401$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$05d7b09d19157401$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$05d7b09d19157401$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$05d7b09d19157401$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$05d7b09d19157401$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$05d7b09d19157401$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$05d7b09d19157401$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $05d7b09d19157401$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $05d7b09d19157401$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($05d7b09d19157401$var$lf));
function $05d7b09d19157401$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $05d7b09d19157401$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $05d7b09d19157401$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $05d7b09d19157401$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $05d7b09d19157401$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($05d7b09d19157401$var$Qb) throw a = $05d7b09d19157401$var$Rb, $05d7b09d19157401$var$Qb = !1, $05d7b09d19157401$var$Rb = null, a;
}
function $05d7b09d19157401$var$D(a, b) {
    var c = b[$05d7b09d19157401$var$of];
    void 0 === c && (c = b[$05d7b09d19157401$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($05d7b09d19157401$var$pf(b, a, 2, !1), c.add(d));
}
function $05d7b09d19157401$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $05d7b09d19157401$var$pf(c, a, d, b);
}
var $05d7b09d19157401$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $05d7b09d19157401$var$sf(a) {
    if (!a[$05d7b09d19157401$var$rf]) {
        a[$05d7b09d19157401$var$rf] = !0;
        $05d7b09d19157401$var$da.forEach(function(b) {
            "selectionchange" !== b && ($05d7b09d19157401$var$mf.has(b) || $05d7b09d19157401$var$qf(b, !1, a), $05d7b09d19157401$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$05d7b09d19157401$var$rf] || (b[$05d7b09d19157401$var$rf] = !0, $05d7b09d19157401$var$qf("selectionchange", !1, b));
    }
}
function $05d7b09d19157401$var$pf(a, b, c, d) {
    switch($05d7b09d19157401$var$jd(b)){
        case 1:
            var e = $05d7b09d19157401$var$ed;
            break;
        case 4:
            e = $05d7b09d19157401$var$gd;
            break;
        default:
            e = $05d7b09d19157401$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$05d7b09d19157401$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $05d7b09d19157401$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $05d7b09d19157401$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $05d7b09d19157401$var$Jb(function() {
        var d = f, e = $05d7b09d19157401$var$xb(c), g = [];
        a: {
            var h = $05d7b09d19157401$var$df.get(a);
            if (void 0 !== h) {
                var k = $05d7b09d19157401$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $05d7b09d19157401$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $05d7b09d19157401$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $05d7b09d19157401$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $05d7b09d19157401$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $05d7b09d19157401$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $05d7b09d19157401$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $05d7b09d19157401$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $05d7b09d19157401$var$Vd;
                        break;
                    case $05d7b09d19157401$var$$e:
                    case $05d7b09d19157401$var$af:
                    case $05d7b09d19157401$var$bf:
                        k = $05d7b09d19157401$var$Hd;
                        break;
                    case $05d7b09d19157401$var$cf:
                        k = $05d7b09d19157401$var$Xd;
                        break;
                    case "scroll":
                        k = $05d7b09d19157401$var$vd;
                        break;
                    case "wheel":
                        k = $05d7b09d19157401$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $05d7b09d19157401$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $05d7b09d19157401$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $05d7b09d19157401$var$Kb(w, x), null != F && t.push($05d7b09d19157401$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $05d7b09d19157401$var$wb && (n = c.relatedTarget || c.fromElement) && ($05d7b09d19157401$var$Wc(n) || n[$05d7b09d19157401$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $05d7b09d19157401$var$Wc(n) : null, null !== n && (J = $05d7b09d19157401$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $05d7b09d19157401$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $05d7b09d19157401$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $05d7b09d19157401$var$ue(k);
                        u = null == n ? h : $05d7b09d19157401$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $05d7b09d19157401$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $05d7b09d19157401$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $05d7b09d19157401$var$vf(F))u++;
                            for(; 0 < w - u;)t = $05d7b09d19157401$var$vf(t), w--;
                            for(; 0 < u - w;)x = $05d7b09d19157401$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $05d7b09d19157401$var$vf(t);
                                x = $05d7b09d19157401$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $05d7b09d19157401$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $05d7b09d19157401$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $05d7b09d19157401$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $05d7b09d19157401$var$ve;
                else if ($05d7b09d19157401$var$me(h)) {
                    if ($05d7b09d19157401$var$we) na = $05d7b09d19157401$var$Fe;
                    else {
                        na = $05d7b09d19157401$var$De;
                        var xa = $05d7b09d19157401$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $05d7b09d19157401$var$Ee);
                if (na && (na = na(a, d))) {
                    $05d7b09d19157401$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $05d7b09d19157401$var$cb(h, "number", h.value);
            }
            xa = d ? $05d7b09d19157401$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($05d7b09d19157401$var$me(xa) || "true" === xa.contentEditable) $05d7b09d19157401$var$Qe = xa, $05d7b09d19157401$var$Re = d, $05d7b09d19157401$var$Se = null;
                    break;
                case "focusout":
                    $05d7b09d19157401$var$Se = $05d7b09d19157401$var$Re = $05d7b09d19157401$var$Qe = null;
                    break;
                case "mousedown":
                    $05d7b09d19157401$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $05d7b09d19157401$var$Te = !1;
                    $05d7b09d19157401$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($05d7b09d19157401$var$Pe) break;
                case "keydown":
                case "keyup":
                    $05d7b09d19157401$var$Ue(g, c, e);
            }
            var $a;
            if ($05d7b09d19157401$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $05d7b09d19157401$var$ie ? $05d7b09d19157401$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($05d7b09d19157401$var$de && "ko" !== c.locale && ($05d7b09d19157401$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $05d7b09d19157401$var$ie && ($a = $05d7b09d19157401$var$nd()) : ($05d7b09d19157401$var$kd = e, $05d7b09d19157401$var$ld = "value" in $05d7b09d19157401$var$kd ? $05d7b09d19157401$var$kd.value : $05d7b09d19157401$var$kd.textContent, $05d7b09d19157401$var$ie = !0)), xa = $05d7b09d19157401$var$oe(d, ba), 0 < xa.length && (ba = new $05d7b09d19157401$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $05d7b09d19157401$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $05d7b09d19157401$var$ce ? $05d7b09d19157401$var$je(a, c) : $05d7b09d19157401$var$ke(a, c)) d = $05d7b09d19157401$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $05d7b09d19157401$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $05d7b09d19157401$var$se(g, b);
    });
}
function $05d7b09d19157401$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $05d7b09d19157401$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $05d7b09d19157401$var$Kb(a, c), null != f && d.unshift($05d7b09d19157401$var$tf(a, f, e)), f = $05d7b09d19157401$var$Kb(a, b), null != f && d.push($05d7b09d19157401$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $05d7b09d19157401$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $05d7b09d19157401$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $05d7b09d19157401$var$Kb(c, f), null != k && g.unshift($05d7b09d19157401$var$tf(c, k, h))) : e || (k = $05d7b09d19157401$var$Kb(c, f), null != k && g.push($05d7b09d19157401$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $05d7b09d19157401$var$xf = /\r\n?/g, $05d7b09d19157401$var$yf = /\u0000|\uFFFD/g;
function $05d7b09d19157401$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($05d7b09d19157401$var$xf, "\n").replace($05d7b09d19157401$var$yf, "");
}
function $05d7b09d19157401$var$Af(a, b, c) {
    b = $05d7b09d19157401$var$zf(b);
    if ($05d7b09d19157401$var$zf(a) !== b && c) throw Error($05d7b09d19157401$var$p(425));
}
function $05d7b09d19157401$var$Bf() {}
var $05d7b09d19157401$var$Cf = null, $05d7b09d19157401$var$Df = null;
function $05d7b09d19157401$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $05d7b09d19157401$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $05d7b09d19157401$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $05d7b09d19157401$var$Hf = "function" === typeof Promise ? Promise : void 0, $05d7b09d19157401$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $05d7b09d19157401$var$Hf ? function(a) {
    return $05d7b09d19157401$var$Hf.resolve(null).then(a).catch($05d7b09d19157401$var$If);
} : $05d7b09d19157401$var$Ff;
function $05d7b09d19157401$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $05d7b09d19157401$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $05d7b09d19157401$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $05d7b09d19157401$var$bd(b);
}
function $05d7b09d19157401$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $05d7b09d19157401$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $05d7b09d19157401$var$Nf = Math.random().toString(36).slice(2), $05d7b09d19157401$var$Of = "__reactFiber$" + $05d7b09d19157401$var$Nf, $05d7b09d19157401$var$Pf = "__reactProps$" + $05d7b09d19157401$var$Nf, $05d7b09d19157401$var$uf = "__reactContainer$" + $05d7b09d19157401$var$Nf, $05d7b09d19157401$var$of = "__reactEvents$" + $05d7b09d19157401$var$Nf, $05d7b09d19157401$var$Qf = "__reactListeners$" + $05d7b09d19157401$var$Nf, $05d7b09d19157401$var$Rf = "__reactHandles$" + $05d7b09d19157401$var$Nf;
function $05d7b09d19157401$var$Wc(a) {
    var b = a[$05d7b09d19157401$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$05d7b09d19157401$var$uf] || c[$05d7b09d19157401$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $05d7b09d19157401$var$Mf(a); null !== a;){
                if (c = a[$05d7b09d19157401$var$Of]) return c;
                a = $05d7b09d19157401$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $05d7b09d19157401$var$Cb(a) {
    a = a[$05d7b09d19157401$var$Of] || a[$05d7b09d19157401$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $05d7b09d19157401$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($05d7b09d19157401$var$p(33));
}
function $05d7b09d19157401$var$Db(a) {
    return a[$05d7b09d19157401$var$Pf] || null;
}
var $05d7b09d19157401$var$Sf = [], $05d7b09d19157401$var$Tf = -1;
function $05d7b09d19157401$var$Uf(a) {
    return {
        current: a
    };
}
function $05d7b09d19157401$var$E(a) {
    0 > $05d7b09d19157401$var$Tf || (a.current = $05d7b09d19157401$var$Sf[$05d7b09d19157401$var$Tf], $05d7b09d19157401$var$Sf[$05d7b09d19157401$var$Tf] = null, $05d7b09d19157401$var$Tf--);
}
function $05d7b09d19157401$var$G(a, b) {
    $05d7b09d19157401$var$Tf++;
    $05d7b09d19157401$var$Sf[$05d7b09d19157401$var$Tf] = a.current;
    a.current = b;
}
var $05d7b09d19157401$var$Vf = {}, $05d7b09d19157401$var$H = $05d7b09d19157401$var$Uf($05d7b09d19157401$var$Vf), $05d7b09d19157401$var$Wf = $05d7b09d19157401$var$Uf(!1), $05d7b09d19157401$var$Xf = $05d7b09d19157401$var$Vf;
function $05d7b09d19157401$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $05d7b09d19157401$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $05d7b09d19157401$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $05d7b09d19157401$var$$f() {
    $05d7b09d19157401$var$E($05d7b09d19157401$var$Wf);
    $05d7b09d19157401$var$E($05d7b09d19157401$var$H);
}
function $05d7b09d19157401$var$ag(a, b, c) {
    if ($05d7b09d19157401$var$H.current !== $05d7b09d19157401$var$Vf) throw Error($05d7b09d19157401$var$p(168));
    $05d7b09d19157401$var$G($05d7b09d19157401$var$H, b);
    $05d7b09d19157401$var$G($05d7b09d19157401$var$Wf, c);
}
function $05d7b09d19157401$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($05d7b09d19157401$var$p(108, $05d7b09d19157401$var$Ra(a) || "Unknown", e));
    return $05d7b09d19157401$var$A({}, c, d);
}
function $05d7b09d19157401$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $05d7b09d19157401$var$Vf;
    $05d7b09d19157401$var$Xf = $05d7b09d19157401$var$H.current;
    $05d7b09d19157401$var$G($05d7b09d19157401$var$H, a);
    $05d7b09d19157401$var$G($05d7b09d19157401$var$Wf, $05d7b09d19157401$var$Wf.current);
    return !0;
}
function $05d7b09d19157401$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($05d7b09d19157401$var$p(169));
    c ? (a = $05d7b09d19157401$var$bg(a, b, $05d7b09d19157401$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $05d7b09d19157401$var$E($05d7b09d19157401$var$Wf), $05d7b09d19157401$var$E($05d7b09d19157401$var$H), $05d7b09d19157401$var$G($05d7b09d19157401$var$H, a)) : $05d7b09d19157401$var$E($05d7b09d19157401$var$Wf);
    $05d7b09d19157401$var$G($05d7b09d19157401$var$Wf, c);
}
var $05d7b09d19157401$var$eg = null, $05d7b09d19157401$var$fg = !1, $05d7b09d19157401$var$gg = !1;
function $05d7b09d19157401$var$hg(a) {
    null === $05d7b09d19157401$var$eg ? $05d7b09d19157401$var$eg = [
        a
    ] : $05d7b09d19157401$var$eg.push(a);
}
function $05d7b09d19157401$var$ig(a) {
    $05d7b09d19157401$var$fg = !0;
    $05d7b09d19157401$var$hg(a);
}
function $05d7b09d19157401$var$jg() {
    if (!$05d7b09d19157401$var$gg && null !== $05d7b09d19157401$var$eg) {
        $05d7b09d19157401$var$gg = !0;
        var a = 0, b = $05d7b09d19157401$var$C;
        try {
            var c = $05d7b09d19157401$var$eg;
            for($05d7b09d19157401$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $05d7b09d19157401$var$eg = null;
            $05d7b09d19157401$var$fg = !1;
        } catch (e) {
            throw null !== $05d7b09d19157401$var$eg && ($05d7b09d19157401$var$eg = $05d7b09d19157401$var$eg.slice(a + 1)), $05d7b09d19157401$var$ac($05d7b09d19157401$var$fc, $05d7b09d19157401$var$jg), e;
        } finally{
            $05d7b09d19157401$var$C = b, $05d7b09d19157401$var$gg = !1;
        }
    }
    return null;
}
var $05d7b09d19157401$var$kg = [], $05d7b09d19157401$var$lg = 0, $05d7b09d19157401$var$mg = null, $05d7b09d19157401$var$ng = 0, $05d7b09d19157401$var$og = [], $05d7b09d19157401$var$pg = 0, $05d7b09d19157401$var$qg = null, $05d7b09d19157401$var$rg = 1, $05d7b09d19157401$var$sg = "";
function $05d7b09d19157401$var$tg(a, b) {
    $05d7b09d19157401$var$kg[$05d7b09d19157401$var$lg++] = $05d7b09d19157401$var$ng;
    $05d7b09d19157401$var$kg[$05d7b09d19157401$var$lg++] = $05d7b09d19157401$var$mg;
    $05d7b09d19157401$var$mg = a;
    $05d7b09d19157401$var$ng = b;
}
function $05d7b09d19157401$var$ug(a, b, c) {
    $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg++] = $05d7b09d19157401$var$rg;
    $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg++] = $05d7b09d19157401$var$sg;
    $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg++] = $05d7b09d19157401$var$qg;
    $05d7b09d19157401$var$qg = a;
    var d = $05d7b09d19157401$var$rg;
    a = $05d7b09d19157401$var$sg;
    var e = 32 - $05d7b09d19157401$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $05d7b09d19157401$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $05d7b09d19157401$var$rg = 1 << 32 - $05d7b09d19157401$var$oc(b) + e | c << e | d;
        $05d7b09d19157401$var$sg = f + a;
    } else $05d7b09d19157401$var$rg = 1 << f | c << e | d, $05d7b09d19157401$var$sg = a;
}
function $05d7b09d19157401$var$vg(a) {
    null !== a.return && ($05d7b09d19157401$var$tg(a, 1), $05d7b09d19157401$var$ug(a, 1, 0));
}
function $05d7b09d19157401$var$wg(a) {
    for(; a === $05d7b09d19157401$var$mg;)$05d7b09d19157401$var$mg = $05d7b09d19157401$var$kg[--$05d7b09d19157401$var$lg], $05d7b09d19157401$var$kg[$05d7b09d19157401$var$lg] = null, $05d7b09d19157401$var$ng = $05d7b09d19157401$var$kg[--$05d7b09d19157401$var$lg], $05d7b09d19157401$var$kg[$05d7b09d19157401$var$lg] = null;
    for(; a === $05d7b09d19157401$var$qg;)$05d7b09d19157401$var$qg = $05d7b09d19157401$var$og[--$05d7b09d19157401$var$pg], $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg] = null, $05d7b09d19157401$var$sg = $05d7b09d19157401$var$og[--$05d7b09d19157401$var$pg], $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg] = null, $05d7b09d19157401$var$rg = $05d7b09d19157401$var$og[--$05d7b09d19157401$var$pg], $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg] = null;
}
var $05d7b09d19157401$var$xg = null, $05d7b09d19157401$var$yg = null, $05d7b09d19157401$var$I = !1, $05d7b09d19157401$var$zg = null;
function $05d7b09d19157401$var$Ag(a, b) {
    var c = $05d7b09d19157401$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $05d7b09d19157401$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $05d7b09d19157401$var$xg = a, $05d7b09d19157401$var$yg = $05d7b09d19157401$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $05d7b09d19157401$var$xg = a, $05d7b09d19157401$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $05d7b09d19157401$var$qg ? {
                id: $05d7b09d19157401$var$rg,
                overflow: $05d7b09d19157401$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $05d7b09d19157401$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $05d7b09d19157401$var$xg = a, $05d7b09d19157401$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $05d7b09d19157401$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $05d7b09d19157401$var$Eg(a) {
    if ($05d7b09d19157401$var$I) {
        var b = $05d7b09d19157401$var$yg;
        if (b) {
            var c = b;
            if (!$05d7b09d19157401$var$Cg(a, b)) {
                if ($05d7b09d19157401$var$Dg(a)) throw Error($05d7b09d19157401$var$p(418));
                b = $05d7b09d19157401$var$Lf(c.nextSibling);
                var d = $05d7b09d19157401$var$xg;
                b && $05d7b09d19157401$var$Cg(a, b) ? $05d7b09d19157401$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $05d7b09d19157401$var$I = !1, $05d7b09d19157401$var$xg = a);
            }
        } else {
            if ($05d7b09d19157401$var$Dg(a)) throw Error($05d7b09d19157401$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $05d7b09d19157401$var$I = !1;
            $05d7b09d19157401$var$xg = a;
        }
    }
}
function $05d7b09d19157401$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $05d7b09d19157401$var$xg = a;
}
function $05d7b09d19157401$var$Gg(a) {
    if (a !== $05d7b09d19157401$var$xg) return !1;
    if (!$05d7b09d19157401$var$I) return $05d7b09d19157401$var$Fg(a), $05d7b09d19157401$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$05d7b09d19157401$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $05d7b09d19157401$var$yg)) {
        if ($05d7b09d19157401$var$Dg(a)) throw $05d7b09d19157401$var$Hg(), Error($05d7b09d19157401$var$p(418));
        for(; b;)$05d7b09d19157401$var$Ag(a, b), b = $05d7b09d19157401$var$Lf(b.nextSibling);
    }
    $05d7b09d19157401$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($05d7b09d19157401$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $05d7b09d19157401$var$yg = $05d7b09d19157401$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $05d7b09d19157401$var$yg = null;
        }
    } else $05d7b09d19157401$var$yg = $05d7b09d19157401$var$xg ? $05d7b09d19157401$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $05d7b09d19157401$var$Hg() {
    for(var a = $05d7b09d19157401$var$yg; a;)a = $05d7b09d19157401$var$Lf(a.nextSibling);
}
function $05d7b09d19157401$var$Ig() {
    $05d7b09d19157401$var$yg = $05d7b09d19157401$var$xg = null;
    $05d7b09d19157401$var$I = !1;
}
function $05d7b09d19157401$var$Jg(a) {
    null === $05d7b09d19157401$var$zg ? $05d7b09d19157401$var$zg = [
        a
    ] : $05d7b09d19157401$var$zg.push(a);
}
var $05d7b09d19157401$var$Kg = $05d7b09d19157401$var$ua.ReactCurrentBatchConfig;
function $05d7b09d19157401$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($05d7b09d19157401$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($05d7b09d19157401$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($05d7b09d19157401$var$p(284));
        if (!c._owner) throw Error($05d7b09d19157401$var$p(290, a));
    }
    return a;
}
function $05d7b09d19157401$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($05d7b09d19157401$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $05d7b09d19157401$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $05d7b09d19157401$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $05d7b09d19157401$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $05d7b09d19157401$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $05d7b09d19157401$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $05d7b09d19157401$var$Ha && $05d7b09d19157401$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $05d7b09d19157401$var$Lg(a, b, c), d.return = a, d;
        d = $05d7b09d19157401$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $05d7b09d19157401$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $05d7b09d19157401$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $05d7b09d19157401$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $05d7b09d19157401$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $05d7b09d19157401$var$va:
                    return c = $05d7b09d19157401$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $05d7b09d19157401$var$Lg(a, null, b), c.return = a, c;
                case $05d7b09d19157401$var$wa:
                    return b = $05d7b09d19157401$var$Sg(b, a.mode, c), b.return = a, b;
                case $05d7b09d19157401$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($05d7b09d19157401$var$eb(b) || $05d7b09d19157401$var$Ka(b)) return b = $05d7b09d19157401$var$Tg(b, a.mode, c, null), b.return = a, b;
            $05d7b09d19157401$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $05d7b09d19157401$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $05d7b09d19157401$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $05d7b09d19157401$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($05d7b09d19157401$var$eb(c) || $05d7b09d19157401$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $05d7b09d19157401$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $05d7b09d19157401$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $05d7b09d19157401$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $05d7b09d19157401$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($05d7b09d19157401$var$eb(d) || $05d7b09d19157401$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $05d7b09d19157401$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $05d7b09d19157401$var$I && $05d7b09d19157401$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $05d7b09d19157401$var$I && $05d7b09d19157401$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $05d7b09d19157401$var$I && $05d7b09d19157401$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $05d7b09d19157401$var$Ka(h);
        if ("function" !== typeof l) throw Error($05d7b09d19157401$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($05d7b09d19157401$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $05d7b09d19157401$var$I && $05d7b09d19157401$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $05d7b09d19157401$var$I && $05d7b09d19157401$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $05d7b09d19157401$var$I && $05d7b09d19157401$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $05d7b09d19157401$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $05d7b09d19157401$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $05d7b09d19157401$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $05d7b09d19157401$var$Ha && $05d7b09d19157401$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $05d7b09d19157401$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $05d7b09d19157401$var$ya ? (d = $05d7b09d19157401$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $05d7b09d19157401$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $05d7b09d19157401$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $05d7b09d19157401$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $05d7b09d19157401$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $05d7b09d19157401$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($05d7b09d19157401$var$eb(f)) return n(a, d, f, h);
            if ($05d7b09d19157401$var$Ka(f)) return t(a, d, f, h);
            $05d7b09d19157401$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $05d7b09d19157401$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $05d7b09d19157401$var$Ug = $05d7b09d19157401$var$Og(!0), $05d7b09d19157401$var$Vg = $05d7b09d19157401$var$Og(!1), $05d7b09d19157401$var$Wg = $05d7b09d19157401$var$Uf(null), $05d7b09d19157401$var$Xg = null, $05d7b09d19157401$var$Yg = null, $05d7b09d19157401$var$Zg = null;
function $05d7b09d19157401$var$$g() {
    $05d7b09d19157401$var$Zg = $05d7b09d19157401$var$Yg = $05d7b09d19157401$var$Xg = null;
}
function $05d7b09d19157401$var$ah(a) {
    var b = $05d7b09d19157401$var$Wg.current;
    $05d7b09d19157401$var$E($05d7b09d19157401$var$Wg);
    a._currentValue = b;
}
function $05d7b09d19157401$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $05d7b09d19157401$var$ch(a, b) {
    $05d7b09d19157401$var$Xg = a;
    $05d7b09d19157401$var$Zg = $05d7b09d19157401$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($05d7b09d19157401$var$dh = !0), a.firstContext = null);
}
function $05d7b09d19157401$var$eh(a) {
    var b = a._currentValue;
    if ($05d7b09d19157401$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $05d7b09d19157401$var$Yg) {
            if (null === $05d7b09d19157401$var$Xg) throw Error($05d7b09d19157401$var$p(308));
            $05d7b09d19157401$var$Yg = a;
            $05d7b09d19157401$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $05d7b09d19157401$var$Yg = $05d7b09d19157401$var$Yg.next = a;
    }
    return b;
}
var $05d7b09d19157401$var$fh = null;
function $05d7b09d19157401$var$gh(a) {
    null === $05d7b09d19157401$var$fh ? $05d7b09d19157401$var$fh = [
        a
    ] : $05d7b09d19157401$var$fh.push(a);
}
function $05d7b09d19157401$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $05d7b09d19157401$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $05d7b09d19157401$var$ih(a, d);
}
function $05d7b09d19157401$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $05d7b09d19157401$var$jh = !1;
function $05d7b09d19157401$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $05d7b09d19157401$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $05d7b09d19157401$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $05d7b09d19157401$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($05d7b09d19157401$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $05d7b09d19157401$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $05d7b09d19157401$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $05d7b09d19157401$var$ih(a, c);
}
function $05d7b09d19157401$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $05d7b09d19157401$var$Cc(a, c);
    }
}
function $05d7b09d19157401$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $05d7b09d19157401$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $05d7b09d19157401$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $05d7b09d19157401$var$A({}, q, r);
                            break a;
                        case 2:
                            $05d7b09d19157401$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $05d7b09d19157401$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $05d7b09d19157401$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($05d7b09d19157401$var$p(191, e));
            e.call(d);
        }
    }
}
var $05d7b09d19157401$var$th = {}, $05d7b09d19157401$var$uh = $05d7b09d19157401$var$Uf($05d7b09d19157401$var$th), $05d7b09d19157401$var$vh = $05d7b09d19157401$var$Uf($05d7b09d19157401$var$th), $05d7b09d19157401$var$wh = $05d7b09d19157401$var$Uf($05d7b09d19157401$var$th);
function $05d7b09d19157401$var$xh(a) {
    if (a === $05d7b09d19157401$var$th) throw Error($05d7b09d19157401$var$p(174));
    return a;
}
function $05d7b09d19157401$var$yh(a, b) {
    $05d7b09d19157401$var$G($05d7b09d19157401$var$wh, b);
    $05d7b09d19157401$var$G($05d7b09d19157401$var$vh, a);
    $05d7b09d19157401$var$G($05d7b09d19157401$var$uh, $05d7b09d19157401$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $05d7b09d19157401$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $05d7b09d19157401$var$lb(b, a);
    }
    $05d7b09d19157401$var$E($05d7b09d19157401$var$uh);
    $05d7b09d19157401$var$G($05d7b09d19157401$var$uh, b);
}
function $05d7b09d19157401$var$zh() {
    $05d7b09d19157401$var$E($05d7b09d19157401$var$uh);
    $05d7b09d19157401$var$E($05d7b09d19157401$var$vh);
    $05d7b09d19157401$var$E($05d7b09d19157401$var$wh);
}
function $05d7b09d19157401$var$Ah(a) {
    $05d7b09d19157401$var$xh($05d7b09d19157401$var$wh.current);
    var b = $05d7b09d19157401$var$xh($05d7b09d19157401$var$uh.current);
    var c = $05d7b09d19157401$var$lb(b, a.type);
    b !== c && ($05d7b09d19157401$var$G($05d7b09d19157401$var$vh, a), $05d7b09d19157401$var$G($05d7b09d19157401$var$uh, c));
}
function $05d7b09d19157401$var$Bh(a) {
    $05d7b09d19157401$var$vh.current === a && ($05d7b09d19157401$var$E($05d7b09d19157401$var$uh), $05d7b09d19157401$var$E($05d7b09d19157401$var$vh));
}
var $05d7b09d19157401$var$L = $05d7b09d19157401$var$Uf(0);
function $05d7b09d19157401$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $05d7b09d19157401$var$Dh = [];
function $05d7b09d19157401$var$Eh() {
    for(var a = 0; a < $05d7b09d19157401$var$Dh.length; a++)$05d7b09d19157401$var$Dh[a]._workInProgressVersionPrimary = null;
    $05d7b09d19157401$var$Dh.length = 0;
}
var $05d7b09d19157401$var$Fh = $05d7b09d19157401$var$ua.ReactCurrentDispatcher, $05d7b09d19157401$var$Gh = $05d7b09d19157401$var$ua.ReactCurrentBatchConfig, $05d7b09d19157401$var$Hh = 0, $05d7b09d19157401$var$M = null, $05d7b09d19157401$var$N = null, $05d7b09d19157401$var$O = null, $05d7b09d19157401$var$Ih = !1, $05d7b09d19157401$var$Jh = !1, $05d7b09d19157401$var$Kh = 0, $05d7b09d19157401$var$Lh = 0;
function $05d7b09d19157401$var$P() {
    throw Error($05d7b09d19157401$var$p(321));
}
function $05d7b09d19157401$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$05d7b09d19157401$var$He(a[c], b[c])) return !1;
    return !0;
}
function $05d7b09d19157401$var$Nh(a, b, c, d, e, f) {
    $05d7b09d19157401$var$Hh = f;
    $05d7b09d19157401$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $05d7b09d19157401$var$Fh.current = null === a || null === a.memoizedState ? $05d7b09d19157401$var$Oh : $05d7b09d19157401$var$Ph;
    a = c(d, e);
    if ($05d7b09d19157401$var$Jh) {
        f = 0;
        do {
            $05d7b09d19157401$var$Jh = !1;
            $05d7b09d19157401$var$Kh = 0;
            if (25 <= f) throw Error($05d7b09d19157401$var$p(301));
            f += 1;
            $05d7b09d19157401$var$O = $05d7b09d19157401$var$N = null;
            b.updateQueue = null;
            $05d7b09d19157401$var$Fh.current = $05d7b09d19157401$var$Qh;
            a = c(d, e);
        }while ($05d7b09d19157401$var$Jh);
    }
    $05d7b09d19157401$var$Fh.current = $05d7b09d19157401$var$Rh;
    b = null !== $05d7b09d19157401$var$N && null !== $05d7b09d19157401$var$N.next;
    $05d7b09d19157401$var$Hh = 0;
    $05d7b09d19157401$var$O = $05d7b09d19157401$var$N = $05d7b09d19157401$var$M = null;
    $05d7b09d19157401$var$Ih = !1;
    if (b) throw Error($05d7b09d19157401$var$p(300));
    return a;
}
function $05d7b09d19157401$var$Sh() {
    var a = 0 !== $05d7b09d19157401$var$Kh;
    $05d7b09d19157401$var$Kh = 0;
    return a;
}
function $05d7b09d19157401$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $05d7b09d19157401$var$O ? $05d7b09d19157401$var$M.memoizedState = $05d7b09d19157401$var$O = a : $05d7b09d19157401$var$O = $05d7b09d19157401$var$O.next = a;
    return $05d7b09d19157401$var$O;
}
function $05d7b09d19157401$var$Uh() {
    if (null === $05d7b09d19157401$var$N) {
        var a = $05d7b09d19157401$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $05d7b09d19157401$var$N.next;
    var b = null === $05d7b09d19157401$var$O ? $05d7b09d19157401$var$M.memoizedState : $05d7b09d19157401$var$O.next;
    if (null !== b) $05d7b09d19157401$var$O = b, $05d7b09d19157401$var$N = a;
    else {
        if (null === a) throw Error($05d7b09d19157401$var$p(310));
        $05d7b09d19157401$var$N = a;
        a = {
            memoizedState: $05d7b09d19157401$var$N.memoizedState,
            baseState: $05d7b09d19157401$var$N.baseState,
            baseQueue: $05d7b09d19157401$var$N.baseQueue,
            queue: $05d7b09d19157401$var$N.queue,
            next: null
        };
        null === $05d7b09d19157401$var$O ? $05d7b09d19157401$var$M.memoizedState = $05d7b09d19157401$var$O = a : $05d7b09d19157401$var$O = $05d7b09d19157401$var$O.next = a;
    }
    return $05d7b09d19157401$var$O;
}
function $05d7b09d19157401$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $05d7b09d19157401$var$Wh(a) {
    var b = $05d7b09d19157401$var$Uh(), c = b.queue;
    if (null === c) throw Error($05d7b09d19157401$var$p(311));
    c.lastRenderedReducer = a;
    var d = $05d7b09d19157401$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($05d7b09d19157401$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $05d7b09d19157401$var$M.lanes |= m;
                $05d7b09d19157401$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $05d7b09d19157401$var$He(d, b.memoizedState) || ($05d7b09d19157401$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $05d7b09d19157401$var$M.lanes |= f, $05d7b09d19157401$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $05d7b09d19157401$var$Xh(a) {
    var b = $05d7b09d19157401$var$Uh(), c = b.queue;
    if (null === c) throw Error($05d7b09d19157401$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $05d7b09d19157401$var$He(f, b.memoizedState) || ($05d7b09d19157401$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $05d7b09d19157401$var$Yh() {}
function $05d7b09d19157401$var$Zh(a, b) {
    var c = $05d7b09d19157401$var$M, d = $05d7b09d19157401$var$Uh(), e = b(), f = !$05d7b09d19157401$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $05d7b09d19157401$var$dh = !0);
    d = d.queue;
    $05d7b09d19157401$var$$h($05d7b09d19157401$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $05d7b09d19157401$var$O && $05d7b09d19157401$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $05d7b09d19157401$var$bi(9, $05d7b09d19157401$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $05d7b09d19157401$var$Q) throw Error($05d7b09d19157401$var$p(349));
        0 !== ($05d7b09d19157401$var$Hh & 30) || $05d7b09d19157401$var$di(c, b, e);
    }
    return e;
}
function $05d7b09d19157401$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $05d7b09d19157401$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $05d7b09d19157401$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $05d7b09d19157401$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $05d7b09d19157401$var$ei(b) && $05d7b09d19157401$var$fi(a);
}
function $05d7b09d19157401$var$ai(a, b, c) {
    return c(function() {
        $05d7b09d19157401$var$ei(b) && $05d7b09d19157401$var$fi(a);
    });
}
function $05d7b09d19157401$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$05d7b09d19157401$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $05d7b09d19157401$var$fi(a) {
    var b = $05d7b09d19157401$var$ih(a, 1);
    null !== b && $05d7b09d19157401$var$gi(b, a, 1, -1);
}
function $05d7b09d19157401$var$hi(a) {
    var b = $05d7b09d19157401$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $05d7b09d19157401$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $05d7b09d19157401$var$ii.bind(null, $05d7b09d19157401$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $05d7b09d19157401$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $05d7b09d19157401$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $05d7b09d19157401$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $05d7b09d19157401$var$ji() {
    return $05d7b09d19157401$var$Uh().memoizedState;
}
function $05d7b09d19157401$var$ki(a, b, c, d) {
    var e = $05d7b09d19157401$var$Th();
    $05d7b09d19157401$var$M.flags |= a;
    e.memoizedState = $05d7b09d19157401$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $05d7b09d19157401$var$li(a, b, c, d) {
    var e = $05d7b09d19157401$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $05d7b09d19157401$var$N) {
        var g = $05d7b09d19157401$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $05d7b09d19157401$var$Mh(d, g.deps)) {
            e.memoizedState = $05d7b09d19157401$var$bi(b, c, f, d);
            return;
        }
    }
    $05d7b09d19157401$var$M.flags |= a;
    e.memoizedState = $05d7b09d19157401$var$bi(1 | b, c, f, d);
}
function $05d7b09d19157401$var$mi(a, b) {
    return $05d7b09d19157401$var$ki(8390656, 8, a, b);
}
function $05d7b09d19157401$var$$h(a, b) {
    return $05d7b09d19157401$var$li(2048, 8, a, b);
}
function $05d7b09d19157401$var$ni(a, b) {
    return $05d7b09d19157401$var$li(4, 2, a, b);
}
function $05d7b09d19157401$var$oi(a, b) {
    return $05d7b09d19157401$var$li(4, 4, a, b);
}
function $05d7b09d19157401$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $05d7b09d19157401$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $05d7b09d19157401$var$li(4, 4, $05d7b09d19157401$var$pi.bind(null, b, a), c);
}
function $05d7b09d19157401$var$ri() {}
function $05d7b09d19157401$var$si(a, b) {
    var c = $05d7b09d19157401$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $05d7b09d19157401$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $05d7b09d19157401$var$ti(a, b) {
    var c = $05d7b09d19157401$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $05d7b09d19157401$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $05d7b09d19157401$var$ui(a, b, c) {
    if (0 === ($05d7b09d19157401$var$Hh & 21)) return a.baseState && (a.baseState = !1, $05d7b09d19157401$var$dh = !0), a.memoizedState = c;
    $05d7b09d19157401$var$He(c, b) || (c = $05d7b09d19157401$var$yc(), $05d7b09d19157401$var$M.lanes |= c, $05d7b09d19157401$var$rh |= c, a.baseState = !0);
    return b;
}
function $05d7b09d19157401$var$vi(a, b) {
    var c = $05d7b09d19157401$var$C;
    $05d7b09d19157401$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $05d7b09d19157401$var$Gh.transition;
    $05d7b09d19157401$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $05d7b09d19157401$var$C = c, $05d7b09d19157401$var$Gh.transition = d;
    }
}
function $05d7b09d19157401$var$wi() {
    return $05d7b09d19157401$var$Uh().memoizedState;
}
function $05d7b09d19157401$var$xi(a, b, c) {
    var d = $05d7b09d19157401$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($05d7b09d19157401$var$zi(a)) $05d7b09d19157401$var$Ai(b, c);
    else if (c = $05d7b09d19157401$var$hh(a, b, c, d), null !== c) {
        var e = $05d7b09d19157401$var$R();
        $05d7b09d19157401$var$gi(c, a, d, e);
        $05d7b09d19157401$var$Bi(c, b, d);
    }
}
function $05d7b09d19157401$var$ii(a, b, c) {
    var d = $05d7b09d19157401$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($05d7b09d19157401$var$zi(a)) $05d7b09d19157401$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($05d7b09d19157401$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $05d7b09d19157401$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $05d7b09d19157401$var$hh(a, b, e, d);
        null !== c && (e = $05d7b09d19157401$var$R(), $05d7b09d19157401$var$gi(c, a, d, e), $05d7b09d19157401$var$Bi(c, b, d));
    }
}
function $05d7b09d19157401$var$zi(a) {
    var b = a.alternate;
    return a === $05d7b09d19157401$var$M || null !== b && b === $05d7b09d19157401$var$M;
}
function $05d7b09d19157401$var$Ai(a, b) {
    $05d7b09d19157401$var$Jh = $05d7b09d19157401$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $05d7b09d19157401$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $05d7b09d19157401$var$Cc(a, c);
    }
}
var $05d7b09d19157401$var$Rh = {
    readContext: $05d7b09d19157401$var$eh,
    useCallback: $05d7b09d19157401$var$P,
    useContext: $05d7b09d19157401$var$P,
    useEffect: $05d7b09d19157401$var$P,
    useImperativeHandle: $05d7b09d19157401$var$P,
    useInsertionEffect: $05d7b09d19157401$var$P,
    useLayoutEffect: $05d7b09d19157401$var$P,
    useMemo: $05d7b09d19157401$var$P,
    useReducer: $05d7b09d19157401$var$P,
    useRef: $05d7b09d19157401$var$P,
    useState: $05d7b09d19157401$var$P,
    useDebugValue: $05d7b09d19157401$var$P,
    useDeferredValue: $05d7b09d19157401$var$P,
    useTransition: $05d7b09d19157401$var$P,
    useMutableSource: $05d7b09d19157401$var$P,
    useSyncExternalStore: $05d7b09d19157401$var$P,
    useId: $05d7b09d19157401$var$P,
    unstable_isNewReconciler: !1
}, $05d7b09d19157401$var$Oh = {
    readContext: $05d7b09d19157401$var$eh,
    useCallback: function(a, b) {
        $05d7b09d19157401$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $05d7b09d19157401$var$eh,
    useEffect: $05d7b09d19157401$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $05d7b09d19157401$var$ki(4194308, 4, $05d7b09d19157401$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $05d7b09d19157401$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $05d7b09d19157401$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $05d7b09d19157401$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $05d7b09d19157401$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $05d7b09d19157401$var$xi.bind(null, $05d7b09d19157401$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $05d7b09d19157401$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $05d7b09d19157401$var$hi,
    useDebugValue: $05d7b09d19157401$var$ri,
    useDeferredValue: function(a) {
        return $05d7b09d19157401$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $05d7b09d19157401$var$hi(!1), b = a[0];
        a = $05d7b09d19157401$var$vi.bind(null, a[1]);
        $05d7b09d19157401$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $05d7b09d19157401$var$M, e = $05d7b09d19157401$var$Th();
        if ($05d7b09d19157401$var$I) {
            if (void 0 === c) throw Error($05d7b09d19157401$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $05d7b09d19157401$var$Q) throw Error($05d7b09d19157401$var$p(349));
            0 !== ($05d7b09d19157401$var$Hh & 30) || $05d7b09d19157401$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $05d7b09d19157401$var$mi($05d7b09d19157401$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $05d7b09d19157401$var$bi(9, $05d7b09d19157401$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $05d7b09d19157401$var$Th(), b = $05d7b09d19157401$var$Q.identifierPrefix;
        if ($05d7b09d19157401$var$I) {
            var c = $05d7b09d19157401$var$sg;
            var d = $05d7b09d19157401$var$rg;
            c = (d & ~(1 << 32 - $05d7b09d19157401$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $05d7b09d19157401$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $05d7b09d19157401$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $05d7b09d19157401$var$Ph = {
    readContext: $05d7b09d19157401$var$eh,
    useCallback: $05d7b09d19157401$var$si,
    useContext: $05d7b09d19157401$var$eh,
    useEffect: $05d7b09d19157401$var$$h,
    useImperativeHandle: $05d7b09d19157401$var$qi,
    useInsertionEffect: $05d7b09d19157401$var$ni,
    useLayoutEffect: $05d7b09d19157401$var$oi,
    useMemo: $05d7b09d19157401$var$ti,
    useReducer: $05d7b09d19157401$var$Wh,
    useRef: $05d7b09d19157401$var$ji,
    useState: function() {
        return $05d7b09d19157401$var$Wh($05d7b09d19157401$var$Vh);
    },
    useDebugValue: $05d7b09d19157401$var$ri,
    useDeferredValue: function(a) {
        var b = $05d7b09d19157401$var$Uh();
        return $05d7b09d19157401$var$ui(b, $05d7b09d19157401$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $05d7b09d19157401$var$Wh($05d7b09d19157401$var$Vh)[0], b = $05d7b09d19157401$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $05d7b09d19157401$var$Yh,
    useSyncExternalStore: $05d7b09d19157401$var$Zh,
    useId: $05d7b09d19157401$var$wi,
    unstable_isNewReconciler: !1
}, $05d7b09d19157401$var$Qh = {
    readContext: $05d7b09d19157401$var$eh,
    useCallback: $05d7b09d19157401$var$si,
    useContext: $05d7b09d19157401$var$eh,
    useEffect: $05d7b09d19157401$var$$h,
    useImperativeHandle: $05d7b09d19157401$var$qi,
    useInsertionEffect: $05d7b09d19157401$var$ni,
    useLayoutEffect: $05d7b09d19157401$var$oi,
    useMemo: $05d7b09d19157401$var$ti,
    useReducer: $05d7b09d19157401$var$Xh,
    useRef: $05d7b09d19157401$var$ji,
    useState: function() {
        return $05d7b09d19157401$var$Xh($05d7b09d19157401$var$Vh);
    },
    useDebugValue: $05d7b09d19157401$var$ri,
    useDeferredValue: function(a) {
        var b = $05d7b09d19157401$var$Uh();
        return null === $05d7b09d19157401$var$N ? b.memoizedState = a : $05d7b09d19157401$var$ui(b, $05d7b09d19157401$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $05d7b09d19157401$var$Xh($05d7b09d19157401$var$Vh)[0], b = $05d7b09d19157401$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $05d7b09d19157401$var$Yh,
    useSyncExternalStore: $05d7b09d19157401$var$Zh,
    useId: $05d7b09d19157401$var$wi,
    unstable_isNewReconciler: !1
};
function $05d7b09d19157401$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $05d7b09d19157401$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $05d7b09d19157401$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $05d7b09d19157401$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $05d7b09d19157401$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $05d7b09d19157401$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $05d7b09d19157401$var$R(), e = $05d7b09d19157401$var$yi(a), f = $05d7b09d19157401$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $05d7b09d19157401$var$nh(a, f, e);
        null !== b && ($05d7b09d19157401$var$gi(b, a, e, d), $05d7b09d19157401$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $05d7b09d19157401$var$R(), e = $05d7b09d19157401$var$yi(a), f = $05d7b09d19157401$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $05d7b09d19157401$var$nh(a, f, e);
        null !== b && ($05d7b09d19157401$var$gi(b, a, e, d), $05d7b09d19157401$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $05d7b09d19157401$var$R(), d = $05d7b09d19157401$var$yi(a), e = $05d7b09d19157401$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $05d7b09d19157401$var$nh(a, e, d);
        null !== b && ($05d7b09d19157401$var$gi(b, a, d, c), $05d7b09d19157401$var$oh(b, a, d));
    }
};
function $05d7b09d19157401$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$05d7b09d19157401$var$Ie(c, d) || !$05d7b09d19157401$var$Ie(e, f) : !0;
}
function $05d7b09d19157401$var$Gi(a, b, c) {
    var d = !1, e = $05d7b09d19157401$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $05d7b09d19157401$var$eh(f) : (e = $05d7b09d19157401$var$Zf(b) ? $05d7b09d19157401$var$Xf : $05d7b09d19157401$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $05d7b09d19157401$var$Yf(a, e) : $05d7b09d19157401$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $05d7b09d19157401$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $05d7b09d19157401$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $05d7b09d19157401$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $05d7b09d19157401$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $05d7b09d19157401$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $05d7b09d19157401$var$eh(f) : (f = $05d7b09d19157401$var$Zf(b) ? $05d7b09d19157401$var$Xf : $05d7b09d19157401$var$H.current, e.context = $05d7b09d19157401$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($05d7b09d19157401$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $05d7b09d19157401$var$Ei.enqueueReplaceState(e, e.state, null), $05d7b09d19157401$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $05d7b09d19157401$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $05d7b09d19157401$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $05d7b09d19157401$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $05d7b09d19157401$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $05d7b09d19157401$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $05d7b09d19157401$var$Ni(a, b, c) {
    c = $05d7b09d19157401$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $05d7b09d19157401$var$Oi || ($05d7b09d19157401$var$Oi = !0, $05d7b09d19157401$var$Pi = d);
        $05d7b09d19157401$var$Li(a, b);
    };
    return c;
}
function $05d7b09d19157401$var$Qi(a, b, c) {
    c = $05d7b09d19157401$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $05d7b09d19157401$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $05d7b09d19157401$var$Li(a, b);
        "function" !== typeof d && (null === $05d7b09d19157401$var$Ri ? $05d7b09d19157401$var$Ri = new Set([
            this
        ]) : $05d7b09d19157401$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $05d7b09d19157401$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $05d7b09d19157401$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $05d7b09d19157401$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $05d7b09d19157401$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $05d7b09d19157401$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $05d7b09d19157401$var$mh(-1, 1), b.tag = 2, $05d7b09d19157401$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $05d7b09d19157401$var$Wi = $05d7b09d19157401$var$ua.ReactCurrentOwner, $05d7b09d19157401$var$dh = !1;
function $05d7b09d19157401$var$Xi(a, b, c, d) {
    b.child = null === a ? $05d7b09d19157401$var$Vg(b, null, c, d) : $05d7b09d19157401$var$Ug(b, a.child, c, d);
}
function $05d7b09d19157401$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $05d7b09d19157401$var$ch(b, e);
    d = $05d7b09d19157401$var$Nh(a, b, c, d, f, e);
    c = $05d7b09d19157401$var$Sh();
    if (null !== a && !$05d7b09d19157401$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $05d7b09d19157401$var$Zi(a, b, e);
    $05d7b09d19157401$var$I && c && $05d7b09d19157401$var$vg(b);
    b.flags |= 1;
    $05d7b09d19157401$var$Xi(a, b, d, e);
    return b.child;
}
function $05d7b09d19157401$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$05d7b09d19157401$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $05d7b09d19157401$var$bj(a, b, f, d, e);
        a = $05d7b09d19157401$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $05d7b09d19157401$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $05d7b09d19157401$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $05d7b09d19157401$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $05d7b09d19157401$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($05d7b09d19157401$var$Ie(f, d) && a.ref === b.ref) {
            if ($05d7b09d19157401$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($05d7b09d19157401$var$dh = !0);
            else return b.lanes = a.lanes, $05d7b09d19157401$var$Zi(a, b, e);
        }
    }
    return $05d7b09d19157401$var$cj(a, b, c, d, e);
}
function $05d7b09d19157401$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $05d7b09d19157401$var$G($05d7b09d19157401$var$ej, $05d7b09d19157401$var$fj), $05d7b09d19157401$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $05d7b09d19157401$var$G($05d7b09d19157401$var$ej, $05d7b09d19157401$var$fj), $05d7b09d19157401$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $05d7b09d19157401$var$G($05d7b09d19157401$var$ej, $05d7b09d19157401$var$fj);
            $05d7b09d19157401$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $05d7b09d19157401$var$G($05d7b09d19157401$var$ej, $05d7b09d19157401$var$fj), $05d7b09d19157401$var$fj |= d;
    $05d7b09d19157401$var$Xi(a, b, e, c);
    return b.child;
}
function $05d7b09d19157401$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $05d7b09d19157401$var$cj(a, b, c, d, e) {
    var f = $05d7b09d19157401$var$Zf(c) ? $05d7b09d19157401$var$Xf : $05d7b09d19157401$var$H.current;
    f = $05d7b09d19157401$var$Yf(b, f);
    $05d7b09d19157401$var$ch(b, e);
    c = $05d7b09d19157401$var$Nh(a, b, c, d, f, e);
    d = $05d7b09d19157401$var$Sh();
    if (null !== a && !$05d7b09d19157401$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $05d7b09d19157401$var$Zi(a, b, e);
    $05d7b09d19157401$var$I && d && $05d7b09d19157401$var$vg(b);
    b.flags |= 1;
    $05d7b09d19157401$var$Xi(a, b, c, e);
    return b.child;
}
function $05d7b09d19157401$var$hj(a, b, c, d, e) {
    if ($05d7b09d19157401$var$Zf(c)) {
        var f = !0;
        $05d7b09d19157401$var$cg(b);
    } else f = !1;
    $05d7b09d19157401$var$ch(b, e);
    if (null === b.stateNode) $05d7b09d19157401$var$ij(a, b), $05d7b09d19157401$var$Gi(b, c, d), $05d7b09d19157401$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $05d7b09d19157401$var$eh(l) : (l = $05d7b09d19157401$var$Zf(c) ? $05d7b09d19157401$var$Xf : $05d7b09d19157401$var$H.current, l = $05d7b09d19157401$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $05d7b09d19157401$var$Hi(b, g, d, l);
        $05d7b09d19157401$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $05d7b09d19157401$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $05d7b09d19157401$var$Wf.current || $05d7b09d19157401$var$jh ? ("function" === typeof m && ($05d7b09d19157401$var$Di(b, c, m, d), k = b.memoizedState), (h = $05d7b09d19157401$var$jh || $05d7b09d19157401$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $05d7b09d19157401$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $05d7b09d19157401$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $05d7b09d19157401$var$eh(k) : (k = $05d7b09d19157401$var$Zf(c) ? $05d7b09d19157401$var$Xf : $05d7b09d19157401$var$H.current, k = $05d7b09d19157401$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $05d7b09d19157401$var$Hi(b, g, d, k);
        $05d7b09d19157401$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $05d7b09d19157401$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $05d7b09d19157401$var$Wf.current || $05d7b09d19157401$var$jh ? ("function" === typeof y && ($05d7b09d19157401$var$Di(b, c, y, d), n = b.memoizedState), (l = $05d7b09d19157401$var$jh || $05d7b09d19157401$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $05d7b09d19157401$var$jj(a, b, c, d, f, e);
}
function $05d7b09d19157401$var$jj(a, b, c, d, e, f) {
    $05d7b09d19157401$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $05d7b09d19157401$var$dg(b, c, !1), $05d7b09d19157401$var$Zi(a, b, f);
    d = b.stateNode;
    $05d7b09d19157401$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $05d7b09d19157401$var$Ug(b, a.child, null, f), b.child = $05d7b09d19157401$var$Ug(b, null, h, f)) : $05d7b09d19157401$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $05d7b09d19157401$var$dg(b, c, !0);
    return b.child;
}
function $05d7b09d19157401$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $05d7b09d19157401$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $05d7b09d19157401$var$ag(a, b.context, !1);
    $05d7b09d19157401$var$yh(a, b.containerInfo);
}
function $05d7b09d19157401$var$lj(a, b, c, d, e) {
    $05d7b09d19157401$var$Ig();
    $05d7b09d19157401$var$Jg(e);
    b.flags |= 256;
    $05d7b09d19157401$var$Xi(a, b, c, d);
    return b.child;
}
var $05d7b09d19157401$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $05d7b09d19157401$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $05d7b09d19157401$var$oj(a, b, c) {
    var d = b.pendingProps, e = $05d7b09d19157401$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $05d7b09d19157401$var$G($05d7b09d19157401$var$L, e & 1);
    if (null === a) {
        $05d7b09d19157401$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $05d7b09d19157401$var$pj(g, d, 0, null), a = $05d7b09d19157401$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $05d7b09d19157401$var$nj(c), b.memoizedState = $05d7b09d19157401$var$mj, a) : $05d7b09d19157401$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $05d7b09d19157401$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $05d7b09d19157401$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $05d7b09d19157401$var$Pg(h, f) : (f = $05d7b09d19157401$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $05d7b09d19157401$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $05d7b09d19157401$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $05d7b09d19157401$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $05d7b09d19157401$var$qj(a, b) {
    b = $05d7b09d19157401$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $05d7b09d19157401$var$sj(a, b, c, d) {
    null !== d && $05d7b09d19157401$var$Jg(d);
    $05d7b09d19157401$var$Ug(b, a.child, null, c);
    a = $05d7b09d19157401$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $05d7b09d19157401$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $05d7b09d19157401$var$Ki(Error($05d7b09d19157401$var$p(422))), $05d7b09d19157401$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $05d7b09d19157401$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $05d7b09d19157401$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $05d7b09d19157401$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $05d7b09d19157401$var$nj(g);
        b.memoizedState = $05d7b09d19157401$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $05d7b09d19157401$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($05d7b09d19157401$var$p(419));
        d = $05d7b09d19157401$var$Ki(f, d, void 0);
        return $05d7b09d19157401$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($05d7b09d19157401$var$dh || h) {
        d = $05d7b09d19157401$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $05d7b09d19157401$var$ih(a, e), $05d7b09d19157401$var$gi(d, a, e, -1));
        }
        $05d7b09d19157401$var$tj();
        d = $05d7b09d19157401$var$Ki(Error($05d7b09d19157401$var$p(421)));
        return $05d7b09d19157401$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $05d7b09d19157401$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $05d7b09d19157401$var$yg = $05d7b09d19157401$var$Lf(e.nextSibling);
    $05d7b09d19157401$var$xg = b;
    $05d7b09d19157401$var$I = !0;
    $05d7b09d19157401$var$zg = null;
    null !== a && ($05d7b09d19157401$var$og[$05d7b09d19157401$var$pg++] = $05d7b09d19157401$var$rg, $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg++] = $05d7b09d19157401$var$sg, $05d7b09d19157401$var$og[$05d7b09d19157401$var$pg++] = $05d7b09d19157401$var$qg, $05d7b09d19157401$var$rg = a.id, $05d7b09d19157401$var$sg = a.overflow, $05d7b09d19157401$var$qg = b);
    b = $05d7b09d19157401$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $05d7b09d19157401$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $05d7b09d19157401$var$bh(a.return, b, c);
}
function $05d7b09d19157401$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $05d7b09d19157401$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $05d7b09d19157401$var$Xi(a, b, d.children, c);
    d = $05d7b09d19157401$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $05d7b09d19157401$var$vj(a, c, b);
            else if (19 === a.tag) $05d7b09d19157401$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $05d7b09d19157401$var$G($05d7b09d19157401$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $05d7b09d19157401$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $05d7b09d19157401$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $05d7b09d19157401$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $05d7b09d19157401$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $05d7b09d19157401$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $05d7b09d19157401$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $05d7b09d19157401$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $05d7b09d19157401$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($05d7b09d19157401$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $05d7b09d19157401$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $05d7b09d19157401$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $05d7b09d19157401$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $05d7b09d19157401$var$kj(b);
            $05d7b09d19157401$var$Ig();
            break;
        case 5:
            $05d7b09d19157401$var$Ah(b);
            break;
        case 1:
            $05d7b09d19157401$var$Zf(b.type) && $05d7b09d19157401$var$cg(b);
            break;
        case 4:
            $05d7b09d19157401$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $05d7b09d19157401$var$G($05d7b09d19157401$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $05d7b09d19157401$var$G($05d7b09d19157401$var$L, $05d7b09d19157401$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $05d7b09d19157401$var$oj(a, b, c);
                $05d7b09d19157401$var$G($05d7b09d19157401$var$L, $05d7b09d19157401$var$L.current & 1);
                a = $05d7b09d19157401$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $05d7b09d19157401$var$G($05d7b09d19157401$var$L, $05d7b09d19157401$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $05d7b09d19157401$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $05d7b09d19157401$var$G($05d7b09d19157401$var$L, $05d7b09d19157401$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $05d7b09d19157401$var$dj(a, b, c);
    }
    return $05d7b09d19157401$var$Zi(a, b, c);
}
var $05d7b09d19157401$var$zj, $05d7b09d19157401$var$Aj, $05d7b09d19157401$var$Bj, $05d7b09d19157401$var$Cj;
$05d7b09d19157401$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$05d7b09d19157401$var$Aj = function() {};
$05d7b09d19157401$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $05d7b09d19157401$var$xh($05d7b09d19157401$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $05d7b09d19157401$var$Ya(a, e);
                d = $05d7b09d19157401$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $05d7b09d19157401$var$A({}, e, {
                    value: void 0
                });
                d = $05d7b09d19157401$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $05d7b09d19157401$var$gb(a, e);
                d = $05d7b09d19157401$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $05d7b09d19157401$var$Bf);
        }
        $05d7b09d19157401$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($05d7b09d19157401$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($05d7b09d19157401$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $05d7b09d19157401$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$05d7b09d19157401$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $05d7b09d19157401$var$Dj(a, b) {
    if (!$05d7b09d19157401$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $05d7b09d19157401$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $05d7b09d19157401$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $05d7b09d19157401$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $05d7b09d19157401$var$S(b), null;
        case 1:
            return $05d7b09d19157401$var$Zf(b.type) && $05d7b09d19157401$var$$f(), $05d7b09d19157401$var$S(b), null;
        case 3:
            d = b.stateNode;
            $05d7b09d19157401$var$zh();
            $05d7b09d19157401$var$E($05d7b09d19157401$var$Wf);
            $05d7b09d19157401$var$E($05d7b09d19157401$var$H);
            $05d7b09d19157401$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $05d7b09d19157401$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $05d7b09d19157401$var$zg && ($05d7b09d19157401$var$Fj($05d7b09d19157401$var$zg), $05d7b09d19157401$var$zg = null));
            $05d7b09d19157401$var$Aj(a, b);
            $05d7b09d19157401$var$S(b);
            return null;
        case 5:
            $05d7b09d19157401$var$Bh(b);
            var e = $05d7b09d19157401$var$xh($05d7b09d19157401$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $05d7b09d19157401$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($05d7b09d19157401$var$p(166));
                    $05d7b09d19157401$var$S(b);
                    return null;
                }
                a = $05d7b09d19157401$var$xh($05d7b09d19157401$var$uh.current);
                if ($05d7b09d19157401$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$05d7b09d19157401$var$Of] = b;
                    d[$05d7b09d19157401$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $05d7b09d19157401$var$D("cancel", d);
                            $05d7b09d19157401$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $05d7b09d19157401$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $05d7b09d19157401$var$lf.length; e++)$05d7b09d19157401$var$D($05d7b09d19157401$var$lf[e], d);
                            break;
                        case "source":
                            $05d7b09d19157401$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $05d7b09d19157401$var$D("error", d);
                            $05d7b09d19157401$var$D("load", d);
                            break;
                        case "details":
                            $05d7b09d19157401$var$D("toggle", d);
                            break;
                        case "input":
                            $05d7b09d19157401$var$Za(d, f);
                            $05d7b09d19157401$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $05d7b09d19157401$var$D("invalid", d);
                            break;
                        case "textarea":
                            $05d7b09d19157401$var$hb(d, f), $05d7b09d19157401$var$D("invalid", d);
                    }
                    $05d7b09d19157401$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $05d7b09d19157401$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $05d7b09d19157401$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $05d7b09d19157401$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $05d7b09d19157401$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $05d7b09d19157401$var$Va(d);
                            $05d7b09d19157401$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $05d7b09d19157401$var$Va(d);
                            $05d7b09d19157401$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $05d7b09d19157401$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $05d7b09d19157401$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$05d7b09d19157401$var$Of] = b;
                    a[$05d7b09d19157401$var$Pf] = d;
                    $05d7b09d19157401$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $05d7b09d19157401$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $05d7b09d19157401$var$D("cancel", a);
                                $05d7b09d19157401$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $05d7b09d19157401$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $05d7b09d19157401$var$lf.length; e++)$05d7b09d19157401$var$D($05d7b09d19157401$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $05d7b09d19157401$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $05d7b09d19157401$var$D("error", a);
                                $05d7b09d19157401$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $05d7b09d19157401$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $05d7b09d19157401$var$Za(a, d);
                                e = $05d7b09d19157401$var$Ya(a, d);
                                $05d7b09d19157401$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $05d7b09d19157401$var$A({}, d, {
                                    value: void 0
                                });
                                $05d7b09d19157401$var$D("invalid", a);
                                break;
                            case "textarea":
                                $05d7b09d19157401$var$hb(a, d);
                                e = $05d7b09d19157401$var$gb(a, d);
                                $05d7b09d19157401$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $05d7b09d19157401$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $05d7b09d19157401$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $05d7b09d19157401$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $05d7b09d19157401$var$ob(a, k) : "number" === typeof k && $05d7b09d19157401$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($05d7b09d19157401$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $05d7b09d19157401$var$D("scroll", a) : null != k && $05d7b09d19157401$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $05d7b09d19157401$var$Va(a);
                                $05d7b09d19157401$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $05d7b09d19157401$var$Va(a);
                                $05d7b09d19157401$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $05d7b09d19157401$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $05d7b09d19157401$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $05d7b09d19157401$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $05d7b09d19157401$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $05d7b09d19157401$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $05d7b09d19157401$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($05d7b09d19157401$var$p(166));
                c = $05d7b09d19157401$var$xh($05d7b09d19157401$var$wh.current);
                $05d7b09d19157401$var$xh($05d7b09d19157401$var$uh.current);
                if ($05d7b09d19157401$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$05d7b09d19157401$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $05d7b09d19157401$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $05d7b09d19157401$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $05d7b09d19157401$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$05d7b09d19157401$var$Of] = b, b.stateNode = d;
            }
            $05d7b09d19157401$var$S(b);
            return null;
        case 13:
            $05d7b09d19157401$var$E($05d7b09d19157401$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($05d7b09d19157401$var$I && null !== $05d7b09d19157401$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $05d7b09d19157401$var$Hg(), $05d7b09d19157401$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $05d7b09d19157401$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($05d7b09d19157401$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($05d7b09d19157401$var$p(317));
                        f[$05d7b09d19157401$var$Of] = b;
                    } else $05d7b09d19157401$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $05d7b09d19157401$var$S(b);
                    f = !1;
                } else null !== $05d7b09d19157401$var$zg && ($05d7b09d19157401$var$Fj($05d7b09d19157401$var$zg), $05d7b09d19157401$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($05d7b09d19157401$var$L.current & 1) ? 0 === $05d7b09d19157401$var$T && ($05d7b09d19157401$var$T = 3) : $05d7b09d19157401$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $05d7b09d19157401$var$S(b);
            return null;
        case 4:
            return $05d7b09d19157401$var$zh(), $05d7b09d19157401$var$Aj(a, b), null === a && $05d7b09d19157401$var$sf(b.stateNode.containerInfo), $05d7b09d19157401$var$S(b), null;
        case 10:
            return $05d7b09d19157401$var$ah(b.type._context), $05d7b09d19157401$var$S(b), null;
        case 17:
            return $05d7b09d19157401$var$Zf(b.type) && $05d7b09d19157401$var$$f(), $05d7b09d19157401$var$S(b), null;
        case 19:
            $05d7b09d19157401$var$E($05d7b09d19157401$var$L);
            f = b.memoizedState;
            if (null === f) return $05d7b09d19157401$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $05d7b09d19157401$var$Dj(f, !1);
                else {
                    if (0 !== $05d7b09d19157401$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $05d7b09d19157401$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $05d7b09d19157401$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $05d7b09d19157401$var$G($05d7b09d19157401$var$L, $05d7b09d19157401$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $05d7b09d19157401$var$B() > $05d7b09d19157401$var$Gj && (b.flags |= 128, d = !0, $05d7b09d19157401$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $05d7b09d19157401$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $05d7b09d19157401$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$05d7b09d19157401$var$I) return $05d7b09d19157401$var$S(b), null;
                    } else 2 * $05d7b09d19157401$var$B() - f.renderingStartTime > $05d7b09d19157401$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $05d7b09d19157401$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $05d7b09d19157401$var$B(), b.sibling = null, c = $05d7b09d19157401$var$L.current, $05d7b09d19157401$var$G($05d7b09d19157401$var$L, d ? c & 1 | 2 : c & 1), b;
            $05d7b09d19157401$var$S(b);
            return null;
        case 22:
        case 23:
            return $05d7b09d19157401$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($05d7b09d19157401$var$fj & 1073741824) && ($05d7b09d19157401$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $05d7b09d19157401$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($05d7b09d19157401$var$p(156, b.tag));
}
function $05d7b09d19157401$var$Ij(a, b) {
    $05d7b09d19157401$var$wg(b);
    switch(b.tag){
        case 1:
            return $05d7b09d19157401$var$Zf(b.type) && $05d7b09d19157401$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $05d7b09d19157401$var$zh(), $05d7b09d19157401$var$E($05d7b09d19157401$var$Wf), $05d7b09d19157401$var$E($05d7b09d19157401$var$H), $05d7b09d19157401$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $05d7b09d19157401$var$Bh(b), null;
        case 13:
            $05d7b09d19157401$var$E($05d7b09d19157401$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($05d7b09d19157401$var$p(340));
                $05d7b09d19157401$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $05d7b09d19157401$var$E($05d7b09d19157401$var$L), null;
        case 4:
            return $05d7b09d19157401$var$zh(), null;
        case 10:
            return $05d7b09d19157401$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $05d7b09d19157401$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $05d7b09d19157401$var$Jj = !1, $05d7b09d19157401$var$U = !1, $05d7b09d19157401$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $05d7b09d19157401$var$V = null;
function $05d7b09d19157401$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $05d7b09d19157401$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $05d7b09d19157401$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $05d7b09d19157401$var$W(a, b, d);
    }
}
var $05d7b09d19157401$var$Nj = !1;
function $05d7b09d19157401$var$Oj(a, b) {
    $05d7b09d19157401$var$Cf = $05d7b09d19157401$var$dd;
    a = $05d7b09d19157401$var$Me();
    if ($05d7b09d19157401$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $05d7b09d19157401$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $05d7b09d19157401$var$dd = !1;
    for($05d7b09d19157401$var$V = b; null !== $05d7b09d19157401$var$V;)if (b = $05d7b09d19157401$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $05d7b09d19157401$var$V = a;
    else for(; null !== $05d7b09d19157401$var$V;){
        b = $05d7b09d19157401$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $05d7b09d19157401$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($05d7b09d19157401$var$p(163));
            }
        } catch (F) {
            $05d7b09d19157401$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $05d7b09d19157401$var$V = a;
            break;
        }
        $05d7b09d19157401$var$V = b.return;
    }
    n = $05d7b09d19157401$var$Nj;
    $05d7b09d19157401$var$Nj = !1;
    return n;
}
function $05d7b09d19157401$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $05d7b09d19157401$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $05d7b09d19157401$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $05d7b09d19157401$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $05d7b09d19157401$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $05d7b09d19157401$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$05d7b09d19157401$var$Of], delete b[$05d7b09d19157401$var$Pf], delete b[$05d7b09d19157401$var$of], delete b[$05d7b09d19157401$var$Qf], delete b[$05d7b09d19157401$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $05d7b09d19157401$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $05d7b09d19157401$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $05d7b09d19157401$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $05d7b09d19157401$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $05d7b09d19157401$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($05d7b09d19157401$var$Vj(a, b, c), a = a.sibling; null !== a;)$05d7b09d19157401$var$Vj(a, b, c), a = a.sibling;
}
function $05d7b09d19157401$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($05d7b09d19157401$var$Wj(a, b, c), a = a.sibling; null !== a;)$05d7b09d19157401$var$Wj(a, b, c), a = a.sibling;
}
var $05d7b09d19157401$var$X = null, $05d7b09d19157401$var$Xj = !1;
function $05d7b09d19157401$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$05d7b09d19157401$var$Zj(a, b, c), c = c.sibling;
}
function $05d7b09d19157401$var$Zj(a, b, c) {
    if ($05d7b09d19157401$var$lc && "function" === typeof $05d7b09d19157401$var$lc.onCommitFiberUnmount) try {
        $05d7b09d19157401$var$lc.onCommitFiberUnmount($05d7b09d19157401$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $05d7b09d19157401$var$U || $05d7b09d19157401$var$Lj(c, b);
        case 6:
            var d = $05d7b09d19157401$var$X, e = $05d7b09d19157401$var$Xj;
            $05d7b09d19157401$var$X = null;
            $05d7b09d19157401$var$Yj(a, b, c);
            $05d7b09d19157401$var$X = d;
            $05d7b09d19157401$var$Xj = e;
            null !== $05d7b09d19157401$var$X && ($05d7b09d19157401$var$Xj ? (a = $05d7b09d19157401$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $05d7b09d19157401$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $05d7b09d19157401$var$X && ($05d7b09d19157401$var$Xj ? (a = $05d7b09d19157401$var$X, c = c.stateNode, 8 === a.nodeType ? $05d7b09d19157401$var$Kf(a.parentNode, c) : 1 === a.nodeType && $05d7b09d19157401$var$Kf(a, c), $05d7b09d19157401$var$bd(a)) : $05d7b09d19157401$var$Kf($05d7b09d19157401$var$X, c.stateNode));
            break;
        case 4:
            d = $05d7b09d19157401$var$X;
            e = $05d7b09d19157401$var$Xj;
            $05d7b09d19157401$var$X = c.stateNode.containerInfo;
            $05d7b09d19157401$var$Xj = !0;
            $05d7b09d19157401$var$Yj(a, b, c);
            $05d7b09d19157401$var$X = d;
            $05d7b09d19157401$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$05d7b09d19157401$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $05d7b09d19157401$var$Mj(c, b, g) : 0 !== (f & 4) && $05d7b09d19157401$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $05d7b09d19157401$var$Yj(a, b, c);
            break;
        case 1:
            if (!$05d7b09d19157401$var$U && ($05d7b09d19157401$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $05d7b09d19157401$var$W(c, b, h);
            }
            $05d7b09d19157401$var$Yj(a, b, c);
            break;
        case 21:
            $05d7b09d19157401$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($05d7b09d19157401$var$U = (d = $05d7b09d19157401$var$U) || null !== c.memoizedState, $05d7b09d19157401$var$Yj(a, b, c), $05d7b09d19157401$var$U = d) : $05d7b09d19157401$var$Yj(a, b, c);
            break;
        default:
            $05d7b09d19157401$var$Yj(a, b, c);
    }
}
function $05d7b09d19157401$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $05d7b09d19157401$var$Kj);
        b.forEach(function(b) {
            var d = $05d7b09d19157401$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $05d7b09d19157401$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $05d7b09d19157401$var$X = h.stateNode;
                        $05d7b09d19157401$var$Xj = !1;
                        break a;
                    case 3:
                        $05d7b09d19157401$var$X = h.stateNode.containerInfo;
                        $05d7b09d19157401$var$Xj = !0;
                        break a;
                    case 4:
                        $05d7b09d19157401$var$X = h.stateNode.containerInfo;
                        $05d7b09d19157401$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $05d7b09d19157401$var$X) throw Error($05d7b09d19157401$var$p(160));
            $05d7b09d19157401$var$Zj(f, g, e);
            $05d7b09d19157401$var$X = null;
            $05d7b09d19157401$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $05d7b09d19157401$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$05d7b09d19157401$var$dk(b, a), b = b.sibling;
}
function $05d7b09d19157401$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            if (d & 4) {
                try {
                    $05d7b09d19157401$var$Pj(3, a, a.return), $05d7b09d19157401$var$Qj(3, a);
                } catch (t) {
                    $05d7b09d19157401$var$W(a, a.return, t);
                }
                try {
                    $05d7b09d19157401$var$Pj(5, a, a.return);
                } catch (t) {
                    $05d7b09d19157401$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            d & 512 && null !== c && $05d7b09d19157401$var$Lj(c, c.return);
            break;
        case 5:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            d & 512 && null !== c && $05d7b09d19157401$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $05d7b09d19157401$var$ob(e, "");
                } catch (t) {
                    $05d7b09d19157401$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $05d7b09d19157401$var$ab(e, f);
                    $05d7b09d19157401$var$vb(h, g);
                    var l = $05d7b09d19157401$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $05d7b09d19157401$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $05d7b09d19157401$var$nb(e, q) : "children" === m ? $05d7b09d19157401$var$ob(e, q) : $05d7b09d19157401$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $05d7b09d19157401$var$bb(e, f);
                            break;
                        case "textarea":
                            $05d7b09d19157401$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $05d7b09d19157401$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $05d7b09d19157401$var$fb(e, !!f.multiple, f.defaultValue, !0) : $05d7b09d19157401$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$05d7b09d19157401$var$Pf] = f;
                } catch (t) {
                    $05d7b09d19157401$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($05d7b09d19157401$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $05d7b09d19157401$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $05d7b09d19157401$var$bd(b.containerInfo);
            } catch (t) {
                $05d7b09d19157401$var$W(a, a.return, t);
            }
            break;
        case 4:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            break;
        case 13:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($05d7b09d19157401$var$fk = $05d7b09d19157401$var$B()));
            d & 4 && $05d7b09d19157401$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($05d7b09d19157401$var$U = (l = $05d7b09d19157401$var$U) || m, $05d7b09d19157401$var$ck(b, a), $05d7b09d19157401$var$U = l) : $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($05d7b09d19157401$var$V = a, m = a.child; null !== m;){
                    for(q = $05d7b09d19157401$var$V = m; null !== $05d7b09d19157401$var$V;){
                        r = $05d7b09d19157401$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $05d7b09d19157401$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $05d7b09d19157401$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $05d7b09d19157401$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $05d7b09d19157401$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $05d7b09d19157401$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $05d7b09d19157401$var$V = y) : $05d7b09d19157401$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $05d7b09d19157401$var$rb("display", g));
                            } catch (t) {
                                $05d7b09d19157401$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $05d7b09d19157401$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $05d7b09d19157401$var$ck(b, a);
            $05d7b09d19157401$var$ek(a);
            d & 4 && $05d7b09d19157401$var$ak(a);
            break;
        case 21:
            break;
        default:
            $05d7b09d19157401$var$ck(b, a), $05d7b09d19157401$var$ek(a);
    }
}
function $05d7b09d19157401$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($05d7b09d19157401$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($05d7b09d19157401$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($05d7b09d19157401$var$ob(e, ""), d.flags &= -33);
                    var f = $05d7b09d19157401$var$Uj(a);
                    $05d7b09d19157401$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $05d7b09d19157401$var$Uj(a);
                    $05d7b09d19157401$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($05d7b09d19157401$var$p(161));
            }
        } catch (k) {
            $05d7b09d19157401$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $05d7b09d19157401$var$hk(a, b, c) {
    $05d7b09d19157401$var$V = a;
    $05d7b09d19157401$var$ik(a, b, c);
}
function $05d7b09d19157401$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $05d7b09d19157401$var$V;){
        var e = $05d7b09d19157401$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $05d7b09d19157401$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $05d7b09d19157401$var$U;
                h = $05d7b09d19157401$var$Jj;
                var l = $05d7b09d19157401$var$U;
                $05d7b09d19157401$var$Jj = g;
                if (($05d7b09d19157401$var$U = k) && !l) for($05d7b09d19157401$var$V = e; null !== $05d7b09d19157401$var$V;)g = $05d7b09d19157401$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $05d7b09d19157401$var$jk(e) : null !== k ? (k.return = g, $05d7b09d19157401$var$V = k) : $05d7b09d19157401$var$jk(e);
                for(; null !== f;)$05d7b09d19157401$var$V = f, $05d7b09d19157401$var$ik(f, b, c), f = f.sibling;
                $05d7b09d19157401$var$V = e;
                $05d7b09d19157401$var$Jj = h;
                $05d7b09d19157401$var$U = l;
            }
            $05d7b09d19157401$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $05d7b09d19157401$var$V = f) : $05d7b09d19157401$var$kk(a, b, c);
    }
}
function $05d7b09d19157401$var$kk(a) {
    for(; null !== $05d7b09d19157401$var$V;){
        var b = $05d7b09d19157401$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $05d7b09d19157401$var$U || $05d7b09d19157401$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$05d7b09d19157401$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $05d7b09d19157401$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $05d7b09d19157401$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $05d7b09d19157401$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $05d7b09d19157401$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($05d7b09d19157401$var$p(163));
                }
                $05d7b09d19157401$var$U || b.flags & 512 && $05d7b09d19157401$var$Rj(b);
            } catch (r) {
                $05d7b09d19157401$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $05d7b09d19157401$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $05d7b09d19157401$var$V = c;
            break;
        }
        $05d7b09d19157401$var$V = b.return;
    }
}
function $05d7b09d19157401$var$gk(a) {
    for(; null !== $05d7b09d19157401$var$V;){
        var b = $05d7b09d19157401$var$V;
        if (b === a) {
            $05d7b09d19157401$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $05d7b09d19157401$var$V = c;
            break;
        }
        $05d7b09d19157401$var$V = b.return;
    }
}
function $05d7b09d19157401$var$jk(a) {
    for(; null !== $05d7b09d19157401$var$V;){
        var b = $05d7b09d19157401$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $05d7b09d19157401$var$Qj(4, b);
                    } catch (k) {
                        $05d7b09d19157401$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $05d7b09d19157401$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $05d7b09d19157401$var$Rj(b);
                    } catch (k) {
                        $05d7b09d19157401$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $05d7b09d19157401$var$Rj(b);
                    } catch (k) {
                        $05d7b09d19157401$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $05d7b09d19157401$var$W(b, b.return, k);
        }
        if (b === a) {
            $05d7b09d19157401$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $05d7b09d19157401$var$V = h;
            break;
        }
        $05d7b09d19157401$var$V = b.return;
    }
}
var $05d7b09d19157401$var$lk = Math.ceil, $05d7b09d19157401$var$mk = $05d7b09d19157401$var$ua.ReactCurrentDispatcher, $05d7b09d19157401$var$nk = $05d7b09d19157401$var$ua.ReactCurrentOwner, $05d7b09d19157401$var$ok = $05d7b09d19157401$var$ua.ReactCurrentBatchConfig, $05d7b09d19157401$var$K = 0, $05d7b09d19157401$var$Q = null, $05d7b09d19157401$var$Y = null, $05d7b09d19157401$var$Z = 0, $05d7b09d19157401$var$fj = 0, $05d7b09d19157401$var$ej = $05d7b09d19157401$var$Uf(0), $05d7b09d19157401$var$T = 0, $05d7b09d19157401$var$pk = null, $05d7b09d19157401$var$rh = 0, $05d7b09d19157401$var$qk = 0, $05d7b09d19157401$var$rk = 0, $05d7b09d19157401$var$sk = null, $05d7b09d19157401$var$tk = null, $05d7b09d19157401$var$fk = 0, $05d7b09d19157401$var$Gj = Infinity, $05d7b09d19157401$var$uk = null, $05d7b09d19157401$var$Oi = !1, $05d7b09d19157401$var$Pi = null, $05d7b09d19157401$var$Ri = null, $05d7b09d19157401$var$vk = !1, $05d7b09d19157401$var$wk = null, $05d7b09d19157401$var$xk = 0, $05d7b09d19157401$var$yk = 0, $05d7b09d19157401$var$zk = null, $05d7b09d19157401$var$Ak = -1, $05d7b09d19157401$var$Bk = 0;
function $05d7b09d19157401$var$R() {
    return 0 !== ($05d7b09d19157401$var$K & 6) ? $05d7b09d19157401$var$B() : -1 !== $05d7b09d19157401$var$Ak ? $05d7b09d19157401$var$Ak : $05d7b09d19157401$var$Ak = $05d7b09d19157401$var$B();
}
function $05d7b09d19157401$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($05d7b09d19157401$var$K & 2) && 0 !== $05d7b09d19157401$var$Z) return $05d7b09d19157401$var$Z & -$05d7b09d19157401$var$Z;
    if (null !== $05d7b09d19157401$var$Kg.transition) return 0 === $05d7b09d19157401$var$Bk && ($05d7b09d19157401$var$Bk = $05d7b09d19157401$var$yc()), $05d7b09d19157401$var$Bk;
    a = $05d7b09d19157401$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $05d7b09d19157401$var$jd(a.type);
    return a;
}
function $05d7b09d19157401$var$gi(a, b, c, d) {
    if (50 < $05d7b09d19157401$var$yk) throw $05d7b09d19157401$var$yk = 0, $05d7b09d19157401$var$zk = null, Error($05d7b09d19157401$var$p(185));
    $05d7b09d19157401$var$Ac(a, c, d);
    if (0 === ($05d7b09d19157401$var$K & 2) || a !== $05d7b09d19157401$var$Q) a === $05d7b09d19157401$var$Q && (0 === ($05d7b09d19157401$var$K & 2) && ($05d7b09d19157401$var$qk |= c), 4 === $05d7b09d19157401$var$T && $05d7b09d19157401$var$Ck(a, $05d7b09d19157401$var$Z)), $05d7b09d19157401$var$Dk(a, d), 1 === c && 0 === $05d7b09d19157401$var$K && 0 === (b.mode & 1) && ($05d7b09d19157401$var$Gj = $05d7b09d19157401$var$B() + 500, $05d7b09d19157401$var$fg && $05d7b09d19157401$var$jg());
}
function $05d7b09d19157401$var$Dk(a, b) {
    var c = a.callbackNode;
    $05d7b09d19157401$var$wc(a, b);
    var d = $05d7b09d19157401$var$uc(a, a === $05d7b09d19157401$var$Q ? $05d7b09d19157401$var$Z : 0);
    if (0 === d) null !== c && $05d7b09d19157401$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $05d7b09d19157401$var$bc(c);
        if (1 === b) 0 === a.tag ? $05d7b09d19157401$var$ig($05d7b09d19157401$var$Ek.bind(null, a)) : $05d7b09d19157401$var$hg($05d7b09d19157401$var$Ek.bind(null, a)), $05d7b09d19157401$var$Jf(function() {
            0 === ($05d7b09d19157401$var$K & 6) && $05d7b09d19157401$var$jg();
        }), c = null;
        else {
            switch($05d7b09d19157401$var$Dc(d)){
                case 1:
                    c = $05d7b09d19157401$var$fc;
                    break;
                case 4:
                    c = $05d7b09d19157401$var$gc;
                    break;
                case 16:
                    c = $05d7b09d19157401$var$hc;
                    break;
                case 536870912:
                    c = $05d7b09d19157401$var$jc;
                    break;
                default:
                    c = $05d7b09d19157401$var$hc;
            }
            c = $05d7b09d19157401$var$Fk(c, $05d7b09d19157401$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $05d7b09d19157401$var$Gk(a, b) {
    $05d7b09d19157401$var$Ak = -1;
    $05d7b09d19157401$var$Bk = 0;
    if (0 !== ($05d7b09d19157401$var$K & 6)) throw Error($05d7b09d19157401$var$p(327));
    var c = a.callbackNode;
    if ($05d7b09d19157401$var$Hk() && a.callbackNode !== c) return null;
    var d = $05d7b09d19157401$var$uc(a, a === $05d7b09d19157401$var$Q ? $05d7b09d19157401$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $05d7b09d19157401$var$Ik(a, d);
    else {
        b = d;
        var e = $05d7b09d19157401$var$K;
        $05d7b09d19157401$var$K |= 2;
        var f = $05d7b09d19157401$var$Jk();
        if ($05d7b09d19157401$var$Q !== a || $05d7b09d19157401$var$Z !== b) $05d7b09d19157401$var$uk = null, $05d7b09d19157401$var$Gj = $05d7b09d19157401$var$B() + 500, $05d7b09d19157401$var$Kk(a, b);
        for(;;)try {
            $05d7b09d19157401$var$Lk();
            break;
        } catch (h) {
            $05d7b09d19157401$var$Mk(a, h);
        }
        $05d7b09d19157401$var$$g();
        $05d7b09d19157401$var$mk.current = f;
        $05d7b09d19157401$var$K = e;
        null !== $05d7b09d19157401$var$Y ? b = 0 : ($05d7b09d19157401$var$Q = null, $05d7b09d19157401$var$Z = 0, b = $05d7b09d19157401$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $05d7b09d19157401$var$xc(a), 0 !== e && (d = e, b = $05d7b09d19157401$var$Nk(a, e)));
        if (1 === b) throw c = $05d7b09d19157401$var$pk, $05d7b09d19157401$var$Kk(a, 0), $05d7b09d19157401$var$Ck(a, d), $05d7b09d19157401$var$Dk(a, $05d7b09d19157401$var$B()), c;
        if (6 === b) $05d7b09d19157401$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$05d7b09d19157401$var$Ok(e) && (b = $05d7b09d19157401$var$Ik(a, d), 2 === b && (f = $05d7b09d19157401$var$xc(a), 0 !== f && (d = f, b = $05d7b09d19157401$var$Nk(a, f))), 1 === b)) throw c = $05d7b09d19157401$var$pk, $05d7b09d19157401$var$Kk(a, 0), $05d7b09d19157401$var$Ck(a, d), $05d7b09d19157401$var$Dk(a, $05d7b09d19157401$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($05d7b09d19157401$var$p(345));
                case 2:
                    $05d7b09d19157401$var$Pk(a, $05d7b09d19157401$var$tk, $05d7b09d19157401$var$uk);
                    break;
                case 3:
                    $05d7b09d19157401$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $05d7b09d19157401$var$fk + 500 - $05d7b09d19157401$var$B(), 10 < b)) {
                        if (0 !== $05d7b09d19157401$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $05d7b09d19157401$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $05d7b09d19157401$var$Ff($05d7b09d19157401$var$Pk.bind(null, a, $05d7b09d19157401$var$tk, $05d7b09d19157401$var$uk), b);
                        break;
                    }
                    $05d7b09d19157401$var$Pk(a, $05d7b09d19157401$var$tk, $05d7b09d19157401$var$uk);
                    break;
                case 4:
                    $05d7b09d19157401$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $05d7b09d19157401$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $05d7b09d19157401$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $05d7b09d19157401$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $05d7b09d19157401$var$Ff($05d7b09d19157401$var$Pk.bind(null, a, $05d7b09d19157401$var$tk, $05d7b09d19157401$var$uk), d);
                        break;
                    }
                    $05d7b09d19157401$var$Pk(a, $05d7b09d19157401$var$tk, $05d7b09d19157401$var$uk);
                    break;
                case 5:
                    $05d7b09d19157401$var$Pk(a, $05d7b09d19157401$var$tk, $05d7b09d19157401$var$uk);
                    break;
                default:
                    throw Error($05d7b09d19157401$var$p(329));
            }
        }
    }
    $05d7b09d19157401$var$Dk(a, $05d7b09d19157401$var$B());
    return a.callbackNode === c ? $05d7b09d19157401$var$Gk.bind(null, a) : null;
}
function $05d7b09d19157401$var$Nk(a, b) {
    var c = $05d7b09d19157401$var$sk;
    a.current.memoizedState.isDehydrated && ($05d7b09d19157401$var$Kk(a, b).flags |= 256);
    a = $05d7b09d19157401$var$Ik(a, b);
    2 !== a && (b = $05d7b09d19157401$var$tk, $05d7b09d19157401$var$tk = c, null !== b && $05d7b09d19157401$var$Fj(b));
    return a;
}
function $05d7b09d19157401$var$Fj(a) {
    null === $05d7b09d19157401$var$tk ? $05d7b09d19157401$var$tk = a : $05d7b09d19157401$var$tk.push.apply($05d7b09d19157401$var$tk, a);
}
function $05d7b09d19157401$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$05d7b09d19157401$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $05d7b09d19157401$var$Ck(a, b) {
    b &= ~$05d7b09d19157401$var$rk;
    b &= ~$05d7b09d19157401$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $05d7b09d19157401$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $05d7b09d19157401$var$Ek(a) {
    if (0 !== ($05d7b09d19157401$var$K & 6)) throw Error($05d7b09d19157401$var$p(327));
    $05d7b09d19157401$var$Hk();
    var b = $05d7b09d19157401$var$uc(a, 0);
    if (0 === (b & 1)) return $05d7b09d19157401$var$Dk(a, $05d7b09d19157401$var$B()), null;
    var c = $05d7b09d19157401$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $05d7b09d19157401$var$xc(a);
        0 !== d && (b = d, c = $05d7b09d19157401$var$Nk(a, d));
    }
    if (1 === c) throw c = $05d7b09d19157401$var$pk, $05d7b09d19157401$var$Kk(a, 0), $05d7b09d19157401$var$Ck(a, b), $05d7b09d19157401$var$Dk(a, $05d7b09d19157401$var$B()), c;
    if (6 === c) throw Error($05d7b09d19157401$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $05d7b09d19157401$var$Pk(a, $05d7b09d19157401$var$tk, $05d7b09d19157401$var$uk);
    $05d7b09d19157401$var$Dk(a, $05d7b09d19157401$var$B());
    return null;
}
function $05d7b09d19157401$var$Qk(a, b) {
    var c = $05d7b09d19157401$var$K;
    $05d7b09d19157401$var$K |= 1;
    try {
        return a(b);
    } finally{
        $05d7b09d19157401$var$K = c, 0 === $05d7b09d19157401$var$K && ($05d7b09d19157401$var$Gj = $05d7b09d19157401$var$B() + 500, $05d7b09d19157401$var$fg && $05d7b09d19157401$var$jg());
    }
}
function $05d7b09d19157401$var$Rk(a) {
    null !== $05d7b09d19157401$var$wk && 0 === $05d7b09d19157401$var$wk.tag && 0 === ($05d7b09d19157401$var$K & 6) && $05d7b09d19157401$var$Hk();
    var b = $05d7b09d19157401$var$K;
    $05d7b09d19157401$var$K |= 1;
    var c = $05d7b09d19157401$var$ok.transition, d = $05d7b09d19157401$var$C;
    try {
        if ($05d7b09d19157401$var$ok.transition = null, $05d7b09d19157401$var$C = 1, a) return a();
    } finally{
        $05d7b09d19157401$var$C = d, $05d7b09d19157401$var$ok.transition = c, $05d7b09d19157401$var$K = b, 0 === ($05d7b09d19157401$var$K & 6) && $05d7b09d19157401$var$jg();
    }
}
function $05d7b09d19157401$var$Hj() {
    $05d7b09d19157401$var$fj = $05d7b09d19157401$var$ej.current;
    $05d7b09d19157401$var$E($05d7b09d19157401$var$ej);
}
function $05d7b09d19157401$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $05d7b09d19157401$var$Gf(c));
    if (null !== $05d7b09d19157401$var$Y) for(c = $05d7b09d19157401$var$Y.return; null !== c;){
        var d = c;
        $05d7b09d19157401$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $05d7b09d19157401$var$$f();
                break;
            case 3:
                $05d7b09d19157401$var$zh();
                $05d7b09d19157401$var$E($05d7b09d19157401$var$Wf);
                $05d7b09d19157401$var$E($05d7b09d19157401$var$H);
                $05d7b09d19157401$var$Eh();
                break;
            case 5:
                $05d7b09d19157401$var$Bh(d);
                break;
            case 4:
                $05d7b09d19157401$var$zh();
                break;
            case 13:
                $05d7b09d19157401$var$E($05d7b09d19157401$var$L);
                break;
            case 19:
                $05d7b09d19157401$var$E($05d7b09d19157401$var$L);
                break;
            case 10:
                $05d7b09d19157401$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $05d7b09d19157401$var$Hj();
        }
        c = c.return;
    }
    $05d7b09d19157401$var$Q = a;
    $05d7b09d19157401$var$Y = a = $05d7b09d19157401$var$Pg(a.current, null);
    $05d7b09d19157401$var$Z = $05d7b09d19157401$var$fj = b;
    $05d7b09d19157401$var$T = 0;
    $05d7b09d19157401$var$pk = null;
    $05d7b09d19157401$var$rk = $05d7b09d19157401$var$qk = $05d7b09d19157401$var$rh = 0;
    $05d7b09d19157401$var$tk = $05d7b09d19157401$var$sk = null;
    if (null !== $05d7b09d19157401$var$fh) {
        for(b = 0; b < $05d7b09d19157401$var$fh.length; b++)if (c = $05d7b09d19157401$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $05d7b09d19157401$var$fh = null;
    }
    return a;
}
function $05d7b09d19157401$var$Mk(a, b) {
    do {
        var c = $05d7b09d19157401$var$Y;
        try {
            $05d7b09d19157401$var$$g();
            $05d7b09d19157401$var$Fh.current = $05d7b09d19157401$var$Rh;
            if ($05d7b09d19157401$var$Ih) {
                for(var d = $05d7b09d19157401$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $05d7b09d19157401$var$Ih = !1;
            }
            $05d7b09d19157401$var$Hh = 0;
            $05d7b09d19157401$var$O = $05d7b09d19157401$var$N = $05d7b09d19157401$var$M = null;
            $05d7b09d19157401$var$Jh = !1;
            $05d7b09d19157401$var$Kh = 0;
            $05d7b09d19157401$var$nk.current = null;
            if (null === c || null === c.return) {
                $05d7b09d19157401$var$T = 1;
                $05d7b09d19157401$var$pk = b;
                $05d7b09d19157401$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $05d7b09d19157401$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $05d7b09d19157401$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $05d7b09d19157401$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $05d7b09d19157401$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $05d7b09d19157401$var$Si(f, l, b);
                            $05d7b09d19157401$var$tj();
                            break a;
                        }
                        k = Error($05d7b09d19157401$var$p(426));
                    }
                } else if ($05d7b09d19157401$var$I && h.mode & 1) {
                    var J = $05d7b09d19157401$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $05d7b09d19157401$var$Vi(J, g, h, f, b);
                        $05d7b09d19157401$var$Jg($05d7b09d19157401$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $05d7b09d19157401$var$Ji(k, h);
                4 !== $05d7b09d19157401$var$T && ($05d7b09d19157401$var$T = 2);
                null === $05d7b09d19157401$var$sk ? $05d7b09d19157401$var$sk = [
                    f
                ] : $05d7b09d19157401$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $05d7b09d19157401$var$Ni(f, k, b);
                            $05d7b09d19157401$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $05d7b09d19157401$var$Ri || !$05d7b09d19157401$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $05d7b09d19157401$var$Qi(f, h, b);
                                $05d7b09d19157401$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $05d7b09d19157401$var$Sk(c);
        } catch (na) {
            b = na;
            $05d7b09d19157401$var$Y === c && null !== c && ($05d7b09d19157401$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $05d7b09d19157401$var$Jk() {
    var a = $05d7b09d19157401$var$mk.current;
    $05d7b09d19157401$var$mk.current = $05d7b09d19157401$var$Rh;
    return null === a ? $05d7b09d19157401$var$Rh : a;
}
function $05d7b09d19157401$var$tj() {
    if (0 === $05d7b09d19157401$var$T || 3 === $05d7b09d19157401$var$T || 2 === $05d7b09d19157401$var$T) $05d7b09d19157401$var$T = 4;
    null === $05d7b09d19157401$var$Q || 0 === ($05d7b09d19157401$var$rh & 268435455) && 0 === ($05d7b09d19157401$var$qk & 268435455) || $05d7b09d19157401$var$Ck($05d7b09d19157401$var$Q, $05d7b09d19157401$var$Z);
}
function $05d7b09d19157401$var$Ik(a, b) {
    var c = $05d7b09d19157401$var$K;
    $05d7b09d19157401$var$K |= 2;
    var d = $05d7b09d19157401$var$Jk();
    if ($05d7b09d19157401$var$Q !== a || $05d7b09d19157401$var$Z !== b) $05d7b09d19157401$var$uk = null, $05d7b09d19157401$var$Kk(a, b);
    for(;;)try {
        $05d7b09d19157401$var$Tk();
        break;
    } catch (e) {
        $05d7b09d19157401$var$Mk(a, e);
    }
    $05d7b09d19157401$var$$g();
    $05d7b09d19157401$var$K = c;
    $05d7b09d19157401$var$mk.current = d;
    if (null !== $05d7b09d19157401$var$Y) throw Error($05d7b09d19157401$var$p(261));
    $05d7b09d19157401$var$Q = null;
    $05d7b09d19157401$var$Z = 0;
    return $05d7b09d19157401$var$T;
}
function $05d7b09d19157401$var$Tk() {
    for(; null !== $05d7b09d19157401$var$Y;)$05d7b09d19157401$var$Uk($05d7b09d19157401$var$Y);
}
function $05d7b09d19157401$var$Lk() {
    for(; null !== $05d7b09d19157401$var$Y && !$05d7b09d19157401$var$cc();)$05d7b09d19157401$var$Uk($05d7b09d19157401$var$Y);
}
function $05d7b09d19157401$var$Uk(a) {
    var b = $05d7b09d19157401$var$Vk(a.alternate, a, $05d7b09d19157401$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $05d7b09d19157401$var$Sk(a) : $05d7b09d19157401$var$Y = b;
    $05d7b09d19157401$var$nk.current = null;
}
function $05d7b09d19157401$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $05d7b09d19157401$var$Ej(c, b, $05d7b09d19157401$var$fj), null !== c) {
                $05d7b09d19157401$var$Y = c;
                return;
            }
        } else {
            c = $05d7b09d19157401$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $05d7b09d19157401$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $05d7b09d19157401$var$T = 6;
                $05d7b09d19157401$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $05d7b09d19157401$var$Y = b;
            return;
        }
        $05d7b09d19157401$var$Y = b = a;
    }while (null !== b);
    0 === $05d7b09d19157401$var$T && ($05d7b09d19157401$var$T = 5);
}
function $05d7b09d19157401$var$Pk(a, b, c) {
    var d = $05d7b09d19157401$var$C, e = $05d7b09d19157401$var$ok.transition;
    try {
        $05d7b09d19157401$var$ok.transition = null, $05d7b09d19157401$var$C = 1, $05d7b09d19157401$var$Wk(a, b, c, d);
    } finally{
        $05d7b09d19157401$var$ok.transition = e, $05d7b09d19157401$var$C = d;
    }
    return null;
}
function $05d7b09d19157401$var$Wk(a, b, c, d) {
    do $05d7b09d19157401$var$Hk();
    while (null !== $05d7b09d19157401$var$wk);
    if (0 !== ($05d7b09d19157401$var$K & 6)) throw Error($05d7b09d19157401$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($05d7b09d19157401$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $05d7b09d19157401$var$Bc(a, f);
    a === $05d7b09d19157401$var$Q && ($05d7b09d19157401$var$Y = $05d7b09d19157401$var$Q = null, $05d7b09d19157401$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $05d7b09d19157401$var$vk || ($05d7b09d19157401$var$vk = !0, $05d7b09d19157401$var$Fk($05d7b09d19157401$var$hc, function() {
        $05d7b09d19157401$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $05d7b09d19157401$var$ok.transition;
        $05d7b09d19157401$var$ok.transition = null;
        var g = $05d7b09d19157401$var$C;
        $05d7b09d19157401$var$C = 1;
        var h = $05d7b09d19157401$var$K;
        $05d7b09d19157401$var$K |= 4;
        $05d7b09d19157401$var$nk.current = null;
        $05d7b09d19157401$var$Oj(a, c);
        $05d7b09d19157401$var$dk(c, a);
        $05d7b09d19157401$var$Oe($05d7b09d19157401$var$Df);
        $05d7b09d19157401$var$dd = !!$05d7b09d19157401$var$Cf;
        $05d7b09d19157401$var$Df = $05d7b09d19157401$var$Cf = null;
        a.current = c;
        $05d7b09d19157401$var$hk(c, a, e);
        $05d7b09d19157401$var$dc();
        $05d7b09d19157401$var$K = h;
        $05d7b09d19157401$var$C = g;
        $05d7b09d19157401$var$ok.transition = f;
    } else a.current = c;
    $05d7b09d19157401$var$vk && ($05d7b09d19157401$var$vk = !1, $05d7b09d19157401$var$wk = a, $05d7b09d19157401$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($05d7b09d19157401$var$Ri = null);
    $05d7b09d19157401$var$mc(c.stateNode, d);
    $05d7b09d19157401$var$Dk(a, $05d7b09d19157401$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($05d7b09d19157401$var$Oi) throw $05d7b09d19157401$var$Oi = !1, a = $05d7b09d19157401$var$Pi, $05d7b09d19157401$var$Pi = null, a;
    0 !== ($05d7b09d19157401$var$xk & 1) && 0 !== a.tag && $05d7b09d19157401$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $05d7b09d19157401$var$zk ? $05d7b09d19157401$var$yk++ : ($05d7b09d19157401$var$yk = 0, $05d7b09d19157401$var$zk = a) : $05d7b09d19157401$var$yk = 0;
    $05d7b09d19157401$var$jg();
    return null;
}
function $05d7b09d19157401$var$Hk() {
    if (null !== $05d7b09d19157401$var$wk) {
        var a = $05d7b09d19157401$var$Dc($05d7b09d19157401$var$xk), b = $05d7b09d19157401$var$ok.transition, c = $05d7b09d19157401$var$C;
        try {
            $05d7b09d19157401$var$ok.transition = null;
            $05d7b09d19157401$var$C = 16 > a ? 16 : a;
            if (null === $05d7b09d19157401$var$wk) var d = !1;
            else {
                a = $05d7b09d19157401$var$wk;
                $05d7b09d19157401$var$wk = null;
                $05d7b09d19157401$var$xk = 0;
                if (0 !== ($05d7b09d19157401$var$K & 6)) throw Error($05d7b09d19157401$var$p(331));
                var e = $05d7b09d19157401$var$K;
                $05d7b09d19157401$var$K |= 4;
                for($05d7b09d19157401$var$V = a.current; null !== $05d7b09d19157401$var$V;){
                    var f = $05d7b09d19157401$var$V, g = f.child;
                    if (0 !== ($05d7b09d19157401$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($05d7b09d19157401$var$V = l; null !== $05d7b09d19157401$var$V;){
                                    var m = $05d7b09d19157401$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $05d7b09d19157401$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $05d7b09d19157401$var$V = q;
                                    else for(; null !== $05d7b09d19157401$var$V;){
                                        m = $05d7b09d19157401$var$V;
                                        var r = m.sibling, y = m.return;
                                        $05d7b09d19157401$var$Sj(m);
                                        if (m === l) {
                                            $05d7b09d19157401$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $05d7b09d19157401$var$V = r;
                                            break;
                                        }
                                        $05d7b09d19157401$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $05d7b09d19157401$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $05d7b09d19157401$var$V = g;
                    else b: for(; null !== $05d7b09d19157401$var$V;){
                        f = $05d7b09d19157401$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $05d7b09d19157401$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $05d7b09d19157401$var$V = x;
                            break b;
                        }
                        $05d7b09d19157401$var$V = f.return;
                    }
                }
                var w = a.current;
                for($05d7b09d19157401$var$V = w; null !== $05d7b09d19157401$var$V;){
                    g = $05d7b09d19157401$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $05d7b09d19157401$var$V = u;
                    else b: for(g = w; null !== $05d7b09d19157401$var$V;){
                        h = $05d7b09d19157401$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $05d7b09d19157401$var$Qj(9, h);
                            }
                        } catch (na) {
                            $05d7b09d19157401$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $05d7b09d19157401$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $05d7b09d19157401$var$V = F;
                            break b;
                        }
                        $05d7b09d19157401$var$V = h.return;
                    }
                }
                $05d7b09d19157401$var$K = e;
                $05d7b09d19157401$var$jg();
                if ($05d7b09d19157401$var$lc && "function" === typeof $05d7b09d19157401$var$lc.onPostCommitFiberRoot) try {
                    $05d7b09d19157401$var$lc.onPostCommitFiberRoot($05d7b09d19157401$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $05d7b09d19157401$var$C = c, $05d7b09d19157401$var$ok.transition = b;
        }
    }
    return !1;
}
function $05d7b09d19157401$var$Xk(a, b, c) {
    b = $05d7b09d19157401$var$Ji(c, b);
    b = $05d7b09d19157401$var$Ni(a, b, 1);
    a = $05d7b09d19157401$var$nh(a, b, 1);
    b = $05d7b09d19157401$var$R();
    null !== a && ($05d7b09d19157401$var$Ac(a, 1, b), $05d7b09d19157401$var$Dk(a, b));
}
function $05d7b09d19157401$var$W(a, b, c) {
    if (3 === a.tag) $05d7b09d19157401$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $05d7b09d19157401$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $05d7b09d19157401$var$Ri || !$05d7b09d19157401$var$Ri.has(d))) {
                a = $05d7b09d19157401$var$Ji(c, a);
                a = $05d7b09d19157401$var$Qi(b, a, 1);
                b = $05d7b09d19157401$var$nh(b, a, 1);
                a = $05d7b09d19157401$var$R();
                null !== b && ($05d7b09d19157401$var$Ac(b, 1, a), $05d7b09d19157401$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $05d7b09d19157401$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $05d7b09d19157401$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $05d7b09d19157401$var$Q === a && ($05d7b09d19157401$var$Z & c) === c && (4 === $05d7b09d19157401$var$T || 3 === $05d7b09d19157401$var$T && ($05d7b09d19157401$var$Z & 130023424) === $05d7b09d19157401$var$Z && 500 > $05d7b09d19157401$var$B() - $05d7b09d19157401$var$fk ? $05d7b09d19157401$var$Kk(a, 0) : $05d7b09d19157401$var$rk |= c);
    $05d7b09d19157401$var$Dk(a, b);
}
function $05d7b09d19157401$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $05d7b09d19157401$var$sc, $05d7b09d19157401$var$sc <<= 1, 0 === ($05d7b09d19157401$var$sc & 130023424) && ($05d7b09d19157401$var$sc = 4194304)));
    var c = $05d7b09d19157401$var$R();
    a = $05d7b09d19157401$var$ih(a, b);
    null !== a && ($05d7b09d19157401$var$Ac(a, b, c), $05d7b09d19157401$var$Dk(a, c));
}
function $05d7b09d19157401$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $05d7b09d19157401$var$Yk(a, c);
}
function $05d7b09d19157401$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($05d7b09d19157401$var$p(314));
    }
    null !== d && d.delete(b);
    $05d7b09d19157401$var$Yk(a, c);
}
var $05d7b09d19157401$var$Vk;
$05d7b09d19157401$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $05d7b09d19157401$var$Wf.current) $05d7b09d19157401$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $05d7b09d19157401$var$dh = !1, $05d7b09d19157401$var$yj(a, b, c);
            $05d7b09d19157401$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $05d7b09d19157401$var$dh = !1, $05d7b09d19157401$var$I && 0 !== (b.flags & 1048576) && $05d7b09d19157401$var$ug(b, $05d7b09d19157401$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $05d7b09d19157401$var$ij(a, b);
            a = b.pendingProps;
            var e = $05d7b09d19157401$var$Yf(b, $05d7b09d19157401$var$H.current);
            $05d7b09d19157401$var$ch(b, c);
            e = $05d7b09d19157401$var$Nh(null, b, d, a, e, c);
            var f = $05d7b09d19157401$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $05d7b09d19157401$var$Zf(d) ? (f = !0, $05d7b09d19157401$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $05d7b09d19157401$var$kh(b), e.updater = $05d7b09d19157401$var$Ei, b.stateNode = e, e._reactInternals = b, $05d7b09d19157401$var$Ii(b, d, a, c), b = $05d7b09d19157401$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $05d7b09d19157401$var$I && f && $05d7b09d19157401$var$vg(b), $05d7b09d19157401$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $05d7b09d19157401$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $05d7b09d19157401$var$Zk(d);
                a = $05d7b09d19157401$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $05d7b09d19157401$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $05d7b09d19157401$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $05d7b09d19157401$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $05d7b09d19157401$var$$i(null, b, d, $05d7b09d19157401$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($05d7b09d19157401$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $05d7b09d19157401$var$Ci(d, e), $05d7b09d19157401$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $05d7b09d19157401$var$Ci(d, e), $05d7b09d19157401$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $05d7b09d19157401$var$kj(b);
                if (null === a) throw Error($05d7b09d19157401$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $05d7b09d19157401$var$lh(a, b);
                $05d7b09d19157401$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $05d7b09d19157401$var$Ji(Error($05d7b09d19157401$var$p(423)), b);
                        b = $05d7b09d19157401$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $05d7b09d19157401$var$Ji(Error($05d7b09d19157401$var$p(424)), b);
                        b = $05d7b09d19157401$var$lj(a, b, d, c, e);
                        break a;
                    } else for($05d7b09d19157401$var$yg = $05d7b09d19157401$var$Lf(b.stateNode.containerInfo.firstChild), $05d7b09d19157401$var$xg = b, $05d7b09d19157401$var$I = !0, $05d7b09d19157401$var$zg = null, c = $05d7b09d19157401$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $05d7b09d19157401$var$Ig();
                    if (d === e) {
                        b = $05d7b09d19157401$var$Zi(a, b, c);
                        break a;
                    }
                    $05d7b09d19157401$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $05d7b09d19157401$var$Ah(b), null === a && $05d7b09d19157401$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $05d7b09d19157401$var$Ef(d, e) ? g = null : null !== f && $05d7b09d19157401$var$Ef(d, f) && (b.flags |= 32), $05d7b09d19157401$var$gj(a, b), $05d7b09d19157401$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $05d7b09d19157401$var$Eg(b), null;
        case 13:
            return $05d7b09d19157401$var$oj(a, b, c);
        case 4:
            return $05d7b09d19157401$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $05d7b09d19157401$var$Ug(b, null, d, c) : $05d7b09d19157401$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $05d7b09d19157401$var$Ci(d, e), $05d7b09d19157401$var$Yi(a, b, d, e, c);
        case 7:
            return $05d7b09d19157401$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $05d7b09d19157401$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $05d7b09d19157401$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $05d7b09d19157401$var$G($05d7b09d19157401$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($05d7b09d19157401$var$He(f.value, g)) {
                        if (f.children === e.children && !$05d7b09d19157401$var$Wf.current) {
                            b = $05d7b09d19157401$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $05d7b09d19157401$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $05d7b09d19157401$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($05d7b09d19157401$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $05d7b09d19157401$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $05d7b09d19157401$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $05d7b09d19157401$var$ch(b, c), e = $05d7b09d19157401$var$eh(e), d = d(e), b.flags |= 1, $05d7b09d19157401$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $05d7b09d19157401$var$Ci(d, b.pendingProps), e = $05d7b09d19157401$var$Ci(d.type, e), $05d7b09d19157401$var$$i(a, b, d, e, c);
        case 15:
            return $05d7b09d19157401$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $05d7b09d19157401$var$Ci(d, e), $05d7b09d19157401$var$ij(a, b), b.tag = 1, $05d7b09d19157401$var$Zf(d) ? (a = !0, $05d7b09d19157401$var$cg(b)) : a = !1, $05d7b09d19157401$var$ch(b, c), $05d7b09d19157401$var$Gi(b, d, e), $05d7b09d19157401$var$Ii(b, d, e, c), $05d7b09d19157401$var$jj(null, b, d, !0, a, c);
        case 19:
            return $05d7b09d19157401$var$xj(a, b, c);
        case 22:
            return $05d7b09d19157401$var$dj(a, b, c);
    }
    throw Error($05d7b09d19157401$var$p(156, b.tag));
};
function $05d7b09d19157401$var$Fk(a, b) {
    return $05d7b09d19157401$var$ac(a, b);
}
function $05d7b09d19157401$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $05d7b09d19157401$var$Bg(a, b, c, d) {
    return new $05d7b09d19157401$var$$k(a, b, c, d);
}
function $05d7b09d19157401$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $05d7b09d19157401$var$Zk(a) {
    if ("function" === typeof a) return $05d7b09d19157401$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $05d7b09d19157401$var$Da) return 11;
        if (a === $05d7b09d19157401$var$Ga) return 14;
    }
    return 2;
}
function $05d7b09d19157401$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $05d7b09d19157401$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $05d7b09d19157401$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $05d7b09d19157401$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $05d7b09d19157401$var$ya:
            return $05d7b09d19157401$var$Tg(c.children, e, f, b);
        case $05d7b09d19157401$var$za:
            g = 8;
            e |= 8;
            break;
        case $05d7b09d19157401$var$Aa:
            return a = $05d7b09d19157401$var$Bg(12, c, b, e | 2), a.elementType = $05d7b09d19157401$var$Aa, a.lanes = f, a;
        case $05d7b09d19157401$var$Ea:
            return a = $05d7b09d19157401$var$Bg(13, c, b, e), a.elementType = $05d7b09d19157401$var$Ea, a.lanes = f, a;
        case $05d7b09d19157401$var$Fa:
            return a = $05d7b09d19157401$var$Bg(19, c, b, e), a.elementType = $05d7b09d19157401$var$Fa, a.lanes = f, a;
        case $05d7b09d19157401$var$Ia:
            return $05d7b09d19157401$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $05d7b09d19157401$var$Ba:
                    g = 10;
                    break a;
                case $05d7b09d19157401$var$Ca:
                    g = 9;
                    break a;
                case $05d7b09d19157401$var$Da:
                    g = 11;
                    break a;
                case $05d7b09d19157401$var$Ga:
                    g = 14;
                    break a;
                case $05d7b09d19157401$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($05d7b09d19157401$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $05d7b09d19157401$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $05d7b09d19157401$var$Tg(a, b, c, d) {
    a = $05d7b09d19157401$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $05d7b09d19157401$var$pj(a, b, c, d) {
    a = $05d7b09d19157401$var$Bg(22, a, d, b);
    a.elementType = $05d7b09d19157401$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $05d7b09d19157401$var$Qg(a, b, c) {
    a = $05d7b09d19157401$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $05d7b09d19157401$var$Sg(a, b, c) {
    b = $05d7b09d19157401$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $05d7b09d19157401$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $05d7b09d19157401$var$zc(0);
    this.expirationTimes = $05d7b09d19157401$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $05d7b09d19157401$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $05d7b09d19157401$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $05d7b09d19157401$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $05d7b09d19157401$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $05d7b09d19157401$var$kh(f);
    return a;
}
function $05d7b09d19157401$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $05d7b09d19157401$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $05d7b09d19157401$var$dl(a) {
    if (!a) return $05d7b09d19157401$var$Vf;
    a = a._reactInternals;
    a: {
        if ($05d7b09d19157401$var$Vb(a) !== a || 1 !== a.tag) throw Error($05d7b09d19157401$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($05d7b09d19157401$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($05d7b09d19157401$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($05d7b09d19157401$var$Zf(c)) return $05d7b09d19157401$var$bg(a, c, b);
    }
    return b;
}
function $05d7b09d19157401$var$el(a, b, c, d, e, f, g, h, k) {
    a = $05d7b09d19157401$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $05d7b09d19157401$var$dl(null);
    c = a.current;
    d = $05d7b09d19157401$var$R();
    e = $05d7b09d19157401$var$yi(c);
    f = $05d7b09d19157401$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $05d7b09d19157401$var$nh(c, f, e);
    a.current.lanes = e;
    $05d7b09d19157401$var$Ac(a, e, d);
    $05d7b09d19157401$var$Dk(a, d);
    return a;
}
function $05d7b09d19157401$var$fl(a, b, c, d) {
    var e = b.current, f = $05d7b09d19157401$var$R(), g = $05d7b09d19157401$var$yi(e);
    c = $05d7b09d19157401$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $05d7b09d19157401$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $05d7b09d19157401$var$nh(e, b, g);
    null !== a && ($05d7b09d19157401$var$gi(a, e, g, f), $05d7b09d19157401$var$oh(a, e, g));
    return g;
}
function $05d7b09d19157401$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $05d7b09d19157401$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $05d7b09d19157401$var$il(a, b) {
    $05d7b09d19157401$var$hl(a, b);
    (a = a.alternate) && $05d7b09d19157401$var$hl(a, b);
}
function $05d7b09d19157401$var$jl() {
    return null;
}
var $05d7b09d19157401$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $05d7b09d19157401$var$ll(a) {
    this._internalRoot = a;
}
$05d7b09d19157401$var$ml.prototype.render = $05d7b09d19157401$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($05d7b09d19157401$var$p(409));
    $05d7b09d19157401$var$fl(a, b, null, null);
};
$05d7b09d19157401$var$ml.prototype.unmount = $05d7b09d19157401$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $05d7b09d19157401$var$Rk(function() {
            $05d7b09d19157401$var$fl(null, a, null, null);
        });
        b[$05d7b09d19157401$var$uf] = null;
    }
};
function $05d7b09d19157401$var$ml(a) {
    this._internalRoot = a;
}
$05d7b09d19157401$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $05d7b09d19157401$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $05d7b09d19157401$var$Qc.length && 0 !== b && b < $05d7b09d19157401$var$Qc[c].priority; c++);
        $05d7b09d19157401$var$Qc.splice(c, 0, a);
        0 === c && $05d7b09d19157401$var$Vc(a);
    }
};
function $05d7b09d19157401$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $05d7b09d19157401$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $05d7b09d19157401$var$pl() {}
function $05d7b09d19157401$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $05d7b09d19157401$var$gl(g);
                f.call(a);
            };
        }
        var g = $05d7b09d19157401$var$el(b, d, a, 0, null, !1, !1, "", $05d7b09d19157401$var$pl);
        a._reactRootContainer = g;
        a[$05d7b09d19157401$var$uf] = g.current;
        $05d7b09d19157401$var$sf(8 === a.nodeType ? a.parentNode : a);
        $05d7b09d19157401$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $05d7b09d19157401$var$gl(k);
            h.call(a);
        };
    }
    var k = $05d7b09d19157401$var$bl(a, 0, !1, null, null, !1, !1, "", $05d7b09d19157401$var$pl);
    a._reactRootContainer = k;
    a[$05d7b09d19157401$var$uf] = k.current;
    $05d7b09d19157401$var$sf(8 === a.nodeType ? a.parentNode : a);
    $05d7b09d19157401$var$Rk(function() {
        $05d7b09d19157401$var$fl(b, k, c, d);
    });
    return k;
}
function $05d7b09d19157401$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $05d7b09d19157401$var$gl(g);
                h.call(a);
            };
        }
        $05d7b09d19157401$var$fl(b, g, a, e);
    } else g = $05d7b09d19157401$var$ql(c, b, a, e, d);
    return $05d7b09d19157401$var$gl(g);
}
$05d7b09d19157401$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $05d7b09d19157401$var$tc(b.pendingLanes);
                0 !== c && ($05d7b09d19157401$var$Cc(b, c | 1), $05d7b09d19157401$var$Dk(b, $05d7b09d19157401$var$B()), 0 === ($05d7b09d19157401$var$K & 6) && ($05d7b09d19157401$var$Gj = $05d7b09d19157401$var$B() + 500, $05d7b09d19157401$var$jg()));
            }
            break;
        case 13:
            $05d7b09d19157401$var$Rk(function() {
                var b = $05d7b09d19157401$var$ih(a, 1);
                if (null !== b) {
                    var c = $05d7b09d19157401$var$R();
                    $05d7b09d19157401$var$gi(b, a, 1, c);
                }
            }), $05d7b09d19157401$var$il(a, 1);
    }
};
$05d7b09d19157401$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $05d7b09d19157401$var$ih(a, 134217728);
        if (null !== b) {
            var c = $05d7b09d19157401$var$R();
            $05d7b09d19157401$var$gi(b, a, 134217728, c);
        }
        $05d7b09d19157401$var$il(a, 134217728);
    }
};
$05d7b09d19157401$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $05d7b09d19157401$var$yi(a), c = $05d7b09d19157401$var$ih(a, b);
        if (null !== c) {
            var d = $05d7b09d19157401$var$R();
            $05d7b09d19157401$var$gi(c, a, b, d);
        }
        $05d7b09d19157401$var$il(a, b);
    }
};
$05d7b09d19157401$var$Hc = function() {
    return $05d7b09d19157401$var$C;
};
$05d7b09d19157401$var$Ic = function(a, b) {
    var c = $05d7b09d19157401$var$C;
    try {
        return $05d7b09d19157401$var$C = a, b();
    } finally{
        $05d7b09d19157401$var$C = c;
    }
};
$05d7b09d19157401$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $05d7b09d19157401$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $05d7b09d19157401$var$Db(d);
                        if (!e) throw Error($05d7b09d19157401$var$p(90));
                        $05d7b09d19157401$var$Wa(d);
                        $05d7b09d19157401$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $05d7b09d19157401$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $05d7b09d19157401$var$fb(a, !!c.multiple, b, !1);
    }
};
$05d7b09d19157401$var$Gb = $05d7b09d19157401$var$Qk;
$05d7b09d19157401$var$Hb = $05d7b09d19157401$var$Rk;
var $05d7b09d19157401$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $05d7b09d19157401$var$Cb,
        $05d7b09d19157401$var$ue,
        $05d7b09d19157401$var$Db,
        $05d7b09d19157401$var$Eb,
        $05d7b09d19157401$var$Fb,
        $05d7b09d19157401$var$Qk
    ]
}, $05d7b09d19157401$var$tl = {
    findFiberByHostInstance: $05d7b09d19157401$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $05d7b09d19157401$var$ul = {
    bundleType: $05d7b09d19157401$var$tl.bundleType,
    version: $05d7b09d19157401$var$tl.version,
    rendererPackageName: $05d7b09d19157401$var$tl.rendererPackageName,
    rendererConfig: $05d7b09d19157401$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $05d7b09d19157401$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $05d7b09d19157401$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $05d7b09d19157401$var$tl.findFiberByHostInstance || $05d7b09d19157401$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $05d7b09d19157401$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$05d7b09d19157401$var$vl.isDisabled && $05d7b09d19157401$var$vl.supportsFiber) try {
        $05d7b09d19157401$var$kc = $05d7b09d19157401$var$vl.inject($05d7b09d19157401$var$ul), $05d7b09d19157401$var$lc = $05d7b09d19157401$var$vl;
    } catch (a) {}
}
$05d7b09d19157401$export$ae55be85d98224ed = $05d7b09d19157401$var$sl;
$05d7b09d19157401$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$05d7b09d19157401$var$nl(b)) throw Error($05d7b09d19157401$var$p(200));
    return $05d7b09d19157401$var$cl(a, b, null, c);
};
$05d7b09d19157401$export$882461b6382ed46c = function(a, b) {
    if (!$05d7b09d19157401$var$nl(a)) throw Error($05d7b09d19157401$var$p(299));
    var c = !1, d = "", e = $05d7b09d19157401$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $05d7b09d19157401$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$05d7b09d19157401$var$uf] = b.current;
    $05d7b09d19157401$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $05d7b09d19157401$var$ll(b);
};
$05d7b09d19157401$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($05d7b09d19157401$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($05d7b09d19157401$var$p(268, a));
    }
    a = $05d7b09d19157401$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$05d7b09d19157401$export$cd75ccfd720a3cd4 = function(a) {
    return $05d7b09d19157401$var$Rk(a);
};
$05d7b09d19157401$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$05d7b09d19157401$var$ol(b)) throw Error($05d7b09d19157401$var$p(200));
    return $05d7b09d19157401$var$rl(null, a, b, !0, c);
};
$05d7b09d19157401$export$757ceba2d55c277e = function(a, b, c) {
    if (!$05d7b09d19157401$var$nl(a)) throw Error($05d7b09d19157401$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $05d7b09d19157401$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $05d7b09d19157401$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$05d7b09d19157401$var$uf] = b.current;
    $05d7b09d19157401$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $05d7b09d19157401$var$ml(b);
};
$05d7b09d19157401$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$05d7b09d19157401$var$ol(b)) throw Error($05d7b09d19157401$var$p(200));
    return $05d7b09d19157401$var$rl(null, a, b, !1, c);
};
$05d7b09d19157401$export$502457920280e6be = function(a) {
    if (!$05d7b09d19157401$var$ol(a)) throw Error($05d7b09d19157401$var$p(40));
    return a._reactRootContainer ? ($05d7b09d19157401$var$Rk(function() {
        $05d7b09d19157401$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$05d7b09d19157401$var$uf] = null;
        });
    }), !0) : !1;
};
$05d7b09d19157401$export$c78a37762a8d58e1 = $05d7b09d19157401$var$Qk;
$05d7b09d19157401$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$05d7b09d19157401$var$ol(c)) throw Error($05d7b09d19157401$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($05d7b09d19157401$var$p(38));
    return $05d7b09d19157401$var$rl(a, b, c, !1, d);
};
$05d7b09d19157401$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fwoBu", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5ajTb"));

});
parcelRegister("5ajTb", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3c2d507e3bfa4033$export$c4744153514ff05d, (v) => $3c2d507e3bfa4033$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3c2d507e3bfa4033$export$3e506c1ccc9cc1a7, (v) => $3c2d507e3bfa4033$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3c2d507e3bfa4033$export$e26fe2ed2fa76875, (v) => $3c2d507e3bfa4033$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3c2d507e3bfa4033$export$502329bbf4b505b1, (v) => $3c2d507e3bfa4033$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3c2d507e3bfa4033$export$6e3807111c4874c4, (v) => $3c2d507e3bfa4033$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3c2d507e3bfa4033$export$c27134553091fb3a, (v) => $3c2d507e3bfa4033$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3c2d507e3bfa4033$export$33ee1acdc04fd2a2, (v) => $3c2d507e3bfa4033$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3c2d507e3bfa4033$export$b00a404bbd5edef2, (v) => $3c2d507e3bfa4033$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3c2d507e3bfa4033$export$8352ce38b91d0c62, (v) => $3c2d507e3bfa4033$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3c2d507e3bfa4033$export$d66a1c1c77bd778b, (v) => $3c2d507e3bfa4033$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3c2d507e3bfa4033$export$d3dfb8e4810cb555, (v) => $3c2d507e3bfa4033$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3c2d507e3bfa4033$export$839f9183b0465a69, (v) => $3c2d507e3bfa4033$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3c2d507e3bfa4033$export$72fdf0e06517287b, (v) => $3c2d507e3bfa4033$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3c2d507e3bfa4033$export$4b844e58a3e414b4, (v) => $3c2d507e3bfa4033$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3c2d507e3bfa4033$export$816d2913ae6b83b1, (v) => $3c2d507e3bfa4033$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3c2d507e3bfa4033$export$61bcfe829111a1d0, (v) => $3c2d507e3bfa4033$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3c2d507e3bfa4033$export$7ee8c9beb337bc3f, (v) => $3c2d507e3bfa4033$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3c2d507e3bfa4033$export$b5836b71941fa3ed, (v) => $3c2d507e3bfa4033$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3c2d507e3bfa4033$export$cf845f2c119da08a, (v) => $3c2d507e3bfa4033$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c2d507e3bfa4033$export$c4744153514ff05d;
var $3c2d507e3bfa4033$export$3e506c1ccc9cc1a7;
var $3c2d507e3bfa4033$export$e26fe2ed2fa76875;
var $3c2d507e3bfa4033$export$502329bbf4b505b1;
var $3c2d507e3bfa4033$export$6e3807111c4874c4;
var $3c2d507e3bfa4033$export$c27134553091fb3a;
var $3c2d507e3bfa4033$export$33ee1acdc04fd2a2;
var $3c2d507e3bfa4033$export$b00a404bbd5edef2;
var $3c2d507e3bfa4033$export$8352ce38b91d0c62;
var $3c2d507e3bfa4033$export$d66a1c1c77bd778b;
var $3c2d507e3bfa4033$export$d3dfb8e4810cb555;
var $3c2d507e3bfa4033$export$839f9183b0465a69;
var $3c2d507e3bfa4033$export$72fdf0e06517287b;
var $3c2d507e3bfa4033$export$4b844e58a3e414b4;
var $3c2d507e3bfa4033$export$816d2913ae6b83b1;
var $3c2d507e3bfa4033$export$61bcfe829111a1d0;
var $3c2d507e3bfa4033$export$7ee8c9beb337bc3f;
var $3c2d507e3bfa4033$export$b5836b71941fa3ed;
var $3c2d507e3bfa4033$export$cf845f2c119da08a;
"use strict";
function $3c2d507e3bfa4033$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3c2d507e3bfa4033$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3c2d507e3bfa4033$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3c2d507e3bfa4033$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3c2d507e3bfa4033$var$g(C, c)) n < e && 0 > $3c2d507e3bfa4033$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3c2d507e3bfa4033$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3c2d507e3bfa4033$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3c2d507e3bfa4033$var$l = performance;
    $3c2d507e3bfa4033$export$c4744153514ff05d = function() {
        return $3c2d507e3bfa4033$var$l.now();
    };
} else {
    var $3c2d507e3bfa4033$var$p = Date, $3c2d507e3bfa4033$var$q = $3c2d507e3bfa4033$var$p.now();
    $3c2d507e3bfa4033$export$c4744153514ff05d = function() {
        return $3c2d507e3bfa4033$var$p.now() - $3c2d507e3bfa4033$var$q;
    };
}
var $3c2d507e3bfa4033$var$r = [], $3c2d507e3bfa4033$var$t = [], $3c2d507e3bfa4033$var$u = 1, $3c2d507e3bfa4033$var$v = null, $3c2d507e3bfa4033$var$y = 3, $3c2d507e3bfa4033$var$z = !1, $3c2d507e3bfa4033$var$A = !1, $3c2d507e3bfa4033$var$B = !1, $3c2d507e3bfa4033$var$D = "function" === typeof setTimeout ? setTimeout : null, $3c2d507e3bfa4033$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3c2d507e3bfa4033$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3c2d507e3bfa4033$var$G(a) {
    for(var b = $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$t); null !== b;){
        if (null === b.callback) $3c2d507e3bfa4033$var$k($3c2d507e3bfa4033$var$t);
        else if (b.startTime <= a) $3c2d507e3bfa4033$var$k($3c2d507e3bfa4033$var$t), b.sortIndex = b.expirationTime, $3c2d507e3bfa4033$var$f($3c2d507e3bfa4033$var$r, b);
        else break;
        b = $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$t);
    }
}
function $3c2d507e3bfa4033$var$H(a) {
    $3c2d507e3bfa4033$var$B = !1;
    $3c2d507e3bfa4033$var$G(a);
    if (!$3c2d507e3bfa4033$var$A) {
        if (null !== $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$r)) $3c2d507e3bfa4033$var$A = !0, $3c2d507e3bfa4033$var$I($3c2d507e3bfa4033$var$J);
        else {
            var b = $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$t);
            null !== b && $3c2d507e3bfa4033$var$K($3c2d507e3bfa4033$var$H, b.startTime - a);
        }
    }
}
function $3c2d507e3bfa4033$var$J(a, b) {
    $3c2d507e3bfa4033$var$A = !1;
    $3c2d507e3bfa4033$var$B && ($3c2d507e3bfa4033$var$B = !1, $3c2d507e3bfa4033$var$E($3c2d507e3bfa4033$var$L), $3c2d507e3bfa4033$var$L = -1);
    $3c2d507e3bfa4033$var$z = !0;
    var c = $3c2d507e3bfa4033$var$y;
    try {
        $3c2d507e3bfa4033$var$G(b);
        for($3c2d507e3bfa4033$var$v = $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$r); null !== $3c2d507e3bfa4033$var$v && (!($3c2d507e3bfa4033$var$v.expirationTime > b) || a && !$3c2d507e3bfa4033$var$M());){
            var d = $3c2d507e3bfa4033$var$v.callback;
            if ("function" === typeof d) {
                $3c2d507e3bfa4033$var$v.callback = null;
                $3c2d507e3bfa4033$var$y = $3c2d507e3bfa4033$var$v.priorityLevel;
                var e = d($3c2d507e3bfa4033$var$v.expirationTime <= b);
                b = $3c2d507e3bfa4033$export$c4744153514ff05d();
                "function" === typeof e ? $3c2d507e3bfa4033$var$v.callback = e : $3c2d507e3bfa4033$var$v === $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$r) && $3c2d507e3bfa4033$var$k($3c2d507e3bfa4033$var$r);
                $3c2d507e3bfa4033$var$G(b);
            } else $3c2d507e3bfa4033$var$k($3c2d507e3bfa4033$var$r);
            $3c2d507e3bfa4033$var$v = $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$r);
        }
        if (null !== $3c2d507e3bfa4033$var$v) var w = !0;
        else {
            var m = $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$t);
            null !== m && $3c2d507e3bfa4033$var$K($3c2d507e3bfa4033$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3c2d507e3bfa4033$var$v = null, $3c2d507e3bfa4033$var$y = c, $3c2d507e3bfa4033$var$z = !1;
    }
}
var $3c2d507e3bfa4033$var$N = !1, $3c2d507e3bfa4033$var$O = null, $3c2d507e3bfa4033$var$L = -1, $3c2d507e3bfa4033$var$P = 5, $3c2d507e3bfa4033$var$Q = -1;
function $3c2d507e3bfa4033$var$M() {
    return $3c2d507e3bfa4033$export$c4744153514ff05d() - $3c2d507e3bfa4033$var$Q < $3c2d507e3bfa4033$var$P ? !1 : !0;
}
function $3c2d507e3bfa4033$var$R() {
    if (null !== $3c2d507e3bfa4033$var$O) {
        var a = $3c2d507e3bfa4033$export$c4744153514ff05d();
        $3c2d507e3bfa4033$var$Q = a;
        var b = !0;
        try {
            b = $3c2d507e3bfa4033$var$O(!0, a);
        } finally{
            b ? $3c2d507e3bfa4033$var$S() : ($3c2d507e3bfa4033$var$N = !1, $3c2d507e3bfa4033$var$O = null);
        }
    } else $3c2d507e3bfa4033$var$N = !1;
}
var $3c2d507e3bfa4033$var$S;
if ("function" === typeof $3c2d507e3bfa4033$var$F) $3c2d507e3bfa4033$var$S = function() {
    $3c2d507e3bfa4033$var$F($3c2d507e3bfa4033$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3c2d507e3bfa4033$var$T = new MessageChannel, $3c2d507e3bfa4033$var$U = $3c2d507e3bfa4033$var$T.port2;
    $3c2d507e3bfa4033$var$T.port1.onmessage = $3c2d507e3bfa4033$var$R;
    $3c2d507e3bfa4033$var$S = function() {
        $3c2d507e3bfa4033$var$U.postMessage(null);
    };
} else $3c2d507e3bfa4033$var$S = function() {
    $3c2d507e3bfa4033$var$D($3c2d507e3bfa4033$var$R, 0);
};
function $3c2d507e3bfa4033$var$I(a) {
    $3c2d507e3bfa4033$var$O = a;
    $3c2d507e3bfa4033$var$N || ($3c2d507e3bfa4033$var$N = !0, $3c2d507e3bfa4033$var$S());
}
function $3c2d507e3bfa4033$var$K(a, b) {
    $3c2d507e3bfa4033$var$L = $3c2d507e3bfa4033$var$D(function() {
        a($3c2d507e3bfa4033$export$c4744153514ff05d());
    }, b);
}
$3c2d507e3bfa4033$export$3e506c1ccc9cc1a7 = 5;
$3c2d507e3bfa4033$export$e26fe2ed2fa76875 = 1;
$3c2d507e3bfa4033$export$502329bbf4b505b1 = 4;
$3c2d507e3bfa4033$export$6e3807111c4874c4 = 3;
$3c2d507e3bfa4033$export$c27134553091fb3a = null;
$3c2d507e3bfa4033$export$33ee1acdc04fd2a2 = 2;
$3c2d507e3bfa4033$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3c2d507e3bfa4033$export$8352ce38b91d0c62 = function() {
    $3c2d507e3bfa4033$var$A || $3c2d507e3bfa4033$var$z || ($3c2d507e3bfa4033$var$A = !0, $3c2d507e3bfa4033$var$I($3c2d507e3bfa4033$var$J));
};
$3c2d507e3bfa4033$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3c2d507e3bfa4033$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3c2d507e3bfa4033$export$d3dfb8e4810cb555 = function() {
    return $3c2d507e3bfa4033$var$y;
};
$3c2d507e3bfa4033$export$839f9183b0465a69 = function() {
    return $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$r);
};
$3c2d507e3bfa4033$export$72fdf0e06517287b = function(a) {
    switch($3c2d507e3bfa4033$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3c2d507e3bfa4033$var$y;
    }
    var c = $3c2d507e3bfa4033$var$y;
    $3c2d507e3bfa4033$var$y = b;
    try {
        return a();
    } finally{
        $3c2d507e3bfa4033$var$y = c;
    }
};
$3c2d507e3bfa4033$export$4b844e58a3e414b4 = function() {};
$3c2d507e3bfa4033$export$816d2913ae6b83b1 = function() {};
$3c2d507e3bfa4033$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3c2d507e3bfa4033$var$y;
    $3c2d507e3bfa4033$var$y = a;
    try {
        return b();
    } finally{
        $3c2d507e3bfa4033$var$y = c;
    }
};
$3c2d507e3bfa4033$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3c2d507e3bfa4033$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3c2d507e3bfa4033$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3c2d507e3bfa4033$var$f($3c2d507e3bfa4033$var$t, a), null === $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$r) && a === $3c2d507e3bfa4033$var$h($3c2d507e3bfa4033$var$t) && ($3c2d507e3bfa4033$var$B ? ($3c2d507e3bfa4033$var$E($3c2d507e3bfa4033$var$L), $3c2d507e3bfa4033$var$L = -1) : $3c2d507e3bfa4033$var$B = !0, $3c2d507e3bfa4033$var$K($3c2d507e3bfa4033$var$H, c - d))) : (a.sortIndex = e, $3c2d507e3bfa4033$var$f($3c2d507e3bfa4033$var$r, a), $3c2d507e3bfa4033$var$A || $3c2d507e3bfa4033$var$z || ($3c2d507e3bfa4033$var$A = !0, $3c2d507e3bfa4033$var$I($3c2d507e3bfa4033$var$J)));
    return a;
};
$3c2d507e3bfa4033$export$b5836b71941fa3ed = $3c2d507e3bfa4033$var$M;
$3c2d507e3bfa4033$export$cf845f2c119da08a = function(a) {
    var b = $3c2d507e3bfa4033$var$y;
    return function() {
        var c = $3c2d507e3bfa4033$var$y;
        $3c2d507e3bfa4033$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3c2d507e3bfa4033$var$y = c;
        }
    };
};

});



var $fe00083af124a348$exports = {};
"use strict";

$fe00083af124a348$exports = (parcelRequire("gGb7Q"));


var $ee2623c680381be0$export$882461b6382ed46c;
var $ee2623c680381be0$export$757ceba2d55c277e;
"use strict";
var $ad3a4949853b0851$exports = {};
"use strict";
function $ad3a4949853b0851$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ad3a4949853b0851$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ad3a4949853b0851$var$checkDCE();

$ad3a4949853b0851$exports = (parcelRequire("v6beo"));


var $ee2623c680381be0$var$i;
$ee2623c680381be0$export$882461b6382ed46c = $ad3a4949853b0851$exports.createRoot;
$ee2623c680381be0$export$757ceba2d55c277e = $ad3a4949853b0851$exports.hydrateRoot;



/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eFMZj = parcelRequire("eFMZj");

/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $0157a75f5719b651$var$_extends() {
    $0157a75f5719b651$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0157a75f5719b651$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $0157a75f5719b651$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($0157a75f5719b651$export$e19cd5f9376f8cee || ($0157a75f5719b651$export$e19cd5f9376f8cee = {}));
const $0157a75f5719b651$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $0157a75f5719b651$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $0157a75f5719b651$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $0157a75f5719b651$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $0157a75f5719b651$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $0157a75f5719b651$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $0157a75f5719b651$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $0157a75f5719b651$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $0157a75f5719b651$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $0157a75f5719b651$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $0157a75f5719b651$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $0157a75f5719b651$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $0157a75f5719b651$export$fe53371bee54353d(to);
    }
    return $0157a75f5719b651$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $0157a75f5719b651$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $0157a75f5719b651$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $0157a75f5719b651$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $0157a75f5719b651$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $0157a75f5719b651$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $0157a75f5719b651$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $0157a75f5719b651$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $0157a75f5719b651$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $0157a75f5719b651$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $0157a75f5719b651$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $0157a75f5719b651$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $0157a75f5719b651$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $0157a75f5719b651$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $0157a75f5719b651$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $0157a75f5719b651$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $0157a75f5719b651$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $0157a75f5719b651$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $0157a75f5719b651$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($0157a75f5719b651$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $0157a75f5719b651$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $0157a75f5719b651$export$e19cd5f9376f8cee.Push;
        let location = $0157a75f5719b651$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $0157a75f5719b651$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $0157a75f5719b651$export$e19cd5f9376f8cee.Replace;
        let location = $0157a75f5719b651$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $0157a75f5719b651$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $0157a75f5719b651$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $0157a75f5719b651$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($0157a75f5719b651$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($0157a75f5719b651$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $0157a75f5719b651$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($0157a75f5719b651$var$ResultType || ($0157a75f5719b651$var$ResultType = {}));
const $0157a75f5719b651$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $0157a75f5719b651$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $0157a75f5719b651$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $0157a75f5719b651$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $0157a75f5719b651$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($0157a75f5719b651$var$isIndexRoute(route)) {
            let indexRoute = $0157a75f5719b651$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $0157a75f5719b651$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $0157a75f5719b651$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $0157a75f5719b651$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $0157a75f5719b651$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $0157a75f5719b651$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $0157a75f5719b651$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $0157a75f5719b651$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $0157a75f5719b651$var$flattenRoutes(routes);
    $0157a75f5719b651$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $0157a75f5719b651$export$30d21fd6d7295f52(pathname);
        matches = $0157a75f5719b651$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $0157a75f5719b651$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $0157a75f5719b651$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $0157a75f5719b651$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $0157a75f5719b651$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $0157a75f5719b651$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $0157a75f5719b651$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $0157a75f5719b651$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $0157a75f5719b651$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $0157a75f5719b651$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $0157a75f5719b651$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $0157a75f5719b651$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $0157a75f5719b651$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $0157a75f5719b651$var$paramRe = /^:[\w-]+$/;
const $0157a75f5719b651$var$dynamicSegmentValue = 3;
const $0157a75f5719b651$var$indexRouteValue = 2;
const $0157a75f5719b651$var$emptySegmentValue = 1;
const $0157a75f5719b651$var$staticSegmentValue = 10;
const $0157a75f5719b651$var$splatPenalty = -2;
const $0157a75f5719b651$var$isSplat = (s)=>s === "*";
function $0157a75f5719b651$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($0157a75f5719b651$var$isSplat)) initialScore += $0157a75f5719b651$var$splatPenalty;
    if (index) initialScore += $0157a75f5719b651$var$indexRouteValue;
    return segments.filter((s)=>!$0157a75f5719b651$var$isSplat(s)).reduce((score, segment)=>score + ($0157a75f5719b651$var$paramRe.test(segment) ? $0157a75f5719b651$var$dynamicSegmentValue : segment === "" ? $0157a75f5719b651$var$emptySegmentValue : $0157a75f5719b651$var$staticSegmentValue), initialScore);
}
function $0157a75f5719b651$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $0157a75f5719b651$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $0157a75f5719b651$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $0157a75f5719b651$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $0157a75f5719b651$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $0157a75f5719b651$export$a5c6d149b50c1d86($0157a75f5719b651$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $0157a75f5719b651$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $0157a75f5719b651$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $0157a75f5719b651$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $0157a75f5719b651$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $0157a75f5719b651$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $0157a75f5719b651$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $0157a75f5719b651$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $0157a75f5719b651$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $0157a75f5719b651$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $0157a75f5719b651$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $0157a75f5719b651$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $0157a75f5719b651$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $0157a75f5719b651$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $0157a75f5719b651$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $0157a75f5719b651$var$normalizeSearch(search),
        hash: $0157a75f5719b651$var$normalizeHash(hash)
    };
}
function $0157a75f5719b651$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $0157a75f5719b651$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $0157a75f5719b651$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $0157a75f5719b651$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $0157a75f5719b651$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $0157a75f5719b651$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $0157a75f5719b651$export$8ccf933b0513f8d0(toArg);
    else {
        to = $0157a75f5719b651$var$_extends({}, toArg);
        $0157a75f5719b651$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $0157a75f5719b651$var$getInvalidPathError("?", "pathname", "search", to));
        $0157a75f5719b651$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $0157a75f5719b651$var$getInvalidPathError("#", "pathname", "hash", to));
        $0157a75f5719b651$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $0157a75f5719b651$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $0157a75f5719b651$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $0157a75f5719b651$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $0157a75f5719b651$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $0157a75f5719b651$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $0157a75f5719b651$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $0157a75f5719b651$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $0157a75f5719b651$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $0157a75f5719b651$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $0157a75f5719b651$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $0157a75f5719b651$export$42a99a7a4bc0e76a extends Error {
}
class $0157a75f5719b651$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $0157a75f5719b651$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $0157a75f5719b651$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $0157a75f5719b651$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $0157a75f5719b651$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $0157a75f5719b651$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $0157a75f5719b651$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $0157a75f5719b651$var$unwrapTrackedPromise(value) {
    if (!$0157a75f5719b651$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $0157a75f5719b651$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $0157a75f5719b651$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0157a75f5719b651$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $0157a75f5719b651$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0157a75f5719b651$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $0157a75f5719b651$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $0157a75f5719b651$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $0157a75f5719b651$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $0157a75f5719b651$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $0157a75f5719b651$var$validMutationMethods = new Set($0157a75f5719b651$var$validMutationMethodsArr);
const $0157a75f5719b651$var$validRequestMethodsArr = [
    "get",
    ...$0157a75f5719b651$var$validMutationMethodsArr
];
const $0157a75f5719b651$var$validRequestMethods = new Set($0157a75f5719b651$var$validRequestMethodsArr);
const $0157a75f5719b651$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $0157a75f5719b651$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $0157a75f5719b651$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0157a75f5719b651$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0157a75f5719b651$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $0157a75f5719b651$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $0157a75f5719b651$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $0157a75f5719b651$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $0157a75f5719b651$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $0157a75f5719b651$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0157a75f5719b651$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $0157a75f5719b651$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $0157a75f5719b651$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $0157a75f5719b651$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $0157a75f5719b651$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $0157a75f5719b651$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $0157a75f5719b651$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && patchRoutesOnMissImpl && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $0157a75f5719b651$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $0157a75f5719b651$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $0157a75f5719b651$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $0157a75f5719b651$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $0157a75f5719b651$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$0157a75f5719b651$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($0157a75f5719b651$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $0157a75f5719b651$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $0157a75f5719b651$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $0157a75f5719b651$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $0157a75f5719b651$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $0157a75f5719b651$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $0157a75f5719b651$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $0157a75f5719b651$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $0157a75f5719b651$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $0157a75f5719b651$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($0157a75f5719b651$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $0157a75f5719b651$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $0157a75f5719b651$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $0157a75f5719b651$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $0157a75f5719b651$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $0157a75f5719b651$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $0157a75f5719b651$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $0157a75f5719b651$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $0157a75f5719b651$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $0157a75f5719b651$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $0157a75f5719b651$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $0157a75f5719b651$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $0157a75f5719b651$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $0157a75f5719b651$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $0157a75f5719b651$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $0157a75f5719b651$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $0157a75f5719b651$var$findNearestBoundary(matches).route.id,
            {
                type: $0157a75f5719b651$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $0157a75f5719b651$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($0157a75f5719b651$var$isErrorResult(result) && $0157a75f5719b651$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $0157a75f5719b651$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $0157a75f5719b651$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $0157a75f5719b651$var$_extends({
            matches: updatedMatches || matches
        }, $0157a75f5719b651$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $0157a75f5719b651$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $0157a75f5719b651$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $0157a75f5719b651$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $0157a75f5719b651$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $0157a75f5719b651$var$ResultType.error,
            error: $0157a75f5719b651$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($0157a75f5719b651$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $0157a75f5719b651$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($0157a75f5719b651$var$isDeferredResult(result)) throw $0157a75f5719b651$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($0157a75f5719b651$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $0157a75f5719b651$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $0157a75f5719b651$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $0157a75f5719b651$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $0157a75f5719b651$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($0157a75f5719b651$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $0157a75f5719b651$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $0157a75f5719b651$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $0157a75f5719b651$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $0157a75f5719b651$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $0157a75f5719b651$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0157a75f5719b651$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $0157a75f5719b651$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$0157a75f5719b651$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $0157a75f5719b651$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $0157a75f5719b651$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $0157a75f5719b651$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $0157a75f5719b651$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $0157a75f5719b651$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $0157a75f5719b651$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $0157a75f5719b651$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $0157a75f5719b651$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0157a75f5719b651$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $0157a75f5719b651$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $0157a75f5719b651$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $0157a75f5719b651$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($0157a75f5719b651$var$isRedirectResult(actionResult) || $0157a75f5719b651$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $0157a75f5719b651$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($0157a75f5719b651$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $0157a75f5719b651$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $0157a75f5719b651$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($0157a75f5719b651$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($0157a75f5719b651$var$isDeferredResult(actionResult)) throw $0157a75f5719b651$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $0157a75f5719b651$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $0157a75f5719b651$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $0157a75f5719b651$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $0157a75f5719b651$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $0157a75f5719b651$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $0157a75f5719b651$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $0157a75f5719b651$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0157a75f5719b651$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $0157a75f5719b651$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $0157a75f5719b651$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $0157a75f5719b651$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0157a75f5719b651$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $0157a75f5719b651$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $0157a75f5719b651$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $0157a75f5719b651$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($0157a75f5719b651$var$isDeferredResult(result)) result = await $0157a75f5719b651$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $0157a75f5719b651$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($0157a75f5719b651$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $0157a75f5719b651$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($0157a75f5719b651$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $0157a75f5719b651$export$3e9cee6b33872309(!$0157a75f5719b651$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $0157a75f5719b651$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $0157a75f5719b651$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $0157a75f5719b651$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $0157a75f5719b651$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($0157a75f5719b651$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $0157a75f5719b651$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $0157a75f5719b651$export$e19cd5f9376f8cee.Replace : $0157a75f5719b651$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $0157a75f5719b651$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($0157a75f5719b651$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $0157a75f5719b651$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $0157a75f5719b651$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $0157a75f5719b651$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $0157a75f5719b651$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($0157a75f5719b651$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $0157a75f5719b651$var$ResultType.redirect,
                        response: $0157a75f5719b651$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $0157a75f5719b651$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $0157a75f5719b651$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $0157a75f5719b651$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $0157a75f5719b651$var$ResultType.error,
                    error: $0157a75f5719b651$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $0157a75f5719b651$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $0157a75f5719b651$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $0157a75f5719b651$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $0157a75f5719b651$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $0157a75f5719b651$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $0157a75f5719b651$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $0157a75f5719b651$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $0157a75f5719b651$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $0157a75f5719b651$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $0157a75f5719b651$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $0157a75f5719b651$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $0157a75f5719b651$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $0157a75f5719b651$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $0157a75f5719b651$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $0157a75f5719b651$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $0157a75f5719b651$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $0157a75f5719b651$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$0157a75f5719b651$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $0157a75f5719b651$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $0157a75f5719b651$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $0157a75f5719b651$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $0157a75f5719b651$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $0157a75f5719b651$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $0157a75f5719b651$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $0157a75f5719b651$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $0157a75f5719b651$export$4d0306f8f6a4585b = Symbol("deferred");
function $0157a75f5719b651$export$3336b097a6fbc59a(routes, opts) {
    $0157a75f5719b651$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0157a75f5719b651$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $0157a75f5719b651$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $0157a75f5719b651$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0157a75f5719b651$var$createLocation("", $0157a75f5719b651$export$fe53371bee54353d(url), null, "default");
        let matches = $0157a75f5719b651$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0157a75f5719b651$var$isValidMethod(method) && method !== "HEAD") {
            let error = $0157a75f5719b651$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $0157a75f5719b651$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $0157a75f5719b651$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $0157a75f5719b651$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($0157a75f5719b651$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $0157a75f5719b651$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0157a75f5719b651$var$createLocation("", $0157a75f5719b651$export$fe53371bee54353d(url), null, "default");
        let matches = $0157a75f5719b651$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0157a75f5719b651$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $0157a75f5719b651$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $0157a75f5719b651$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $0157a75f5719b651$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $0157a75f5719b651$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $0157a75f5719b651$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($0157a75f5719b651$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$0157a75f5719b651$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $0157a75f5719b651$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($0157a75f5719b651$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $0157a75f5719b651$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $0157a75f5719b651$var$isResponse(result) ? result : $0157a75f5719b651$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($0157a75f5719b651$var$isHandlerResult(e) && $0157a75f5719b651$var$isResponse(e.result)) {
                if (e.type === $0157a75f5719b651$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($0157a75f5719b651$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $0157a75f5719b651$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0157a75f5719b651$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $0157a75f5719b651$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($0157a75f5719b651$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($0157a75f5719b651$var$isDeferredResult(result)) {
            let error = $0157a75f5719b651$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0157a75f5719b651$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($0157a75f5719b651$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($0157a75f5719b651$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $0157a75f5719b651$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $0157a75f5719b651$var$_extends({}, context, {
                statusCode: $0157a75f5719b651$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $0157a75f5719b651$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $0157a75f5719b651$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $0157a75f5719b651$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $0157a75f5719b651$var$isErrorResult(pendingActionResult[1]) ? $0157a75f5719b651$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $0157a75f5719b651$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $0157a75f5719b651$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $0157a75f5719b651$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $0157a75f5719b651$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $0157a75f5719b651$var$callDataStrategyImpl(unstable_dataStrategy || $0157a75f5719b651$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($0157a75f5719b651$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $0157a75f5719b651$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($0157a75f5719b651$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $0157a75f5719b651$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $0157a75f5719b651$export$fec11da027c70692(routes, context, error) {
    let newContext = $0157a75f5719b651$var$_extends({}, context, {
        statusCode: $0157a75f5719b651$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $0157a75f5719b651$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $0157a75f5719b651$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $0157a75f5719b651$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $0157a75f5719b651$export$cae722b0cc860f13(to ? to : ".", $0157a75f5719b651$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $0157a75f5719b651$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$0157a75f5719b651$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $0157a75f5719b651$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $0157a75f5719b651$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $0157a75f5719b651$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$0157a75f5719b651$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$0157a75f5719b651$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $0157a75f5719b651$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $0157a75f5719b651$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $0157a75f5719b651$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$0157a75f5719b651$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$0157a75f5719b651$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $0157a75f5719b651$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $0157a75f5719b651$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $0157a75f5719b651$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $0157a75f5719b651$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $0157a75f5719b651$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($0157a75f5719b651$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $0157a75f5719b651$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $0157a75f5719b651$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $0157a75f5719b651$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $0157a75f5719b651$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $0157a75f5719b651$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $0157a75f5719b651$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $0157a75f5719b651$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $0157a75f5719b651$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($0157a75f5719b651$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $0157a75f5719b651$var$shouldRevalidateLoader(match, $0157a75f5719b651$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $0157a75f5719b651$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $0157a75f5719b651$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $0157a75f5719b651$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $0157a75f5719b651$var$shouldRevalidateLoader(fetcherMatch, $0157a75f5719b651$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $0157a75f5719b651$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $0157a75f5719b651$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $0157a75f5719b651$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $0157a75f5719b651$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $0157a75f5719b651$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $0157a75f5719b651$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $0157a75f5719b651$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $0157a75f5719b651$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $0157a75f5719b651$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $0157a75f5719b651$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $0157a75f5719b651$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $0157a75f5719b651$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $0157a75f5719b651$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$0157a75f5719b651$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $0157a75f5719b651$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $0157a75f5719b651$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $0157a75f5719b651$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $0157a75f5719b651$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $0157a75f5719b651$var$ResultType.data,
                    result: undefined
                });
            };
            return $0157a75f5719b651$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$0157a75f5719b651$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $0157a75f5719b651$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $0157a75f5719b651$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $0157a75f5719b651$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $0157a75f5719b651$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $0157a75f5719b651$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $0157a75f5719b651$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $0157a75f5719b651$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $0157a75f5719b651$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $0157a75f5719b651$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($0157a75f5719b651$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $0157a75f5719b651$var$ResultType.error,
                error: e
            };
        }
        if (type === $0157a75f5719b651$var$ResultType.error) return {
            type: $0157a75f5719b651$var$ResultType.error,
            error: new $0157a75f5719b651$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $0157a75f5719b651$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $0157a75f5719b651$var$ResultType.error) return {
        type: $0157a75f5719b651$var$ResultType.error,
        error: result,
        statusCode: $0157a75f5719b651$export$972111febbeef05b(result) ? result.status : status
    };
    if ($0157a75f5719b651$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $0157a75f5719b651$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $0157a75f5719b651$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $0157a75f5719b651$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $0157a75f5719b651$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$0157a75f5719b651$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $0157a75f5719b651$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $0157a75f5719b651$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($0157a75f5719b651$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $0157a75f5719b651$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $0157a75f5719b651$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($0157a75f5719b651$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $0157a75f5719b651$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $0157a75f5719b651$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $0157a75f5719b651$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $0157a75f5719b651$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $0157a75f5719b651$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $0157a75f5719b651$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $0157a75f5719b651$export$3e9cee6b33872309(!$0157a75f5719b651$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($0157a75f5719b651$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $0157a75f5719b651$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $0157a75f5719b651$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($0157a75f5719b651$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $0157a75f5719b651$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $0157a75f5719b651$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $0157a75f5719b651$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($0157a75f5719b651$var$isErrorResult(result)) {
            let boundaryMatch = $0157a75f5719b651$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $0157a75f5719b651$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($0157a75f5719b651$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $0157a75f5719b651$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($0157a75f5719b651$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $0157a75f5719b651$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $0157a75f5719b651$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $0157a75f5719b651$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $0157a75f5719b651$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $0157a75f5719b651$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $0157a75f5719b651$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $0157a75f5719b651$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $0157a75f5719b651$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $0157a75f5719b651$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $0157a75f5719b651$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $0157a75f5719b651$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($0157a75f5719b651$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $0157a75f5719b651$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $0157a75f5719b651$export$8ccf933b0513f8d0(path) : path;
    return $0157a75f5719b651$export$fe53371bee54353d($0157a75f5719b651$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $0157a75f5719b651$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $0157a75f5719b651$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $0157a75f5719b651$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $0157a75f5719b651$var$ResultType.data || result.type === $0157a75f5719b651$var$ResultType.error);
}
function $0157a75f5719b651$var$isRedirectHandlerResult(result) {
    return $0157a75f5719b651$var$isResponse(result.result) && $0157a75f5719b651$var$redirectStatusCodes.has(result.result.status);
}
function $0157a75f5719b651$var$isDeferredResult(result) {
    return result.type === $0157a75f5719b651$var$ResultType.deferred;
}
function $0157a75f5719b651$var$isErrorResult(result) {
    return result.type === $0157a75f5719b651$var$ResultType.error;
}
function $0157a75f5719b651$var$isRedirectResult(result) {
    return (result && result.type) === $0157a75f5719b651$var$ResultType.redirect;
}
function $0157a75f5719b651$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $0157a75f5719b651$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $0157a75f5719b651$var$isRedirectResponse(result) {
    if (!$0157a75f5719b651$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $0157a75f5719b651$var$isValidMethod(method) {
    return $0157a75f5719b651$var$validRequestMethods.has(method.toLowerCase());
}
function $0157a75f5719b651$var$isMutationMethod(method) {
    return $0157a75f5719b651$var$validMutationMethods.has(method.toLowerCase());
}
async function $0157a75f5719b651$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$0157a75f5719b651$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($0157a75f5719b651$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $0157a75f5719b651$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $0157a75f5719b651$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $0157a75f5719b651$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $0157a75f5719b651$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $0157a75f5719b651$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $0157a75f5719b651$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $0157a75f5719b651$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $0157a75f5719b651$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $0157a75f5719b651$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $0157a75f5719b651$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $0157a75f5719b651$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $0157a75f5719b651$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $0157a75f5719b651$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $0157a75f5719b651$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $0157a75f5719b651$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $0157a75f5719b651$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $0157a75f5719b651$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $0157a75f5719b651$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($0157a75f5719b651$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $0157a75f5719b651$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($0157a75f5719b651$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $0157a75f5719b651$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eFMZj = parcelRequire("eFMZj");

function $72fa3923970c35a7$var$_extends() {
    $72fa3923970c35a7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $72fa3923970c35a7$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $72fa3923970c35a7$export$3add0d5dce533e2e = /*#__PURE__*/ $eFMZj.createContext(null);
const $72fa3923970c35a7$export$145dfa71566a64dc = /*#__PURE__*/ $eFMZj.createContext(null);
const $72fa3923970c35a7$var$AwaitContext = /*#__PURE__*/ $eFMZj.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $72fa3923970c35a7$export$26749e8557646306 = /*#__PURE__*/ $eFMZj.createContext(null);
const $72fa3923970c35a7$export$c7914228fb69b0f5 = /*#__PURE__*/ $eFMZj.createContext(null);
const $72fa3923970c35a7$export$9072aa6dd1f93057 = /*#__PURE__*/ $eFMZj.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $72fa3923970c35a7$var$RouteErrorContext = /*#__PURE__*/ $eFMZj.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $72fa3923970c35a7$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$72fa3923970c35a7$export$9c954a9d03d32f4a() && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $eFMZj.useContext($72fa3923970c35a7$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $72fa3923970c35a7$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $0157a75f5719b651$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $72fa3923970c35a7$export$9c954a9d03d32f4a() {
    return $eFMZj.useContext($72fa3923970c35a7$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $72fa3923970c35a7$export$45d76561a5302f2b() {
    !$72fa3923970c35a7$export$9c954a9d03d32f4a() && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    return $eFMZj.useContext($72fa3923970c35a7$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $72fa3923970c35a7$export$1b3f31771c5d07c() {
    return $eFMZj.useContext($72fa3923970c35a7$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $72fa3923970c35a7$export$6c330e8992e8a295(pattern) {
    !$72fa3923970c35a7$export$9c954a9d03d32f4a() && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $72fa3923970c35a7$export$45d76561a5302f2b();
    return $eFMZj.useMemo(()=>(0, $0157a75f5719b651$export$81336c211d5ff295)(pattern, (0, $0157a75f5719b651$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $72fa3923970c35a7$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $72fa3923970c35a7$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eFMZj.useContext($72fa3923970c35a7$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eFMZj.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $72fa3923970c35a7$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $72fa3923970c35a7$var$useNavigateStable() : $72fa3923970c35a7$var$useNavigateUnstable();
}
function $72fa3923970c35a7$var$useNavigateUnstable() {
    !$72fa3923970c35a7$export$9c954a9d03d32f4a() && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    let dataRouterContext = $eFMZj.useContext($72fa3923970c35a7$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eFMZj.useContext($72fa3923970c35a7$export$26749e8557646306);
    let { matches: matches } = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $72fa3923970c35a7$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $0157a75f5719b651$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $eFMZj.useRef(false);
    $72fa3923970c35a7$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eFMZj.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $0157a75f5719b651$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $0157a75f5719b651$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $72fa3923970c35a7$var$OutletContext = /*#__PURE__*/ $eFMZj.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $72fa3923970c35a7$export$4138103a3ae699cc() {
    return $eFMZj.useContext($72fa3923970c35a7$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $72fa3923970c35a7$export$a3be3530d8e40d0b(context) {
    let outlet = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $72fa3923970c35a7$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $72fa3923970c35a7$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eFMZj.useContext($72fa3923970c35a7$export$26749e8557646306);
    let { matches: matches } = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $72fa3923970c35a7$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $0157a75f5719b651$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $eFMZj.useMemo(()=>(0, $0157a75f5719b651$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $72fa3923970c35a7$export$5d3fca4a98652595(routes, locationArg) {
    return $72fa3923970c35a7$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $72fa3923970c35a7$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$72fa3923970c35a7$export$9c954a9d03d32f4a() && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $eFMZj.useContext($72fa3923970c35a7$export$26749e8557646306);
    let { matches: parentMatches } = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $72fa3923970c35a7$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $0157a75f5719b651$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $0157a75f5719b651$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $72fa3923970c35a7$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $0157a75f5719b651$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $0157a75f5719b651$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $72fa3923970c35a7$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $0157a75f5719b651$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $72fa3923970c35a7$var$DefaultErrorComponent() {
    let error = $72fa3923970c35a7$export$ed527bf60f6e05f2();
    let message = (0, $0157a75f5719b651$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eFMZj.createElement($eFMZj.Fragment, null, /*#__PURE__*/ $eFMZj.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eFMZj.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eFMZj.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $72fa3923970c35a7$var$defaultErrorElement = /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$DefaultErrorComponent, null);
class $72fa3923970c35a7$var$RenderErrorBoundary extends $eFMZj.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $72fa3923970c35a7$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eFMZj.useContext($72fa3923970c35a7$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $72fa3923970c35a7$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $72fa3923970c35a7$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $72fa3923970c35a7$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eFMZj.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $72fa3923970c35a7$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($72fa3923970c35a7$var$DataRouterHook || {});
var $72fa3923970c35a7$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($72fa3923970c35a7$var$DataRouterStateHook || {});
function $72fa3923970c35a7$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $72fa3923970c35a7$var$useDataRouterContext(hookName) {
    let ctx = $eFMZj.useContext($72fa3923970c35a7$export$3add0d5dce533e2e);
    !ctx && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    return ctx;
}
function $72fa3923970c35a7$var$useDataRouterState(hookName) {
    let state = $eFMZj.useContext($72fa3923970c35a7$export$145dfa71566a64dc);
    !state && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    return state;
}
function $72fa3923970c35a7$var$useRouteContext(hookName) {
    let route = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057);
    !route && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $72fa3923970c35a7$var$useCurrentRouteId(hookName) {
    let route = $72fa3923970c35a7$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $72fa3923970c35a7$export$5fc8298006ad9e58() {
    return $72fa3923970c35a7$var$useCurrentRouteId($72fa3923970c35a7$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $72fa3923970c35a7$export$d0fd4b7106de2769() {
    let state = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $72fa3923970c35a7$export$600dc272ed516c15() {
    let dataRouterContext = $72fa3923970c35a7$var$useDataRouterContext($72fa3923970c35a7$var$DataRouterHook.UseRevalidator);
    let state = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseRevalidator);
    return $eFMZj.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $72fa3923970c35a7$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseMatches);
    return $eFMZj.useMemo(()=>matches.map((m)=>(0, $0157a75f5719b651$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $72fa3923970c35a7$export$1448a5050d252c4d() {
    let state = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseLoaderData);
    let routeId = $72fa3923970c35a7$var$useCurrentRouteId($72fa3923970c35a7$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $72fa3923970c35a7$export$fd5d37484eab868d(routeId) {
    let state = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $72fa3923970c35a7$export$fdc00f3f26066d5e() {
    let state = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseActionData);
    let routeId = $72fa3923970c35a7$var$useCurrentRouteId($72fa3923970c35a7$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $72fa3923970c35a7$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eFMZj.useContext($72fa3923970c35a7$var$RouteErrorContext);
    let state = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseRouteError);
    let routeId = $72fa3923970c35a7$var$useCurrentRouteId($72fa3923970c35a7$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $72fa3923970c35a7$export$78a72ddb39bdd145() {
    let value = $eFMZj.useContext($72fa3923970c35a7$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $72fa3923970c35a7$export$17f53340677d5831() {
    let value = $eFMZj.useContext($72fa3923970c35a7$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $72fa3923970c35a7$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $72fa3923970c35a7$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $72fa3923970c35a7$var$useDataRouterContext($72fa3923970c35a7$var$DataRouterHook.UseBlocker);
    let state = $72fa3923970c35a7$var$useDataRouterState($72fa3923970c35a7$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eFMZj.useState("");
    let blockerFunction = $eFMZj.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $72fa3923970c35a7$var$_extends({}, currentLocation, {
                pathname: (0, $0157a75f5719b651$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $72fa3923970c35a7$var$_extends({}, nextLocation, {
                pathname: (0, $0157a75f5719b651$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eFMZj.useEffect(()=>{
        let key = String(++$72fa3923970c35a7$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eFMZj.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $0157a75f5719b651$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $72fa3923970c35a7$var$useNavigateStable() {
    let { router: router } = $72fa3923970c35a7$var$useDataRouterContext($72fa3923970c35a7$var$DataRouterHook.UseNavigateStable);
    let id = $72fa3923970c35a7$var$useCurrentRouteId($72fa3923970c35a7$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eFMZj.useRef(false);
    $72fa3923970c35a7$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eFMZj.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $72fa3923970c35a7$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $72fa3923970c35a7$var$alreadyWarned = {};
function $72fa3923970c35a7$var$warningOnce(key, cond, message) {
    if (!cond && !$72fa3923970c35a7$var$alreadyWarned[key]) $72fa3923970c35a7$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $72fa3923970c35a7$var$START_TRANSITION = "startTransition";
const $72fa3923970c35a7$var$startTransitionImpl = $eFMZj[$72fa3923970c35a7$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $72fa3923970c35a7$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eFMZj.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eFMZj.useCallback((newState)=>{
        if (v7_startTransition && $72fa3923970c35a7$var$startTransitionImpl) $72fa3923970c35a7$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eFMZj.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eFMZj.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eFMZj.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eFMZj.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eFMZj.createElement($eFMZj.Fragment, null, /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $72fa3923970c35a7$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $72fa3923970c35a7$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $72fa3923970c35a7$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eFMZj.useRef();
    if (historyRef.current == null) historyRef.current = (0, $0157a75f5719b651$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eFMZj.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eFMZj.useCallback((newState)=>{
        v7_startTransition && $72fa3923970c35a7$var$startTransitionImpl ? $72fa3923970c35a7$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eFMZj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $72fa3923970c35a7$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$72fa3923970c35a7$export$9c954a9d03d32f4a() && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $eFMZj.useContext($72fa3923970c35a7$export$26749e8557646306);
    let { matches: matches } = $eFMZj.useContext($72fa3923970c35a7$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $72fa3923970c35a7$export$45d76561a5302f2b();
    let navigate = $72fa3923970c35a7$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $0157a75f5719b651$export$cae722b0cc860f13)(to, (0, $0157a75f5719b651$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eFMZj.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $72fa3923970c35a7$export$910ae8079b2c2852(props) {
    return $72fa3923970c35a7$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $72fa3923970c35a7$export$e7b0ac011bb776c6(_props) {
    (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $72fa3923970c35a7$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $0157a75f5719b651$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$72fa3923970c35a7$export$9c954a9d03d32f4a() && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eFMZj.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $72fa3923970c35a7$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $0157a75f5719b651$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eFMZj.useMemo(()=>{
        let trailingPathname = (0, $0157a75f5719b651$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $72fa3923970c35a7$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $72fa3923970c35a7$export$5d3fca4a98652595($72fa3923970c35a7$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $72fa3923970c35a7$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$ResolveAwait, null, children));
}
var $72fa3923970c35a7$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($72fa3923970c35a7$var$AwaitRenderStatus || {});
const $72fa3923970c35a7$var$neverSettledPromise = new Promise(()=>{});
class $72fa3923970c35a7$var$AwaitErrorBoundary extends $eFMZj.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $72fa3923970c35a7$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $72fa3923970c35a7$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $72fa3923970c35a7$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $72fa3923970c35a7$var$AwaitRenderStatus.error : "_data" in promise ? $72fa3923970c35a7$var$AwaitRenderStatus.success : $72fa3923970c35a7$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $72fa3923970c35a7$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $72fa3923970c35a7$var$AwaitRenderStatus.error && promise._error instanceof (0, $0157a75f5719b651$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $72fa3923970c35a7$var$neverSettledPromise;
        if (status === $72fa3923970c35a7$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $72fa3923970c35a7$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $72fa3923970c35a7$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eFMZj.createElement($72fa3923970c35a7$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $72fa3923970c35a7$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $72fa3923970c35a7$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eFMZj.createElement($eFMZj.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $72fa3923970c35a7$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eFMZj.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eFMZj.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eFMZj.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $72fa3923970c35a7$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $72fa3923970c35a7$export$e7b0ac011bb776c6) && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $72fa3923970c35a7$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $72fa3923970c35a7$export$daf73786167a7f72(matches) {
    return $72fa3923970c35a7$var$_renderMatches(matches);
}
function $72fa3923970c35a7$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eFMZj.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eFMZj.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eFMZj.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $72fa3923970c35a7$export$f30f7e456d254e83(routes, opts) {
    return (0, $0157a75f5719b651$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $72fa3923970c35a7$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $0157a75f5719b651$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $72fa3923970c35a7$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $b019c3b4a8678a9e$var$_extends() {
    $b019c3b4a8678a9e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b019c3b4a8678a9e$var$_extends.apply(this, arguments);
}
function $b019c3b4a8678a9e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b019c3b4a8678a9e$var$defaultMethod = "get";
const $b019c3b4a8678a9e$var$defaultEncType = "application/x-www-form-urlencoded";
function $b019c3b4a8678a9e$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b019c3b4a8678a9e$var$isButtonElement(object) {
    return $b019c3b4a8678a9e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b019c3b4a8678a9e$var$isFormElement(object) {
    return $b019c3b4a8678a9e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b019c3b4a8678a9e$var$isInputElement(object) {
    return $b019c3b4a8678a9e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b019c3b4a8678a9e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b019c3b4a8678a9e$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b019c3b4a8678a9e$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b019c3b4a8678a9e$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b019c3b4a8678a9e$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b019c3b4a8678a9e$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $b019c3b4a8678a9e$var$_formDataSupportsSubmitter = null;
function $b019c3b4a8678a9e$var$isFormDataSubmitterSupported() {
    if ($b019c3b4a8678a9e$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b019c3b4a8678a9e$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b019c3b4a8678a9e$var$_formDataSupportsSubmitter = true;
    }
    return $b019c3b4a8678a9e$var$_formDataSupportsSubmitter;
}
const $b019c3b4a8678a9e$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b019c3b4a8678a9e$var$getFormEncType(encType) {
    if (encType != null && !$b019c3b4a8678a9e$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $b019c3b4a8678a9e$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b019c3b4a8678a9e$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $0157a75f5719b651$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $b019c3b4a8678a9e$var$defaultMethod;
        encType = $b019c3b4a8678a9e$var$getFormEncType(target.getAttribute("enctype")) || $b019c3b4a8678a9e$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b019c3b4a8678a9e$var$isButtonElement(target) || $b019c3b4a8678a9e$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $0157a75f5719b651$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b019c3b4a8678a9e$var$defaultMethod;
        encType = $b019c3b4a8678a9e$var$getFormEncType(target.getAttribute("formenctype")) || $b019c3b4a8678a9e$var$getFormEncType(form.getAttribute("enctype")) || $b019c3b4a8678a9e$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$b019c3b4a8678a9e$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b019c3b4a8678a9e$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $b019c3b4a8678a9e$var$defaultMethod;
        action = null;
        encType = $b019c3b4a8678a9e$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $b019c3b4a8678a9e$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $b019c3b4a8678a9e$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $b019c3b4a8678a9e$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $b019c3b4a8678a9e$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $b019c3b4a8678a9e$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $b019c3b4a8678a9e$export$1f3f55432a00e06d(routes, opts) {
    return (0, $0157a75f5719b651$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b019c3b4a8678a9e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $0157a75f5719b651$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b019c3b4a8678a9e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $72fa3923970c35a7$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b019c3b4a8678a9e$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $0157a75f5719b651$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b019c3b4a8678a9e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $0157a75f5719b651$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b019c3b4a8678a9e$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $72fa3923970c35a7$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b019c3b4a8678a9e$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b019c3b4a8678a9e$var$_extends({}, state, {
        errors: $b019c3b4a8678a9e$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b019c3b4a8678a9e$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $0157a75f5719b651$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $b019c3b4a8678a9e$export$7ad602f0e94e62d1 = /*#__PURE__*/ $eFMZj.createContext({
    isTransitioning: false
});
const $b019c3b4a8678a9e$export$148fd98d095596d4 = /*#__PURE__*/ $eFMZj.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b019c3b4a8678a9e$var$START_TRANSITION = "startTransition";
const $b019c3b4a8678a9e$var$startTransitionImpl = $eFMZj[$b019c3b4a8678a9e$var$START_TRANSITION];
const $b019c3b4a8678a9e$var$FLUSH_SYNC = "flushSync";
const $b019c3b4a8678a9e$var$flushSyncImpl = $ad3a4949853b0851$exports[$b019c3b4a8678a9e$var$FLUSH_SYNC];
const $b019c3b4a8678a9e$var$USE_ID = "useId";
const $b019c3b4a8678a9e$var$useIdImpl = $eFMZj[$b019c3b4a8678a9e$var$USE_ID];
function $b019c3b4a8678a9e$var$startTransitionSafe(cb) {
    if ($b019c3b4a8678a9e$var$startTransitionImpl) $b019c3b4a8678a9e$var$startTransitionImpl(cb);
    else cb();
}
function $b019c3b4a8678a9e$var$flushSyncSafe(cb) {
    if ($b019c3b4a8678a9e$var$flushSyncImpl) $b019c3b4a8678a9e$var$flushSyncImpl(cb);
    else cb();
}
class $b019c3b4a8678a9e$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b019c3b4a8678a9e$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eFMZj.useState(router.state);
    let [pendingState, setPendingState] = $eFMZj.useState();
    let [vtContext, setVtContext] = $eFMZj.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eFMZj.useState();
    let [transition, setTransition] = $eFMZj.useState();
    let [interruption, setInterruption] = $eFMZj.useState();
    let fetcherData = $eFMZj.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $eFMZj.useCallback((cb)=>{
        if (v7_startTransition) $b019c3b4a8678a9e$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $eFMZj.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $b019c3b4a8678a9e$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $b019c3b4a8678a9e$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $b019c3b4a8678a9e$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $b019c3b4a8678a9e$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $b019c3b4a8678a9e$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eFMZj.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $eFMZj.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b019c3b4a8678a9e$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $eFMZj.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $eFMZj.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $eFMZj.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $eFMZj.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eFMZj.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eFMZj.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $eFMZj.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eFMZj.createElement($eFMZj.Fragment, null, /*#__PURE__*/ $eFMZj.createElement((0, $72fa3923970c35a7$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eFMZj.createElement((0, $72fa3923970c35a7$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $eFMZj.createElement($b019c3b4a8678a9e$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $eFMZj.createElement($b019c3b4a8678a9e$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $eFMZj.createElement((0, $72fa3923970c35a7$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eFMZj.createElement($b019c3b4a8678a9e$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $b019c3b4a8678a9e$var$MemoizedDataRoutes = /*#__PURE__*/ $eFMZj.memo($b019c3b4a8678a9e$var$DataRoutes);
function $b019c3b4a8678a9e$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $72fa3923970c35a7$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b019c3b4a8678a9e$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $eFMZj.useRef();
    if (historyRef.current == null) historyRef.current = (0, $0157a75f5719b651$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eFMZj.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eFMZj.useCallback((newState)=>{
        v7_startTransition && $b019c3b4a8678a9e$var$startTransitionImpl ? $b019c3b4a8678a9e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eFMZj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eFMZj.createElement((0, $72fa3923970c35a7$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b019c3b4a8678a9e$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $eFMZj.useRef();
    if (historyRef.current == null) historyRef.current = (0, $0157a75f5719b651$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eFMZj.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eFMZj.useCallback((newState)=>{
        v7_startTransition && $b019c3b4a8678a9e$var$startTransitionImpl ? $b019c3b4a8678a9e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eFMZj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eFMZj.createElement((0, $72fa3923970c35a7$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b019c3b4a8678a9e$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $eFMZj.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eFMZj.useCallback((newState)=>{
        v7_startTransition && $b019c3b4a8678a9e$var$startTransitionImpl ? $b019c3b4a8678a9e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eFMZj.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eFMZj.createElement((0, $72fa3923970c35a7$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $b019c3b4a8678a9e$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b019c3b4a8678a9e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $b019c3b4a8678a9e$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eFMZj.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $b019c3b4a8678a9e$var$_objectWithoutPropertiesLoose(_ref7, $b019c3b4a8678a9e$var$_excluded);
    let { basename: basename } = $eFMZj.useContext((0, $72fa3923970c35a7$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b019c3b4a8678a9e$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b019c3b4a8678a9e$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $0157a75f5719b651$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $72fa3923970c35a7$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $b019c3b4a8678a9e$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eFMZj.createElement("a", $b019c3b4a8678a9e$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $b019c3b4a8678a9e$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eFMZj.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $b019c3b4a8678a9e$var$_objectWithoutPropertiesLoose(_ref8, $b019c3b4a8678a9e$var$_excluded2);
    let path = (0, $72fa3923970c35a7$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $72fa3923970c35a7$export$45d76561a5302f2b)();
    let routerState = $eFMZj.useContext((0, $72fa3923970c35a7$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $eFMZj.useContext((0, $72fa3923970c35a7$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b019c3b4a8678a9e$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $0157a75f5719b651$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $eFMZj.createElement($b019c3b4a8678a9e$export$a6c7ac8248d6e38a, $b019c3b4a8678a9e$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b019c3b4a8678a9e$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eFMZj.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $b019c3b4a8678a9e$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $b019c3b4a8678a9e$var$_objectWithoutPropertiesLoose(_ref9, $b019c3b4a8678a9e$var$_excluded3);
    let submit = $b019c3b4a8678a9e$export$47c85c6e3a081d3();
    let formAction = $b019c3b4a8678a9e$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $eFMZj.createElement("form", $b019c3b4a8678a9e$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b019c3b4a8678a9e$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $b019c3b4a8678a9e$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b019c3b4a8678a9e$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($b019c3b4a8678a9e$var$DataRouterHook || ($b019c3b4a8678a9e$var$DataRouterHook = {}));
var $b019c3b4a8678a9e$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b019c3b4a8678a9e$var$DataRouterStateHook || ($b019c3b4a8678a9e$var$DataRouterStateHook = {}));
// Internal hooks
function $b019c3b4a8678a9e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b019c3b4a8678a9e$var$useDataRouterContext(hookName) {
    let ctx = $eFMZj.useContext((0, $72fa3923970c35a7$export$3add0d5dce533e2e));
    !ctx && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b019c3b4a8678a9e$var$useDataRouterState(hookName) {
    let state = $eFMZj.useContext((0, $72fa3923970c35a7$export$145dfa71566a64dc));
    !state && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b019c3b4a8678a9e$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $72fa3923970c35a7$export$9770f232ac06a008)();
    let location = (0, $72fa3923970c35a7$export$45d76561a5302f2b)();
    let path = (0, $72fa3923970c35a7$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $eFMZj.useCallback((event)=>{
        if ($b019c3b4a8678a9e$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $0157a75f5719b651$export$fe53371bee54353d)(location) === (0, $0157a75f5719b651$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b019c3b4a8678a9e$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eFMZj.useRef($b019c3b4a8678a9e$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eFMZj.useRef(false);
    let location = (0, $72fa3923970c35a7$export$45d76561a5302f2b)();
    let searchParams = $eFMZj.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b019c3b4a8678a9e$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $72fa3923970c35a7$export$9770f232ac06a008)();
    let setSearchParams = $eFMZj.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b019c3b4a8678a9e$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $b019c3b4a8678a9e$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $b019c3b4a8678a9e$var$fetcherId = 0;
let $b019c3b4a8678a9e$var$getUniqueFetcherId = ()=>"__" + String(++$b019c3b4a8678a9e$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b019c3b4a8678a9e$export$47c85c6e3a081d3() {
    let { router: router } = $b019c3b4a8678a9e$var$useDataRouterContext($b019c3b4a8678a9e$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $eFMZj.useContext((0, $72fa3923970c35a7$export$26749e8557646306));
    let currentRouteId = (0, $72fa3923970c35a7$export$5fc8298006ad9e58)();
    return $eFMZj.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b019c3b4a8678a9e$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b019c3b4a8678a9e$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b019c3b4a8678a9e$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b019c3b4a8678a9e$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eFMZj.useContext((0, $72fa3923970c35a7$export$26749e8557646306));
    let routeContext = $eFMZj.useContext((0, $72fa3923970c35a7$export$9072aa6dd1f93057));
    !routeContext && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b019c3b4a8678a9e$var$_extends({}, (0, $72fa3923970c35a7$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $72fa3923970c35a7$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $0157a75f5719b651$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $0157a75f5719b651$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b019c3b4a8678a9e$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b019c3b4a8678a9e$var$useDataRouterContext($b019c3b4a8678a9e$var$DataRouterHook.UseFetcher);
    let state = $b019c3b4a8678a9e$var$useDataRouterState($b019c3b4a8678a9e$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $eFMZj.useContext($b019c3b4a8678a9e$export$148fd98d095596d4);
    let route = $eFMZj.useContext((0, $72fa3923970c35a7$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    !route && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $b019c3b4a8678a9e$var$useIdImpl ? $b019c3b4a8678a9e$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $eFMZj.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($b019c3b4a8678a9e$var$getUniqueFetcherId());
    // Registration/cleanup
    $eFMZj.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $eFMZj.useCallback((href, opts)=>{
        !routeId && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $b019c3b4a8678a9e$export$47c85c6e3a081d3();
    let submit = $eFMZj.useCallback((target, opts)=>{
        submitImpl(target, $b019c3b4a8678a9e$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $eFMZj.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $eFMZj.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $eFMZj.createElement($b019c3b4a8678a9e$export$a7fed597f4b8afd8, $b019c3b4a8678a9e$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $0157a75f5719b651$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eFMZj.useMemo(()=>$b019c3b4a8678a9e$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b019c3b4a8678a9e$export$fa996778a3a31087() {
    let state = $b019c3b4a8678a9e$var$useDataRouterState($b019c3b4a8678a9e$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $b019c3b4a8678a9e$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $b019c3b4a8678a9e$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b019c3b4a8678a9e$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b019c3b4a8678a9e$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $b019c3b4a8678a9e$var$useDataRouterContext($b019c3b4a8678a9e$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b019c3b4a8678a9e$var$useDataRouterState($b019c3b4a8678a9e$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $eFMZj.useContext((0, $72fa3923970c35a7$export$26749e8557646306));
    let location = (0, $72fa3923970c35a7$export$45d76561a5302f2b)();
    let matches = (0, $72fa3923970c35a7$export$2378eb7f5ff86053)();
    let navigation = (0, $72fa3923970c35a7$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $eFMZj.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b019c3b4a8678a9e$var$usePageHide($eFMZj.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b019c3b4a8678a9e$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b019c3b4a8678a9e$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b019c3b4a8678a9e$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eFMZj.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b019c3b4a8678a9e$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b019c3b4a8678a9e$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eFMZj.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($b019c3b4a8678a9e$var$_extends({}, location, {
                    pathname: (0, $0157a75f5719b651$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b019c3b4a8678a9e$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eFMZj.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b019c3b4a8678a9e$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eFMZj.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b019c3b4a8678a9e$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eFMZj.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b019c3b4a8678a9e$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $72fa3923970c35a7$export$b273b3273281a049)(when);
    $eFMZj.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eFMZj.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $b019c3b4a8678a9e$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $eFMZj.useContext($b019c3b4a8678a9e$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $0157a75f5719b651$export$3e9cee6b33872309)(false);
    let { basename: basename } = $b019c3b4a8678a9e$var$useDataRouterContext($b019c3b4a8678a9e$var$DataRouterHook.useViewTransitionState);
    let path = (0, $72fa3923970c35a7$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $0157a75f5719b651$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $0157a75f5719b651$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $0157a75f5719b651$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $0157a75f5719b651$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}





const $193714fcc8f30367$var$Header = ()=>{
    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
        className: "header",
        children: [
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                className: "logo",
                children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)((0, $b019c3b4a8678a9e$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: [
                        "Price",
                        /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("b", {
                            children: "Time"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
                className: "links",
                children: [
                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $b019c3b4a8678a9e$export$a6c7ac8248d6e38a), {
                        to: "addNewBooks",
                        children: "Add new books"
                    }),
                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $b019c3b4a8678a9e$export$a6c7ac8248d6e38a), {
                        to: "myBookstores",
                        children: "My bookstores"
                    }),
                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("span", {
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("span", {
                        children: "Logout"
                    })
                ]
            })
        ]
    });
};
var $193714fcc8f30367$export$2e2bcd8739ae039 = $193714fcc8f30367$var$Header;




var $eFMZj = parcelRequire("eFMZj");



var $eFMZj = parcelRequire("eFMZj");

var $207ee7e68268eafd$exports = {};
$207ee7e68268eafd$exports = new URL("lupa.d27de514.png", import.meta.url).toString();


const $1776cf2c45871ed5$var$SearchBar = ()=>{
    const [inputText, setInputText] = (0, $eFMZj.useState)("");
    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
        className: "search-bar",
        children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
            className: "frame",
            children: [
                /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("span", {
                    className: "search",
                    children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($207ee7e68268eafd$exports))),
                        alt: "search"
                    })
                }),
                /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("input", {
                    className: "input",
                    type: "text",
                    placeholder: "Search for books",
                    onChange: (e)=>setInputText(e.target.value),
                    value: inputText
                })
            ]
        })
    });
};
var $1776cf2c45871ed5$export$2e2bcd8739ae039 = $1776cf2c45871ed5$var$SearchBar;


"use strict";
function $5710a213c29d9911$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $e23ec7d1c0feb3a0$var$toString } = Object.prototype;
const { getPrototypeOf: $e23ec7d1c0feb3a0$var$getPrototypeOf } = Object;
const $e23ec7d1c0feb3a0$var$kindOf = ((cache)=>(thing)=>{
        const str = $e23ec7d1c0feb3a0$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $e23ec7d1c0feb3a0$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$e23ec7d1c0feb3a0$var$kindOf(thing) === type;
};
const $e23ec7d1c0feb3a0$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $e23ec7d1c0feb3a0$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isUndefined = $e23ec7d1c0feb3a0$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $e23ec7d1c0feb3a0$var$isBuffer(val) {
    return val !== null && !$e23ec7d1c0feb3a0$var$isUndefined(val) && val.constructor !== null && !$e23ec7d1c0feb3a0$var$isUndefined(val.constructor) && $e23ec7d1c0feb3a0$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isArrayBuffer = $e23ec7d1c0feb3a0$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $e23ec7d1c0feb3a0$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $e23ec7d1c0feb3a0$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isString = $e23ec7d1c0feb3a0$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isFunction = $e23ec7d1c0feb3a0$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isNumber = $e23ec7d1c0feb3a0$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isPlainObject = (val)=>{
    if ($e23ec7d1c0feb3a0$var$kindOf(val) !== "object") return false;
    const prototype = $e23ec7d1c0feb3a0$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isDate = $e23ec7d1c0feb3a0$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isFile = $e23ec7d1c0feb3a0$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isBlob = $e23ec7d1c0feb3a0$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isFileList = $e23ec7d1c0feb3a0$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isStream = (val)=>$e23ec7d1c0feb3a0$var$isObject(val) && $e23ec7d1c0feb3a0$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $e23ec7d1c0feb3a0$var$isFunction(thing.append) && ((kind = $e23ec7d1c0feb3a0$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $e23ec7d1c0feb3a0$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isURLSearchParams = $e23ec7d1c0feb3a0$var$kindOfTest("URLSearchParams");
const [$e23ec7d1c0feb3a0$var$isReadableStream, $e23ec7d1c0feb3a0$var$isRequest, $e23ec7d1c0feb3a0$var$isResponse, $e23ec7d1c0feb3a0$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($e23ec7d1c0feb3a0$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $e23ec7d1c0feb3a0$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $e23ec7d1c0feb3a0$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($e23ec7d1c0feb3a0$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $e23ec7d1c0feb3a0$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $e23ec7d1c0feb3a0$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $e23ec7d1c0feb3a0$var$isContextDefined = (context)=>!$e23ec7d1c0feb3a0$var$isUndefined(context) && context !== $e23ec7d1c0feb3a0$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $e23ec7d1c0feb3a0$var$merge() {
    const { caseless: caseless } = $e23ec7d1c0feb3a0$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $e23ec7d1c0feb3a0$var$findKey(result, key) || key;
        if ($e23ec7d1c0feb3a0$var$isPlainObject(result[targetKey]) && $e23ec7d1c0feb3a0$var$isPlainObject(val)) result[targetKey] = $e23ec7d1c0feb3a0$var$merge(result[targetKey], val);
        else if ($e23ec7d1c0feb3a0$var$isPlainObject(val)) result[targetKey] = $e23ec7d1c0feb3a0$var$merge({}, val);
        else if ($e23ec7d1c0feb3a0$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $e23ec7d1c0feb3a0$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $e23ec7d1c0feb3a0$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $e23ec7d1c0feb3a0$var$forEach(b, (val, key)=>{
        if (thisArg && $e23ec7d1c0feb3a0$var$isFunction(val)) a[key] = (0, $5710a213c29d9911$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $e23ec7d1c0feb3a0$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $e23ec7d1c0feb3a0$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $e23ec7d1c0feb3a0$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $e23ec7d1c0feb3a0$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $e23ec7d1c0feb3a0$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $e23ec7d1c0feb3a0$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($e23ec7d1c0feb3a0$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$e23ec7d1c0feb3a0$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $e23ec7d1c0feb3a0$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $e23ec7d1c0feb3a0$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $e23ec7d1c0feb3a0$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $e23ec7d1c0feb3a0$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $e23ec7d1c0feb3a0$var$isHTMLForm = $e23ec7d1c0feb3a0$var$kindOfTest("HTMLFormElement");
const $e23ec7d1c0feb3a0$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $e23ec7d1c0feb3a0$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $e23ec7d1c0feb3a0$var$isRegExp = $e23ec7d1c0feb3a0$var$kindOfTest("RegExp");
const $e23ec7d1c0feb3a0$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $e23ec7d1c0feb3a0$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $e23ec7d1c0feb3a0$var$freezeMethods = (obj)=>{
    $e23ec7d1c0feb3a0$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($e23ec7d1c0feb3a0$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$e23ec7d1c0feb3a0$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $e23ec7d1c0feb3a0$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $e23ec7d1c0feb3a0$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $e23ec7d1c0feb3a0$var$noop = ()=>{};
const $e23ec7d1c0feb3a0$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $e23ec7d1c0feb3a0$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $e23ec7d1c0feb3a0$var$DIGIT = "0123456789";
const $e23ec7d1c0feb3a0$var$ALPHABET = {
    DIGIT: $e23ec7d1c0feb3a0$var$DIGIT,
    ALPHA: $e23ec7d1c0feb3a0$var$ALPHA,
    ALPHA_DIGIT: $e23ec7d1c0feb3a0$var$ALPHA + $e23ec7d1c0feb3a0$var$ALPHA.toUpperCase() + $e23ec7d1c0feb3a0$var$DIGIT
};
const $e23ec7d1c0feb3a0$var$generateString = (size = 16, alphabet = $e23ec7d1c0feb3a0$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $e23ec7d1c0feb3a0$var$isSpecCompliantForm(thing) {
    return !!(thing && $e23ec7d1c0feb3a0$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $e23ec7d1c0feb3a0$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($e23ec7d1c0feb3a0$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $e23ec7d1c0feb3a0$var$isArray(source) ? [] : {};
                $e23ec7d1c0feb3a0$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$e23ec7d1c0feb3a0$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $e23ec7d1c0feb3a0$var$isAsyncFn = $e23ec7d1c0feb3a0$var$kindOfTest("AsyncFunction");
const $e23ec7d1c0feb3a0$var$isThenable = (thing)=>thing && ($e23ec7d1c0feb3a0$var$isObject(thing) || $e23ec7d1c0feb3a0$var$isFunction(thing)) && $e23ec7d1c0feb3a0$var$isFunction(thing.then) && $e23ec7d1c0feb3a0$var$isFunction(thing.catch);
var $e23ec7d1c0feb3a0$export$2e2bcd8739ae039 = {
    isArray: $e23ec7d1c0feb3a0$var$isArray,
    isArrayBuffer: $e23ec7d1c0feb3a0$var$isArrayBuffer,
    isBuffer: $e23ec7d1c0feb3a0$var$isBuffer,
    isFormData: $e23ec7d1c0feb3a0$var$isFormData,
    isArrayBufferView: $e23ec7d1c0feb3a0$var$isArrayBufferView,
    isString: $e23ec7d1c0feb3a0$var$isString,
    isNumber: $e23ec7d1c0feb3a0$var$isNumber,
    isBoolean: $e23ec7d1c0feb3a0$var$isBoolean,
    isObject: $e23ec7d1c0feb3a0$var$isObject,
    isPlainObject: $e23ec7d1c0feb3a0$var$isPlainObject,
    isReadableStream: $e23ec7d1c0feb3a0$var$isReadableStream,
    isRequest: $e23ec7d1c0feb3a0$var$isRequest,
    isResponse: $e23ec7d1c0feb3a0$var$isResponse,
    isHeaders: $e23ec7d1c0feb3a0$var$isHeaders,
    isUndefined: $e23ec7d1c0feb3a0$var$isUndefined,
    isDate: $e23ec7d1c0feb3a0$var$isDate,
    isFile: $e23ec7d1c0feb3a0$var$isFile,
    isBlob: $e23ec7d1c0feb3a0$var$isBlob,
    isRegExp: $e23ec7d1c0feb3a0$var$isRegExp,
    isFunction: $e23ec7d1c0feb3a0$var$isFunction,
    isStream: $e23ec7d1c0feb3a0$var$isStream,
    isURLSearchParams: $e23ec7d1c0feb3a0$var$isURLSearchParams,
    isTypedArray: $e23ec7d1c0feb3a0$var$isTypedArray,
    isFileList: $e23ec7d1c0feb3a0$var$isFileList,
    forEach: $e23ec7d1c0feb3a0$var$forEach,
    merge: $e23ec7d1c0feb3a0$var$merge,
    extend: $e23ec7d1c0feb3a0$var$extend,
    trim: $e23ec7d1c0feb3a0$var$trim,
    stripBOM: $e23ec7d1c0feb3a0$var$stripBOM,
    inherits: $e23ec7d1c0feb3a0$var$inherits,
    toFlatObject: $e23ec7d1c0feb3a0$var$toFlatObject,
    kindOf: $e23ec7d1c0feb3a0$var$kindOf,
    kindOfTest: $e23ec7d1c0feb3a0$var$kindOfTest,
    endsWith: $e23ec7d1c0feb3a0$var$endsWith,
    toArray: $e23ec7d1c0feb3a0$var$toArray,
    forEachEntry: $e23ec7d1c0feb3a0$var$forEachEntry,
    matchAll: $e23ec7d1c0feb3a0$var$matchAll,
    isHTMLForm: $e23ec7d1c0feb3a0$var$isHTMLForm,
    hasOwnProperty: $e23ec7d1c0feb3a0$var$hasOwnProperty,
    hasOwnProp: $e23ec7d1c0feb3a0$var$hasOwnProperty,
    reduceDescriptors: $e23ec7d1c0feb3a0$var$reduceDescriptors,
    freezeMethods: $e23ec7d1c0feb3a0$var$freezeMethods,
    toObjectSet: $e23ec7d1c0feb3a0$var$toObjectSet,
    toCamelCase: $e23ec7d1c0feb3a0$var$toCamelCase,
    noop: $e23ec7d1c0feb3a0$var$noop,
    toFiniteNumber: $e23ec7d1c0feb3a0$var$toFiniteNumber,
    findKey: $e23ec7d1c0feb3a0$var$findKey,
    global: $e23ec7d1c0feb3a0$var$_global,
    isContextDefined: $e23ec7d1c0feb3a0$var$isContextDefined,
    ALPHABET: $e23ec7d1c0feb3a0$var$ALPHABET,
    generateString: $e23ec7d1c0feb3a0$var$generateString,
    isSpecCompliantForm: $e23ec7d1c0feb3a0$var$isSpecCompliantForm,
    toJSONObject: $e23ec7d1c0feb3a0$var$toJSONObject,
    isAsyncFn: $e23ec7d1c0feb3a0$var$isAsyncFn,
    isThenable: $e23ec7d1c0feb3a0$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $fb451e42496c1980$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).inherits($fb451e42496c1980$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $fb451e42496c1980$var$prototype = $fb451e42496c1980$var$AxiosError.prototype;
const $fb451e42496c1980$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $fb451e42496c1980$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($fb451e42496c1980$var$AxiosError, $fb451e42496c1980$var$descriptors);
Object.defineProperty($fb451e42496c1980$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$fb451e42496c1980$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($fb451e42496c1980$var$prototype);
    (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $fb451e42496c1980$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $fb451e42496c1980$export$2e2bcd8739ae039 = $fb451e42496c1980$var$AxiosError;


// eslint-disable-next-line strict
var $867ea35d7d21822e$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ab4981a981433a56$export$a143d493d941bafc;
var $ab4981a981433a56$export$e4cf37d7f6fb9e0a;
var $ab4981a981433a56$export$f99ded8fe4b79145;
var $ab4981a981433a56$export$599f31c3813fae4d;
"use strict";
var $3978bffb083aad49$export$a48f0734ac7c2329;
var $3978bffb083aad49$export$d622b2ad8d90c771;
var $3978bffb083aad49$export$6100ba28696e12de;
"use strict";
$3978bffb083aad49$export$a48f0734ac7c2329 = $3978bffb083aad49$var$byteLength;
$3978bffb083aad49$export$d622b2ad8d90c771 = $3978bffb083aad49$var$toByteArray;
$3978bffb083aad49$export$6100ba28696e12de = $3978bffb083aad49$var$fromByteArray;
var $3978bffb083aad49$var$lookup = [];
var $3978bffb083aad49$var$revLookup = [];
var $3978bffb083aad49$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3978bffb083aad49$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3978bffb083aad49$var$i = 0, $3978bffb083aad49$var$len = $3978bffb083aad49$var$code.length; $3978bffb083aad49$var$i < $3978bffb083aad49$var$len; ++$3978bffb083aad49$var$i){
    $3978bffb083aad49$var$lookup[$3978bffb083aad49$var$i] = $3978bffb083aad49$var$code[$3978bffb083aad49$var$i];
    $3978bffb083aad49$var$revLookup[$3978bffb083aad49$var$code.charCodeAt($3978bffb083aad49$var$i)] = $3978bffb083aad49$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3978bffb083aad49$var$revLookup["-".charCodeAt(0)] = 62;
$3978bffb083aad49$var$revLookup["_".charCodeAt(0)] = 63;
function $3978bffb083aad49$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3978bffb083aad49$var$byteLength(b64) {
    var lens = $3978bffb083aad49$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3978bffb083aad49$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3978bffb083aad49$var$toByteArray(b64) {
    var tmp;
    var lens = $3978bffb083aad49$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3978bffb083aad49$var$Arr($3978bffb083aad49$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3978bffb083aad49$var$revLookup[b64.charCodeAt(i)] << 18 | $3978bffb083aad49$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3978bffb083aad49$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3978bffb083aad49$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3978bffb083aad49$var$revLookup[b64.charCodeAt(i)] << 2 | $3978bffb083aad49$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3978bffb083aad49$var$revLookup[b64.charCodeAt(i)] << 10 | $3978bffb083aad49$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3978bffb083aad49$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3978bffb083aad49$var$tripletToBase64(num) {
    return $3978bffb083aad49$var$lookup[num >> 18 & 0x3F] + $3978bffb083aad49$var$lookup[num >> 12 & 0x3F] + $3978bffb083aad49$var$lookup[num >> 6 & 0x3F] + $3978bffb083aad49$var$lookup[num & 0x3F];
}
function $3978bffb083aad49$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3978bffb083aad49$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3978bffb083aad49$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3978bffb083aad49$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3978bffb083aad49$var$lookup[tmp >> 2] + $3978bffb083aad49$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3978bffb083aad49$var$lookup[tmp >> 10] + $3978bffb083aad49$var$lookup[tmp >> 4 & 0x3F] + $3978bffb083aad49$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $cfa3e86d9f9f28d7$export$aafa59e2e03f2942;
var $cfa3e86d9f9f28d7$export$68d8715fc104d294;
$cfa3e86d9f9f28d7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$cfa3e86d9f9f28d7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $ab4981a981433a56$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$ab4981a981433a56$export$a143d493d941bafc = $ab4981a981433a56$var$Buffer;
$ab4981a981433a56$export$e4cf37d7f6fb9e0a = $ab4981a981433a56$var$SlowBuffer;
$ab4981a981433a56$export$f99ded8fe4b79145 = 50;
const $ab4981a981433a56$var$K_MAX_LENGTH = 0x7fffffff;
$ab4981a981433a56$export$599f31c3813fae4d = $ab4981a981433a56$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ab4981a981433a56$var$Buffer.TYPED_ARRAY_SUPPORT = $ab4981a981433a56$var$typedArraySupport();
if (!$ab4981a981433a56$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ab4981a981433a56$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ab4981a981433a56$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$ab4981a981433a56$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ab4981a981433a56$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$ab4981a981433a56$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ab4981a981433a56$var$createBuffer(length) {
    if (length > $ab4981a981433a56$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ab4981a981433a56$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ab4981a981433a56$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ab4981a981433a56$var$allocUnsafe(arg);
    }
    return $ab4981a981433a56$var$from(arg, encodingOrOffset, length);
}
$ab4981a981433a56$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ab4981a981433a56$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $ab4981a981433a56$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ab4981a981433a56$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ab4981a981433a56$var$isInstance(value, ArrayBuffer) || value && $ab4981a981433a56$var$isInstance(value.buffer, ArrayBuffer)) return $ab4981a981433a56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($ab4981a981433a56$var$isInstance(value, SharedArrayBuffer) || value && $ab4981a981433a56$var$isInstance(value.buffer, SharedArrayBuffer))) return $ab4981a981433a56$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ab4981a981433a56$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $ab4981a981433a56$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $ab4981a981433a56$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ab4981a981433a56$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ab4981a981433a56$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ab4981a981433a56$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ab4981a981433a56$var$Buffer, Uint8Array);
function $ab4981a981433a56$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ab4981a981433a56$var$alloc(size, fill, encoding) {
    $ab4981a981433a56$var$assertSize(size);
    if (size <= 0) return $ab4981a981433a56$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $ab4981a981433a56$var$createBuffer(size).fill(fill, encoding) : $ab4981a981433a56$var$createBuffer(size).fill(fill);
    return $ab4981a981433a56$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ab4981a981433a56$var$Buffer.alloc = function(size, fill, encoding) {
    return $ab4981a981433a56$var$alloc(size, fill, encoding);
};
function $ab4981a981433a56$var$allocUnsafe(size) {
    $ab4981a981433a56$var$assertSize(size);
    return $ab4981a981433a56$var$createBuffer(size < 0 ? 0 : $ab4981a981433a56$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ab4981a981433a56$var$Buffer.allocUnsafe = function(size) {
    return $ab4981a981433a56$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ab4981a981433a56$var$Buffer.allocUnsafeSlow = function(size) {
    return $ab4981a981433a56$var$allocUnsafe(size);
};
function $ab4981a981433a56$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$ab4981a981433a56$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $ab4981a981433a56$var$byteLength(string, encoding) | 0;
    let buf = $ab4981a981433a56$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ab4981a981433a56$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $ab4981a981433a56$var$checked(array.length) | 0;
    const buf = $ab4981a981433a56$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ab4981a981433a56$var$fromArrayView(arrayView) {
    if ($ab4981a981433a56$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $ab4981a981433a56$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ab4981a981433a56$var$fromArrayLike(arrayView);
}
function $ab4981a981433a56$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ab4981a981433a56$var$Buffer.prototype);
    return buf;
}
function $ab4981a981433a56$var$fromObject(obj) {
    if ($ab4981a981433a56$var$Buffer.isBuffer(obj)) {
        const len = $ab4981a981433a56$var$checked(obj.length) | 0;
        const buf = $ab4981a981433a56$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $ab4981a981433a56$var$numberIsNaN(obj.length)) return $ab4981a981433a56$var$createBuffer(0);
        return $ab4981a981433a56$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $ab4981a981433a56$var$fromArrayLike(obj.data);
}
function $ab4981a981433a56$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ab4981a981433a56$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ab4981a981433a56$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $ab4981a981433a56$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ab4981a981433a56$var$Buffer.alloc(+length);
}
$ab4981a981433a56$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ab4981a981433a56$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ab4981a981433a56$var$Buffer.compare = function compare(a, b) {
    if ($ab4981a981433a56$var$isInstance(a, Uint8Array)) a = $ab4981a981433a56$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ab4981a981433a56$var$isInstance(b, Uint8Array)) b = $ab4981a981433a56$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ab4981a981433a56$var$Buffer.isBuffer(a) || !$ab4981a981433a56$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ab4981a981433a56$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$ab4981a981433a56$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ab4981a981433a56$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $ab4981a981433a56$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($ab4981a981433a56$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ab4981a981433a56$var$Buffer.isBuffer(buf)) buf = $ab4981a981433a56$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ab4981a981433a56$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ab4981a981433a56$var$byteLength(string, encoding) {
    if ($ab4981a981433a56$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ab4981a981433a56$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $ab4981a981433a56$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $ab4981a981433a56$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ab4981a981433a56$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ab4981a981433a56$var$Buffer.byteLength = $ab4981a981433a56$var$byteLength;
function $ab4981a981433a56$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $ab4981a981433a56$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $ab4981a981433a56$var$utf8Slice(this, start, end);
        case "ascii":
            return $ab4981a981433a56$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $ab4981a981433a56$var$latin1Slice(this, start, end);
        case "base64":
            return $ab4981a981433a56$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ab4981a981433a56$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ab4981a981433a56$var$Buffer.prototype._isBuffer = true;
function $ab4981a981433a56$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ab4981a981433a56$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$ab4981a981433a56$var$swap(this, i, i + 1);
    return this;
};
$ab4981a981433a56$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $ab4981a981433a56$var$swap(this, i, i + 3);
        $ab4981a981433a56$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ab4981a981433a56$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $ab4981a981433a56$var$swap(this, i, i + 7);
        $ab4981a981433a56$var$swap(this, i + 1, i + 6);
        $ab4981a981433a56$var$swap(this, i + 2, i + 5);
        $ab4981a981433a56$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ab4981a981433a56$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $ab4981a981433a56$var$utf8Slice(this, 0, length);
    return $ab4981a981433a56$var$slowToString.apply(this, arguments);
};
$ab4981a981433a56$var$Buffer.prototype.toLocaleString = $ab4981a981433a56$var$Buffer.prototype.toString;
$ab4981a981433a56$var$Buffer.prototype.equals = function equals(b) {
    if (!$ab4981a981433a56$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $ab4981a981433a56$var$Buffer.compare(this, b) === 0;
};
$ab4981a981433a56$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $ab4981a981433a56$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($ab4981a981433a56$var$customInspectSymbol) $ab4981a981433a56$var$Buffer.prototype[$ab4981a981433a56$var$customInspectSymbol] = $ab4981a981433a56$var$Buffer.prototype.inspect;
$ab4981a981433a56$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ab4981a981433a56$var$isInstance(target, Uint8Array)) target = $ab4981a981433a56$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ab4981a981433a56$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ab4981a981433a56$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ab4981a981433a56$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $ab4981a981433a56$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ab4981a981433a56$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ab4981a981433a56$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ab4981a981433a56$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $ab4981a981433a56$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ab4981a981433a56$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ab4981a981433a56$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ab4981a981433a56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ab4981a981433a56$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ab4981a981433a56$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ab4981a981433a56$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ab4981a981433a56$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ab4981a981433a56$var$utf8Write(buf, string, offset, length) {
    return $ab4981a981433a56$var$blitBuffer($ab4981a981433a56$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ab4981a981433a56$var$asciiWrite(buf, string, offset, length) {
    return $ab4981a981433a56$var$blitBuffer($ab4981a981433a56$var$asciiToBytes(string), buf, offset, length);
}
function $ab4981a981433a56$var$base64Write(buf, string, offset, length) {
    return $ab4981a981433a56$var$blitBuffer($ab4981a981433a56$var$base64ToBytes(string), buf, offset, length);
}
function $ab4981a981433a56$var$ucs2Write(buf, string, offset, length) {
    return $ab4981a981433a56$var$blitBuffer($ab4981a981433a56$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ab4981a981433a56$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $ab4981a981433a56$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $ab4981a981433a56$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $ab4981a981433a56$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $ab4981a981433a56$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ab4981a981433a56$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ab4981a981433a56$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ab4981a981433a56$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3978bffb083aad49$export$6100ba28696e12de(buf);
    else return $3978bffb083aad49$export$6100ba28696e12de(buf.slice(start, end));
}
function $ab4981a981433a56$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ab4981a981433a56$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $ab4981a981433a56$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ab4981a981433a56$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $ab4981a981433a56$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ab4981a981433a56$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ab4981a981433a56$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ab4981a981433a56$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ab4981a981433a56$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $ab4981a981433a56$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ab4981a981433a56$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ab4981a981433a56$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ab4981a981433a56$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ab4981a981433a56$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$ab4981a981433a56$var$Buffer.prototype.readUintLE = $ab4981a981433a56$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ab4981a981433a56$var$Buffer.prototype.readUintBE = $ab4981a981433a56$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ab4981a981433a56$var$Buffer.prototype.readUint8 = $ab4981a981433a56$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ab4981a981433a56$var$Buffer.prototype.readUint16LE = $ab4981a981433a56$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ab4981a981433a56$var$Buffer.prototype.readUint16BE = $ab4981a981433a56$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ab4981a981433a56$var$Buffer.prototype.readUint32LE = $ab4981a981433a56$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ab4981a981433a56$var$Buffer.prototype.readUint32BE = $ab4981a981433a56$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ab4981a981433a56$var$Buffer.prototype.readBigUInt64LE = $ab4981a981433a56$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ab4981a981433a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ab4981a981433a56$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ab4981a981433a56$var$Buffer.prototype.readBigUInt64BE = $ab4981a981433a56$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ab4981a981433a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ab4981a981433a56$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ab4981a981433a56$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ab4981a981433a56$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ab4981a981433a56$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ab4981a981433a56$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ab4981a981433a56$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ab4981a981433a56$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ab4981a981433a56$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ab4981a981433a56$var$Buffer.prototype.readBigInt64LE = $ab4981a981433a56$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ab4981a981433a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ab4981a981433a56$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$ab4981a981433a56$var$Buffer.prototype.readBigInt64BE = $ab4981a981433a56$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ab4981a981433a56$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ab4981a981433a56$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$ab4981a981433a56$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 4, this.length);
    return $cfa3e86d9f9f28d7$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$ab4981a981433a56$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 4, this.length);
    return $cfa3e86d9f9f28d7$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$ab4981a981433a56$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 8, this.length);
    return $cfa3e86d9f9f28d7$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$ab4981a981433a56$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkOffset(offset, 8, this.length);
    return $cfa3e86d9f9f28d7$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $ab4981a981433a56$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ab4981a981433a56$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$ab4981a981433a56$var$Buffer.prototype.writeUintLE = $ab4981a981433a56$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ab4981a981433a56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ab4981a981433a56$var$Buffer.prototype.writeUintBE = $ab4981a981433a56$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ab4981a981433a56$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ab4981a981433a56$var$Buffer.prototype.writeUint8 = $ab4981a981433a56$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ab4981a981433a56$var$Buffer.prototype.writeUint16LE = $ab4981a981433a56$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ab4981a981433a56$var$Buffer.prototype.writeUint16BE = $ab4981a981433a56$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ab4981a981433a56$var$Buffer.prototype.writeUint32LE = $ab4981a981433a56$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ab4981a981433a56$var$Buffer.prototype.writeUint32BE = $ab4981a981433a56$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ab4981a981433a56$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ab4981a981433a56$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ab4981a981433a56$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ab4981a981433a56$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ab4981a981433a56$var$Buffer.prototype.writeBigUInt64LE = $ab4981a981433a56$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $ab4981a981433a56$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$ab4981a981433a56$var$Buffer.prototype.writeBigUInt64BE = $ab4981a981433a56$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $ab4981a981433a56$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$ab4981a981433a56$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ab4981a981433a56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ab4981a981433a56$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ab4981a981433a56$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ab4981a981433a56$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ab4981a981433a56$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ab4981a981433a56$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ab4981a981433a56$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ab4981a981433a56$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ab4981a981433a56$var$Buffer.prototype.writeBigInt64LE = $ab4981a981433a56$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $ab4981a981433a56$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$ab4981a981433a56$var$Buffer.prototype.writeBigInt64BE = $ab4981a981433a56$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $ab4981a981433a56$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $ab4981a981433a56$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $ab4981a981433a56$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $cfa3e86d9f9f28d7$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ab4981a981433a56$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ab4981a981433a56$var$writeFloat(this, value, offset, true, noAssert);
};
$ab4981a981433a56$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ab4981a981433a56$var$writeFloat(this, value, offset, false, noAssert);
};
function $ab4981a981433a56$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab4981a981433a56$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $cfa3e86d9f9f28d7$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ab4981a981433a56$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ab4981a981433a56$var$writeDouble(this, value, offset, true, noAssert);
};
$ab4981a981433a56$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ab4981a981433a56$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ab4981a981433a56$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ab4981a981433a56$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ab4981a981433a56$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$ab4981a981433a56$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $ab4981a981433a56$var$Buffer.isBuffer(val) ? val : $ab4981a981433a56$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $ab4981a981433a56$var$errors = {};
function $ab4981a981433a56$var$E(sym, getMessage, Base) {
    $ab4981a981433a56$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$ab4981a981433a56$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$ab4981a981433a56$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$ab4981a981433a56$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $ab4981a981433a56$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $ab4981a981433a56$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $ab4981a981433a56$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $ab4981a981433a56$var$checkBounds(buf, offset, byteLength) {
    $ab4981a981433a56$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ab4981a981433a56$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ab4981a981433a56$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $ab4981a981433a56$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $ab4981a981433a56$var$checkBounds(buf, offset, byteLength);
}
function $ab4981a981433a56$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $ab4981a981433a56$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $ab4981a981433a56$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ab4981a981433a56$var$validateNumber(value, type);
        throw new $ab4981a981433a56$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $ab4981a981433a56$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ab4981a981433a56$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $ab4981a981433a56$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ab4981a981433a56$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ab4981a981433a56$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $ab4981a981433a56$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $ab4981a981433a56$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ab4981a981433a56$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ab4981a981433a56$var$base64ToBytes(str) {
    return $3978bffb083aad49$export$d622b2ad8d90c771($ab4981a981433a56$var$base64clean(str));
}
function $ab4981a981433a56$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ab4981a981433a56$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ab4981a981433a56$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $ab4981a981433a56$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ab4981a981433a56$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $ab4981a981433a56$var$BufferBigIntNotDefined : fn;
}
function $ab4981a981433a56$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $bd9adef957ea6bd7$require$Buffer = $ab4981a981433a56$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $bd9adef957ea6bd7$var$isVisitable(thing) {
    return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $bd9adef957ea6bd7$var$removeBrackets(key) {
    return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $bd9adef957ea6bd7$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $bd9adef957ea6bd7$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $bd9adef957ea6bd7$var$isFlatArray(arr) {
    return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(arr) && !arr.some($bd9adef957ea6bd7$var$isVisitable);
}
const $bd9adef957ea6bd7$var$predicates = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toFlatObject((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $bd9adef957ea6bd7$var$toFormData(obj, formData, options) {
    if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $867ea35d7d21822e$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $bd9adef957ea6bd7$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(value) && $bd9adef957ea6bd7$var$isFlatArray(value) || ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFileList(value) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $bd9adef957ea6bd7$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $bd9adef957ea6bd7$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($bd9adef957ea6bd7$var$isVisitable(value)) return true;
        formData.append($bd9adef957ea6bd7$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($bd9adef957ea6bd7$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $bd9adef957ea6bd7$var$isVisitable
    });
    function build(value, path) {
        if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $bd9adef957ea6bd7$export$2e2bcd8739ae039 = $bd9adef957ea6bd7$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $3d937dc925e535a8$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $3d937dc925e535a8$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $bd9adef957ea6bd7$export$2e2bcd8739ae039)(params, this, options);
}
const $3d937dc925e535a8$var$prototype = $3d937dc925e535a8$var$AxiosURLSearchParams.prototype;
$3d937dc925e535a8$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$3d937dc925e535a8$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $3d937dc925e535a8$var$encode);
    } : $3d937dc925e535a8$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $3d937dc925e535a8$export$2e2bcd8739ae039 = $3d937dc925e535a8$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $88475219083cdfe4$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $88475219083cdfe4$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $88475219083cdfe4$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $3d937dc925e535a8$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $c7ccc3c4a57a8df1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $c7ccc3c4a57a8df1$export$2e2bcd8739ae039 = $c7ccc3c4a57a8df1$var$InterceptorManager;





"use strict";
var $bed711272f380336$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $c206a033afe0440f$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $3d937dc925e535a8$export$2e2bcd8739ae039);


"use strict";
var $e0e0104f161432d4$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $b732a57b804ab7ea$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2ab4bbae78217f79$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $c206a033afe0440f$export$2e2bcd8739ae039,
        FormData: $e0e0104f161432d4$export$2e2bcd8739ae039,
        Blob: $b732a57b804ab7ea$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $74b155127b84468b$exports = {};

$parcel$export($74b155127b84468b$exports, "hasBrowserEnv", () => $74b155127b84468b$export$c4996c4b7b93b0bf);
$parcel$export($74b155127b84468b$exports, "hasStandardBrowserEnv", () => $74b155127b84468b$export$c0bcc9250309d66);
$parcel$export($74b155127b84468b$exports, "hasStandardBrowserWebWorkerEnv", () => $74b155127b84468b$export$c81692cf5af97dac);
$parcel$export($74b155127b84468b$exports, "origin", () => $74b155127b84468b$export$f710a83a91838a36);
const $74b155127b84468b$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $74b155127b84468b$export$c0bcc9250309d66 = ((product)=>{
    return $74b155127b84468b$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $74b155127b84468b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $74b155127b84468b$export$f710a83a91838a36 = $74b155127b84468b$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $9cb8955fa65ad13b$export$2e2bcd8739ae039 = {
    ...$74b155127b84468b$exports,
    ...(0, $2ab4bbae78217f79$export$2e2bcd8739ae039)
};


"use strict";
function $875aeae9bb06bacd$export$2e2bcd8739ae039(data, options) {
    return (0, $bd9adef957ea6bd7$export$2e2bcd8739ae039)(data, new (0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).isNode && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $c74f89a612444218$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $c74f89a612444218$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $c74f89a612444218$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $c74f89a612444218$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFormData(formData) && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($c74f89a612444218$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $c74f89a612444218$export$2e2bcd8739ae039 = $c74f89a612444218$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $39796557f86162f7$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $39796557f86162f7$var$defaults = {
    transitional: (0, $bed711272f380336$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $c74f89a612444218$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isBuffer(data) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isStream(data) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFile(data) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isBlob(data) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $875aeae9bb06bacd$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $bd9adef957ea6bd7$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $39796557f86162f7$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $39796557f86162f7$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isResponse(data) || (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $fb451e42496c1980$export$2e2bcd8739ae039).from(e, (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $39796557f86162f7$var$defaults.headers[method] = {};
});
var $39796557f86162f7$export$2e2bcd8739ae039 = $39796557f86162f7$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $6a995fae6359148a$var$ignoreDuplicateOf = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $6a995fae6359148a$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $6a995fae6359148a$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $d139d8624c3c3d31$var$$internals = Symbol("internals");
function $d139d8624c3c3d31$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $d139d8624c3c3d31$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(value) ? value.map($d139d8624c3c3d31$var$normalizeValue) : String(value);
}
function $d139d8624c3c3d31$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $d139d8624c3c3d31$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $d139d8624c3c3d31$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $d139d8624c3c3d31$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $d139d8624c3c3d31$var$buildAccessors(obj, header) {
    const accessorName = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $d139d8624c3c3d31$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $d139d8624c3c3d31$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $d139d8624c3c3d31$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$d139d8624c3c3d31$var$isValidHeaderName(header)) setHeaders((0, $6a995fae6359148a$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $d139d8624c3c3d31$var$normalizeHeader(header);
        if (header) {
            const key = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $d139d8624c3c3d31$var$parseTokens(value);
                if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $d139d8624c3c3d31$var$normalizeHeader(header);
        if (header) {
            const key = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $d139d8624c3c3d31$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $d139d8624c3c3d31$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $d139d8624c3c3d31$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $d139d8624c3c3d31$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $d139d8624c3c3d31$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $d139d8624c3c3d31$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $d139d8624c3c3d31$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$d139d8624c3c3d31$var$$internals] = this[$d139d8624c3c3d31$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $d139d8624c3c3d31$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $d139d8624c3c3d31$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$d139d8624c3c3d31$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).reduceDescriptors($d139d8624c3c3d31$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).freezeMethods($d139d8624c3c3d31$var$AxiosHeaders);
var $d139d8624c3c3d31$export$2e2bcd8739ae039 = $d139d8624c3c3d31$var$AxiosHeaders;


"use strict";
function $822c76a1bb2f59ab$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $39796557f86162f7$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $cf3b9ebe03bac229$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $377db19232dbf117$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $fb451e42496c1980$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).inherits($377db19232dbf117$var$CanceledError, (0, $fb451e42496c1980$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $377db19232dbf117$export$2e2bcd8739ae039 = $377db19232dbf117$var$CanceledError;







"use strict";
function $f826a78bb5722cc1$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $8675de3ad1124da8$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $bb56c22cc9c9b915$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $bb56c22cc9c9b915$export$2e2bcd8739ae039 = $bb56c22cc9c9b915$var$speedometer;


"use strict";
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $45141caed1105a53$var$throttle(fn, freq) {
    let timestamp = 0;
    const threshold = 1000 / freq;
    let timer = null;
    return function throttled() {
        const force = this === true;
        const now = Date.now();
        if (force || now - timestamp > threshold) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timestamp = now;
            return fn.apply(null, arguments);
        }
        if (!timer) timer = setTimeout(()=>{
            timer = null;
            timestamp = Date.now();
            return fn.apply(null, arguments);
        }, threshold - (now - timestamp));
    };
}
var $45141caed1105a53$export$2e2bcd8739ae039 = $45141caed1105a53$var$throttle;


var $96ed50d91e67228b$export$2e2bcd8739ae039 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $bb56c22cc9c9b915$export$2e2bcd8739ae039)(50, 250);
    return (0, $45141caed1105a53$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    }, freq);
};






"use strict";
var $137a4cfffd4c1a99$export$2e2bcd8739ae039 = (0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $10978feaa8dbdcba$export$2e2bcd8739ae039 = (0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $ce0bbf38e358a42d$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $df768182dce4aba1$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $7dc7a0ba20978630$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $ce0bbf38e358a42d$export$2e2bcd8739ae039)(requestedURL)) return (0, $df768182dce4aba1$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $7d88907664272480$var$headersToObject = (thing)=>thing instanceof (0, $d139d8624c3c3d31$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $7d88907664272480$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isPlainObject(target) && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($7d88907664272480$var$headersToObject(a), $7d88907664272480$var$headersToObject(b), true)
    };
    (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $2c07beb00fc0d3a5$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $7d88907664272480$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $88475219083cdfe4$export$2e2bcd8739ae039)((0, $7dc7a0ba20978630$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $137a4cfffd4c1a99$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $10978feaa8dbdcba$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $340438476b4f7d95$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $340438476b4f7d95$export$2e2bcd8739ae039 = $340438476b4f7d95$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $2c07beb00fc0d3a5$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType } = _config;
        let onCanceled;
        function done() {
            if (_config.cancelToken) _config.cancelToken.unsubscribe(onCanceled);
            if (_config.signal) _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $f826a78bb5722cc1$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("Request aborted", (0, $fb451e42496c1980$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("Network Error", (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_NETWORK, _config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $bed711272f380336$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $fb451e42496c1980$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $fb451e42496c1980$export$2e2bcd8739ae039).ETIMEDOUT : (0, $fb451e42496c1980$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (typeof _config.onDownloadProgress === "function") request.addEventListener("progress", (0, $96ed50d91e67228b$export$2e2bcd8739ae039)(_config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof _config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", (0, $96ed50d91e67228b$export$2e2bcd8739ae039)(_config.onUploadProgress));
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $377db19232dbf117$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $8675de3ad1124da8$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $291b5b946c09779f$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $fb451e42496c1980$export$2e2bcd8739ae039) ? err : new (0, $377db19232dbf117$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $fb451e42496c1980$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $fb451e42496c1980$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $291b5b946c09779f$export$2e2bcd8739ae039 = $291b5b946c09779f$var$composeSignals;


const $8fda49c11113f6c3$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $8fda49c11113f6c3$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $8fda49c11113f6c3$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $8fda49c11113f6c3$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $8fda49c11113f6c3$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    return new ReadableStream({
        type: "bytes",
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                controller.close();
                onFinish();
                return;
            }
            let len = value.byteLength;
            onProgress && onProgress(bytes += len);
            controller.enqueue(new Uint8Array(value));
        },
        cancel (reason) {
            onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $de8db1b6050514fd$var$fetchProgressDecorator = (total, fn)=>{
    const lengthComputable = total != null;
    return (loaded)=>setTimeout(()=>fn({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }));
};
const $de8db1b6050514fd$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $de8db1b6050514fd$var$isReadableStreamSupported = $de8db1b6050514fd$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $de8db1b6050514fd$var$encodeText = $de8db1b6050514fd$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $de8db1b6050514fd$var$supportsRequestStream = $de8db1b6050514fd$var$isReadableStreamSupported && (()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $9cb8955fa65ad13b$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $de8db1b6050514fd$var$DEFAULT_CHUNK_SIZE = 65536;
const $de8db1b6050514fd$var$supportsResponseStream = $de8db1b6050514fd$var$isReadableStreamSupported && !!(()=>{
    try {
        return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
    } catch (err) {
    // return undefined
    }
})();
const $de8db1b6050514fd$var$resolvers = {
    stream: $de8db1b6050514fd$var$supportsResponseStream && ((res)=>res.body)
};
$de8db1b6050514fd$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$de8db1b6050514fd$var$resolvers[type] && ($de8db1b6050514fd$var$resolvers[type] = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $de8db1b6050514fd$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArrayBufferView(body)) return body.byteLength;
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(body)) return (await $de8db1b6050514fd$var$encodeText(body)).byteLength;
};
const $de8db1b6050514fd$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $de8db1b6050514fd$var$getBodyLength(body) : length;
};
var $de8db1b6050514fd$export$2e2bcd8739ae039 = $de8db1b6050514fd$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $2c07beb00fc0d3a5$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $291b5b946c09779f$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $de8db1b6050514fd$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $de8db1b6050514fd$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) data = (0, $8fda49c11113f6c3$export$b0119225647bd83)(_request.body, $de8db1b6050514fd$var$DEFAULT_CHUNK_SIZE, $de8db1b6050514fd$var$fetchProgressDecorator(requestContentLength, (0, $96ed50d91e67228b$export$2e2bcd8739ae039)(onUploadProgress)), null, $de8db1b6050514fd$var$encodeText);
        }
        if (!(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "cors" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            withCredentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $de8db1b6050514fd$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($de8db1b6050514fd$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            response = new Response((0, $8fda49c11113f6c3$export$b0119225647bd83)(response.body, $de8db1b6050514fd$var$DEFAULT_CHUNK_SIZE, onDownloadProgress && $de8db1b6050514fd$var$fetchProgressDecorator(responseContentLength, (0, $96ed50d91e67228b$export$2e2bcd8739ae039)(onDownloadProgress, true)), isStreamResponse && onFinish, $de8db1b6050514fd$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $de8db1b6050514fd$var$resolvers[(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).findKey($de8db1b6050514fd$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $f826a78bb5722cc1$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("Network Error", (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $fb451e42496c1980$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $afbbab284bad51cf$var$knownAdapters = {
    http: (0, $867ea35d7d21822e$export$2e2bcd8739ae039),
    xhr: (0, $340438476b4f7d95$export$2e2bcd8739ae039),
    fetch: (0, $de8db1b6050514fd$export$2e2bcd8739ae039)
};
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach($afbbab284bad51cf$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $afbbab284bad51cf$var$renderReason = (reason)=>`- ${reason}`;
const $afbbab284bad51cf$var$isResolvedHandle = (adapter)=>(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $afbbab284bad51cf$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$afbbab284bad51cf$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $afbbab284bad51cf$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($afbbab284bad51cf$var$renderReason).join("\n") : " " + $afbbab284bad51cf$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $afbbab284bad51cf$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $bb8d5d583e4fa878$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $377db19232dbf117$export$2e2bcd8739ae039)(null, config);
}
function $bb8d5d583e4fa878$export$2e2bcd8739ae039(config) {
    $bb8d5d583e4fa878$var$throwIfCancellationRequested(config);
    config.headers = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $822c76a1bb2f59ab$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $afbbab284bad51cf$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $39796557f86162f7$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $bb8d5d583e4fa878$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $822c76a1bb2f59ab$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $cf3b9ebe03bac229$export$2e2bcd8739ae039)(reason)) {
            $bb8d5d583e4fa878$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $822c76a1bb2f59ab$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $c1d478370f60cc00$export$a4ad2735b021c132 = "1.7.2";



"use strict";
const $60ae2cd977d73afb$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $60ae2cd977d73afb$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $60ae2cd977d73afb$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $60ae2cd977d73afb$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $c1d478370f60cc00$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$60ae2cd977d73afb$var$deprecatedWarnings[opt]) {
            $60ae2cd977d73afb$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $60ae2cd977d73afb$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("options must be an object", (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $fb451e42496c1980$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $fb451e42496c1980$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $60ae2cd977d73afb$export$2e2bcd8739ae039 = {
    assertOptions: $60ae2cd977d73afb$var$assertOptions,
    validators: $60ae2cd977d73afb$var$validators
};



"use strict";
const $edd3baac6362bb6f$var$validators = (0, $60ae2cd977d73afb$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $edd3baac6362bb6f$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $c7ccc3c4a57a8df1$export$2e2bcd8739ae039)(),
            response: new (0, $c7ccc3c4a57a8df1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $7d88907664272480$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $60ae2cd977d73afb$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $edd3baac6362bb6f$var$validators.transitional($edd3baac6362bb6f$var$validators.boolean),
            forcedJSONParsing: $edd3baac6362bb6f$var$validators.transitional($edd3baac6362bb6f$var$validators.boolean),
            clarifyTimeoutError: $edd3baac6362bb6f$var$validators.transitional($edd3baac6362bb6f$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $60ae2cd977d73afb$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $edd3baac6362bb6f$var$validators.function,
                serialize: $edd3baac6362bb6f$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $bb8d5d583e4fa878$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $bb8d5d583e4fa878$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $7d88907664272480$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $7dc7a0ba20978630$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $88475219083cdfe4$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $edd3baac6362bb6f$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $7d88907664272480$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $7d88907664272480$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $edd3baac6362bb6f$var$Axios.prototype[method] = generateHTTPMethod();
    $edd3baac6362bb6f$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $edd3baac6362bb6f$export$2e2bcd8739ae039 = $edd3baac6362bb6f$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $ac94e4dcf86c2fcc$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $377db19232dbf117$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $ac94e4dcf86c2fcc$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $ac94e4dcf86c2fcc$export$2e2bcd8739ae039 = $ac94e4dcf86c2fcc$var$CancelToken;






"use strict";
function $6ba073bf4c45c4cd$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $7075dd963f9b4df3$export$2e2bcd8739ae039(payload) {
    return (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $8b1df385f2aaeabb$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($8b1df385f2aaeabb$var$HttpStatusCode).forEach(([key, value])=>{
    $8b1df385f2aaeabb$var$HttpStatusCode[value] = key;
});
var $8b1df385f2aaeabb$export$2e2bcd8739ae039 = $8b1df385f2aaeabb$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $0009911253f185b5$var$createInstance(defaultConfig) {
    const context = new (0, $edd3baac6362bb6f$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $5710a213c29d9911$export$2e2bcd8739ae039)((0, $edd3baac6362bb6f$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).extend(instance, (0, $edd3baac6362bb6f$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $0009911253f185b5$var$createInstance((0, $7d88907664272480$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $0009911253f185b5$var$axios = $0009911253f185b5$var$createInstance((0, $39796557f86162f7$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$0009911253f185b5$var$axios.Axios = (0, $edd3baac6362bb6f$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$0009911253f185b5$var$axios.CanceledError = (0, $377db19232dbf117$export$2e2bcd8739ae039);
$0009911253f185b5$var$axios.CancelToken = (0, $ac94e4dcf86c2fcc$export$2e2bcd8739ae039);
$0009911253f185b5$var$axios.isCancel = (0, $cf3b9ebe03bac229$export$2e2bcd8739ae039);
$0009911253f185b5$var$axios.VERSION = (0, $c1d478370f60cc00$export$a4ad2735b021c132);
$0009911253f185b5$var$axios.toFormData = (0, $bd9adef957ea6bd7$export$2e2bcd8739ae039);
// Expose AxiosError class
$0009911253f185b5$var$axios.AxiosError = (0, $fb451e42496c1980$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$0009911253f185b5$var$axios.Cancel = $0009911253f185b5$var$axios.CanceledError;
// Expose all/spread
$0009911253f185b5$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$0009911253f185b5$var$axios.spread = (0, $6ba073bf4c45c4cd$export$2e2bcd8739ae039);
// Expose isAxiosError
$0009911253f185b5$var$axios.isAxiosError = (0, $7075dd963f9b4df3$export$2e2bcd8739ae039);
// Expose mergeConfig
$0009911253f185b5$var$axios.mergeConfig = (0, $7d88907664272480$export$2e2bcd8739ae039);
$0009911253f185b5$var$axios.AxiosHeaders = (0, $d139d8624c3c3d31$export$2e2bcd8739ae039);
$0009911253f185b5$var$axios.formToJSON = (thing)=>(0, $c74f89a612444218$export$2e2bcd8739ae039)((0, $e23ec7d1c0feb3a0$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$0009911253f185b5$var$axios.getAdapter = (0, $afbbab284bad51cf$export$2e2bcd8739ae039).getAdapter;
$0009911253f185b5$var$axios.HttpStatusCode = (0, $8b1df385f2aaeabb$export$2e2bcd8739ae039);
$0009911253f185b5$var$axios.default = $0009911253f185b5$var$axios;
var // this module should only have a default export
$0009911253f185b5$export$2e2bcd8739ae039 = $0009911253f185b5$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $ab3f4e589643de6f$export$1c00760e9e5a4e95, AxiosError: $ab3f4e589643de6f$export$c1fbed17c2f6a328, CanceledError: $ab3f4e589643de6f$export$1ab0c6b20d94fa14, isCancel: $ab3f4e589643de6f$export$3b22524397b493c6, CancelToken: $ab3f4e589643de6f$export$fd08e3cb425f0d61, VERSION: $ab3f4e589643de6f$export$a4ad2735b021c132, all: $ab3f4e589643de6f$export$84bf76cd7afc7469, Cancel: $ab3f4e589643de6f$export$848c9b7ead0df967, isAxiosError: $ab3f4e589643de6f$export$fbafdbe06a5b5a9a, spread: $ab3f4e589643de6f$export$3ae0fd4797ed47c8, toFormData: $ab3f4e589643de6f$export$10ae0d317ea97f8b, AxiosHeaders: $ab3f4e589643de6f$export$4e7d6ff0f3e6520, HttpStatusCode: $ab3f4e589643de6f$export$a972f69c851492b3, formToJSON: $ab3f4e589643de6f$export$86d7c59254d6a2c9, getAdapter: $ab3f4e589643de6f$export$17ddc20a97d669e2, mergeConfig: $ab3f4e589643de6f$export$7ec1ebcfa9d8bd6a } = (0, $0009911253f185b5$export$2e2bcd8739ae039);


const $55a38ce22f7d50c0$export$37b96ba04a8c05d1 = "/api/v1/";
const $55a38ce22f7d50c0$var$instance = (0, $0009911253f185b5$export$2e2bcd8739ae039).create({
    baseURL: $55a38ce22f7d50c0$export$37b96ba04a8c05d1
});
var $55a38ce22f7d50c0$export$2e2bcd8739ae039 = $55a38ce22f7d50c0$var$instance;


const $a64b320130750adf$export$4c7d1278a60f36b1 = async ()=>{
    try {
        return await (0, $55a38ce22f7d50c0$export$2e2bcd8739ae039).get("/books/tracked");
    } catch (error) {
        console.error(error);
    }
};
const $a64b320130750adf$export$be7c2acc48adceee = async (id)=>{
    try {
        return await (0, $55a38ce22f7d50c0$export$2e2bcd8739ae039).get(`/books/tracked/${id}`);
    } catch (error) {
        console.error(error);
    }
};
const $a64b320130750adf$export$c6bbc0ad86b096be = async (id)=>{
    try {
        return await (0, $55a38ce22f7d50c0$export$2e2bcd8739ae039).get(`/books/prices/${id}`);
    } catch (error) {
        console.log(error);
    }
};
const $a64b320130750adf$export$1dfe6134a9c18c04 = async (book, dateRange, sellers)=>{
    const sellersIDString = sellers.map((seller)=>seller.id).join("^");
    const sellersNameString = sellers.map((seller)=>seller.name).join(",");
    try {
        const response = await (0, $55a38ce22f7d50c0$export$2e2bcd8739ae039).get(`/excel/${book.id}/${dateRange}/${sellersIDString}`, {
            responseType: "blob"
        });
        const url = window.URL.createObjectURL(new Blob([
            response.data
        ]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${book.title}: ${dateRange} : ${sellersNameString}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error(error);
    }
};



const $cfbb0f1268b8f04e$var$LandingPage = ()=>{
    const [books, setBooks] = (0, $eFMZj.useState)([]);
    const navigate = (0, $72fa3923970c35a7$export$9770f232ac06a008)();
    (0, $eFMZj.useEffect)(()=>{
        const fetchBooks = async ()=>{
            const response = await (0, $a64b320130750adf$export$4c7d1278a60f36b1)();
            setBooks(response.data);
        };
        fetchBooks();
    }, []);
    if (!books) return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $1776cf2c45871ed5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                className: "book-tiles",
                children: books.map((book)=>{
                    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                        onClick: ()=>navigate(`/bookDetails/${book.title}_${book.id}`, {
                                state: {
                                    book: book
                                }
                            }),
                        children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                            className: "book-tile",
                            children: book.title
                        }, book.id)
                    });
                })
            })
        ]
    });
};
var $cfbb0f1268b8f04e$export$2e2bcd8739ae039 = $cfbb0f1268b8f04e$var$LandingPage;



const $e61a02728d045410$var$AddNewBooks = ()=>{
    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
        children: "Add New Books"
    });
};
var $e61a02728d045410$export$2e2bcd8739ae039 = $e61a02728d045410$var$AddNewBooks;



const $ffce6c52262ee78e$var$MyBookstores = ()=>{
    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
        children: "MyBookstores"
    });
};
var $ffce6c52262ee78e$export$2e2bcd8739ae039 = $ffce6c52262ee78e$var$MyBookstores;




var $eFMZj = parcelRequire("eFMZj");

var $8a5fbc940731a38b$exports = {};
$8a5fbc940731a38b$exports = new URL("Arrow3.990271fc.png", import.meta.url).toString();




const $8d9070921b077ed1$export$b24c985f13a29127 = async (ids)=>{
    try {
        return await (0, $55a38ce22f7d50c0$export$2e2bcd8739ae039).get(`/sellers/${ids}`);
    } catch (error) {
        console.error(error);
    }
};



parcelRequire("eFMZj");
/*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $7d9b3a2168c16436$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $7d9b3a2168c16436$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $7d9b3a2168c16436$export$bcc6e673dfa14d36(v) {
    return $7d9b3a2168c16436$export$837ba5c449269406($7d9b3a2168c16436$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $7d9b3a2168c16436$export$869b26d4e1bbdb63(v) {
    return $7d9b3a2168c16436$export$837ba5c449269406($7d9b3a2168c16436$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $7d9b3a2168c16436$export$ed9bd8dcaeba14f6(v) {
    return $7d9b3a2168c16436$export$837ba5c449269406($7d9b3a2168c16436$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $7d9b3a2168c16436$export$dbf961a8d278dbef(v) {
    return $7d9b3a2168c16436$export$837ba5c449269406($7d9b3a2168c16436$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $7d9b3a2168c16436$export$aa35ef1f24408ab9(v) {
    return $7d9b3a2168c16436$export$837ba5c449269406($7d9b3a2168c16436$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $7d9b3a2168c16436$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $7d9b3a2168c16436$var$hex = [
    ..."0123456789ABCDEF"
];
const $7d9b3a2168c16436$var$h1 = (b)=>$7d9b3a2168c16436$var$hex[b & 0xF];
const $7d9b3a2168c16436$var$h2 = (b)=>$7d9b3a2168c16436$var$hex[(b & 0xF0) >> 4] + $7d9b3a2168c16436$var$hex[b & 0xF];
const $7d9b3a2168c16436$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $7d9b3a2168c16436$var$isShort = (v)=>$7d9b3a2168c16436$var$eq(v.r) && $7d9b3a2168c16436$var$eq(v.g) && $7d9b3a2168c16436$var$eq(v.b) && $7d9b3a2168c16436$var$eq(v.a);
function $7d9b3a2168c16436$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $7d9b3a2168c16436$var$map$1[str[1]] * 17,
            g: 255 & $7d9b3a2168c16436$var$map$1[str[2]] * 17,
            b: 255 & $7d9b3a2168c16436$var$map$1[str[3]] * 17,
            a: len === 5 ? $7d9b3a2168c16436$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $7d9b3a2168c16436$var$map$1[str[1]] << 4 | $7d9b3a2168c16436$var$map$1[str[2]],
            g: $7d9b3a2168c16436$var$map$1[str[3]] << 4 | $7d9b3a2168c16436$var$map$1[str[4]],
            b: $7d9b3a2168c16436$var$map$1[str[5]] << 4 | $7d9b3a2168c16436$var$map$1[str[6]],
            a: len === 9 ? $7d9b3a2168c16436$var$map$1[str[7]] << 4 | $7d9b3a2168c16436$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $7d9b3a2168c16436$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $7d9b3a2168c16436$export$1b06654353ef9f67(v) {
    var f = $7d9b3a2168c16436$var$isShort(v) ? $7d9b3a2168c16436$var$h1 : $7d9b3a2168c16436$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $7d9b3a2168c16436$var$alpha(v.a, f) : undefined;
}
const $7d9b3a2168c16436$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $7d9b3a2168c16436$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $7d9b3a2168c16436$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $7d9b3a2168c16436$var$hwb2rgbn(h, w, b) {
    const rgb = $7d9b3a2168c16436$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $7d9b3a2168c16436$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $7d9b3a2168c16436$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $7d9b3a2168c16436$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $7d9b3a2168c16436$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($7d9b3a2168c16436$export$ed9bd8dcaeba14f6);
}
function $7d9b3a2168c16436$export$4c15bd42559b811d(h, s, l) {
    return $7d9b3a2168c16436$var$calln($7d9b3a2168c16436$var$hsl2rgbn, h, s, l);
}
function $7d9b3a2168c16436$export$e2710022c70fc9ee(h, w, b) {
    return $7d9b3a2168c16436$var$calln($7d9b3a2168c16436$var$hwb2rgbn, h, w, b);
}
function $7d9b3a2168c16436$export$b785a357c84e4a04(h, s, v) {
    return $7d9b3a2168c16436$var$calln($7d9b3a2168c16436$var$hsv2rgbn, h, s, v);
}
function $7d9b3a2168c16436$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $7d9b3a2168c16436$export$5e91288c399be4f9(str) {
    const m = $7d9b3a2168c16436$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $7d9b3a2168c16436$export$bcc6e673dfa14d36(+m[5]) : $7d9b3a2168c16436$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $7d9b3a2168c16436$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $7d9b3a2168c16436$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === "hsv") v = $7d9b3a2168c16436$export$b785a357c84e4a04(h, p1, p2);
    else v = $7d9b3a2168c16436$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $7d9b3a2168c16436$export$bb628a54ab399bc9(v, deg) {
    var h = $7d9b3a2168c16436$export$b5ba70b240f8f7f(v);
    h[0] = $7d9b3a2168c16436$var$hue(h[0] + deg);
    h = $7d9b3a2168c16436$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $7d9b3a2168c16436$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $7d9b3a2168c16436$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $7d9b3a2168c16436$export$aa35ef1f24408ab9(a[1]);
    const l = $7d9b3a2168c16436$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$7d9b3a2168c16436$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $7d9b3a2168c16436$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $7d9b3a2168c16436$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $7d9b3a2168c16436$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($7d9b3a2168c16436$var$names$1);
    const tkeys = Object.keys($7d9b3a2168c16436$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $7d9b3a2168c16436$var$map[k]);
        }
        k = parseInt($7d9b3a2168c16436$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $7d9b3a2168c16436$var$names;
function $7d9b3a2168c16436$export$b2f06b640faad956(str) {
    if (!$7d9b3a2168c16436$var$names) {
        $7d9b3a2168c16436$var$names = $7d9b3a2168c16436$var$unpack();
        $7d9b3a2168c16436$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $7d9b3a2168c16436$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $7d9b3a2168c16436$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $7d9b3a2168c16436$export$91aedb20f296e541(str) {
    const m = $7d9b3a2168c16436$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $7d9b3a2168c16436$export$bcc6e673dfa14d36(v) : $7d9b3a2168c16436$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $7d9b3a2168c16436$export$bcc6e673dfa14d36(r) : $7d9b3a2168c16436$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $7d9b3a2168c16436$export$bcc6e673dfa14d36(g) : $7d9b3a2168c16436$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $7d9b3a2168c16436$export$bcc6e673dfa14d36(b) : $7d9b3a2168c16436$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $7d9b3a2168c16436$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$7d9b3a2168c16436$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $7d9b3a2168c16436$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $7d9b3a2168c16436$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $7d9b3a2168c16436$var$interpolate(rgb1, rgb2, t) {
    const r = $7d9b3a2168c16436$var$from($7d9b3a2168c16436$export$dbf961a8d278dbef(rgb1.r));
    const g = $7d9b3a2168c16436$var$from($7d9b3a2168c16436$export$dbf961a8d278dbef(rgb1.g));
    const b = $7d9b3a2168c16436$var$from($7d9b3a2168c16436$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $7d9b3a2168c16436$export$ed9bd8dcaeba14f6($7d9b3a2168c16436$var$to(r + t * ($7d9b3a2168c16436$var$from($7d9b3a2168c16436$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $7d9b3a2168c16436$export$ed9bd8dcaeba14f6($7d9b3a2168c16436$var$to(g + t * ($7d9b3a2168c16436$var$from($7d9b3a2168c16436$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $7d9b3a2168c16436$export$ed9bd8dcaeba14f6($7d9b3a2168c16436$var$to(b + t * ($7d9b3a2168c16436$var$from($7d9b3a2168c16436$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $7d9b3a2168c16436$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $7d9b3a2168c16436$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $7d9b3a2168c16436$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $7d9b3a2168c16436$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $7d9b3a2168c16436$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $7d9b3a2168c16436$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $7d9b3a2168c16436$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $7d9b3a2168c16436$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $7d9b3a2168c16436$var$functionParse(str) {
    if (str.charAt(0) === "r") return $7d9b3a2168c16436$export$91aedb20f296e541(str);
    return $7d9b3a2168c16436$export$5e91288c399be4f9(str);
}
class $7d9b3a2168c16436$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $7d9b3a2168c16436$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $7d9b3a2168c16436$var$fromObject(input);
        else if (type === "string") v = $7d9b3a2168c16436$export$625a38b961e8b5e9(input) || $7d9b3a2168c16436$export$b2f06b640faad956(input) || $7d9b3a2168c16436$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $7d9b3a2168c16436$var$clone(this._rgb);
        if (v) v.a = $7d9b3a2168c16436$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $7d9b3a2168c16436$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $7d9b3a2168c16436$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $7d9b3a2168c16436$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $7d9b3a2168c16436$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $7d9b3a2168c16436$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $7d9b3a2168c16436$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $7d9b3a2168c16436$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $7d9b3a2168c16436$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $7d9b3a2168c16436$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $7d9b3a2168c16436$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $7d9b3a2168c16436$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $7d9b3a2168c16436$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $7d9b3a2168c16436$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $7d9b3a2168c16436$export$2e2bcd8739ae039(input) {
    return new $7d9b3a2168c16436$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $22594696cd565665$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $22594696cd565665$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $22594696cd565665$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $22594696cd565665$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $22594696cd565665$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $22594696cd565665$export$39b482c5e57630a8(value) {
    return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $22594696cd565665$export$c4ce752e73470fba(value, defaultValue) {
    return $22594696cd565665$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $22594696cd565665$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $22594696cd565665$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
const $22594696cd565665$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $22594696cd565665$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $22594696cd565665$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($22594696cd565665$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($22594696cd565665$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $22594696cd565665$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $22594696cd565665$export$d377dcb2b61d6c4e(source) {
    if ($22594696cd565665$export$8b22cf2602fb60ce(source)) return source.map($22594696cd565665$export$d377dcb2b61d6c4e);
    if ($22594696cd565665$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $22594696cd565665$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $22594696cd565665$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $22594696cd565665$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$22594696cd565665$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($22594696cd565665$export$23f2a1d2818174ef(tval) && $22594696cd565665$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $22594696cd565665$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $22594696cd565665$export$d377dcb2b61d6c4e(sval);
}
function $22594696cd565665$export$efca4cbe5dd06740(target, source, options) {
    const sources = $22594696cd565665$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$22594696cd565665$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $22594696cd565665$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$22594696cd565665$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $22594696cd565665$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $22594696cd565665$export$efca4cbe5dd06740(target, source, {
        merger: $22594696cd565665$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $22594696cd565665$export$317a3d46287192d8(key, target, source) {
    if (!$22594696cd565665$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($22594696cd565665$export$23f2a1d2818174ef(tval) && $22594696cd565665$export$23f2a1d2818174ef(sval)) $22594696cd565665$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $22594696cd565665$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $22594696cd565665$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $22594696cd565665$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    "": (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $22594696cd565665$export$9d0e2d13d04f7070(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $22594696cd565665$var$_getKeyResolver(key) {
    const keys = $22594696cd565665$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $22594696cd565665$export$2d1720544b23b823(obj, key) {
    const resolver = $22594696cd565665$var$keyResolvers[key] || ($22594696cd565665$var$keyResolvers[key] = $22594696cd565665$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $22594696cd565665$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $22594696cd565665$export$dda1d9f60106f0e9 = (value)=>typeof value !== "undefined";
const $22594696cd565665$export$a93c5207d687da10 = (value)=>typeof value === "function";
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $22594696cd565665$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $22594696cd565665$export$f38c853ae54ed474(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $22594696cd565665$export$56c0d5a1e737357d = Math.PI;
const $22594696cd565665$export$971d5caa766a69d7 = 2 * $22594696cd565665$export$56c0d5a1e737357d;
const $22594696cd565665$export$d29e374196577086 = $22594696cd565665$export$971d5caa766a69d7 + $22594696cd565665$export$56c0d5a1e737357d;
const $22594696cd565665$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $22594696cd565665$export$53c86fa97d611818 = $22594696cd565665$export$56c0d5a1e737357d / 180;
const $22594696cd565665$export$7f8ddf7c7c20b3cd = $22594696cd565665$export$56c0d5a1e737357d / 2;
const $22594696cd565665$export$39c1cc7c062529d4 = $22594696cd565665$export$56c0d5a1e737357d / 4;
const $22594696cd565665$export$7a0bdf7d4a91ea88 = $22594696cd565665$export$56c0d5a1e737357d * 2 / 3;
const $22594696cd565665$export$9f4f30ee63539e24 = Math.log10;
const $22594696cd565665$export$2408f22a0fab9ae5 = Math.sign;
function $22594696cd565665$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $22594696cd565665$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $22594696cd565665$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($22594696cd565665$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $22594696cd565665$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $22594696cd565665$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $22594696cd565665$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $22594696cd565665$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $22594696cd565665$export$625550452a3fa3ec(degrees) {
    return degrees * ($22594696cd565665$export$56c0d5a1e737357d / 180);
}
function $22594696cd565665$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $22594696cd565665$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $22594696cd565665$export$23ebac1979863676(x) {
    if (!$22594696cd565665$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $22594696cd565665$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $22594696cd565665$export$56c0d5a1e737357d) angle += $22594696cd565665$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $22594696cd565665$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $22594696cd565665$export$c18d01048907ea92(a, b) {
    return (a - b + $22594696cd565665$export$d29e374196577086) % $22594696cd565665$export$971d5caa766a69d7 - $22594696cd565665$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $22594696cd565665$export$28f7fcd39efa255(a) {
    return (a % $22594696cd565665$export$971d5caa766a69d7 + $22594696cd565665$export$971d5caa766a69d7) % $22594696cd565665$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $22594696cd565665$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $22594696cd565665$export$28f7fcd39efa255(angle);
    const s = $22594696cd565665$export$28f7fcd39efa255(start);
    const e = $22594696cd565665$export$28f7fcd39efa255(end);
    const angleToStart = $22594696cd565665$export$28f7fcd39efa255(s - a);
    const angleToEnd = $22594696cd565665$export$28f7fcd39efa255(e - a);
    const startToAngle = $22594696cd565665$export$28f7fcd39efa255(a - s);
    const endToAngle = $22594696cd565665$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $22594696cd565665$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $22594696cd565665$export$71cec2538cb2c617(value) {
    return $22594696cd565665$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $22594696cd565665$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $22594696cd565665$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $22594696cd565665$export$ef35774e6d314e91 = (table, key, value, last)=>$22594696cd565665$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $22594696cd565665$export$ebd11618f299a286 = (table, key, value)=>$22594696cd565665$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $22594696cd565665$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $22594696cd565665$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $22594696cd565665$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $22594696cd565665$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $22594696cd565665$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $22594696cd565665$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $22594696cd565665$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $22594696cd565665$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $22594696cd565665$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
/**
* Request animation polyfill
*/ const $22594696cd565665$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $22594696cd565665$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $22594696cd565665$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $22594696cd565665$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $22594696cd565665$export$3c2fa207a37baaea = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $22594696cd565665$export$ce26c07117d59d6a = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $22594696cd565665$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $22594696cd565665$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $22594696cd565665$export$25ce5a424b770e84(Math.min($22594696cd565665$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $22594696cd565665$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $22594696cd565665$export$25ce5a424b770e84(Math.max($22594696cd565665$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $22594696cd565665$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $22594696cd565665$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $22594696cd565665$var$atEdge = (t)=>t === 0 || t === 1;
const $22594696cd565665$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $22594696cd565665$export$971d5caa766a69d7 / p));
const $22594696cd565665$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $22594696cd565665$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $22594696cd565665$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $22594696cd565665$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $22594696cd565665$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($22594696cd565665$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$22594696cd565665$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$22594696cd565665$var$atEdge(t) ? t : $22594696cd565665$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$22594696cd565665$var$atEdge(t) ? t : $22594696cd565665$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $22594696cd565665$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $22594696cd565665$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $22594696cd565665$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $22594696cd565665$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $22594696cd565665$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $22594696cd565665$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $22594696cd565665$export$f96d196f7728bb5(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $22594696cd565665$export$db3b6bfb95261072(value) {
    return $22594696cd565665$export$f96d196f7728bb5(value) ? value : new (0, $7d9b3a2168c16436$export$892596cec99bc70e)(value);
}
function $22594696cd565665$export$738ab4df8bf92ae9(value) {
    return $22594696cd565665$export$f96d196f7728bb5(value) ? value : new (0, $7d9b3a2168c16436$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $22594696cd565665$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $22594696cd565665$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
function $22594696cd565665$var$applyAnimationsDefaults(defaults) {
    defaults.set("animation", {
        delay: undefined,
        duration: 1000,
        easing: "easeOutQuart",
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe("animation", {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
    });
    defaults.set("animations", {
        colors: {
            type: "color",
            properties: $22594696cd565665$var$colors
        },
        numbers: {
            type: "number",
            properties: $22594696cd565665$var$numbers
        }
    });
    defaults.describe("animations", {
        _fallback: "animation"
    });
    defaults.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $22594696cd565665$var$applyLayoutsDefaults(defaults) {
    defaults.set("layout", {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $22594696cd565665$var$intlCache = new Map();
function $22594696cd565665$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $22594696cd565665$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $22594696cd565665$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $22594696cd565665$export$ae1af26003f05816(num, locale, options) {
    return $22594696cd565665$var$getNumberFormat(locale, options).format(num);
}
const $22594696cd565665$var$formatters = {
    values (value) {
        return $22594696cd565665$export$8b22cf2602fb60ce(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $22594696cd565665$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $22594696cd565665$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $22594696cd565665$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($22594696cd565665$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $22594696cd565665$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $22594696cd565665$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $22594696cd565665$export$91477dc880baac21 = {
    formatters: $22594696cd565665$var$formatters
};
function $22594696cd565665$var$applyScaleDefaults(defaults) {
    defaults.set("scale", {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: "ticks",
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $22594696cd565665$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: false,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    });
    defaults.route("scale.ticks", "color", "", "color");
    defaults.route("scale.grid", "color", "", "borderColor");
    defaults.route("scale.border", "color", "", "borderColor");
    defaults.route("scale.title", "color", "", "color");
    defaults.describe("scale", {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
        _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
    });
    defaults.describe("scales", {
        _fallback: "scale"
    });
    defaults.describe("scale.ticks", {
        _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
        _indexable: (name)=>name !== "backdropPadding"
    });
}
const $22594696cd565665$export$6559d589eb85fbb6 = Object.create(null);
const $22594696cd565665$export$2e2af4578d910ddf = Object.create(null);
function $22594696cd565665$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $22594696cd565665$var$set(root, scope, values) {
    if (typeof scope === "string") return $22594696cd565665$export$efca4cbe5dd06740($22594696cd565665$var$getScope$1(root, scope), values);
    return $22594696cd565665$export$efca4cbe5dd06740($22594696cd565665$var$getScope$1(root, ""), scope);
}
class $22594696cd565665$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$22594696cd565665$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$22594696cd565665$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$22594696cd565665$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $22594696cd565665$var$set(this, scope, values);
    }
    get(scope) {
        return $22594696cd565665$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $22594696cd565665$var$set($22594696cd565665$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $22594696cd565665$var$set($22594696cd565665$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $22594696cd565665$var$getScope$1(this, scope);
        const targetScopeObject = $22594696cd565665$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($22594696cd565665$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $22594696cd565665$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $22594696cd565665$export$4368d992c4eafac0 = /* #__PURE__ */ new $22594696cd565665$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $22594696cd565665$var$applyAnimationsDefaults,
    $22594696cd565665$var$applyLayoutsDefaults,
    $22594696cd565665$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $22594696cd565665$export$1a8f5705751d8277(font) {
    if (!font || $22594696cd565665$export$342063e11d6c3cad(font.size) || $22594696cd565665$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
/**
 * @private
 */ function $22594696cd565665$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $22594696cd565665$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$22594696cd565665$export$8b22cf2602fb60ce(thing)) longest = $22594696cd565665$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($22594696cd565665$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$22594696cd565665$export$8b22cf2602fb60ce(nestedThing)) longest = $22594696cd565665$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $22594696cd565665$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $22594696cd565665$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $22594696cd565665$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $22594696cd565665$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $22594696cd565665$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $22594696cd565665$export$53c86fa97d611818;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $22594696cd565665$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $22594696cd565665$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $22594696cd565665$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $22594696cd565665$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $22594696cd565665$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $22594696cd565665$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $22594696cd565665$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $22594696cd565665$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $22594696cd565665$export$56c0d5a1e737357d, rad - $22594696cd565665$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $22594696cd565665$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $22594696cd565665$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $22594696cd565665$export$7f8ddf7c7c20b3cd, rad + $22594696cd565665$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $22594696cd565665$export$39c1cc7c062529d4;
        /* falls through */ case "rectRot":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $22594696cd565665$export$39c1cc7c062529d4;
        /* falls through */ case "cross":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "star":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $22594696cd565665$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $22594696cd565665$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $22594696cd565665$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $22594696cd565665$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $22594696cd565665$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $22594696cd565665$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $22594696cd565665$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$22594696cd565665$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $22594696cd565665$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $22594696cd565665$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $22594696cd565665$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $22594696cd565665$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $22594696cd565665$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $22594696cd565665$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$22594696cd565665$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $22594696cd565665$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $22594696cd565665$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $22594696cd565665$export$56c0d5a1e737357d, $22594696cd565665$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $22594696cd565665$export$56c0d5a1e737357d, $22594696cd565665$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $22594696cd565665$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$22594696cd565665$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $22594696cd565665$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $22594696cd565665$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $22594696cd565665$export$8c78c7c36408ea29(value, size) {
    const matches = ("" + value).match($22594696cd565665$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $22594696cd565665$var$numberOrZero = (v)=>+v || 0;
function $22594696cd565665$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $22594696cd565665$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $22594696cd565665$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$22594696cd565665$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $22594696cd565665$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $22594696cd565665$export$d66dc83d8cfc8dd(value) {
    return $22594696cd565665$export$21579262ef46735b(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $22594696cd565665$export$92108d983e8ee699(value) {
    return $22594696cd565665$export$21579262ef46735b(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $22594696cd565665$export$a9c23c6ac3fc3eca(value) {
    const obj = $22594696cd565665$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $22594696cd565665$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $22594696cd565665$export$4368d992c4eafac0.font;
    let size = $22594696cd565665$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $22594696cd565665$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($22594696cd565665$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $22594696cd565665$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $22594696cd565665$export$8c78c7c36408ea29($22594696cd565665$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $22594696cd565665$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $22594696cd565665$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $22594696cd565665$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $22594696cd565665$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $22594696cd565665$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $22594696cd565665$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $22594696cd565665$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $22594696cd565665$export$a9c996f45e5784d0(scopes, prefixes = [
    ""
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === "undefined") fallback = $22594696cd565665$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$22594696cd565665$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $22594696cd565665$var$_cached(target, prop, ()=>$22594696cd565665$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $22594696cd565665$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $22594696cd565665$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $22594696cd565665$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $22594696cd565665$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$22594696cd565665$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$22594696cd565665$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $22594696cd565665$var$_cached(target, prop, ()=>$22594696cd565665$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $22594696cd565665$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $22594696cd565665$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $22594696cd565665$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $22594696cd565665$var$readKey = (prefix, name)=>prefix ? prefix + $22594696cd565665$export$a8550f7dbe79f93a(name) : name;
const $22594696cd565665$var$needsSubResolver = (prop, value)=>$22594696cd565665$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $22594696cd565665$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === "constructor") return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $22594696cd565665$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($22594696cd565665$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $22594696cd565665$var$_resolveScriptable(prop, value, target, receiver);
    if ($22594696cd565665$export$8b22cf2602fb60ce(value) && value.length) value = $22594696cd565665$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($22594696cd565665$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $22594696cd565665$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $22594696cd565665$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($22594696cd565665$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $22594696cd565665$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $22594696cd565665$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== "undefined" && isIndexable(prop)) return value[_context.index % value.length];
    else if ($22594696cd565665$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $22594696cd565665$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($22594696cd565665$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $22594696cd565665$var$resolveFallback(fallback, prop, value) {
    return $22594696cd565665$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $22594696cd565665$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $22594696cd565665$export$2d1720544b23b823(parent, key) : undefined;
function $22594696cd565665$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $22594696cd565665$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $22594696cd565665$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $22594696cd565665$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $22594696cd565665$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $22594696cd565665$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== "undefined" && fallback !== prop) {
        key = $22594696cd565665$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $22594696cd565665$export$a9c996f45e5784d0(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$22594696cd565665$var$subGetTarget(resolver, prop, value));
}
function $22594696cd565665$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $22594696cd565665$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $22594696cd565665$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($22594696cd565665$export$8b22cf2602fb60ce(target) && $22594696cd565665$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $22594696cd565665$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $22594696cd565665$var$_resolve($22594696cd565665$var$readKey(prefix, prop), scopes);
        if (typeof value !== "undefined") return $22594696cd565665$var$needsSubResolver(prop, value) ? $22594696cd565665$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $22594696cd565665$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== "undefined") return value;
    }
}
function $22594696cd565665$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $22594696cd565665$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $22594696cd565665$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $22594696cd565665$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($22594696cd565665$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $22594696cd565665$var$EPSILON = Number.EPSILON || 1e-14;
const $22594696cd565665$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $22594696cd565665$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $22594696cd565665$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $22594696cd565665$export$158acd800e1ef08b(current, previous);
    const d12 = $22594696cd565665$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $22594696cd565665$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $22594696cd565665$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $22594696cd565665$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($22594696cd565665$export$a05254e7c3aeba6e(deltaK[i], 0, $22594696cd565665$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $22594696cd565665$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $22594696cd565665$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $22594696cd565665$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $22594696cd565665$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $22594696cd565665$export$527e9aa3390079e9(points, indexAxis = "x") {
    const valueAxis = $22594696cd565665$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $22594696cd565665$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $22594696cd565665$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $22594696cd565665$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $22594696cd565665$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $22594696cd565665$var$monotoneAdjust(points, deltaK, mK);
    $22594696cd565665$var$monotoneCompute(points, mK, indexAxis);
}
function $22594696cd565665$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $22594696cd565665$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $22594696cd565665$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $22594696cd565665$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $22594696cd565665$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $22594696cd565665$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $22594696cd565665$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $22594696cd565665$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $22594696cd565665$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $22594696cd565665$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $22594696cd565665$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $22594696cd565665$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $22594696cd565665$export$3a1a48c8f6ef640e() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * @private
 */ function $22594696cd565665$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $22594696cd565665$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $22594696cd565665$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $22594696cd565665$export$a17c37559e1db147(el, property) {
    return $22594696cd565665$var$getComputedStyle(el).getPropertyValue(property);
}
const $22594696cd565665$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $22594696cd565665$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $22594696cd565665$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $22594696cd565665$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $22594696cd565665$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($22594696cd565665$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $22594696cd565665$export$df995fae86a55f06(event, chart) {
    if ("native" in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $22594696cd565665$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $22594696cd565665$var$getPositionedStyle(style, "padding");
    const borders = $22594696cd565665$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $22594696cd565665$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $22594696cd565665$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $22594696cd565665$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $22594696cd565665$var$getComputedStyle(container);
            const containerBorder = $22594696cd565665$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $22594696cd565665$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $22594696cd565665$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $22594696cd565665$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $22594696cd565665$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $22594696cd565665$export$2ec5befb9e6c97d4
    };
}
const $22594696cd565665$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $22594696cd565665$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $22594696cd565665$var$getComputedStyle(canvas);
    const margins = $22594696cd565665$var$getPositionedStyle(style, "margin");
    const maxWidth = $22594696cd565665$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $22594696cd565665$export$2ec5befb9e6c97d4;
    const maxHeight = $22594696cd565665$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $22594696cd565665$export$2ec5befb9e6c97d4;
    const containerSize = $22594696cd565665$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $22594696cd565665$var$getPositionedStyle(style, "border", "width");
        const paddings = $22594696cd565665$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $22594696cd565665$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $22594696cd565665$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $22594696cd565665$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $22594696cd565665$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $22594696cd565665$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $22594696cd565665$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($22594696cd565665$export$3a1a48c8f6ef640e()) {
            window.addEventListener("test", null, options);
            window.removeEventListener("test", null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $22594696cd565665$export$b4171a6734a65d42(element, property) {
    const value = $22594696cd565665$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $22594696cd565665$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $22594696cd565665$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $22594696cd565665$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $22594696cd565665$export$8a5498727ef6be21(p1, cp1, t);
    const b = $22594696cd565665$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $22594696cd565665$export$8a5498727ef6be21(cp2, p2, t);
    const d = $22594696cd565665$export$8a5498727ef6be21(a, b, t);
    const e = $22594696cd565665$export$8a5498727ef6be21(b, c, t);
    return $22594696cd565665$export$8a5498727ef6be21(d, e, t);
}
const $22594696cd565665$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $22594696cd565665$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $22594696cd565665$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $22594696cd565665$var$getRightToLeftAdapter(rectX, width) : $22594696cd565665$var$getLeftToRightAdapter();
}
function $22594696cd565665$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $22594696cd565665$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $22594696cd565665$var$propertyFn(property) {
    if (property === "angle") return {
        between: $22594696cd565665$export$ffb5f4729a158638,
        compare: $22594696cd565665$export$c18d01048907ea92,
        normalize: $22594696cd565665$export$28f7fcd39efa255
    };
    return {
        between: $22594696cd565665$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $22594696cd565665$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $22594696cd565665$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $22594696cd565665$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $22594696cd565665$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $22594696cd565665$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $22594696cd565665$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($22594696cd565665$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($22594696cd565665$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $22594696cd565665$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $22594696cd565665$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $22594696cd565665$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $22594696cd565665$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $22594696cd565665$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $22594696cd565665$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $22594696cd565665$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $22594696cd565665$var$splitByStyles(line, $22594696cd565665$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $22594696cd565665$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $22594696cd565665$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $22594696cd565665$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $22594696cd565665$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $22594696cd565665$var$readStyle(segmentOptions.setContext($22594696cd565665$export$35e795649ee09318(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($22594696cd565665$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $22594696cd565665$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $22594696cd565665$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$22594696cd565665$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}



class $0cf031cb80554143$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $22594696cd565665$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $0cf031cb80554143$export$a424a0aa8f687495 = /* #__PURE__ */ new $0cf031cb80554143$var$Animator();
const $0cf031cb80554143$var$transparent = "transparent";
const $0cf031cb80554143$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $22594696cd565665$export$db3b6bfb95261072)(from || $0cf031cb80554143$var$transparent);
        const c1 = c0.valid && (0, $22594696cd565665$export$db3b6bfb95261072)(to || $0cf031cb80554143$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $0cf031cb80554143$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $22594696cd565665$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $22594696cd565665$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $0cf031cb80554143$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $22594696cd565665$export$f1e1789686576879)[cfg.easing] || (0, $22594696cd565665$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $22594696cd565665$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $22594696cd565665$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $0cf031cb80554143$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $22594696cd565665$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $22594696cd565665$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $22594696cd565665$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $22594696cd565665$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $0cf031cb80554143$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $0cf031cb80554143$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $0cf031cb80554143$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $0cf031cb80554143$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $0cf031cb80554143$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $0cf031cb80554143$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $0cf031cb80554143$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $0cf031cb80554143$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $0cf031cb80554143$var$scaleClip(xScale, allowedOverflow);
    const y = $0cf031cb80554143$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $0cf031cb80554143$var$toClip(value) {
    let t, r, b, l;
    if ((0, $22594696cd565665$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $0cf031cb80554143$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $0cf031cb80554143$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $22594696cd565665$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $22594696cd565665$export$2408f22a0fab9ae5)(value) === (0, $22594696cd565665$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $0cf031cb80554143$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === "x" ? "x" : "y";
    const vAxisKey = vScale.axis === "x" ? "x" : "y";
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $0cf031cb80554143$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $0cf031cb80554143$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $0cf031cb80554143$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $0cf031cb80554143$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $0cf031cb80554143$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $0cf031cb80554143$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $0cf031cb80554143$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $0cf031cb80554143$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $0cf031cb80554143$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $0cf031cb80554143$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $0cf031cb80554143$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $0cf031cb80554143$var$createDatasetContext(parent, index) {
    return (0, $22594696cd565665$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $0cf031cb80554143$var$createDataContext(parent, index, element) {
    return (0, $22594696cd565665$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $0cf031cb80554143$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $0cf031cb80554143$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $0cf031cb80554143$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $0cf031cb80554143$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $0cf031cb80554143$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $0cf031cb80554143$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $0cf031cb80554143$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled("filler")) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $0cf031cb80554143$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $22594696cd565665$export$90a7f3efeed30595)(dataset.xAxisID, $0cf031cb80554143$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $22594696cd565665$export$90a7f3efeed30595)(dataset.yAxisID, $0cf031cb80554143$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $22594696cd565665$export$90a7f3efeed30595)(dataset.rAxisID, $0cf031cb80554143$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $22594696cd565665$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $0cf031cb80554143$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $22594696cd565665$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $0cf031cb80554143$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $22594696cd565665$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $0cf031cb80554143$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $22594696cd565665$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $0cf031cb80554143$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $0cf031cb80554143$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $0cf031cb80554143$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $22594696cd565665$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $22594696cd565665$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $0cf031cb80554143$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $22594696cd565665$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $22594696cd565665$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $0cf031cb80554143$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $0cf031cb80554143$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $0cf031cb80554143$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $0cf031cb80554143$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $0cf031cb80554143$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $22594696cd565665$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $22594696cd565665$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $0cf031cb80554143$var$toClip((0, $22594696cd565665$export$90a7f3efeed30595)(this.options.clip, $0cf031cb80554143$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $0cf031cb80554143$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $0cf031cb80554143$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $22594696cd565665$export$dda1d9f60106f0e9)(index);
        if (cached) return $0cf031cb80554143$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $22594696cd565665$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($0cf031cb80554143$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $0cf031cb80554143$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $0cf031cb80554143$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($0cf031cb80554143$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$0cf031cb80554143$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $0cf031cb80554143$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
function $0cf031cb80554143$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $22594696cd565665$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $0cf031cb80554143$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $0cf031cb80554143$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $22594696cd565665$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $0cf031cb80554143$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $22594696cd565665$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $0cf031cb80554143$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $0cf031cb80554143$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $0cf031cb80554143$var$parseValue(entry, item, vScale, i) {
    if ((0, $22594696cd565665$export$8b22cf2602fb60ce)(entry)) $0cf031cb80554143$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $0cf031cb80554143$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($0cf031cb80554143$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $0cf031cb80554143$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $0cf031cb80554143$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $22594696cd565665$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $0cf031cb80554143$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $0cf031cb80554143$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $0cf031cb80554143$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$0cf031cb80554143$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$0cf031cb80554143$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $0cf031cb80554143$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $0cf031cb80554143$var$swap(edge, a, b);
        edge = $0cf031cb80554143$var$startEnd(edge, b, a);
    } else edge = $0cf031cb80554143$var$startEnd(edge, a, b);
    return edge;
}
function $0cf031cb80554143$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $0cf031cb80554143$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $0cf031cb80554143$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $0cf031cb80554143$export$e97d5dc64e999004 extends $0cf031cb80554143$export$75572ec5c55b4048 {
    static id = "bar";
    static defaults = {
        datasetElementType: false,
        dataElementType: "bar",
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "base",
                    "width",
                    "height"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category",
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: "linear",
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $0cf031cb80554143$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $0cf031cb80554143$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $22594696cd565665$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($0cf031cb80554143$var$parseValue((0, $22594696cd565665$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $0cf031cb80554143$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $22594696cd565665$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $0cf031cb80554143$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $0cf031cb80554143$var$setBorderSkipped(properties, options, stack, index);
            $0cf031cb80554143$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $22594696cd565665$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $0cf031cb80554143$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $0cf031cb80554143$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $22594696cd565665$export$2408f22a0fab9ae5)(value) !== (0, $22594696cd565665$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $22594696cd565665$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $0cf031cb80554143$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $22594696cd565665$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $22594696cd565665$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $0cf031cb80554143$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $0cf031cb80554143$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $0cf031cb80554143$export$19b5c4773f17abe extends $0cf031cb80554143$export$75572ec5c55b4048 {
    static id = "bubble";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "borderWidth",
                    "radius"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $22594696cd565665$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $22594696cd565665$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $22594696cd565665$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $0cf031cb80554143$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $22594696cd565665$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $22594696cd565665$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $22594696cd565665$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $22594696cd565665$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $22594696cd565665$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $22594696cd565665$export$56c0d5a1e737357d) + (0, $22594696cd565665$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $0cf031cb80554143$export$e04603e7d8b77172 extends $0cf031cb80554143$export$75572ec5c55b4048 {
    static id = "doughnut";
    static defaults = {
        datasetElementType: false,
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "circumference",
                    "endAngle",
                    "innerRadius",
                    "outerRadius",
                    "startAngle",
                    "x",
                    "y",
                    "offset",
                    "borderWidth",
                    "spacing"
                ]
            }
        },
        cutout: "50%",
        rotation: 0,
        circumference: 360,
        radius: "100%",
        spacing: 0,
        indexAxis: "r"
    };
    static descriptors = {
        _scriptable: (name)=>name !== "spacing",
        _indexable: (name)=>name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $22594696cd565665$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $22594696cd565665$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $22594696cd565665$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $22594696cd565665$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $22594696cd565665$export$971d5caa766a69d7);
        let max = -(0, $22594696cd565665$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $22594696cd565665$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $0cf031cb80554143$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $22594696cd565665$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $22594696cd565665$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $22594696cd565665$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $22594696cd565665$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $22594696cd565665$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $0cf031cb80554143$export$3c9b5d28c11cbfd0 extends $0cf031cb80554143$export$75572ec5c55b4048 {
    static id = "line";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category"
            },
            _value_: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $22594696cd565665$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $22594696cd565665$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $22594696cd565665$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $22594696cd565665$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $0cf031cb80554143$export$2a270b3a0d973c85 extends $0cf031cb80554143$export$75572ec5c55b4048 {
    static id = "polarArea";
    static defaults = {
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "startAngle",
                    "endAngle",
                    "innerRadius",
                    "outerRadius"
                ]
            }
        },
        indexAxis: "r",
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: "radialLinear",
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $22594696cd565665$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $22594696cd565665$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $22594696cd565665$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $22594696cd565665$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $0cf031cb80554143$export$b21a3f1286706191 extends $0cf031cb80554143$export$e04603e7d8b77172 {
    static id = "pie";
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: "100%"
    };
}
class $0cf031cb80554143$export$48dbc6ac651bf8be extends $0cf031cb80554143$export$75572ec5c55b4048 {
    static id = "radar";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        indexAxis: "r",
        showLine: true,
        elements: {
            line: {
                fill: "start"
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: "radialLinear"
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $22594696cd565665$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $0cf031cb80554143$export$b2f2bae6713db87 extends $0cf031cb80554143$export$75572ec5c55b4048 {
    static id = "scatter";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: "point"
        },
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + ")"
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $22594696cd565665$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $22594696cd565665$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $22594696cd565665$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $22594696cd565665$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $0cf031cb80554143$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $0cf031cb80554143$export$e97d5dc64e999004,
    BubbleController: $0cf031cb80554143$export$19b5c4773f17abe,
    DoughnutController: $0cf031cb80554143$export$e04603e7d8b77172,
    LineController: $0cf031cb80554143$export$3c9b5d28c11cbfd0,
    PieController: $0cf031cb80554143$export$b21a3f1286706191,
    PolarAreaController: $0cf031cb80554143$export$2a270b3a0d973c85,
    RadarController: $0cf031cb80554143$export$48dbc6ac651bf8be,
    ScatterController: $0cf031cb80554143$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $0cf031cb80554143$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $0cf031cb80554143$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($0cf031cb80554143$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $0cf031cb80554143$var$abstract();
    }
    parse() {
        return $0cf031cb80554143$var$abstract();
    }
    format() {
        return $0cf031cb80554143$var$abstract();
    }
    add() {
        return $0cf031cb80554143$var$abstract();
    }
    diff() {
        return $0cf031cb80554143$var$abstract();
    }
    startOf() {
        return $0cf031cb80554143$var$abstract();
    }
    endOf() {
        return $0cf031cb80554143$var$abstract();
    }
}
var $0cf031cb80554143$export$f32766ea09ec8bc4 = {
    _date: $0cf031cb80554143$var$DateAdapterBase
};
function $0cf031cb80554143$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $22594696cd565665$export$ebd11618f299a286) : (0, $22594696cd565665$export$ef35774e6d314e91);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $0cf031cb80554143$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $0cf031cb80554143$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $0cf031cb80554143$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $0cf031cb80554143$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $22594696cd565665$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $0cf031cb80554143$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $0cf031cb80554143$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $22594696cd565665$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $22594696cd565665$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $0cf031cb80554143$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $0cf031cb80554143$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $0cf031cb80554143$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $0cf031cb80554143$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $0cf031cb80554143$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $0cf031cb80554143$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $0cf031cb80554143$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $0cf031cb80554143$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $0cf031cb80554143$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $0cf031cb80554143$export$a13296960cae0384 = {
    evaluateInteractionItems: $0cf031cb80554143$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $22594696cd565665$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $0cf031cb80554143$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $0cf031cb80554143$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $22594696cd565665$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $0cf031cb80554143$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $0cf031cb80554143$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $22594696cd565665$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $0cf031cb80554143$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $22594696cd565665$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $0cf031cb80554143$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $22594696cd565665$export$df995fae86a55f06)(e, chart);
            return $0cf031cb80554143$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $22594696cd565665$export$df995fae86a55f06)(e, chart);
            return $0cf031cb80554143$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $0cf031cb80554143$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $0cf031cb80554143$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $0cf031cb80554143$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$0cf031cb80554143$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $0cf031cb80554143$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $0cf031cb80554143$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $0cf031cb80554143$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$0cf031cb80554143$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $0cf031cb80554143$var$setLayoutDims(layouts, params) {
    const stacks = $0cf031cb80554143$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $0cf031cb80554143$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $0cf031cb80554143$var$wrapBoxes(boxes);
    const fullSize = $0cf031cb80554143$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $0cf031cb80554143$var$sortByWeight($0cf031cb80554143$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $0cf031cb80554143$var$sortByWeight($0cf031cb80554143$var$filterByPosition(layoutBoxes, "right"));
    const top = $0cf031cb80554143$var$sortByWeight($0cf031cb80554143$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $0cf031cb80554143$var$sortByWeight($0cf031cb80554143$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $0cf031cb80554143$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $0cf031cb80554143$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $0cf031cb80554143$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $0cf031cb80554143$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $0cf031cb80554143$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $0cf031cb80554143$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $22594696cd565665$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $0cf031cb80554143$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $0cf031cb80554143$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $0cf031cb80554143$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $0cf031cb80554143$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $0cf031cb80554143$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $0cf031cb80554143$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $0cf031cb80554143$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $0cf031cb80554143$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $0cf031cb80554143$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $0cf031cb80554143$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $0cf031cb80554143$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $22594696cd565665$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $0cf031cb80554143$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $0cf031cb80554143$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $22594696cd565665$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $0cf031cb80554143$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $0cf031cb80554143$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $0cf031cb80554143$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $0cf031cb80554143$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $22594696cd565665$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $0cf031cb80554143$var$updateMaxPadding(maxPadding, (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $0cf031cb80554143$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $0cf031cb80554143$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $0cf031cb80554143$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($0cf031cb80554143$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $0cf031cb80554143$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $0cf031cb80554143$var$handleMaxPadding(chartArea);
        $0cf031cb80554143$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $0cf031cb80554143$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $22594696cd565665$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $0cf031cb80554143$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $0cf031cb80554143$export$a40a96b24b46cf35 extends $0cf031cb80554143$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $0cf031cb80554143$var$EXPANDO_KEY = "$chartjs";
const $0cf031cb80554143$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $0cf031cb80554143$var$isNullOrEmpty = (value)=>value === null || value === "";
function $0cf031cb80554143$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$0cf031cb80554143$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($0cf031cb80554143$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $22594696cd565665$export$b4171a6734a65d42)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($0cf031cb80554143$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $22594696cd565665$export$b4171a6734a65d42)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $0cf031cb80554143$var$eventListenerOptions = (0, $22594696cd565665$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $0cf031cb80554143$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $0cf031cb80554143$var$eventListenerOptions);
}
function $0cf031cb80554143$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $0cf031cb80554143$var$eventListenerOptions);
}
function $0cf031cb80554143$var$fromNativeEvent(event, chart) {
    const type = $0cf031cb80554143$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $22594696cd565665$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $0cf031cb80554143$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $0cf031cb80554143$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $0cf031cb80554143$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$0cf031cb80554143$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $0cf031cb80554143$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $0cf031cb80554143$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$0cf031cb80554143$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $0cf031cb80554143$var$drpListeningCharts = new Map();
let $0cf031cb80554143$var$oldDevicePixelRatio = 0;
function $0cf031cb80554143$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $0cf031cb80554143$var$oldDevicePixelRatio) return;
    $0cf031cb80554143$var$oldDevicePixelRatio = dpr;
    $0cf031cb80554143$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $0cf031cb80554143$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$0cf031cb80554143$var$drpListeningCharts.size) window.addEventListener("resize", $0cf031cb80554143$var$onWindowResize);
    $0cf031cb80554143$var$drpListeningCharts.set(chart, resize);
}
function $0cf031cb80554143$var$unlistenDevicePixelRatioChanges(chart) {
    $0cf031cb80554143$var$drpListeningCharts.delete(chart);
    if (!$0cf031cb80554143$var$drpListeningCharts.size) window.removeEventListener("resize", $0cf031cb80554143$var$onWindowResize);
}
function $0cf031cb80554143$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $22594696cd565665$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $22594696cd565665$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $0cf031cb80554143$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $0cf031cb80554143$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $0cf031cb80554143$var$unlistenDevicePixelRatioChanges(chart);
}
function $0cf031cb80554143$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $22594696cd565665$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($0cf031cb80554143$var$fromNativeEvent(event, chart));
    }, chart);
    $0cf031cb80554143$var$addListener(canvas, type, proxy);
    return proxy;
}
class $0cf031cb80554143$export$f02da7f882cf6b2e extends $0cf031cb80554143$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $0cf031cb80554143$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$0cf031cb80554143$var$EXPANDO_KEY]) return false;
        const initial = canvas[$0cf031cb80554143$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $22594696cd565665$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$0cf031cb80554143$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $0cf031cb80554143$var$createAttachObserver,
            detach: $0cf031cb80554143$var$createDetachObserver,
            resize: $0cf031cb80554143$var$createResizeObserver
        };
        const handler = handlers[type] || $0cf031cb80554143$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $0cf031cb80554143$var$releaseObserver,
            detach: $0cf031cb80554143$var$releaseObserver,
            resize: $0cf031cb80554143$var$releaseObserver
        };
        const handler = handlers[type] || $0cf031cb80554143$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $22594696cd565665$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $22594696cd565665$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $0cf031cb80554143$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $22594696cd565665$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $0cf031cb80554143$export$a40a96b24b46cf35;
    return $0cf031cb80554143$export$f02da7f882cf6b2e;
}
class $0cf031cb80554143$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $22594696cd565665$export$d141bba7fdc215a3)(this.x) && (0, $22594696cd565665$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $0cf031cb80554143$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $0cf031cb80554143$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $0cf031cb80554143$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $0cf031cb80554143$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $0cf031cb80554143$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $0cf031cb80554143$var$skip(ticks, newTicks, spacing, (0, $22594696cd565665$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$0cf031cb80554143$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $0cf031cb80554143$var$skip(ticks, newTicks, spacing, last, (0, $22594696cd565665$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $0cf031cb80554143$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $0cf031cb80554143$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $0cf031cb80554143$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $0cf031cb80554143$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $22594696cd565665$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $0cf031cb80554143$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $0cf031cb80554143$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $0cf031cb80554143$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $22594696cd565665$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $22594696cd565665$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $0cf031cb80554143$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $0cf031cb80554143$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $0cf031cb80554143$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
const $0cf031cb80554143$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $0cf031cb80554143$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $0cf031cb80554143$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $0cf031cb80554143$var$garbageCollect(caches, length) {
    (0, $22594696cd565665$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $0cf031cb80554143$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $0cf031cb80554143$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $22594696cd565665$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $22594696cd565665$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $0cf031cb80554143$var$createScaleContext(parent, scale) {
    return (0, $22594696cd565665$export$35e795649ee09318)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $0cf031cb80554143$var$createTickContext(parent, index, tick) {
    return (0, $22594696cd565665$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $0cf031cb80554143$var$titleAlign(align, position, reverse) {
    let ret = (0, $22594696cd565665$export$3c2fa207a37baaea)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $0cf031cb80554143$var$reverseAlign(ret);
    return ret;
}
function $0cf031cb80554143$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $22594696cd565665$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $0cf031cb80554143$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $22594696cd565665$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $0cf031cb80554143$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === "left" ? -(0, $22594696cd565665$export$7f8ddf7c7c20b3cd) : (0, $22594696cd565665$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $0cf031cb80554143$export$d60cfc58d3c358b6 extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $22594696cd565665$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $22594696cd565665$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $22594696cd565665$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $22594696cd565665$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $22594696cd565665$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $22594696cd565665$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $22594696cd565665$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $22594696cd565665$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $22594696cd565665$export$c4ce752e73470fba)(min, (0, $22594696cd565665$export$c4ce752e73470fba)(max, min)),
            max: (0, $22594696cd565665$export$c4ce752e73470fba)(max, (0, $22594696cd565665$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $22594696cd565665$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $0cf031cb80554143$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $0cf031cb80554143$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $22594696cd565665$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $0cf031cb80554143$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $22594696cd565665$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $0cf031cb80554143$var$getTickMarkLength(options.grid) - tickOpts.padding - $0cf031cb80554143$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $22594696cd565665$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $22594696cd565665$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $22594696cd565665$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $22594696cd565665$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $0cf031cb80554143$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $0cf031cb80554143$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $0cf031cb80554143$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $22594696cd565665$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $22594696cd565665$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $0cf031cb80554143$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $0cf031cb80554143$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $22594696cd565665$export$342063e11d6c3cad)(label) && !(0, $22594696cd565665$export$8b22cf2602fb60ce)(label)) {
                width = (0, $22594696cd565665$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $22594696cd565665$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $22594696cd565665$export$342063e11d6c3cad)(nestedLabel) && !(0, $22594696cd565665$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $22594696cd565665$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $0cf031cb80554143$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $22594696cd565665$export$71cec2538cb2c617)(this._alignToPixels ? (0, $22594696cd565665$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $0cf031cb80554143$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $0cf031cb80554143$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $22594696cd565665$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $0cf031cb80554143$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $22594696cd565665$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $22594696cd565665$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $22594696cd565665$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $22594696cd565665$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $0cf031cb80554143$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $22594696cd565665$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $0cf031cb80554143$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $22594696cd565665$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $22594696cd565665$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $22594696cd565665$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $22594696cd565665$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                    case "inner":
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $22594696cd565665$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $22594696cd565665$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $22594696cd565665$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $22594696cd565665$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $22594696cd565665$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $22594696cd565665$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $22594696cd565665$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $22594696cd565665$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $22594696cd565665$export$34aec0b863436764)(title.font);
        const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $22594696cd565665$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $22594696cd565665$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $0cf031cb80554143$var$titleArgs(this, offset, position, align);
        (0, $22594696cd565665$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $0cf031cb80554143$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $22594696cd565665$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $22594696cd565665$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $0cf031cb80554143$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $22594696cd565665$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $0cf031cb80554143$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($0cf031cb80554143$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $0cf031cb80554143$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $22594696cd565665$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $22594696cd565665$export$4368d992c4eafac0)[scope]) {
            delete (0, $22594696cd565665$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $22594696cd565665$export$6559d589eb85fbb6)[id];
        }
    }
}
function $0cf031cb80554143$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $22594696cd565665$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $22594696cd565665$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $22594696cd565665$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $22594696cd565665$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $0cf031cb80554143$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $22594696cd565665$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $0cf031cb80554143$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $22594696cd565665$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $0cf031cb80554143$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $0cf031cb80554143$var$Registry {
    constructor(){
        this.controllers = new $0cf031cb80554143$var$TypedRegistry($0cf031cb80554143$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $0cf031cb80554143$var$TypedRegistry($0cf031cb80554143$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $0cf031cb80554143$var$TypedRegistry(Object, "plugins");
        this.scales = new $0cf031cb80554143$var$TypedRegistry($0cf031cb80554143$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $22594696cd565665$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $22594696cd565665$export$a8550f7dbe79f93a)(method);
        (0, $22594696cd565665$export$3722cfe417b6ed86)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $22594696cd565665$export$3722cfe417b6ed86)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $0cf031cb80554143$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $0cf031cb80554143$var$Registry();
class $0cf031cb80554143$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $22594696cd565665$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $22594696cd565665$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $22594696cd565665$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $0cf031cb80554143$var$allPlugins(config);
        return options === false && !all ? [] : $0cf031cb80554143$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $0cf031cb80554143$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($0cf031cb80554143$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($0cf031cb80554143$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $0cf031cb80554143$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $0cf031cb80554143$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $0cf031cb80554143$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $0cf031cb80554143$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $0cf031cb80554143$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $0cf031cb80554143$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $22594696cd565665$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $0cf031cb80554143$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $0cf031cb80554143$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $0cf031cb80554143$var$idMatchesAxis(id) {
    if (id === "x" || id === "y" || id === "r") return id;
}
function $0cf031cb80554143$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $0cf031cb80554143$var$determineAxis(id, ...scaleOptions) {
    if ($0cf031cb80554143$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $0cf031cb80554143$var$axisFromPosition(opts.position) || id.length > 1 && $0cf031cb80554143$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $0cf031cb80554143$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + "AxisID"] === id) return {
        axis: axis
    };
}
function $0cf031cb80554143$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $0cf031cb80554143$var$getAxisFromDataset(id, "x", boundDs[0]) || $0cf031cb80554143$var$getAxisFromDataset(id, "y", boundDs[0]);
    }
    return {};
}
function $0cf031cb80554143$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $22594696cd565665$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $0cf031cb80554143$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $22594696cd565665$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $0cf031cb80554143$var$determineAxis(id, scaleConf, $0cf031cb80554143$var$retrieveAxisFromDatasets(id, config), (0, $22594696cd565665$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $0cf031cb80554143$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $22594696cd565665$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $0cf031cb80554143$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $22594696cd565665$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $0cf031cb80554143$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $22594696cd565665$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $22594696cd565665$export$555508cbc6add439)(scale, [
            (0, $22594696cd565665$export$4368d992c4eafac0).scales[scale.type],
            (0, $22594696cd565665$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $0cf031cb80554143$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $22594696cd565665$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $0cf031cb80554143$var$mergeScaleConfig(config, options);
}
function $0cf031cb80554143$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $0cf031cb80554143$var$initConfig(config) {
    config = config || {};
    config.data = $0cf031cb80554143$var$initData(config.data);
    $0cf031cb80554143$var$initOptions(config);
    return config;
}
const $0cf031cb80554143$var$keyCache = new Map();
const $0cf031cb80554143$var$keysCached = new Set();
function $0cf031cb80554143$var$cachedKeys(cacheKey, generate) {
    let keys = $0cf031cb80554143$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $0cf031cb80554143$var$keyCache.set(cacheKey, keys);
        $0cf031cb80554143$var$keysCached.add(keys);
    }
    return keys;
}
const $0cf031cb80554143$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $22594696cd565665$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $0cf031cb80554143$var$Config {
    constructor(config){
        this._config = $0cf031cb80554143$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $0cf031cb80554143$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $0cf031cb80554143$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $0cf031cb80554143$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $0cf031cb80554143$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $0cf031cb80554143$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $0cf031cb80554143$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$0cf031cb80554143$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$0cf031cb80554143$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$0cf031cb80554143$var$addIfFound(scopes, (0, $22594696cd565665$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$0cf031cb80554143$var$addIfFound(scopes, (0, $22594696cd565665$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$0cf031cb80554143$var$addIfFound(scopes, (0, $22594696cd565665$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($0cf031cb80554143$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $22594696cd565665$export$6559d589eb85fbb6)[type] || {},
            (0, $22594696cd565665$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $22594696cd565665$export$4368d992c4eafac0),
            (0, $22594696cd565665$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $0cf031cb80554143$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($0cf031cb80554143$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $22594696cd565665$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $22594696cd565665$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $0cf031cb80554143$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $22594696cd565665$export$23f2a1d2818174ef)(context) ? (0, $22594696cd565665$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $0cf031cb80554143$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $22594696cd565665$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $0cf031cb80554143$var$hasFunction = (value)=>(0, $22594696cd565665$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $22594696cd565665$export$a93c5207d687da10)(value[key]));
function $0cf031cb80554143$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $22594696cd565665$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $22594696cd565665$export$a93c5207d687da10)(value) || $0cf031cb80554143$var$hasFunction(value)) || indexable && (0, $22594696cd565665$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $0cf031cb80554143$var$version = "4.4.3";
const $0cf031cb80554143$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $0cf031cb80554143$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $0cf031cb80554143$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $0cf031cb80554143$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $0cf031cb80554143$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $22594696cd565665$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $0cf031cb80554143$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $22594696cd565665$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $0cf031cb80554143$var$getCanvas(item) {
    if ((0, $22594696cd565665$export$3a1a48c8f6ef640e)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $0cf031cb80554143$var$instances = {};
const $0cf031cb80554143$var$getChart = (key)=>{
    const canvas = $0cf031cb80554143$var$getCanvas(key);
    return Object.values($0cf031cb80554143$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $0cf031cb80554143$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $0cf031cb80554143$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
function $0cf031cb80554143$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $0cf031cb80554143$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $0cf031cb80554143$var$getSizeForArea(xScale, chartArea, "left"),
        right: $0cf031cb80554143$var$getSizeForArea(xScale, chartArea, "right"),
        top: $0cf031cb80554143$var$getSizeForArea(yScale, chartArea, "top"),
        bottom: $0cf031cb80554143$var$getSizeForArea(yScale, chartArea, "bottom")
    };
    return chartArea;
}
class $0cf031cb80554143$export$acaa6426d77a227e {
    static defaults = (0, $22594696cd565665$export$4368d992c4eafac0);
    static instances = $0cf031cb80554143$var$instances;
    static overrides = (0, $22594696cd565665$export$6559d589eb85fbb6);
    static registry = $0cf031cb80554143$export$4bb7493d241fd8a5;
    static version = $0cf031cb80554143$var$version;
    static getChart = $0cf031cb80554143$var$getChart;
    static register(...items) {
        $0cf031cb80554143$export$4bb7493d241fd8a5.add(...items);
        $0cf031cb80554143$var$invalidatePlugins();
    }
    static unregister(...items) {
        $0cf031cb80554143$export$4bb7493d241fd8a5.remove(...items);
        $0cf031cb80554143$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $0cf031cb80554143$var$Config(userConfig);
        const initialCanvas = $0cf031cb80554143$var$getCanvas(item);
        const existingChart = $0cf031cb80554143$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $0cf031cb80554143$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $22594696cd565665$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $0cf031cb80554143$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $22594696cd565665$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $0cf031cb80554143$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $0cf031cb80554143$export$a424a0aa8f687495.listen(this, "complete", $0cf031cb80554143$var$onAnimationsComplete);
        $0cf031cb80554143$export$a424a0aa8f687495.listen(this, "progress", $0cf031cb80554143$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $22594696cd565665$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $0cf031cb80554143$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $22594696cd565665$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $22594696cd565665$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $0cf031cb80554143$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$0cf031cb80554143$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $22594696cd565665$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $22594696cd565665$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $22594696cd565665$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $0cf031cb80554143$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $22594696cd565665$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $0cf031cb80554143$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $22594696cd565665$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $0cf031cb80554143$var$positionIsHorizontal(scaleOptions.position, axis) !== $0cf031cb80554143$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $0cf031cb80554143$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $22594696cd565665$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $22594696cd565665$export$d66501df72047452)(scales, (scale)=>{
            $0cf031cb80554143$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $0cf031cb80554143$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($0cf031cb80554143$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $0cf031cb80554143$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $0cf031cb80554143$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $22594696cd565665$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $0cf031cb80554143$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $0cf031cb80554143$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $22594696cd565665$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $22594696cd565665$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($0cf031cb80554143$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $22594696cd565665$export$d66501df72047452)(this.scales, (scale)=>{
            $0cf031cb80554143$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $22594696cd565665$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $0cf031cb80554143$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $22594696cd565665$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $0cf031cb80554143$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $22594696cd565665$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $22594696cd565665$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($0cf031cb80554143$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$0cf031cb80554143$export$a424a0aa8f687495.running(this)) $0cf031cb80554143$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $0cf031cb80554143$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $0cf031cb80554143$var$getDatasetArea(meta, this.chartArea);
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $22594696cd565665$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $22594696cd565665$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $22594696cd565665$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $0cf031cb80554143$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $22594696cd565665$export$35e795649ee09318)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $22594696cd565665$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $0cf031cb80554143$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $22594696cd565665$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $0cf031cb80554143$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $22594696cd565665$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $22594696cd565665$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $22594696cd565665$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $22594696cd565665$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $22594696cd565665$export$f38c853ae54ed474)(e);
        const lastEvent = $0cf031cb80554143$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $22594696cd565665$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $22594696cd565665$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $22594696cd565665$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $0cf031cb80554143$var$invalidatePlugins() {
    return (0, $22594696cd565665$export$d66501df72047452)($0cf031cb80554143$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $0cf031cb80554143$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $22594696cd565665$export$7f8ddf7c7c20b3cd), startAngle - (0, $22594696cd565665$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $0cf031cb80554143$var$toRadiusCorners(value) {
    return (0, $22594696cd565665$export$21579262ef46735b)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $0cf031cb80554143$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $0cf031cb80554143$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $22594696cd565665$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $22594696cd565665$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $22594696cd565665$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $0cf031cb80554143$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $0cf031cb80554143$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $22594696cd565665$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $0cf031cb80554143$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $0cf031cb80554143$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $22594696cd565665$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $0cf031cb80554143$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $0cf031cb80554143$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $22594696cd565665$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $0cf031cb80554143$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $22594696cd565665$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $0cf031cb80554143$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $0cf031cb80554143$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $22594696cd565665$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $0cf031cb80554143$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $0cf031cb80554143$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $22594696cd565665$export$971d5caa766a69d7) || (0, $22594696cd565665$export$971d5caa766a69d7));
    }
    $0cf031cb80554143$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $0cf031cb80554143$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $0cf031cb80554143$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $22594696cd565665$export$971d5caa766a69d7) || (0, $22594696cd565665$export$971d5caa766a69d7));
    }
    if (inner) $0cf031cb80554143$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $0cf031cb80554143$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $0cf031cb80554143$export$d48203c759d6a1fc extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    static id = "arc";
    static defaults = {
        borderAlign: "center",
        borderColor: "#fff",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash"
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $22594696cd565665$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $22594696cd565665$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $22594696cd565665$export$971d5caa766a69d7) || (0, $22594696cd565665$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $22594696cd565665$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $22594696cd565665$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $22594696cd565665$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $22594696cd565665$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $0cf031cb80554143$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $0cf031cb80554143$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $0cf031cb80554143$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $22594696cd565665$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $22594696cd565665$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $22594696cd565665$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $22594696cd565665$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $22594696cd565665$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $22594696cd565665$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $0cf031cb80554143$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $0cf031cb80554143$var$getLineMethod(options) {
    if (options.stepped) return 0, $22594696cd565665$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $22594696cd565665$export$6554612db691658e;
    return $0cf031cb80554143$var$lineTo;
}
function $0cf031cb80554143$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $0cf031cb80554143$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $0cf031cb80554143$var$pathVars(points, segment, params);
    const lineMethod = $0cf031cb80554143$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $0cf031cb80554143$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $0cf031cb80554143$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $0cf031cb80554143$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $0cf031cb80554143$var$fastPathSegment : $0cf031cb80554143$var$pathSegment;
}
function $0cf031cb80554143$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $22594696cd565665$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $22594696cd565665$export$2f6ca3d3b1f80bf5;
    return 0, $22594696cd565665$export$8a5498727ef6be21;
}
function $0cf031cb80554143$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $0cf031cb80554143$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $0cf031cb80554143$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $0cf031cb80554143$var$_getSegmentMethod(line);
    for (const segment of segments){
        $0cf031cb80554143$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $0cf031cb80554143$var$usePath2D = typeof Path2D === "function";
function $0cf031cb80554143$var$draw(ctx, line, start, count) {
    if ($0cf031cb80554143$var$usePath2D && !line.options.segment) $0cf031cb80554143$var$strokePathWithCache(ctx, line, start, count);
    else $0cf031cb80554143$var$strokePathDirect(ctx, line, start, count);
}
class $0cf031cb80554143$export$55e463fa7bcd3469 extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    static id = "line";
    static defaults = {
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: "miter",
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: "default",
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash" && name !== "fill"
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $22594696cd565665$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $22594696cd565665$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $22594696cd565665$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $0cf031cb80554143$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $0cf031cb80554143$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $0cf031cb80554143$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $0cf031cb80554143$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $0cf031cb80554143$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $0cf031cb80554143$export$bd159b522b230b7a extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    static id = "point";
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: "circle",
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $0cf031cb80554143$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $0cf031cb80554143$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $22594696cd565665$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $22594696cd565665$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $0cf031cb80554143$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $0cf031cb80554143$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $22594696cd565665$export$25ce5a424b770e84)(value, min, max);
}
function $0cf031cb80554143$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $22594696cd565665$export$d66dc83d8cfc8dd)(value);
    return {
        t: $0cf031cb80554143$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $0cf031cb80554143$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $0cf031cb80554143$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $0cf031cb80554143$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $0cf031cb80554143$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $22594696cd565665$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $22594696cd565665$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $0cf031cb80554143$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $0cf031cb80554143$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $0cf031cb80554143$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $0cf031cb80554143$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $0cf031cb80554143$var$boundingRects(bar) {
    const bounds = $0cf031cb80554143$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $0cf031cb80554143$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $0cf031cb80554143$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $0cf031cb80554143$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $0cf031cb80554143$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $22594696cd565665$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $22594696cd565665$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $0cf031cb80554143$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $0cf031cb80554143$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $0cf031cb80554143$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $0cf031cb80554143$export$a16ed71bf4b07672 extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    static id = "bar";
    static defaults = {
        borderSkipped: "start",
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: "auto",
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $0cf031cb80554143$var$boundingRects(this);
        const addRectPath = $0cf031cb80554143$var$hasRadius(outer.radius) ? (0, $22594696cd565665$export$1fbe638ecf81657e) : $0cf031cb80554143$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $0cf031cb80554143$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $0cf031cb80554143$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $0cf031cb80554143$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $0cf031cb80554143$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $0cf031cb80554143$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $0cf031cb80554143$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
var $0cf031cb80554143$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $0cf031cb80554143$export$d48203c759d6a1fc,
    BarElement: $0cf031cb80554143$export$a16ed71bf4b07672,
    LineElement: $0cf031cb80554143$export$55e463fa7bcd3469,
    PointElement: $0cf031cb80554143$export$bd159b522b230b7a
});
const $0cf031cb80554143$var$BORDER_COLORS = [
    "rgb(54, 162, 235)",
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)" // grey
];
// Border colors with 50% transparency
const $0cf031cb80554143$var$BACKGROUND_COLORS = /* #__PURE__ */ $0cf031cb80554143$var$BORDER_COLORS.map((color)=>color.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function $0cf031cb80554143$var$getBorderColor(i) {
    return $0cf031cb80554143$var$BORDER_COLORS[i % $0cf031cb80554143$var$BORDER_COLORS.length];
}
function $0cf031cb80554143$var$getBackgroundColor(i) {
    return $0cf031cb80554143$var$BACKGROUND_COLORS[i % $0cf031cb80554143$var$BACKGROUND_COLORS.length];
}
function $0cf031cb80554143$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $0cf031cb80554143$var$getBorderColor(i);
    dataset.backgroundColor = $0cf031cb80554143$var$getBackgroundColor(i);
    return ++i;
}
function $0cf031cb80554143$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$0cf031cb80554143$var$getBorderColor(i++));
    return i;
}
function $0cf031cb80554143$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$0cf031cb80554143$var$getBackgroundColor(i++));
    return i;
}
function $0cf031cb80554143$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $0cf031cb80554143$export$e04603e7d8b77172) i = $0cf031cb80554143$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $0cf031cb80554143$export$2a270b3a0d973c85) i = $0cf031cb80554143$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $0cf031cb80554143$var$colorizeDefaultDataset(dataset, i);
    };
}
function $0cf031cb80554143$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $0cf031cb80554143$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var $0cf031cb80554143$export$c537fa0d021d010b = {
    id: "colors",
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        if (!options.forceOverride && ($0cf031cb80554143$var$containsColorsDefinitions(datasets) || $0cf031cb80554143$var$containsColorsDefinition(chartOptions) || elements && $0cf031cb80554143$var$containsColorsDefinitions(elements))) return;
        const colorizer = $0cf031cb80554143$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $0cf031cb80554143$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $0cf031cb80554143$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $22594696cd565665$export$342063e11d6c3cad)(minIndex) && !(0, $22594696cd565665$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $0cf031cb80554143$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $0cf031cb80554143$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $0cf031cb80554143$var$cleanDecimatedDataset(dataset);
    });
}
function $0cf031cb80554143$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $22594696cd565665$export$25ce5a424b770e84)((0, $22594696cd565665$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $22594696cd565665$export$25ce5a424b770e84)((0, $22594696cd565665$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $0cf031cb80554143$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $0cf031cb80554143$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $22594696cd565665$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $0cf031cb80554143$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $0cf031cb80554143$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $22594696cd565665$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $0cf031cb80554143$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $0cf031cb80554143$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $0cf031cb80554143$var$cleanDecimatedData(chart);
    }
};
function $0cf031cb80554143$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $0cf031cb80554143$var$_findSegmentEnd(start, end, points);
        const bounds = $0cf031cb80554143$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $22594696cd565665$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $0cf031cb80554143$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $22594696cd565665$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $0cf031cb80554143$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $0cf031cb80554143$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $0cf031cb80554143$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $22594696cd565665$export$28f7fcd39efa255)(start);
        end = (0, $22594696cd565665$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $0cf031cb80554143$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $0cf031cb80554143$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $0cf031cb80554143$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $0cf031cb80554143$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $0cf031cb80554143$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $22594696cd565665$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $0cf031cb80554143$var$_pointsFromSegments(boundary, line);
    return points.length ? new $0cf031cb80554143$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $0cf031cb80554143$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $0cf031cb80554143$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $22594696cd565665$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $0cf031cb80554143$var$_decodeFill(line, index, count) {
    const fill = $0cf031cb80554143$var$parseFillOption(line);
    if ((0, $22594696cd565665$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $22594696cd565665$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $0cf031cb80554143$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $0cf031cb80554143$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $0cf031cb80554143$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $22594696cd565665$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $0cf031cb80554143$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $22594696cd565665$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $0cf031cb80554143$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $22594696cd565665$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $0cf031cb80554143$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $0cf031cb80554143$var$getLinesBelow(scale, index);
    linesBelow.push($0cf031cb80554143$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$0cf031cb80554143$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $0cf031cb80554143$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $0cf031cb80554143$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $0cf031cb80554143$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $0cf031cb80554143$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $0cf031cb80554143$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $22594696cd565665$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $0cf031cb80554143$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $22594696cd565665$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $0cf031cb80554143$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $22594696cd565665$export$39b482c5e57630a8)(fill)) return $0cf031cb80554143$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $0cf031cb80554143$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $0cf031cb80554143$var$computeBoundary(source);
    if (boundary instanceof $0cf031cb80554143$var$simpleArc) return boundary;
    return $0cf031cb80554143$var$_createBoundaryLine(boundary, line);
}
function $0cf031cb80554143$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $0cf031cb80554143$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $0cf031cb80554143$var$computeCircularBoundary(source);
    return $0cf031cb80554143$var$computeLinearBoundary(source);
}
function $0cf031cb80554143$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $0cf031cb80554143$var$_getTargetPixel(fill, scale);
    if ((0, $22594696cd565665$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $0cf031cb80554143$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $0cf031cb80554143$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $0cf031cb80554143$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $0cf031cb80554143$var$_drawfill(ctx, source, area) {
    const target = $0cf031cb80554143$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $22594696cd565665$export$8743009a87fcb00f)(ctx, area);
        $0cf031cb80554143$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $22594696cd565665$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $0cf031cb80554143$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $0cf031cb80554143$var$clipVertical(ctx, target, area.top);
        $0cf031cb80554143$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $0cf031cb80554143$var$clipVertical(ctx, target, area.bottom);
    }
    $0cf031cb80554143$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $0cf031cb80554143$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$0cf031cb80554143$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $0cf031cb80554143$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $0cf031cb80554143$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $0cf031cb80554143$var$clipBounds(ctx, scale, notShape && $0cf031cb80554143$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $0cf031cb80554143$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $0cf031cb80554143$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $0cf031cb80554143$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $0cf031cb80554143$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $0cf031cb80554143$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $0cf031cb80554143$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $0cf031cb80554143$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $0cf031cb80554143$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $0cf031cb80554143$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($0cf031cb80554143$var$_shouldApplyFill(source)) $0cf031cb80554143$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$0cf031cb80554143$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $0cf031cb80554143$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $0cf031cb80554143$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $0cf031cb80554143$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $0cf031cb80554143$var$Legend extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $22594696cd565665$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $22594696cd565665$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $0cf031cb80554143$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $0cf031cb80554143$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $22594696cd565665$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $22594696cd565665$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $22594696cd565665$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $22594696cd565665$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $22594696cd565665$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $22594696cd565665$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $0cf031cb80554143$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $22594696cd565665$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $22594696cd565665$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $22594696cd565665$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $22594696cd565665$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $22594696cd565665$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $22594696cd565665$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $22594696cd565665$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $22594696cd565665$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $22594696cd565665$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $22594696cd565665$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $22594696cd565665$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $22594696cd565665$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $22594696cd565665$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== "string") {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $0cf031cb80554143$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $22594696cd565665$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $22594696cd565665$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $22594696cd565665$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $22594696cd565665$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $22594696cd565665$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $22594696cd565665$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $22594696cd565665$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $22594696cd565665$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $22594696cd565665$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $22594696cd565665$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $22594696cd565665$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $22594696cd565665$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $22594696cd565665$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$0cf031cb80554143$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $0cf031cb80554143$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $22594696cd565665$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $22594696cd565665$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $22594696cd565665$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $0cf031cb80554143$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $0cf031cb80554143$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $0cf031cb80554143$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $0cf031cb80554143$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== "string") legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $0cf031cb80554143$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== "string") itemHeight = $0cf031cb80554143$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $0cf031cb80554143$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $0cf031cb80554143$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $0cf031cb80554143$export$ed247974535929c7 = {
    id: "legend",
    _element: $0cf031cb80554143$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $0cf031cb80554143$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $0cf031cb80554143$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $0cf031cb80554143$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $0cf031cb80554143$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $0cf031cb80554143$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $0cf031cb80554143$var$Title extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $22594696cd565665$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $22594696cd565665$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $22594696cd565665$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $22594696cd565665$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $22594696cd565665$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $22594696cd565665$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $22594696cd565665$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $22594696cd565665$export$3c2fa207a37baaea)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $0cf031cb80554143$var$createTitle(chart, titleOpts) {
    const title = new $0cf031cb80554143$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $0cf031cb80554143$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $0cf031cb80554143$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $0cf031cb80554143$export$f99233281efd08a0 = {
    id: "title",
    _element: $0cf031cb80554143$var$Title,
    start (chart, _args, options) {
        $0cf031cb80554143$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $0cf031cb80554143$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $0cf031cb80554143$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $0cf031cb80554143$var$map = new WeakMap();
var $0cf031cb80554143$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $0cf031cb80554143$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $0cf031cb80554143$export$1ecca0613f5e56d2.configure(chart, title, options);
        $0cf031cb80554143$export$1ecca0613f5e56d2.addBox(chart, title);
        $0cf031cb80554143$var$map.set(chart, title);
    },
    stop (chart) {
        $0cf031cb80554143$export$1ecca0613f5e56d2.removeBox(chart, $0cf031cb80554143$var$map.get(chart));
        $0cf031cb80554143$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $0cf031cb80554143$var$map.get(chart);
        $0cf031cb80554143$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $0cf031cb80554143$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $22594696cd565665$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $0cf031cb80554143$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $22594696cd565665$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $0cf031cb80554143$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $0cf031cb80554143$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $0cf031cb80554143$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $22594696cd565665$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $22594696cd565665$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $22594696cd565665$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $22594696cd565665$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $22594696cd565665$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $22594696cd565665$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $22594696cd565665$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $22594696cd565665$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $22594696cd565665$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $22594696cd565665$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $0cf031cb80554143$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $0cf031cb80554143$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $0cf031cb80554143$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($0cf031cb80554143$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $0cf031cb80554143$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $0cf031cb80554143$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $0cf031cb80554143$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $0cf031cb80554143$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $0cf031cb80554143$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $0cf031cb80554143$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $22594696cd565665$export$92108d983e8ee699)(cornerRadius);
    let x = $0cf031cb80554143$var$alignX(size, xAlign);
    const y = $0cf031cb80554143$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $22594696cd565665$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $22594696cd565665$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $0cf031cb80554143$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $0cf031cb80554143$var$getBeforeAfterBodyLines(callback) {
    return $0cf031cb80554143$var$pushOrConcat([], $0cf031cb80554143$var$splitNewlines(callback));
}
function $0cf031cb80554143$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $22594696cd565665$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $0cf031cb80554143$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $0cf031cb80554143$var$defaultCallbacks = {
    beforeTitle: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return "";
    },
    afterTitle: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    beforeBody: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    beforeLabel: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || "";
        if (label) label += ": ";
        const value = tooltipItem.formattedValue;
        if (!(0, $22594696cd565665$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    afterBody: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    beforeFooter: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    footer: (0, $22594696cd565665$export$cf2f7c5792f80b46),
    afterFooter: (0, $22594696cd565665$export$cf2f7c5792f80b46)
};
function $0cf031cb80554143$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === "undefined") return $0cf031cb80554143$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $0cf031cb80554143$var$Tooltip extends $0cf031cb80554143$export$db77ccec0bb4ccac {
    static positioners = $0cf031cb80554143$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $0cf031cb80554143$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $0cf031cb80554143$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $0cf031cb80554143$var$invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
        const title = $0cf031cb80554143$var$invokeCallbackWithFallback(callbacks, "title", this, context);
        const afterTitle = $0cf031cb80554143$var$invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
        let lines = [];
        lines = $0cf031cb80554143$var$pushOrConcat(lines, $0cf031cb80554143$var$splitNewlines(beforeTitle));
        lines = $0cf031cb80554143$var$pushOrConcat(lines, $0cf031cb80554143$var$splitNewlines(title));
        lines = $0cf031cb80554143$var$pushOrConcat(lines, $0cf031cb80554143$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $0cf031cb80554143$var$getBeforeAfterBodyLines($0cf031cb80554143$var$invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $22594696cd565665$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $0cf031cb80554143$var$overrideCallbacks(callbacks, context);
            $0cf031cb80554143$var$pushOrConcat(bodyItem.before, $0cf031cb80554143$var$splitNewlines($0cf031cb80554143$var$invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
            $0cf031cb80554143$var$pushOrConcat(bodyItem.lines, $0cf031cb80554143$var$invokeCallbackWithFallback(scoped, "label", this, context));
            $0cf031cb80554143$var$pushOrConcat(bodyItem.after, $0cf031cb80554143$var$splitNewlines($0cf031cb80554143$var$invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $0cf031cb80554143$var$getBeforeAfterBodyLines($0cf031cb80554143$var$invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $0cf031cb80554143$var$invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
        const footer = $0cf031cb80554143$var$invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
        const afterFooter = $0cf031cb80554143$var$invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
        let lines = [];
        lines = $0cf031cb80554143$var$pushOrConcat(lines, $0cf031cb80554143$var$splitNewlines(beforeFooter));
        lines = $0cf031cb80554143$var$pushOrConcat(lines, $0cf031cb80554143$var$splitNewlines(footer));
        lines = $0cf031cb80554143$var$pushOrConcat(lines, $0cf031cb80554143$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($0cf031cb80554143$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $22594696cd565665$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $0cf031cb80554143$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($0cf031cb80554143$var$invokeCallbackWithFallback(scoped, "labelColor", this, context));
            labelPointStyles.push($0cf031cb80554143$var$invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
            labelTextColors.push($0cf031cb80554143$var$invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $0cf031cb80554143$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $0cf031cb80554143$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $0cf031cb80554143$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $0cf031cb80554143$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $22594696cd565665$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $22594696cd565665$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $0cf031cb80554143$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $22594696cd565665$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $22594696cd565665$export$34aec0b863436764)(options.bodyFont);
        const colorX = $0cf031cb80554143$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $22594696cd565665$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $22594696cd565665$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $22594696cd565665$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $22594696cd565665$export$92108d983e8ee699)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $22594696cd565665$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $22594696cd565665$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $22594696cd565665$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $22594696cd565665$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $0cf031cb80554143$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $22594696cd565665$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $22594696cd565665$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $22594696cd565665$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $22594696cd565665$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $22594696cd565665$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $0cf031cb80554143$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $22594696cd565665$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $22594696cd565665$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $0cf031cb80554143$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $0cf031cb80554143$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $0cf031cb80554143$var$determineAlignment(chart, options, positionAndSize);
            const point = $0cf031cb80554143$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $22594696cd565665$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $22594696cd565665$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $22594696cd565665$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $22594696cd565665$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $0cf031cb80554143$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $0cf031cb80554143$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $0cf031cb80554143$var$Tooltip,
    positioners: $0cf031cb80554143$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $0cf031cb80554143$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: $0cf031cb80554143$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $0cf031cb80554143$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $0cf031cb80554143$export$c537fa0d021d010b,
    Decimation: $0cf031cb80554143$export$be17f937e9aa7533,
    Filler: $0cf031cb80554143$export$d19ba4d812bed757,
    Legend: $0cf031cb80554143$export$ed247974535929c7,
    SubTitle: $0cf031cb80554143$export$d5c56664638992a4,
    Title: $0cf031cb80554143$export$f99233281efd08a0,
    Tooltip: $0cf031cb80554143$export$28c660c63b792dea
});
const $0cf031cb80554143$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $0cf031cb80554143$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $0cf031cb80554143$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $0cf031cb80554143$var$validIndex = (index, max)=>index === null ? null : (0, $22594696cd565665$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $0cf031cb80554143$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $0cf031cb80554143$export$29e663ba4d09fe7 extends $0cf031cb80554143$export$d60cfc58d3c358b6 {
    static id = "category";
    static defaults = {
        ticks: {
            callback: $0cf031cb80554143$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $22594696cd565665$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $0cf031cb80554143$var$findOrAddLabel(labels, raw, (0, $22594696cd565665$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $0cf031cb80554143$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $0cf031cb80554143$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $0cf031cb80554143$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $22594696cd565665$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $22594696cd565665$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $22594696cd565665$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $22594696cd565665$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $22594696cd565665$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $22594696cd565665$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $22594696cd565665$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $22594696cd565665$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $22594696cd565665$export$23ebac1979863676)(spacing), (0, $22594696cd565665$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $22594696cd565665$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $22594696cd565665$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $0cf031cb80554143$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $22594696cd565665$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $0cf031cb80554143$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $0cf031cb80554143$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $22594696cd565665$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $0cf031cb80554143$var$LinearScaleBase extends $0cf031cb80554143$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $22594696cd565665$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $22594696cd565665$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $22594696cd565665$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $0cf031cb80554143$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $22594696cd565665$export$53a70dd1ebbae346)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $22594696cd565665$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $0cf031cb80554143$export$e7f4e5e8656f0b93 extends $0cf031cb80554143$var$LinearScaleBase {
    static id = "linear";
    static defaults = {
        ticks: {
            callback: (0, $22594696cd565665$export$91477dc880baac21).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $22594696cd565665$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $22594696cd565665$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $22594696cd565665$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $0cf031cb80554143$var$log10Floor = (v)=>Math.floor((0, $22594696cd565665$export$9f4f30ee63539e24)(v));
const $0cf031cb80554143$var$changeExponent = (v, m)=>Math.pow(10, $0cf031cb80554143$var$log10Floor(v) + m);
function $0cf031cb80554143$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $0cf031cb80554143$var$log10Floor(tickVal));
    return remain === 1;
}
function $0cf031cb80554143$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $0cf031cb80554143$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $0cf031cb80554143$var$log10Floor(range);
    while($0cf031cb80554143$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($0cf031cb80554143$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $0cf031cb80554143$var$log10Floor(min));
}
function $0cf031cb80554143$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $22594696cd565665$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $0cf031cb80554143$var$log10Floor(min);
    let exp = $0cf031cb80554143$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $22594696cd565665$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $0cf031cb80554143$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $22594696cd565665$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $0cf031cb80554143$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $0cf031cb80554143$export$85295eaf7cb3ac3e extends $0cf031cb80554143$export$d60cfc58d3c358b6 {
    static id = "logarithmic";
    static defaults = {
        ticks: {
            callback: (0, $22594696cd565665$export$91477dc880baac21).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $0cf031cb80554143$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $22594696cd565665$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $22594696cd565665$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $22594696cd565665$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $22594696cd565665$export$39b482c5e57630a8)(this._userMin)) this.min = min === $0cf031cb80554143$var$changeExponent(this.min, 0) ? $0cf031cb80554143$var$changeExponent(this.min, -1) : $0cf031cb80554143$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($0cf031cb80554143$var$changeExponent(min, -1));
                setMax($0cf031cb80554143$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($0cf031cb80554143$var$changeExponent(max, -1));
        if (max <= 0) setMax($0cf031cb80554143$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $0cf031cb80554143$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $22594696cd565665$export$53a70dd1ebbae346)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $22594696cd565665$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $22594696cd565665$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $22594696cd565665$export$9f4f30ee63539e24)(this.max) - (0, $22594696cd565665$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $22594696cd565665$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $0cf031cb80554143$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $22594696cd565665$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $22594696cd565665$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $0cf031cb80554143$var$measureLabelSize(ctx, font, label) {
    label = (0, $22594696cd565665$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $22594696cd565665$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $0cf031cb80554143$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $0cf031cb80554143$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $22594696cd565665$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $22594696cd565665$export$34aec0b863436764)(opts.font);
        const textSize = $0cf031cb80554143$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $22594696cd565665$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $22594696cd565665$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $0cf031cb80554143$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $0cf031cb80554143$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $0cf031cb80554143$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $0cf031cb80554143$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $0cf031cb80554143$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $0cf031cb80554143$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $22594696cd565665$export$3a6d5c9ae78a2c08)((0, $22594696cd565665$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $22594696cd565665$export$7f8ddf7c7c20b3cd))));
    const y = $0cf031cb80554143$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $0cf031cb80554143$var$getTextAlignForAngle(angle);
    const left = $0cf031cb80554143$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $0cf031cb80554143$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $22594696cd565665$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $22594696cd565665$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $22594696cd565665$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $22594696cd565665$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $0cf031cb80554143$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $0cf031cb80554143$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $22594696cd565665$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $0cf031cb80554143$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === "auto") {
            item.visible = $0cf031cb80554143$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $0cf031cb80554143$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $0cf031cb80554143$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $0cf031cb80554143$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $0cf031cb80554143$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $22594696cd565665$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $22594696cd565665$export$92108d983e8ee699)(opts.borderRadius);
        const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $22594696cd565665$export$1fbe638ecf81657e)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $0cf031cb80554143$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $0cf031cb80554143$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $22594696cd565665$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $22594696cd565665$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $0cf031cb80554143$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $22594696cd565665$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $0cf031cb80554143$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $0cf031cb80554143$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $0cf031cb80554143$var$createPointLabelContext(parent, index, label) {
    return (0, $22594696cd565665$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $0cf031cb80554143$export$cfafc36d95386d38 extends $0cf031cb80554143$var$LinearScaleBase {
    static id = "radialLinear";
    static defaults = {
        display: true,
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $22594696cd565665$export$91477dc880baac21).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        "angleLines.color": "borderColor",
        "pointLabels.color": "color",
        "ticks.color": "color"
    };
    static descriptors = {
        angleLines: {
            _fallback: "grid"
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)($0cf031cb80554143$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $22594696cd565665$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $22594696cd565665$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $0cf031cb80554143$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $0cf031cb80554143$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $22594696cd565665$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $0cf031cb80554143$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $22594696cd565665$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $22594696cd565665$export$28f7fcd39efa255)(index * angleMultiplier + (0, $22594696cd565665$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $22594696cd565665$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $22594696cd565665$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $0cf031cb80554143$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $22594696cd565665$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $0cf031cb80554143$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $0cf031cb80554143$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $0cf031cb80554143$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $22594696cd565665$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $22594696cd565665$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $22594696cd565665$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $0cf031cb80554143$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $0cf031cb80554143$var$UNITS = /* #__PURE__ */ Object.keys($0cf031cb80554143$var$INTERVALS);
function $0cf031cb80554143$var$sorter(a, b) {
    return a - b;
}
function $0cf031cb80554143$var$parse(scale, input) {
    if ((0, $22594696cd565665$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $22594696cd565665$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $22594696cd565665$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $0cf031cb80554143$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $0cf031cb80554143$var$UNITS.length;
    for(let i = $0cf031cb80554143$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $0cf031cb80554143$var$INTERVALS[$0cf031cb80554143$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $0cf031cb80554143$var$UNITS[i];
    }
    return $0cf031cb80554143$var$UNITS[ilen - 1];
}
function $0cf031cb80554143$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $0cf031cb80554143$var$UNITS.length - 1; i >= $0cf031cb80554143$var$UNITS.indexOf(minUnit); i--){
        const unit = $0cf031cb80554143$var$UNITS[i];
        if ($0cf031cb80554143$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $0cf031cb80554143$var$UNITS[minUnit ? $0cf031cb80554143$var$UNITS.indexOf(minUnit) : 0];
}
function $0cf031cb80554143$var$determineMajorUnit(unit) {
    for(let i = $0cf031cb80554143$var$UNITS.indexOf(unit) + 1, ilen = $0cf031cb80554143$var$UNITS.length; i < ilen; ++i){
        if ($0cf031cb80554143$var$INTERVALS[$0cf031cb80554143$var$UNITS[i]].common) return $0cf031cb80554143$var$UNITS[i];
    }
}
function $0cf031cb80554143$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $22594696cd565665$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $0cf031cb80554143$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $0cf031cb80554143$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $0cf031cb80554143$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $0cf031cb80554143$export$a894c72689ff3ec extends $0cf031cb80554143$export$d60cfc58d3c358b6 {
    static id = "time";
    static defaults = {
        bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            source: "auto",
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $0cf031cb80554143$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $22594696cd565665$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $0cf031cb80554143$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $22594696cd565665$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $22594696cd565665$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $22594696cd565665$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $0cf031cb80554143$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $0cf031cb80554143$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $0cf031cb80554143$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $0cf031cb80554143$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $22594696cd565665$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $22594696cd565665$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $0cf031cb80554143$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $22594696cd565665$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $22594696cd565665$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$0cf031cb80554143$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $0cf031cb80554143$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($0cf031cb80554143$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $22594696cd565665$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $22594696cd565665$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $0cf031cb80554143$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($0cf031cb80554143$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $22594696cd565665$export$71511d61b312f219)(values.sort($0cf031cb80554143$var$sorter));
    }
}
function $0cf031cb80554143$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $22594696cd565665$export$ef35774e6d314e91)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $22594696cd565665$export$ef35774e6d314e91)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $0cf031cb80554143$export$85df64a8eb6dc986 extends $0cf031cb80554143$export$a894c72689ff3ec {
    static id = "timeseries";
    static defaults = $0cf031cb80554143$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $0cf031cb80554143$var$interpolate(table, this.min);
        this._tableRange = $0cf031cb80554143$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($0cf031cb80554143$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $0cf031cb80554143$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $0cf031cb80554143$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $0cf031cb80554143$export$29e663ba4d09fe7,
    LinearScale: $0cf031cb80554143$export$e7f4e5e8656f0b93,
    LogarithmicScale: $0cf031cb80554143$export$85295eaf7cb3ac3e,
    RadialLinearScale: $0cf031cb80554143$export$cfafc36d95386d38,
    TimeScale: $0cf031cb80554143$export$a894c72689ff3ec,
    TimeSeriesScale: $0cf031cb80554143$export$85df64a8eb6dc986
});
const $0cf031cb80554143$export$e8959e79e3af550f = [
    $0cf031cb80554143$export$a6506504f799c5d5,
    $0cf031cb80554143$export$7a5d735b2ab6389d,
    $0cf031cb80554143$export$8b3ca321c77fdea6,
    $0cf031cb80554143$export$bcac1c16f1530ec2
];



var $eFMZj = parcelRequire("eFMZj");

const $2ac768a2f15b75cc$var$defaultDatasetIdKey = "label";
function $2ac768a2f15b75cc$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $2ac768a2f15b75cc$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $2ac768a2f15b75cc$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $2ac768a2f15b75cc$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $2ac768a2f15b75cc$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $2ac768a2f15b75cc$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2ac768a2f15b75cc$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $2ac768a2f15b75cc$var$setLabels(nextData, data.labels);
    $2ac768a2f15b75cc$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $2ac768a2f15b75cc$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $2ac768a2f15b75cc$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $2ac768a2f15b75cc$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $2ac768a2f15b75cc$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $eFMZj.useRef)(null);
    const chartRef = (0, $eFMZj.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $0cf031cb80554143$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $2ac768a2f15b75cc$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $2ac768a2f15b75cc$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $2ac768a2f15b75cc$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $eFMZj.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $2ac768a2f15b75cc$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $eFMZj.useEffect)(()=>{
        if (!redraw && chartRef.current) $2ac768a2f15b75cc$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $eFMZj.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $2ac768a2f15b75cc$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $eFMZj.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $eFMZj.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $eFMZj.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eFMZj))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const $2ac768a2f15b75cc$export$acaa6426d77a227e = /*#__PURE__*/ (0, $eFMZj.forwardRef)($2ac768a2f15b75cc$var$ChartComponent);
function $2ac768a2f15b75cc$var$createTypedChart(type, registerables) {
    (0, $0cf031cb80554143$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $eFMZj.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eFMZj))).createElement($2ac768a2f15b75cc$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $2ac768a2f15b75cc$export$17d680238e50603e = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("line", (0, $0cf031cb80554143$export$3c9b5d28c11cbfd0));
const $2ac768a2f15b75cc$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("bar", (0, $0cf031cb80554143$export$e97d5dc64e999004));
const $2ac768a2f15b75cc$export$bace472c466fdd25 = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("radar", (0, $0cf031cb80554143$export$48dbc6ac651bf8be));
const $2ac768a2f15b75cc$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("doughnut", (0, $0cf031cb80554143$export$e04603e7d8b77172));
const $2ac768a2f15b75cc$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("polarArea", (0, $0cf031cb80554143$export$2a270b3a0d973c85));
const $2ac768a2f15b75cc$export$646feb54fbadbe06 = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("bubble", (0, $0cf031cb80554143$export$19b5c4773f17abe));
const $2ac768a2f15b75cc$export$2ae8800cf67c848c = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("pie", (0, $0cf031cb80554143$export$b21a3f1286706191));
const $2ac768a2f15b75cc$export$1c460fb4285edadc = /* #__PURE__ */ $2ac768a2f15b75cc$var$createTypedChart("scatter", (0, $0cf031cb80554143$export$b2f2bae6713db87));


(0, $0cf031cb80554143$export$acaa6426d77a227e).register((0, $0cf031cb80554143$export$29e663ba4d09fe7), (0, $0cf031cb80554143$export$e7f4e5e8656f0b93), (0, $0cf031cb80554143$export$bd159b522b230b7a), (0, $0cf031cb80554143$export$55e463fa7bcd3469), (0, $0cf031cb80554143$export$f99233281efd08a0), (0, $0cf031cb80554143$export$28c660c63b792dea), (0, $0cf031cb80554143$export$ed247974535929c7));
const $6acc28114d203e0f$export$41c562ebe57d11e2 = {
    responsive: true,
    plugins: {
        legend: {
            position: "top"
        },
        // const Chart = () => {
        title: {
            display: true,
            text: "Chart.js Line Chart"
        }
    }
};
const $6acc28114d203e0f$var$Chart = (props)=>{
    const data = {
        labels: props.labels,
        datasets: props.datasets
    };
    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $2ac768a2f15b75cc$export$17d680238e50603e), {
        options: $6acc28114d203e0f$export$41c562ebe57d11e2,
        data: data
    });
};
var $6acc28114d203e0f$export$2e2bcd8739ae039 = $6acc28114d203e0f$var$Chart;


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $2fa74e0d35df6ea4$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$2fa74e0d35df6ea4$export$2e2bcd8739ae039 = $2fa74e0d35df6ea4$export$e67a095c620b86fe;


/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $df78b8a31cfb4938$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$df78b8a31cfb4938$export$2e2bcd8739ae039 = $df78b8a31cfb4938$export$ead8a1812b171991;


function $f9cba28c27e4fe95$export$dd412b56f1e4d8aa(date, amount) {
    const _date = (0, $2fa74e0d35df6ea4$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $df78b8a31cfb4938$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$f9cba28c27e4fe95$export$2e2bcd8739ae039 = $f9cba28c27e4fe95$export$dd412b56f1e4d8aa;




var $eFMZj = parcelRequire("eFMZj");
var $4a2650a25edc3aa6$exports = {};
"use strict";
var $cafa819bac795364$exports = {};

$parcel$export($cafa819bac795364$exports, "add", () => $cafa819bac795364$export$e16d8520af44a096, (v) => $cafa819bac795364$export$e16d8520af44a096 = v);
var $cafa819bac795364$export$e16d8520af44a096;
"use strict";
$cafa819bac795364$export$e16d8520af44a096 = $cafa819bac795364$var$add;
var $c520f1511b64acf6$exports = {};

$parcel$export($c520f1511b64acf6$exports, "addDays", () => $c520f1511b64acf6$export$dd412b56f1e4d8aa, (v) => $c520f1511b64acf6$export$dd412b56f1e4d8aa = v);
var $c520f1511b64acf6$export$dd412b56f1e4d8aa;
"use strict";
$c520f1511b64acf6$export$dd412b56f1e4d8aa = $c520f1511b64acf6$var$addDays;
var $ce0fc8830a11c560$exports = {};

$parcel$export($ce0fc8830a11c560$exports, "toDate", () => $ce0fc8830a11c560$export$e67a095c620b86fe, (v) => $ce0fc8830a11c560$export$e67a095c620b86fe = v);
var $ce0fc8830a11c560$export$e67a095c620b86fe;
"use strict";
$ce0fc8830a11c560$export$e67a095c620b86fe = $ce0fc8830a11c560$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $ce0fc8830a11c560$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}


var $d122570071c49798$exports = {};

$parcel$export($d122570071c49798$exports, "constructFrom", () => $d122570071c49798$export$ead8a1812b171991, (v) => $d122570071c49798$export$ead8a1812b171991 = v);
var $d122570071c49798$export$ead8a1812b171991;
"use strict";
$d122570071c49798$export$ead8a1812b171991 = $d122570071c49798$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $d122570071c49798$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $c520f1511b64acf6$var$addDays(date, amount) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $d122570071c49798$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}


var $7fad57ce385af81f$exports = {};

$parcel$export($7fad57ce385af81f$exports, "addMonths", () => $7fad57ce385af81f$export$17c93e242b2d3a22, (v) => $7fad57ce385af81f$export$17c93e242b2d3a22 = v);
var $7fad57ce385af81f$export$17c93e242b2d3a22;
"use strict";
$7fad57ce385af81f$export$17c93e242b2d3a22 = $7fad57ce385af81f$var$addMonths;


/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $7fad57ce385af81f$var$addMonths(date, amount) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $d122570071c49798$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $d122570071c49798$export$ead8a1812b171991)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}




/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $cafa819bac795364$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const dateWithMonths = months || years ? (0, $7fad57ce385af81f$export$17c93e242b2d3a22)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $d122570071c49798$export$ead8a1812b171991)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}


Object.keys($cafa819bac795364$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $cafa819bac795364$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $cafa819bac795364$exports[key];
        }
    });
});
var $66d557e404af808a$exports = {};

$parcel$export($66d557e404af808a$exports, "addBusinessDays", () => $66d557e404af808a$export$f087b9ada3136ae9, (v) => $66d557e404af808a$export$f087b9ada3136ae9 = v);
var $66d557e404af808a$export$f087b9ada3136ae9;
"use strict";
$66d557e404af808a$export$f087b9ada3136ae9 = $66d557e404af808a$var$addBusinessDays;

var $32791e28314ec933$exports = {};

$parcel$export($32791e28314ec933$exports, "isSaturday", () => $32791e28314ec933$export$def9f260655b3a76, (v) => $32791e28314ec933$export$def9f260655b3a76 = v);
var $32791e28314ec933$export$def9f260655b3a76;
"use strict";
$32791e28314ec933$export$def9f260655b3a76 = $32791e28314ec933$var$isSaturday;

/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $32791e28314ec933$var$isSaturday(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay() === 6;
}


var $1988039d914ad977$exports = {};

$parcel$export($1988039d914ad977$exports, "isSunday", () => $1988039d914ad977$export$70f720dfc6028987, (v) => $1988039d914ad977$export$70f720dfc6028987 = v);
var $1988039d914ad977$export$70f720dfc6028987;
"use strict";
$1988039d914ad977$export$70f720dfc6028987 = $1988039d914ad977$var$isSunday;

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $1988039d914ad977$var$isSunday(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay() === 0;
}


var $72883b968e5b403e$exports = {};

$parcel$export($72883b968e5b403e$exports, "isWeekend", () => $72883b968e5b403e$export$618d60ea299da42, (v) => $72883b968e5b403e$export$618d60ea299da42 = v);
var $72883b968e5b403e$export$618d60ea299da42;
"use strict";
$72883b968e5b403e$export$618d60ea299da42 = $72883b968e5b403e$var$isWeekend;

/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $72883b968e5b403e$var$isWeekend(date) {
    const day = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay();
    return day === 0 || day === 6;
}



/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $66d557e404af808a$var$addBusinessDays(date, amount) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const startedOnWeekend = (0, $72883b968e5b403e$export$618d60ea299da42)(_date);
    if (isNaN(amount)) return (0, $d122570071c49798$export$ead8a1812b171991)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $72883b968e5b403e$export$618d60ea299da42)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $72883b968e5b403e$export$618d60ea299da42)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $32791e28314ec933$export$def9f260655b3a76)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $1988039d914ad977$export$70f720dfc6028987)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}


Object.keys($66d557e404af808a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $66d557e404af808a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $66d557e404af808a$exports[key];
        }
    });
});

Object.keys($c520f1511b64acf6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c520f1511b64acf6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c520f1511b64acf6$exports[key];
        }
    });
});
var $4e19a7d9910c20d1$exports = {};

$parcel$export($4e19a7d9910c20d1$exports, "addHours", () => $4e19a7d9910c20d1$export$4a4306ad4fa0e5e6, (v) => $4e19a7d9910c20d1$export$4a4306ad4fa0e5e6 = v);
var $4e19a7d9910c20d1$export$4a4306ad4fa0e5e6;
"use strict";
$4e19a7d9910c20d1$export$4a4306ad4fa0e5e6 = $4e19a7d9910c20d1$var$addHours;
var $75a2a6b86d6d60b2$exports = {};

$parcel$export($75a2a6b86d6d60b2$exports, "addMilliseconds", () => $75a2a6b86d6d60b2$export$baf757aaf0c95c94, (v) => $75a2a6b86d6d60b2$export$baf757aaf0c95c94 = v);
var $75a2a6b86d6d60b2$export$baf757aaf0c95c94;
"use strict";
$75a2a6b86d6d60b2$export$baf757aaf0c95c94 = $75a2a6b86d6d60b2$var$addMilliseconds;


/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $75a2a6b86d6d60b2$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    return (0, $d122570071c49798$export$ead8a1812b171991)(date, timestamp + amount);
}


var $68a6706ec8075339$export$7271e9e3478110d1;
var $68a6706ec8075339$export$34804a017b31e2fe;
var $68a6706ec8075339$export$be1dccf2de902d31;
var $68a6706ec8075339$export$8e6600bbdee7dabb;
var $68a6706ec8075339$export$a77c1a7ebebe2a5a;
var $68a6706ec8075339$export$698aec755e92c695;
var $68a6706ec8075339$export$815a9362476d2fe3;
var $68a6706ec8075339$export$4db7641526e3241f;
var $68a6706ec8075339$export$80d7e435f744f319;
var $68a6706ec8075339$export$3c58128db900d44e;
var $68a6706ec8075339$export$3633035e63cee86a;
var $68a6706ec8075339$export$ab7da2ccd1075c38;
var $68a6706ec8075339$export$f2f5ae5a8e2d8f9f;
var $68a6706ec8075339$export$2423174df8cd3cd2;
var $68a6706ec8075339$export$4dec998e48f9c246;
var $68a6706ec8075339$export$4fad13613e88edc8;
var $68a6706ec8075339$export$397c2d5776aa9055;
var $68a6706ec8075339$export$91246f0b9bd9beff;
var $68a6706ec8075339$export$7f72910d6dfd237a;
var $68a6706ec8075339$export$b76b1809a2898f9a;
var $68a6706ec8075339$export$81caae6e1cc7a622;
var $68a6706ec8075339$export$3913210603d8e9ae;
var $68a6706ec8075339$export$dfd9b671c89acc8e;
"use strict";
$68a6706ec8075339$export$7271e9e3478110d1 = $68a6706ec8075339$export$34804a017b31e2fe = $68a6706ec8075339$export$be1dccf2de902d31 = $68a6706ec8075339$export$8e6600bbdee7dabb = $68a6706ec8075339$export$a77c1a7ebebe2a5a = $68a6706ec8075339$export$698aec755e92c695 = $68a6706ec8075339$export$815a9362476d2fe3 = $68a6706ec8075339$export$4db7641526e3241f = $68a6706ec8075339$export$80d7e435f744f319 = $68a6706ec8075339$export$3c58128db900d44e = $68a6706ec8075339$export$3633035e63cee86a = $68a6706ec8075339$export$ab7da2ccd1075c38 = $68a6706ec8075339$export$f2f5ae5a8e2d8f9f = $68a6706ec8075339$export$2423174df8cd3cd2 = $68a6706ec8075339$export$4dec998e48f9c246 = $68a6706ec8075339$export$4fad13613e88edc8 = $68a6706ec8075339$export$397c2d5776aa9055 = $68a6706ec8075339$export$91246f0b9bd9beff = $68a6706ec8075339$export$7f72910d6dfd237a = $68a6706ec8075339$export$b76b1809a2898f9a = $68a6706ec8075339$export$81caae6e1cc7a622 = $68a6706ec8075339$export$3913210603d8e9ae = $68a6706ec8075339$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $68a6706ec8075339$var$daysInWeek = $68a6706ec8075339$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $68a6706ec8075339$var$daysInYear = $68a6706ec8075339$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $68a6706ec8075339$var$maxTime = $68a6706ec8075339$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $68a6706ec8075339$var$minTime = $68a6706ec8075339$export$4dec998e48f9c246 = -$68a6706ec8075339$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $68a6706ec8075339$var$millisecondsInWeek = $68a6706ec8075339$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $68a6706ec8075339$var$millisecondsInDay = $68a6706ec8075339$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $68a6706ec8075339$var$millisecondsInMinute = $68a6706ec8075339$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $68a6706ec8075339$var$millisecondsInHour = $68a6706ec8075339$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $68a6706ec8075339$var$millisecondsInSecond = $68a6706ec8075339$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $68a6706ec8075339$var$minutesInYear = $68a6706ec8075339$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $68a6706ec8075339$var$minutesInMonth = $68a6706ec8075339$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $68a6706ec8075339$var$minutesInDay = $68a6706ec8075339$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $68a6706ec8075339$var$minutesInHour = $68a6706ec8075339$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $68a6706ec8075339$var$monthsInQuarter = $68a6706ec8075339$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $68a6706ec8075339$var$monthsInYear = $68a6706ec8075339$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $68a6706ec8075339$var$quartersInYear = $68a6706ec8075339$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $68a6706ec8075339$var$secondsInHour = $68a6706ec8075339$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $68a6706ec8075339$var$secondsInMinute = $68a6706ec8075339$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $68a6706ec8075339$var$secondsInDay = $68a6706ec8075339$export$815a9362476d2fe3 = $68a6706ec8075339$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $68a6706ec8075339$var$secondsInWeek = $68a6706ec8075339$export$34804a017b31e2fe = $68a6706ec8075339$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $68a6706ec8075339$var$secondsInYear = $68a6706ec8075339$export$7271e9e3478110d1 = $68a6706ec8075339$var$secondsInDay * $68a6706ec8075339$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $68a6706ec8075339$var$secondsInMonth = $68a6706ec8075339$export$8e6600bbdee7dabb = $68a6706ec8075339$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $68a6706ec8075339$var$secondsInQuarter = $68a6706ec8075339$export$be1dccf2de902d31 = $68a6706ec8075339$var$secondsInMonth * 3;


/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $4e19a7d9910c20d1$var$addHours(date, amount) {
    return (0, $75a2a6b86d6d60b2$export$baf757aaf0c95c94)(date, amount * $68a6706ec8075339$export$7f72910d6dfd237a);
}


Object.keys($4e19a7d9910c20d1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $4e19a7d9910c20d1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $4e19a7d9910c20d1$exports[key];
        }
    });
});
var $896ff0227cc591c6$exports = {};

$parcel$export($896ff0227cc591c6$exports, "addISOWeekYears", () => $896ff0227cc591c6$export$c8240694da10d5f, (v) => $896ff0227cc591c6$export$c8240694da10d5f = v);
var $896ff0227cc591c6$export$c8240694da10d5f;
"use strict";
$896ff0227cc591c6$export$c8240694da10d5f = $896ff0227cc591c6$var$addISOWeekYears;
var $14ce8a7023d6978a$exports = {};

$parcel$export($14ce8a7023d6978a$exports, "getISOWeekYear", () => $14ce8a7023d6978a$export$3dbc52535f6f8fcc, (v) => $14ce8a7023d6978a$export$3dbc52535f6f8fcc = v);
var $14ce8a7023d6978a$export$3dbc52535f6f8fcc;
"use strict";
$14ce8a7023d6978a$export$3dbc52535f6f8fcc = $14ce8a7023d6978a$var$getISOWeekYear;

var $e35c31db2e1e85b1$exports = {};

$parcel$export($e35c31db2e1e85b1$exports, "startOfISOWeek", () => $e35c31db2e1e85b1$export$6173213f95a4431e, (v) => $e35c31db2e1e85b1$export$6173213f95a4431e = v);
var $e35c31db2e1e85b1$export$6173213f95a4431e;
"use strict";
$e35c31db2e1e85b1$export$6173213f95a4431e = $e35c31db2e1e85b1$var$startOfISOWeek;
var $4e0d9d2cb57da1ac$exports = {};

$parcel$export($4e0d9d2cb57da1ac$exports, "startOfWeek", () => $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4, (v) => $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4 = v);
var $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4;
"use strict";
$4e0d9d2cb57da1ac$export$42c81a444fbfb5d4 = $4e0d9d2cb57da1ac$var$startOfWeek;

var $56871551bba7dca4$export$430a3269e24b912e;
var $56871551bba7dca4$export$95365be1b0704abc;
"use strict";
$56871551bba7dca4$export$430a3269e24b912e = $56871551bba7dca4$var$getDefaultOptions;
$56871551bba7dca4$export$95365be1b0704abc = $56871551bba7dca4$var$setDefaultOptions;
let $56871551bba7dca4$var$defaultOptions = {};
function $56871551bba7dca4$var$getDefaultOptions() {
    return $56871551bba7dca4$var$defaultOptions;
}
function $56871551bba7dca4$var$setDefaultOptions(newOptions) {
    $56871551bba7dca4$var$defaultOptions = newOptions;
}


/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $4e0d9d2cb57da1ac$var$startOfWeek(date, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $e35c31db2e1e85b1$var$startOfISOWeek(date) {
    return (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $14ce8a7023d6978a$var$getISOWeekYear(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}


var $e2882b111a87d031$exports = {};

$parcel$export($e2882b111a87d031$exports, "setISOWeekYear", () => $e2882b111a87d031$export$814397aabf10ab77, (v) => $e2882b111a87d031$export$814397aabf10ab77 = v);
var $e2882b111a87d031$export$814397aabf10ab77;
"use strict";
$e2882b111a87d031$export$814397aabf10ab77 = $e2882b111a87d031$var$setISOWeekYear;

var $db8722365c910ec5$exports = {};

$parcel$export($db8722365c910ec5$exports, "differenceInCalendarDays", () => $db8722365c910ec5$export$4a02e9c37dab4871, (v) => $db8722365c910ec5$export$4a02e9c37dab4871 = v);
var $db8722365c910ec5$export$4a02e9c37dab4871;
"use strict";
$db8722365c910ec5$export$4a02e9c37dab4871 = $db8722365c910ec5$var$differenceInCalendarDays;

var $ffa24db69fa668a4$exports = {};

$parcel$export($ffa24db69fa668a4$exports, "startOfDay", () => $ffa24db69fa668a4$export$63fa379ae8a9ba2, (v) => $ffa24db69fa668a4$export$63fa379ae8a9ba2 = v);
var $ffa24db69fa668a4$export$63fa379ae8a9ba2;
"use strict";
$ffa24db69fa668a4$export$63fa379ae8a9ba2 = $ffa24db69fa668a4$var$startOfDay;

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $ffa24db69fa668a4$var$startOfDay(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


var $588883c191ca40e9$export$113002b5eff6e430;
"use strict";
$588883c191ca40e9$export$113002b5eff6e430 = $588883c191ca40e9$var$getTimezoneOffsetInMilliseconds;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $588883c191ca40e9$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $db8722365c910ec5$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $ffa24db69fa668a4$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $ffa24db69fa668a4$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $588883c191ca40e9$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $588883c191ca40e9$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $68a6706ec8075339$export$b76b1809a2898f9a);
}


var $b2d2382037e56893$exports = {};

$parcel$export($b2d2382037e56893$exports, "startOfISOWeekYear", () => $b2d2382037e56893$export$236bdfa374eb69a9, (v) => $b2d2382037e56893$export$236bdfa374eb69a9 = v);
var $b2d2382037e56893$export$236bdfa374eb69a9;
"use strict";
$b2d2382037e56893$export$236bdfa374eb69a9 = $b2d2382037e56893$var$startOfISOWeekYear;



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $b2d2382037e56893$var$startOfISOWeekYear(date) {
    const year = (0, $14ce8a7023d6978a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(fourthOfJanuary);
}



/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $e2882b111a87d031$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const diff = (0, $db8722365c910ec5$export$4a02e9c37dab4871)(_date, (0, $b2d2382037e56893$export$236bdfa374eb69a9)(_date));
    const fourthOfJanuary = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $b2d2382037e56893$export$236bdfa374eb69a9)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $896ff0227cc591c6$var$addISOWeekYears(date, amount) {
    return (0, $e2882b111a87d031$export$814397aabf10ab77)(date, (0, $14ce8a7023d6978a$export$3dbc52535f6f8fcc)(date) + amount);
}


Object.keys($896ff0227cc591c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $896ff0227cc591c6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $896ff0227cc591c6$exports[key];
        }
    });
});

Object.keys($75a2a6b86d6d60b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $75a2a6b86d6d60b2$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $75a2a6b86d6d60b2$exports[key];
        }
    });
});
var $3ef862ba623316f3$exports = {};

$parcel$export($3ef862ba623316f3$exports, "addMinutes", () => $3ef862ba623316f3$export$2287e3d29250119e, (v) => $3ef862ba623316f3$export$2287e3d29250119e = v);
var $3ef862ba623316f3$export$2287e3d29250119e;
"use strict";
$3ef862ba623316f3$export$2287e3d29250119e = $3ef862ba623316f3$var$addMinutes;


/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $3ef862ba623316f3$var$addMinutes(date, amount) {
    return (0, $75a2a6b86d6d60b2$export$baf757aaf0c95c94)(date, amount * $68a6706ec8075339$export$91246f0b9bd9beff);
}


Object.keys($3ef862ba623316f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3ef862ba623316f3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3ef862ba623316f3$exports[key];
        }
    });
});

Object.keys($7fad57ce385af81f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $7fad57ce385af81f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $7fad57ce385af81f$exports[key];
        }
    });
});
var $fc5f3bd56b1e4b07$exports = {};

$parcel$export($fc5f3bd56b1e4b07$exports, "addQuarters", () => $fc5f3bd56b1e4b07$export$c252a41d0fbed2ce, (v) => $fc5f3bd56b1e4b07$export$c252a41d0fbed2ce = v);
var $fc5f3bd56b1e4b07$export$c252a41d0fbed2ce;
"use strict";
$fc5f3bd56b1e4b07$export$c252a41d0fbed2ce = $fc5f3bd56b1e4b07$var$addQuarters;

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $fc5f3bd56b1e4b07$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $7fad57ce385af81f$export$17c93e242b2d3a22)(date, months);
}


Object.keys($fc5f3bd56b1e4b07$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $fc5f3bd56b1e4b07$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $fc5f3bd56b1e4b07$exports[key];
        }
    });
});
var $a4a2380920bba7a6$exports = {};

$parcel$export($a4a2380920bba7a6$exports, "addSeconds", () => $a4a2380920bba7a6$export$3cb31b0df13be68, (v) => $a4a2380920bba7a6$export$3cb31b0df13be68 = v);
var $a4a2380920bba7a6$export$3cb31b0df13be68;
"use strict";
$a4a2380920bba7a6$export$3cb31b0df13be68 = $a4a2380920bba7a6$var$addSeconds;

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $a4a2380920bba7a6$var$addSeconds(date, amount) {
    return (0, $75a2a6b86d6d60b2$export$baf757aaf0c95c94)(date, amount * 1000);
}


Object.keys($a4a2380920bba7a6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a4a2380920bba7a6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a4a2380920bba7a6$exports[key];
        }
    });
});
var $78f454683e97f088$exports = {};

$parcel$export($78f454683e97f088$exports, "addWeeks", () => $78f454683e97f088$export$ef501a2bb4f3ee6b, (v) => $78f454683e97f088$export$ef501a2bb4f3ee6b = v);
var $78f454683e97f088$export$ef501a2bb4f3ee6b;
"use strict";
$78f454683e97f088$export$ef501a2bb4f3ee6b = $78f454683e97f088$var$addWeeks;

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $78f454683e97f088$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(date, days);
}


Object.keys($78f454683e97f088$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $78f454683e97f088$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $78f454683e97f088$exports[key];
        }
    });
});
var $3ee269da3665ce8c$exports = {};

$parcel$export($3ee269da3665ce8c$exports, "addYears", () => $3ee269da3665ce8c$export$3d83eec43f4ea476, (v) => $3ee269da3665ce8c$export$3d83eec43f4ea476 = v);
var $3ee269da3665ce8c$export$3d83eec43f4ea476;
"use strict";
$3ee269da3665ce8c$export$3d83eec43f4ea476 = $3ee269da3665ce8c$var$addYears;

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $3ee269da3665ce8c$var$addYears(date, amount) {
    return (0, $7fad57ce385af81f$export$17c93e242b2d3a22)(date, amount * 12);
}


Object.keys($3ee269da3665ce8c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3ee269da3665ce8c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3ee269da3665ce8c$exports[key];
        }
    });
});
var $9092373d10279d2b$exports = {};

$parcel$export($9092373d10279d2b$exports, "areIntervalsOverlapping", () => $9092373d10279d2b$export$2bf3385645436101, (v) => $9092373d10279d2b$export$2bf3385645436101 = v);
var $9092373d10279d2b$export$2bf3385645436101;
"use strict";
$9092373d10279d2b$export$2bf3385645436101 = $9092373d10279d2b$var$areIntervalsOverlapping;

/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $9092373d10279d2b$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}


Object.keys($9092373d10279d2b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $9092373d10279d2b$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $9092373d10279d2b$exports[key];
        }
    });
});
var $8f24fc77a1105365$exports = {};

$parcel$export($8f24fc77a1105365$exports, "clamp", () => $8f24fc77a1105365$export$7d15b64cf5a3a4c4, (v) => $8f24fc77a1105365$export$7d15b64cf5a3a4c4 = v);
var $8f24fc77a1105365$export$7d15b64cf5a3a4c4;
"use strict";
$8f24fc77a1105365$export$7d15b64cf5a3a4c4 = $8f24fc77a1105365$var$clamp;
var $37aeb77df769e4eb$exports = {};

$parcel$export($37aeb77df769e4eb$exports, "max", () => $37aeb77df769e4eb$export$8960430cfd85939f, (v) => $37aeb77df769e4eb$export$8960430cfd85939f = v);
var $37aeb77df769e4eb$export$8960430cfd85939f;
"use strict";
$37aeb77df769e4eb$export$8960430cfd85939f = $37aeb77df769e4eb$var$max;

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $37aeb77df769e4eb$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}


var $ba124f2aa3edf6f7$exports = {};

$parcel$export($ba124f2aa3edf6f7$exports, "min", () => $ba124f2aa3edf6f7$export$96ec731ed4dcb222, (v) => $ba124f2aa3edf6f7$export$96ec731ed4dcb222 = v);
var $ba124f2aa3edf6f7$export$96ec731ed4dcb222;
"use strict";
$ba124f2aa3edf6f7$export$96ec731ed4dcb222 = $ba124f2aa3edf6f7$var$min;

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $ba124f2aa3edf6f7$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}


/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $8f24fc77a1105365$var$clamp(date, interval) {
    return (0, $ba124f2aa3edf6f7$export$96ec731ed4dcb222)([
        (0, $37aeb77df769e4eb$export$8960430cfd85939f)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}


Object.keys($8f24fc77a1105365$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8f24fc77a1105365$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8f24fc77a1105365$exports[key];
        }
    });
});
var $e6f7397c66f116f3$exports = {};

$parcel$export($e6f7397c66f116f3$exports, "closestIndexTo", () => $e6f7397c66f116f3$export$42127b72a9d091c7, (v) => $e6f7397c66f116f3$export$42127b72a9d091c7 = v);
var $e6f7397c66f116f3$export$42127b72a9d091c7;
"use strict";
$e6f7397c66f116f3$export$42127b72a9d091c7 = $e6f7397c66f116f3$var$closestIndexTo;

/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $e6f7397c66f116f3$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($e6f7397c66f116f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e6f7397c66f116f3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e6f7397c66f116f3$exports[key];
        }
    });
});
var $9860c094e49cb8a1$exports = {};

$parcel$export($9860c094e49cb8a1$exports, "closestTo", () => $9860c094e49cb8a1$export$73858b464497125a, (v) => $9860c094e49cb8a1$export$73858b464497125a = v);
var $9860c094e49cb8a1$export$73858b464497125a;
"use strict";
$9860c094e49cb8a1$export$73858b464497125a = $9860c094e49cb8a1$var$closestTo;


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $9860c094e49cb8a1$var$closestTo(dateToCompare, dates) {
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return (0, $d122570071c49798$export$ead8a1812b171991)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $d122570071c49798$export$ead8a1812b171991)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($9860c094e49cb8a1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $9860c094e49cb8a1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $9860c094e49cb8a1$exports[key];
        }
    });
});
var $976a76a5c353dde9$exports = {};

$parcel$export($976a76a5c353dde9$exports, "compareAsc", () => $976a76a5c353dde9$export$fe114145ae75d197, (v) => $976a76a5c353dde9$export$fe114145ae75d197 = v);
var $976a76a5c353dde9$export$fe114145ae75d197;
"use strict";
$976a76a5c353dde9$export$fe114145ae75d197 = $976a76a5c353dde9$var$compareAsc;

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $976a76a5c353dde9$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($976a76a5c353dde9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $976a76a5c353dde9$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $976a76a5c353dde9$exports[key];
        }
    });
});
var $cbee5aabc8238cb8$exports = {};

$parcel$export($cbee5aabc8238cb8$exports, "compareDesc", () => $cbee5aabc8238cb8$export$ed84005ac9356f7a, (v) => $cbee5aabc8238cb8$export$ed84005ac9356f7a = v);
var $cbee5aabc8238cb8$export$ed84005ac9356f7a;
"use strict";
$cbee5aabc8238cb8$export$ed84005ac9356f7a = $cbee5aabc8238cb8$var$compareDesc;

/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $cbee5aabc8238cb8$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}


Object.keys($cbee5aabc8238cb8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $cbee5aabc8238cb8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $cbee5aabc8238cb8$exports[key];
        }
    });
});

Object.keys($d122570071c49798$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d122570071c49798$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d122570071c49798$exports[key];
        }
    });
});
var $d6257872e87ed1f0$exports = {};

$parcel$export($d6257872e87ed1f0$exports, "constructNow", () => $d6257872e87ed1f0$export$18c3c6510fb97afc, (v) => $d6257872e87ed1f0$export$18c3c6510fb97afc = v);
var $d6257872e87ed1f0$export$18c3c6510fb97afc;
"use strict";
$d6257872e87ed1f0$export$18c3c6510fb97afc = $d6257872e87ed1f0$var$constructNow;

/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $d6257872e87ed1f0$var$constructNow(date) {
    return (0, $d122570071c49798$export$ead8a1812b171991)(date, Date.now());
}


Object.keys($d6257872e87ed1f0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d6257872e87ed1f0$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d6257872e87ed1f0$exports[key];
        }
    });
});
var $78b25a1776fcdbeb$exports = {};

$parcel$export($78b25a1776fcdbeb$exports, "daysToWeeks", () => $78b25a1776fcdbeb$export$66d8b66cbb6006a8, (v) => $78b25a1776fcdbeb$export$66d8b66cbb6006a8 = v);
var $78b25a1776fcdbeb$export$66d8b66cbb6006a8;
"use strict";
$78b25a1776fcdbeb$export$66d8b66cbb6006a8 = $78b25a1776fcdbeb$var$daysToWeeks;

/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $78b25a1776fcdbeb$var$daysToWeeks(days) {
    const weeks = days / $68a6706ec8075339$export$dfd9b671c89acc8e;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($78b25a1776fcdbeb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $78b25a1776fcdbeb$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $78b25a1776fcdbeb$exports[key];
        }
    });
});
var $3b8afe333365cb1d$exports = {};

$parcel$export($3b8afe333365cb1d$exports, "differenceInBusinessDays", () => $3b8afe333365cb1d$export$f30d3269a6c53cb9, (v) => $3b8afe333365cb1d$export$f30d3269a6c53cb9 = v);
var $3b8afe333365cb1d$export$f30d3269a6c53cb9;
"use strict";
$3b8afe333365cb1d$export$f30d3269a6c53cb9 = $3b8afe333365cb1d$var$differenceInBusinessDays;


var $d1275d6457f4d4aa$exports = {};

$parcel$export($d1275d6457f4d4aa$exports, "isSameDay", () => $d1275d6457f4d4aa$export$ea39ec197993aef0, (v) => $d1275d6457f4d4aa$export$ea39ec197993aef0 = v);
var $d1275d6457f4d4aa$export$ea39ec197993aef0;
"use strict";
$d1275d6457f4d4aa$export$ea39ec197993aef0 = $d1275d6457f4d4aa$var$isSameDay;

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $d1275d6457f4d4aa$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $ffa24db69fa668a4$export$63fa379ae8a9ba2)(dateLeft);
    const dateRightStartOfDay = (0, $ffa24db69fa668a4$export$63fa379ae8a9ba2)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}


var $8eac5c8197f2cd9a$exports = {};

$parcel$export($8eac5c8197f2cd9a$exports, "isValid", () => $8eac5c8197f2cd9a$export$1ea939691cdc45b8, (v) => $8eac5c8197f2cd9a$export$1ea939691cdc45b8 = v);
var $8eac5c8197f2cd9a$export$1ea939691cdc45b8;
"use strict";
$8eac5c8197f2cd9a$export$1ea939691cdc45b8 = $8eac5c8197f2cd9a$var$isValid;
var $85b6f418e42a275a$exports = {};

$parcel$export($85b6f418e42a275a$exports, "isDate", () => $85b6f418e42a275a$export$871608497c498473, (v) => $85b6f418e42a275a$export$871608497c498473 = v);
var $85b6f418e42a275a$export$871608497c498473;
"use strict";
$85b6f418e42a275a$export$871608497c498473 = $85b6f418e42a275a$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $85b6f418e42a275a$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $8eac5c8197f2cd9a$var$isValid(date) {
    if (!(0, $85b6f418e42a275a$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}




/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $3b8afe333365cb1d$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    let _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    if (!(0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)(_dateLeft) || !(0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)(_dateRight)) return NaN;
    const calendarDifference = (0, $db8722365c910ec5$export$4a02e9c37dab4871)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $d1275d6457f4d4aa$export$ea39ec197993aef0)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $72883b968e5b403e$export$618d60ea299da42)(_dateRight) ? 0 : sign;
        _dateRight = (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($3b8afe333365cb1d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3b8afe333365cb1d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3b8afe333365cb1d$exports[key];
        }
    });
});

Object.keys($db8722365c910ec5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $db8722365c910ec5$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $db8722365c910ec5$exports[key];
        }
    });
});
var $20ea4ad2a3f2d73a$exports = {};

$parcel$export($20ea4ad2a3f2d73a$exports, "differenceInCalendarISOWeekYears", () => $20ea4ad2a3f2d73a$export$7f8a73dc2e50a070, (v) => $20ea4ad2a3f2d73a$export$7f8a73dc2e50a070 = v);
var $20ea4ad2a3f2d73a$export$7f8a73dc2e50a070;
"use strict";
$20ea4ad2a3f2d73a$export$7f8a73dc2e50a070 = $20ea4ad2a3f2d73a$var$differenceInCalendarISOWeekYears;

/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $20ea4ad2a3f2d73a$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $14ce8a7023d6978a$export$3dbc52535f6f8fcc)(dateLeft) - (0, $14ce8a7023d6978a$export$3dbc52535f6f8fcc)(dateRight);
}


Object.keys($20ea4ad2a3f2d73a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $20ea4ad2a3f2d73a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $20ea4ad2a3f2d73a$exports[key];
        }
    });
});
var $32e77b022e6d1769$exports = {};

$parcel$export($32e77b022e6d1769$exports, "differenceInCalendarISOWeeks", () => $32e77b022e6d1769$export$28df1cb58b17e450, (v) => $32e77b022e6d1769$export$28df1cb58b17e450 = v);
var $32e77b022e6d1769$export$28df1cb58b17e450;
"use strict";
$32e77b022e6d1769$export$28df1cb58b17e450 = $32e77b022e6d1769$var$differenceInCalendarISOWeeks;



/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $32e77b022e6d1769$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(dateLeft);
    const startOfISOWeekRight = (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $588883c191ca40e9$export$113002b5eff6e430)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $588883c191ca40e9$export$113002b5eff6e430)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $68a6706ec8075339$export$4fad13613e88edc8);
}


Object.keys($32e77b022e6d1769$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $32e77b022e6d1769$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $32e77b022e6d1769$exports[key];
        }
    });
});
var $f0f727c269611d4e$exports = {};

$parcel$export($f0f727c269611d4e$exports, "differenceInCalendarMonths", () => $f0f727c269611d4e$export$489984ac7c996389, (v) => $f0f727c269611d4e$export$489984ac7c996389 = v);
var $f0f727c269611d4e$export$489984ac7c996389;
"use strict";
$f0f727c269611d4e$export$489984ac7c996389 = $f0f727c269611d4e$var$differenceInCalendarMonths;

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $f0f727c269611d4e$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}


Object.keys($f0f727c269611d4e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f0f727c269611d4e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f0f727c269611d4e$exports[key];
        }
    });
});
var $f9130f4f4a28ee9f$exports = {};

$parcel$export($f9130f4f4a28ee9f$exports, "differenceInCalendarQuarters", () => $f9130f4f4a28ee9f$export$f62ae9fb13958c7a, (v) => $f9130f4f4a28ee9f$export$f62ae9fb13958c7a = v);
var $f9130f4f4a28ee9f$export$f62ae9fb13958c7a;
"use strict";
$f9130f4f4a28ee9f$export$f62ae9fb13958c7a = $f9130f4f4a28ee9f$var$differenceInCalendarQuarters;
var $77d1eba5f0a0b035$exports = {};

$parcel$export($77d1eba5f0a0b035$exports, "getQuarter", () => $77d1eba5f0a0b035$export$de90a4bb31c25221, (v) => $77d1eba5f0a0b035$export$de90a4bb31c25221 = v);
var $77d1eba5f0a0b035$export$de90a4bb31c25221;
"use strict";
$77d1eba5f0a0b035$export$de90a4bb31c25221 = $77d1eba5f0a0b035$var$getQuarter;

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $77d1eba5f0a0b035$var$getQuarter(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $f9130f4f4a28ee9f$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $77d1eba5f0a0b035$export$de90a4bb31c25221)(_dateLeft) - (0, $77d1eba5f0a0b035$export$de90a4bb31c25221)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}


Object.keys($f9130f4f4a28ee9f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f9130f4f4a28ee9f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f9130f4f4a28ee9f$exports[key];
        }
    });
});
var $dda0d3c8044c7a74$exports = {};

$parcel$export($dda0d3c8044c7a74$exports, "differenceInCalendarWeeks", () => $dda0d3c8044c7a74$export$6ed034ce62348e4, (v) => $dda0d3c8044c7a74$export$6ed034ce62348e4 = v);
var $dda0d3c8044c7a74$export$6ed034ce62348e4;
"use strict";
$dda0d3c8044c7a74$export$6ed034ce62348e4 = $dda0d3c8044c7a74$var$differenceInCalendarWeeks;



/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $dda0d3c8044c7a74$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(dateLeft, options);
    const startOfWeekRight = (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $588883c191ca40e9$export$113002b5eff6e430)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $588883c191ca40e9$export$113002b5eff6e430)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $68a6706ec8075339$export$4fad13613e88edc8);
}


Object.keys($dda0d3c8044c7a74$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $dda0d3c8044c7a74$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $dda0d3c8044c7a74$exports[key];
        }
    });
});
var $575993f708f72d85$exports = {};

$parcel$export($575993f708f72d85$exports, "differenceInCalendarYears", () => $575993f708f72d85$export$c06dce8b38891685, (v) => $575993f708f72d85$export$c06dce8b38891685 = v);
var $575993f708f72d85$export$c06dce8b38891685;
"use strict";
$575993f708f72d85$export$c06dce8b38891685 = $575993f708f72d85$var$differenceInCalendarYears;

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $575993f708f72d85$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}


Object.keys($575993f708f72d85$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $575993f708f72d85$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $575993f708f72d85$exports[key];
        }
    });
});
var $ccddb97e12a36498$exports = {};

$parcel$export($ccddb97e12a36498$exports, "differenceInDays", () => $ccddb97e12a36498$export$86415ebf4eb36b8c, (v) => $ccddb97e12a36498$export$86415ebf4eb36b8c = v);
var $ccddb97e12a36498$export$86415ebf4eb36b8c;
"use strict";
$ccddb97e12a36498$export$86415ebf4eb36b8c = $ccddb97e12a36498$var$differenceInDays;


/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $ccddb97e12a36498$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const sign = $ccddb97e12a36498$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $db8722365c910ec5$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($ccddb97e12a36498$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $ccddb97e12a36498$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($ccddb97e12a36498$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ccddb97e12a36498$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ccddb97e12a36498$exports[key];
        }
    });
});
var $c9ca699389c66572$exports = {};

$parcel$export($c9ca699389c66572$exports, "differenceInHours", () => $c9ca699389c66572$export$5436ca250d4d6872, (v) => $c9ca699389c66572$export$5436ca250d4d6872 = v);
var $c9ca699389c66572$export$5436ca250d4d6872;
"use strict";
$c9ca699389c66572$export$5436ca250d4d6872 = $c9ca699389c66572$var$differenceInHours;
var $e299bd4246a08683$export$b6474a47258c1211;
"use strict";
$e299bd4246a08683$export$b6474a47258c1211 = $e299bd4246a08683$var$getRoundingMethod;
function $e299bd4246a08683$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



var $183df16b9d4c18ff$exports = {};

$parcel$export($183df16b9d4c18ff$exports, "differenceInMilliseconds", () => $183df16b9d4c18ff$export$7be94d13716b4bf6, (v) => $183df16b9d4c18ff$export$7be94d13716b4bf6 = v);
var $183df16b9d4c18ff$export$7be94d13716b4bf6;
"use strict";
$183df16b9d4c18ff$export$7be94d13716b4bf6 = $183df16b9d4c18ff$var$differenceInMilliseconds;

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $183df16b9d4c18ff$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft) - +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
}


/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $c9ca699389c66572$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $183df16b9d4c18ff$export$7be94d13716b4bf6)(dateLeft, dateRight) / $68a6706ec8075339$export$7f72910d6dfd237a;
    return (0, $e299bd4246a08683$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($c9ca699389c66572$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c9ca699389c66572$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c9ca699389c66572$exports[key];
        }
    });
});
var $e354787d71ced5f8$exports = {};

$parcel$export($e354787d71ced5f8$exports, "differenceInISOWeekYears", () => $e354787d71ced5f8$export$bf7bde0b3bf8913a, (v) => $e354787d71ced5f8$export$bf7bde0b3bf8913a = v);
var $e354787d71ced5f8$export$bf7bde0b3bf8913a;
"use strict";
$e354787d71ced5f8$export$bf7bde0b3bf8913a = $e354787d71ced5f8$var$differenceInISOWeekYears;


var $eba9dc4c3864f51d$exports = {};

$parcel$export($eba9dc4c3864f51d$exports, "subISOWeekYears", () => $eba9dc4c3864f51d$export$4f7d47b952f4a0aa, (v) => $eba9dc4c3864f51d$export$4f7d47b952f4a0aa = v);
var $eba9dc4c3864f51d$export$4f7d47b952f4a0aa;
"use strict";
$eba9dc4c3864f51d$export$4f7d47b952f4a0aa = $eba9dc4c3864f51d$var$subISOWeekYears;

/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $eba9dc4c3864f51d$var$subISOWeekYears(date, amount) {
    return (0, $896ff0227cc591c6$export$c8240694da10d5f)(date, -amount);
}



/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $e354787d71ced5f8$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $976a76a5c353dde9$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $20ea4ad2a3f2d73a$export$7f8a73dc2e50a070)(_dateLeft, _dateRight));
    _dateLeft = (0, $eba9dc4c3864f51d$export$4f7d47b952f4a0aa)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $976a76a5c353dde9$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($e354787d71ced5f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e354787d71ced5f8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e354787d71ced5f8$exports[key];
        }
    });
});

Object.keys($183df16b9d4c18ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $183df16b9d4c18ff$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $183df16b9d4c18ff$exports[key];
        }
    });
});
var $8a0c735b714f6109$exports = {};

$parcel$export($8a0c735b714f6109$exports, "differenceInMinutes", () => $8a0c735b714f6109$export$d904251335be481a, (v) => $8a0c735b714f6109$export$d904251335be481a = v);
var $8a0c735b714f6109$export$d904251335be481a;
"use strict";
$8a0c735b714f6109$export$d904251335be481a = $8a0c735b714f6109$var$differenceInMinutes;



/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $8a0c735b714f6109$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $183df16b9d4c18ff$export$7be94d13716b4bf6)(dateLeft, dateRight) / $68a6706ec8075339$export$91246f0b9bd9beff;
    return (0, $e299bd4246a08683$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($8a0c735b714f6109$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8a0c735b714f6109$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8a0c735b714f6109$exports[key];
        }
    });
});
var $edb0c694294ce359$exports = {};

$parcel$export($edb0c694294ce359$exports, "differenceInMonths", () => $edb0c694294ce359$export$fc1ed482c2861792, (v) => $edb0c694294ce359$export$fc1ed482c2861792 = v);
var $edb0c694294ce359$export$fc1ed482c2861792;
"use strict";
$edb0c694294ce359$export$fc1ed482c2861792 = $edb0c694294ce359$var$differenceInMonths;


var $59a7e1998b9978b4$exports = {};

$parcel$export($59a7e1998b9978b4$exports, "isLastDayOfMonth", () => $59a7e1998b9978b4$export$c817d0312007ea5e, (v) => $59a7e1998b9978b4$export$c817d0312007ea5e = v);
var $59a7e1998b9978b4$export$c817d0312007ea5e;
"use strict";
$59a7e1998b9978b4$export$c817d0312007ea5e = $59a7e1998b9978b4$var$isLastDayOfMonth;
var $6608a21bd440e819$exports = {};

$parcel$export($6608a21bd440e819$exports, "endOfDay", () => $6608a21bd440e819$export$eb9a03f0e9aa6cea, (v) => $6608a21bd440e819$export$eb9a03f0e9aa6cea = v);
var $6608a21bd440e819$export$eb9a03f0e9aa6cea;
"use strict";
$6608a21bd440e819$export$eb9a03f0e9aa6cea = $6608a21bd440e819$var$endOfDay;

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $6608a21bd440e819$var$endOfDay(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


var $ecae5d8650b06fbf$exports = {};

$parcel$export($ecae5d8650b06fbf$exports, "endOfMonth", () => $ecae5d8650b06fbf$export$a2258d9c4118825c, (v) => $ecae5d8650b06fbf$export$a2258d9c4118825c = v);
var $ecae5d8650b06fbf$export$a2258d9c4118825c;
"use strict";
$ecae5d8650b06fbf$export$a2258d9c4118825c = $ecae5d8650b06fbf$var$endOfMonth;

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $ecae5d8650b06fbf$var$endOfMonth(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}



/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $59a7e1998b9978b4$var$isLastDayOfMonth(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    return +(0, $6608a21bd440e819$export$eb9a03f0e9aa6cea)(_date) === +(0, $ecae5d8650b06fbf$export$a2258d9c4118825c)(_date);
}



/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $edb0c694294ce359$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $976a76a5c353dde9$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $f0f727c269611d4e$export$489984ac7c996389)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $976a76a5c353dde9$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $59a7e1998b9978b4$export$c817d0312007ea5e)((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft)) && difference === 1 && (0, $976a76a5c353dde9$export$fe114145ae75d197)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($edb0c694294ce359$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $edb0c694294ce359$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $edb0c694294ce359$exports[key];
        }
    });
});
var $c1bee3c8369c14ab$exports = {};

$parcel$export($c1bee3c8369c14ab$exports, "differenceInQuarters", () => $c1bee3c8369c14ab$export$74b5c4055a405552, (v) => $c1bee3c8369c14ab$export$74b5c4055a405552 = v);
var $c1bee3c8369c14ab$export$74b5c4055a405552;
"use strict";
$c1bee3c8369c14ab$export$74b5c4055a405552 = $c1bee3c8369c14ab$var$differenceInQuarters;


/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $c1bee3c8369c14ab$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $edb0c694294ce359$export$fc1ed482c2861792)(dateLeft, dateRight) / 3;
    return (0, $e299bd4246a08683$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($c1bee3c8369c14ab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c1bee3c8369c14ab$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c1bee3c8369c14ab$exports[key];
        }
    });
});
var $b959d7b7ef976870$exports = {};

$parcel$export($b959d7b7ef976870$exports, "differenceInSeconds", () => $b959d7b7ef976870$export$c1889aec51783710, (v) => $b959d7b7ef976870$export$c1889aec51783710 = v);
var $b959d7b7ef976870$export$c1889aec51783710;
"use strict";
$b959d7b7ef976870$export$c1889aec51783710 = $b959d7b7ef976870$var$differenceInSeconds;


/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $b959d7b7ef976870$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $183df16b9d4c18ff$export$7be94d13716b4bf6)(dateLeft, dateRight) / 1000;
    return (0, $e299bd4246a08683$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($b959d7b7ef976870$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b959d7b7ef976870$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b959d7b7ef976870$exports[key];
        }
    });
});
var $d6b8f38f7c33afb5$exports = {};

$parcel$export($d6b8f38f7c33afb5$exports, "differenceInWeeks", () => $d6b8f38f7c33afb5$export$b5147a91dc40ddb7, (v) => $d6b8f38f7c33afb5$export$b5147a91dc40ddb7 = v);
var $d6b8f38f7c33afb5$export$b5147a91dc40ddb7;
"use strict";
$d6b8f38f7c33afb5$export$b5147a91dc40ddb7 = $d6b8f38f7c33afb5$var$differenceInWeeks;


/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $d6b8f38f7c33afb5$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $ccddb97e12a36498$export$86415ebf4eb36b8c)(dateLeft, dateRight) / 7;
    return (0, $e299bd4246a08683$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($d6b8f38f7c33afb5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d6b8f38f7c33afb5$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d6b8f38f7c33afb5$exports[key];
        }
    });
});
var $d362eeeb66bec530$exports = {};

$parcel$export($d362eeeb66bec530$exports, "differenceInYears", () => $d362eeeb66bec530$export$ed6bf486f68899ca, (v) => $d362eeeb66bec530$export$ed6bf486f68899ca = v);
var $d362eeeb66bec530$export$ed6bf486f68899ca;
"use strict";
$d362eeeb66bec530$export$ed6bf486f68899ca = $d362eeeb66bec530$var$differenceInYears;



/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $d362eeeb66bec530$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $976a76a5c353dde9$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $575993f708f72d85$export$c06dce8b38891685)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $976a76a5c353dde9$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($d362eeeb66bec530$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d362eeeb66bec530$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d362eeeb66bec530$exports[key];
        }
    });
});
var $3f754e806fd283ce$exports = {};

$parcel$export($3f754e806fd283ce$exports, "eachDayOfInterval", () => $3f754e806fd283ce$export$7a337e5923c7ceb5, (v) => $3f754e806fd283ce$export$7a337e5923c7ceb5 = v);
var $3f754e806fd283ce$export$7a337e5923c7ceb5;
"use strict";
$3f754e806fd283ce$export$7a337e5923c7ceb5 = $3f754e806fd283ce$var$eachDayOfInterval;

/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $3f754e806fd283ce$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($3f754e806fd283ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3f754e806fd283ce$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3f754e806fd283ce$exports[key];
        }
    });
});
var $d10edd6b6abd7119$exports = {};

$parcel$export($d10edd6b6abd7119$exports, "eachHourOfInterval", () => $d10edd6b6abd7119$export$bb4f48fee90ea86e, (v) => $d10edd6b6abd7119$export$bb4f48fee90ea86e = v);
var $d10edd6b6abd7119$export$bb4f48fee90ea86e;
"use strict";
$d10edd6b6abd7119$export$bb4f48fee90ea86e = $d10edd6b6abd7119$var$eachHourOfInterval;


/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $d10edd6b6abd7119$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $4e19a7d9910c20d1$export$4a4306ad4fa0e5e6)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($d10edd6b6abd7119$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d10edd6b6abd7119$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d10edd6b6abd7119$exports[key];
        }
    });
});
var $ad4ef7d2d708cbc0$exports = {};

$parcel$export($ad4ef7d2d708cbc0$exports, "eachMinuteOfInterval", () => $ad4ef7d2d708cbc0$export$82e17d693ce9eb6c, (v) => $ad4ef7d2d708cbc0$export$82e17d693ce9eb6c = v);
var $ad4ef7d2d708cbc0$export$82e17d693ce9eb6c;
"use strict";
$ad4ef7d2d708cbc0$export$82e17d693ce9eb6c = $ad4ef7d2d708cbc0$var$eachMinuteOfInterval;

var $0d13cf15751d2b2c$exports = {};

$parcel$export($0d13cf15751d2b2c$exports, "startOfMinute", () => $0d13cf15751d2b2c$export$c66440458c6aa793, (v) => $0d13cf15751d2b2c$export$c66440458c6aa793 = v);
var $0d13cf15751d2b2c$export$c66440458c6aa793;
"use strict";
$0d13cf15751d2b2c$export$c66440458c6aa793 = $0d13cf15751d2b2c$var$startOfMinute;

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $0d13cf15751d2b2c$var$startOfMinute(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setSeconds(0, 0);
    return _date;
}



/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $ad4ef7d2d708cbc0$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $0d13cf15751d2b2c$export$c66440458c6aa793)((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start));
    const endDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $3ef862ba623316f3$export$2287e3d29250119e)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($ad4ef7d2d708cbc0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ad4ef7d2d708cbc0$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ad4ef7d2d708cbc0$exports[key];
        }
    });
});
var $40d69d6cc0e45b9a$exports = {};

$parcel$export($40d69d6cc0e45b9a$exports, "eachMonthOfInterval", () => $40d69d6cc0e45b9a$export$1c9322f2d2a5eed3, (v) => $40d69d6cc0e45b9a$export$1c9322f2d2a5eed3 = v);
var $40d69d6cc0e45b9a$export$1c9322f2d2a5eed3;
"use strict";
$40d69d6cc0e45b9a$export$1c9322f2d2a5eed3 = $40d69d6cc0e45b9a$var$eachMonthOfInterval;

/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $40d69d6cc0e45b9a$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($40d69d6cc0e45b9a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $40d69d6cc0e45b9a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $40d69d6cc0e45b9a$exports[key];
        }
    });
});
var $14fe904a4b32a5fd$exports = {};

$parcel$export($14fe904a4b32a5fd$exports, "eachQuarterOfInterval", () => $14fe904a4b32a5fd$export$96790a0abfab0078, (v) => $14fe904a4b32a5fd$export$96790a0abfab0078 = v);
var $14fe904a4b32a5fd$export$96790a0abfab0078;
"use strict";
$14fe904a4b32a5fd$export$96790a0abfab0078 = $14fe904a4b32a5fd$var$eachQuarterOfInterval;

var $a0d6a3a081a59e60$exports = {};

$parcel$export($a0d6a3a081a59e60$exports, "startOfQuarter", () => $a0d6a3a081a59e60$export$69be7267a042ecb3, (v) => $a0d6a3a081a59e60$export$69be7267a042ecb3 = v);
var $a0d6a3a081a59e60$export$69be7267a042ecb3;
"use strict";
$a0d6a3a081a59e60$export$69be7267a042ecb3 = $a0d6a3a081a59e60$var$startOfQuarter;

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $a0d6a3a081a59e60$var$startOfQuarter(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $14fe904a4b32a5fd$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $a0d6a3a081a59e60$export$69be7267a042ecb3)(startDate) : +(0, $a0d6a3a081a59e60$export$69be7267a042ecb3)(endDate);
    let currentDate = reversed ? (0, $a0d6a3a081a59e60$export$69be7267a042ecb3)(endDate) : (0, $a0d6a3a081a59e60$export$69be7267a042ecb3)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $fc5f3bd56b1e4b07$export$c252a41d0fbed2ce)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($14fe904a4b32a5fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $14fe904a4b32a5fd$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $14fe904a4b32a5fd$exports[key];
        }
    });
});
var $7fad9c4437259dff$exports = {};

$parcel$export($7fad9c4437259dff$exports, "eachWeekOfInterval", () => $7fad9c4437259dff$export$d31a8caec75fa456, (v) => $7fad9c4437259dff$export$d31a8caec75fa456 = v);
var $7fad9c4437259dff$export$d31a8caec75fa456;
"use strict";
$7fad9c4437259dff$export$d31a8caec75fa456 = $7fad9c4437259dff$var$eachWeekOfInterval;



/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $7fad9c4437259dff$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(endDate, options) : (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(startDate, options);
    const endDateWeek = reversed ? (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(startDate, options) : (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $78f454683e97f088$export$ef501a2bb4f3ee6b)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($7fad9c4437259dff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $7fad9c4437259dff$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $7fad9c4437259dff$exports[key];
        }
    });
});
var $13b31a552cd06e17$exports = {};

$parcel$export($13b31a552cd06e17$exports, "eachWeekendOfInterval", () => $13b31a552cd06e17$export$a2ae85dd849354a8, (v) => $13b31a552cd06e17$export$a2ae85dd849354a8 = v);
var $13b31a552cd06e17$export$a2ae85dd849354a8;
"use strict";
$13b31a552cd06e17$export$a2ae85dd849354a8 = $13b31a552cd06e17$var$eachWeekendOfInterval;


/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $13b31a552cd06e17$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $3f754e806fd283ce$export$7a337e5923c7ceb5)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $72883b968e5b403e$export$618d60ea299da42)(date)) weekends.push(date);
    }
    return weekends;
}


Object.keys($13b31a552cd06e17$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $13b31a552cd06e17$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $13b31a552cd06e17$exports[key];
        }
    });
});
var $57e0ce3fc48bffaa$exports = {};

$parcel$export($57e0ce3fc48bffaa$exports, "eachWeekendOfMonth", () => $57e0ce3fc48bffaa$export$f9a185d0ad232d17, (v) => $57e0ce3fc48bffaa$export$f9a185d0ad232d17 = v);
var $57e0ce3fc48bffaa$export$f9a185d0ad232d17;
"use strict";
$57e0ce3fc48bffaa$export$f9a185d0ad232d17 = $57e0ce3fc48bffaa$var$eachWeekendOfMonth;


var $079952111a69a2fd$exports = {};

$parcel$export($079952111a69a2fd$exports, "startOfMonth", () => $079952111a69a2fd$export$a5a3b454ada2268e, (v) => $079952111a69a2fd$export$a5a3b454ada2268e = v);
var $079952111a69a2fd$export$a5a3b454ada2268e;
"use strict";
$079952111a69a2fd$export$a5a3b454ada2268e = $079952111a69a2fd$var$startOfMonth;

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $079952111a69a2fd$var$startOfMonth(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $57e0ce3fc48bffaa$var$eachWeekendOfMonth(date) {
    const start = (0, $079952111a69a2fd$export$a5a3b454ada2268e)(date);
    const end = (0, $ecae5d8650b06fbf$export$a2258d9c4118825c)(date);
    return (0, $13b31a552cd06e17$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($57e0ce3fc48bffaa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $57e0ce3fc48bffaa$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $57e0ce3fc48bffaa$exports[key];
        }
    });
});
var $c08022f53a0ad570$exports = {};

$parcel$export($c08022f53a0ad570$exports, "eachWeekendOfYear", () => $c08022f53a0ad570$export$d4a9e5efc1ddceb9, (v) => $c08022f53a0ad570$export$d4a9e5efc1ddceb9 = v);
var $c08022f53a0ad570$export$d4a9e5efc1ddceb9;
"use strict";
$c08022f53a0ad570$export$d4a9e5efc1ddceb9 = $c08022f53a0ad570$var$eachWeekendOfYear;

var $153ced7dcaf9116f$exports = {};

$parcel$export($153ced7dcaf9116f$exports, "endOfYear", () => $153ced7dcaf9116f$export$8b7aa55c66d5569e, (v) => $153ced7dcaf9116f$export$8b7aa55c66d5569e = v);
var $153ced7dcaf9116f$export$8b7aa55c66d5569e;
"use strict";
$153ced7dcaf9116f$export$8b7aa55c66d5569e = $153ced7dcaf9116f$var$endOfYear;

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $153ced7dcaf9116f$var$endOfYear(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


var $2a0c5e290b1b02ec$exports = {};

$parcel$export($2a0c5e290b1b02ec$exports, "startOfYear", () => $2a0c5e290b1b02ec$export$f91e89d3d0406102, (v) => $2a0c5e290b1b02ec$export$f91e89d3d0406102 = v);
var $2a0c5e290b1b02ec$export$f91e89d3d0406102;
"use strict";
$2a0c5e290b1b02ec$export$f91e89d3d0406102 = $2a0c5e290b1b02ec$var$startOfYear;


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $2a0c5e290b1b02ec$var$startOfYear(date) {
    const cleanDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const _date = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $c08022f53a0ad570$var$eachWeekendOfYear(date) {
    const start = (0, $2a0c5e290b1b02ec$export$f91e89d3d0406102)(date);
    const end = (0, $153ced7dcaf9116f$export$8b7aa55c66d5569e)(date);
    return (0, $13b31a552cd06e17$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($c08022f53a0ad570$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c08022f53a0ad570$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c08022f53a0ad570$exports[key];
        }
    });
});
var $1cd8964dee707333$exports = {};

$parcel$export($1cd8964dee707333$exports, "eachYearOfInterval", () => $1cd8964dee707333$export$9b7f165f0a71d2a5, (v) => $1cd8964dee707333$export$9b7f165f0a71d2a5 = v);
var $1cd8964dee707333$export$9b7f165f0a71d2a5;
"use strict";
$1cd8964dee707333$export$9b7f165f0a71d2a5 = $1cd8964dee707333$var$eachYearOfInterval;

/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $1cd8964dee707333$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($1cd8964dee707333$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $1cd8964dee707333$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $1cd8964dee707333$exports[key];
        }
    });
});

Object.keys($6608a21bd440e819$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $6608a21bd440e819$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $6608a21bd440e819$exports[key];
        }
    });
});
var $5948a4ee0623eb8b$exports = {};

$parcel$export($5948a4ee0623eb8b$exports, "endOfDecade", () => $5948a4ee0623eb8b$export$b922ac31d5bbe7a6, (v) => $5948a4ee0623eb8b$export$b922ac31d5bbe7a6 = v);
var $5948a4ee0623eb8b$export$b922ac31d5bbe7a6;
"use strict";
$5948a4ee0623eb8b$export$b922ac31d5bbe7a6 = $5948a4ee0623eb8b$var$endOfDecade;

/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $5948a4ee0623eb8b$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($5948a4ee0623eb8b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5948a4ee0623eb8b$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5948a4ee0623eb8b$exports[key];
        }
    });
});
var $6030ab8520c81ff6$exports = {};

$parcel$export($6030ab8520c81ff6$exports, "endOfHour", () => $6030ab8520c81ff6$export$95ae95d2176c5f0, (v) => $6030ab8520c81ff6$export$95ae95d2176c5f0 = v);
var $6030ab8520c81ff6$export$95ae95d2176c5f0;
"use strict";
$6030ab8520c81ff6$export$95ae95d2176c5f0 = $6030ab8520c81ff6$var$endOfHour;

/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $6030ab8520c81ff6$var$endOfHour(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}


Object.keys($6030ab8520c81ff6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $6030ab8520c81ff6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $6030ab8520c81ff6$exports[key];
        }
    });
});
var $c424c6f4d3cad546$exports = {};

$parcel$export($c424c6f4d3cad546$exports, "endOfISOWeek", () => $c424c6f4d3cad546$export$186cd934f32084be, (v) => $c424c6f4d3cad546$export$186cd934f32084be = v);
var $c424c6f4d3cad546$export$186cd934f32084be;
"use strict";
$c424c6f4d3cad546$export$186cd934f32084be = $c424c6f4d3cad546$var$endOfISOWeek;
var $0f35049740f46db1$exports = {};

$parcel$export($0f35049740f46db1$exports, "endOfWeek", () => $0f35049740f46db1$export$ef8b6d9133084f4e, (v) => $0f35049740f46db1$export$ef8b6d9133084f4e = v);
var $0f35049740f46db1$export$ef8b6d9133084f4e;
"use strict";
$0f35049740f46db1$export$ef8b6d9133084f4e = $0f35049740f46db1$var$endOfWeek;


/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $0f35049740f46db1$var$endOfWeek(date, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $c424c6f4d3cad546$var$endOfISOWeek(date) {
    return (0, $0f35049740f46db1$export$ef8b6d9133084f4e)(date, {
        weekStartsOn: 1
    });
}


Object.keys($c424c6f4d3cad546$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c424c6f4d3cad546$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c424c6f4d3cad546$exports[key];
        }
    });
});
var $6fe29a38d996ca93$exports = {};

$parcel$export($6fe29a38d996ca93$exports, "endOfISOWeekYear", () => $6fe29a38d996ca93$export$73068f3824c9c1d, (v) => $6fe29a38d996ca93$export$73068f3824c9c1d = v);
var $6fe29a38d996ca93$export$73068f3824c9c1d;
"use strict";
$6fe29a38d996ca93$export$73068f3824c9c1d = $6fe29a38d996ca93$var$endOfISOWeekYear;



/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $6fe29a38d996ca93$var$endOfISOWeekYear(date) {
    const year = (0, $14ce8a7023d6978a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuaryOfNextYear = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}


Object.keys($6fe29a38d996ca93$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $6fe29a38d996ca93$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $6fe29a38d996ca93$exports[key];
        }
    });
});
var $d2a5b938447b25e1$exports = {};

$parcel$export($d2a5b938447b25e1$exports, "endOfMinute", () => $d2a5b938447b25e1$export$a06a772fc63bff07, (v) => $d2a5b938447b25e1$export$a06a772fc63bff07 = v);
var $d2a5b938447b25e1$export$a06a772fc63bff07;
"use strict";
$d2a5b938447b25e1$export$a06a772fc63bff07 = $d2a5b938447b25e1$var$endOfMinute;

/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $d2a5b938447b25e1$var$endOfMinute(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setSeconds(59, 999);
    return _date;
}


Object.keys($d2a5b938447b25e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d2a5b938447b25e1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d2a5b938447b25e1$exports[key];
        }
    });
});

Object.keys($ecae5d8650b06fbf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ecae5d8650b06fbf$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ecae5d8650b06fbf$exports[key];
        }
    });
});
var $1791adc6c5bc24fd$exports = {};

$parcel$export($1791adc6c5bc24fd$exports, "endOfQuarter", () => $1791adc6c5bc24fd$export$5f53493861eef879, (v) => $1791adc6c5bc24fd$export$5f53493861eef879 = v);
var $1791adc6c5bc24fd$export$5f53493861eef879;
"use strict";
$1791adc6c5bc24fd$export$5f53493861eef879 = $1791adc6c5bc24fd$var$endOfQuarter;

/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $1791adc6c5bc24fd$var$endOfQuarter(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($1791adc6c5bc24fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $1791adc6c5bc24fd$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $1791adc6c5bc24fd$exports[key];
        }
    });
});
var $ec5d4a31dae112a6$exports = {};

$parcel$export($ec5d4a31dae112a6$exports, "endOfSecond", () => $ec5d4a31dae112a6$export$ef560ab2fa7b52a2, (v) => $ec5d4a31dae112a6$export$ef560ab2fa7b52a2 = v);
var $ec5d4a31dae112a6$export$ef560ab2fa7b52a2;
"use strict";
$ec5d4a31dae112a6$export$ef560ab2fa7b52a2 = $ec5d4a31dae112a6$var$endOfSecond;

/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $ec5d4a31dae112a6$var$endOfSecond(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(999);
    return _date;
}


Object.keys($ec5d4a31dae112a6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ec5d4a31dae112a6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ec5d4a31dae112a6$exports[key];
        }
    });
});
var $dea5f484ec44cf07$exports = {};

$parcel$export($dea5f484ec44cf07$exports, "endOfToday", () => $dea5f484ec44cf07$export$1b7031a80bd92a6e, (v) => $dea5f484ec44cf07$export$1b7031a80bd92a6e = v);
var $dea5f484ec44cf07$export$1b7031a80bd92a6e;
"use strict";
$dea5f484ec44cf07$export$1b7031a80bd92a6e = $dea5f484ec44cf07$var$endOfToday;

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $dea5f484ec44cf07$var$endOfToday() {
    return (0, $6608a21bd440e819$export$eb9a03f0e9aa6cea)(Date.now());
}


Object.keys($dea5f484ec44cf07$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $dea5f484ec44cf07$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $dea5f484ec44cf07$exports[key];
        }
    });
});
var $709286b7f2c002c4$exports = {};

$parcel$export($709286b7f2c002c4$exports, "endOfTomorrow", () => $709286b7f2c002c4$export$d788ac27ae2a54ea, (v) => $709286b7f2c002c4$export$d788ac27ae2a54ea = v);
var $709286b7f2c002c4$export$d788ac27ae2a54ea;
"use strict";
$709286b7f2c002c4$export$d788ac27ae2a54ea = $709286b7f2c002c4$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $709286b7f2c002c4$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($709286b7f2c002c4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $709286b7f2c002c4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $709286b7f2c002c4$exports[key];
        }
    });
});

Object.keys($0f35049740f46db1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0f35049740f46db1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0f35049740f46db1$exports[key];
        }
    });
});

Object.keys($153ced7dcaf9116f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $153ced7dcaf9116f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $153ced7dcaf9116f$exports[key];
        }
    });
});
var $94e08fdc97ae8d7e$exports = {};

$parcel$export($94e08fdc97ae8d7e$exports, "endOfYesterday", () => $94e08fdc97ae8d7e$export$45190faf1024f97a, (v) => $94e08fdc97ae8d7e$export$45190faf1024f97a = v);
var $94e08fdc97ae8d7e$export$45190faf1024f97a;
"use strict";
$94e08fdc97ae8d7e$export$45190faf1024f97a = $94e08fdc97ae8d7e$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $94e08fdc97ae8d7e$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($94e08fdc97ae8d7e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $94e08fdc97ae8d7e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $94e08fdc97ae8d7e$exports[key];
        }
    });
});
var $003ee58a38f5aa97$exports = {};
"use strict";
$003ee58a38f5aa97$exports.format = $003ee58a38f5aa97$exports.formatDate = $003ee58a38f5aa97$var$format;
Object.defineProperty($003ee58a38f5aa97$exports, "formatters", {
    enumerable: true,
    get: function() {
        return $7a03923996f2002a$export$fe98a034cfb96d55;
    }
});
Object.defineProperty($003ee58a38f5aa97$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $14a0de1c0c2d5442$export$70cc8fd02856fd58;
    }
});
var $b5606a4787083ded$exports = {};
"use strict";
Object.defineProperty($b5606a4787083ded$exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $b02594bc4c9f5081$export$137380d9ce54f7f;
    }
});
var $b02594bc4c9f5081$exports = {};

$parcel$export($b02594bc4c9f5081$exports, "enUS", () => $b02594bc4c9f5081$export$137380d9ce54f7f, (v) => $b02594bc4c9f5081$export$137380d9ce54f7f = v);
var $b02594bc4c9f5081$export$137380d9ce54f7f;
"use strict";
$b02594bc4c9f5081$export$137380d9ce54f7f = void 0;
var $26a15732792bd3bc$export$2c14ff85d6318973;
"use strict";
$26a15732792bd3bc$export$2c14ff85d6318973 = void 0;
const $26a15732792bd3bc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $26a15732792bd3bc$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $26a15732792bd3bc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$26a15732792bd3bc$export$2c14ff85d6318973 = $26a15732792bd3bc$var$formatDistance;


var $960590c935cf7e66$export$cbf60ecb96cbb82f;
"use strict";
$960590c935cf7e66$export$cbf60ecb96cbb82f = void 0;
var $8debed4d8224b686$export$38e44e97ce4dbb7d;
"use strict";
$8debed4d8224b686$export$38e44e97ce4dbb7d = $8debed4d8224b686$var$buildFormatLongFn;
function $8debed4d8224b686$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $960590c935cf7e66$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $960590c935cf7e66$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $960590c935cf7e66$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $960590c935cf7e66$var$formatLong = $960590c935cf7e66$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $960590c935cf7e66$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $960590c935cf7e66$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $960590c935cf7e66$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $6902e30e5f40b039$export$8fbbfd65594f46a0;
"use strict";
$6902e30e5f40b039$export$8fbbfd65594f46a0 = void 0;
const $6902e30e5f40b039$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $6902e30e5f40b039$var$formatRelative = (token, _date, _baseDate, _options)=>$6902e30e5f40b039$var$formatRelativeLocale[token];
$6902e30e5f40b039$export$8fbbfd65594f46a0 = $6902e30e5f40b039$var$formatRelative;


var $280713024bd29391$export$b3bd0bc58e36cd63;
"use strict";
$280713024bd29391$export$b3bd0bc58e36cd63 = void 0;
var $70754fa1f3ab9ab1$export$63596d6ee8878b25;
"use strict";
$70754fa1f3ab9ab1$export$63596d6ee8878b25 = $70754fa1f3ab9ab1$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $70754fa1f3ab9ab1$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $280713024bd29391$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $280713024bd29391$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $280713024bd29391$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $280713024bd29391$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $280713024bd29391$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $280713024bd29391$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $280713024bd29391$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $280713024bd29391$var$localize = $280713024bd29391$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $280713024bd29391$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $280713024bd29391$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $280713024bd29391$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $280713024bd29391$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $280713024bd29391$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $280713024bd29391$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $280713024bd29391$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $ece9c2ac1beca5d0$export$4659b591c19bdf3d;
"use strict";
$ece9c2ac1beca5d0$export$4659b591c19bdf3d = void 0;
var $c7bab40ce41055a9$export$1430a0f35710914d;
"use strict";
$c7bab40ce41055a9$export$1430a0f35710914d = $c7bab40ce41055a9$var$buildMatchFn;
function $c7bab40ce41055a9$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $c7bab40ce41055a9$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $c7bab40ce41055a9$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c7bab40ce41055a9$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c7bab40ce41055a9$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


var $8b0286364b664829$export$fdaf2fd6d7edde95;
"use strict";
$8b0286364b664829$export$fdaf2fd6d7edde95 = $8b0286364b664829$var$buildMatchPatternFn;
function $8b0286364b664829$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $ece9c2ac1beca5d0$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $ece9c2ac1beca5d0$var$parseOrdinalNumberPattern = /\d+/i;
const $ece9c2ac1beca5d0$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $ece9c2ac1beca5d0$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $ece9c2ac1beca5d0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $ece9c2ac1beca5d0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ece9c2ac1beca5d0$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $ece9c2ac1beca5d0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ece9c2ac1beca5d0$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $ece9c2ac1beca5d0$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $ece9c2ac1beca5d0$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $ece9c2ac1beca5d0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $ece9c2ac1beca5d0$var$match = $ece9c2ac1beca5d0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $ece9c2ac1beca5d0$var$matchOrdinalNumberPattern,
        parsePattern: $ece9c2ac1beca5d0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ece9c2ac1beca5d0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ece9c2ac1beca5d0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ece9c2ac1beca5d0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ece9c2ac1beca5d0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ece9c2ac1beca5d0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ece9c2ac1beca5d0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ece9c2ac1beca5d0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ece9c2ac1beca5d0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ece9c2ac1beca5d0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ece9c2ac1beca5d0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $b02594bc4c9f5081$var$enUS = $b02594bc4c9f5081$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $26a15732792bd3bc$export$2c14ff85d6318973,
    formatLong: $960590c935cf7e66$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};





var $7a03923996f2002a$export$fe98a034cfb96d55;
"use strict";
$7a03923996f2002a$export$fe98a034cfb96d55 = void 0;
var $30e61c2b7b493e1d$exports = {};

$parcel$export($30e61c2b7b493e1d$exports, "getDayOfYear", () => $30e61c2b7b493e1d$export$d3b42cd8452deec, (v) => $30e61c2b7b493e1d$export$d3b42cd8452deec = v);
var $30e61c2b7b493e1d$export$d3b42cd8452deec;
"use strict";
$30e61c2b7b493e1d$export$d3b42cd8452deec = $30e61c2b7b493e1d$var$getDayOfYear;



/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $30e61c2b7b493e1d$var$getDayOfYear(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const diff = (0, $db8722365c910ec5$export$4a02e9c37dab4871)(_date, (0, $2a0c5e290b1b02ec$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}


var $a5f39ea06618a69d$exports = {};

$parcel$export($a5f39ea06618a69d$exports, "getISOWeek", () => $a5f39ea06618a69d$export$7cabdc5698b63e2f, (v) => $a5f39ea06618a69d$export$7cabdc5698b63e2f = v);
var $a5f39ea06618a69d$export$7cabdc5698b63e2f;
"use strict";
$a5f39ea06618a69d$export$7cabdc5698b63e2f = $a5f39ea06618a69d$var$getISOWeek;




/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $a5f39ea06618a69d$var$getISOWeek(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const diff = +(0, $e35c31db2e1e85b1$export$6173213f95a4431e)(_date) - +(0, $b2d2382037e56893$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $68a6706ec8075339$export$4fad13613e88edc8) + 1;
}



var $cd28fd34ea432b51$exports = {};

$parcel$export($cd28fd34ea432b51$exports, "getWeek", () => $cd28fd34ea432b51$export$efe19b760242b2fc, (v) => $cd28fd34ea432b51$export$efe19b760242b2fc = v);
var $cd28fd34ea432b51$export$efe19b760242b2fc;
"use strict";
$cd28fd34ea432b51$export$efe19b760242b2fc = $cd28fd34ea432b51$var$getWeek;


var $1652bf99f6ce2785$exports = {};

$parcel$export($1652bf99f6ce2785$exports, "startOfWeekYear", () => $1652bf99f6ce2785$export$bb7b45bb8e74da0f, (v) => $1652bf99f6ce2785$export$bb7b45bb8e74da0f = v);
var $1652bf99f6ce2785$export$bb7b45bb8e74da0f;
"use strict";
$1652bf99f6ce2785$export$bb7b45bb8e74da0f = $1652bf99f6ce2785$var$startOfWeekYear;

var $fc873680f7d773ff$exports = {};

$parcel$export($fc873680f7d773ff$exports, "getWeekYear", () => $fc873680f7d773ff$export$12d572480ceb6e58, (v) => $fc873680f7d773ff$export$12d572480ceb6e58 = v);
var $fc873680f7d773ff$export$12d572480ceb6e58;
"use strict";
$fc873680f7d773ff$export$12d572480ceb6e58 = $fc873680f7d773ff$var$getWeekYear;




/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $fc873680f7d773ff$var$getWeekYear(date, options) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $1652bf99f6ce2785$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $fc873680f7d773ff$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}



/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $cd28fd34ea432b51$var$getWeek(date, options) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const diff = +(0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(_date, options) - +(0, $1652bf99f6ce2785$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $68a6706ec8075339$export$4fad13613e88edc8) + 1;
}



var $9f7024483df1879f$export$c8306e720e213c0f;
"use strict";
$9f7024483df1879f$export$c8306e720e213c0f = $9f7024483df1879f$var$addLeadingZeros;
function $9f7024483df1879f$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}


var $675501d264d94e61$export$b0d4b338e1516f13;
"use strict";
$675501d264d94e61$export$b0d4b338e1516f13 = void 0;

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $675501d264d94e61$var$lightFormatters = $675501d264d94e61$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $9f7024483df1879f$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $7a03923996f2002a$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $7a03923996f2002a$var$formatters = $7a03923996f2002a$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $675501d264d94e61$export$b0d4b338e1516f13.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $fc873680f7d773ff$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $9f7024483df1879f$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $14ce8a7023d6978a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $9f7024483df1879f$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $9f7024483df1879f$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $675501d264d94e61$export$b0d4b338e1516f13.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $9f7024483df1879f$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $cd28fd34ea432b51$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $a5f39ea06618a69d$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $675501d264d94e61$export$b0d4b338e1516f13.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $30e61c2b7b493e1d$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $9f7024483df1879f$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $9f7024483df1879f$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $9f7024483df1879f$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $7a03923996f2002a$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $7a03923996f2002a$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $7a03923996f2002a$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $7a03923996f2002a$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $7a03923996f2002a$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $7a03923996f2002a$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $675501d264d94e61$export$b0d4b338e1516f13.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $675501d264d94e61$export$b0d4b338e1516f13.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $675501d264d94e61$export$b0d4b338e1516f13.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $675501d264d94e61$export$b0d4b338e1516f13.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $675501d264d94e61$export$b0d4b338e1516f13.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $7a03923996f2002a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $7a03923996f2002a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $7a03923996f2002a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $7a03923996f2002a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $7a03923996f2002a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $7a03923996f2002a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $7a03923996f2002a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $7a03923996f2002a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $7a03923996f2002a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $7a03923996f2002a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $9f7024483df1879f$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $7a03923996f2002a$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $9f7024483df1879f$export$c8306e720e213c0f)(minutes, 2);
}
function $7a03923996f2002a$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $9f7024483df1879f$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $7a03923996f2002a$var$formatTimezone(offset, delimiter);
}
function $7a03923996f2002a$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $9f7024483df1879f$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $9f7024483df1879f$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


var $14a0de1c0c2d5442$export$70cc8fd02856fd58;
"use strict";
$14a0de1c0c2d5442$export$70cc8fd02856fd58 = void 0;
const $14a0de1c0c2d5442$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $14a0de1c0c2d5442$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $14a0de1c0c2d5442$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $14a0de1c0c2d5442$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $14a0de1c0c2d5442$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $14a0de1c0c2d5442$var$timeLongFormatter(timePattern, formatLong));
};
const $14a0de1c0c2d5442$var$longFormatters = $14a0de1c0c2d5442$export$70cc8fd02856fd58 = {
    p: $14a0de1c0c2d5442$var$timeLongFormatter,
    P: $14a0de1c0c2d5442$var$dateTimeLongFormatter
};


var $9d5fabdcbe897d16$export$c6cc36aa33304772;
var $9d5fabdcbe897d16$export$c6b49d6dceb604a1;
var $9d5fabdcbe897d16$export$f5f38f90ecaaf879;
"use strict";
$9d5fabdcbe897d16$export$c6cc36aa33304772 = $9d5fabdcbe897d16$var$isProtectedDayOfYearToken;
$9d5fabdcbe897d16$export$c6b49d6dceb604a1 = $9d5fabdcbe897d16$var$isProtectedWeekYearToken;
$9d5fabdcbe897d16$export$f5f38f90ecaaf879 = $9d5fabdcbe897d16$var$warnOrThrowProtectedError;
const $9d5fabdcbe897d16$var$dayOfYearTokenRE = /^D+$/;
const $9d5fabdcbe897d16$var$weekYearTokenRE = /^Y+$/;
const $9d5fabdcbe897d16$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $9d5fabdcbe897d16$var$isProtectedDayOfYearToken(token) {
    return $9d5fabdcbe897d16$var$dayOfYearTokenRE.test(token);
}
function $9d5fabdcbe897d16$var$isProtectedWeekYearToken(token) {
    return $9d5fabdcbe897d16$var$weekYearTokenRE.test(token);
}
function $9d5fabdcbe897d16$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $9d5fabdcbe897d16$var$message(token, format, input);
    console.warn(_message);
    if ($9d5fabdcbe897d16$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $9d5fabdcbe897d16$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}




// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $003ee58a38f5aa97$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $003ee58a38f5aa97$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $003ee58a38f5aa97$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $003ee58a38f5aa97$var$doubleQuoteRegExp = /''/g;
const $003ee58a38f5aa97$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $003ee58a38f5aa97$var$format(date, formatStr, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $b5606a4787083ded$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (!(0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($003ee58a38f5aa97$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $14a0de1c0c2d5442$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($003ee58a38f5aa97$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $003ee58a38f5aa97$var$cleanEscapedString(substring)
        };
        if ($7a03923996f2002a$export$fe98a034cfb96d55[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($003ee58a38f5aa97$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $9d5fabdcbe897d16$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $9d5fabdcbe897d16$export$c6cc36aa33304772)(token)) (0, $9d5fabdcbe897d16$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = $7a03923996f2002a$export$fe98a034cfb96d55[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $003ee58a38f5aa97$var$cleanEscapedString(input) {
    const matched = input.match($003ee58a38f5aa97$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($003ee58a38f5aa97$var$doubleQuoteRegExp, "'");
}


Object.keys($003ee58a38f5aa97$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $003ee58a38f5aa97$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $003ee58a38f5aa97$exports[key];
        }
    });
});
var $972a704203921907$exports = {};

$parcel$export($972a704203921907$exports, "formatDistance", () => $972a704203921907$export$2c14ff85d6318973, (v) => $972a704203921907$export$2c14ff85d6318973 = v);
var $972a704203921907$export$2c14ff85d6318973;
"use strict";
$972a704203921907$export$2c14ff85d6318973 = $972a704203921907$var$formatDistance;








/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $972a704203921907$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $b5606a4787083ded$exports.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $976a76a5c353dde9$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
        dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(baseDate);
    }
    const seconds = (0, $b959d7b7ef976870$export$c1889aec51783710)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $588883c191ca40e9$export$113002b5eff6e430)(dateRight) - (0, $588883c191ca40e9$export$113002b5eff6e430)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $68a6706ec8075339$export$2423174df8cd3cd2) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $68a6706ec8075339$export$ab7da2ccd1075c38) {
        const days = Math.round(minutes / $68a6706ec8075339$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $68a6706ec8075339$export$ab7da2ccd1075c38 * 2) {
        months = Math.round(minutes / $68a6706ec8075339$export$ab7da2ccd1075c38);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $edb0c694294ce359$export$fc1ed482c2861792)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $68a6706ec8075339$export$ab7da2ccd1075c38);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}


Object.keys($972a704203921907$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $972a704203921907$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $972a704203921907$exports[key];
        }
    });
});
var $51153accc8992d20$exports = {};

$parcel$export($51153accc8992d20$exports, "formatDistanceStrict", () => $51153accc8992d20$export$e4be225b8ee0a759, (v) => $51153accc8992d20$export$e4be225b8ee0a759 = v);
var $51153accc8992d20$export$e4be225b8ee0a759;
"use strict";
$51153accc8992d20$export$e4be225b8ee0a759 = $51153accc8992d20$var$formatDistanceStrict;







/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $51153accc8992d20$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $b5606a4787083ded$exports.defaultLocale;
    const comparison = (0, $976a76a5c353dde9$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
        dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(baseDate);
    }
    const roundingMethod = (0, $e299bd4246a08683$export$b6474a47258c1211)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $68a6706ec8075339$export$91246f0b9bd9beff;
    const timezoneOffset = (0, $588883c191ca40e9$export$113002b5eff6e430)(dateRight) - (0, $588883c191ca40e9$export$113002b5eff6e430)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $68a6706ec8075339$export$91246f0b9bd9beff;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $68a6706ec8075339$export$2423174df8cd3cd2) unit = "hour";
        else if (dstNormalizedMinutes < $68a6706ec8075339$export$ab7da2ccd1075c38) unit = "day";
        else if (dstNormalizedMinutes < $68a6706ec8075339$export$3633035e63cee86a) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $68a6706ec8075339$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $68a6706ec8075339$export$ab7da2ccd1075c38);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $68a6706ec8075339$export$3633035e63cee86a);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}


Object.keys($51153accc8992d20$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $51153accc8992d20$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $51153accc8992d20$exports[key];
        }
    });
});
var $e08f3cd8742bea87$exports = {};

$parcel$export($e08f3cd8742bea87$exports, "formatDistanceToNow", () => $e08f3cd8742bea87$export$d130c20a256f8817, (v) => $e08f3cd8742bea87$export$d130c20a256f8817 = v);
var $e08f3cd8742bea87$export$d130c20a256f8817;
"use strict";
$e08f3cd8742bea87$export$d130c20a256f8817 = $e08f3cd8742bea87$var$formatDistanceToNow;


/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $e08f3cd8742bea87$var$formatDistanceToNow(date, options) {
    return (0, $972a704203921907$export$2c14ff85d6318973)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date), options);
}


Object.keys($e08f3cd8742bea87$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e08f3cd8742bea87$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e08f3cd8742bea87$exports[key];
        }
    });
});
var $66e6946f7089243c$exports = {};

$parcel$export($66e6946f7089243c$exports, "formatDistanceToNowStrict", () => $66e6946f7089243c$export$d0e02d4eb1ad1e32, (v) => $66e6946f7089243c$export$d0e02d4eb1ad1e32 = v);
var $66e6946f7089243c$export$d0e02d4eb1ad1e32;
"use strict";
$66e6946f7089243c$export$d0e02d4eb1ad1e32 = $66e6946f7089243c$var$formatDistanceToNowStrict;


/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $66e6946f7089243c$var$formatDistanceToNowStrict(date, options) {
    return (0, $51153accc8992d20$export$e4be225b8ee0a759)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date), options);
}


Object.keys($66e6946f7089243c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $66e6946f7089243c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $66e6946f7089243c$exports[key];
        }
    });
});
var $bfec5291fbee0ab5$exports = {};

$parcel$export($bfec5291fbee0ab5$exports, "formatDuration", () => $bfec5291fbee0ab5$export$bc733b0c5cbb3e8a, (v) => $bfec5291fbee0ab5$export$bc733b0c5cbb3e8a = v);
var $bfec5291fbee0ab5$export$bc733b0c5cbb3e8a;
"use strict";
$bfec5291fbee0ab5$export$bc733b0c5cbb3e8a = $bfec5291fbee0ab5$var$formatDuration;


/**
 * The {@link formatDuration} function options.
 */ const $bfec5291fbee0ab5$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $bfec5291fbee0ab5$var$formatDuration(duration, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $b5606a4787083ded$exports.defaultLocale;
    const format = options?.format ?? $bfec5291fbee0ab5$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}


Object.keys($bfec5291fbee0ab5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $bfec5291fbee0ab5$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $bfec5291fbee0ab5$exports[key];
        }
    });
});
var $759b76a138ef1837$exports = {};

$parcel$export($759b76a138ef1837$exports, "formatISO", () => $759b76a138ef1837$export$3c826ac3ab9da76c, (v) => $759b76a138ef1837$export$3c826ac3ab9da76c = v);
var $759b76a138ef1837$export$3c826ac3ab9da76c;
"use strict";
$759b76a138ef1837$export$3c826ac3ab9da76c = $759b76a138ef1837$var$formatISO;


/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $759b76a138ef1837$var$formatISO(date, options) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $9f7024483df1879f$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $9f7024483df1879f$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}


Object.keys($759b76a138ef1837$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $759b76a138ef1837$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $759b76a138ef1837$exports[key];
        }
    });
});
var $8adefc40a4e5b461$exports = {};

$parcel$export($8adefc40a4e5b461$exports, "formatISO9075", () => $8adefc40a4e5b461$export$a673944250043fa4, (v) => $8adefc40a4e5b461$export$a673944250043fa4 = v);
var $8adefc40a4e5b461$export$a673944250043fa4;
"use strict";
$8adefc40a4e5b461$export$a673944250043fa4 = $8adefc40a4e5b461$var$formatISO9075;



/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $8adefc40a4e5b461$var$formatISO9075(date, options) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (!(0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}


Object.keys($8adefc40a4e5b461$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8adefc40a4e5b461$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8adefc40a4e5b461$exports[key];
        }
    });
});
var $1884e03da06640db$exports = {};

$parcel$export($1884e03da06640db$exports, "formatISODuration", () => $1884e03da06640db$export$437c31ab743f6b26, (v) => $1884e03da06640db$export$437c31ab743f6b26 = v);
var $1884e03da06640db$export$437c31ab743f6b26;
"use strict";
$1884e03da06640db$export$437c31ab743f6b26 = $1884e03da06640db$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $1884e03da06640db$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}


Object.keys($1884e03da06640db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $1884e03da06640db$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $1884e03da06640db$exports[key];
        }
    });
});
var $a1d99c13ecf65118$exports = {};

$parcel$export($a1d99c13ecf65118$exports, "formatRFC3339", () => $a1d99c13ecf65118$export$6d441bffeec6bd6c, (v) => $a1d99c13ecf65118$export$6d441bffeec6bd6c = v);
var $a1d99c13ecf65118$export$6d441bffeec6bd6c;
"use strict";
$a1d99c13ecf65118$export$6d441bffeec6bd6c = $a1d99c13ecf65118$var$formatRFC3339;



/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $a1d99c13ecf65118$var$formatRFC3339(date, options) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (!(0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getDate(), 2);
    const month = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getHours(), 2);
    const minute = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getMinutes(), 2);
    const second = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $9f7024483df1879f$export$c8306e720e213c0f)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $9f7024483df1879f$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $9f7024483df1879f$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}


Object.keys($a1d99c13ecf65118$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a1d99c13ecf65118$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a1d99c13ecf65118$exports[key];
        }
    });
});
var $d59886eaee6dac5a$exports = {};

$parcel$export($d59886eaee6dac5a$exports, "formatRFC7231", () => $d59886eaee6dac5a$export$7add2e4539ce658a, (v) => $d59886eaee6dac5a$export$7add2e4539ce658a = v);
var $d59886eaee6dac5a$export$7add2e4539ce658a;
"use strict";
$d59886eaee6dac5a$export$7add2e4539ce658a = $d59886eaee6dac5a$var$formatRFC7231;



const $d59886eaee6dac5a$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $d59886eaee6dac5a$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $d59886eaee6dac5a$var$formatRFC7231(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (!(0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const dayName = $d59886eaee6dac5a$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getUTCDate(), 2);
    const monthName = $d59886eaee6dac5a$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getUTCHours(), 2);
    const minute = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getUTCMinutes(), 2);
    const second = (0, $9f7024483df1879f$export$c8306e720e213c0f)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}


Object.keys($d59886eaee6dac5a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d59886eaee6dac5a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d59886eaee6dac5a$exports[key];
        }
    });
});
var $8e3517bb8b208ea9$exports = {};

$parcel$export($8e3517bb8b208ea9$exports, "formatRelative", () => $8e3517bb8b208ea9$export$8fbbfd65594f46a0, (v) => $8e3517bb8b208ea9$export$8fbbfd65594f46a0 = v);
var $8e3517bb8b208ea9$export$8fbbfd65594f46a0;
"use strict";
$8e3517bb8b208ea9$export$8fbbfd65594f46a0 = $8e3517bb8b208ea9$var$formatRelative;





/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $8e3517bb8b208ea9$var$formatRelative(date, baseDate, options) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const _baseDate = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(baseDate);
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $b5606a4787083ded$exports.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $db8722365c910ec5$export$4a02e9c37dab4871)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $003ee58a38f5aa97$exports.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}


Object.keys($8e3517bb8b208ea9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8e3517bb8b208ea9$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8e3517bb8b208ea9$exports[key];
        }
    });
});
var $24ee9f3891918d75$exports = {};

$parcel$export($24ee9f3891918d75$exports, "fromUnixTime", () => $24ee9f3891918d75$export$3664df8597731ed4, (v) => $24ee9f3891918d75$export$3664df8597731ed4 = v);
var $24ee9f3891918d75$export$3664df8597731ed4;
"use strict";
$24ee9f3891918d75$export$3664df8597731ed4 = $24ee9f3891918d75$var$fromUnixTime;

/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $24ee9f3891918d75$var$fromUnixTime(unixTime) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(unixTime * 1000);
}


Object.keys($24ee9f3891918d75$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $24ee9f3891918d75$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $24ee9f3891918d75$exports[key];
        }
    });
});
var $0ba1fb30b64cbd38$exports = {};

$parcel$export($0ba1fb30b64cbd38$exports, "getDate", () => $0ba1fb30b64cbd38$export$aa350b96d91cd94, (v) => $0ba1fb30b64cbd38$export$aa350b96d91cd94 = v);
var $0ba1fb30b64cbd38$export$aa350b96d91cd94;
"use strict";
$0ba1fb30b64cbd38$export$aa350b96d91cd94 = $0ba1fb30b64cbd38$var$getDate;

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $0ba1fb30b64cbd38$var$getDate(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}


Object.keys($0ba1fb30b64cbd38$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0ba1fb30b64cbd38$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0ba1fb30b64cbd38$exports[key];
        }
    });
});
var $9c47022cd70b02b7$exports = {};

$parcel$export($9c47022cd70b02b7$exports, "getDay", () => $9c47022cd70b02b7$export$1b64bc9c5306ed54, (v) => $9c47022cd70b02b7$export$1b64bc9c5306ed54 = v);
var $9c47022cd70b02b7$export$1b64bc9c5306ed54;
"use strict";
$9c47022cd70b02b7$export$1b64bc9c5306ed54 = $9c47022cd70b02b7$var$getDay;

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $9c47022cd70b02b7$var$getDay(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    return day;
}


Object.keys($9c47022cd70b02b7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $9c47022cd70b02b7$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $9c47022cd70b02b7$exports[key];
        }
    });
});

Object.keys($30e61c2b7b493e1d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $30e61c2b7b493e1d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $30e61c2b7b493e1d$exports[key];
        }
    });
});
var $461903d15212cf89$exports = {};

$parcel$export($461903d15212cf89$exports, "getDaysInMonth", () => $461903d15212cf89$export$f645ddd439eb259d, (v) => $461903d15212cf89$export$f645ddd439eb259d = v);
var $461903d15212cf89$export$f645ddd439eb259d;
"use strict";
$461903d15212cf89$export$f645ddd439eb259d = $461903d15212cf89$var$getDaysInMonth;


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $461903d15212cf89$var$getDaysInMonth(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}


Object.keys($461903d15212cf89$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $461903d15212cf89$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $461903d15212cf89$exports[key];
        }
    });
});
var $86d49f55e758b063$exports = {};

$parcel$export($86d49f55e758b063$exports, "getDaysInYear", () => $86d49f55e758b063$export$63a4a9fc49e3550e, (v) => $86d49f55e758b063$export$63a4a9fc49e3550e = v);
var $86d49f55e758b063$export$63a4a9fc49e3550e;
"use strict";
$86d49f55e758b063$export$63a4a9fc49e3550e = $86d49f55e758b063$var$getDaysInYear;
var $dd8899fe09bd64f8$exports = {};

$parcel$export($dd8899fe09bd64f8$exports, "isLeapYear", () => $dd8899fe09bd64f8$export$553d7fa8e3805fc0, (v) => $dd8899fe09bd64f8$export$553d7fa8e3805fc0 = v);
var $dd8899fe09bd64f8$export$553d7fa8e3805fc0;
"use strict";
$dd8899fe09bd64f8$export$553d7fa8e3805fc0 = $dd8899fe09bd64f8$var$isLeapYear;

/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $dd8899fe09bd64f8$var$isLeapYear(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $86d49f55e758b063$var$getDaysInYear(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $dd8899fe09bd64f8$export$553d7fa8e3805fc0)(_date) ? 366 : 365;
}


Object.keys($86d49f55e758b063$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $86d49f55e758b063$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $86d49f55e758b063$exports[key];
        }
    });
});
var $d8c2047545d91d8b$exports = {};

$parcel$export($d8c2047545d91d8b$exports, "getDecade", () => $d8c2047545d91d8b$export$5bc0f4decfc52b64, (v) => $d8c2047545d91d8b$export$5bc0f4decfc52b64 = v);
var $d8c2047545d91d8b$export$5bc0f4decfc52b64;
"use strict";
$d8c2047545d91d8b$export$5bc0f4decfc52b64 = $d8c2047545d91d8b$var$getDecade;

/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $d8c2047545d91d8b$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}


Object.keys($d8c2047545d91d8b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d8c2047545d91d8b$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d8c2047545d91d8b$exports[key];
        }
    });
});
var $c855634a1566d11e$exports = {};

$parcel$export($c855634a1566d11e$exports, "getDefaultOptions", () => $c855634a1566d11e$export$430a3269e24b912e, (v) => $c855634a1566d11e$export$430a3269e24b912e = v);
var $c855634a1566d11e$export$430a3269e24b912e;
"use strict";
$c855634a1566d11e$export$430a3269e24b912e = $c855634a1566d11e$var$getDefaultOptions;

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $c855634a1566d11e$var$getDefaultOptions() {
    return Object.assign({}, (0, $56871551bba7dca4$export$430a3269e24b912e)());
}


Object.keys($c855634a1566d11e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c855634a1566d11e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c855634a1566d11e$exports[key];
        }
    });
});
var $5a47f1ff83a3341a$exports = {};

$parcel$export($5a47f1ff83a3341a$exports, "getHours", () => $5a47f1ff83a3341a$export$257b40f71c07d58f, (v) => $5a47f1ff83a3341a$export$257b40f71c07d58f = v);
var $5a47f1ff83a3341a$export$257b40f71c07d58f;
"use strict";
$5a47f1ff83a3341a$export$257b40f71c07d58f = $5a47f1ff83a3341a$var$getHours;

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $5a47f1ff83a3341a$var$getHours(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const hours = _date.getHours();
    return hours;
}


Object.keys($5a47f1ff83a3341a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5a47f1ff83a3341a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5a47f1ff83a3341a$exports[key];
        }
    });
});
var $b8e7d0a4aa2c277f$exports = {};

$parcel$export($b8e7d0a4aa2c277f$exports, "getISODay", () => $b8e7d0a4aa2c277f$export$c514f4c1a8ed5e9e, (v) => $b8e7d0a4aa2c277f$export$c514f4c1a8ed5e9e = v);
var $b8e7d0a4aa2c277f$export$c514f4c1a8ed5e9e;
"use strict";
$b8e7d0a4aa2c277f$export$c514f4c1a8ed5e9e = $b8e7d0a4aa2c277f$var$getISODay;

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $b8e7d0a4aa2c277f$var$getISODay(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}


Object.keys($b8e7d0a4aa2c277f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b8e7d0a4aa2c277f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b8e7d0a4aa2c277f$exports[key];
        }
    });
});

Object.keys($a5f39ea06618a69d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a5f39ea06618a69d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a5f39ea06618a69d$exports[key];
        }
    });
});

Object.keys($14ce8a7023d6978a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $14ce8a7023d6978a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $14ce8a7023d6978a$exports[key];
        }
    });
});
var $f085ebdc88bc8b70$exports = {};

$parcel$export($f085ebdc88bc8b70$exports, "getISOWeeksInYear", () => $f085ebdc88bc8b70$export$822983242a16750f, (v) => $f085ebdc88bc8b70$export$822983242a16750f = v);
var $f085ebdc88bc8b70$export$822983242a16750f;
"use strict";
$f085ebdc88bc8b70$export$822983242a16750f = $f085ebdc88bc8b70$var$getISOWeeksInYear;



/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $f085ebdc88bc8b70$var$getISOWeeksInYear(date) {
    const thisYear = (0, $b2d2382037e56893$export$236bdfa374eb69a9)(date);
    const nextYear = (0, $b2d2382037e56893$export$236bdfa374eb69a9)((0, $78f454683e97f088$export$ef501a2bb4f3ee6b)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $68a6706ec8075339$export$4fad13613e88edc8);
}


Object.keys($f085ebdc88bc8b70$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f085ebdc88bc8b70$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f085ebdc88bc8b70$exports[key];
        }
    });
});
var $d1992b032f9ba8fa$exports = {};

$parcel$export($d1992b032f9ba8fa$exports, "getMilliseconds", () => $d1992b032f9ba8fa$export$b8e4380f312797af, (v) => $d1992b032f9ba8fa$export$b8e4380f312797af = v);
var $d1992b032f9ba8fa$export$b8e4380f312797af;
"use strict";
$d1992b032f9ba8fa$export$b8e4380f312797af = $d1992b032f9ba8fa$var$getMilliseconds;

/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $d1992b032f9ba8fa$var$getMilliseconds(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}


Object.keys($d1992b032f9ba8fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d1992b032f9ba8fa$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d1992b032f9ba8fa$exports[key];
        }
    });
});
var $e972c701e07f0318$exports = {};

$parcel$export($e972c701e07f0318$exports, "getMinutes", () => $e972c701e07f0318$export$b7f1bc3ea3ac4145, (v) => $e972c701e07f0318$export$b7f1bc3ea3ac4145 = v);
var $e972c701e07f0318$export$b7f1bc3ea3ac4145;
"use strict";
$e972c701e07f0318$export$b7f1bc3ea3ac4145 = $e972c701e07f0318$var$getMinutes;

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $e972c701e07f0318$var$getMinutes(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const minutes = _date.getMinutes();
    return minutes;
}


Object.keys($e972c701e07f0318$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e972c701e07f0318$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e972c701e07f0318$exports[key];
        }
    });
});
var $158acc39b013b046$exports = {};

$parcel$export($158acc39b013b046$exports, "getMonth", () => $158acc39b013b046$export$6ce1b5acc29cb53b, (v) => $158acc39b013b046$export$6ce1b5acc29cb53b = v);
var $158acc39b013b046$export$6ce1b5acc29cb53b;
"use strict";
$158acc39b013b046$export$6ce1b5acc29cb53b = $158acc39b013b046$var$getMonth;

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $158acc39b013b046$var$getMonth(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    return month;
}


Object.keys($158acc39b013b046$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $158acc39b013b046$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $158acc39b013b046$exports[key];
        }
    });
});
var $2b131cdab2ad28b4$exports = {};

$parcel$export($2b131cdab2ad28b4$exports, "getOverlappingDaysInIntervals", () => $2b131cdab2ad28b4$export$baae148532bd1d46, (v) => $2b131cdab2ad28b4$export$baae148532bd1d46 = v);
var $2b131cdab2ad28b4$export$baae148532bd1d46;
"use strict";
$2b131cdab2ad28b4$export$baae148532bd1d46 = $2b131cdab2ad28b4$var$getOverlappingDaysInIntervals;



/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $2b131cdab2ad28b4$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $588883c191ca40e9$export$113002b5eff6e430)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $588883c191ca40e9$export$113002b5eff6e430)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $68a6706ec8075339$export$b76b1809a2898f9a);
}


Object.keys($2b131cdab2ad28b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $2b131cdab2ad28b4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $2b131cdab2ad28b4$exports[key];
        }
    });
});

Object.keys($77d1eba5f0a0b035$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $77d1eba5f0a0b035$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $77d1eba5f0a0b035$exports[key];
        }
    });
});
var $96168557243b269c$exports = {};

$parcel$export($96168557243b269c$exports, "getSeconds", () => $96168557243b269c$export$5e9417507ff28427, (v) => $96168557243b269c$export$5e9417507ff28427 = v);
var $96168557243b269c$export$5e9417507ff28427;
"use strict";
$96168557243b269c$export$5e9417507ff28427 = $96168557243b269c$var$getSeconds;

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $96168557243b269c$var$getSeconds(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const seconds = _date.getSeconds();
    return seconds;
}


Object.keys($96168557243b269c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $96168557243b269c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $96168557243b269c$exports[key];
        }
    });
});
var $e651016c5254d430$exports = {};

$parcel$export($e651016c5254d430$exports, "getTime", () => $e651016c5254d430$export$1428f42a7de81803, (v) => $e651016c5254d430$export$1428f42a7de81803 = v);
var $e651016c5254d430$export$1428f42a7de81803;
"use strict";
$e651016c5254d430$export$1428f42a7de81803 = $e651016c5254d430$var$getTime;

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $e651016c5254d430$var$getTime(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const timestamp = _date.getTime();
    return timestamp;
}


Object.keys($e651016c5254d430$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e651016c5254d430$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e651016c5254d430$exports[key];
        }
    });
});
var $8e006e77c68d649c$exports = {};

$parcel$export($8e006e77c68d649c$exports, "getUnixTime", () => $8e006e77c68d649c$export$1f77c0008d16313, (v) => $8e006e77c68d649c$export$1f77c0008d16313 = v);
var $8e006e77c68d649c$export$1f77c0008d16313;
"use strict";
$8e006e77c68d649c$export$1f77c0008d16313 = $8e006e77c68d649c$var$getUnixTime;

/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $8e006e77c68d649c$var$getUnixTime(date) {
    return Math.trunc(+(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date) / 1000);
}


Object.keys($8e006e77c68d649c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8e006e77c68d649c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8e006e77c68d649c$exports[key];
        }
    });
});

Object.keys($cd28fd34ea432b51$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $cd28fd34ea432b51$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $cd28fd34ea432b51$exports[key];
        }
    });
});
var $e4a8525954a23283$exports = {};

$parcel$export($e4a8525954a23283$exports, "getWeekOfMonth", () => $e4a8525954a23283$export$59fb9b85a4d8d027, (v) => $e4a8525954a23283$export$59fb9b85a4d8d027 = v);
var $e4a8525954a23283$export$59fb9b85a4d8d027;
"use strict";
$e4a8525954a23283$export$59fb9b85a4d8d027 = $e4a8525954a23283$var$getWeekOfMonth;




/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $e4a8525954a23283$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $0ba1fb30b64cbd38$export$aa350b96d91cd94)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $9c47022cd70b02b7$export$1b64bc9c5306ed54)((0, $079952111a69a2fd$export$a5a3b454ada2268e)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}


Object.keys($e4a8525954a23283$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e4a8525954a23283$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e4a8525954a23283$exports[key];
        }
    });
});

Object.keys($fc873680f7d773ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $fc873680f7d773ff$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $fc873680f7d773ff$exports[key];
        }
    });
});
var $e08825c6bcd460f4$exports = {};

$parcel$export($e08825c6bcd460f4$exports, "getWeeksInMonth", () => $e08825c6bcd460f4$export$ccc1b2479e7dd654, (v) => $e08825c6bcd460f4$export$ccc1b2479e7dd654 = v);
var $e08825c6bcd460f4$export$ccc1b2479e7dd654;
"use strict";
$e08825c6bcd460f4$export$ccc1b2479e7dd654 = $e08825c6bcd460f4$var$getWeeksInMonth;

var $47662c5f67705cf1$exports = {};

$parcel$export($47662c5f67705cf1$exports, "lastDayOfMonth", () => $47662c5f67705cf1$export$36818250d6c87922, (v) => $47662c5f67705cf1$export$36818250d6c87922 = v);
var $47662c5f67705cf1$export$36818250d6c87922;
"use strict";
$47662c5f67705cf1$export$36818250d6c87922 = $47662c5f67705cf1$var$lastDayOfMonth;

/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $47662c5f67705cf1$var$lastDayOfMonth(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $e08825c6bcd460f4$var$getWeeksInMonth(date, options) {
    return (0, $dda0d3c8044c7a74$export$6ed034ce62348e4)((0, $47662c5f67705cf1$export$36818250d6c87922)(date), (0, $079952111a69a2fd$export$a5a3b454ada2268e)(date), options) + 1;
}


Object.keys($e08825c6bcd460f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e08825c6bcd460f4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e08825c6bcd460f4$exports[key];
        }
    });
});
var $7f327ea72afd350d$exports = {};

$parcel$export($7f327ea72afd350d$exports, "getYear", () => $7f327ea72afd350d$export$5846dc2d57a5c860, (v) => $7f327ea72afd350d$export$5846dc2d57a5c860 = v);
var $7f327ea72afd350d$export$5846dc2d57a5c860;
"use strict";
$7f327ea72afd350d$export$5846dc2d57a5c860 = $7f327ea72afd350d$var$getYear;

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $7f327ea72afd350d$var$getYear(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getFullYear();
}


Object.keys($7f327ea72afd350d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $7f327ea72afd350d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $7f327ea72afd350d$exports[key];
        }
    });
});
var $9ce61459e91efed0$exports = {};

$parcel$export($9ce61459e91efed0$exports, "hoursToMilliseconds", () => $9ce61459e91efed0$export$5b42ab7a22898b69, (v) => $9ce61459e91efed0$export$5b42ab7a22898b69 = v);
var $9ce61459e91efed0$export$5b42ab7a22898b69;
"use strict";
$9ce61459e91efed0$export$5b42ab7a22898b69 = $9ce61459e91efed0$var$hoursToMilliseconds;

/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $9ce61459e91efed0$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $68a6706ec8075339$export$7f72910d6dfd237a);
}


Object.keys($9ce61459e91efed0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $9ce61459e91efed0$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $9ce61459e91efed0$exports[key];
        }
    });
});
var $b700275a280b1009$exports = {};

$parcel$export($b700275a280b1009$exports, "hoursToMinutes", () => $b700275a280b1009$export$83bfc73cdf89a4d8, (v) => $b700275a280b1009$export$83bfc73cdf89a4d8 = v);
var $b700275a280b1009$export$83bfc73cdf89a4d8;
"use strict";
$b700275a280b1009$export$83bfc73cdf89a4d8 = $b700275a280b1009$var$hoursToMinutes;

/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $b700275a280b1009$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $68a6706ec8075339$export$f2f5ae5a8e2d8f9f);
}


Object.keys($b700275a280b1009$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b700275a280b1009$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b700275a280b1009$exports[key];
        }
    });
});
var $e9bd05a2bf1a4b56$exports = {};

$parcel$export($e9bd05a2bf1a4b56$exports, "hoursToSeconds", () => $e9bd05a2bf1a4b56$export$59b1396ccbd5a4e1, (v) => $e9bd05a2bf1a4b56$export$59b1396ccbd5a4e1 = v);
var $e9bd05a2bf1a4b56$export$59b1396ccbd5a4e1;
"use strict";
$e9bd05a2bf1a4b56$export$59b1396ccbd5a4e1 = $e9bd05a2bf1a4b56$var$hoursToSeconds;

/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $e9bd05a2bf1a4b56$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $68a6706ec8075339$export$698aec755e92c695);
}


Object.keys($e9bd05a2bf1a4b56$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e9bd05a2bf1a4b56$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e9bd05a2bf1a4b56$exports[key];
        }
    });
});
var $5b9e9d56e5ef864a$exports = {};

$parcel$export($5b9e9d56e5ef864a$exports, "interval", () => $5b9e9d56e5ef864a$export$3174cdbf0a0cbc84, (v) => $5b9e9d56e5ef864a$export$3174cdbf0a0cbc84 = v);
var $5b9e9d56e5ef864a$export$3174cdbf0a0cbc84;
"use strict";
$5b9e9d56e5ef864a$export$3174cdbf0a0cbc84 = $5b9e9d56e5ef864a$var$interval;

/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $5b9e9d56e5ef864a$var$interval(start, end, options) {
    const _start = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}


Object.keys($5b9e9d56e5ef864a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5b9e9d56e5ef864a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5b9e9d56e5ef864a$exports[key];
        }
    });
});
var $f46ab993cdf41d01$exports = {};

$parcel$export($f46ab993cdf41d01$exports, "intervalToDuration", () => $f46ab993cdf41d01$export$7b6c9a626316863, (v) => $f46ab993cdf41d01$export$7b6c9a626316863 = v);
var $f46ab993cdf41d01$export$7b6c9a626316863;
"use strict";
$f46ab993cdf41d01$export$7b6c9a626316863 = $f46ab993cdf41d01$var$intervalToDuration;








/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $f46ab993cdf41d01$var$intervalToDuration(interval) {
    const start = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start);
    const end = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end);
    const duration = {};
    const years = (0, $d362eeeb66bec530$export$ed6bf486f68899ca)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $cafa819bac795364$export$e16d8520af44a096)(start, {
        years: duration.years
    });
    const months = (0, $edb0c694294ce359$export$fc1ed482c2861792)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $cafa819bac795364$export$e16d8520af44a096)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $ccddb97e12a36498$export$86415ebf4eb36b8c)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $cafa819bac795364$export$e16d8520af44a096)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $c9ca699389c66572$export$5436ca250d4d6872)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $cafa819bac795364$export$e16d8520af44a096)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $8a0c735b714f6109$export$d904251335be481a)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $cafa819bac795364$export$e16d8520af44a096)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $b959d7b7ef976870$export$c1889aec51783710)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}


Object.keys($f46ab993cdf41d01$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f46ab993cdf41d01$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f46ab993cdf41d01$exports[key];
        }
    });
});
var $8ac850a84e10a49a$exports = {};

$parcel$export($8ac850a84e10a49a$exports, "intlFormat", () => $8ac850a84e10a49a$export$f58f1234eed71f82, (v) => $8ac850a84e10a49a$export$f58f1234eed71f82 = v);
var $8ac850a84e10a49a$export$f58f1234eed71f82;
"use strict";
$8ac850a84e10a49a$export$f58f1234eed71f82 = $8ac850a84e10a49a$var$intlFormat;

/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $8ac850a84e10a49a$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($8ac850a84e10a49a$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date));
}
function $8ac850a84e10a49a$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}


Object.keys($8ac850a84e10a49a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8ac850a84e10a49a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8ac850a84e10a49a$exports[key];
        }
    });
});
var $d4f4164be6838145$exports = {};

$parcel$export($d4f4164be6838145$exports, "intlFormatDistance", () => $d4f4164be6838145$export$a110a4020280fd5, (v) => $d4f4164be6838145$export$a110a4020280fd5 = v);
var $d4f4164be6838145$export$a110a4020280fd5;
"use strict";
$d4f4164be6838145$export$a110a4020280fd5 = $d4f4164be6838145$var$intlFormatDistance;










/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $d4f4164be6838145$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $b959d7b7ef976870$export$c1889aec51783710)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $68a6706ec8075339$export$a77c1a7ebebe2a5a) {
            value = (0, $b959d7b7ef976870$export$c1889aec51783710)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $68a6706ec8075339$export$698aec755e92c695) {
            value = (0, $8a0c735b714f6109$export$d904251335be481a)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $68a6706ec8075339$export$815a9362476d2fe3 && Math.abs((0, $db8722365c910ec5$export$4a02e9c37dab4871)(dateLeft, dateRight)) < 1) {
            value = (0, $c9ca699389c66572$export$5436ca250d4d6872)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $68a6706ec8075339$export$34804a017b31e2fe && (value = (0, $db8722365c910ec5$export$4a02e9c37dab4871)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $68a6706ec8075339$export$8e6600bbdee7dabb) {
            value = (0, $dda0d3c8044c7a74$export$6ed034ce62348e4)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $68a6706ec8075339$export$be1dccf2de902d31) {
            value = (0, $f0f727c269611d4e$export$489984ac7c996389)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $68a6706ec8075339$export$7271e9e3478110d1) {
            if ((0, $f9130f4f4a28ee9f$export$f62ae9fb13958c7a)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $f9130f4f4a28ee9f$export$f62ae9fb13958c7a)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $575993f708f72d85$export$c06dce8b38891685)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $575993f708f72d85$export$c06dce8b38891685)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $b959d7b7ef976870$export$c1889aec51783710)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $8a0c735b714f6109$export$d904251335be481a)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $c9ca699389c66572$export$5436ca250d4d6872)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $db8722365c910ec5$export$4a02e9c37dab4871)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $dda0d3c8044c7a74$export$6ed034ce62348e4)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $f0f727c269611d4e$export$489984ac7c996389)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $f9130f4f4a28ee9f$export$f62ae9fb13958c7a)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $575993f708f72d85$export$c06dce8b38891685)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}


Object.keys($d4f4164be6838145$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d4f4164be6838145$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d4f4164be6838145$exports[key];
        }
    });
});
var $59e2c0d3ca5f3c0b$exports = {};

$parcel$export($59e2c0d3ca5f3c0b$exports, "isAfter", () => $59e2c0d3ca5f3c0b$export$e4de839670987035, (v) => $59e2c0d3ca5f3c0b$export$e4de839670987035 = v);
var $59e2c0d3ca5f3c0b$export$e4de839670987035;
"use strict";
$59e2c0d3ca5f3c0b$export$e4de839670987035 = $59e2c0d3ca5f3c0b$var$isAfter;

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $59e2c0d3ca5f3c0b$var$isAfter(date, dateToCompare) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}


Object.keys($59e2c0d3ca5f3c0b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $59e2c0d3ca5f3c0b$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $59e2c0d3ca5f3c0b$exports[key];
        }
    });
});
var $8c6f6dd2b4d885c1$exports = {};

$parcel$export($8c6f6dd2b4d885c1$exports, "isBefore", () => $8c6f6dd2b4d885c1$export$5c007e10c6929c95, (v) => $8c6f6dd2b4d885c1$export$5c007e10c6929c95 = v);
var $8c6f6dd2b4d885c1$export$5c007e10c6929c95;
"use strict";
$8c6f6dd2b4d885c1$export$5c007e10c6929c95 = $8c6f6dd2b4d885c1$var$isBefore;

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $8c6f6dd2b4d885c1$var$isBefore(date, dateToCompare) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateToCompare);
    return +_date < +_dateToCompare;
}


Object.keys($8c6f6dd2b4d885c1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8c6f6dd2b4d885c1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8c6f6dd2b4d885c1$exports[key];
        }
    });
});

Object.keys($85b6f418e42a275a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $85b6f418e42a275a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $85b6f418e42a275a$exports[key];
        }
    });
});
var $fba1f706f83f33b6$exports = {};

$parcel$export($fba1f706f83f33b6$exports, "isEqual", () => $fba1f706f83f33b6$export$248d38f6296296c5, (v) => $fba1f706f83f33b6$export$248d38f6296296c5 = v);
var $fba1f706f83f33b6$export$248d38f6296296c5;
"use strict";
$fba1f706f83f33b6$export$248d38f6296296c5 = $fba1f706f83f33b6$var$isEqual;

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $fba1f706f83f33b6$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(leftDate);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(rightDate);
    return +_dateLeft === +_dateRight;
}


Object.keys($fba1f706f83f33b6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $fba1f706f83f33b6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $fba1f706f83f33b6$exports[key];
        }
    });
});
var $0eb74ace5045fe89$exports = {};

$parcel$export($0eb74ace5045fe89$exports, "isExists", () => $0eb74ace5045fe89$export$127519e0edcdc58b, (v) => $0eb74ace5045fe89$export$127519e0edcdc58b = v);
var $0eb74ace5045fe89$export$127519e0edcdc58b;
"use strict";
$0eb74ace5045fe89$export$127519e0edcdc58b = $0eb74ace5045fe89$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $0eb74ace5045fe89$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}


Object.keys($0eb74ace5045fe89$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0eb74ace5045fe89$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0eb74ace5045fe89$exports[key];
        }
    });
});
var $0e818dec727e455d$exports = {};

$parcel$export($0e818dec727e455d$exports, "isFirstDayOfMonth", () => $0e818dec727e455d$export$2716a425049f51dd, (v) => $0e818dec727e455d$export$2716a425049f51dd = v);
var $0e818dec727e455d$export$2716a425049f51dd;
"use strict";
$0e818dec727e455d$export$2716a425049f51dd = $0e818dec727e455d$var$isFirstDayOfMonth;

/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $0e818dec727e455d$var$isFirstDayOfMonth(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDate() === 1;
}


Object.keys($0e818dec727e455d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0e818dec727e455d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0e818dec727e455d$exports[key];
        }
    });
});
var $6eb2cce1edb02041$exports = {};

$parcel$export($6eb2cce1edb02041$exports, "isFriday", () => $6eb2cce1edb02041$export$3b7d89f127884993, (v) => $6eb2cce1edb02041$export$3b7d89f127884993 = v);
var $6eb2cce1edb02041$export$3b7d89f127884993;
"use strict";
$6eb2cce1edb02041$export$3b7d89f127884993 = $6eb2cce1edb02041$var$isFriday;

/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $6eb2cce1edb02041$var$isFriday(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay() === 5;
}


Object.keys($6eb2cce1edb02041$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $6eb2cce1edb02041$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $6eb2cce1edb02041$exports[key];
        }
    });
});
var $f3e35565e2110876$exports = {};

$parcel$export($f3e35565e2110876$exports, "isFuture", () => $f3e35565e2110876$export$2baac2df6018cd7, (v) => $f3e35565e2110876$export$2baac2df6018cd7 = v);
var $f3e35565e2110876$export$2baac2df6018cd7;
"use strict";
$f3e35565e2110876$export$2baac2df6018cd7 = $f3e35565e2110876$var$isFuture;

/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $f3e35565e2110876$var$isFuture(date) {
    return +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date) > Date.now();
}


Object.keys($f3e35565e2110876$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f3e35565e2110876$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f3e35565e2110876$exports[key];
        }
    });
});

Object.keys($59a7e1998b9978b4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $59a7e1998b9978b4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $59a7e1998b9978b4$exports[key];
        }
    });
});

Object.keys($dd8899fe09bd64f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $dd8899fe09bd64f8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $dd8899fe09bd64f8$exports[key];
        }
    });
});
var $7693a7211ae95556$exports = {};

$parcel$export($7693a7211ae95556$exports, "isMatch", () => $7693a7211ae95556$export$b74c33566721f70f, (v) => $7693a7211ae95556$export$b74c33566721f70f = v);
var $7693a7211ae95556$export$b74c33566721f70f;
"use strict";
$7693a7211ae95556$export$b74c33566721f70f = $7693a7211ae95556$var$isMatch;

var $41113806dd07b1ef$exports = {};
"use strict";
Object.defineProperty($41113806dd07b1ef$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $14a0de1c0c2d5442$export$70cc8fd02856fd58;
    }
});
$41113806dd07b1ef$exports.parse = $41113806dd07b1ef$var$parse;
Object.defineProperty($41113806dd07b1ef$exports, "parsers", {
    enumerable: true,
    get: function() {
        return $b3c66655e789fca9$export$19131010e7fd8373;
    }
});






var $b3c66655e789fca9$export$19131010e7fd8373;
"use strict";
$b3c66655e789fca9$export$19131010e7fd8373 = void 0;
var $636223af8748a77a$export$8e5a1d3f85a9688;
"use strict";
$636223af8748a77a$export$8e5a1d3f85a9688 = void 0;
var $4bf5c55b4a7aa38c$export$7acfa6ed01010e37;
"use strict";
$4bf5c55b4a7aa38c$export$7acfa6ed01010e37 = void 0;
var $e09ae1b2868c636f$export$9a09e32dd4990fd5;
var $e09ae1b2868c636f$export$81d53e3678089a6;
var $e09ae1b2868c636f$export$5aaf7ff7f09ea4ee;
"use strict";
$e09ae1b2868c636f$export$9a09e32dd4990fd5 = $e09ae1b2868c636f$export$81d53e3678089a6 = $e09ae1b2868c636f$export$5aaf7ff7f09ea4ee = void 0;
var $8aeb01d247b025cb$exports = {};

$parcel$export($8aeb01d247b025cb$exports, "transpose", () => $8aeb01d247b025cb$export$9cb09a71b7d66923, (v) => $8aeb01d247b025cb$export$9cb09a71b7d66923 = v);
var $8aeb01d247b025cb$export$9cb09a71b7d66923;
"use strict";
$8aeb01d247b025cb$export$9cb09a71b7d66923 = $8aeb01d247b025cb$var$transpose;

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $8aeb01d247b025cb$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $d122570071c49798$export$ead8a1812b171991)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}



const $e09ae1b2868c636f$var$TIMEZONE_UNIT_PRIORITY = 10;
class $e09ae1b2868c636f$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$e09ae1b2868c636f$export$81d53e3678089a6 = $e09ae1b2868c636f$var$Setter;
class $e09ae1b2868c636f$var$ValueSetter extends $e09ae1b2868c636f$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$e09ae1b2868c636f$export$9a09e32dd4990fd5 = $e09ae1b2868c636f$var$ValueSetter;
class $e09ae1b2868c636f$var$DateToSystemTimezoneSetter extends $e09ae1b2868c636f$var$Setter {
    priority = $e09ae1b2868c636f$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $d122570071c49798$export$ead8a1812b171991)(date, (0, $8aeb01d247b025cb$export$9cb09a71b7d66923)(date, Date));
    }
}
$e09ae1b2868c636f$export$5aaf7ff7f09ea4ee = $e09ae1b2868c636f$var$DateToSystemTimezoneSetter;


class $4bf5c55b4a7aa38c$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $e09ae1b2868c636f$export$9a09e32dd4990fd5(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$4bf5c55b4a7aa38c$export$7acfa6ed01010e37 = $4bf5c55b4a7aa38c$var$Parser;


class $636223af8748a77a$var$EraParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$636223af8748a77a$export$8e5a1d3f85a9688 = $636223af8748a77a$var$EraParser;


var $a60438b356c7f1df$export$48d352de7cd4a988;
"use strict";
$a60438b356c7f1df$export$48d352de7cd4a988 = void 0;

var $247f19511e487226$export$fb506d2676e7f207;
var $247f19511e487226$export$3d50627710b84d75;
var $247f19511e487226$export$4f84e3a82c7b538;
var $247f19511e487226$export$29126f735cbf69f7;
var $247f19511e487226$export$d931c43c4608a164;
var $247f19511e487226$export$513bb01536146ab6;
var $247f19511e487226$export$2c9307b2e29c533c;
var $247f19511e487226$export$cc7cc9e2a3ff9388;
var $247f19511e487226$export$6497f4c0ecdfba8e;
"use strict";
$247f19511e487226$export$fb506d2676e7f207 = $247f19511e487226$var$dayPeriodEnumToHours;
$247f19511e487226$export$3d50627710b84d75 = $247f19511e487226$var$isLeapYearIndex;
$247f19511e487226$export$4f84e3a82c7b538 = $247f19511e487226$var$mapValue;
$247f19511e487226$export$29126f735cbf69f7 = $247f19511e487226$var$normalizeTwoDigitYear;
$247f19511e487226$export$d931c43c4608a164 = $247f19511e487226$var$parseAnyDigitsSigned;
$247f19511e487226$export$513bb01536146ab6 = $247f19511e487226$var$parseNDigits;
$247f19511e487226$export$2c9307b2e29c533c = $247f19511e487226$var$parseNDigitsSigned;
$247f19511e487226$export$cc7cc9e2a3ff9388 = $247f19511e487226$var$parseNumericPattern;
$247f19511e487226$export$6497f4c0ecdfba8e = $247f19511e487226$var$parseTimezonePattern;

var $15486c42ab30b9ee$export$a7ee192b982af9c1;
var $15486c42ab30b9ee$export$c123ee06d9da8480;
"use strict";
$15486c42ab30b9ee$export$a7ee192b982af9c1 = $15486c42ab30b9ee$export$c123ee06d9da8480 = void 0;
const $15486c42ab30b9ee$var$numericPatterns = $15486c42ab30b9ee$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $15486c42ab30b9ee$var$timezonePatterns = $15486c42ab30b9ee$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $247f19511e487226$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $247f19511e487226$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $247f19511e487226$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $68a6706ec8075339$export$7f72910d6dfd237a + minutes * $68a6706ec8075339$export$91246f0b9bd9beff + seconds * $68a6706ec8075339$export$397c2d5776aa9055),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $247f19511e487226$var$parseAnyDigitsSigned(dateString) {
    return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.anyDigitsSigned, dateString);
}
function $247f19511e487226$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.singleDigit, dateString);
        case 2:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.twoDigits, dateString);
        case 3:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.threeDigits, dateString);
        case 4:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.fourDigits, dateString);
        default:
            return $247f19511e487226$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $247f19511e487226$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.singleDigitSigned, dateString);
        case 2:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.twoDigitsSigned, dateString);
        case 3:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.threeDigitsSigned, dateString);
        case 4:
            return $247f19511e487226$var$parseNumericPattern($15486c42ab30b9ee$export$c123ee06d9da8480.fourDigitsSigned, dateString);
        default:
            return $247f19511e487226$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $247f19511e487226$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $247f19511e487226$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $247f19511e487226$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $a60438b356c7f1df$var$YearParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $247f19511e487226$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$a60438b356c7f1df$export$48d352de7cd4a988 = $a60438b356c7f1df$var$YearParser;


var $1429c33a70368c74$export$b8ef38dfcf05d5db;
"use strict";
$1429c33a70368c74$export$b8ef38dfcf05d5db = void 0;




// Local week-numbering year
class $1429c33a70368c74$var$LocalWeekYearParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $fc873680f7d773ff$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $247f19511e487226$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$1429c33a70368c74$export$b8ef38dfcf05d5db = $1429c33a70368c74$var$LocalWeekYearParser;


var $7dba73c345b37cca$export$951d1df011fde06f;
"use strict";
$7dba73c345b37cca$export$951d1df011fde06f = void 0;




// ISO week-numbering year
class $7dba73c345b37cca$var$ISOWeekYearParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $247f19511e487226$export$2c9307b2e29c533c)(4, dateString);
        return (0, $247f19511e487226$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$7dba73c345b37cca$export$951d1df011fde06f = $7dba73c345b37cca$var$ISOWeekYearParser;


var $7507da0aea3723b7$export$bad9d2ea38e8f1a;
"use strict";
$7507da0aea3723b7$export$bad9d2ea38e8f1a = void 0;


class $7507da0aea3723b7$var$ExtendedYearParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $247f19511e487226$export$2c9307b2e29c533c)(4, dateString);
        return (0, $247f19511e487226$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$7507da0aea3723b7$export$bad9d2ea38e8f1a = $7507da0aea3723b7$var$ExtendedYearParser;


var $cbf917a17cda7289$export$5cb0f701186dde1d;
"use strict";
$cbf917a17cda7289$export$5cb0f701186dde1d = void 0;


class $cbf917a17cda7289$var$QuarterParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$cbf917a17cda7289$export$5cb0f701186dde1d = $cbf917a17cda7289$var$QuarterParser;


var $963b395fef127c97$export$300c0c2990e20e6d;
"use strict";
$963b395fef127c97$export$300c0c2990e20e6d = void 0;


class $963b395fef127c97$var$StandAloneQuarterParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$963b395fef127c97$export$300c0c2990e20e6d = $963b395fef127c97$var$StandAloneQuarterParser;


var $6cf1f2ad592f31ed$export$400dd8b40ef138a3;
"use strict";
$6cf1f2ad592f31ed$export$400dd8b40ef138a3 = void 0;



class $6cf1f2ad592f31ed$var$MonthParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$6cf1f2ad592f31ed$export$400dd8b40ef138a3 = $6cf1f2ad592f31ed$var$MonthParser;


var $6293d025a166b920$export$1d7eaa53eaa5deba;
"use strict";
$6293d025a166b920$export$1d7eaa53eaa5deba = void 0;



class $6293d025a166b920$var$StandAloneMonthParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6293d025a166b920$export$1d7eaa53eaa5deba = $6293d025a166b920$var$StandAloneMonthParser;


var $6e847a79a8d94fb3$export$c4005ffc174e07c0;
"use strict";
$6e847a79a8d94fb3$export$c4005ffc174e07c0 = void 0;
var $952110cb424f6568$exports = {};

$parcel$export($952110cb424f6568$exports, "setWeek", () => $952110cb424f6568$export$4b3066ce4afafd88, (v) => $952110cb424f6568$export$4b3066ce4afafd88 = v);
var $952110cb424f6568$export$4b3066ce4afafd88;
"use strict";
$952110cb424f6568$export$4b3066ce4afafd88 = $952110cb424f6568$var$setWeek;


/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $952110cb424f6568$var$setWeek(date, week, options) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const diff = (0, $cd28fd34ea432b51$export$efe19b760242b2fc)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// Local week of year
class $6e847a79a8d94fb3$var$LocalWeekParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)((0, $952110cb424f6568$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$6e847a79a8d94fb3$export$c4005ffc174e07c0 = $6e847a79a8d94fb3$var$LocalWeekParser;


var $51f899ff296eec71$export$6fc8dbedd560a6af;
"use strict";
$51f899ff296eec71$export$6fc8dbedd560a6af = void 0;
var $f8ba334b5e0396af$exports = {};

$parcel$export($f8ba334b5e0396af$exports, "setISOWeek", () => $f8ba334b5e0396af$export$6542bebf6be94082, (v) => $f8ba334b5e0396af$export$6542bebf6be94082 = v);
var $f8ba334b5e0396af$export$6542bebf6be94082;
"use strict";
$f8ba334b5e0396af$export$6542bebf6be94082 = $f8ba334b5e0396af$var$setISOWeek;


/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $f8ba334b5e0396af$var$setISOWeek(date, week) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const diff = (0, $a5f39ea06618a69d$export$7cabdc5698b63e2f)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// ISO week of year
class $51f899ff296eec71$var$ISOWeekParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $e35c31db2e1e85b1$export$6173213f95a4431e)((0, $f8ba334b5e0396af$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$51f899ff296eec71$export$6fc8dbedd560a6af = $51f899ff296eec71$var$ISOWeekParser;


var $f2f8a72cdc2e1802$export$e8d4b28a20981dd2;
"use strict";
$f2f8a72cdc2e1802$export$e8d4b28a20981dd2 = void 0;



const $f2f8a72cdc2e1802$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $f2f8a72cdc2e1802$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $f2f8a72cdc2e1802$var$DateParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $247f19511e487226$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $f2f8a72cdc2e1802$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $f2f8a72cdc2e1802$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f2f8a72cdc2e1802$export$e8d4b28a20981dd2 = $f2f8a72cdc2e1802$var$DateParser;


var $90b1105e47c92823$export$6cfe0d613455f615;
"use strict";
$90b1105e47c92823$export$6cfe0d613455f615 = void 0;



class $90b1105e47c92823$var$DayOfYearParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $247f19511e487226$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$90b1105e47c92823$export$6cfe0d613455f615 = $90b1105e47c92823$var$DayOfYearParser;


var $e46200fbf4a325c6$export$1b03c8b76262f7bd;
"use strict";
$e46200fbf4a325c6$export$1b03c8b76262f7bd = void 0;
var $0862d0c9051b14a8$exports = {};

$parcel$export($0862d0c9051b14a8$exports, "setDay", () => $0862d0c9051b14a8$export$b04fdcda82decc6c, (v) => $0862d0c9051b14a8$export$b04fdcda82decc6c = v);
var $0862d0c9051b14a8$export$b04fdcda82decc6c;
"use strict";
$0862d0c9051b14a8$export$b04fdcda82decc6c = $0862d0c9051b14a8$var$setDay;



/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $0862d0c9051b14a8$var$setDay(date, day, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(_date, diff);
}



// Day of week
class $e46200fbf4a325c6$var$DayParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $0862d0c9051b14a8$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e46200fbf4a325c6$export$1b03c8b76262f7bd = $e46200fbf4a325c6$var$DayParser;


var $887883380b8b9842$export$44d1c127ab42c480;
"use strict";
$887883380b8b9842$export$44d1c127ab42c480 = void 0;



// Local day of week
class $887883380b8b9842$var$LocalDayParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $0862d0c9051b14a8$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$887883380b8b9842$export$44d1c127ab42c480 = $887883380b8b9842$var$LocalDayParser;


var $6701fb33e32d508b$export$e447a647caaaec1d;
"use strict";
$6701fb33e32d508b$export$e447a647caaaec1d = void 0;



// Stand-alone local day of week
class $6701fb33e32d508b$var$StandAloneLocalDayParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $0862d0c9051b14a8$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$6701fb33e32d508b$export$e447a647caaaec1d = $6701fb33e32d508b$var$StandAloneLocalDayParser;


var $6a61be44a3e29ecc$export$693fb1e525095b2a;
"use strict";
$6a61be44a3e29ecc$export$693fb1e525095b2a = void 0;
var $82929f56fcd14f2e$exports = {};

$parcel$export($82929f56fcd14f2e$exports, "setISODay", () => $82929f56fcd14f2e$export$1fd9df65adb0d1aa, (v) => $82929f56fcd14f2e$export$1fd9df65adb0d1aa = v);
var $82929f56fcd14f2e$export$1fd9df65adb0d1aa;
"use strict";
$82929f56fcd14f2e$export$1fd9df65adb0d1aa = $82929f56fcd14f2e$var$setISODay;



/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $82929f56fcd14f2e$var$setISODay(date, day) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const currentDay = (0, $b8e7d0a4aa2c277f$export$c514f4c1a8ed5e9e)(_date);
    const diff = day - currentDay;
    return (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(_date, diff);
}




// ISO day of week
class $6a61be44a3e29ecc$var$ISODayParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $247f19511e487226$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $82929f56fcd14f2e$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$6a61be44a3e29ecc$export$693fb1e525095b2a = $6a61be44a3e29ecc$var$ISODayParser;


var $bebeb82ce9bda57d$export$8d1e08492351df91;
"use strict";
$bebeb82ce9bda57d$export$8d1e08492351df91 = void 0;


class $bebeb82ce9bda57d$var$AMPMParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $247f19511e487226$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$bebeb82ce9bda57d$export$8d1e08492351df91 = $bebeb82ce9bda57d$var$AMPMParser;


var $ae4f1be940112933$export$73ca2bd0a17d273;
"use strict";
$ae4f1be940112933$export$73ca2bd0a17d273 = void 0;


class $ae4f1be940112933$var$AMPMMidnightParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $247f19511e487226$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$ae4f1be940112933$export$73ca2bd0a17d273 = $ae4f1be940112933$var$AMPMMidnightParser;


var $ad66ffab63ff77c5$export$bb9212adf05373db;
"use strict";
$ad66ffab63ff77c5$export$bb9212adf05373db = void 0;


// in the morning, in the afternoon, in the evening, at night
class $ad66ffab63ff77c5$var$DayPeriodParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $247f19511e487226$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$ad66ffab63ff77c5$export$bb9212adf05373db = $ad66ffab63ff77c5$var$DayPeriodParser;


var $0093a3506522befe$export$8a04050a727a1756;
"use strict";
$0093a3506522befe$export$8a04050a727a1756 = void 0;



class $0093a3506522befe$var$Hour1to12Parser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$0093a3506522befe$export$8a04050a727a1756 = $0093a3506522befe$var$Hour1to12Parser;


var $f3eb12fd3fd537c9$export$e56f4dea2c3e56dd;
"use strict";
$f3eb12fd3fd537c9$export$e56f4dea2c3e56dd = void 0;



class $f3eb12fd3fd537c9$var$Hour0to23Parser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$f3eb12fd3fd537c9$export$e56f4dea2c3e56dd = $f3eb12fd3fd537c9$var$Hour0to23Parser;


var $0d9a0a7c58e9744e$export$cbbe855312f87d77;
"use strict";
$0d9a0a7c58e9744e$export$cbbe855312f87d77 = void 0;



class $0d9a0a7c58e9744e$var$Hour0To11Parser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$0d9a0a7c58e9744e$export$cbbe855312f87d77 = $0d9a0a7c58e9744e$var$Hour0To11Parser;


var $304373103a6c1b76$export$6008046d2b34b6a5;
"use strict";
$304373103a6c1b76$export$6008046d2b34b6a5 = void 0;



class $304373103a6c1b76$var$Hour1To24Parser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$304373103a6c1b76$export$6008046d2b34b6a5 = $304373103a6c1b76$var$Hour1To24Parser;


var $83e726e95dd4d358$export$2b52670d9e2be53;
"use strict";
$83e726e95dd4d358$export$2b52670d9e2be53 = void 0;



class $83e726e95dd4d358$var$MinuteParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$83e726e95dd4d358$export$2b52670d9e2be53 = $83e726e95dd4d358$var$MinuteParser;


var $fc9b141b84a61903$export$94d46d540cf1366a;
"use strict";
$fc9b141b84a61903$export$94d46d540cf1366a = void 0;



class $fc9b141b84a61903$var$SecondParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $247f19511e487226$export$cc7cc9e2a3ff9388)($15486c42ab30b9ee$export$c123ee06d9da8480.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$fc9b141b84a61903$export$94d46d540cf1366a = $fc9b141b84a61903$var$SecondParser;


var $db6564007d062521$export$b8e6f8b2d70893b1;
"use strict";
$db6564007d062521$export$b8e6f8b2d70893b1 = void 0;


class $db6564007d062521$var$FractionOfSecondParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $247f19511e487226$export$4f84e3a82c7b538)((0, $247f19511e487226$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$db6564007d062521$export$b8e6f8b2d70893b1 = $db6564007d062521$var$FractionOfSecondParser;


var $eb69b8f9a6c7d286$export$104d901d49fea29b;
"use strict";
$eb69b8f9a6c7d286$export$104d901d49fea29b = void 0;





// Timezone (ISO-8601. +00:00 is `'Z'`)
class $eb69b8f9a6c7d286$var$ISOTimezoneWithZParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.basic, dateString);
            case "XXXX":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $d122570071c49798$export$ead8a1812b171991)(date, date.getTime() - (0, $588883c191ca40e9$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$eb69b8f9a6c7d286$export$104d901d49fea29b = $eb69b8f9a6c7d286$var$ISOTimezoneWithZParser;


var $58747dbbef2c4f69$export$12910e5204b52b9;
"use strict";
$58747dbbef2c4f69$export$12910e5204b52b9 = void 0;





// Timezone (ISO-8601)
class $58747dbbef2c4f69$var$ISOTimezoneParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.basic, dateString);
            case "xxxx":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $247f19511e487226$export$6497f4c0ecdfba8e)($15486c42ab30b9ee$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $d122570071c49798$export$ead8a1812b171991)(date, date.getTime() - (0, $588883c191ca40e9$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$58747dbbef2c4f69$export$12910e5204b52b9 = $58747dbbef2c4f69$var$ISOTimezoneParser;


var $783007311462fc28$export$2cd8bf877a05e96;
"use strict";
$783007311462fc28$export$2cd8bf877a05e96 = void 0;



class $783007311462fc28$var$TimestampSecondsParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 40;
    parse(dateString) {
        return (0, $247f19511e487226$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $d122570071c49798$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$783007311462fc28$export$2cd8bf877a05e96 = $783007311462fc28$var$TimestampSecondsParser;


var $19238d77f8729f97$export$6d8f69c6906d6368;
"use strict";
$19238d77f8729f97$export$6d8f69c6906d6368 = void 0;



class $19238d77f8729f97$var$TimestampMillisecondsParser extends $4bf5c55b4a7aa38c$export$7acfa6ed01010e37 {
    priority = 20;
    parse(dateString) {
        return (0, $247f19511e487226$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $d122570071c49798$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$19238d77f8729f97$export$6d8f69c6906d6368 = $19238d77f8729f97$var$TimestampMillisecondsParser;


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $b3c66655e789fca9$var$parsers = $b3c66655e789fca9$export$19131010e7fd8373 = {
    G: new $636223af8748a77a$export$8e5a1d3f85a9688(),
    y: new $a60438b356c7f1df$export$48d352de7cd4a988(),
    Y: new $1429c33a70368c74$export$b8ef38dfcf05d5db(),
    R: new $7dba73c345b37cca$export$951d1df011fde06f(),
    u: new $7507da0aea3723b7$export$bad9d2ea38e8f1a(),
    Q: new $cbf917a17cda7289$export$5cb0f701186dde1d(),
    q: new $963b395fef127c97$export$300c0c2990e20e6d(),
    M: new $6cf1f2ad592f31ed$export$400dd8b40ef138a3(),
    L: new $6293d025a166b920$export$1d7eaa53eaa5deba(),
    w: new $6e847a79a8d94fb3$export$c4005ffc174e07c0(),
    I: new $51f899ff296eec71$export$6fc8dbedd560a6af(),
    d: new $f2f8a72cdc2e1802$export$e8d4b28a20981dd2(),
    D: new $90b1105e47c92823$export$6cfe0d613455f615(),
    E: new $e46200fbf4a325c6$export$1b03c8b76262f7bd(),
    e: new $887883380b8b9842$export$44d1c127ab42c480(),
    c: new $6701fb33e32d508b$export$e447a647caaaec1d(),
    i: new $6a61be44a3e29ecc$export$693fb1e525095b2a(),
    a: new $bebeb82ce9bda57d$export$8d1e08492351df91(),
    b: new $ae4f1be940112933$export$73ca2bd0a17d273(),
    B: new $ad66ffab63ff77c5$export$bb9212adf05373db(),
    h: new $0093a3506522befe$export$8a04050a727a1756(),
    H: new $f3eb12fd3fd537c9$export$e56f4dea2c3e56dd(),
    K: new $0d9a0a7c58e9744e$export$cbbe855312f87d77(),
    k: new $304373103a6c1b76$export$6008046d2b34b6a5(),
    m: new $83e726e95dd4d358$export$2b52670d9e2be53(),
    s: new $fc9b141b84a61903$export$94d46d540cf1366a(),
    S: new $db6564007d062521$export$b8e6f8b2d70893b1(),
    X: new $eb69b8f9a6c7d286$export$104d901d49fea29b(),
    x: new $58747dbbef2c4f69$export$12910e5204b52b9(),
    t: new $783007311462fc28$export$2cd8bf877a05e96(),
    T: new $19238d77f8729f97$export$6d8f69c6906d6368()
};



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $41113806dd07b1ef$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $41113806dd07b1ef$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $41113806dd07b1ef$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $41113806dd07b1ef$var$doubleQuoteRegExp = /''/g;
const $41113806dd07b1ef$var$notWhitespaceRegExp = /\S/;
const $41113806dd07b1ef$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $41113806dd07b1ef$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $c855634a1566d11e$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $b5606a4787083ded$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(referenceDate);
        else return (0, $d122570071c49798$export$ead8a1812b171991)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $e09ae1b2868c636f$export$5aaf7ff7f09ea4ee()
    ];
    const tokens = formatStr.match($41113806dd07b1ef$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $14a0de1c0c2d5442$export$70cc8fd02856fd58) {
            const longFormatter = $14a0de1c0c2d5442$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($41113806dd07b1ef$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $9d5fabdcbe897d16$export$c6b49d6dceb604a1)(token)) (0, $9d5fabdcbe897d16$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $9d5fabdcbe897d16$export$c6cc36aa33304772)(token)) (0, $9d5fabdcbe897d16$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $b3c66655e789fca9$export$19131010e7fd8373[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $d122570071c49798$export$ead8a1812b171991)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($41113806dd07b1ef$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $41113806dd07b1ef$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $d122570071c49798$export$ead8a1812b171991)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $41113806dd07b1ef$var$notWhitespaceRegExp.test(dateStr)) return (0, $d122570071c49798$export$ead8a1812b171991)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(referenceDate);
    if (isNaN(date.getTime())) return (0, $d122570071c49798$export$ead8a1812b171991)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $d122570071c49798$export$ead8a1812b171991)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $d122570071c49798$export$ead8a1812b171991)(referenceDate, date);
}
function $41113806dd07b1ef$var$cleanEscapedString(input) {
    return input.match($41113806dd07b1ef$var$escapedStringRegExp)[1].replace($41113806dd07b1ef$var$doubleQuoteRegExp, "'");
}


/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $7693a7211ae95556$var$isMatch(dateStr, formatStr, options) {
    return (0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)((0, $41113806dd07b1ef$exports.parse)(dateStr, formatStr, new Date(), options));
}


Object.keys($7693a7211ae95556$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $7693a7211ae95556$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $7693a7211ae95556$exports[key];
        }
    });
});
var $74fbbbe051bebd3c$exports = {};

$parcel$export($74fbbbe051bebd3c$exports, "isMonday", () => $74fbbbe051bebd3c$export$9573fe9b7c9ac3f5, (v) => $74fbbbe051bebd3c$export$9573fe9b7c9ac3f5 = v);
var $74fbbbe051bebd3c$export$9573fe9b7c9ac3f5;
"use strict";
$74fbbbe051bebd3c$export$9573fe9b7c9ac3f5 = $74fbbbe051bebd3c$var$isMonday;

/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $74fbbbe051bebd3c$var$isMonday(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay() === 1;
}


Object.keys($74fbbbe051bebd3c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $74fbbbe051bebd3c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $74fbbbe051bebd3c$exports[key];
        }
    });
});
var $194f4de52ae31051$exports = {};

$parcel$export($194f4de52ae31051$exports, "isPast", () => $194f4de52ae31051$export$fc5014aa3db48558, (v) => $194f4de52ae31051$export$fc5014aa3db48558 = v);
var $194f4de52ae31051$export$fc5014aa3db48558;
"use strict";
$194f4de52ae31051$export$fc5014aa3db48558 = $194f4de52ae31051$var$isPast;

/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $194f4de52ae31051$var$isPast(date) {
    return +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date) < Date.now();
}


Object.keys($194f4de52ae31051$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $194f4de52ae31051$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $194f4de52ae31051$exports[key];
        }
    });
});

Object.keys($d1275d6457f4d4aa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d1275d6457f4d4aa$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d1275d6457f4d4aa$exports[key];
        }
    });
});
var $b235e6c1cba30b31$exports = {};

$parcel$export($b235e6c1cba30b31$exports, "isSameHour", () => $b235e6c1cba30b31$export$f9f3a94a0371013, (v) => $b235e6c1cba30b31$export$f9f3a94a0371013 = v);
var $b235e6c1cba30b31$export$f9f3a94a0371013;
"use strict";
$b235e6c1cba30b31$export$f9f3a94a0371013 = $b235e6c1cba30b31$var$isSameHour;
var $a77fac645c14050f$exports = {};

$parcel$export($a77fac645c14050f$exports, "startOfHour", () => $a77fac645c14050f$export$24f91f68e7c9d9d5, (v) => $a77fac645c14050f$export$24f91f68e7c9d9d5 = v);
var $a77fac645c14050f$export$24f91f68e7c9d9d5;
"use strict";
$a77fac645c14050f$export$24f91f68e7c9d9d5 = $a77fac645c14050f$var$startOfHour;

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $a77fac645c14050f$var$startOfHour(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $b235e6c1cba30b31$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $a77fac645c14050f$export$24f91f68e7c9d9d5)(dateLeft);
    const dateRightStartOfHour = (0, $a77fac645c14050f$export$24f91f68e7c9d9d5)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}


Object.keys($b235e6c1cba30b31$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b235e6c1cba30b31$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b235e6c1cba30b31$exports[key];
        }
    });
});
var $64ec02a6c891e4d6$exports = {};

$parcel$export($64ec02a6c891e4d6$exports, "isSameISOWeek", () => $64ec02a6c891e4d6$export$1c6e74e3c7b27764, (v) => $64ec02a6c891e4d6$export$1c6e74e3c7b27764 = v);
var $64ec02a6c891e4d6$export$1c6e74e3c7b27764;
"use strict";
$64ec02a6c891e4d6$export$1c6e74e3c7b27764 = $64ec02a6c891e4d6$var$isSameISOWeek;
var $797b36256ddc073d$exports = {};

$parcel$export($797b36256ddc073d$exports, "isSameWeek", () => $797b36256ddc073d$export$6ea683876c36b8d2, (v) => $797b36256ddc073d$export$6ea683876c36b8d2 = v);
var $797b36256ddc073d$export$6ea683876c36b8d2;
"use strict";
$797b36256ddc073d$export$6ea683876c36b8d2 = $797b36256ddc073d$var$isSameWeek;

/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $797b36256ddc073d$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(dateLeft, options);
    const dateRightStartOfWeek = (0, $4e0d9d2cb57da1ac$export$42c81a444fbfb5d4)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $64ec02a6c891e4d6$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $797b36256ddc073d$export$6ea683876c36b8d2)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}


Object.keys($64ec02a6c891e4d6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $64ec02a6c891e4d6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $64ec02a6c891e4d6$exports[key];
        }
    });
});
var $403b8488d7a8b620$exports = {};

$parcel$export($403b8488d7a8b620$exports, "isSameISOWeekYear", () => $403b8488d7a8b620$export$5f55dbf38a1aee81, (v) => $403b8488d7a8b620$export$5f55dbf38a1aee81 = v);
var $403b8488d7a8b620$export$5f55dbf38a1aee81;
"use strict";
$403b8488d7a8b620$export$5f55dbf38a1aee81 = $403b8488d7a8b620$var$isSameISOWeekYear;

/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $403b8488d7a8b620$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $b2d2382037e56893$export$236bdfa374eb69a9)(dateLeft);
    const dateRightStartOfYear = (0, $b2d2382037e56893$export$236bdfa374eb69a9)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}


Object.keys($403b8488d7a8b620$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $403b8488d7a8b620$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $403b8488d7a8b620$exports[key];
        }
    });
});
var $5d2b109b982b0ed1$exports = {};

$parcel$export($5d2b109b982b0ed1$exports, "isSameMinute", () => $5d2b109b982b0ed1$export$5d274bf63c8705cb, (v) => $5d2b109b982b0ed1$export$5d274bf63c8705cb = v);
var $5d2b109b982b0ed1$export$5d274bf63c8705cb;
"use strict";
$5d2b109b982b0ed1$export$5d274bf63c8705cb = $5d2b109b982b0ed1$var$isSameMinute;

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $5d2b109b982b0ed1$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $0d13cf15751d2b2c$export$c66440458c6aa793)(dateLeft);
    const dateRightStartOfMinute = (0, $0d13cf15751d2b2c$export$c66440458c6aa793)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}


Object.keys($5d2b109b982b0ed1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5d2b109b982b0ed1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5d2b109b982b0ed1$exports[key];
        }
    });
});
var $05908a82dea08f3f$exports = {};

$parcel$export($05908a82dea08f3f$exports, "isSameMonth", () => $05908a82dea08f3f$export$a18c89cbd24170ff, (v) => $05908a82dea08f3f$export$a18c89cbd24170ff = v);
var $05908a82dea08f3f$export$a18c89cbd24170ff;
"use strict";
$05908a82dea08f3f$export$a18c89cbd24170ff = $05908a82dea08f3f$var$isSameMonth;

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $05908a82dea08f3f$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}


Object.keys($05908a82dea08f3f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $05908a82dea08f3f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $05908a82dea08f3f$exports[key];
        }
    });
});
var $9d6067a22aba0eed$exports = {};

$parcel$export($9d6067a22aba0eed$exports, "isSameQuarter", () => $9d6067a22aba0eed$export$5c60e4190867161c, (v) => $9d6067a22aba0eed$export$5c60e4190867161c = v);
var $9d6067a22aba0eed$export$5c60e4190867161c;
"use strict";
$9d6067a22aba0eed$export$5c60e4190867161c = $9d6067a22aba0eed$var$isSameQuarter;

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $9d6067a22aba0eed$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $a0d6a3a081a59e60$export$69be7267a042ecb3)(dateLeft);
    const dateRightStartOfQuarter = (0, $a0d6a3a081a59e60$export$69be7267a042ecb3)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}


Object.keys($9d6067a22aba0eed$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $9d6067a22aba0eed$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $9d6067a22aba0eed$exports[key];
        }
    });
});
var $a229e54cc24d4c5b$exports = {};

$parcel$export($a229e54cc24d4c5b$exports, "isSameSecond", () => $a229e54cc24d4c5b$export$b88fbcfe038f3498, (v) => $a229e54cc24d4c5b$export$b88fbcfe038f3498 = v);
var $a229e54cc24d4c5b$export$b88fbcfe038f3498;
"use strict";
$a229e54cc24d4c5b$export$b88fbcfe038f3498 = $a229e54cc24d4c5b$var$isSameSecond;
var $dca062d79702aef8$exports = {};

$parcel$export($dca062d79702aef8$exports, "startOfSecond", () => $dca062d79702aef8$export$66c51f9715fdbff5, (v) => $dca062d79702aef8$export$66c51f9715fdbff5 = v);
var $dca062d79702aef8$export$66c51f9715fdbff5;
"use strict";
$dca062d79702aef8$export$66c51f9715fdbff5 = $dca062d79702aef8$var$startOfSecond;

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $dca062d79702aef8$var$startOfSecond(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(0);
    return _date;
}


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $a229e54cc24d4c5b$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $dca062d79702aef8$export$66c51f9715fdbff5)(dateLeft);
    const dateRightStartOfSecond = (0, $dca062d79702aef8$export$66c51f9715fdbff5)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}


Object.keys($a229e54cc24d4c5b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a229e54cc24d4c5b$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a229e54cc24d4c5b$exports[key];
        }
    });
});

Object.keys($797b36256ddc073d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $797b36256ddc073d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $797b36256ddc073d$exports[key];
        }
    });
});
var $021030c25b8bcda3$exports = {};

$parcel$export($021030c25b8bcda3$exports, "isSameYear", () => $021030c25b8bcda3$export$5841f9eb9773f25f, (v) => $021030c25b8bcda3$export$5841f9eb9773f25f = v);
var $021030c25b8bcda3$export$5841f9eb9773f25f;
"use strict";
$021030c25b8bcda3$export$5841f9eb9773f25f = $021030c25b8bcda3$var$isSameYear;

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $021030c25b8bcda3$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}


Object.keys($021030c25b8bcda3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $021030c25b8bcda3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $021030c25b8bcda3$exports[key];
        }
    });
});

Object.keys($32791e28314ec933$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $32791e28314ec933$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $32791e28314ec933$exports[key];
        }
    });
});

Object.keys($1988039d914ad977$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $1988039d914ad977$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $1988039d914ad977$exports[key];
        }
    });
});
var $77f6084e2f3c6a16$exports = {};

$parcel$export($77f6084e2f3c6a16$exports, "isThisHour", () => $77f6084e2f3c6a16$export$5d41bdc7172839b9, (v) => $77f6084e2f3c6a16$export$5d41bdc7172839b9 = v);
var $77f6084e2f3c6a16$export$5d41bdc7172839b9;
"use strict";
$77f6084e2f3c6a16$export$5d41bdc7172839b9 = $77f6084e2f3c6a16$var$isThisHour;


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $77f6084e2f3c6a16$var$isThisHour(date) {
    return (0, $b235e6c1cba30b31$export$f9f3a94a0371013)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($77f6084e2f3c6a16$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $77f6084e2f3c6a16$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $77f6084e2f3c6a16$exports[key];
        }
    });
});
var $886c34de617962d7$exports = {};

$parcel$export($886c34de617962d7$exports, "isThisISOWeek", () => $886c34de617962d7$export$4e987896c721f753, (v) => $886c34de617962d7$export$4e987896c721f753 = v);
var $886c34de617962d7$export$4e987896c721f753;
"use strict";
$886c34de617962d7$export$4e987896c721f753 = $886c34de617962d7$var$isThisISOWeek;


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $886c34de617962d7$var$isThisISOWeek(date) {
    return (0, $64ec02a6c891e4d6$export$1c6e74e3c7b27764)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($886c34de617962d7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $886c34de617962d7$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $886c34de617962d7$exports[key];
        }
    });
});
var $45f94f85b9f0e601$exports = {};

$parcel$export($45f94f85b9f0e601$exports, "isThisMinute", () => $45f94f85b9f0e601$export$fa55b7d29d8d957a, (v) => $45f94f85b9f0e601$export$fa55b7d29d8d957a = v);
var $45f94f85b9f0e601$export$fa55b7d29d8d957a;
"use strict";
$45f94f85b9f0e601$export$fa55b7d29d8d957a = $45f94f85b9f0e601$var$isThisMinute;


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $45f94f85b9f0e601$var$isThisMinute(date) {
    return (0, $5d2b109b982b0ed1$export$5d274bf63c8705cb)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($45f94f85b9f0e601$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $45f94f85b9f0e601$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $45f94f85b9f0e601$exports[key];
        }
    });
});
var $58e19c40ef4dedb8$exports = {};

$parcel$export($58e19c40ef4dedb8$exports, "isThisMonth", () => $58e19c40ef4dedb8$export$173f1e1d92847276, (v) => $58e19c40ef4dedb8$export$173f1e1d92847276 = v);
var $58e19c40ef4dedb8$export$173f1e1d92847276;
"use strict";
$58e19c40ef4dedb8$export$173f1e1d92847276 = $58e19c40ef4dedb8$var$isThisMonth;


/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $58e19c40ef4dedb8$var$isThisMonth(date) {
    return (0, $05908a82dea08f3f$export$a18c89cbd24170ff)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($58e19c40ef4dedb8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $58e19c40ef4dedb8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $58e19c40ef4dedb8$exports[key];
        }
    });
});
var $57af35df4375db9c$exports = {};

$parcel$export($57af35df4375db9c$exports, "isThisQuarter", () => $57af35df4375db9c$export$3d88fd18ab599ccc, (v) => $57af35df4375db9c$export$3d88fd18ab599ccc = v);
var $57af35df4375db9c$export$3d88fd18ab599ccc;
"use strict";
$57af35df4375db9c$export$3d88fd18ab599ccc = $57af35df4375db9c$var$isThisQuarter;


/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $57af35df4375db9c$var$isThisQuarter(date) {
    return (0, $9d6067a22aba0eed$export$5c60e4190867161c)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($57af35df4375db9c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $57af35df4375db9c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $57af35df4375db9c$exports[key];
        }
    });
});
var $3cadbf7081ef8ef1$exports = {};

$parcel$export($3cadbf7081ef8ef1$exports, "isThisSecond", () => $3cadbf7081ef8ef1$export$8d7059b5bca087e6, (v) => $3cadbf7081ef8ef1$export$8d7059b5bca087e6 = v);
var $3cadbf7081ef8ef1$export$8d7059b5bca087e6;
"use strict";
$3cadbf7081ef8ef1$export$8d7059b5bca087e6 = $3cadbf7081ef8ef1$var$isThisSecond;


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $3cadbf7081ef8ef1$var$isThisSecond(date) {
    return (0, $a229e54cc24d4c5b$export$b88fbcfe038f3498)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($3cadbf7081ef8ef1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3cadbf7081ef8ef1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3cadbf7081ef8ef1$exports[key];
        }
    });
});
var $0c279fee8cb70a96$exports = {};

$parcel$export($0c279fee8cb70a96$exports, "isThisWeek", () => $0c279fee8cb70a96$export$cfe4b66a69cdd8a, (v) => $0c279fee8cb70a96$export$cfe4b66a69cdd8a = v);
var $0c279fee8cb70a96$export$cfe4b66a69cdd8a;
"use strict";
$0c279fee8cb70a96$export$cfe4b66a69cdd8a = $0c279fee8cb70a96$var$isThisWeek;


/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $0c279fee8cb70a96$var$isThisWeek(date, options) {
    return (0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date), options);
}


Object.keys($0c279fee8cb70a96$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0c279fee8cb70a96$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0c279fee8cb70a96$exports[key];
        }
    });
});
var $f84ac4d7ff95c338$exports = {};

$parcel$export($f84ac4d7ff95c338$exports, "isThisYear", () => $f84ac4d7ff95c338$export$a28c94941893a5ac, (v) => $f84ac4d7ff95c338$export$a28c94941893a5ac = v);
var $f84ac4d7ff95c338$export$a28c94941893a5ac;
"use strict";
$f84ac4d7ff95c338$export$a28c94941893a5ac = $f84ac4d7ff95c338$var$isThisYear;


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $f84ac4d7ff95c338$var$isThisYear(date) {
    return (0, $021030c25b8bcda3$export$5841f9eb9773f25f)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($f84ac4d7ff95c338$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f84ac4d7ff95c338$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f84ac4d7ff95c338$exports[key];
        }
    });
});
var $6d2dd1c8c4c0b84e$exports = {};

$parcel$export($6d2dd1c8c4c0b84e$exports, "isThursday", () => $6d2dd1c8c4c0b84e$export$c8e7c906983ea347, (v) => $6d2dd1c8c4c0b84e$export$c8e7c906983ea347 = v);
var $6d2dd1c8c4c0b84e$export$c8e7c906983ea347;
"use strict";
$6d2dd1c8c4c0b84e$export$c8e7c906983ea347 = $6d2dd1c8c4c0b84e$var$isThursday;

/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $6d2dd1c8c4c0b84e$var$isThursday(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay() === 4;
}


Object.keys($6d2dd1c8c4c0b84e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $6d2dd1c8c4c0b84e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $6d2dd1c8c4c0b84e$exports[key];
        }
    });
});
var $b28cd5a4f27ed1a5$exports = {};

$parcel$export($b28cd5a4f27ed1a5$exports, "isToday", () => $b28cd5a4f27ed1a5$export$629b0a497aa65267, (v) => $b28cd5a4f27ed1a5$export$629b0a497aa65267 = v);
var $b28cd5a4f27ed1a5$export$629b0a497aa65267;
"use strict";
$b28cd5a4f27ed1a5$export$629b0a497aa65267 = $b28cd5a4f27ed1a5$var$isToday;


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $b28cd5a4f27ed1a5$var$isToday(date) {
    return (0, $d1275d6457f4d4aa$export$ea39ec197993aef0)(date, (0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date));
}


Object.keys($b28cd5a4f27ed1a5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b28cd5a4f27ed1a5$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b28cd5a4f27ed1a5$exports[key];
        }
    });
});
var $5a683f38b547f533$exports = {};

$parcel$export($5a683f38b547f533$exports, "isTomorrow", () => $5a683f38b547f533$export$d6365ba92f0647f1, (v) => $5a683f38b547f533$export$d6365ba92f0647f1 = v);
var $5a683f38b547f533$export$d6365ba92f0647f1;
"use strict";
$5a683f38b547f533$export$d6365ba92f0647f1 = $5a683f38b547f533$var$isTomorrow;



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $5a683f38b547f533$var$isTomorrow(date) {
    return (0, $d1275d6457f4d4aa$export$ea39ec197993aef0)(date, (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)((0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($5a683f38b547f533$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5a683f38b547f533$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5a683f38b547f533$exports[key];
        }
    });
});
var $6b27911adbb2c611$exports = {};

$parcel$export($6b27911adbb2c611$exports, "isTuesday", () => $6b27911adbb2c611$export$90d50b8f209f5ac3, (v) => $6b27911adbb2c611$export$90d50b8f209f5ac3 = v);
var $6b27911adbb2c611$export$90d50b8f209f5ac3;
"use strict";
$6b27911adbb2c611$export$90d50b8f209f5ac3 = $6b27911adbb2c611$var$isTuesday;

/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $6b27911adbb2c611$var$isTuesday(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay() === 2;
}


Object.keys($6b27911adbb2c611$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $6b27911adbb2c611$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $6b27911adbb2c611$exports[key];
        }
    });
});

Object.keys($8eac5c8197f2cd9a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8eac5c8197f2cd9a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8eac5c8197f2cd9a$exports[key];
        }
    });
});
var $067c7b9bda9d9f91$exports = {};

$parcel$export($067c7b9bda9d9f91$exports, "isWednesday", () => $067c7b9bda9d9f91$export$ec9de642cdd62944, (v) => $067c7b9bda9d9f91$export$ec9de642cdd62944 = v);
var $067c7b9bda9d9f91$export$ec9de642cdd62944;
"use strict";
$067c7b9bda9d9f91$export$ec9de642cdd62944 = $067c7b9bda9d9f91$var$isWednesday;

/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $067c7b9bda9d9f91$var$isWednesday(date) {
    return (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date).getDay() === 3;
}


Object.keys($067c7b9bda9d9f91$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $067c7b9bda9d9f91$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $067c7b9bda9d9f91$exports[key];
        }
    });
});

Object.keys($72883b968e5b403e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $72883b968e5b403e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $72883b968e5b403e$exports[key];
        }
    });
});
var $2bee6b56d7bbee0f$exports = {};

$parcel$export($2bee6b56d7bbee0f$exports, "isWithinInterval", () => $2bee6b56d7bbee0f$export$d7deef7a3738e19d, (v) => $2bee6b56d7bbee0f$export$d7deef7a3738e19d = v);
var $2bee6b56d7bbee0f$export$d7deef7a3738e19d;
"use strict";
$2bee6b56d7bbee0f$export$d7deef7a3738e19d = $2bee6b56d7bbee0f$var$isWithinInterval;

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $2bee6b56d7bbee0f$var$isWithinInterval(date, interval) {
    const time = +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const [startTime, endTime] = [
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.start),
        +(0, $ce0fc8830a11c560$export$e67a095c620b86fe)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}


Object.keys($2bee6b56d7bbee0f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $2bee6b56d7bbee0f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $2bee6b56d7bbee0f$exports[key];
        }
    });
});
var $e4a2686985f68623$exports = {};

$parcel$export($e4a2686985f68623$exports, "isYesterday", () => $e4a2686985f68623$export$221990270ebfe867, (v) => $e4a2686985f68623$export$221990270ebfe867 = v);
var $e4a2686985f68623$export$221990270ebfe867;
"use strict";
$e4a2686985f68623$export$221990270ebfe867 = $e4a2686985f68623$var$isYesterday;


var $bfb0065014f6fab2$exports = {};

$parcel$export($bfb0065014f6fab2$exports, "subDays", () => $bfb0065014f6fab2$export$70823084e2deb1ea, (v) => $bfb0065014f6fab2$export$70823084e2deb1ea = v);
var $bfb0065014f6fab2$export$70823084e2deb1ea;
"use strict";
$bfb0065014f6fab2$export$70823084e2deb1ea = $bfb0065014f6fab2$var$subDays;

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $bfb0065014f6fab2$var$subDays(date, amount) {
    return (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(date, -amount);
}


/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $e4a2686985f68623$var$isYesterday(date) {
    return (0, $d1275d6457f4d4aa$export$ea39ec197993aef0)(date, (0, $bfb0065014f6fab2$export$70823084e2deb1ea)((0, $d6257872e87ed1f0$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($e4a2686985f68623$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e4a2686985f68623$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e4a2686985f68623$exports[key];
        }
    });
});
var $57d87318a099f5f3$exports = {};

$parcel$export($57d87318a099f5f3$exports, "lastDayOfDecade", () => $57d87318a099f5f3$export$2aaf6241f57dd605, (v) => $57d87318a099f5f3$export$2aaf6241f57dd605 = v);
var $57d87318a099f5f3$export$2aaf6241f57dd605;
"use strict";
$57d87318a099f5f3$export$2aaf6241f57dd605 = $57d87318a099f5f3$var$lastDayOfDecade;

/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $57d87318a099f5f3$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($57d87318a099f5f3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $57d87318a099f5f3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $57d87318a099f5f3$exports[key];
        }
    });
});
var $a2726bc333093f86$exports = {};

$parcel$export($a2726bc333093f86$exports, "lastDayOfISOWeek", () => $a2726bc333093f86$export$b08a8fc26ae6d94b, (v) => $a2726bc333093f86$export$b08a8fc26ae6d94b = v);
var $a2726bc333093f86$export$b08a8fc26ae6d94b;
"use strict";
$a2726bc333093f86$export$b08a8fc26ae6d94b = $a2726bc333093f86$var$lastDayOfISOWeek;
var $90a68508572b7c6e$exports = {};

$parcel$export($90a68508572b7c6e$exports, "lastDayOfWeek", () => $90a68508572b7c6e$export$b73502c35a293b0a, (v) => $90a68508572b7c6e$export$b73502c35a293b0a = v);
var $90a68508572b7c6e$export$b73502c35a293b0a;
"use strict";
$90a68508572b7c6e$export$b73502c35a293b0a = $90a68508572b7c6e$var$lastDayOfWeek;


/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $90a68508572b7c6e$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $a2726bc333093f86$var$lastDayOfISOWeek(date) {
    return (0, $90a68508572b7c6e$export$b73502c35a293b0a)(date, {
        weekStartsOn: 1
    });
}


Object.keys($a2726bc333093f86$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a2726bc333093f86$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a2726bc333093f86$exports[key];
        }
    });
});
var $1d336924b4d75eb3$exports = {};

$parcel$export($1d336924b4d75eb3$exports, "lastDayOfISOWeekYear", () => $1d336924b4d75eb3$export$1810bada8cd02ee1, (v) => $1d336924b4d75eb3$export$1810bada8cd02ee1 = v);
var $1d336924b4d75eb3$export$1810bada8cd02ee1;
"use strict";
$1d336924b4d75eb3$export$1810bada8cd02ee1 = $1d336924b4d75eb3$var$lastDayOfISOWeekYear;



/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $1d336924b4d75eb3$var$lastDayOfISOWeekYear(date) {
    const year = (0, $14ce8a7023d6978a$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $e35c31db2e1e85b1$export$6173213f95a4431e)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}


Object.keys($1d336924b4d75eb3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $1d336924b4d75eb3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $1d336924b4d75eb3$exports[key];
        }
    });
});

Object.keys($47662c5f67705cf1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $47662c5f67705cf1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $47662c5f67705cf1$exports[key];
        }
    });
});
var $e277deb9373d300e$exports = {};

$parcel$export($e277deb9373d300e$exports, "lastDayOfQuarter", () => $e277deb9373d300e$export$8693c04228304c7, (v) => $e277deb9373d300e$export$8693c04228304c7 = v);
var $e277deb9373d300e$export$8693c04228304c7;
"use strict";
$e277deb9373d300e$export$8693c04228304c7 = $e277deb9373d300e$var$lastDayOfQuarter;

/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $e277deb9373d300e$var$lastDayOfQuarter(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($e277deb9373d300e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e277deb9373d300e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e277deb9373d300e$exports[key];
        }
    });
});

Object.keys($90a68508572b7c6e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $90a68508572b7c6e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $90a68508572b7c6e$exports[key];
        }
    });
});
var $7eaa244896af6cc3$exports = {};

$parcel$export($7eaa244896af6cc3$exports, "lastDayOfYear", () => $7eaa244896af6cc3$export$323f7bc07b828bed, (v) => $7eaa244896af6cc3$export$323f7bc07b828bed = v);
var $7eaa244896af6cc3$export$323f7bc07b828bed;
"use strict";
$7eaa244896af6cc3$export$323f7bc07b828bed = $7eaa244896af6cc3$var$lastDayOfYear;

/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $7eaa244896af6cc3$var$lastDayOfYear(date) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($7eaa244896af6cc3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $7eaa244896af6cc3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $7eaa244896af6cc3$exports[key];
        }
    });
});
var $54cf8f424c98c529$exports = {};
"use strict";
$54cf8f424c98c529$exports.lightFormat = $54cf8f424c98c529$var$lightFormat;
Object.defineProperty($54cf8f424c98c529$exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $675501d264d94e61$export$b0d4b338e1516f13;
    }
});



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $54cf8f424c98c529$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $54cf8f424c98c529$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $54cf8f424c98c529$var$doubleQuoteRegExp = /''/g;
const $54cf8f424c98c529$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $54cf8f424c98c529$var$lightFormat(date, formatStr) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    if (!(0, $8eac5c8197f2cd9a$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($54cf8f424c98c529$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $54cf8f424c98c529$var$cleanEscapedString(substring);
        const formatter = $675501d264d94e61$export$b0d4b338e1516f13[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($54cf8f424c98c529$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $54cf8f424c98c529$var$cleanEscapedString(input) {
    const matches = input.match($54cf8f424c98c529$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($54cf8f424c98c529$var$doubleQuoteRegExp, "'");
}


Object.keys($54cf8f424c98c529$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $54cf8f424c98c529$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $54cf8f424c98c529$exports[key];
        }
    });
});

Object.keys($37aeb77df769e4eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $37aeb77df769e4eb$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $37aeb77df769e4eb$exports[key];
        }
    });
});
var $a83a41d4ffefc1e0$exports = {};

$parcel$export($a83a41d4ffefc1e0$exports, "milliseconds", () => $a83a41d4ffefc1e0$export$9a27fac83d67afd3, (v) => $a83a41d4ffefc1e0$export$9a27fac83d67afd3 = v);
var $a83a41d4ffefc1e0$export$9a27fac83d67afd3;
"use strict";
$a83a41d4ffefc1e0$export$9a27fac83d67afd3 = $a83a41d4ffefc1e0$var$milliseconds;

/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $a83a41d4ffefc1e0$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $68a6706ec8075339$export$3913210603d8e9ae;
    if (months) totalDays += months * ($68a6706ec8075339$export$3913210603d8e9ae / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}


Object.keys($a83a41d4ffefc1e0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a83a41d4ffefc1e0$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a83a41d4ffefc1e0$exports[key];
        }
    });
});
var $1f53142b90037b1b$exports = {};

$parcel$export($1f53142b90037b1b$exports, "millisecondsToHours", () => $1f53142b90037b1b$export$689a412b29fa9ed5, (v) => $1f53142b90037b1b$export$689a412b29fa9ed5 = v);
var $1f53142b90037b1b$export$689a412b29fa9ed5;
"use strict";
$1f53142b90037b1b$export$689a412b29fa9ed5 = $1f53142b90037b1b$var$millisecondsToHours;

/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $1f53142b90037b1b$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $68a6706ec8075339$export$7f72910d6dfd237a;
    return Math.trunc(hours);
}


Object.keys($1f53142b90037b1b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $1f53142b90037b1b$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $1f53142b90037b1b$exports[key];
        }
    });
});
var $515c4b68cbd55cc5$exports = {};

$parcel$export($515c4b68cbd55cc5$exports, "millisecondsToMinutes", () => $515c4b68cbd55cc5$export$a5f974e81e48cfc0, (v) => $515c4b68cbd55cc5$export$a5f974e81e48cfc0 = v);
var $515c4b68cbd55cc5$export$a5f974e81e48cfc0;
"use strict";
$515c4b68cbd55cc5$export$a5f974e81e48cfc0 = $515c4b68cbd55cc5$var$millisecondsToMinutes;

/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $515c4b68cbd55cc5$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $68a6706ec8075339$export$91246f0b9bd9beff;
    return Math.trunc(minutes);
}


Object.keys($515c4b68cbd55cc5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $515c4b68cbd55cc5$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $515c4b68cbd55cc5$exports[key];
        }
    });
});
var $5602fc507af94bfc$exports = {};

$parcel$export($5602fc507af94bfc$exports, "millisecondsToSeconds", () => $5602fc507af94bfc$export$f64c3bfbc58eec0f, (v) => $5602fc507af94bfc$export$f64c3bfbc58eec0f = v);
var $5602fc507af94bfc$export$f64c3bfbc58eec0f;
"use strict";
$5602fc507af94bfc$export$f64c3bfbc58eec0f = $5602fc507af94bfc$var$millisecondsToSeconds;

/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $5602fc507af94bfc$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $68a6706ec8075339$export$397c2d5776aa9055;
    return Math.trunc(seconds);
}


Object.keys($5602fc507af94bfc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5602fc507af94bfc$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5602fc507af94bfc$exports[key];
        }
    });
});

Object.keys($ba124f2aa3edf6f7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ba124f2aa3edf6f7$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ba124f2aa3edf6f7$exports[key];
        }
    });
});
var $fa3367b92c3487c4$exports = {};

$parcel$export($fa3367b92c3487c4$exports, "minutesToHours", () => $fa3367b92c3487c4$export$815164eb42530ae7, (v) => $fa3367b92c3487c4$export$815164eb42530ae7 = v);
var $fa3367b92c3487c4$export$815164eb42530ae7;
"use strict";
$fa3367b92c3487c4$export$815164eb42530ae7 = $fa3367b92c3487c4$var$minutesToHours;

/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $fa3367b92c3487c4$var$minutesToHours(minutes) {
    const hours = minutes / $68a6706ec8075339$export$f2f5ae5a8e2d8f9f;
    return Math.trunc(hours);
}


Object.keys($fa3367b92c3487c4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $fa3367b92c3487c4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $fa3367b92c3487c4$exports[key];
        }
    });
});
var $6eb9da06e352d0a5$exports = {};

$parcel$export($6eb9da06e352d0a5$exports, "minutesToMilliseconds", () => $6eb9da06e352d0a5$export$f6b9795ef9056e3d, (v) => $6eb9da06e352d0a5$export$f6b9795ef9056e3d = v);
var $6eb9da06e352d0a5$export$f6b9795ef9056e3d;
"use strict";
$6eb9da06e352d0a5$export$f6b9795ef9056e3d = $6eb9da06e352d0a5$var$minutesToMilliseconds;

/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $6eb9da06e352d0a5$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $68a6706ec8075339$export$91246f0b9bd9beff);
}


Object.keys($6eb9da06e352d0a5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $6eb9da06e352d0a5$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $6eb9da06e352d0a5$exports[key];
        }
    });
});
var $f259154f7eca7fe2$exports = {};

$parcel$export($f259154f7eca7fe2$exports, "minutesToSeconds", () => $f259154f7eca7fe2$export$81ded4628c655103, (v) => $f259154f7eca7fe2$export$81ded4628c655103 = v);
var $f259154f7eca7fe2$export$81ded4628c655103;
"use strict";
$f259154f7eca7fe2$export$81ded4628c655103 = $f259154f7eca7fe2$var$minutesToSeconds;

/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $f259154f7eca7fe2$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $68a6706ec8075339$export$a77c1a7ebebe2a5a);
}


Object.keys($f259154f7eca7fe2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f259154f7eca7fe2$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f259154f7eca7fe2$exports[key];
        }
    });
});
var $f6d5f8470515c48a$exports = {};

$parcel$export($f6d5f8470515c48a$exports, "monthsToQuarters", () => $f6d5f8470515c48a$export$1932fa2a2068c849, (v) => $f6d5f8470515c48a$export$1932fa2a2068c849 = v);
var $f6d5f8470515c48a$export$1932fa2a2068c849;
"use strict";
$f6d5f8470515c48a$export$1932fa2a2068c849 = $f6d5f8470515c48a$var$monthsToQuarters;

/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $f6d5f8470515c48a$var$monthsToQuarters(months) {
    const quarters = months / $68a6706ec8075339$export$3c58128db900d44e;
    return Math.trunc(quarters);
}


Object.keys($f6d5f8470515c48a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f6d5f8470515c48a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f6d5f8470515c48a$exports[key];
        }
    });
});
var $2ce7da4cab7dd52c$exports = {};

$parcel$export($2ce7da4cab7dd52c$exports, "monthsToYears", () => $2ce7da4cab7dd52c$export$7489026ed27fc925, (v) => $2ce7da4cab7dd52c$export$7489026ed27fc925 = v);
var $2ce7da4cab7dd52c$export$7489026ed27fc925;
"use strict";
$2ce7da4cab7dd52c$export$7489026ed27fc925 = $2ce7da4cab7dd52c$var$monthsToYears;

/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $2ce7da4cab7dd52c$var$monthsToYears(months) {
    const years = months / $68a6706ec8075339$export$80d7e435f744f319;
    return Math.trunc(years);
}


Object.keys($2ce7da4cab7dd52c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $2ce7da4cab7dd52c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $2ce7da4cab7dd52c$exports[key];
        }
    });
});
var $9472848a4bf56823$exports = {};

$parcel$export($9472848a4bf56823$exports, "nextDay", () => $9472848a4bf56823$export$992728922317ffc8, (v) => $9472848a4bf56823$export$992728922317ffc8 = v);
var $9472848a4bf56823$export$992728922317ffc8;
"use strict";
$9472848a4bf56823$export$992728922317ffc8 = $9472848a4bf56823$var$nextDay;


/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $9472848a4bf56823$var$nextDay(date, day) {
    let delta = day - (0, $9c47022cd70b02b7$export$1b64bc9c5306ed54)(date);
    if (delta <= 0) delta += 7;
    return (0, $c520f1511b64acf6$export$dd412b56f1e4d8aa)(date, delta);
}


Object.keys($9472848a4bf56823$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $9472848a4bf56823$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $9472848a4bf56823$exports[key];
        }
    });
});
var $16d8f6b6fd5e821a$exports = {};

$parcel$export($16d8f6b6fd5e821a$exports, "nextFriday", () => $16d8f6b6fd5e821a$export$21d76934fce76327, (v) => $16d8f6b6fd5e821a$export$21d76934fce76327 = v);
var $16d8f6b6fd5e821a$export$21d76934fce76327;
"use strict";
$16d8f6b6fd5e821a$export$21d76934fce76327 = $16d8f6b6fd5e821a$var$nextFriday;

/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $16d8f6b6fd5e821a$var$nextFriday(date) {
    return (0, $9472848a4bf56823$export$992728922317ffc8)(date, 5);
}


Object.keys($16d8f6b6fd5e821a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $16d8f6b6fd5e821a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $16d8f6b6fd5e821a$exports[key];
        }
    });
});
var $9adbda2d1912ffe3$exports = {};

$parcel$export($9adbda2d1912ffe3$exports, "nextMonday", () => $9adbda2d1912ffe3$export$a20373bb0df6efdd, (v) => $9adbda2d1912ffe3$export$a20373bb0df6efdd = v);
var $9adbda2d1912ffe3$export$a20373bb0df6efdd;
"use strict";
$9adbda2d1912ffe3$export$a20373bb0df6efdd = $9adbda2d1912ffe3$var$nextMonday;

/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $9adbda2d1912ffe3$var$nextMonday(date) {
    return (0, $9472848a4bf56823$export$992728922317ffc8)(date, 1);
}


Object.keys($9adbda2d1912ffe3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $9adbda2d1912ffe3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $9adbda2d1912ffe3$exports[key];
        }
    });
});
var $919ca8802dc999ad$exports = {};

$parcel$export($919ca8802dc999ad$exports, "nextSaturday", () => $919ca8802dc999ad$export$c52f069246f7b032, (v) => $919ca8802dc999ad$export$c52f069246f7b032 = v);
var $919ca8802dc999ad$export$c52f069246f7b032;
"use strict";
$919ca8802dc999ad$export$c52f069246f7b032 = $919ca8802dc999ad$var$nextSaturday;

/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $919ca8802dc999ad$var$nextSaturday(date) {
    return (0, $9472848a4bf56823$export$992728922317ffc8)(date, 6);
}


Object.keys($919ca8802dc999ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $919ca8802dc999ad$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $919ca8802dc999ad$exports[key];
        }
    });
});
var $c5b6aa556c98f000$exports = {};

$parcel$export($c5b6aa556c98f000$exports, "nextSunday", () => $c5b6aa556c98f000$export$a30adaa3ef47f854, (v) => $c5b6aa556c98f000$export$a30adaa3ef47f854 = v);
var $c5b6aa556c98f000$export$a30adaa3ef47f854;
"use strict";
$c5b6aa556c98f000$export$a30adaa3ef47f854 = $c5b6aa556c98f000$var$nextSunday;

/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $c5b6aa556c98f000$var$nextSunday(date) {
    return (0, $9472848a4bf56823$export$992728922317ffc8)(date, 0);
}


Object.keys($c5b6aa556c98f000$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c5b6aa556c98f000$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c5b6aa556c98f000$exports[key];
        }
    });
});
var $b3921b788558507a$exports = {};

$parcel$export($b3921b788558507a$exports, "nextThursday", () => $b3921b788558507a$export$36d9a8523a98d5a4, (v) => $b3921b788558507a$export$36d9a8523a98d5a4 = v);
var $b3921b788558507a$export$36d9a8523a98d5a4;
"use strict";
$b3921b788558507a$export$36d9a8523a98d5a4 = $b3921b788558507a$var$nextThursday;

/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $b3921b788558507a$var$nextThursday(date) {
    return (0, $9472848a4bf56823$export$992728922317ffc8)(date, 4);
}


Object.keys($b3921b788558507a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b3921b788558507a$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b3921b788558507a$exports[key];
        }
    });
});
var $ea60e09f3ccad2c6$exports = {};

$parcel$export($ea60e09f3ccad2c6$exports, "nextTuesday", () => $ea60e09f3ccad2c6$export$391d63ff7dc2f668, (v) => $ea60e09f3ccad2c6$export$391d63ff7dc2f668 = v);
var $ea60e09f3ccad2c6$export$391d63ff7dc2f668;
"use strict";
$ea60e09f3ccad2c6$export$391d63ff7dc2f668 = $ea60e09f3ccad2c6$var$nextTuesday;

/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $ea60e09f3ccad2c6$var$nextTuesday(date) {
    return (0, $9472848a4bf56823$export$992728922317ffc8)(date, 2);
}


Object.keys($ea60e09f3ccad2c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ea60e09f3ccad2c6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ea60e09f3ccad2c6$exports[key];
        }
    });
});
var $b5d0af701547dd9f$exports = {};

$parcel$export($b5d0af701547dd9f$exports, "nextWednesday", () => $b5d0af701547dd9f$export$7a895c1ff204304e, (v) => $b5d0af701547dd9f$export$7a895c1ff204304e = v);
var $b5d0af701547dd9f$export$7a895c1ff204304e;
"use strict";
$b5d0af701547dd9f$export$7a895c1ff204304e = $b5d0af701547dd9f$var$nextWednesday;

/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $b5d0af701547dd9f$var$nextWednesday(date) {
    return (0, $9472848a4bf56823$export$992728922317ffc8)(date, 3);
}


Object.keys($b5d0af701547dd9f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b5d0af701547dd9f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b5d0af701547dd9f$exports[key];
        }
    });
});

Object.keys($41113806dd07b1ef$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $41113806dd07b1ef$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $41113806dd07b1ef$exports[key];
        }
    });
});
var $ab0b7f05e0af6bdc$exports = {};

$parcel$export($ab0b7f05e0af6bdc$exports, "parseISO", () => $ab0b7f05e0af6bdc$export$4393d2ccbbedb219, (v) => $ab0b7f05e0af6bdc$export$4393d2ccbbedb219 = v);
var $ab0b7f05e0af6bdc$export$4393d2ccbbedb219;
"use strict";
$ab0b7f05e0af6bdc$export$4393d2ccbbedb219 = $ab0b7f05e0af6bdc$var$parseISO;

/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $ab0b7f05e0af6bdc$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $ab0b7f05e0af6bdc$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $ab0b7f05e0af6bdc$var$parseYear(dateStrings.date, additionalDigits);
        date = $ab0b7f05e0af6bdc$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $ab0b7f05e0af6bdc$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $ab0b7f05e0af6bdc$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $ab0b7f05e0af6bdc$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $ab0b7f05e0af6bdc$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $ab0b7f05e0af6bdc$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $ab0b7f05e0af6bdc$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $ab0b7f05e0af6bdc$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($ab0b7f05e0af6bdc$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($ab0b7f05e0af6bdc$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($ab0b7f05e0af6bdc$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $ab0b7f05e0af6bdc$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $ab0b7f05e0af6bdc$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $ab0b7f05e0af6bdc$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($ab0b7f05e0af6bdc$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $ab0b7f05e0af6bdc$var$parseDateUnit(captures[1]);
    const month = $ab0b7f05e0af6bdc$var$parseDateUnit(captures[2]) - 1;
    const day = $ab0b7f05e0af6bdc$var$parseDateUnit(captures[3]);
    const week = $ab0b7f05e0af6bdc$var$parseDateUnit(captures[4]);
    const dayOfWeek = $ab0b7f05e0af6bdc$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$ab0b7f05e0af6bdc$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $ab0b7f05e0af6bdc$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$ab0b7f05e0af6bdc$var$validateDate(year, month, day) || !$ab0b7f05e0af6bdc$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $ab0b7f05e0af6bdc$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $ab0b7f05e0af6bdc$var$parseTime(timeString) {
    const captures = timeString.match($ab0b7f05e0af6bdc$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $ab0b7f05e0af6bdc$var$parseTimeUnit(captures[1]);
    const minutes = $ab0b7f05e0af6bdc$var$parseTimeUnit(captures[2]);
    const seconds = $ab0b7f05e0af6bdc$var$parseTimeUnit(captures[3]);
    if (!$ab0b7f05e0af6bdc$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $68a6706ec8075339$export$7f72910d6dfd237a + minutes * $68a6706ec8075339$export$91246f0b9bd9beff + seconds * 1000;
}
function $ab0b7f05e0af6bdc$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $ab0b7f05e0af6bdc$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($ab0b7f05e0af6bdc$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$ab0b7f05e0af6bdc$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $68a6706ec8075339$export$7f72910d6dfd237a + minutes * $68a6706ec8075339$export$91246f0b9bd9beff);
}
function $ab0b7f05e0af6bdc$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $ab0b7f05e0af6bdc$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $ab0b7f05e0af6bdc$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $ab0b7f05e0af6bdc$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($ab0b7f05e0af6bdc$var$daysInMonths[month] || ($ab0b7f05e0af6bdc$var$isLeapYearIndex(year) ? 29 : 28));
}
function $ab0b7f05e0af6bdc$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($ab0b7f05e0af6bdc$var$isLeapYearIndex(year) ? 366 : 365);
}
function $ab0b7f05e0af6bdc$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $ab0b7f05e0af6bdc$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $ab0b7f05e0af6bdc$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


Object.keys($ab0b7f05e0af6bdc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ab0b7f05e0af6bdc$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ab0b7f05e0af6bdc$exports[key];
        }
    });
});
var $8ba1fd9ceee4d6a6$exports = {};

$parcel$export($8ba1fd9ceee4d6a6$exports, "parseJSON", () => $8ba1fd9ceee4d6a6$export$27924e57e9afff7f, (v) => $8ba1fd9ceee4d6a6$export$27924e57e9afff7f = v);
var $8ba1fd9ceee4d6a6$export$27924e57e9afff7f;
"use strict";
$8ba1fd9ceee4d6a6$export$27924e57e9afff7f = $8ba1fd9ceee4d6a6$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $8ba1fd9ceee4d6a6$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}


Object.keys($8ba1fd9ceee4d6a6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8ba1fd9ceee4d6a6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8ba1fd9ceee4d6a6$exports[key];
        }
    });
});
var $169f50632382ceb8$exports = {};

$parcel$export($169f50632382ceb8$exports, "previousDay", () => $169f50632382ceb8$export$4caccb62df4eacc0, (v) => $169f50632382ceb8$export$4caccb62df4eacc0 = v);
var $169f50632382ceb8$export$4caccb62df4eacc0;
"use strict";
$169f50632382ceb8$export$4caccb62df4eacc0 = $169f50632382ceb8$var$previousDay;


/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $169f50632382ceb8$var$previousDay(date, day) {
    let delta = (0, $9c47022cd70b02b7$export$1b64bc9c5306ed54)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $bfb0065014f6fab2$export$70823084e2deb1ea)(date, delta);
}


Object.keys($169f50632382ceb8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $169f50632382ceb8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $169f50632382ceb8$exports[key];
        }
    });
});
var $e931326210b6c5ad$exports = {};

$parcel$export($e931326210b6c5ad$exports, "previousFriday", () => $e931326210b6c5ad$export$32d52646c338c11d, (v) => $e931326210b6c5ad$export$32d52646c338c11d = v);
var $e931326210b6c5ad$export$32d52646c338c11d;
"use strict";
$e931326210b6c5ad$export$32d52646c338c11d = $e931326210b6c5ad$var$previousFriday;

/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $e931326210b6c5ad$var$previousFriday(date) {
    return (0, $169f50632382ceb8$export$4caccb62df4eacc0)(date, 5);
}


Object.keys($e931326210b6c5ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e931326210b6c5ad$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e931326210b6c5ad$exports[key];
        }
    });
});
var $a531522c20fd2bc5$exports = {};

$parcel$export($a531522c20fd2bc5$exports, "previousMonday", () => $a531522c20fd2bc5$export$398437ab6f45c582, (v) => $a531522c20fd2bc5$export$398437ab6f45c582 = v);
var $a531522c20fd2bc5$export$398437ab6f45c582;
"use strict";
$a531522c20fd2bc5$export$398437ab6f45c582 = $a531522c20fd2bc5$var$previousMonday;

/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $a531522c20fd2bc5$var$previousMonday(date) {
    return (0, $169f50632382ceb8$export$4caccb62df4eacc0)(date, 1);
}


Object.keys($a531522c20fd2bc5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a531522c20fd2bc5$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a531522c20fd2bc5$exports[key];
        }
    });
});
var $7218b3f859cd6301$exports = {};

$parcel$export($7218b3f859cd6301$exports, "previousSaturday", () => $7218b3f859cd6301$export$36767a7e6101ecb0, (v) => $7218b3f859cd6301$export$36767a7e6101ecb0 = v);
var $7218b3f859cd6301$export$36767a7e6101ecb0;
"use strict";
$7218b3f859cd6301$export$36767a7e6101ecb0 = $7218b3f859cd6301$var$previousSaturday;

/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $7218b3f859cd6301$var$previousSaturday(date) {
    return (0, $169f50632382ceb8$export$4caccb62df4eacc0)(date, 6);
}


Object.keys($7218b3f859cd6301$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $7218b3f859cd6301$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $7218b3f859cd6301$exports[key];
        }
    });
});
var $177912fe99b1768c$exports = {};

$parcel$export($177912fe99b1768c$exports, "previousSunday", () => $177912fe99b1768c$export$7d3d7d8fc5e81fd4, (v) => $177912fe99b1768c$export$7d3d7d8fc5e81fd4 = v);
var $177912fe99b1768c$export$7d3d7d8fc5e81fd4;
"use strict";
$177912fe99b1768c$export$7d3d7d8fc5e81fd4 = $177912fe99b1768c$var$previousSunday;

/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $177912fe99b1768c$var$previousSunday(date) {
    return (0, $169f50632382ceb8$export$4caccb62df4eacc0)(date, 0);
}


Object.keys($177912fe99b1768c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $177912fe99b1768c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $177912fe99b1768c$exports[key];
        }
    });
});
var $e6a78e5ec905d907$exports = {};

$parcel$export($e6a78e5ec905d907$exports, "previousThursday", () => $e6a78e5ec905d907$export$1975b5b1f6b0e34e, (v) => $e6a78e5ec905d907$export$1975b5b1f6b0e34e = v);
var $e6a78e5ec905d907$export$1975b5b1f6b0e34e;
"use strict";
$e6a78e5ec905d907$export$1975b5b1f6b0e34e = $e6a78e5ec905d907$var$previousThursday;

/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $e6a78e5ec905d907$var$previousThursday(date) {
    return (0, $169f50632382ceb8$export$4caccb62df4eacc0)(date, 4);
}


Object.keys($e6a78e5ec905d907$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e6a78e5ec905d907$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e6a78e5ec905d907$exports[key];
        }
    });
});
var $d059acdfdace1794$exports = {};

$parcel$export($d059acdfdace1794$exports, "previousTuesday", () => $d059acdfdace1794$export$a034a75f093bcfaf, (v) => $d059acdfdace1794$export$a034a75f093bcfaf = v);
var $d059acdfdace1794$export$a034a75f093bcfaf;
"use strict";
$d059acdfdace1794$export$a034a75f093bcfaf = $d059acdfdace1794$var$previousTuesday;

/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $d059acdfdace1794$var$previousTuesday(date) {
    return (0, $169f50632382ceb8$export$4caccb62df4eacc0)(date, 2);
}


Object.keys($d059acdfdace1794$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d059acdfdace1794$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d059acdfdace1794$exports[key];
        }
    });
});
var $34e4b83a4e89d66d$exports = {};

$parcel$export($34e4b83a4e89d66d$exports, "previousWednesday", () => $34e4b83a4e89d66d$export$26334f591e4ce672, (v) => $34e4b83a4e89d66d$export$26334f591e4ce672 = v);
var $34e4b83a4e89d66d$export$26334f591e4ce672;
"use strict";
$34e4b83a4e89d66d$export$26334f591e4ce672 = $34e4b83a4e89d66d$var$previousWednesday;

/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $34e4b83a4e89d66d$var$previousWednesday(date) {
    return (0, $169f50632382ceb8$export$4caccb62df4eacc0)(date, 3);
}


Object.keys($34e4b83a4e89d66d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $34e4b83a4e89d66d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $34e4b83a4e89d66d$exports[key];
        }
    });
});
var $de2b75fc77de5855$exports = {};

$parcel$export($de2b75fc77de5855$exports, "quartersToMonths", () => $de2b75fc77de5855$export$a29d19ce21d74c57, (v) => $de2b75fc77de5855$export$a29d19ce21d74c57 = v);
var $de2b75fc77de5855$export$a29d19ce21d74c57;
"use strict";
$de2b75fc77de5855$export$a29d19ce21d74c57 = $de2b75fc77de5855$var$quartersToMonths;

/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $de2b75fc77de5855$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $68a6706ec8075339$export$3c58128db900d44e);
}


Object.keys($de2b75fc77de5855$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $de2b75fc77de5855$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $de2b75fc77de5855$exports[key];
        }
    });
});
var $3f0eb9cd0e21dcfd$exports = {};

$parcel$export($3f0eb9cd0e21dcfd$exports, "quartersToYears", () => $3f0eb9cd0e21dcfd$export$c309fa8f184b4648, (v) => $3f0eb9cd0e21dcfd$export$c309fa8f184b4648 = v);
var $3f0eb9cd0e21dcfd$export$c309fa8f184b4648;
"use strict";
$3f0eb9cd0e21dcfd$export$c309fa8f184b4648 = $3f0eb9cd0e21dcfd$var$quartersToYears;

/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $3f0eb9cd0e21dcfd$var$quartersToYears(quarters) {
    const years = quarters / $68a6706ec8075339$export$4db7641526e3241f;
    return Math.trunc(years);
}


Object.keys($3f0eb9cd0e21dcfd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3f0eb9cd0e21dcfd$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3f0eb9cd0e21dcfd$exports[key];
        }
    });
});
var $0bafa870490659c4$exports = {};

$parcel$export($0bafa870490659c4$exports, "roundToNearestHours", () => $0bafa870490659c4$export$a8b87649ebc0e3c2, (v) => $0bafa870490659c4$export$a8b87649ebc0e3c2 = v);
var $0bafa870490659c4$export$a8b87649ebc0e3c2;
"use strict";
$0bafa870490659c4$export$a8b87649ebc0e3c2 = $0bafa870490659c4$var$roundToNearestHours;



/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $0bafa870490659c4$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $d122570071c49798$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $e299bd4246a08683$export$b6474a47258c1211)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $d122570071c49798$export$ead8a1812b171991)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}


Object.keys($0bafa870490659c4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0bafa870490659c4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0bafa870490659c4$exports[key];
        }
    });
});
var $dd85fe9008da28bb$exports = {};

$parcel$export($dd85fe9008da28bb$exports, "roundToNearestMinutes", () => $dd85fe9008da28bb$export$d97410bb8cd0dff, (v) => $dd85fe9008da28bb$export$d97410bb8cd0dff = v);
var $dd85fe9008da28bb$export$d97410bb8cd0dff;
"use strict";
$dd85fe9008da28bb$export$d97410bb8cd0dff = $dd85fe9008da28bb$var$roundToNearestMinutes;



/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $dd85fe9008da28bb$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $d122570071c49798$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $e299bd4246a08683$export$b6474a47258c1211)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $d122570071c49798$export$ead8a1812b171991)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}


Object.keys($dd85fe9008da28bb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $dd85fe9008da28bb$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $dd85fe9008da28bb$exports[key];
        }
    });
});
var $194e6a9e3d118b1d$exports = {};

$parcel$export($194e6a9e3d118b1d$exports, "secondsToHours", () => $194e6a9e3d118b1d$export$47d555ff5354096f, (v) => $194e6a9e3d118b1d$export$47d555ff5354096f = v);
var $194e6a9e3d118b1d$export$47d555ff5354096f;
"use strict";
$194e6a9e3d118b1d$export$47d555ff5354096f = $194e6a9e3d118b1d$var$secondsToHours;

/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $194e6a9e3d118b1d$var$secondsToHours(seconds) {
    const hours = seconds / $68a6706ec8075339$export$698aec755e92c695;
    return Math.trunc(hours);
}


Object.keys($194e6a9e3d118b1d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $194e6a9e3d118b1d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $194e6a9e3d118b1d$exports[key];
        }
    });
});
var $058087aad318c3ae$exports = {};

$parcel$export($058087aad318c3ae$exports, "secondsToMilliseconds", () => $058087aad318c3ae$export$fc3e7e8557f8c8c7, (v) => $058087aad318c3ae$export$fc3e7e8557f8c8c7 = v);
var $058087aad318c3ae$export$fc3e7e8557f8c8c7;
"use strict";
$058087aad318c3ae$export$fc3e7e8557f8c8c7 = $058087aad318c3ae$var$secondsToMilliseconds;

/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $058087aad318c3ae$var$secondsToMilliseconds(seconds) {
    return seconds * $68a6706ec8075339$export$397c2d5776aa9055;
}


Object.keys($058087aad318c3ae$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $058087aad318c3ae$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $058087aad318c3ae$exports[key];
        }
    });
});
var $921210a1336eb5ac$exports = {};

$parcel$export($921210a1336eb5ac$exports, "secondsToMinutes", () => $921210a1336eb5ac$export$ed657adb62398e99, (v) => $921210a1336eb5ac$export$ed657adb62398e99 = v);
var $921210a1336eb5ac$export$ed657adb62398e99;
"use strict";
$921210a1336eb5ac$export$ed657adb62398e99 = $921210a1336eb5ac$var$secondsToMinutes;

/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $921210a1336eb5ac$var$secondsToMinutes(seconds) {
    const minutes = seconds / $68a6706ec8075339$export$a77c1a7ebebe2a5a;
    return Math.trunc(minutes);
}


Object.keys($921210a1336eb5ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $921210a1336eb5ac$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $921210a1336eb5ac$exports[key];
        }
    });
});
var $73e65924970ce3f2$exports = {};

$parcel$export($73e65924970ce3f2$exports, "set", () => $73e65924970ce3f2$export$adaa4cf7ef1b65be, (v) => $73e65924970ce3f2$export$adaa4cf7ef1b65be = v);
var $73e65924970ce3f2$export$adaa4cf7ef1b65be;
"use strict";
$73e65924970ce3f2$export$adaa4cf7ef1b65be = $73e65924970ce3f2$var$set;

var $a5870fb8feff80b0$exports = {};

$parcel$export($a5870fb8feff80b0$exports, "setMonth", () => $a5870fb8feff80b0$export$63264690f8e36790, (v) => $a5870fb8feff80b0$export$63264690f8e36790 = v);
var $a5870fb8feff80b0$export$63264690f8e36790;
"use strict";
$a5870fb8feff80b0$export$63264690f8e36790 = $a5870fb8feff80b0$var$setMonth;



/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $a5870fb8feff80b0$var$setMonth(date, month) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $461903d15212cf89$export$f645ddd439eb259d)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}



/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $73e65924970ce3f2$var$set(date, values) {
    let _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $d122570071c49798$export$ead8a1812b171991)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $a5870fb8feff80b0$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}


Object.keys($73e65924970ce3f2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $73e65924970ce3f2$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $73e65924970ce3f2$exports[key];
        }
    });
});
var $670d14059d2a03a2$exports = {};

$parcel$export($670d14059d2a03a2$exports, "setDate", () => $670d14059d2a03a2$export$566174fa40823587, (v) => $670d14059d2a03a2$export$566174fa40823587 = v);
var $670d14059d2a03a2$export$566174fa40823587;
"use strict";
$670d14059d2a03a2$export$566174fa40823587 = $670d14059d2a03a2$var$setDate;

/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $670d14059d2a03a2$var$setDate(date, dayOfMonth) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setDate(dayOfMonth);
    return _date;
}


Object.keys($670d14059d2a03a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $670d14059d2a03a2$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $670d14059d2a03a2$exports[key];
        }
    });
});

Object.keys($0862d0c9051b14a8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0862d0c9051b14a8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0862d0c9051b14a8$exports[key];
        }
    });
});
var $c184b458b2822371$exports = {};

$parcel$export($c184b458b2822371$exports, "setDayOfYear", () => $c184b458b2822371$export$2af590ffc7e7d7c5, (v) => $c184b458b2822371$export$2af590ffc7e7d7c5 = v);
var $c184b458b2822371$export$2af590ffc7e7d7c5;
"use strict";
$c184b458b2822371$export$2af590ffc7e7d7c5 = $c184b458b2822371$var$setDayOfYear;

/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $c184b458b2822371$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}


Object.keys($c184b458b2822371$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c184b458b2822371$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c184b458b2822371$exports[key];
        }
    });
});
var $d90bf8bc2cce7143$exports = {};

$parcel$export($d90bf8bc2cce7143$exports, "setDefaultOptions", () => $d90bf8bc2cce7143$export$95365be1b0704abc, (v) => $d90bf8bc2cce7143$export$95365be1b0704abc = v);
var $d90bf8bc2cce7143$export$95365be1b0704abc;
"use strict";
$d90bf8bc2cce7143$export$95365be1b0704abc = $d90bf8bc2cce7143$var$setDefaultOptions;

/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $d90bf8bc2cce7143$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $56871551bba7dca4$export$95365be1b0704abc)(result);
}


Object.keys($d90bf8bc2cce7143$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d90bf8bc2cce7143$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d90bf8bc2cce7143$exports[key];
        }
    });
});
var $7ee93e7843358220$exports = {};

$parcel$export($7ee93e7843358220$exports, "setHours", () => $7ee93e7843358220$export$f86b797a4659b781, (v) => $7ee93e7843358220$export$f86b797a4659b781 = v);
var $7ee93e7843358220$export$f86b797a4659b781;
"use strict";
$7ee93e7843358220$export$f86b797a4659b781 = $7ee93e7843358220$var$setHours;

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $7ee93e7843358220$var$setHours(date, hours) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setHours(hours);
    return _date;
}


Object.keys($7ee93e7843358220$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $7ee93e7843358220$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $7ee93e7843358220$exports[key];
        }
    });
});

Object.keys($82929f56fcd14f2e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $82929f56fcd14f2e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $82929f56fcd14f2e$exports[key];
        }
    });
});

Object.keys($f8ba334b5e0396af$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f8ba334b5e0396af$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f8ba334b5e0396af$exports[key];
        }
    });
});

Object.keys($e2882b111a87d031$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e2882b111a87d031$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e2882b111a87d031$exports[key];
        }
    });
});
var $3574c399b1ac706e$exports = {};

$parcel$export($3574c399b1ac706e$exports, "setMilliseconds", () => $3574c399b1ac706e$export$de5664029b35e06d, (v) => $3574c399b1ac706e$export$de5664029b35e06d = v);
var $3574c399b1ac706e$export$de5664029b35e06d;
"use strict";
$3574c399b1ac706e$export$de5664029b35e06d = $3574c399b1ac706e$var$setMilliseconds;

/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $3574c399b1ac706e$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}


Object.keys($3574c399b1ac706e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3574c399b1ac706e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3574c399b1ac706e$exports[key];
        }
    });
});
var $bb10de68b6c6c16c$exports = {};

$parcel$export($bb10de68b6c6c16c$exports, "setMinutes", () => $bb10de68b6c6c16c$export$ad569bf1c79ea89d, (v) => $bb10de68b6c6c16c$export$ad569bf1c79ea89d = v);
var $bb10de68b6c6c16c$export$ad569bf1c79ea89d;
"use strict";
$bb10de68b6c6c16c$export$ad569bf1c79ea89d = $bb10de68b6c6c16c$var$setMinutes;

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $bb10de68b6c6c16c$var$setMinutes(date, minutes) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setMinutes(minutes);
    return _date;
}


Object.keys($bb10de68b6c6c16c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $bb10de68b6c6c16c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $bb10de68b6c6c16c$exports[key];
        }
    });
});

Object.keys($a5870fb8feff80b0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a5870fb8feff80b0$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a5870fb8feff80b0$exports[key];
        }
    });
});
var $fe6a56319a8ae60d$exports = {};

$parcel$export($fe6a56319a8ae60d$exports, "setQuarter", () => $fe6a56319a8ae60d$export$8924d1de7efe1755, (v) => $fe6a56319a8ae60d$export$8924d1de7efe1755 = v);
var $fe6a56319a8ae60d$export$8924d1de7efe1755;
"use strict";
$fe6a56319a8ae60d$export$8924d1de7efe1755 = $fe6a56319a8ae60d$var$setQuarter;


/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $fe6a56319a8ae60d$var$setQuarter(date, quarter) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $a5870fb8feff80b0$export$63264690f8e36790)(_date, _date.getMonth() + diff * 3);
}


Object.keys($fe6a56319a8ae60d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $fe6a56319a8ae60d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $fe6a56319a8ae60d$exports[key];
        }
    });
});
var $aed6aac1777cfdc3$exports = {};

$parcel$export($aed6aac1777cfdc3$exports, "setSeconds", () => $aed6aac1777cfdc3$export$aec44746644cbf43, (v) => $aed6aac1777cfdc3$export$aec44746644cbf43 = v);
var $aed6aac1777cfdc3$export$aec44746644cbf43;
"use strict";
$aed6aac1777cfdc3$export$aec44746644cbf43 = $aed6aac1777cfdc3$var$setSeconds;

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $aed6aac1777cfdc3$var$setSeconds(date, seconds) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    _date.setSeconds(seconds);
    return _date;
}


Object.keys($aed6aac1777cfdc3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $aed6aac1777cfdc3$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $aed6aac1777cfdc3$exports[key];
        }
    });
});

Object.keys($952110cb424f6568$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $952110cb424f6568$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $952110cb424f6568$exports[key];
        }
    });
});
var $5fb8d15e6d3f0165$exports = {};

$parcel$export($5fb8d15e6d3f0165$exports, "setWeekYear", () => $5fb8d15e6d3f0165$export$4340968d5939835e, (v) => $5fb8d15e6d3f0165$export$4340968d5939835e = v);
var $5fb8d15e6d3f0165$export$4340968d5939835e;
"use strict";
$5fb8d15e6d3f0165$export$4340968d5939835e = $5fb8d15e6d3f0165$var$setWeekYear;





/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $5fb8d15e6d3f0165$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $56871551bba7dca4$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const diff = (0, $db8722365c910ec5$export$4a02e9c37dab4871)(_date, (0, $1652bf99f6ce2785$export$bb7b45bb8e74da0f)(_date, options));
    const firstWeek = (0, $d122570071c49798$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $1652bf99f6ce2785$export$bb7b45bb8e74da0f)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


Object.keys($5fb8d15e6d3f0165$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5fb8d15e6d3f0165$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5fb8d15e6d3f0165$exports[key];
        }
    });
});
var $c1d99b1c3bb6475d$exports = {};

$parcel$export($c1d99b1c3bb6475d$exports, "setYear", () => $c1d99b1c3bb6475d$export$a8408b6c5639cab7, (v) => $c1d99b1c3bb6475d$export$a8408b6c5639cab7 = v);
var $c1d99b1c3bb6475d$export$a8408b6c5639cab7;
"use strict";
$c1d99b1c3bb6475d$export$a8408b6c5639cab7 = $c1d99b1c3bb6475d$var$setYear;


/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $c1d99b1c3bb6475d$var$setYear(date, year) {
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $d122570071c49798$export$ead8a1812b171991)(date, NaN);
    _date.setFullYear(year);
    return _date;
}


Object.keys($c1d99b1c3bb6475d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c1d99b1c3bb6475d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c1d99b1c3bb6475d$exports[key];
        }
    });
});

Object.keys($ffa24db69fa668a4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ffa24db69fa668a4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ffa24db69fa668a4$exports[key];
        }
    });
});
var $8e864c4f444e3188$exports = {};

$parcel$export($8e864c4f444e3188$exports, "startOfDecade", () => $8e864c4f444e3188$export$730492981c634308, (v) => $8e864c4f444e3188$export$730492981c634308 = v);
var $8e864c4f444e3188$export$730492981c634308;
"use strict";
$8e864c4f444e3188$export$730492981c634308 = $8e864c4f444e3188$var$startOfDecade;

/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $8e864c4f444e3188$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($8e864c4f444e3188$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8e864c4f444e3188$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8e864c4f444e3188$exports[key];
        }
    });
});

Object.keys($a77fac645c14050f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a77fac645c14050f$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a77fac645c14050f$exports[key];
        }
    });
});

Object.keys($e35c31db2e1e85b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $e35c31db2e1e85b1$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $e35c31db2e1e85b1$exports[key];
        }
    });
});

Object.keys($b2d2382037e56893$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $b2d2382037e56893$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $b2d2382037e56893$exports[key];
        }
    });
});

Object.keys($0d13cf15751d2b2c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $0d13cf15751d2b2c$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $0d13cf15751d2b2c$exports[key];
        }
    });
});

Object.keys($079952111a69a2fd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $079952111a69a2fd$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $079952111a69a2fd$exports[key];
        }
    });
});

Object.keys($a0d6a3a081a59e60$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a0d6a3a081a59e60$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a0d6a3a081a59e60$exports[key];
        }
    });
});

Object.keys($dca062d79702aef8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $dca062d79702aef8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $dca062d79702aef8$exports[key];
        }
    });
});
var $892e20036252d2a4$exports = {};

$parcel$export($892e20036252d2a4$exports, "startOfToday", () => $892e20036252d2a4$export$444d742fd5a45a57, (v) => $892e20036252d2a4$export$444d742fd5a45a57 = v);
var $892e20036252d2a4$export$444d742fd5a45a57;
"use strict";
$892e20036252d2a4$export$444d742fd5a45a57 = $892e20036252d2a4$var$startOfToday;

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $892e20036252d2a4$var$startOfToday() {
    return (0, $ffa24db69fa668a4$export$63fa379ae8a9ba2)(Date.now());
}


Object.keys($892e20036252d2a4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $892e20036252d2a4$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $892e20036252d2a4$exports[key];
        }
    });
});
var $38e4f2a72d12b676$exports = {};

$parcel$export($38e4f2a72d12b676$exports, "startOfTomorrow", () => $38e4f2a72d12b676$export$7e8566c79d5bee07, (v) => $38e4f2a72d12b676$export$7e8566c79d5bee07 = v);
var $38e4f2a72d12b676$export$7e8566c79d5bee07;
"use strict";
$38e4f2a72d12b676$export$7e8566c79d5bee07 = $38e4f2a72d12b676$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $38e4f2a72d12b676$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($38e4f2a72d12b676$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $38e4f2a72d12b676$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $38e4f2a72d12b676$exports[key];
        }
    });
});

Object.keys($4e0d9d2cb57da1ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $4e0d9d2cb57da1ac$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $4e0d9d2cb57da1ac$exports[key];
        }
    });
});

Object.keys($1652bf99f6ce2785$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $1652bf99f6ce2785$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $1652bf99f6ce2785$exports[key];
        }
    });
});

Object.keys($2a0c5e290b1b02ec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $2a0c5e290b1b02ec$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $2a0c5e290b1b02ec$exports[key];
        }
    });
});
var $f550c09338391bea$exports = {};

$parcel$export($f550c09338391bea$exports, "startOfYesterday", () => $f550c09338391bea$export$23a16f3c6d143ce9, (v) => $f550c09338391bea$export$23a16f3c6d143ce9 = v);
var $f550c09338391bea$export$23a16f3c6d143ce9;
"use strict";
$f550c09338391bea$export$23a16f3c6d143ce9 = $f550c09338391bea$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $f550c09338391bea$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($f550c09338391bea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $f550c09338391bea$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $f550c09338391bea$exports[key];
        }
    });
});
var $eaad8a3131635caa$exports = {};

$parcel$export($eaad8a3131635caa$exports, "sub", () => $eaad8a3131635caa$export$f93b5905241a7cca, (v) => $eaad8a3131635caa$export$f93b5905241a7cca = v);
var $eaad8a3131635caa$export$f93b5905241a7cca;
"use strict";
$eaad8a3131635caa$export$f93b5905241a7cca = $eaad8a3131635caa$var$sub;

var $c1053ba3f2721721$exports = {};

$parcel$export($c1053ba3f2721721$exports, "subMonths", () => $c1053ba3f2721721$export$73d1c15a21f9fae5, (v) => $c1053ba3f2721721$export$73d1c15a21f9fae5 = v);
var $c1053ba3f2721721$export$73d1c15a21f9fae5;
"use strict";
$c1053ba3f2721721$export$73d1c15a21f9fae5 = $c1053ba3f2721721$var$subMonths;

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $c1053ba3f2721721$var$subMonths(date, amount) {
    return (0, $7fad57ce385af81f$export$17c93e242b2d3a22)(date, -amount);
}



/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $eaad8a3131635caa$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $c1053ba3f2721721$export$73d1c15a21f9fae5)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $bfb0065014f6fab2$export$70823084e2deb1ea)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $d122570071c49798$export$ead8a1812b171991)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}


Object.keys($eaad8a3131635caa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $eaad8a3131635caa$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $eaad8a3131635caa$exports[key];
        }
    });
});
var $612d22069fbb88da$exports = {};

$parcel$export($612d22069fbb88da$exports, "subBusinessDays", () => $612d22069fbb88da$export$e5cc51ae28664a93, (v) => $612d22069fbb88da$export$e5cc51ae28664a93 = v);
var $612d22069fbb88da$export$e5cc51ae28664a93;
"use strict";
$612d22069fbb88da$export$e5cc51ae28664a93 = $612d22069fbb88da$var$subBusinessDays;

/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $612d22069fbb88da$var$subBusinessDays(date, amount) {
    return (0, $66d557e404af808a$export$f087b9ada3136ae9)(date, -amount);
}


Object.keys($612d22069fbb88da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $612d22069fbb88da$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $612d22069fbb88da$exports[key];
        }
    });
});

Object.keys($bfb0065014f6fab2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $bfb0065014f6fab2$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $bfb0065014f6fab2$exports[key];
        }
    });
});
var $c0ab4b3a03263299$exports = {};

$parcel$export($c0ab4b3a03263299$exports, "subHours", () => $c0ab4b3a03263299$export$5e9fa51cd5bb1e71, (v) => $c0ab4b3a03263299$export$5e9fa51cd5bb1e71 = v);
var $c0ab4b3a03263299$export$5e9fa51cd5bb1e71;
"use strict";
$c0ab4b3a03263299$export$5e9fa51cd5bb1e71 = $c0ab4b3a03263299$var$subHours;

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $c0ab4b3a03263299$var$subHours(date, amount) {
    return (0, $4e19a7d9910c20d1$export$4a4306ad4fa0e5e6)(date, -amount);
}


Object.keys($c0ab4b3a03263299$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c0ab4b3a03263299$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c0ab4b3a03263299$exports[key];
        }
    });
});

Object.keys($eba9dc4c3864f51d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $eba9dc4c3864f51d$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $eba9dc4c3864f51d$exports[key];
        }
    });
});
var $5150f50724abc77b$exports = {};

$parcel$export($5150f50724abc77b$exports, "subMilliseconds", () => $5150f50724abc77b$export$5abaf57ab8e91640, (v) => $5150f50724abc77b$export$5abaf57ab8e91640 = v);
var $5150f50724abc77b$export$5abaf57ab8e91640;
"use strict";
$5150f50724abc77b$export$5abaf57ab8e91640 = $5150f50724abc77b$var$subMilliseconds;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $5150f50724abc77b$var$subMilliseconds(date, amount) {
    return (0, $75a2a6b86d6d60b2$export$baf757aaf0c95c94)(date, -amount);
}


Object.keys($5150f50724abc77b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $5150f50724abc77b$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $5150f50724abc77b$exports[key];
        }
    });
});
var $3e4a1f1f7c8b2b17$exports = {};

$parcel$export($3e4a1f1f7c8b2b17$exports, "subMinutes", () => $3e4a1f1f7c8b2b17$export$e12a970efb73fce5, (v) => $3e4a1f1f7c8b2b17$export$e12a970efb73fce5 = v);
var $3e4a1f1f7c8b2b17$export$e12a970efb73fce5;
"use strict";
$3e4a1f1f7c8b2b17$export$e12a970efb73fce5 = $3e4a1f1f7c8b2b17$var$subMinutes;

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $3e4a1f1f7c8b2b17$var$subMinutes(date, amount) {
    return (0, $3ef862ba623316f3$export$2287e3d29250119e)(date, -amount);
}


Object.keys($3e4a1f1f7c8b2b17$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3e4a1f1f7c8b2b17$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3e4a1f1f7c8b2b17$exports[key];
        }
    });
});

Object.keys($c1053ba3f2721721$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $c1053ba3f2721721$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $c1053ba3f2721721$exports[key];
        }
    });
});
var $868bd8a0dc177bdd$exports = {};

$parcel$export($868bd8a0dc177bdd$exports, "subQuarters", () => $868bd8a0dc177bdd$export$a31bfeeeee80cce6, (v) => $868bd8a0dc177bdd$export$a31bfeeeee80cce6 = v);
var $868bd8a0dc177bdd$export$a31bfeeeee80cce6;
"use strict";
$868bd8a0dc177bdd$export$a31bfeeeee80cce6 = $868bd8a0dc177bdd$var$subQuarters;

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $868bd8a0dc177bdd$var$subQuarters(date, amount) {
    return (0, $fc5f3bd56b1e4b07$export$c252a41d0fbed2ce)(date, -amount);
}


Object.keys($868bd8a0dc177bdd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $868bd8a0dc177bdd$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $868bd8a0dc177bdd$exports[key];
        }
    });
});
var $975e43dff6f63b14$exports = {};

$parcel$export($975e43dff6f63b14$exports, "subSeconds", () => $975e43dff6f63b14$export$e95d8ad9981db689, (v) => $975e43dff6f63b14$export$e95d8ad9981db689 = v);
var $975e43dff6f63b14$export$e95d8ad9981db689;
"use strict";
$975e43dff6f63b14$export$e95d8ad9981db689 = $975e43dff6f63b14$var$subSeconds;

/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $975e43dff6f63b14$var$subSeconds(date, amount) {
    return (0, $a4a2380920bba7a6$export$3cb31b0df13be68)(date, -amount);
}


Object.keys($975e43dff6f63b14$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $975e43dff6f63b14$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $975e43dff6f63b14$exports[key];
        }
    });
});
var $ce5b067c9bdf9e19$exports = {};

$parcel$export($ce5b067c9bdf9e19$exports, "subWeeks", () => $ce5b067c9bdf9e19$export$b4d8ae6376193efb, (v) => $ce5b067c9bdf9e19$export$b4d8ae6376193efb = v);
var $ce5b067c9bdf9e19$export$b4d8ae6376193efb;
"use strict";
$ce5b067c9bdf9e19$export$b4d8ae6376193efb = $ce5b067c9bdf9e19$var$subWeeks;

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $ce5b067c9bdf9e19$var$subWeeks(date, amount) {
    return (0, $78f454683e97f088$export$ef501a2bb4f3ee6b)(date, -amount);
}


Object.keys($ce5b067c9bdf9e19$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ce5b067c9bdf9e19$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ce5b067c9bdf9e19$exports[key];
        }
    });
});
var $2d6505838f8047c8$exports = {};

$parcel$export($2d6505838f8047c8$exports, "subYears", () => $2d6505838f8047c8$export$14867687ff6c92e2, (v) => $2d6505838f8047c8$export$14867687ff6c92e2 = v);
var $2d6505838f8047c8$export$14867687ff6c92e2;
"use strict";
$2d6505838f8047c8$export$14867687ff6c92e2 = $2d6505838f8047c8$var$subYears;

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $2d6505838f8047c8$var$subYears(date, amount) {
    return (0, $3ee269da3665ce8c$export$3d83eec43f4ea476)(date, -amount);
}


Object.keys($2d6505838f8047c8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $2d6505838f8047c8$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $2d6505838f8047c8$exports[key];
        }
    });
});

Object.keys($ce0fc8830a11c560$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $ce0fc8830a11c560$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $ce0fc8830a11c560$exports[key];
        }
    });
});

Object.keys($8aeb01d247b025cb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $8aeb01d247b025cb$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $8aeb01d247b025cb$exports[key];
        }
    });
});
var $3f413aa0f29d8eb6$exports = {};

$parcel$export($3f413aa0f29d8eb6$exports, "weeksToDays", () => $3f413aa0f29d8eb6$export$b696b6eeb89501ad, (v) => $3f413aa0f29d8eb6$export$b696b6eeb89501ad = v);
var $3f413aa0f29d8eb6$export$b696b6eeb89501ad;
"use strict";
$3f413aa0f29d8eb6$export$b696b6eeb89501ad = $3f413aa0f29d8eb6$var$weeksToDays;

/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $3f413aa0f29d8eb6$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $68a6706ec8075339$export$dfd9b671c89acc8e);
}


Object.keys($3f413aa0f29d8eb6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $3f413aa0f29d8eb6$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $3f413aa0f29d8eb6$exports[key];
        }
    });
});
var $52a1224e4af9c62e$exports = {};

$parcel$export($52a1224e4af9c62e$exports, "yearsToDays", () => $52a1224e4af9c62e$export$862cb7b6e45c3b17, (v) => $52a1224e4af9c62e$export$862cb7b6e45c3b17 = v);
var $52a1224e4af9c62e$export$862cb7b6e45c3b17;
"use strict";
$52a1224e4af9c62e$export$862cb7b6e45c3b17 = $52a1224e4af9c62e$var$yearsToDays;

/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $52a1224e4af9c62e$var$yearsToDays(years) {
    return Math.trunc(years * $68a6706ec8075339$export$3913210603d8e9ae);
}


Object.keys($52a1224e4af9c62e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $52a1224e4af9c62e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $52a1224e4af9c62e$exports[key];
        }
    });
});
var $a304a19cadf5dcf2$exports = {};

$parcel$export($a304a19cadf5dcf2$exports, "yearsToMonths", () => $a304a19cadf5dcf2$export$894abb0747b9a00, (v) => $a304a19cadf5dcf2$export$894abb0747b9a00 = v);
var $a304a19cadf5dcf2$export$894abb0747b9a00;
"use strict";
$a304a19cadf5dcf2$export$894abb0747b9a00 = $a304a19cadf5dcf2$var$yearsToMonths;

/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $a304a19cadf5dcf2$var$yearsToMonths(years) {
    return Math.trunc(years * $68a6706ec8075339$export$80d7e435f744f319);
}


Object.keys($a304a19cadf5dcf2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $a304a19cadf5dcf2$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $a304a19cadf5dcf2$exports[key];
        }
    });
});
var $d16b86d59f25ef1e$exports = {};

$parcel$export($d16b86d59f25ef1e$exports, "yearsToQuarters", () => $d16b86d59f25ef1e$export$ab26576e5e7379d7, (v) => $d16b86d59f25ef1e$export$ab26576e5e7379d7 = v);
var $d16b86d59f25ef1e$export$ab26576e5e7379d7;
"use strict";
$d16b86d59f25ef1e$export$ab26576e5e7379d7 = $d16b86d59f25ef1e$var$yearsToQuarters;

/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $d16b86d59f25ef1e$var$yearsToQuarters(years) {
    return Math.trunc(years * $68a6706ec8075339$export$4db7641526e3241f);
}


Object.keys($d16b86d59f25ef1e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4a2650a25edc3aa6$exports && $4a2650a25edc3aa6$exports[key] === $d16b86d59f25ef1e$exports[key]) return;
    Object.defineProperty($4a2650a25edc3aa6$exports, key, {
        enumerable: true,
        get: function() {
            return $d16b86d59f25ef1e$exports[key];
        }
    });
});


var $2650d1a625c02db9$exports = {};
"use strict";
var $9ebf02fea82c7677$exports = {};

$parcel$export($9ebf02fea82c7677$exports, "af", () => $9ebf02fea82c7677$export$c9170ad7d4cd7e57, (v) => $9ebf02fea82c7677$export$c9170ad7d4cd7e57 = v);
var $9ebf02fea82c7677$export$c9170ad7d4cd7e57;
"use strict";
$9ebf02fea82c7677$export$c9170ad7d4cd7e57 = void 0;
var $d65340ec4134738b$export$2c14ff85d6318973;
"use strict";
$d65340ec4134738b$export$2c14ff85d6318973 = void 0;
const $d65340ec4134738b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: "minder as {{count}} sekondes"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekondes"
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: "minder as {{count}} minute"
    },
    xMinutes: {
        one: "'n minuut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} ure"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} ure"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dae"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weke"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weke"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maande"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maande"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer as 1 jaar",
        other: "meer as {{count}} jaar"
    },
    almostXYears: {
        one: "byna 1 jaar",
        other: "byna {{count}} jaar"
    }
};
const $d65340ec4134738b$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $d65340ec4134738b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oor " + result;
        else return result + " gelede";
    }
    return result;
};
$d65340ec4134738b$export$2c14ff85d6318973 = $d65340ec4134738b$var$formatDistance;


var $0a247dcfde56b32b$export$cbf60ecb96cbb82f;
"use strict";
$0a247dcfde56b32b$export$cbf60ecb96cbb82f = void 0;

const $0a247dcfde56b32b$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "yyyy/MM/dd"
};
const $0a247dcfde56b32b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $0a247dcfde56b32b$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $0a247dcfde56b32b$var$formatLong = $0a247dcfde56b32b$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0a247dcfde56b32b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0a247dcfde56b32b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0a247dcfde56b32b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $aee57d4bcbf720fb$export$8fbbfd65594f46a0;
"use strict";
$aee57d4bcbf720fb$export$8fbbfd65594f46a0 = void 0;
const $aee57d4bcbf720fb$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $aee57d4bcbf720fb$var$formatRelative = (token, _date, _baseDate, _options)=>$aee57d4bcbf720fb$var$formatRelativeLocale[token];
$aee57d4bcbf720fb$export$8fbbfd65594f46a0 = $aee57d4bcbf720fb$var$formatRelative;


var $9ab07541e5e98cdc$export$b3bd0bc58e36cd63;
"use strict";
$9ab07541e5e98cdc$export$b3bd0bc58e36cd63 = void 0;

const $9ab07541e5e98cdc$var$eraValues = {
    narrow: [
        "vC",
        "nC"
    ],
    abbreviated: [
        "vC",
        "nC"
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $9ab07541e5e98cdc$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ste kwartaal",
        "2de kwartaal",
        "3de kwartaal",
        "4de kwartaal"
    ]
};
const $9ab07541e5e98cdc$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januarie",
        "Februarie",
        "Maart",
        "April",
        "Mei",
        "Junie",
        "Julie",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
const $9ab07541e5e98cdc$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "W",
        "D",
        "V",
        "S"
    ],
    short: [
        "So",
        "Ma",
        "Di",
        "Wo",
        "Do",
        "Vr",
        "Sa"
    ],
    abbreviated: [
        "Son",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vry",
        "Sat"
    ],
    wide: [
        "Sondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrydag",
        "Saterdag"
    ]
};
const $9ab07541e5e98cdc$var$dayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    }
};
const $9ab07541e5e98cdc$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    }
};
const $9ab07541e5e98cdc$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + "ste";
        default:
            return number + "de";
    }
    return number + "ste";
};
const $9ab07541e5e98cdc$var$localize = $9ab07541e5e98cdc$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9ab07541e5e98cdc$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9ab07541e5e98cdc$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9ab07541e5e98cdc$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9ab07541e5e98cdc$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9ab07541e5e98cdc$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9ab07541e5e98cdc$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9ab07541e5e98cdc$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $307cce5adcd18bd0$export$4659b591c19bdf3d;
"use strict";
$307cce5adcd18bd0$export$4659b591c19bdf3d = void 0;


const $307cce5adcd18bd0$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
const $307cce5adcd18bd0$var$parseOrdinalNumberPattern = /\d+/i;
const $307cce5adcd18bd0$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
const $307cce5adcd18bd0$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $307cce5adcd18bd0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
const $307cce5adcd18bd0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $307cce5adcd18bd0$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
const $307cce5adcd18bd0$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
const $307cce5adcd18bd0$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
const $307cce5adcd18bd0$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
const $307cce5adcd18bd0$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
const $307cce5adcd18bd0$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
const $307cce5adcd18bd0$var$match = $307cce5adcd18bd0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $307cce5adcd18bd0$var$matchOrdinalNumberPattern,
        parsePattern: $307cce5adcd18bd0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $307cce5adcd18bd0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $307cce5adcd18bd0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $307cce5adcd18bd0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $307cce5adcd18bd0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $307cce5adcd18bd0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $307cce5adcd18bd0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $307cce5adcd18bd0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $307cce5adcd18bd0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $307cce5adcd18bd0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $307cce5adcd18bd0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw](https://github.com/marnusw)
 */ const $9ebf02fea82c7677$var$af = $9ebf02fea82c7677$export$c9170ad7d4cd7e57 = {
    code: "af",
    formatDistance: $d65340ec4134738b$export$2c14ff85d6318973,
    formatLong: $0a247dcfde56b32b$export$cbf60ecb96cbb82f,
    formatRelative: $aee57d4bcbf720fb$export$8fbbfd65594f46a0,
    localize: $9ab07541e5e98cdc$export$b3bd0bc58e36cd63,
    match: $307cce5adcd18bd0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($9ebf02fea82c7677$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $9ebf02fea82c7677$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $9ebf02fea82c7677$exports[key];
        }
    });
});
var $05baa5839b99e6db$exports = {};

$parcel$export($05baa5839b99e6db$exports, "ar", () => $05baa5839b99e6db$export$d24c54395ce0c509, (v) => $05baa5839b99e6db$export$d24c54395ce0c509 = v);
var $05baa5839b99e6db$export$d24c54395ce0c509;
"use strict";
$05baa5839b99e6db$export$d24c54395ce0c509 = void 0;
var $51017f9aaea41e2d$export$2c14ff85d6318973;
"use strict";
$51017f9aaea41e2d$export$2c14ff85d6318973 = void 0;
const $51017f9aaea41e2d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
const $51017f9aaea41e2d$var$formatDistance = (token, count, options)=>{
    const usageGroup = $51017f9aaea41e2d$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$51017f9aaea41e2d$export$2c14ff85d6318973 = $51017f9aaea41e2d$var$formatDistance;


var $30016ae510eb9dc6$export$cbf60ecb96cbb82f;
"use strict";
$30016ae510eb9dc6$export$cbf60ecb96cbb82f = void 0;

const $30016ae510eb9dc6$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $30016ae510eb9dc6$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $30016ae510eb9dc6$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $30016ae510eb9dc6$var$formatLong = $30016ae510eb9dc6$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $30016ae510eb9dc6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $30016ae510eb9dc6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $30016ae510eb9dc6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $b9f3c7805c635a46$export$8fbbfd65594f46a0;
"use strict";
$b9f3c7805c635a46$export$8fbbfd65594f46a0 = void 0;
const $b9f3c7805c635a46$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
const $b9f3c7805c635a46$var$formatRelative = (token)=>$b9f3c7805c635a46$var$formatRelativeLocale[token];
$b9f3c7805c635a46$export$8fbbfd65594f46a0 = $b9f3c7805c635a46$var$formatRelative;


var $525b83df672324a6$export$b3bd0bc58e36cd63;
"use strict";
$525b83df672324a6$export$b3bd0bc58e36cd63 = void 0;

const $525b83df672324a6$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $525b83df672324a6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $525b83df672324a6$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $525b83df672324a6$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $525b83df672324a6$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $525b83df672324a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $525b83df672324a6$var$ordinalNumber = (num)=>String(num);
const $525b83df672324a6$var$localize = $525b83df672324a6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $525b83df672324a6$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $525b83df672324a6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $525b83df672324a6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $525b83df672324a6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $525b83df672324a6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $525b83df672324a6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $525b83df672324a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $02d1778f455ba945$export$4659b591c19bdf3d;
"use strict";
$02d1778f455ba945$export$4659b591c19bdf3d = void 0;


const $02d1778f455ba945$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $02d1778f455ba945$var$parseOrdinalNumberPattern = /\d+/i;
const $02d1778f455ba945$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
const $02d1778f455ba945$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
const $02d1778f455ba945$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
const $02d1778f455ba945$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $02d1778f455ba945$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $02d1778f455ba945$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
const $02d1778f455ba945$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $02d1778f455ba945$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $02d1778f455ba945$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
const $02d1778f455ba945$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
const $02d1778f455ba945$var$match = $02d1778f455ba945$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $02d1778f455ba945$var$matchOrdinalNumberPattern,
        parsePattern: $02d1778f455ba945$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $02d1778f455ba945$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d1778f455ba945$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $02d1778f455ba945$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d1778f455ba945$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $02d1778f455ba945$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d1778f455ba945$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $02d1778f455ba945$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d1778f455ba945$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $02d1778f455ba945$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $02d1778f455ba945$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO](https://github.com/AbdallahAHO)
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */ const $05baa5839b99e6db$var$ar = $05baa5839b99e6db$export$d24c54395ce0c509 = {
    code: "ar",
    formatDistance: $51017f9aaea41e2d$export$2c14ff85d6318973,
    formatLong: $30016ae510eb9dc6$export$cbf60ecb96cbb82f,
    formatRelative: $b9f3c7805c635a46$export$8fbbfd65594f46a0,
    localize: $525b83df672324a6$export$b3bd0bc58e36cd63,
    match: $02d1778f455ba945$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($05baa5839b99e6db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $05baa5839b99e6db$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $05baa5839b99e6db$exports[key];
        }
    });
});
var $f23c61b20c3faeb4$exports = {};

$parcel$export($f23c61b20c3faeb4$exports, "arDZ", () => $f23c61b20c3faeb4$export$f30a46e7176f7a, (v) => $f23c61b20c3faeb4$export$f30a46e7176f7a = v);
var $f23c61b20c3faeb4$export$f30a46e7176f7a;
"use strict";
$f23c61b20c3faeb4$export$f30a46e7176f7a = void 0;
var $19eb50ebd66f0c26$export$2c14ff85d6318973;
"use strict";
$19eb50ebd66f0c26$export$2c14ff85d6318973 = void 0;
const $19eb50ebd66f0c26$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $19eb50ebd66f0c26$var$formatDistance = (token, count, options)=>{
    options = options || {};
    const usageGroup = $19eb50ebd66f0c26$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$19eb50ebd66f0c26$export$2c14ff85d6318973 = $19eb50ebd66f0c26$var$formatDistance;


var $3b298c93386ed192$export$cbf60ecb96cbb82f;
"use strict";
$3b298c93386ed192$export$cbf60ecb96cbb82f = void 0;

const $3b298c93386ed192$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $3b298c93386ed192$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $3b298c93386ed192$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3b298c93386ed192$var$formatLong = $3b298c93386ed192$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3b298c93386ed192$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3b298c93386ed192$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3b298c93386ed192$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $48a9d2cecf265740$export$8fbbfd65594f46a0;
"use strict";
$48a9d2cecf265740$export$8fbbfd65594f46a0 = void 0;
const $48a9d2cecf265740$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $48a9d2cecf265740$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $48a9d2cecf265740$var$formatRelativeLocale[token];
};
$48a9d2cecf265740$export$8fbbfd65594f46a0 = $48a9d2cecf265740$var$formatRelative;


var $9f84d63365d1b3ae$export$b3bd0bc58e36cd63;
"use strict";
$9f84d63365d1b3ae$export$b3bd0bc58e36cd63 = void 0;

const $9f84d63365d1b3ae$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $9f84d63365d1b3ae$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $9f84d63365d1b3ae$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $9f84d63365d1b3ae$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $9f84d63365d1b3ae$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $9f84d63365d1b3ae$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $9f84d63365d1b3ae$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $9f84d63365d1b3ae$var$localize = $9f84d63365d1b3ae$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9f84d63365d1b3ae$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9f84d63365d1b3ae$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9f84d63365d1b3ae$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9f84d63365d1b3ae$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9f84d63365d1b3ae$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9f84d63365d1b3ae$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9f84d63365d1b3ae$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $4c0a9d38ec8ede8a$export$4659b591c19bdf3d;
"use strict";
$4c0a9d38ec8ede8a$export$4659b591c19bdf3d = void 0;


const $4c0a9d38ec8ede8a$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $4c0a9d38ec8ede8a$var$parseOrdinalNumberPattern = /\d+/i;
const $4c0a9d38ec8ede8a$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $4c0a9d38ec8ede8a$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $4c0a9d38ec8ede8a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $4c0a9d38ec8ede8a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $4c0a9d38ec8ede8a$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
const $4c0a9d38ec8ede8a$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
const $4c0a9d38ec8ede8a$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $4c0a9d38ec8ede8a$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $4c0a9d38ec8ede8a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $4c0a9d38ec8ede8a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $4c0a9d38ec8ede8a$var$match = $4c0a9d38ec8ede8a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $4c0a9d38ec8ede8a$var$matchOrdinalNumberPattern,
        parsePattern: $4c0a9d38ec8ede8a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4c0a9d38ec8ede8a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4c0a9d38ec8ede8a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4c0a9d38ec8ede8a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4c0a9d38ec8ede8a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>Number(index) + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4c0a9d38ec8ede8a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4c0a9d38ec8ede8a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4c0a9d38ec8ede8a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4c0a9d38ec8ede8a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4c0a9d38ec8ede8a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4c0a9d38ec8ede8a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429](https://github.com/badre429)
 * @author Ahmed ElShahat [@elshahat](https://github.com/elshahat)
 */ const $f23c61b20c3faeb4$var$arDZ = $f23c61b20c3faeb4$export$f30a46e7176f7a = {
    code: "ar-DZ",
    formatDistance: $19eb50ebd66f0c26$export$2c14ff85d6318973,
    formatLong: $3b298c93386ed192$export$cbf60ecb96cbb82f,
    formatRelative: $48a9d2cecf265740$export$8fbbfd65594f46a0,
    localize: $9f84d63365d1b3ae$export$b3bd0bc58e36cd63,
    match: $4c0a9d38ec8ede8a$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($f23c61b20c3faeb4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $f23c61b20c3faeb4$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $f23c61b20c3faeb4$exports[key];
        }
    });
});
var $89be22d55ddc0497$exports = {};

$parcel$export($89be22d55ddc0497$exports, "arEG", () => $89be22d55ddc0497$export$121716977511c975, (v) => $89be22d55ddc0497$export$121716977511c975 = v);
var $89be22d55ddc0497$export$121716977511c975;
"use strict";
$89be22d55ddc0497$export$121716977511c975 = void 0;
var $96946377a4242f8f$export$2c14ff85d6318973;
"use strict";
$96946377a4242f8f$export$2c14ff85d6318973 = void 0;
const $96946377a4242f8f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
const $96946377a4242f8f$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $96946377a4242f8f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return `\u{641}\u{64A} \u{62E}\u{644}\u{627}\u{644} ${result}`;
        else return `\u{645}\u{646}\u{630} ${result}`;
    }
    return result;
};
$96946377a4242f8f$export$2c14ff85d6318973 = $96946377a4242f8f$var$formatDistance;


var $e15fa0a6c75a703a$export$cbf60ecb96cbb82f;
"use strict";
$e15fa0a6c75a703a$export$cbf60ecb96cbb82f = void 0;

const $e15fa0a6c75a703a$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "dd/MMM/y",
    short: "d/MM/y"
};
const $e15fa0a6c75a703a$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $e15fa0a6c75a703a$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e15fa0a6c75a703a$var$formatLong = $e15fa0a6c75a703a$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e15fa0a6c75a703a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e15fa0a6c75a703a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e15fa0a6c75a703a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $21cb3962e33951c7$export$8fbbfd65594f46a0;
"use strict";
$21cb3962e33951c7$export$8fbbfd65594f46a0 = void 0;
const $21cb3962e33951c7$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
const $21cb3962e33951c7$var$formatRelative = (token, _date, _baseDate, _options)=>$21cb3962e33951c7$var$formatRelativeLocale[token];
$21cb3962e33951c7$export$8fbbfd65594f46a0 = $21cb3962e33951c7$var$formatRelative;


var $4f384cd5a9dfc7b0$export$b3bd0bc58e36cd63;
"use strict";
$4f384cd5a9dfc7b0$export$b3bd0bc58e36cd63 = void 0;

const $4f384cd5a9dfc7b0$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $4f384cd5a9dfc7b0$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $4f384cd5a9dfc7b0$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $4f384cd5a9dfc7b0$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $4f384cd5a9dfc7b0$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $4f384cd5a9dfc7b0$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $4f384cd5a9dfc7b0$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $4f384cd5a9dfc7b0$var$localize = $4f384cd5a9dfc7b0$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $4f384cd5a9dfc7b0$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $4f384cd5a9dfc7b0$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $4f384cd5a9dfc7b0$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $4f384cd5a9dfc7b0$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $4f384cd5a9dfc7b0$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $4f384cd5a9dfc7b0$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4f384cd5a9dfc7b0$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $0bcc5dd1674d5992$export$4659b591c19bdf3d;
"use strict";
$0bcc5dd1674d5992$export$4659b591c19bdf3d = void 0;


const $0bcc5dd1674d5992$var$matchOrdinalNumberPattern = /^(\d+)/;
const $0bcc5dd1674d5992$var$parseOrdinalNumberPattern = /\d+/i;
const $0bcc5dd1674d5992$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
const $0bcc5dd1674d5992$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
const $0bcc5dd1674d5992$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
const $0bcc5dd1674d5992$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
const $0bcc5dd1674d5992$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $0bcc5dd1674d5992$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
const $0bcc5dd1674d5992$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
const $0bcc5dd1674d5992$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
const $0bcc5dd1674d5992$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
const $0bcc5dd1674d5992$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
const $0bcc5dd1674d5992$var$match = $0bcc5dd1674d5992$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $0bcc5dd1674d5992$var$matchOrdinalNumberPattern,
        parsePattern: $0bcc5dd1674d5992$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0bcc5dd1674d5992$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0bcc5dd1674d5992$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0bcc5dd1674d5992$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0bcc5dd1674d5992$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0bcc5dd1674d5992$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0bcc5dd1674d5992$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0bcc5dd1674d5992$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0bcc5dd1674d5992$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0bcc5dd1674d5992$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0bcc5dd1674d5992$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13](https://github.com/AbdAllahAbdElFattah13)
 */ const $89be22d55ddc0497$var$arEG = $89be22d55ddc0497$export$121716977511c975 = {
    code: "ar-EG",
    formatDistance: $96946377a4242f8f$export$2c14ff85d6318973,
    formatLong: $e15fa0a6c75a703a$export$cbf60ecb96cbb82f,
    formatRelative: $21cb3962e33951c7$export$8fbbfd65594f46a0,
    localize: $4f384cd5a9dfc7b0$export$b3bd0bc58e36cd63,
    match: $0bcc5dd1674d5992$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($89be22d55ddc0497$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $89be22d55ddc0497$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $89be22d55ddc0497$exports[key];
        }
    });
});
var $9c710ca4ffa1e59c$exports = {};

$parcel$export($9c710ca4ffa1e59c$exports, "arMA", () => $9c710ca4ffa1e59c$export$6cd16787de86607, (v) => $9c710ca4ffa1e59c$export$6cd16787de86607 = v);
var $9c710ca4ffa1e59c$export$6cd16787de86607;
"use strict";
$9c710ca4ffa1e59c$export$6cd16787de86607 = void 0;
var $e14890e80f3447cf$export$2c14ff85d6318973;
"use strict";
$e14890e80f3447cf$export$2c14ff85d6318973 = void 0;
const $e14890e80f3447cf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $e14890e80f3447cf$var$formatDistance = (token, count, options)=>{
    options = options || {};
    const usageGroup = $e14890e80f3447cf$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$e14890e80f3447cf$export$2c14ff85d6318973 = $e14890e80f3447cf$var$formatDistance;


var $e48411faee89f1e5$export$cbf60ecb96cbb82f;
"use strict";
$e48411faee89f1e5$export$cbf60ecb96cbb82f = void 0;

const $e48411faee89f1e5$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $e48411faee89f1e5$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $e48411faee89f1e5$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $e48411faee89f1e5$var$formatLong = $e48411faee89f1e5$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e48411faee89f1e5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e48411faee89f1e5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e48411faee89f1e5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $4a391c7bc8ead1f5$export$8fbbfd65594f46a0;
"use strict";
$4a391c7bc8ead1f5$export$8fbbfd65594f46a0 = void 0;
const $4a391c7bc8ead1f5$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $4a391c7bc8ead1f5$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $4a391c7bc8ead1f5$var$formatRelativeLocale[token];
};
$4a391c7bc8ead1f5$export$8fbbfd65594f46a0 = $4a391c7bc8ead1f5$var$formatRelative;


var $5055bcf288c7b4d4$export$b3bd0bc58e36cd63;
"use strict";
$5055bcf288c7b4d4$export$b3bd0bc58e36cd63 = void 0;

const $5055bcf288c7b4d4$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $5055bcf288c7b4d4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $5055bcf288c7b4d4$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
const $5055bcf288c7b4d4$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $5055bcf288c7b4d4$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $5055bcf288c7b4d4$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $5055bcf288c7b4d4$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $5055bcf288c7b4d4$var$localize = $5055bcf288c7b4d4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5055bcf288c7b4d4$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5055bcf288c7b4d4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5055bcf288c7b4d4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5055bcf288c7b4d4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5055bcf288c7b4d4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5055bcf288c7b4d4$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5055bcf288c7b4d4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $ab5ddc1129c57b99$export$4659b591c19bdf3d;
"use strict";
$ab5ddc1129c57b99$export$4659b591c19bdf3d = void 0;


const $ab5ddc1129c57b99$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $ab5ddc1129c57b99$var$parseOrdinalNumberPattern = /\d+/i;
const $ab5ddc1129c57b99$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $ab5ddc1129c57b99$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $ab5ddc1129c57b99$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $ab5ddc1129c57b99$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ab5ddc1129c57b99$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
const $ab5ddc1129c57b99$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
const $ab5ddc1129c57b99$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $ab5ddc1129c57b99$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $ab5ddc1129c57b99$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $ab5ddc1129c57b99$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $ab5ddc1129c57b99$var$match = $ab5ddc1129c57b99$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $ab5ddc1129c57b99$var$matchOrdinalNumberPattern,
        parsePattern: $ab5ddc1129c57b99$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ab5ddc1129c57b99$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ab5ddc1129c57b99$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ab5ddc1129c57b99$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ab5ddc1129c57b99$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>Number(index) + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ab5ddc1129c57b99$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ab5ddc1129c57b99$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ab5ddc1129c57b99$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ab5ddc1129c57b99$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ab5ddc1129c57b99$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ab5ddc1129c57b99$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf](https://github.com/rramiachraf)
 */ const $9c710ca4ffa1e59c$var$arMA = $9c710ca4ffa1e59c$export$6cd16787de86607 = {
    code: "ar-MA",
    formatDistance: $e14890e80f3447cf$export$2c14ff85d6318973,
    formatLong: $e48411faee89f1e5$export$cbf60ecb96cbb82f,
    formatRelative: $4a391c7bc8ead1f5$export$8fbbfd65594f46a0,
    localize: $5055bcf288c7b4d4$export$b3bd0bc58e36cd63,
    match: $ab5ddc1129c57b99$export$4659b591c19bdf3d,
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};


Object.keys($9c710ca4ffa1e59c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $9c710ca4ffa1e59c$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $9c710ca4ffa1e59c$exports[key];
        }
    });
});
var $7aca4ddc54042bdb$exports = {};

$parcel$export($7aca4ddc54042bdb$exports, "arSA", () => $7aca4ddc54042bdb$export$f6f6c9668e179f08, (v) => $7aca4ddc54042bdb$export$f6f6c9668e179f08 = v);
var $7aca4ddc54042bdb$export$f6f6c9668e179f08;
"use strict";
$7aca4ddc54042bdb$export$f6f6c9668e179f08 = void 0;
var $3fb9cf8c3eb3bbd8$export$2c14ff85d6318973;
"use strict";
$3fb9cf8c3eb3bbd8$export$2c14ff85d6318973 = void 0;
const $3fb9cf8c3eb3bbd8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
const $3fb9cf8c3eb3bbd8$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $3fb9cf8c3eb3bbd8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
$3fb9cf8c3eb3bbd8$export$2c14ff85d6318973 = $3fb9cf8c3eb3bbd8$var$formatDistance;


var $a9c8ab43c8314e5f$export$cbf60ecb96cbb82f;
"use strict";
$a9c8ab43c8314e5f$export$cbf60ecb96cbb82f = void 0;

const $a9c8ab43c8314e5f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $a9c8ab43c8314e5f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $a9c8ab43c8314e5f$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a9c8ab43c8314e5f$var$formatLong = $a9c8ab43c8314e5f$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a9c8ab43c8314e5f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a9c8ab43c8314e5f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a9c8ab43c8314e5f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $0d39a41b3fe0bd05$export$8fbbfd65594f46a0;
"use strict";
$0d39a41b3fe0bd05$export$8fbbfd65594f46a0 = void 0;
const $0d39a41b3fe0bd05$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
const $0d39a41b3fe0bd05$var$formatRelative = (token, _date, _baseDate, _options)=>$0d39a41b3fe0bd05$var$formatRelativeLocale[token];
$0d39a41b3fe0bd05$export$8fbbfd65594f46a0 = $0d39a41b3fe0bd05$var$formatRelative;


var $207625d9d4912c4a$export$b3bd0bc58e36cd63;
"use strict";
$207625d9d4912c4a$export$b3bd0bc58e36cd63 = void 0;

const $207625d9d4912c4a$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $207625d9d4912c4a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $207625d9d4912c4a$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $207625d9d4912c4a$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $207625d9d4912c4a$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
const $207625d9d4912c4a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
const $207625d9d4912c4a$var$ordinalNumber = (dirtyNumber)=>{
    return String(dirtyNumber);
};
const $207625d9d4912c4a$var$localize = $207625d9d4912c4a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $207625d9d4912c4a$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $207625d9d4912c4a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $207625d9d4912c4a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $207625d9d4912c4a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $207625d9d4912c4a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $207625d9d4912c4a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $207625d9d4912c4a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $aa45d7cde6629ded$export$4659b591c19bdf3d;
"use strict";
$aa45d7cde6629ded$export$4659b591c19bdf3d = void 0;


const $aa45d7cde6629ded$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $aa45d7cde6629ded$var$parseOrdinalNumberPattern = /\d+/i;
const $aa45d7cde6629ded$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
const $aa45d7cde6629ded$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $aa45d7cde6629ded$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
const $aa45d7cde6629ded$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $aa45d7cde6629ded$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
const $aa45d7cde6629ded$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
const $aa45d7cde6629ded$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $aa45d7cde6629ded$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $aa45d7cde6629ded$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $aa45d7cde6629ded$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $aa45d7cde6629ded$var$match = $aa45d7cde6629ded$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $aa45d7cde6629ded$var$matchOrdinalNumberPattern,
        parsePattern: $aa45d7cde6629ded$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $aa45d7cde6629ded$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aa45d7cde6629ded$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $aa45d7cde6629ded$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aa45d7cde6629ded$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $aa45d7cde6629ded$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aa45d7cde6629ded$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $aa45d7cde6629ded$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $aa45d7cde6629ded$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $aa45d7cde6629ded$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $aa45d7cde6629ded$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani](https://github.com/dalwadani)
 */ const $7aca4ddc54042bdb$var$arSA = $7aca4ddc54042bdb$export$f6f6c9668e179f08 = {
    code: "ar-SA",
    formatDistance: $3fb9cf8c3eb3bbd8$export$2c14ff85d6318973,
    formatLong: $a9c8ab43c8314e5f$export$cbf60ecb96cbb82f,
    formatRelative: $0d39a41b3fe0bd05$export$8fbbfd65594f46a0,
    localize: $207625d9d4912c4a$export$b3bd0bc58e36cd63,
    match: $aa45d7cde6629ded$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($7aca4ddc54042bdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $7aca4ddc54042bdb$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $7aca4ddc54042bdb$exports[key];
        }
    });
});
var $d9fdc8a70e4563d6$exports = {};

$parcel$export($d9fdc8a70e4563d6$exports, "arTN", () => $d9fdc8a70e4563d6$export$79b362f080eb24d6, (v) => $d9fdc8a70e4563d6$export$79b362f080eb24d6 = v);
var $d9fdc8a70e4563d6$export$79b362f080eb24d6;
"use strict";
$d9fdc8a70e4563d6$export$79b362f080eb24d6 = void 0;
var $24e66b86feaca456$export$2c14ff85d6318973;
"use strict";
$24e66b86feaca456$export$2c14ff85d6318973 = void 0;
const $24e66b86feaca456$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
const $24e66b86feaca456$var$formatDistance = (token, count, options)=>{
    const usageGroup = $24e66b86feaca456$var$formatDistanceLocale[token];
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
$24e66b86feaca456$export$2c14ff85d6318973 = $24e66b86feaca456$var$formatDistance;


var $6350f6e23efbee12$export$cbf60ecb96cbb82f;
"use strict";
$6350f6e23efbee12$export$cbf60ecb96cbb82f = void 0;

const $6350f6e23efbee12$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $6350f6e23efbee12$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6350f6e23efbee12$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6350f6e23efbee12$var$formatLong = $6350f6e23efbee12$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6350f6e23efbee12$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6350f6e23efbee12$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6350f6e23efbee12$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $67e72b7bd6e56905$export$8fbbfd65594f46a0;
"use strict";
$67e72b7bd6e56905$export$8fbbfd65594f46a0 = void 0;
const $67e72b7bd6e56905$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: "P"
};
const $67e72b7bd6e56905$var$formatRelative = (token)=>$67e72b7bd6e56905$var$formatRelativeLocale[token];
$67e72b7bd6e56905$export$8fbbfd65594f46a0 = $67e72b7bd6e56905$var$formatRelative;


var $d03cbe58e85e3e75$export$b3bd0bc58e36cd63;
"use strict";
$d03cbe58e85e3e75$export$b3bd0bc58e36cd63 = void 0;

const $d03cbe58e85e3e75$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
const $d03cbe58e85e3e75$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
const $d03cbe58e85e3e75$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
const $d03cbe58e85e3e75$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
const $d03cbe58e85e3e75$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $d03cbe58e85e3e75$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
const $d03cbe58e85e3e75$var$ordinalNumber = (num)=>String(num);
const $d03cbe58e85e3e75$var$localize = $d03cbe58e85e3e75$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d03cbe58e85e3e75$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d03cbe58e85e3e75$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d03cbe58e85e3e75$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d03cbe58e85e3e75$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d03cbe58e85e3e75$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d03cbe58e85e3e75$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d03cbe58e85e3e75$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $2fe6f38c19d289c8$export$4659b591c19bdf3d;
"use strict";
$2fe6f38c19d289c8$export$4659b591c19bdf3d = void 0;


const $2fe6f38c19d289c8$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $2fe6f38c19d289c8$var$parseOrdinalNumberPattern = /\d+/i;
const $2fe6f38c19d289c8$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
const $2fe6f38c19d289c8$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
const $2fe6f38c19d289c8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
const $2fe6f38c19d289c8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2fe6f38c19d289c8$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
const $2fe6f38c19d289c8$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
const $2fe6f38c19d289c8$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
const $2fe6f38c19d289c8$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
const $2fe6f38c19d289c8$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
const $2fe6f38c19d289c8$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
const $2fe6f38c19d289c8$var$match = $2fe6f38c19d289c8$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $2fe6f38c19d289c8$var$matchOrdinalNumberPattern,
        parsePattern: $2fe6f38c19d289c8$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2fe6f38c19d289c8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2fe6f38c19d289c8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2fe6f38c19d289c8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2fe6f38c19d289c8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2fe6f38c19d289c8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2fe6f38c19d289c8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2fe6f38c19d289c8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2fe6f38c19d289c8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2fe6f38c19d289c8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2fe6f38c19d289c8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */ const $d9fdc8a70e4563d6$var$arTN = $d9fdc8a70e4563d6$export$79b362f080eb24d6 = {
    code: "ar-TN",
    formatDistance: $24e66b86feaca456$export$2c14ff85d6318973,
    formatLong: $6350f6e23efbee12$export$cbf60ecb96cbb82f,
    formatRelative: $67e72b7bd6e56905$export$8fbbfd65594f46a0,
    localize: $d03cbe58e85e3e75$export$b3bd0bc58e36cd63,
    match: $2fe6f38c19d289c8$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($d9fdc8a70e4563d6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $d9fdc8a70e4563d6$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $d9fdc8a70e4563d6$exports[key];
        }
    });
});
var $3c663587825ac266$exports = {};

$parcel$export($3c663587825ac266$exports, "az", () => $3c663587825ac266$export$3d12bd131bb975d1, (v) => $3c663587825ac266$export$3d12bd131bb975d1 = v);
var $3c663587825ac266$export$3d12bd131bb975d1;
"use strict";
$3c663587825ac266$export$3d12bd131bb975d1 = void 0;
var $ffb8728b04043bf7$export$2c14ff85d6318973;
"use strict";
$ffb8728b04043bf7$export$2c14ff85d6318973 = void 0;
const $ffb8728b04043bf7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: "1 il",
        other: "{{count}} il"
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
const $ffb8728b04043bf7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ffb8728b04043bf7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
$ffb8728b04043bf7$export$2c14ff85d6318973 = $ffb8728b04043bf7$var$formatDistance;


var $8b05c6beac400618$export$cbf60ecb96cbb82f;
"use strict";
$8b05c6beac400618$export$cbf60ecb96cbb82f = void 0;

const $8b05c6beac400618$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: "dd.MM.yyyy"
};
const $8b05c6beac400618$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $8b05c6beac400618$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $8b05c6beac400618$var$formatLong = $8b05c6beac400618$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8b05c6beac400618$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8b05c6beac400618$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8b05c6beac400618$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $48748d28c92fa65e$export$8fbbfd65594f46a0;
"use strict";
$48748d28c92fa65e$export$8fbbfd65594f46a0 = void 0;
const $48748d28c92fa65e$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: "P"
};
const $48748d28c92fa65e$var$formatRelative = (token, _date, _baseDate, _options)=>$48748d28c92fa65e$var$formatRelativeLocale[token];
$48748d28c92fa65e$export$8fbbfd65594f46a0 = $48748d28c92fa65e$var$formatRelative;


var $ecd4f203c0e118c5$export$b3bd0bc58e36cd63;
"use strict";
$ecd4f203c0e118c5$export$b3bd0bc58e36cd63 = void 0;

const $ecd4f203c0e118c5$var$eraValues = {
    narrow: [
        "e.\u0259",
        "b.e"
    ],
    abbreviated: [
        "e.\u0259",
        "b.e"
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        "bizim era"
    ]
};
const $ecd4f203c0e118c5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ci kvartal",
        "2ci kvartal",
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
const $ecd4f203c0e118c5$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "\u0130",
        "\u0130",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avq",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avqust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr"
    ]
};
const $ecd4f203c0e118c5$var$dayValues = {
    narrow: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    short: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    abbreviated: [
        "Baz",
        "Baz.e",
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        "Bazar",
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
const $ecd4f203c0e118c5$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
const $ecd4f203c0e118c5$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
const $ecd4f203c0e118c5$var$suffixes = {
    1: "-inci",
    5: "-inci",
    8: "-inci",
    70: "-inci",
    80: "-inci",
    2: "-nci",
    7: "-nci",
    20: "-nci",
    50: "-nci",
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: "-uncu",
    10: "-uncu",
    30: "-uncu",
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
const $ecd4f203c0e118c5$var$getSuffix = (number)=>{
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    const a = number % 10;
    const b = number % 100 - a;
    const c = number >= 100 ? 100 : null;
    if ($ecd4f203c0e118c5$var$suffixes[a]) return $ecd4f203c0e118c5$var$suffixes[a];
    else if ($ecd4f203c0e118c5$var$suffixes[b]) return $ecd4f203c0e118c5$var$suffixes[b];
    else if (c !== null) return $ecd4f203c0e118c5$var$suffixes[c];
    return "";
};
const $ecd4f203c0e118c5$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const suffix = $ecd4f203c0e118c5$var$getSuffix(number);
    return number + suffix;
};
const $ecd4f203c0e118c5$var$localize = $ecd4f203c0e118c5$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ecd4f203c0e118c5$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ecd4f203c0e118c5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ecd4f203c0e118c5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ecd4f203c0e118c5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ecd4f203c0e118c5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ecd4f203c0e118c5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ecd4f203c0e118c5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $d4ad45c7685b1ff0$export$4659b591c19bdf3d;
"use strict";
$d4ad45c7685b1ff0$export$4659b591c19bdf3d = void 0;


const $d4ad45c7685b1ff0$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
const $d4ad45c7685b1ff0$var$parseOrdinalNumberPattern = /\d+/i;
const $d4ad45c7685b1ff0$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
const $d4ad45c7685b1ff0$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
const $d4ad45c7685b1ff0$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
const $d4ad45c7685b1ff0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d4ad45c7685b1ff0$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
const $d4ad45c7685b1ff0$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
const $d4ad45c7685b1ff0$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
const $d4ad45c7685b1ff0$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
const $d4ad45c7685b1ff0$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
const $d4ad45c7685b1ff0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
const $d4ad45c7685b1ff0$var$match = $d4ad45c7685b1ff0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $d4ad45c7685b1ff0$var$matchOrdinalNumberPattern,
        parsePattern: $d4ad45c7685b1ff0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d4ad45c7685b1ff0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4ad45c7685b1ff0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d4ad45c7685b1ff0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4ad45c7685b1ff0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d4ad45c7685b1ff0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4ad45c7685b1ff0$var$parseMonthPatterns,
        defaultParseWidth: "narrow"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d4ad45c7685b1ff0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d4ad45c7685b1ff0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d4ad45c7685b1ff0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d4ad45c7685b1ff0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ const $3c663587825ac266$var$az = $3c663587825ac266$export$3d12bd131bb975d1 = {
    code: "az",
    formatDistance: $ffb8728b04043bf7$export$2c14ff85d6318973,
    formatLong: $8b05c6beac400618$export$cbf60ecb96cbb82f,
    formatRelative: $48748d28c92fa65e$export$8fbbfd65594f46a0,
    localize: $ecd4f203c0e118c5$export$b3bd0bc58e36cd63,
    match: $d4ad45c7685b1ff0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};


Object.keys($3c663587825ac266$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $3c663587825ac266$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $3c663587825ac266$exports[key];
        }
    });
});
var $f4c8f3776f8f2b6c$exports = {};

$parcel$export($f4c8f3776f8f2b6c$exports, "be", () => $f4c8f3776f8f2b6c$export$51b138e5a065c2bb, (v) => $f4c8f3776f8f2b6c$export$51b138e5a065c2bb = v);
var $f4c8f3776f8f2b6c$export$51b138e5a065c2bb;
"use strict";
$f4c8f3776f8f2b6c$export$51b138e5a065c2bb = void 0;
var $c4a80cf51f272028$export$2c14ff85d6318973;
"use strict";
$c4a80cf51f272028$export$2c14ff85d6318973 = void 0;
function $c4a80cf51f272028$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $c4a80cf51f272028$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $c4a80cf51f272028$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $c4a80cf51f272028$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $c4a80cf51f272028$var$declension(scheme.past, count);
                else return $c4a80cf51f272028$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $c4a80cf51f272028$var$declension(scheme.regular, count);
    };
}
const $c4a80cf51f272028$var$halfAMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
const $c4a80cf51f272028$var$formatDistanceLocale = {
    lessThanXSeconds: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $c4a80cf51f272028$var$halfAMinute,
    lessThanXMinutes: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    xWeeks: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    aboutXMonths: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $c4a80cf51f272028$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
const $c4a80cf51f272028$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $c4a80cf51f272028$var$formatDistanceLocale[token](count, options);
};
$c4a80cf51f272028$export$2c14ff85d6318973 = $c4a80cf51f272028$var$formatDistance;


var $1f9fb77212845dc8$export$cbf60ecb96cbb82f;
"use strict";
$1f9fb77212845dc8$export$cbf60ecb96cbb82f = void 0;

const $1f9fb77212845dc8$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $1f9fb77212845dc8$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $1f9fb77212845dc8$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $1f9fb77212845dc8$var$formatLong = $1f9fb77212845dc8$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1f9fb77212845dc8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1f9fb77212845dc8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1f9fb77212845dc8$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $de6e81261cf4177b$export$8fbbfd65594f46a0;
"use strict";
$de6e81261cf4177b$export$8fbbfd65594f46a0 = void 0;


const $de6e81261cf4177b$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $de6e81261cf4177b$var$lastWeek(day) {
    const weekday = $de6e81261cf4177b$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $de6e81261cf4177b$var$thisWeek(day) {
    const weekday = $de6e81261cf4177b$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $de6e81261cf4177b$var$nextWeek(day) {
    const weekday = $de6e81261cf4177b$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
const $de6e81261cf4177b$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $de6e81261cf4177b$var$thisWeek(day);
    else return $de6e81261cf4177b$var$lastWeek(day);
};
const $de6e81261cf4177b$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $de6e81261cf4177b$var$thisWeek(day);
    else return $de6e81261cf4177b$var$nextWeek(day);
};
const $de6e81261cf4177b$var$formatRelativeLocale = {
    lastWeek: $de6e81261cf4177b$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $de6e81261cf4177b$var$nextWeekFormat,
    other: "P"
};
const $de6e81261cf4177b$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $de6e81261cf4177b$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$de6e81261cf4177b$export$8fbbfd65594f46a0 = $de6e81261cf4177b$var$formatRelative;


var $b4bb5c0a911151d5$export$b3bd0bc58e36cd63;
"use strict";
$b4bb5c0a911151d5$export$b3bd0bc58e36cd63 = void 0;

const $b4bb5c0a911151d5$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
const $b4bb5c0a911151d5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $b4bb5c0a911151d5$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
const $b4bb5c0a911151d5$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
const $b4bb5c0a911151d5$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $b4bb5c0a911151d5$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
const $b4bb5c0a911151d5$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
const $b4bb5c0a911151d5$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
const $b4bb5c0a911151d5$var$localize = $b4bb5c0a911151d5$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b4bb5c0a911151d5$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b4bb5c0a911151d5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b4bb5c0a911151d5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b4bb5c0a911151d5$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b4bb5c0a911151d5$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b4bb5c0a911151d5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b4bb5c0a911151d5$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $b4bb5c0a911151d5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $74abd4488487d57e$export$4659b591c19bdf3d;
"use strict";
$74abd4488487d57e$export$4659b591c19bdf3d = void 0;


const $74abd4488487d57e$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const $74abd4488487d57e$var$parseOrdinalNumberPattern = /\d+/i;
const $74abd4488487d57e$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
const $74abd4488487d57e$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $74abd4488487d57e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
const $74abd4488487d57e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $74abd4488487d57e$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
const $74abd4488487d57e$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
const $74abd4488487d57e$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
const $74abd4488487d57e$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $74abd4488487d57e$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
const $74abd4488487d57e$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $74abd4488487d57e$var$match = $74abd4488487d57e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $74abd4488487d57e$var$matchOrdinalNumberPattern,
        parsePattern: $74abd4488487d57e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $74abd4488487d57e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74abd4488487d57e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $74abd4488487d57e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74abd4488487d57e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $74abd4488487d57e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74abd4488487d57e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $74abd4488487d57e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74abd4488487d57e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $74abd4488487d57e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74abd4488487d57e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik](https://github.com/alyrik)
 * @author Martin Wind [@arvigeus](https://github.com/mawi12345)
 */ const $f4c8f3776f8f2b6c$var$be = $f4c8f3776f8f2b6c$export$51b138e5a065c2bb = {
    code: "be",
    formatDistance: $c4a80cf51f272028$export$2c14ff85d6318973,
    formatLong: $1f9fb77212845dc8$export$cbf60ecb96cbb82f,
    formatRelative: $de6e81261cf4177b$export$8fbbfd65594f46a0,
    localize: $b4bb5c0a911151d5$export$b3bd0bc58e36cd63,
    match: $74abd4488487d57e$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($f4c8f3776f8f2b6c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $f4c8f3776f8f2b6c$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $f4c8f3776f8f2b6c$exports[key];
        }
    });
});
var $2a0040f14dc2c5b1$exports = {};

$parcel$export($2a0040f14dc2c5b1$exports, "beTarask", () => $2a0040f14dc2c5b1$export$af663c27a971be30, (v) => $2a0040f14dc2c5b1$export$af663c27a971be30 = v);
var $2a0040f14dc2c5b1$export$af663c27a971be30;
"use strict";
$2a0040f14dc2c5b1$export$af663c27a971be30 = void 0;
var $268c2b382ebb3b72$export$2c14ff85d6318973;
"use strict";
$268c2b382ebb3b72$export$2c14ff85d6318973 = void 0;
function $268c2b382ebb3b72$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $268c2b382ebb3b72$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $268c2b382ebb3b72$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $268c2b382ebb3b72$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $268c2b382ebb3b72$var$declension(scheme.past, count);
                else return $268c2b382ebb3b72$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $268c2b382ebb3b72$var$declension(scheme.regular, count);
    };
}
const $268c2b382ebb3b72$var$halfAMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
const $268c2b382ebb3b72$var$formatDistanceLocale = {
    lessThanXSeconds: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $268c2b382ebb3b72$var$halfAMinute,
    lessThanXMinutes: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    xWeeks: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u044B\u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
        }
    }),
    aboutXMonths: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $268c2b382ebb3b72$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
const $268c2b382ebb3b72$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $268c2b382ebb3b72$var$formatDistanceLocale[token](count, options);
};
$268c2b382ebb3b72$export$2c14ff85d6318973 = $268c2b382ebb3b72$var$formatDistance;


var $a38828d36b4837fe$export$cbf60ecb96cbb82f;
"use strict";
$a38828d36b4837fe$export$cbf60ecb96cbb82f = void 0;

const $a38828d36b4837fe$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $a38828d36b4837fe$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $a38828d36b4837fe$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $a38828d36b4837fe$var$formatLong = $a38828d36b4837fe$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a38828d36b4837fe$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a38828d36b4837fe$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a38828d36b4837fe$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $d9057c71274a1190$export$8fbbfd65594f46a0;
"use strict";
$d9057c71274a1190$export$8fbbfd65594f46a0 = void 0;


const $d9057c71274a1190$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $d9057c71274a1190$var$lastWeek(day) {
    const weekday = $d9057c71274a1190$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $d9057c71274a1190$var$thisWeek(day) {
    const weekday = $d9057c71274a1190$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $d9057c71274a1190$var$nextWeek(day) {
    const weekday = $d9057c71274a1190$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
const $d9057c71274a1190$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $d9057c71274a1190$var$thisWeek(day);
    else return $d9057c71274a1190$var$lastWeek(day);
};
const $d9057c71274a1190$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $d9057c71274a1190$var$thisWeek(day);
    else return $d9057c71274a1190$var$nextWeek(day);
};
const $d9057c71274a1190$var$formatRelativeLocale = {
    lastWeek: $d9057c71274a1190$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $d9057c71274a1190$var$nextWeekFormat,
    other: "P"
};
const $d9057c71274a1190$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $d9057c71274a1190$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$d9057c71274a1190$export$8fbbfd65594f46a0 = $d9057c71274a1190$var$formatRelative;


var $d5e3313a986fa4a4$export$b3bd0bc58e36cd63;
"use strict";
$d5e3313a986fa4a4$export$b3bd0bc58e36cd63 = void 0;

const $d5e3313a986fa4a4$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
const $d5e3313a986fa4a4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $d5e3313a986fa4a4$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
const $d5e3313a986fa4a4$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
const $d5e3313a986fa4a4$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $d5e3313a986fa4a4$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
const $d5e3313a986fa4a4$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
const $d5e3313a986fa4a4$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
const $d5e3313a986fa4a4$var$localize = $d5e3313a986fa4a4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d5e3313a986fa4a4$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d5e3313a986fa4a4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d5e3313a986fa4a4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d5e3313a986fa4a4$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $d5e3313a986fa4a4$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d5e3313a986fa4a4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d5e3313a986fa4a4$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $d5e3313a986fa4a4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $c839fd233b5eb35f$export$4659b591c19bdf3d;
"use strict";
$c839fd233b5eb35f$export$4659b591c19bdf3d = void 0;


const $c839fd233b5eb35f$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const $c839fd233b5eb35f$var$parseOrdinalNumberPattern = /\d+/i;
const $c839fd233b5eb35f$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
const $c839fd233b5eb35f$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $c839fd233b5eb35f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
const $c839fd233b5eb35f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c839fd233b5eb35f$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
const $c839fd233b5eb35f$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
const $c839fd233b5eb35f$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
const $c839fd233b5eb35f$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $c839fd233b5eb35f$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
const $c839fd233b5eb35f$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $c839fd233b5eb35f$var$match = $c839fd233b5eb35f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $c839fd233b5eb35f$var$matchOrdinalNumberPattern,
        parsePattern: $c839fd233b5eb35f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c839fd233b5eb35f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c839fd233b5eb35f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c839fd233b5eb35f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c839fd233b5eb35f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c839fd233b5eb35f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c839fd233b5eb35f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c839fd233b5eb35f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c839fd233b5eb35f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c839fd233b5eb35f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c839fd233b5eb35f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears](https://github.com/nopears)
 */ const $2a0040f14dc2c5b1$var$beTarask = $2a0040f14dc2c5b1$export$af663c27a971be30 = {
    code: "be-tarask",
    formatDistance: $268c2b382ebb3b72$export$2c14ff85d6318973,
    formatLong: $a38828d36b4837fe$export$cbf60ecb96cbb82f,
    formatRelative: $d9057c71274a1190$export$8fbbfd65594f46a0,
    localize: $d5e3313a986fa4a4$export$b3bd0bc58e36cd63,
    match: $c839fd233b5eb35f$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($2a0040f14dc2c5b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $2a0040f14dc2c5b1$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $2a0040f14dc2c5b1$exports[key];
        }
    });
});
var $432601889056618e$exports = {};

$parcel$export($432601889056618e$exports, "bg", () => $432601889056618e$export$136fd86de524d3c2, (v) => $432601889056618e$export$136fd86de524d3c2 = v);
var $432601889056618e$export$136fd86de524d3c2;
"use strict";
$432601889056618e$export$136fd86de524d3c2 = void 0;
var $5f384945ab66206b$export$2c14ff85d6318973;
"use strict";
$5f384945ab66206b$export$2c14ff85d6318973 = void 0;
const $5f384945ab66206b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
const $5f384945ab66206b$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $5f384945ab66206b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
$5f384945ab66206b$export$2c14ff85d6318973 = $5f384945ab66206b$var$formatDistance;


var $7d98e00f28d5dc7e$export$cbf60ecb96cbb82f;
"use strict";
$7d98e00f28d5dc7e$export$cbf60ecb96cbb82f = void 0;

const $7d98e00f28d5dc7e$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
const $7d98e00f28d5dc7e$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
const $7d98e00f28d5dc7e$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $7d98e00f28d5dc7e$var$formatLong = $7d98e00f28d5dc7e$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7d98e00f28d5dc7e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7d98e00f28d5dc7e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7d98e00f28d5dc7e$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $a3bab782aeb2fb6f$export$8fbbfd65594f46a0;
"use strict";
$a3bab782aeb2fb6f$export$8fbbfd65594f46a0 = void 0;


// Adapted from the `ru` translation
const $a3bab782aeb2fb6f$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $a3bab782aeb2fb6f$var$lastWeek(day) {
    const weekday = $a3bab782aeb2fb6f$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $a3bab782aeb2fb6f$var$thisWeek(day) {
    const weekday = $a3bab782aeb2fb6f$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $a3bab782aeb2fb6f$var$nextWeek(day) {
    const weekday = $a3bab782aeb2fb6f$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
const $a3bab782aeb2fb6f$var$lastWeekFormatToken = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $a3bab782aeb2fb6f$var$thisWeek(day);
    else return $a3bab782aeb2fb6f$var$lastWeek(day);
};
const $a3bab782aeb2fb6f$var$nextWeekFormatToken = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $a3bab782aeb2fb6f$var$thisWeek(day);
    else return $a3bab782aeb2fb6f$var$nextWeek(day);
};
const $a3bab782aeb2fb6f$var$formatRelativeLocale = {
    lastWeek: $a3bab782aeb2fb6f$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $a3bab782aeb2fb6f$var$nextWeekFormatToken,
    other: "P"
};
const $a3bab782aeb2fb6f$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $a3bab782aeb2fb6f$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$a3bab782aeb2fb6f$export$8fbbfd65594f46a0 = $a3bab782aeb2fb6f$var$formatRelative;


var $a1edbf1a55ab84a3$export$b3bd0bc58e36cd63;
"use strict";
$a1edbf1a55ab84a3$export$b3bd0bc58e36cd63 = void 0;

const $a1edbf1a55ab84a3$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
const $a1edbf1a55ab84a3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
const $a1edbf1a55ab84a3$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
const $a1edbf1a55ab84a3$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
const $a1edbf1a55ab84a3$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $a1edbf1a55ab84a3$var$isFeminine(unit) {
    return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function $a1edbf1a55ab84a3$var$isNeuter(unit) {
    return unit === "quarter";
}
function $a1edbf1a55ab84a3$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    const suffix = $a1edbf1a55ab84a3$var$isNeuter(unit) ? neuter : $a1edbf1a55ab84a3$var$isFeminine(unit) ? feminine : masculine;
    return number + "-" + suffix;
}
const $a1edbf1a55ab84a3$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return $a1edbf1a55ab84a3$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $a1edbf1a55ab84a3$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $a1edbf1a55ab84a3$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $a1edbf1a55ab84a3$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $a1edbf1a55ab84a3$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $a1edbf1a55ab84a3$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $a1edbf1a55ab84a3$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
const $a1edbf1a55ab84a3$var$localize = $a1edbf1a55ab84a3$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a1edbf1a55ab84a3$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a1edbf1a55ab84a3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a1edbf1a55ab84a3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a1edbf1a55ab84a3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a1edbf1a55ab84a3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a1edbf1a55ab84a3$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $2031a7898795ade9$export$4659b591c19bdf3d;
"use strict";
$2031a7898795ade9$export$4659b591c19bdf3d = void 0;


const $2031a7898795ade9$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
const $2031a7898795ade9$var$parseOrdinalNumberPattern = /\d+/i;
const $2031a7898795ade9$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
const $2031a7898795ade9$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
const $2031a7898795ade9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
const $2031a7898795ade9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2031a7898795ade9$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
const $2031a7898795ade9$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
const $2031a7898795ade9$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
const $2031a7898795ade9$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
const $2031a7898795ade9$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
const $2031a7898795ade9$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
const $2031a7898795ade9$var$match = $2031a7898795ade9$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $2031a7898795ade9$var$matchOrdinalNumberPattern,
        parsePattern: $2031a7898795ade9$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2031a7898795ade9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2031a7898795ade9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2031a7898795ade9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2031a7898795ade9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2031a7898795ade9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2031a7898795ade9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2031a7898795ade9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2031a7898795ade9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2031a7898795ade9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2031a7898795ade9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus](https://github.com/arvigeus)
 * @author Tsvetan Ovedenski [@fintara](https://github.com/fintara)
 */ const $432601889056618e$var$bg = $432601889056618e$export$136fd86de524d3c2 = {
    code: "bg",
    formatDistance: $5f384945ab66206b$export$2c14ff85d6318973,
    formatLong: $7d98e00f28d5dc7e$export$cbf60ecb96cbb82f,
    formatRelative: $a3bab782aeb2fb6f$export$8fbbfd65594f46a0,
    localize: $a1edbf1a55ab84a3$export$b3bd0bc58e36cd63,
    match: $2031a7898795ade9$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($432601889056618e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $432601889056618e$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $432601889056618e$exports[key];
        }
    });
});
var $0cb60bc99bf2dbc8$exports = {};

$parcel$export($0cb60bc99bf2dbc8$exports, "bn", () => $0cb60bc99bf2dbc8$export$acf3ba20e47771d, (v) => $0cb60bc99bf2dbc8$export$acf3ba20e47771d = v);
var $0cb60bc99bf2dbc8$export$acf3ba20e47771d;
"use strict";
$0cb60bc99bf2dbc8$export$acf3ba20e47771d = void 0;
var $b68f58baa78f51c5$export$2c14ff85d6318973;
"use strict";
$b68f58baa78f51c5$export$2c14ff85d6318973 = void 0;
var $b0d8fa1700e0239e$export$b3bd0bc58e36cd63;
var $b0d8fa1700e0239e$export$3e1d599946644f03;
"use strict";
$b0d8fa1700e0239e$export$b3bd0bc58e36cd63 = void 0;
$b0d8fa1700e0239e$export$3e1d599946644f03 = $b0d8fa1700e0239e$var$numberToLocale;

const $b0d8fa1700e0239e$var$numberValues = {
    locale: {
        1: "\u09E7",
        2: "\u09E8",
        3: "\u09E9",
        4: "\u09EA",
        5: "\u09EB",
        6: "\u09EC",
        7: "\u09ED",
        8: "\u09EE",
        9: "\u09EF",
        0: "\u09E6"
    },
    number: {
        "\u09E7": "1",
        "\u09E8": "2",
        "\u09E9": "3",
        "\u09EA": "4",
        "\u09EB": "5",
        "\u09EC": "6",
        "\u09ED": "7",
        "\u09EE": "8",
        "\u09EF": "9",
        "\u09E6": "0"
    }
};
const $b0d8fa1700e0239e$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
const $b0d8fa1700e0239e$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
const $b0d8fa1700e0239e$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
const $b0d8fa1700e0239e$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
const $b0d8fa1700e0239e$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
const $b0d8fa1700e0239e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $b0d8fa1700e0239e$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
const $b0d8fa1700e0239e$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const localeNumber = $b0d8fa1700e0239e$var$numberToLocale(number);
    const unit = options?.unit;
    if (unit === "date") return $b0d8fa1700e0239e$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    const rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
// function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }
function $b0d8fa1700e0239e$var$numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $b0d8fa1700e0239e$var$numberValues.locale[match];
    });
}
const $b0d8fa1700e0239e$var$localize = $b0d8fa1700e0239e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b0d8fa1700e0239e$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b0d8fa1700e0239e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b0d8fa1700e0239e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b0d8fa1700e0239e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b0d8fa1700e0239e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b0d8fa1700e0239e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b0d8fa1700e0239e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


const $b68f58baa78f51c5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
const $b68f58baa78f51c5$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b68f58baa78f51c5$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $b0d8fa1700e0239e$export$3e1d599946644f03)(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
$b68f58baa78f51c5$export$2c14ff85d6318973 = $b68f58baa78f51c5$var$formatDistance;


var $160c88d09d5a7879$export$cbf60ecb96cbb82f;
"use strict";
$160c88d09d5a7879$export$cbf60ecb96cbb82f = void 0;

const $160c88d09d5a7879$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $160c88d09d5a7879$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $160c88d09d5a7879$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $160c88d09d5a7879$var$formatLong = $160c88d09d5a7879$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $160c88d09d5a7879$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $160c88d09d5a7879$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $160c88d09d5a7879$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $59b1a961e907b1e3$export$8fbbfd65594f46a0;
"use strict";
$59b1a961e907b1e3$export$8fbbfd65594f46a0 = void 0;
const $59b1a961e907b1e3$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: "P"
};
const $59b1a961e907b1e3$var$formatRelative = (token, _date, _baseDate, _options)=>$59b1a961e907b1e3$var$formatRelativeLocale[token];
$59b1a961e907b1e3$export$8fbbfd65594f46a0 = $59b1a961e907b1e3$var$formatRelative;



var $50a2fd2908bdaf26$export$4659b591c19bdf3d;
"use strict";
$50a2fd2908bdaf26$export$4659b591c19bdf3d = void 0;


const $50a2fd2908bdaf26$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
const $50a2fd2908bdaf26$var$parseOrdinalNumberPattern = /\d+/i;
const $50a2fd2908bdaf26$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
const $50a2fd2908bdaf26$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
const $50a2fd2908bdaf26$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
const $50a2fd2908bdaf26$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
const $50a2fd2908bdaf26$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
const $50a2fd2908bdaf26$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
const $50a2fd2908bdaf26$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
const $50a2fd2908bdaf26$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
const $50a2fd2908bdaf26$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
const $50a2fd2908bdaf26$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
const $50a2fd2908bdaf26$var$match = $50a2fd2908bdaf26$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $50a2fd2908bdaf26$var$matchOrdinalNumberPattern,
        parsePattern: $50a2fd2908bdaf26$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $50a2fd2908bdaf26$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $50a2fd2908bdaf26$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $50a2fd2908bdaf26$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $50a2fd2908bdaf26$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $50a2fd2908bdaf26$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $50a2fd2908bdaf26$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $50a2fd2908bdaf26$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $50a2fd2908bdaf26$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $50a2fd2908bdaf26$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $50a2fd2908bdaf26$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman](https://github.com/touhidrahman)
 * @author Farhad Yasir [@nutboltu](https://github.com/nutboltu)
 */ const $0cb60bc99bf2dbc8$var$bn = $0cb60bc99bf2dbc8$export$acf3ba20e47771d = {
    code: "bn",
    formatDistance: $b68f58baa78f51c5$export$2c14ff85d6318973,
    formatLong: $160c88d09d5a7879$export$cbf60ecb96cbb82f,
    formatRelative: $59b1a961e907b1e3$export$8fbbfd65594f46a0,
    localize: $b0d8fa1700e0239e$export$b3bd0bc58e36cd63,
    match: $50a2fd2908bdaf26$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($0cb60bc99bf2dbc8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $0cb60bc99bf2dbc8$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $0cb60bc99bf2dbc8$exports[key];
        }
    });
});
var $4d39e95767136f27$exports = {};

$parcel$export($4d39e95767136f27$exports, "bs", () => $4d39e95767136f27$export$4e222d082f82ee97, (v) => $4d39e95767136f27$export$4e222d082f82ee97 = v);
var $4d39e95767136f27$export$4e222d082f82ee97;
"use strict";
$4d39e95767136f27$export$4e222d082f82ee97 = void 0;
var $956673807ab48893$export$2c14ff85d6318973;
"use strict";
$956673807ab48893$export$2c14ff85d6318973 = void 0;
const $956673807ab48893$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 sedmicu",
            withPrepositionAgo: "oko 1 sedmicu",
            withPrepositionIn: "oko 1 sedmicu"
        },
        dual: "oko {{count}} sedmice",
        other: "oko {{count}} sedmice"
    },
    xWeeks: {
        one: {
            standalone: "1 sedmicu",
            withPrepositionAgo: "1 sedmicu",
            withPrepositionIn: "1 sedmicu"
        },
        dual: "{{count}} sedmice",
        other: "{{count}} sedmice"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $956673807ab48893$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $956673807ab48893$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
$956673807ab48893$export$2c14ff85d6318973 = $956673807ab48893$var$formatDistance;


var $7ed1881c3a8e543c$export$cbf60ecb96cbb82f;
"use strict";
$7ed1881c3a8e543c$export$cbf60ecb96cbb82f = void 0;

const $7ed1881c3a8e543c$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $7ed1881c3a8e543c$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $7ed1881c3a8e543c$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $7ed1881c3a8e543c$var$formatLong = $7ed1881c3a8e543c$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7ed1881c3a8e543c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7ed1881c3a8e543c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7ed1881c3a8e543c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $e69caf11abad9aa8$export$8fbbfd65594f46a0;
"use strict";
$e69caf11abad9aa8$export$8fbbfd65594f46a0 = void 0;
const $e69caf11abad9aa8$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
const $e69caf11abad9aa8$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $e69caf11abad9aa8$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$e69caf11abad9aa8$export$8fbbfd65594f46a0 = $e69caf11abad9aa8$var$formatRelative;


var $66e80900b8b20f20$export$b3bd0bc58e36cd63;
"use strict";
$66e80900b8b20f20$export$b3bd0bc58e36cd63 = void 0;

const $66e80900b8b20f20$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Prije Hrista",
        "Poslije Hrista"
    ]
};
const $66e80900b8b20f20$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $66e80900b8b20f20$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $66e80900b8b20f20$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $66e80900b8b20f20$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $66e80900b8b20f20$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $66e80900b8b20f20$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $66e80900b8b20f20$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number) + ".";
};
const $66e80900b8b20f20$var$localize = $66e80900b8b20f20$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $66e80900b8b20f20$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $66e80900b8b20f20$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $66e80900b8b20f20$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $66e80900b8b20f20$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $66e80900b8b20f20$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $66e80900b8b20f20$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $66e80900b8b20f20$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $66e80900b8b20f20$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $be9235d7fdb6ba1d$export$4659b591c19bdf3d;
"use strict";
$be9235d7fdb6ba1d$export$4659b591c19bdf3d = void 0;


const $be9235d7fdb6ba1d$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $be9235d7fdb6ba1d$var$parseOrdinalNumberPattern = /\d+/i;
const $be9235d7fdb6ba1d$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
const $be9235d7fdb6ba1d$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $be9235d7fdb6ba1d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $be9235d7fdb6ba1d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $be9235d7fdb6ba1d$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
const $be9235d7fdb6ba1d$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $be9235d7fdb6ba1d$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $be9235d7fdb6ba1d$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $be9235d7fdb6ba1d$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
const $be9235d7fdb6ba1d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
const $be9235d7fdb6ba1d$var$match = $be9235d7fdb6ba1d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $be9235d7fdb6ba1d$var$matchOrdinalNumberPattern,
        parsePattern: $be9235d7fdb6ba1d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $be9235d7fdb6ba1d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $be9235d7fdb6ba1d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $be9235d7fdb6ba1d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $be9235d7fdb6ba1d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $be9235d7fdb6ba1d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $be9235d7fdb6ba1d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $be9235d7fdb6ba1d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $be9235d7fdb6ba1d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $be9235d7fdb6ba1d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $be9235d7fdb6ba1d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic](https://github.com/branislavlazic)
 */ const $4d39e95767136f27$var$bs = $4d39e95767136f27$export$4e222d082f82ee97 = {
    code: "bs",
    formatDistance: $956673807ab48893$export$2c14ff85d6318973,
    formatLong: $7ed1881c3a8e543c$export$cbf60ecb96cbb82f,
    formatRelative: $e69caf11abad9aa8$export$8fbbfd65594f46a0,
    localize: $66e80900b8b20f20$export$b3bd0bc58e36cd63,
    match: $be9235d7fdb6ba1d$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($4d39e95767136f27$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $4d39e95767136f27$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $4d39e95767136f27$exports[key];
        }
    });
});
var $4142331027e4a1c6$exports = {};

$parcel$export($4142331027e4a1c6$exports, "ca", () => $4142331027e4a1c6$export$89e9012e902952b6, (v) => $4142331027e4a1c6$export$89e9012e902952b6 = v);
var $4142331027e4a1c6$export$89e9012e902952b6;
"use strict";
$4142331027e4a1c6$export$89e9012e902952b6 = void 0;
var $530e13aa4d6dd0e6$export$2c14ff85d6318973;
"use strict";
$530e13aa4d6dd0e6$export$2c14ff85d6318973 = void 0;
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ const $530e13aa4d6dd0e6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: "menys de {{count}} segons"
    },
    xSeconds: {
        one: "1 segon",
        other: "{{count}} segons"
    },
    halfAMinute: "mig minut",
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: "menys de {{count}} minuts"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minuts"
    },
    aboutXHours: {
        one: "aproximadament una hora",
        other: "aproximadament {{count}} hores"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} hores"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dies"
    },
    aboutXWeeks: {
        one: "aproximadament una setmana",
        other: "aproximadament {{count}} setmanes"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanes"
    },
    aboutXMonths: {
        one: "aproximadament un mes",
        other: "aproximadament {{count}} mesos"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} mesos"
    },
    aboutXYears: {
        one: "aproximadament un any",
        other: "aproximadament {{count}} anys"
    },
    xYears: {
        one: "1 any",
        other: "{{count}} anys"
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
const $530e13aa4d6dd0e6$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $530e13aa4d6dd0e6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "fa " + result;
    }
    return result;
};
$530e13aa4d6dd0e6$export$2c14ff85d6318973 = $530e13aa4d6dd0e6$var$formatDistance;


var $9240983c50738a7e$export$cbf60ecb96cbb82f;
"use strict";
$9240983c50738a7e$export$cbf60ecb96cbb82f = void 0;

const $9240983c50738a7e$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $9240983c50738a7e$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $9240983c50738a7e$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $9240983c50738a7e$var$formatLong = $9240983c50738a7e$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9240983c50738a7e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9240983c50738a7e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9240983c50738a7e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $ec441f96a6014510$export$8fbbfd65594f46a0;
"use strict";
$ec441f96a6014510$export$8fbbfd65594f46a0 = void 0;
const $ec441f96a6014510$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $ec441f96a6014510$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: "P"
};
const $ec441f96a6014510$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $ec441f96a6014510$var$formatRelativeLocalePlural[token];
    return $ec441f96a6014510$var$formatRelativeLocale[token];
};
$ec441f96a6014510$export$8fbbfd65594f46a0 = $ec441f96a6014510$var$formatRelative;


var $ebf18b8915c7e2a6$export$b3bd0bc58e36cd63;
"use strict";
$ebf18b8915c7e2a6$export$b3bd0bc58e36cd63 = void 0;

/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ const $ebf18b8915c7e2a6$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a. de C.",
        "d. de C."
    ],
    wide: [
        "abans de Crist",
        "despr\xe9s de Crist"
    ]
};
const $ebf18b8915c7e2a6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1r trimestre",
        "2n trimestre",
        "3r trimestre",
        "4t trimestre"
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ const $ebf18b8915c7e2a6$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MG",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DS"
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "maig",
        "juny",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "des."
    ],
    wide: [
        "gener",
        "febrer",
        "mar\xe7",
        "abril",
        "maig",
        "juny",
        "juliol",
        "agost",
        "setembre",
        "octubre",
        "novembre",
        "desembre"
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ const $ebf18b8915c7e2a6$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "diumenge",
        "dilluns",
        "dimarts",
        "dimecres",
        "dijous",
        "divendres",
        "dissabte"
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ const $ebf18b8915c7e2a6$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    }
};
const $ebf18b8915c7e2a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ const $ebf18b8915c7e2a6$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "r";
        case 2:
            return number + "n";
        case 3:
            return number + "r";
        case 4:
            return number + "t";
    }
    return number + "\xe8";
};
const $ebf18b8915c7e2a6$var$localize = $ebf18b8915c7e2a6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ebf18b8915c7e2a6$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ebf18b8915c7e2a6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ebf18b8915c7e2a6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ebf18b8915c7e2a6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ebf18b8915c7e2a6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ebf18b8915c7e2a6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ebf18b8915c7e2a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $d042767b84aa05f9$export$4659b591c19bdf3d;
"use strict";
$d042767b84aa05f9$export$4659b591c19bdf3d = void 0;


const $d042767b84aa05f9$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
const $d042767b84aa05f9$var$parseOrdinalNumberPattern = /\d+/i;
const $d042767b84aa05f9$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
const $d042767b84aa05f9$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
const $d042767b84aa05f9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
const $d042767b84aa05f9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d042767b84aa05f9$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
const $d042767b84aa05f9$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
const $d042767b84aa05f9$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
const $d042767b84aa05f9$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
const $d042767b84aa05f9$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
const $d042767b84aa05f9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
const $d042767b84aa05f9$var$match = $d042767b84aa05f9$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $d042767b84aa05f9$var$matchOrdinalNumberPattern,
        parsePattern: $d042767b84aa05f9$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d042767b84aa05f9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d042767b84aa05f9$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d042767b84aa05f9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d042767b84aa05f9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d042767b84aa05f9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d042767b84aa05f9$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d042767b84aa05f9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d042767b84aa05f9$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d042767b84aa05f9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d042767b84aa05f9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Alex Vizcaino [@avizcaino](https://github.com/avizcaino)
 */ const $4142331027e4a1c6$var$ca = $4142331027e4a1c6$export$89e9012e902952b6 = {
    code: "ca",
    formatDistance: $530e13aa4d6dd0e6$export$2c14ff85d6318973,
    formatLong: $9240983c50738a7e$export$cbf60ecb96cbb82f,
    formatRelative: $ec441f96a6014510$export$8fbbfd65594f46a0,
    localize: $ebf18b8915c7e2a6$export$b3bd0bc58e36cd63,
    match: $d042767b84aa05f9$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($4142331027e4a1c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $4142331027e4a1c6$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $4142331027e4a1c6$exports[key];
        }
    });
});
var $3882cd912a3ad905$exports = {};

$parcel$export($3882cd912a3ad905$exports, "ckb", () => $3882cd912a3ad905$export$c045140574fce5cd, (v) => $3882cd912a3ad905$export$c045140574fce5cd = v);
var $3882cd912a3ad905$export$c045140574fce5cd;
"use strict";
$3882cd912a3ad905$export$c045140574fce5cd = void 0;
var $a4e5072516feb473$export$2c14ff85d6318973;
"use strict";
$a4e5072516feb473$export$2c14ff85d6318973 = void 0;
const $a4e5072516feb473$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u0686\u0631\u06A9\u06D5",
        other: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u0686\u0631\u06A9\u06D5"
    },
    xSeconds: {
        one: "1 \u0686\u0631\u06A9\u06D5",
        other: "{{count}} \u0686\u0631\u06A9\u06D5"
    },
    halfAMinute: "\u0646\u06CC\u0648 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
    lessThanXMinutes: {
        one: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u062E\u0648\u0644\u06D5\u06A9",
        other: "\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u062E\u0648\u0644\u06D5\u06A9"
    },
    xMinutes: {
        one: "1 \u062E\u0648\u0644\u06D5\u06A9",
        other: "{{count}} \u062E\u0648\u0644\u06D5\u06A9"
    },
    aboutXHours: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
    },
    xHours: {
        one: "1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
        other: "{{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
    },
    xDays: {
        one: "1 \u0695\u06C6\u0698",
        other: "{{count}} \u0698\u06C6\u0698"
    },
    aboutXWeeks: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0647\u06D5\u0641\u062A\u06D5",
        other: "\u062F\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0647\u06D5\u0641\u062A\u06D5"
    },
    xWeeks: {
        one: "1 \u0647\u06D5\u0641\u062A\u06D5",
        other: "{{count}} \u0647\u06D5\u0641\u062A\u06D5"
    },
    aboutXMonths: {
        one: "\u062F\u0627\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0645\u0627\u0646\u06AF",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0645\u0627\u0646\u06AF"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0646\u06AF",
        other: "{{count}} \u0645\u0627\u0646\u06AF"
    },
    aboutXYears: {
        one: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC  1 \u0633\u0627\u06B5",
        other: "\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0633\u0627\u06B5"
    },
    xYears: {
        one: "1 \u0633\u0627\u06B5",
        other: "{{count}} \u0633\u0627\u06B5"
    },
    overXYears: {
        one: "\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 \u0633\u0627\u06B5\u06CE\u06A9",
        other: "\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 {{count}} \u0633\u0627\u06B5"
    },
    almostXYears: {
        one: "\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC \u0633\u0627\u06B5\u06CE\u06A9  ",
        other: "\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC {{count}} \u0633\u0627\u06B5"
    }
};
const $a4e5072516feb473$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $a4e5072516feb473$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0644\u06D5 \u0645\u0627\u0648\u06D5\u06CC " + result + "\u062F\u0627";
        else return result + "\u067E\u06CE\u0634 \u0626\u06CE\u0633\u062A\u0627";
    }
    return result;
};
$a4e5072516feb473$export$2c14ff85d6318973 = $a4e5072516feb473$var$formatDistance;


var $f89f93af0cceef59$export$cbf60ecb96cbb82f;
"use strict";
$f89f93af0cceef59$export$cbf60ecb96cbb82f = void 0;

const $f89f93af0cceef59$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $f89f93af0cceef59$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $f89f93af0cceef59$var$dateTimeFormats = {
    full: "{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
    long: "{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f89f93af0cceef59$var$formatLong = $f89f93af0cceef59$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f89f93af0cceef59$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f89f93af0cceef59$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f89f93af0cceef59$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $4e8cd066216ac5dd$export$8fbbfd65594f46a0;
"use strict";
$4e8cd066216ac5dd$export$8fbbfd65594f46a0 = void 0;
const $4e8cd066216ac5dd$var$formatRelativeLocale = {
    lastWeek: "'\u0647\u06D5\u0641\u062A\u06D5\u06CC \u0695\u0627\u0628\u0631\u062F\u0648\u0648' eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    yesterday: "'\u062F\u0648\u06CE\u0646\u06CE \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    today: "'\u0626\u06D5\u0645\u0695\u06C6 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    tomorrow: "'\u0628\u06D5\u06CC\u0627\u0646\u06CC \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    nextWeek: "eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
    other: "P"
};
const $4e8cd066216ac5dd$var$formatRelative = (token, _date, _baseDate, _options)=>$4e8cd066216ac5dd$var$formatRelativeLocale[token];
$4e8cd066216ac5dd$export$8fbbfd65594f46a0 = $4e8cd066216ac5dd$var$formatRelative;


var $46f94a81a908e8c9$export$b3bd0bc58e36cd63;
"use strict";
$46f94a81a908e8c9$export$b3bd0bc58e36cd63 = void 0;

const $46f94a81a908e8c9$var$eraValues = {
    narrow: [
        "\u067E",
        "\u062F"
    ],
    abbreviated: [
        "\u067E-\u0632",
        "\u062F-\u0632"
    ],
    wide: [
        "\u067E\u06CE\u0634 \u0632\u0627\u06CC\u0646",
        "\u062F\u0648\u0627\u06CC \u0632\u0627\u06CC\u0646"
    ]
};
const $46f94a81a908e8c9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06861\u0645",
        "\u06862\u0645",
        "\u06863\u0645",
        "\u06864\u0645"
    ],
    wide: [
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u06CC\u06D5\u06A9\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0633\u06CE\u06CC\u06D5\u0645",
        "\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0686\u0648\u0627\u0631\u06D5\u0645"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $46f94a81a908e8c9$var$monthValues = {
    narrow: [
        "\u06A9-\u062F",
        "\u0634",
        "\u0626\u0627",
        "\u0646",
        "\u0645",
        "\u062D",
        "\u062A",
        "\u0626\u0627",
        "\u0626\u06D5",
        "\u062A\u0634-\u06CC",
        "\u062A\u0634-\u062F",
        "\u06A9-\u06CC"
    ],
    abbreviated: [
        "\u06A9\u0627\u0646-\u062F\u0648\u0648",
        "\u0634\u0648\u0628",
        "\u0626\u0627\u062F",
        "\u0646\u06CC\u0633",
        "\u0645\u0627\u06CC\u0633",
        "\u062D\u0648\u0632",
        "\u062A\u06D5\u0645",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u0644",
        "\u062A\u0634-\u06CC\u06D5\u06A9",
        "\u062A\u0634-\u062F\u0648\u0648",
        "\u06A9\u0627\u0646-\u06CC\u06D5\u06A9"
    ],
    wide: [
        "\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u0634\u0648\u0628\u0627\u062A",
        "\u0626\u0627\u062F\u0627\u0631",
        "\u0646\u06CC\u0633\u0627\u0646",
        "\u0645\u0627\u06CC\u0633",
        "\u062D\u0648\u0632\u06D5\u06CC\u0631\u0627\u0646",
        "\u062A\u06D5\u0645\u0645\u0648\u0632",
        "\u0626\u0627\u0628",
        "\u0626\u06D5\u06CC\u0644\u0648\u0644",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645",
        "\u062A\u0634\u0631\u06CC\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
        "\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645"
    ]
};
const $46f94a81a908e8c9$var$dayValues = {
    narrow: [
        "\u06CC-\u0634",
        "\u062F-\u0634",
        "\u0633-\u0634",
        "\u0686-\u0634",
        "\u067E-\u0634",
        "\u0647\u06D5",
        "\u0634"
    ],
    short: [
        "\u06CC\u06D5-\u0634\u06D5",
        "\u062F\u0648\u0648-\u0634\u06D5",
        "\u0633\u06CE-\u0634\u06D5",
        "\u0686\u0648-\u0634\u06D5",
        "\u067E\u06CE-\u0634\u06D5",
        "\u0647\u06D5\u06CC",
        "\u0634\u06D5"
    ],
    abbreviated: [
        "\u06CC\u06D5\u06A9-\u0634\u06D5\u0645",
        "\u062F\u0648\u0648-\u0634\u06D5\u0645",
        "\u0633\u06CE-\u0634\u06D5\u0645",
        "\u0686\u0648\u0627\u0631-\u0634\u06D5\u0645",
        "\u067E\u06CE\u0646\u062C-\u0634\u06D5\u0645",
        "\u0647\u06D5\u06CC\u0646\u06CC",
        "\u0634\u06D5\u0645\u06D5"
    ],
    wide: [
        "\u06CC\u06D5\u06A9 \u0634\u06D5\u0645\u06D5",
        "\u062F\u0648\u0648 \u0634\u06D5\u0645\u06D5",
        "\u0633\u06CE \u0634\u06D5\u0645\u06D5",
        "\u0686\u0648\u0627\u0631 \u0634\u06D5\u0645\u06D5",
        "\u067E\u06CE\u0646\u062C \u0634\u06D5\u0645\u06D5",
        "\u0647\u06D5\u06CC\u0646\u06CC",
        "\u0634\u06D5\u0645\u06D5"
    ]
};
const $46f94a81a908e8c9$var$dayPeriodValues = {
    narrow: {
        am: "\u067E",
        pm: "\u062F",
        midnight: "\u0646-\u0634",
        noon: "\u0646",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    },
    abbreviated: {
        am: "\u067E-\u0646",
        pm: "\u062F-\u0646",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    },
    wide: {
        am: "\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        pm: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0628\u06D5\u06CC\u0627\u0646\u06CC",
        afternoon: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        evening: "\u0626\u06CE\u0648\u0627\u0631\u06D5",
        night: "\u0634\u06D5\u0648"
    }
};
const $46f94a81a908e8c9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u067E",
        pm: "\u062F",
        midnight: "\u0646-\u0634",
        noon: "\u0646",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    },
    abbreviated: {
        am: "\u067E-\u0646",
        pm: "\u062F-\u0646",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    },
    wide: {
        am: "\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        pm: "\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
        midnight: "\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
        noon: "\u0646\u06CC\u0648\u06D5\u0695\u06C6",
        morning: "\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
        afternoon: "\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
        evening: "\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
        night: "\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
    }
};
const $46f94a81a908e8c9$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $46f94a81a908e8c9$var$localize = $46f94a81a908e8c9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $46f94a81a908e8c9$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $46f94a81a908e8c9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $46f94a81a908e8c9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $46f94a81a908e8c9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $46f94a81a908e8c9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $46f94a81a908e8c9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $46f94a81a908e8c9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $38240f0819030919$export$4659b591c19bdf3d;
"use strict";
$38240f0819030919$export$4659b591c19bdf3d = void 0;


const $38240f0819030919$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $38240f0819030919$var$parseOrdinalNumberPattern = /\d+/i;
const $38240f0819030919$var$matchEraPatterns = {
    narrow: /^(پ|د)/i,
    abbreviated: /^(پ-ز|د.ز)/i,
    wide: /^(پێش زاین| دوای زاین)/i
};
const $38240f0819030919$var$parseEraPatterns = {
    any: [
        /^د/g,
        /^پ/g
    ]
};
const $38240f0819030919$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^م[1234]چ/i,
    wide: /^(یەکەم|دووەم|سێیەم| چوارەم) (چارەگی)? quarter/i
};
const $38240f0819030919$var$parseQuarterPatterns = {
    wide: [
        /چارەگی یەکەم/,
        /چارەگی دووەم/,
        /چارەگی سيیەم/,
        /چارەگی چوارەم/
    ],
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $38240f0819030919$var$matchMonthPatterns = {
    narrow: /^(ک-د|ش|ئا|ن|م|ح|ت|ئە|تش-ی|تش-د|ک-ی)/i,
    abbreviated: /^(کان-دوو|شوب|ئاد|نیس|مایس|حوز|تەم|ئاب|ئەل|تش-یەک|تش-دوو|کان-یەک)/i,
    wide: /^(کانوونی دووەم|شوبات|ئادار|نیسان|مایس|حوزەیران|تەمموز|ئاب|ئەیلول|تشرینی یەکەم|تشرینی دووەم|کانوونی یەکەم)/i
};
const $38240f0819030919$var$parseMonthPatterns = {
    narrow: [
        /^ک-د/i,
        /^ش/i,
        /^ئا/i,
        /^ن/i,
        /^م/i,
        /^ح/i,
        /^ت/i,
        /^ئا/i,
        /^ئە/i,
        /^تش-ی/i,
        /^تش-د/i,
        /^ک-ی/i
    ],
    any: [
        /^کان-دوو/i,
        /^شوب/i,
        /^ئاد/i,
        /^نیس/i,
        /^مایس/i,
        /^حوز/i,
        /^تەم/i,
        /^ئاب/i,
        /^ئەل/i,
        /^تش-یەک/i,
        /^تش-دوو/i,
        /^|کان-یەک/i
    ]
};
const $38240f0819030919$var$matchDayPatterns = {
    narrow: /^(ش|ی|د|س|چ|پ|هە)/i,
    short: /^(یە-شە|دوو-شە|سێ-شە|چو-شە|پێ-شە|هە|شە)/i,
    abbreviated: /^(یەک-شەم|دوو-شەم|سێ-شەم|چوار-شەم|پێنخ-شەم|هەینی|شەمە)/i,
    wide: /^(یەک شەمە|دوو شەمە|سێ شەمە|چوار شەمە|پێنج شەمە|هەینی|شەمە)/i
};
const $38240f0819030919$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $38240f0819030919$var$matchDayPeriodPatterns = {
    narrow: /^(پ|د|ن-ش|ن| (بەیانی|دوای نیوەڕۆ|ئێوارە|شەو))/i,
    abbreviated: /^(پ-ن|د-ن|نیوە شەو|نیوەڕۆ|بەیانی|دوای نیوەڕۆ|ئێوارە|شەو)/,
    wide: /^(پێش نیوەڕۆ|دوای نیوەڕۆ|نیوەڕۆ|نیوە شەو|لەبەیانیدا|لەدواینیوەڕۆدا|لە ئێوارەدا|لە شەودا)/,
    any: /^(پ|د|بەیانی|نیوەڕۆ|ئێوارە|شەو)/
};
const $38240f0819030919$var$parseDayPeriodPatterns = {
    any: {
        am: /^د/i,
        pm: /^پ/i,
        midnight: /^ن-ش/i,
        noon: /^ن/i,
        morning: /بەیانی/i,
        afternoon: /دواینیوەڕۆ/i,
        evening: /ئێوارە/i,
        night: /شەو/i
    }
};
const $38240f0819030919$var$match = $38240f0819030919$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $38240f0819030919$var$matchOrdinalNumberPattern,
        parsePattern: $38240f0819030919$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $38240f0819030919$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38240f0819030919$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $38240f0819030919$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38240f0819030919$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $38240f0819030919$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38240f0819030919$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $38240f0819030919$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38240f0819030919$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $38240f0819030919$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $38240f0819030919$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @type {Locale}
 * @category Locales
 * @summary Central Kurdish locale.
 * @language Central Kurdish
 * @iso-639-2 kur
 * @author Revan Sarbast [@Revan99]{@link https://github.com/Revan99}
 */ const $3882cd912a3ad905$var$ckb = $3882cd912a3ad905$export$c045140574fce5cd = {
    code: "ckb",
    formatDistance: $a4e5072516feb473$export$2c14ff85d6318973,
    formatLong: $f89f93af0cceef59$export$cbf60ecb96cbb82f,
    formatRelative: $4e8cd066216ac5dd$export$8fbbfd65594f46a0,
    localize: $46f94a81a908e8c9$export$b3bd0bc58e36cd63,
    match: $38240f0819030919$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($3882cd912a3ad905$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $3882cd912a3ad905$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $3882cd912a3ad905$exports[key];
        }
    });
});
var $98fc3d813bebdf2b$exports = {};

$parcel$export($98fc3d813bebdf2b$exports, "cs", () => $98fc3d813bebdf2b$export$bde1ed0f60b38f2f, (v) => $98fc3d813bebdf2b$export$bde1ed0f60b38f2f = v);
var $98fc3d813bebdf2b$export$bde1ed0f60b38f2f;
"use strict";
$98fc3d813bebdf2b$export$bde1ed0f60b38f2f = void 0;
var $7850d3bcaa51217f$export$2c14ff85d6318973;
"use strict";
$7850d3bcaa51217f$export$2c14ff85d6318973 = void 0;
const $7850d3bcaa51217f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 sekundou",
            future: "za m\xe9n\u011B ne\u017E 1 sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: "1 sekunda",
            past: "p\u0159ed 1 sekundou",
            future: "za 1 sekundu"
        },
        few: {
            regular: "{{count}} sekundy",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekundy"
        },
        many: {
            regular: "{{count}} sekund",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekund"
        }
    },
    halfAMinute: {
        type: "other",
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 minutou",
            future: "za m\xe9n\u011B ne\u017E 1 minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: "1 minuta",
            past: "p\u0159ed 1 minutou",
            future: "za 1 minutu"
        },
        few: {
            regular: "{{count}} minuty",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minuty"
        },
        many: {
            regular: "{{count}} minut",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minut"
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 hodinou",
            future: "p\u0159ibli\u017En\u011B za 1 hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: "1 hodina",
            past: "p\u0159ed 1 hodinou",
            future: "za 1 hodinu"
        },
        few: {
            regular: "{{count}} hodiny",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodiny"
        },
        many: {
            regular: "{{count}} hodin",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodin"
        }
    },
    xDays: {
        one: {
            regular: "1 den",
            past: "p\u0159ed 1 dnem",
            future: "za 1 den"
        },
        few: {
            regular: "{{count}} dny",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dny"
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za 1 t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "1 t\xfdden",
            past: "p\u0159ed 1 t\xfddnem",
            future: "za 1 t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "1 m\u011Bs\xedc",
            past: "p\u0159ed 1 m\u011Bs\xedcem",
            future: "za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 rokem",
            future: "p\u0159ibli\u017En\u011B za 1 rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: "1 rok",
            past: "p\u0159ed 1 rokem",
            future: "za 1 rok"
        },
        few: {
            regular: "{{count}} roky",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} roky"
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E 1 rok",
            past: "p\u0159ed v\xedce ne\u017E 1 rokem",
            future: "za v\xedce ne\u017E 1 rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: "skoro 1 rok",
            past: "skoro p\u0159ed 1 rokem",
            future: "skoro za 1 rok"
        },
        few: {
            regular: "skoro {{count}} roky",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} roky"
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
const $7850d3bcaa51217f$var$formatDistance = (token, count, options)=>{
    let pluralResult;
    const tokenValue = $7850d3bcaa51217f$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === "other") pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    const suffixExist = options?.addSuffix === true;
    const comparison = options?.comparison;
    let timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace("{{count}}", String(count));
};
$7850d3bcaa51217f$export$2c14ff85d6318973 = $7850d3bcaa51217f$var$formatDistance;


var $3556d793f9c32ebd$export$cbf60ecb96cbb82f;
"use strict";
$3556d793f9c32ebd$export$cbf60ecb96cbb82f = void 0;

const $3556d793f9c32ebd$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy",
    long: "d. MMMM yyyy",
    medium: "d. M. yyyy",
    short: "dd.MM.yyyy"
};
const $3556d793f9c32ebd$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $3556d793f9c32ebd$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3556d793f9c32ebd$var$formatLong = $3556d793f9c32ebd$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3556d793f9c32ebd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3556d793f9c32ebd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3556d793f9c32ebd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $ca4afec504e770ae$export$8fbbfd65594f46a0;
"use strict";
$ca4afec504e770ae$export$8fbbfd65594f46a0 = void 0;
const $ca4afec504e770ae$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    "sobotu"
];
const $ca4afec504e770ae$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        return "'v " + $ca4afec504e770ae$var$accusativeWeekdays[day] + " o' p";
    },
    other: "P"
};
const $ca4afec504e770ae$var$formatRelative = (token, date)=>{
    const format = $ca4afec504e770ae$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$ca4afec504e770ae$export$8fbbfd65594f46a0 = $ca4afec504e770ae$var$formatRelative;


var $31ee12506c49e808$export$b3bd0bc58e36cd63;
"use strict";
$31ee12506c49e808$export$b3bd0bc58e36cd63 = void 0;

const $31ee12506c49e808$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        "n. l."
    ],
    abbreviated: [
        "p\u0159. n. l.",
        "n. l."
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
const $31ee12506c49e808$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
const $31ee12506c49e808$var$monthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "leden",
        "\xfanor",
        "b\u0159ezen",
        "duben",
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        "srpen",
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        "listopad",
        "prosinec"
    ]
};
const $31ee12506c49e808$var$formattingMonthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "ledna",
        "\xfanora",
        "b\u0159ezna",
        "dubna",
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        "srpna",
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        "listopadu",
        "prosince"
    ]
};
const $31ee12506c49e808$var$dayValues = {
    narrow: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    short: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    abbreviated: [
        "ned",
        "pon",
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        "sob"
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        "sobota"
    ]
};
const $31ee12506c49e808$var$dayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $31ee12506c49e808$var$formattingDayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $31ee12506c49e808$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $31ee12506c49e808$var$localize = $31ee12506c49e808$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $31ee12506c49e808$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $31ee12506c49e808$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $31ee12506c49e808$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $31ee12506c49e808$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $31ee12506c49e808$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $31ee12506c49e808$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $31ee12506c49e808$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $31ee12506c49e808$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $d5fae68d89e4f945$export$4659b591c19bdf3d;
"use strict";
$d5fae68d89e4f945$export$4659b591c19bdf3d = void 0;


const $d5fae68d89e4f945$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $d5fae68d89e4f945$var$parseOrdinalNumberPattern = /\d+/i;
const $d5fae68d89e4f945$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
const $d5fae68d89e4f945$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
const $d5fae68d89e4f945$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
const $d5fae68d89e4f945$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d5fae68d89e4f945$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
const $d5fae68d89e4f945$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
const $d5fae68d89e4f945$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
const $d5fae68d89e4f945$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
const $d5fae68d89e4f945$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
const $d5fae68d89e4f945$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
const $d5fae68d89e4f945$var$match = $d5fae68d89e4f945$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $d5fae68d89e4f945$var$matchOrdinalNumberPattern,
        parsePattern: $d5fae68d89e4f945$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d5fae68d89e4f945$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5fae68d89e4f945$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d5fae68d89e4f945$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5fae68d89e4f945$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d5fae68d89e4f945$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5fae68d89e4f945$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d5fae68d89e4f945$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d5fae68d89e4f945$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d5fae68d89e4f945$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d5fae68d89e4f945$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus](https://github.com/davidrus)
 * @author Pavel Hrách [@SilenY](https://github.com/SilenY)
 * @author Jozef Bíroš [@JozefBiros](https://github.com/JozefBiros)
 */ const $98fc3d813bebdf2b$var$cs = $98fc3d813bebdf2b$export$bde1ed0f60b38f2f = {
    code: "cs",
    formatDistance: $7850d3bcaa51217f$export$2c14ff85d6318973,
    formatLong: $3556d793f9c32ebd$export$cbf60ecb96cbb82f,
    formatRelative: $ca4afec504e770ae$export$8fbbfd65594f46a0,
    localize: $31ee12506c49e808$export$b3bd0bc58e36cd63,
    match: $d5fae68d89e4f945$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($98fc3d813bebdf2b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $98fc3d813bebdf2b$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $98fc3d813bebdf2b$exports[key];
        }
    });
});
var $5d5a721ea6b0d75f$exports = {};

$parcel$export($5d5a721ea6b0d75f$exports, "cy", () => $5d5a721ea6b0d75f$export$aea64bc1b6f8f415, (v) => $5d5a721ea6b0d75f$export$aea64bc1b6f8f415 = v);
var $5d5a721ea6b0d75f$export$aea64bc1b6f8f415;
"use strict";
$5d5a721ea6b0d75f$export$aea64bc1b6f8f415 = void 0;
var $96af8c23d3895ed4$export$2c14ff85d6318973;
"use strict";
$96af8c23d3895ed4$export$2c14ff85d6318973 = void 0;
const $96af8c23d3895ed4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "llai na eiliad",
        other: "llai na {{count}} eiliad"
    },
    xSeconds: {
        one: "1 eiliad",
        other: "{{count}} eiliad"
    },
    halfAMinute: "hanner munud",
    lessThanXMinutes: {
        one: "llai na munud",
        two: "llai na 2 funud",
        other: "llai na {{count}} munud"
    },
    xMinutes: {
        one: "1 munud",
        two: "2 funud",
        other: "{{count}} munud"
    },
    aboutXHours: {
        one: "tua 1 awr",
        other: "tua {{count}} awr"
    },
    xHours: {
        one: "1 awr",
        other: "{{count}} awr"
    },
    xDays: {
        one: "1 diwrnod",
        two: "2 ddiwrnod",
        other: "{{count}} diwrnod"
    },
    aboutXWeeks: {
        one: "tua 1 wythnos",
        two: "tua pythefnos",
        other: "tua {{count}} wythnos"
    },
    xWeeks: {
        one: "1 wythnos",
        two: "pythefnos",
        other: "{{count}} wythnos"
    },
    aboutXMonths: {
        one: "tua 1 mis",
        two: "tua 2 fis",
        other: "tua {{count}} mis"
    },
    xMonths: {
        one: "1 mis",
        two: "2 fis",
        other: "{{count}} mis"
    },
    aboutXYears: {
        one: "tua 1 flwyddyn",
        two: "tua 2 flynedd",
        other: "tua {{count}} mlynedd"
    },
    xYears: {
        one: "1 flwyddyn",
        two: "2 flynedd",
        other: "{{count}} mlynedd"
    },
    overXYears: {
        one: "dros 1 flwyddyn",
        two: "dros 2 flynedd",
        other: "dros {{count}} mlynedd"
    },
    almostXYears: {
        one: "bron 1 flwyddyn",
        two: "bron 2 flynedd",
        other: "bron {{count}} mlynedd"
    }
};
const $96af8c23d3895ed4$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $96af8c23d3895ed4$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "mewn " + result;
        else return result + " yn \xf4l";
    }
    return result;
};
$96af8c23d3895ed4$export$2c14ff85d6318973 = $96af8c23d3895ed4$var$formatDistance;


var $165ee46943228f2f$export$cbf60ecb96cbb82f;
"use strict";
$165ee46943228f2f$export$cbf60ecb96cbb82f = void 0;

const $165ee46943228f2f$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $165ee46943228f2f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $165ee46943228f2f$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $165ee46943228f2f$var$formatLong = $165ee46943228f2f$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $165ee46943228f2f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $165ee46943228f2f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $165ee46943228f2f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $eae7ff629fd448b6$export$8fbbfd65594f46a0;
"use strict";
$eae7ff629fd448b6$export$8fbbfd65594f46a0 = void 0;
const $eae7ff629fd448b6$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: "P"
};
const $eae7ff629fd448b6$var$formatRelative = (token, _date, _baseDate, _options)=>$eae7ff629fd448b6$var$formatRelativeLocale[token];
$eae7ff629fd448b6$export$8fbbfd65594f46a0 = $eae7ff629fd448b6$var$formatRelative;


var $c0ebb239895b5968$export$b3bd0bc58e36cd63;
"use strict";
$c0ebb239895b5968$export$b3bd0bc58e36cd63 = void 0;

const $c0ebb239895b5968$var$eraValues = {
    narrow: [
        "C",
        "O"
    ],
    abbreviated: [
        "CC",
        "OC"
    ],
    wide: [
        "Cyn Crist",
        "Ar \xf4l Crist"
    ]
};
const $c0ebb239895b5968$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Ch1",
        "Ch2",
        "Ch3",
        "Ch4"
    ],
    wide: [
        "Chwarter 1af",
        "2ail chwarter",
        "3ydd chwarter",
        "4ydd chwarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $c0ebb239895b5968$var$monthValues = {
    narrow: [
        "I",
        "Ch",
        "Ma",
        "E",
        "Mi",
        "Me",
        "G",
        "A",
        "Md",
        "H",
        "T",
        "Rh"
    ],
    abbreviated: [
        "Ion",
        "Chwe",
        "Maw",
        "Ebr",
        "Mai",
        "Meh",
        "Gor",
        "Aws",
        "Med",
        "Hyd",
        "Tach",
        "Rhag"
    ],
    wide: [
        "Ionawr",
        "Chwefror",
        "Mawrth",
        "Ebrill",
        "Mai",
        "Mehefin",
        "Gorffennaf",
        "Awst",
        "Medi",
        "Hydref",
        "Tachwedd",
        "Rhagfyr"
    ]
};
const $c0ebb239895b5968$var$dayValues = {
    narrow: [
        "S",
        "Ll",
        "M",
        "M",
        "I",
        "G",
        "S"
    ],
    short: [
        "Su",
        "Ll",
        "Ma",
        "Me",
        "Ia",
        "Gw",
        "Sa"
    ],
    abbreviated: [
        "Sul",
        "Llun",
        "Maw",
        "Mer",
        "Iau",
        "Gwe",
        "Sad"
    ],
    wide: [
        "dydd Sul",
        "dydd Llun",
        "dydd Mawrth",
        "dydd Mercher",
        "dydd Iau",
        "dydd Gwener",
        "dydd Sadwrn"
    ]
};
const $c0ebb239895b5968$var$dayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    }
};
const $c0ebb239895b5968$var$formattingDayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    }
};
const $c0ebb239895b5968$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + "fed";
        case 1:
            return number + "af";
        case 2:
            return number + "ail";
        case 3:
        case 4:
            return number + "ydd";
        case 5:
        case 6:
            return number + "ed";
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + "fed";
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + "eg";
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + "fed";
    return number + "ain";
};
const $c0ebb239895b5968$var$localize = $c0ebb239895b5968$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c0ebb239895b5968$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c0ebb239895b5968$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c0ebb239895b5968$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c0ebb239895b5968$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c0ebb239895b5968$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c0ebb239895b5968$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c0ebb239895b5968$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $339374ecfdd854a3$export$4659b591c19bdf3d;
"use strict";
$339374ecfdd854a3$export$4659b591c19bdf3d = void 0;


const $339374ecfdd854a3$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
const $339374ecfdd854a3$var$parseOrdinalNumberPattern = /\d+/i;
const $339374ecfdd854a3$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
const $339374ecfdd854a3$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
const $339374ecfdd854a3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
const $339374ecfdd854a3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $339374ecfdd854a3$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
const $339374ecfdd854a3$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
const $339374ecfdd854a3$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
const $339374ecfdd854a3$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
const $339374ecfdd854a3$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
const $339374ecfdd854a3$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
const $339374ecfdd854a3$var$match = $339374ecfdd854a3$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $339374ecfdd854a3$var$matchOrdinalNumberPattern,
        parsePattern: $339374ecfdd854a3$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $339374ecfdd854a3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $339374ecfdd854a3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $339374ecfdd854a3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $339374ecfdd854a3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $339374ecfdd854a3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $339374ecfdd854a3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $339374ecfdd854a3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $339374ecfdd854a3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $339374ecfdd854a3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $339374ecfdd854a3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo](https://github.com/elmomalmo)
 */ const $5d5a721ea6b0d75f$var$cy = $5d5a721ea6b0d75f$export$aea64bc1b6f8f415 = {
    code: "cy",
    formatDistance: $96af8c23d3895ed4$export$2c14ff85d6318973,
    formatLong: $165ee46943228f2f$export$cbf60ecb96cbb82f,
    formatRelative: $eae7ff629fd448b6$export$8fbbfd65594f46a0,
    localize: $c0ebb239895b5968$export$b3bd0bc58e36cd63,
    match: $339374ecfdd854a3$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($5d5a721ea6b0d75f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $5d5a721ea6b0d75f$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $5d5a721ea6b0d75f$exports[key];
        }
    });
});
var $a085411bb6f73312$exports = {};

$parcel$export($a085411bb6f73312$exports, "da", () => $a085411bb6f73312$export$8c8450b83b664ba4, (v) => $a085411bb6f73312$export$8c8450b83b664ba4 = v);
var $a085411bb6f73312$export$8c8450b83b664ba4;
"use strict";
$a085411bb6f73312$export$8c8450b83b664ba4 = void 0;
var $1806dcdaedb3dbc3$export$2c14ff85d6318973;
"use strict";
$1806dcdaedb3dbc3$export$2c14ff85d6318973 = void 0;
const $1806dcdaedb3dbc3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: "mindre end {{count}} minutter"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "cirka 1 time",
        other: "cirka {{count}} timer"
    },
    xHours: {
        one: "1 time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dage"
    },
    aboutXWeeks: {
        one: "cirka 1 uge",
        other: "cirka {{count}} uger"
    },
    xWeeks: {
        one: "1 uge",
        other: "{{count}} uger"
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
const $1806dcdaedb3dbc3$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $1806dcdaedb3dbc3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
$1806dcdaedb3dbc3$export$2c14ff85d6318973 = $1806dcdaedb3dbc3$var$formatDistance;


var $fa85c4251aba34fe$export$cbf60ecb96cbb82f;
"use strict";
$fa85c4251aba34fe$export$cbf60ecb96cbb82f = void 0;

const $fa85c4251aba34fe$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
};
const $fa85c4251aba34fe$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $fa85c4251aba34fe$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $fa85c4251aba34fe$var$formatLong = $fa85c4251aba34fe$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fa85c4251aba34fe$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fa85c4251aba34fe$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fa85c4251aba34fe$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $33bd6ba973c24219$export$8fbbfd65594f46a0;
"use strict";
$33bd6ba973c24219$export$8fbbfd65594f46a0 = void 0;
const $33bd6ba973c24219$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: "P"
};
const $33bd6ba973c24219$var$formatRelative = (token, _date, _baseDate, _options)=>$33bd6ba973c24219$var$formatRelativeLocale[token];
$33bd6ba973c24219$export$8fbbfd65594f46a0 = $33bd6ba973c24219$var$formatRelative;


var $9b7968c0aaa49102$export$b3bd0bc58e36cd63;
"use strict";
$9b7968c0aaa49102$export$b3bd0bc58e36cd63 = void 0;

const $9b7968c0aaa49102$var$eraValues = {
    narrow: [
        "fvt",
        "vt"
    ],
    abbreviated: [
        "f.v.t.",
        "v.t."
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        "vesterlandsk tidsregning"
    ]
};
const $9b7968c0aaa49102$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. kvt.",
        "2. kvt.",
        "3. kvt.",
        "4. kvt."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $9b7968c0aaa49102$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
const $9b7968c0aaa49102$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        "man.",
        "tir.",
        "ons.",
        "tor.",
        "fre.",
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $9b7968c0aaa49102$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    }
};
const $9b7968c0aaa49102$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    }
};
const $9b7968c0aaa49102$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $9b7968c0aaa49102$var$localize = $9b7968c0aaa49102$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9b7968c0aaa49102$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9b7968c0aaa49102$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9b7968c0aaa49102$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9b7968c0aaa49102$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9b7968c0aaa49102$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9b7968c0aaa49102$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9b7968c0aaa49102$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $c010942fa47f8ca2$export$4659b591c19bdf3d;
"use strict";
$c010942fa47f8ca2$export$4659b591c19bdf3d = void 0;


const $c010942fa47f8ca2$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $c010942fa47f8ca2$var$parseOrdinalNumberPattern = /\d+/i;
const $c010942fa47f8ca2$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
const $c010942fa47f8ca2$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
const $c010942fa47f8ca2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
const $c010942fa47f8ca2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c010942fa47f8ca2$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
const $c010942fa47f8ca2$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $c010942fa47f8ca2$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $c010942fa47f8ca2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $c010942fa47f8ca2$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
const $c010942fa47f8ca2$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
const $c010942fa47f8ca2$var$match = $c010942fa47f8ca2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $c010942fa47f8ca2$var$matchOrdinalNumberPattern,
        parsePattern: $c010942fa47f8ca2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c010942fa47f8ca2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c010942fa47f8ca2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c010942fa47f8ca2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c010942fa47f8ca2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c010942fa47f8ca2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c010942fa47f8ca2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c010942fa47f8ca2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c010942fa47f8ca2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c010942fa47f8ca2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c010942fa47f8ca2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg](https://github.com/MathiasKandelborg)
 * @author Anders B. Hansen [@Andersbiha](https://github.com/Andersbiha)
 * @author [@kgram](https://github.com/kgram)
 * @author [@stefanbugge](https://github.com/stefanbugge)
 */ const $a085411bb6f73312$var$da = $a085411bb6f73312$export$8c8450b83b664ba4 = {
    code: "da",
    formatDistance: $1806dcdaedb3dbc3$export$2c14ff85d6318973,
    formatLong: $fa85c4251aba34fe$export$cbf60ecb96cbb82f,
    formatRelative: $33bd6ba973c24219$export$8fbbfd65594f46a0,
    localize: $9b7968c0aaa49102$export$b3bd0bc58e36cd63,
    match: $c010942fa47f8ca2$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($a085411bb6f73312$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $a085411bb6f73312$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $a085411bb6f73312$exports[key];
        }
    });
});
var $d4f04f6f37be1a8a$exports = {};

$parcel$export($d4f04f6f37be1a8a$exports, "de", () => $d4f04f6f37be1a8a$export$2fa162a495d26869, (v) => $d4f04f6f37be1a8a$export$2fa162a495d26869 = v);
var $d4f04f6f37be1a8a$export$2fa162a495d26869;
"use strict";
$d4f04f6f37be1a8a$export$2fa162a495d26869 = void 0;
var $f5c6b64dc6039bc1$export$2c14ff85d6318973;
"use strict";
$f5c6b64dc6039bc1$export$2c14ff85d6318973 = void 0;
const $f5c6b64dc6039bc1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "eine halbe Minute",
        withPreposition: "einer halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
const $f5c6b64dc6039bc1$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $f5c6b64dc6039bc1$var$formatDistanceLocale[token].withPreposition : $f5c6b64dc6039bc1$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};
$f5c6b64dc6039bc1$export$2c14ff85d6318973 = $f5c6b64dc6039bc1$var$formatDistance;


var $2328aee2ad172a6a$export$cbf60ecb96cbb82f;
"use strict";
$2328aee2ad172a6a$export$cbf60ecb96cbb82f = void 0;

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $2328aee2ad172a6a$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $2328aee2ad172a6a$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $2328aee2ad172a6a$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $2328aee2ad172a6a$var$formatLong = $2328aee2ad172a6a$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $2328aee2ad172a6a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $2328aee2ad172a6a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $2328aee2ad172a6a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $79fadec28801463a$export$8fbbfd65594f46a0;
"use strict";
$79fadec28801463a$export$8fbbfd65594f46a0 = void 0;
const $79fadec28801463a$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $79fadec28801463a$var$formatRelative = (token, _date, _baseDate, _options)=>$79fadec28801463a$var$formatRelativeLocale[token];
$79fadec28801463a$export$8fbbfd65594f46a0 = $79fadec28801463a$var$formatRelative;


var $1784306157e95058$export$b3bd0bc58e36cd63;
"use strict";
$1784306157e95058$export$b3bd0bc58e36cd63 = void 0;

const $1784306157e95058$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $1784306157e95058$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $1784306157e95058$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const $1784306157e95058$var$formattingMonthValues = {
    narrow: $1784306157e95058$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $1784306157e95058$var$monthValues.wide
};
const $1784306157e95058$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $1784306157e95058$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $1784306157e95058$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $1784306157e95058$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $1784306157e95058$var$localize = $1784306157e95058$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1784306157e95058$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1784306157e95058$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1784306157e95058$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1784306157e95058$var$monthValues,
        formattingValues: $1784306157e95058$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1784306157e95058$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1784306157e95058$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1784306157e95058$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $82ce090398e88647$export$4659b591c19bdf3d;
"use strict";
$82ce090398e88647$export$4659b591c19bdf3d = void 0;


const $82ce090398e88647$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $82ce090398e88647$var$parseOrdinalNumberPattern = /\d+/i;
const $82ce090398e88647$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
const $82ce090398e88647$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $82ce090398e88647$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $82ce090398e88647$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $82ce090398e88647$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
const $82ce090398e88647$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $82ce090398e88647$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
const $82ce090398e88647$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $82ce090398e88647$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
const $82ce090398e88647$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        evening: /abends/i,
        night: /nachts/i
    }
};
const $82ce090398e88647$var$match = $82ce090398e88647$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $82ce090398e88647$var$matchOrdinalNumberPattern,
        parsePattern: $82ce090398e88647$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $82ce090398e88647$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82ce090398e88647$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $82ce090398e88647$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82ce090398e88647$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $82ce090398e88647$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82ce090398e88647$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $82ce090398e88647$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82ce090398e88647$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $82ce090398e88647$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82ce090398e88647$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Asia [@asia-t](https://github.com/asia-t)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author RomanErnst [@pex](https://github.com/pex)
 * @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
 */ const $d4f04f6f37be1a8a$var$de = $d4f04f6f37be1a8a$export$2fa162a495d26869 = {
    code: "de",
    formatDistance: $f5c6b64dc6039bc1$export$2c14ff85d6318973,
    formatLong: $2328aee2ad172a6a$export$cbf60ecb96cbb82f,
    formatRelative: $79fadec28801463a$export$8fbbfd65594f46a0,
    localize: $1784306157e95058$export$b3bd0bc58e36cd63,
    match: $82ce090398e88647$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($d4f04f6f37be1a8a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $d4f04f6f37be1a8a$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $d4f04f6f37be1a8a$exports[key];
        }
    });
});
var $175e5efa7da7aef9$exports = {};

$parcel$export($175e5efa7da7aef9$exports, "deAT", () => $175e5efa7da7aef9$export$4de28f36c5657e35, (v) => $175e5efa7da7aef9$export$4de28f36c5657e35 = v);
var $175e5efa7da7aef9$export$4de28f36c5657e35;
"use strict";
$175e5efa7da7aef9$export$4de28f36c5657e35 = void 0;




var $dcfc4deb2515bb86$export$b3bd0bc58e36cd63;
"use strict";
$dcfc4deb2515bb86$export$b3bd0bc58e36cd63 = void 0;

const $dcfc4deb2515bb86$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
const $dcfc4deb2515bb86$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $dcfc4deb2515bb86$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "J\xe4n",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "J\xe4nner",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
const $dcfc4deb2515bb86$var$formattingMonthValues = {
    narrow: $dcfc4deb2515bb86$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $dcfc4deb2515bb86$var$monthValues.wide
};
const $dcfc4deb2515bb86$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const $dcfc4deb2515bb86$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
const $dcfc4deb2515bb86$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
const $dcfc4deb2515bb86$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $dcfc4deb2515bb86$var$localize = $dcfc4deb2515bb86$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $dcfc4deb2515bb86$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $dcfc4deb2515bb86$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $dcfc4deb2515bb86$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $dcfc4deb2515bb86$var$monthValues,
        formattingValues: $dcfc4deb2515bb86$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $dcfc4deb2515bb86$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $dcfc4deb2515bb86$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $dcfc4deb2515bb86$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


/**
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein](https://github.com/cstenglein)
 */ const $175e5efa7da7aef9$var$deAT = $175e5efa7da7aef9$export$4de28f36c5657e35 = {
    code: "de-AT",
    formatDistance: $f5c6b64dc6039bc1$export$2c14ff85d6318973,
    formatLong: $2328aee2ad172a6a$export$cbf60ecb96cbb82f,
    formatRelative: $79fadec28801463a$export$8fbbfd65594f46a0,
    localize: $dcfc4deb2515bb86$export$b3bd0bc58e36cd63,
    match: $82ce090398e88647$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($175e5efa7da7aef9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $175e5efa7da7aef9$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $175e5efa7da7aef9$exports[key];
        }
    });
});
var $792b6b7ee2aa3be0$exports = {};

$parcel$export($792b6b7ee2aa3be0$exports, "el", () => $792b6b7ee2aa3be0$export$c3da0dad1b44eea9, (v) => $792b6b7ee2aa3be0$export$c3da0dad1b44eea9 = v);
var $792b6b7ee2aa3be0$export$c3da0dad1b44eea9;
"use strict";
$792b6b7ee2aa3be0$export$c3da0dad1b44eea9 = void 0;
var $81290a68062f796d$export$2c14ff85d6318973;
"use strict";
$81290a68062f796d$export$2c14ff85d6318973 = void 0;
const $81290a68062f796d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
const $81290a68062f796d$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $81290a68062f796d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
$81290a68062f796d$export$2c14ff85d6318973 = $81290a68062f796d$var$formatDistance;


var $f80dfa394e590256$export$cbf60ecb96cbb82f;
"use strict";
$f80dfa394e590256$export$cbf60ecb96cbb82f = void 0;

const $f80dfa394e590256$var$dateFormats = {
    full: "EEEE, d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "d/M/yy"
};
const $f80dfa394e590256$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $f80dfa394e590256$var$dateTimeFormats = {
    full: "{{date}} - {{time}}",
    long: "{{date}} - {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f80dfa394e590256$var$formatLong = $f80dfa394e590256$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f80dfa394e590256$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f80dfa394e590256$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f80dfa394e590256$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $07302169ef5dd2cf$export$8fbbfd65594f46a0;
"use strict";
$07302169ef5dd2cf$export$8fbbfd65594f46a0 = void 0;
const $07302169ef5dd2cf$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 6:
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: "P"
};
const $07302169ef5dd2cf$var$formatRelative = (token, date)=>{
    const format = $07302169ef5dd2cf$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$07302169ef5dd2cf$export$8fbbfd65594f46a0 = $07302169ef5dd2cf$var$formatRelative;


var $b580c4d1d4c05d25$export$b3bd0bc58e36cd63;
"use strict";
$b580c4d1d4c05d25$export$b3bd0bc58e36cd63 = void 0;

const $b580c4d1d4c05d25$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
const $b580c4d1d4c05d25$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
const $b580c4d1d4c05d25$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
const $b580c4d1d4c05d25$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
const $b580c4d1d4c05d25$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        "T",
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
const $b580c4d1d4c05d25$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
const $b580c4d1d4c05d25$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let suffix;
    if (unit === "year" || unit === "month") suffix = "\u03BF\u03C2";
    else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
const $b580c4d1d4c05d25$var$localize = $b580c4d1d4c05d25$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b580c4d1d4c05d25$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b580c4d1d4c05d25$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b580c4d1d4c05d25$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b580c4d1d4c05d25$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b580c4d1d4c05d25$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b580c4d1d4c05d25$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b580c4d1d4c05d25$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $fd7f83bceb834edf$export$4659b591c19bdf3d;
"use strict";
$fd7f83bceb834edf$export$4659b591c19bdf3d = void 0;


const $fd7f83bceb834edf$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
const $fd7f83bceb834edf$var$parseOrdinalNumberPattern = /\d+/i;
const $fd7f83bceb834edf$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
const $fd7f83bceb834edf$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
const $fd7f83bceb834edf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
const $fd7f83bceb834edf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $fd7f83bceb834edf$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
const $fd7f83bceb834edf$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
const $fd7f83bceb834edf$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
const $fd7f83bceb834edf$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
const $fd7f83bceb834edf$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
const $fd7f83bceb834edf$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
const $fd7f83bceb834edf$var$match = $fd7f83bceb834edf$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $fd7f83bceb834edf$var$matchOrdinalNumberPattern,
        parsePattern: $fd7f83bceb834edf$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7f83bceb834edf$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7f83bceb834edf$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7f83bceb834edf$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7f83bceb834edf$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7f83bceb834edf$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7f83bceb834edf$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7f83bceb834edf$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7f83bceb834edf$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7f83bceb834edf$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fd7f83bceb834edf$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk](https://github.com/fanixk)
 * @author Theodoros Orfanidis [@teoulas](https://github.com/teoulas)
 */ const $792b6b7ee2aa3be0$var$el = $792b6b7ee2aa3be0$export$c3da0dad1b44eea9 = {
    code: "el",
    formatDistance: $81290a68062f796d$export$2c14ff85d6318973,
    formatLong: $f80dfa394e590256$export$cbf60ecb96cbb82f,
    formatRelative: $07302169ef5dd2cf$export$8fbbfd65594f46a0,
    localize: $b580c4d1d4c05d25$export$b3bd0bc58e36cd63,
    match: $fd7f83bceb834edf$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($792b6b7ee2aa3be0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $792b6b7ee2aa3be0$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $792b6b7ee2aa3be0$exports[key];
        }
    });
});
var $65352444dab5906d$exports = {};

$parcel$export($65352444dab5906d$exports, "enAU", () => $65352444dab5906d$export$6f7b98a3ca24eeee, (v) => $65352444dab5906d$export$6f7b98a3ca24eeee = v);
var $65352444dab5906d$export$6f7b98a3ca24eeee;
"use strict";
$65352444dab5906d$export$6f7b98a3ca24eeee = void 0;

var $fdd94cd347d7b5f4$export$cbf60ecb96cbb82f;
"use strict";
$fdd94cd347d7b5f4$export$cbf60ecb96cbb82f = void 0;

const $fdd94cd347d7b5f4$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $fdd94cd347d7b5f4$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $fdd94cd347d7b5f4$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fdd94cd347d7b5f4$var$formatLong = $fdd94cd347d7b5f4$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fdd94cd347d7b5f4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fdd94cd347d7b5f4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fdd94cd347d7b5f4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};





/**
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige](https://github.com/JulienMalige)
 */ const $65352444dab5906d$var$enAU = $65352444dab5906d$export$6f7b98a3ca24eeee = {
    code: "en-AU",
    formatDistance: $26a15732792bd3bc$export$2c14ff85d6318973,
    formatLong: $fdd94cd347d7b5f4$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($65352444dab5906d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $65352444dab5906d$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $65352444dab5906d$exports[key];
        }
    });
});
var $a9407aed64768bc2$exports = {};

$parcel$export($a9407aed64768bc2$exports, "enCA", () => $a9407aed64768bc2$export$965481d0ea2ba235, (v) => $a9407aed64768bc2$export$965481d0ea2ba235 = v);
var $a9407aed64768bc2$export$965481d0ea2ba235;
"use strict";
$a9407aed64768bc2$export$965481d0ea2ba235 = void 0;



var $661ca92700db7acd$export$2c14ff85d6318973;
"use strict";
$661ca92700db7acd$export$2c14ff85d6318973 = void 0;
const $661ca92700db7acd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "a second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "a minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about an hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "an hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "a day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about a week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "a week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about a month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "a month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about a year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "a year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over a year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost a year",
        other: "almost {{count}} years"
    }
};
const $661ca92700db7acd$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $661ca92700db7acd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$661ca92700db7acd$export$2c14ff85d6318973 = $661ca92700db7acd$var$formatDistance;


var $aa45a1120940ea46$export$cbf60ecb96cbb82f;
"use strict";
$aa45a1120940ea46$export$cbf60ecb96cbb82f = void 0;

const $aa45a1120940ea46$var$dateFormats = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
};
const $aa45a1120940ea46$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $aa45a1120940ea46$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $aa45a1120940ea46$var$formatLong = $aa45a1120940ea46$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $aa45a1120940ea46$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $aa45a1120940ea46$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $aa45a1120940ea46$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


/**
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak](https://github.com/markowsiak)
 * @author Marco Imperatore [@mimperatore](https://github.com/mimperatore)
 */ const $a9407aed64768bc2$var$enCA = $a9407aed64768bc2$export$965481d0ea2ba235 = {
    code: "en-CA",
    formatDistance: $661ca92700db7acd$export$2c14ff85d6318973,
    formatLong: $aa45a1120940ea46$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($a9407aed64768bc2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $a9407aed64768bc2$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $a9407aed64768bc2$exports[key];
        }
    });
});
var $9cf8f27302f00788$exports = {};

$parcel$export($9cf8f27302f00788$exports, "enGB", () => $9cf8f27302f00788$export$1d08ac19b34481d5, (v) => $9cf8f27302f00788$export$1d08ac19b34481d5 = v);
var $9cf8f27302f00788$export$1d08ac19b34481d5;
"use strict";
$9cf8f27302f00788$export$1d08ac19b34481d5 = void 0;




var $28e8616e87ac55e8$export$cbf60ecb96cbb82f;
"use strict";
$28e8616e87ac55e8$export$cbf60ecb96cbb82f = void 0;

const $28e8616e87ac55e8$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $28e8616e87ac55e8$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $28e8616e87ac55e8$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $28e8616e87ac55e8$var$formatLong = $28e8616e87ac55e8$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $28e8616e87ac55e8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $28e8616e87ac55e8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $28e8616e87ac55e8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


/**
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik](https://github.com/glintik)
 */ const $9cf8f27302f00788$var$enGB = $9cf8f27302f00788$export$1d08ac19b34481d5 = {
    code: "en-GB",
    formatDistance: $26a15732792bd3bc$export$2c14ff85d6318973,
    formatLong: $28e8616e87ac55e8$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($9cf8f27302f00788$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $9cf8f27302f00788$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $9cf8f27302f00788$exports[key];
        }
    });
});
var $e444fa2000ada264$exports = {};

$parcel$export($e444fa2000ada264$exports, "enIE", () => $e444fa2000ada264$export$cc1aa062f801d69e, (v) => $e444fa2000ada264$export$cc1aa062f801d69e = v);
var $e444fa2000ada264$export$cc1aa062f801d69e;
"use strict";
$e444fa2000ada264$export$cc1aa062f801d69e = void 0;





/**
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75](https://github.com/tan75)
 */ const $e444fa2000ada264$var$enIE = $e444fa2000ada264$export$cc1aa062f801d69e = {
    code: "en-IE",
    formatDistance: $26a15732792bd3bc$export$2c14ff85d6318973,
    formatLong: $28e8616e87ac55e8$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($e444fa2000ada264$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $e444fa2000ada264$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $e444fa2000ada264$exports[key];
        }
    });
});
var $1f7d8fc5a640951e$exports = {};

$parcel$export($1f7d8fc5a640951e$exports, "enIN", () => $1f7d8fc5a640951e$export$c9cb94638a6621e, (v) => $1f7d8fc5a640951e$export$c9cb94638a6621e = v);
var $1f7d8fc5a640951e$export$c9cb94638a6621e;
"use strict";
$1f7d8fc5a640951e$export$c9cb94638a6621e = void 0;




var $8516da0cc24786c9$export$cbf60ecb96cbb82f;
"use strict";
$8516da0cc24786c9$export$cbf60ecb96cbb82f = void 0;

const $8516da0cc24786c9$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
};
const $8516da0cc24786c9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $8516da0cc24786c9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $8516da0cc24786c9$var$formatLong = $8516da0cc24786c9$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8516da0cc24786c9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8516da0cc24786c9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8516da0cc24786c9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


/**
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha](https://github.com/gbhasha)
 */ const $1f7d8fc5a640951e$var$enIN = $1f7d8fc5a640951e$export$c9cb94638a6621e = {
    code: "en-IN",
    formatDistance: $26a15732792bd3bc$export$2c14ff85d6318973,
    formatLong: $8516da0cc24786c9$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};


Object.keys($1f7d8fc5a640951e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $1f7d8fc5a640951e$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $1f7d8fc5a640951e$exports[key];
        }
    });
});
var $c28e4e4a64684579$exports = {};

$parcel$export($c28e4e4a64684579$exports, "enNZ", () => $c28e4e4a64684579$export$2bdafeb919fd632b, (v) => $c28e4e4a64684579$export$2bdafeb919fd632b = v);
var $c28e4e4a64684579$export$2bdafeb919fd632b;
"use strict";
$c28e4e4a64684579$export$2bdafeb919fd632b = void 0;




var $3ef618077a0ccad1$export$cbf60ecb96cbb82f;
"use strict";
$3ef618077a0ccad1$export$cbf60ecb96cbb82f = void 0;

const $3ef618077a0ccad1$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $3ef618077a0ccad1$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $3ef618077a0ccad1$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3ef618077a0ccad1$var$formatLong = $3ef618077a0ccad1$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3ef618077a0ccad1$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3ef618077a0ccad1$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3ef618077a0ccad1$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


/**
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact](https://github.com/muntact)
 */ const $c28e4e4a64684579$var$enNZ = $c28e4e4a64684579$export$2bdafeb919fd632b = {
    code: "en-NZ",
    formatDistance: $26a15732792bd3bc$export$2c14ff85d6318973,
    formatLong: $3ef618077a0ccad1$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($c28e4e4a64684579$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $c28e4e4a64684579$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $c28e4e4a64684579$exports[key];
        }
    });
});

Object.keys($b02594bc4c9f5081$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $b02594bc4c9f5081$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $b02594bc4c9f5081$exports[key];
        }
    });
});
var $cd836caf6e90c2e3$exports = {};

$parcel$export($cd836caf6e90c2e3$exports, "enZA", () => $cd836caf6e90c2e3$export$61b66188632c07cb, (v) => $cd836caf6e90c2e3$export$61b66188632c07cb = v);
var $cd836caf6e90c2e3$export$61b66188632c07cb;
"use strict";
$cd836caf6e90c2e3$export$61b66188632c07cb = void 0;




var $1d124e7340344bd8$export$cbf60ecb96cbb82f;
"use strict";
$1d124e7340344bd8$export$cbf60ecb96cbb82f = void 0;

const $1d124e7340344bd8$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
};
const $1d124e7340344bd8$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $1d124e7340344bd8$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $1d124e7340344bd8$var$formatLong = $1d124e7340344bd8$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1d124e7340344bd8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1d124e7340344bd8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1d124e7340344bd8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


/**
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav](https://github.com/shaykav)
 */ const $cd836caf6e90c2e3$var$enZA = $cd836caf6e90c2e3$export$61b66188632c07cb = {
    code: "en-ZA",
    formatDistance: $26a15732792bd3bc$export$2c14ff85d6318973,
    formatLong: $1d124e7340344bd8$export$cbf60ecb96cbb82f,
    formatRelative: $6902e30e5f40b039$export$8fbbfd65594f46a0,
    localize: $280713024bd29391$export$b3bd0bc58e36cd63,
    match: $ece9c2ac1beca5d0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};


Object.keys($cd836caf6e90c2e3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $cd836caf6e90c2e3$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $cd836caf6e90c2e3$exports[key];
        }
    });
});
var $f0f8ab21a70b052e$exports = {};

$parcel$export($f0f8ab21a70b052e$exports, "eo", () => $f0f8ab21a70b052e$export$9e6f8948b1b2764c, (v) => $f0f8ab21a70b052e$export$9e6f8948b1b2764c = v);
var $f0f8ab21a70b052e$export$9e6f8948b1b2764c;
"use strict";
$f0f8ab21a70b052e$export$9e6f8948b1b2764c = void 0;
var $f4f4df9949ecde61$export$2c14ff85d6318973;
"use strict";
$f4f4df9949ecde61$export$2c14ff85d6318973 = void 0;
const $f4f4df9949ecde61$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "malpli ol sekundo",
        other: "malpli ol {{count}} sekundoj"
    },
    xSeconds: {
        one: "1 sekundo",
        other: "{{count}} sekundoj"
    },
    halfAMinute: "duonminuto",
    lessThanXMinutes: {
        one: "malpli ol minuto",
        other: "malpli ol {{count}} minutoj"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutoj"
    },
    aboutXHours: {
        one: "proksimume 1 horo",
        other: "proksimume {{count}} horoj"
    },
    xHours: {
        one: "1 horo",
        other: "{{count}} horoj"
    },
    xDays: {
        one: "1 tago",
        other: "{{count}} tagoj"
    },
    aboutXMonths: {
        one: "proksimume 1 monato",
        other: "proksimume {{count}} monatoj"
    },
    xWeeks: {
        one: "1 semajno",
        other: "{{count}} semajnoj"
    },
    aboutXWeeks: {
        one: "proksimume 1 semajno",
        other: "proksimume {{count}} semajnoj"
    },
    xMonths: {
        one: "1 monato",
        other: "{{count}} monatoj"
    },
    aboutXYears: {
        one: "proksimume 1 jaro",
        other: "proksimume {{count}} jaroj"
    },
    xYears: {
        one: "1 jaro",
        other: "{{count}} jaroj"
    },
    overXYears: {
        one: "pli ol 1 jaro",
        other: "pli ol {{count}} jaroj"
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
const $f4f4df9949ecde61$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f4f4df9949ecde61$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options?.comparison && options.comparison > 0) return "post " + result;
        else return "anta\u016D " + result;
    }
    return result;
};
$f4f4df9949ecde61$export$2c14ff85d6318973 = $f4f4df9949ecde61$var$formatDistance;


var $eee325bcdc1b725c$export$cbf60ecb96cbb82f;
"use strict";
$eee325bcdc1b725c$export$cbf60ecb96cbb82f = void 0;

const $eee325bcdc1b725c$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: "y-MMMM-dd",
    medium: "y-MMM-dd",
    short: "yyyy-MM-dd"
};
const $eee325bcdc1b725c$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $eee325bcdc1b725c$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $eee325bcdc1b725c$var$formatLong = $eee325bcdc1b725c$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $eee325bcdc1b725c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $eee325bcdc1b725c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $eee325bcdc1b725c$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $6f3e77c7917ca9e6$export$8fbbfd65594f46a0;
"use strict";
$6f3e77c7917ca9e6$export$8fbbfd65594f46a0 = void 0;
const $6f3e77c7917ca9e6$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: "P"
};
const $6f3e77c7917ca9e6$var$formatRelative = (token, _date, _baseDate, _options)=>$6f3e77c7917ca9e6$var$formatRelativeLocale[token];
$6f3e77c7917ca9e6$export$8fbbfd65594f46a0 = $6f3e77c7917ca9e6$var$formatRelative;


var $880cc5f5db0dc050$export$b3bd0bc58e36cd63;
"use strict";
$880cc5f5db0dc050$export$b3bd0bc58e36cd63 = void 0;

const $880cc5f5db0dc050$var$eraValues = {
    narrow: [
        "aK",
        "pK"
    ],
    abbreviated: [
        "a.K.E.",
        "p.K.E."
    ],
    wide: [
        "anta\u016D Komuna Erao",
        "Komuna Erao"
    ]
};
const $880cc5f5db0dc050$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1-a kvaronjaro",
        "2-a kvaronjaro",
        "3-a kvaronjaro",
        "4-a kvaronjaro"
    ]
};
const $880cc5f5db0dc050$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "a\u016Dg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januaro",
        "februaro",
        "marto",
        "aprilo",
        "majo",
        "junio",
        "julio",
        "a\u016Dgusto",
        "septembro",
        "oktobro",
        "novembro",
        "decembro"
    ]
};
const $880cc5f5db0dc050$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "\u0134",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "\u0135a",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim",
        "lun",
        "mar",
        "mer",
        "\u0135a\u016D",
        "ven",
        "sab"
    ],
    wide: [
        "diman\u0109o",
        "lundo",
        "mardo",
        "merkredo",
        "\u0135a\u016Ddo",
        "vendredo",
        "sabato"
    ]
};
const $880cc5f5db0dc050$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    abbreviated: {
        am: "a.t.m.",
        pm: "p.t.m.",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: "posttagmeze",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    }
};
const $880cc5f5db0dc050$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    return number + "-a";
};
const $880cc5f5db0dc050$var$localize = $880cc5f5db0dc050$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $880cc5f5db0dc050$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $880cc5f5db0dc050$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $880cc5f5db0dc050$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $880cc5f5db0dc050$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $880cc5f5db0dc050$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $880cc5f5db0dc050$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $e3d9ec1dde70b424$export$4659b591c19bdf3d;
"use strict";
$e3d9ec1dde70b424$export$4659b591c19bdf3d = void 0;


const $e3d9ec1dde70b424$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
const $e3d9ec1dde70b424$var$parseOrdinalNumberPattern = /\d+/i;
const $e3d9ec1dde70b424$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
const $e3d9ec1dde70b424$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
const $e3d9ec1dde70b424$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
const $e3d9ec1dde70b424$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e3d9ec1dde70b424$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
const $e3d9ec1dde70b424$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $e3d9ec1dde70b424$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
const $e3d9ec1dde70b424$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
const $e3d9ec1dde70b424$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
const $e3d9ec1dde70b424$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
const $e3d9ec1dde70b424$var$match = $e3d9ec1dde70b424$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $e3d9ec1dde70b424$var$matchOrdinalNumberPattern,
        parsePattern: $e3d9ec1dde70b424$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3d9ec1dde70b424$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3d9ec1dde70b424$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3d9ec1dde70b424$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3d9ec1dde70b424$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3d9ec1dde70b424$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3d9ec1dde70b424$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3d9ec1dde70b424$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3d9ec1dde70b424$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3d9ec1dde70b424$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3d9ec1dde70b424$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ const $f0f8ab21a70b052e$var$eo = $f0f8ab21a70b052e$export$9e6f8948b1b2764c = {
    code: "eo",
    formatDistance: $f4f4df9949ecde61$export$2c14ff85d6318973,
    formatLong: $eee325bcdc1b725c$export$cbf60ecb96cbb82f,
    formatRelative: $6f3e77c7917ca9e6$export$8fbbfd65594f46a0,
    localize: $880cc5f5db0dc050$export$b3bd0bc58e36cd63,
    match: $e3d9ec1dde70b424$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($f0f8ab21a70b052e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $f0f8ab21a70b052e$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $f0f8ab21a70b052e$exports[key];
        }
    });
});
var $393aa98da32a0bcb$exports = {};

$parcel$export($393aa98da32a0bcb$exports, "es", () => $393aa98da32a0bcb$export$ca5e4045a55e76d2, (v) => $393aa98da32a0bcb$export$ca5e4045a55e76d2 = v);
var $393aa98da32a0bcb$export$ca5e4045a55e76d2;
"use strict";
$393aa98da32a0bcb$export$ca5e4045a55e76d2 = void 0;
var $a0d757a838febf96$export$2c14ff85d6318973;
"use strict";
$a0d757a838febf96$export$2c14ff85d6318973 = void 0;
const $a0d757a838febf96$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
const $a0d757a838febf96$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $a0d757a838febf96$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};
$a0d757a838febf96$export$2c14ff85d6318973 = $a0d757a838febf96$var$formatDistance;


var $d5cd387bf6de5f2c$export$cbf60ecb96cbb82f;
"use strict";
$d5cd387bf6de5f2c$export$cbf60ecb96cbb82f = void 0;

const $d5cd387bf6de5f2c$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $d5cd387bf6de5f2c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $d5cd387bf6de5f2c$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d5cd387bf6de5f2c$var$formatLong = $d5cd387bf6de5f2c$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $d5cd387bf6de5f2c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $d5cd387bf6de5f2c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $d5cd387bf6de5f2c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $96f6202943826218$export$8fbbfd65594f46a0;
"use strict";
$96f6202943826218$export$8fbbfd65594f46a0 = void 0;
const $96f6202943826218$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
const $96f6202943826218$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
const $96f6202943826218$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $96f6202943826218$var$formatRelativeLocalePlural[token];
    else return $96f6202943826218$var$formatRelativeLocale[token];
};
$96f6202943826218$export$8fbbfd65594f46a0 = $96f6202943826218$var$formatRelative;


var $a280fd7edb83233a$export$b3bd0bc58e36cd63;
"use strict";
$a280fd7edb83233a$export$b3bd0bc58e36cd63 = void 0;

const $a280fd7edb83233a$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
const $a280fd7edb83233a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $a280fd7edb83233a$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
const $a280fd7edb83233a$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
const $a280fd7edb83233a$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
const $a280fd7edb83233a$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
const $a280fd7edb83233a$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $a280fd7edb83233a$var$localize = $a280fd7edb83233a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a280fd7edb83233a$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a280fd7edb83233a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a280fd7edb83233a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a280fd7edb83233a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a280fd7edb83233a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a280fd7edb83233a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a280fd7edb83233a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $de239b9790cd4f12$export$4659b591c19bdf3d;
"use strict";
$de239b9790cd4f12$export$4659b591c19bdf3d = void 0;


const $de239b9790cd4f12$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $de239b9790cd4f12$var$parseOrdinalNumberPattern = /\d+/i;
const $de239b9790cd4f12$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
const $de239b9790cd4f12$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
const $de239b9790cd4f12$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $de239b9790cd4f12$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $de239b9790cd4f12$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
const $de239b9790cd4f12$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
const $de239b9790cd4f12$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
const $de239b9790cd4f12$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
const $de239b9790cd4f12$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
const $de239b9790cd4f12$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
const $de239b9790cd4f12$var$match = $de239b9790cd4f12$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $de239b9790cd4f12$var$matchOrdinalNumberPattern,
        parsePattern: $de239b9790cd4f12$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $de239b9790cd4f12$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $de239b9790cd4f12$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $de239b9790cd4f12$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $de239b9790cd4f12$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $de239b9790cd4f12$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $de239b9790cd4f12$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $de239b9790cd4f12$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $de239b9790cd4f12$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $de239b9790cd4f12$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $de239b9790cd4f12$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto](https://github.com/juanangosto)
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Fernando Agüero [@fjaguero](https://github.com/fjaguero)
 * @author Gastón Haro [@harogaston](https://github.com/harogaston)
 * @author Yago Carballo [@YagoCarballo](https://github.com/YagoCarballo)
 */ const $393aa98da32a0bcb$var$es = $393aa98da32a0bcb$export$ca5e4045a55e76d2 = {
    code: "es",
    formatDistance: $a0d757a838febf96$export$2c14ff85d6318973,
    formatLong: $d5cd387bf6de5f2c$export$cbf60ecb96cbb82f,
    formatRelative: $96f6202943826218$export$8fbbfd65594f46a0,
    localize: $a280fd7edb83233a$export$b3bd0bc58e36cd63,
    match: $de239b9790cd4f12$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($393aa98da32a0bcb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $393aa98da32a0bcb$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $393aa98da32a0bcb$exports[key];
        }
    });
});
var $3c92a0f8dd15b531$exports = {};

$parcel$export($3c92a0f8dd15b531$exports, "et", () => $3c92a0f8dd15b531$export$457177dcde8472be, (v) => $3c92a0f8dd15b531$export$457177dcde8472be = v);
var $3c92a0f8dd15b531$export$457177dcde8472be;
"use strict";
$3c92a0f8dd15b531$export$457177dcde8472be = void 0;
var $0398a701f67f9e24$export$2c14ff85d6318973;
"use strict";
$0398a701f67f9e24$export$2c14ff85d6318973 = void 0;
const $0398a701f67f9e24$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: "{{count}} sekundit"
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: "{{count}} sekundi"
        }
    },
    halfAMinute: {
        standalone: "pool minutit",
        withPreposition: "poole minuti"
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: "{{count}} minutit"
        },
        withPreposition: {
            one: "\xfche minuti",
            other: "{{count}} minuti"
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: "umbes {{count}} tundi"
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: "umbes {{count}} tunni"
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: "{{count}} tundi"
        },
        withPreposition: {
            one: "\xfche tunni",
            other: "{{count}} tunni"
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: "umbes {{count}} kuud"
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: "umbes {{count}} kuu"
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: "{{count}} kuud"
        },
        withPreposition: {
            one: "\xfche kuu",
            other: "{{count}} kuu"
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: "umbes {{count}} aastat"
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: "umbes {{count}} aasta"
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: "{{count}} aastat"
        },
        withPreposition: {
            one: "\xfche aasta",
            other: "{{count}} aasta"
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: "rohkem kui {{count}} aastat"
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: "rohkem kui {{count}} aasta"
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: "peaaegu {{count}} aastat"
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: "peaaegu {{count}} aasta"
        }
    }
};
const $0398a701f67f9e24$var$formatDistance = (token, count, options)=>{
    const usageGroup = options?.addSuffix ? $0398a701f67f9e24$var$formatDistanceLocale[token].withPreposition : $0398a701f67f9e24$var$formatDistanceLocale[token].standalone;
    let result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + " eest";
    }
    return result;
};
$0398a701f67f9e24$export$2c14ff85d6318973 = $0398a701f67f9e24$var$formatDistance;


var $26f716dd527acdf9$export$cbf60ecb96cbb82f;
"use strict";
$26f716dd527acdf9$export$cbf60ecb96cbb82f = void 0;

const $26f716dd527acdf9$var$dateFormats = {
    full: "EEEE, d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $26f716dd527acdf9$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $26f716dd527acdf9$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: "{{date}}. {{time}}",
    short: "{{date}}. {{time}}"
};
const $26f716dd527acdf9$var$formatLong = $26f716dd527acdf9$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $26f716dd527acdf9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $26f716dd527acdf9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $26f716dd527acdf9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $86e21a2ae0904486$export$8fbbfd65594f46a0;
"use strict";
$86e21a2ae0904486$export$8fbbfd65594f46a0 = void 0;
const $86e21a2ae0904486$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: "P"
};
const $86e21a2ae0904486$var$formatRelative = (token, _date, _baseDate, _options)=>$86e21a2ae0904486$var$formatRelativeLocale[token];
$86e21a2ae0904486$export$8fbbfd65594f46a0 = $86e21a2ae0904486$var$formatRelative;


var $ed17edad2103b4b1$export$b3bd0bc58e36cd63;
"use strict";
$ed17edad2103b4b1$export$b3bd0bc58e36cd63 = void 0;

const $ed17edad2103b4b1$var$eraValues = {
    narrow: [
        "e.m.a",
        "m.a.j"
    ],
    abbreviated: [
        "e.m.a",
        "m.a.j"
    ],
    wide: [
        "enne meie ajaarvamist",
        "meie ajaarvamise j\xe4rgi"
    ]
};
const $ed17edad2103b4b1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $ed17edad2103b4b1$var$monthValues = {
    narrow: [
        "J",
        "V",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jaan",
        "veebr",
        "m\xe4rts",
        "apr",
        "mai",
        "juuni",
        "juuli",
        "aug",
        "sept",
        "okt",
        "nov",
        "dets"
    ],
    wide: [
        "jaanuar",
        "veebruar",
        "m\xe4rts",
        "aprill",
        "mai",
        "juuni",
        "juuli",
        "august",
        "september",
        "oktoober",
        "november",
        "detsember"
    ]
};
const $ed17edad2103b4b1$var$dayValues = {
    narrow: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    short: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    abbreviated: [
        "p\xfchap.",
        "esmasp.",
        "teisip.",
        "kolmap.",
        "neljap.",
        "reede.",
        "laup."
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        "reede",
        "laup\xe4ev"
    ]
};
const $ed17edad2103b4b1$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
const $ed17edad2103b4b1$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
const $ed17edad2103b4b1$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $ed17edad2103b4b1$var$localize = $ed17edad2103b4b1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ed17edad2103b4b1$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ed17edad2103b4b1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ed17edad2103b4b1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ed17edad2103b4b1$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $ed17edad2103b4b1$var$monthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ed17edad2103b4b1$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $ed17edad2103b4b1$var$dayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ed17edad2103b4b1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ed17edad2103b4b1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $f2e1513a0b6f85bc$export$4659b591c19bdf3d;
"use strict";
$f2e1513a0b6f85bc$export$4659b591c19bdf3d = void 0;


const $f2e1513a0b6f85bc$var$matchOrdinalNumberPattern = /^\d+\./i;
const $f2e1513a0b6f85bc$var$parseOrdinalNumberPattern = /\d+/i;
const $f2e1513a0b6f85bc$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
const $f2e1513a0b6f85bc$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
const $f2e1513a0b6f85bc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $f2e1513a0b6f85bc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $f2e1513a0b6f85bc$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
const $f2e1513a0b6f85bc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $f2e1513a0b6f85bc$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
const $f2e1513a0b6f85bc$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
const $f2e1513a0b6f85bc$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
const $f2e1513a0b6f85bc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
const $f2e1513a0b6f85bc$var$match = $f2e1513a0b6f85bc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $f2e1513a0b6f85bc$var$matchOrdinalNumberPattern,
        parsePattern: $f2e1513a0b6f85bc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f2e1513a0b6f85bc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2e1513a0b6f85bc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f2e1513a0b6f85bc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2e1513a0b6f85bc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f2e1513a0b6f85bc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2e1513a0b6f85bc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f2e1513a0b6f85bc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2e1513a0b6f85bc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f2e1513a0b6f85bc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f2e1513a0b6f85bc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit](https://github.com/priithansen)
 */ const $3c92a0f8dd15b531$var$et = $3c92a0f8dd15b531$export$457177dcde8472be = {
    code: "et",
    formatDistance: $0398a701f67f9e24$export$2c14ff85d6318973,
    formatLong: $26f716dd527acdf9$export$cbf60ecb96cbb82f,
    formatRelative: $86e21a2ae0904486$export$8fbbfd65594f46a0,
    localize: $ed17edad2103b4b1$export$b3bd0bc58e36cd63,
    match: $f2e1513a0b6f85bc$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($3c92a0f8dd15b531$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $3c92a0f8dd15b531$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $3c92a0f8dd15b531$exports[key];
        }
    });
});
var $867bc67e75e016f7$exports = {};

$parcel$export($867bc67e75e016f7$exports, "eu", () => $867bc67e75e016f7$export$2f4e8cc3c5ca4de9, (v) => $867bc67e75e016f7$export$2f4e8cc3c5ca4de9 = v);
var $867bc67e75e016f7$export$2f4e8cc3c5ca4de9;
"use strict";
$867bc67e75e016f7$export$2f4e8cc3c5ca4de9 = void 0;
var $2f314bed05018b76$export$2c14ff85d6318973;
"use strict";
$2f314bed05018b76$export$2c14ff85d6318973 = void 0;
const $2f314bed05018b76$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "segundo bat baino gutxiago",
        other: "{{count}} segundo baino gutxiago"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundo"
    },
    halfAMinute: "minutu erdi",
    lessThanXMinutes: {
        one: "minutu bat baino gutxiago",
        other: "{{count}} minutu baino gutxiago"
    },
    xMinutes: {
        one: "1 minutu",
        other: "{{count}} minutu"
    },
    aboutXHours: {
        one: "1 ordu gutxi gorabehera",
        other: "{{count}} ordu gutxi gorabehera"
    },
    xHours: {
        one: "1 ordu",
        other: "{{count}} ordu"
    },
    xDays: {
        one: "1 egun",
        other: "{{count}} egun"
    },
    aboutXWeeks: {
        one: "aste 1 inguru",
        other: "{{count}} aste inguru"
    },
    xWeeks: {
        one: "1 aste",
        other: "{{count}} astean"
    },
    aboutXMonths: {
        one: "1 hilabete gutxi gorabehera",
        other: "{{count}} hilabete gutxi gorabehera"
    },
    xMonths: {
        one: "1 hilabete",
        other: "{{count}} hilabete"
    },
    aboutXYears: {
        one: "1 urte gutxi gorabehera",
        other: "{{count}} urte gutxi gorabehera"
    },
    xYears: {
        one: "1 urte",
        other: "{{count}} urte"
    },
    overXYears: {
        one: "1 urte baino gehiago",
        other: "{{count}} urte baino gehiago"
    },
    almostXYears: {
        one: "ia 1 urte",
        other: "ia {{count}} urte"
    }
};
const $2f314bed05018b76$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2f314bed05018b76$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "duela " + result;
    }
    return result;
};
$2f314bed05018b76$export$2c14ff85d6318973 = $2f314bed05018b76$var$formatDistance;


var $f255898ad9a5710e$export$cbf60ecb96cbb82f;
"use strict";
$f255898ad9a5710e$export$cbf60ecb96cbb82f = void 0;

const $f255898ad9a5710e$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: "y MMM d",
    short: "yy/MM/dd"
};
const $f255898ad9a5710e$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $f255898ad9a5710e$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f255898ad9a5710e$var$formatLong = $f255898ad9a5710e$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f255898ad9a5710e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f255898ad9a5710e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f255898ad9a5710e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $748989700a823d44$export$8fbbfd65594f46a0;
"use strict";
$748989700a823d44$export$8fbbfd65594f46a0 = void 0;
const $748989700a823d44$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
const $748989700a823d44$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
const $748989700a823d44$var$formatRelative = (token, date)=>{
    if (date.getHours() !== 1) return $748989700a823d44$var$formatRelativeLocalePlural[token];
    return $748989700a823d44$var$formatRelativeLocale[token];
};
$748989700a823d44$export$8fbbfd65594f46a0 = $748989700a823d44$var$formatRelative;


var $7572664ade3234a4$export$b3bd0bc58e36cd63;
"use strict";
$7572664ade3234a4$export$b3bd0bc58e36cd63 = void 0;

const $7572664ade3234a4$var$eraValues = {
    narrow: [
        "k.a.",
        "k.o."
    ],
    abbreviated: [
        "k.a.",
        "k.o."
    ],
    wide: [
        "kristo aurretik",
        "kristo ondoren"
    ]
};
const $7572664ade3234a4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1H",
        "2H",
        "3H",
        "4H"
    ],
    wide: [
        "1. hiruhilekoa",
        "2. hiruhilekoa",
        "3. hiruhilekoa",
        "4. hiruhilekoa"
    ]
};
const $7572664ade3234a4$var$monthValues = {
    narrow: [
        "u",
        "o",
        "m",
        "a",
        "m",
        "e",
        "u",
        "a",
        "i",
        "u",
        "a",
        "a"
    ],
    abbreviated: [
        "urt",
        "ots",
        "mar",
        "api",
        "mai",
        "eka",
        "uzt",
        "abu",
        "ira",
        "urr",
        "aza",
        "abe"
    ],
    wide: [
        "urtarrila",
        "otsaila",
        "martxoa",
        "apirila",
        "maiatza",
        "ekaina",
        "uztaila",
        "abuztua",
        "iraila",
        "urria",
        "azaroa",
        "abendua"
    ]
};
const $7572664ade3234a4$var$dayValues = {
    narrow: [
        "i",
        "a",
        "a",
        "a",
        "o",
        "o",
        "l"
    ],
    short: [
        "ig",
        "al",
        "as",
        "az",
        "og",
        "or",
        "lr"
    ],
    abbreviated: [
        "iga",
        "ast",
        "ast",
        "ast",
        "ost",
        "ost",
        "lar"
    ],
    wide: [
        "igandea",
        "astelehena",
        "asteartea",
        "asteazkena",
        "osteguna",
        "ostirala",
        "larunbata"
    ]
};
const $7572664ade3234a4$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    }
};
const $7572664ade3234a4$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    }
};
const $7572664ade3234a4$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $7572664ade3234a4$var$localize = $7572664ade3234a4$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7572664ade3234a4$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7572664ade3234a4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7572664ade3234a4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7572664ade3234a4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7572664ade3234a4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7572664ade3234a4$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7572664ade3234a4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $80f75804fb0e8074$export$4659b591c19bdf3d;
"use strict";
$80f75804fb0e8074$export$4659b591c19bdf3d = void 0;


const $80f75804fb0e8074$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
const $80f75804fb0e8074$var$parseOrdinalNumberPattern = /\d+/i;
const $80f75804fb0e8074$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
const $80f75804fb0e8074$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
const $80f75804fb0e8074$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
const $80f75804fb0e8074$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $80f75804fb0e8074$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
const $80f75804fb0e8074$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
const $80f75804fb0e8074$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
const $80f75804fb0e8074$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
const $80f75804fb0e8074$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
const $80f75804fb0e8074$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
const $80f75804fb0e8074$var$match = $80f75804fb0e8074$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $80f75804fb0e8074$var$matchOrdinalNumberPattern,
        parsePattern: $80f75804fb0e8074$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f75804fb0e8074$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f75804fb0e8074$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f75804fb0e8074$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f75804fb0e8074$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f75804fb0e8074$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f75804fb0e8074$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f75804fb0e8074$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f75804fb0e8074$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f75804fb0e8074$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $80f75804fb0e8074$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom](https://github.com/JacobSoderblom)
 */ const $867bc67e75e016f7$var$eu = $867bc67e75e016f7$export$2f4e8cc3c5ca4de9 = {
    code: "eu",
    formatDistance: $2f314bed05018b76$export$2c14ff85d6318973,
    formatLong: $f255898ad9a5710e$export$cbf60ecb96cbb82f,
    formatRelative: $748989700a823d44$export$8fbbfd65594f46a0,
    localize: $7572664ade3234a4$export$b3bd0bc58e36cd63,
    match: $80f75804fb0e8074$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($867bc67e75e016f7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $867bc67e75e016f7$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $867bc67e75e016f7$exports[key];
        }
    });
});
var $326b230a7f2e6dc6$exports = {};

$parcel$export($326b230a7f2e6dc6$exports, "faIR", () => $326b230a7f2e6dc6$export$355e05e1e35701f3, (v) => $326b230a7f2e6dc6$export$355e05e1e35701f3 = v);
var $326b230a7f2e6dc6$export$355e05e1e35701f3;
"use strict";
$326b230a7f2e6dc6$export$355e05e1e35701f3 = void 0;
var $b13516fdf367c421$export$2c14ff85d6318973;
"use strict";
$b13516fdf367c421$export$2c14ff85d6318973 = void 0;
const $b13516fdf367c421$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
const $b13516fdf367c421$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b13516fdf367c421$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
$b13516fdf367c421$export$2c14ff85d6318973 = $b13516fdf367c421$var$formatDistance;


var $8d12160c10b3c10b$export$cbf60ecb96cbb82f;
"use strict";
$8d12160c10b3c10b$export$cbf60ecb96cbb82f = void 0;

const $8d12160c10b3c10b$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "yyyy/MM/dd"
};
const $8d12160c10b3c10b$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $8d12160c10b3c10b$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $8d12160c10b3c10b$var$formatLong = $8d12160c10b3c10b$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8d12160c10b3c10b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8d12160c10b3c10b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $8d12160c10b3c10b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $d7c2509eadf0d5f8$export$8fbbfd65594f46a0;
"use strict";
$d7c2509eadf0d5f8$export$8fbbfd65594f46a0 = void 0;
const $d7c2509eadf0d5f8$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: "P"
};
const $d7c2509eadf0d5f8$var$formatRelative = (token, _date, _baseDate, _options)=>$d7c2509eadf0d5f8$var$formatRelativeLocale[token];
$d7c2509eadf0d5f8$export$8fbbfd65594f46a0 = $d7c2509eadf0d5f8$var$formatRelative;


var $c2a86b0201621282$export$b3bd0bc58e36cd63;
"use strict";
$c2a86b0201621282$export$b3bd0bc58e36cd63 = void 0;

const $c2a86b0201621282$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
const $c2a86b0201621282$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $c2a86b0201621282$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
const $c2a86b0201621282$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
const $c2a86b0201621282$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $c2a86b0201621282$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $c2a86b0201621282$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $c2a86b0201621282$var$localize = $c2a86b0201621282$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $c2a86b0201621282$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c2a86b0201621282$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c2a86b0201621282$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c2a86b0201621282$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c2a86b0201621282$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $c2a86b0201621282$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c2a86b0201621282$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $749e4a126a3bef55$export$4659b591c19bdf3d;
"use strict";
$749e4a126a3bef55$export$4659b591c19bdf3d = void 0;


const $749e4a126a3bef55$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $749e4a126a3bef55$var$parseOrdinalNumberPattern = /\d+/i;
const $749e4a126a3bef55$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
const $749e4a126a3bef55$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $749e4a126a3bef55$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
const $749e4a126a3bef55$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $749e4a126a3bef55$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
const $749e4a126a3bef55$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
const $749e4a126a3bef55$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
const $749e4a126a3bef55$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
const $749e4a126a3bef55$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
const $749e4a126a3bef55$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
const $749e4a126a3bef55$var$match = $749e4a126a3bef55$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $749e4a126a3bef55$var$matchOrdinalNumberPattern,
        parsePattern: $749e4a126a3bef55$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $749e4a126a3bef55$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $749e4a126a3bef55$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $749e4a126a3bef55$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $749e4a126a3bef55$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $749e4a126a3bef55$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $749e4a126a3bef55$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $749e4a126a3bef55$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $749e4a126a3bef55$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $749e4a126a3bef55$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $749e4a126a3bef55$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za](https://github.com/mort3za)
 */ const $326b230a7f2e6dc6$var$faIR = $326b230a7f2e6dc6$export$355e05e1e35701f3 = {
    code: "fa-IR",
    formatDistance: $b13516fdf367c421$export$2c14ff85d6318973,
    formatLong: $8d12160c10b3c10b$export$cbf60ecb96cbb82f,
    formatRelative: $d7c2509eadf0d5f8$export$8fbbfd65594f46a0,
    localize: $c2a86b0201621282$export$b3bd0bc58e36cd63,
    match: $749e4a126a3bef55$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($326b230a7f2e6dc6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $326b230a7f2e6dc6$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $326b230a7f2e6dc6$exports[key];
        }
    });
});
var $af5c7676f1c9c755$exports = {};

$parcel$export($af5c7676f1c9c755$exports, "fi", () => $af5c7676f1c9c755$export$ed5179c818622fb, (v) => $af5c7676f1c9c755$export$ed5179c818622fb = v);
var $af5c7676f1c9c755$export$ed5179c818622fb;
"use strict";
$af5c7676f1c9c755$export$ed5179c818622fb = void 0;
var $743ee12d8cfb3dba$export$2c14ff85d6318973;
"use strict";
$743ee12d8cfb3dba$export$2c14ff85d6318973 = void 0;
function $743ee12d8cfb3dba$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, "sekunnin");
}
function $743ee12d8cfb3dba$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, "minuutin");
}
function $743ee12d8cfb3dba$var$futureHours(text) {
    return text.replace(/tuntia?/, "tunnin");
}
function $743ee12d8cfb3dba$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $743ee12d8cfb3dba$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, "viikon");
}
function $743ee12d8cfb3dba$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function $743ee12d8cfb3dba$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, "vuoden");
}
const $743ee12d8cfb3dba$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "alle sekunti",
        other: "alle {{count}} sekuntia",
        futureTense: $743ee12d8cfb3dba$var$futureSeconds
    },
    xSeconds: {
        one: "sekunti",
        other: "{{count}} sekuntia",
        futureTense: $743ee12d8cfb3dba$var$futureSeconds
    },
    halfAMinute: {
        one: "puoli minuuttia",
        other: "puoli minuuttia",
        futureTense: (_text)=>"puolen minuutin"
    },
    lessThanXMinutes: {
        one: "alle minuutti",
        other: "alle {{count}} minuuttia",
        futureTense: $743ee12d8cfb3dba$var$futureMinutes
    },
    xMinutes: {
        one: "minuutti",
        other: "{{count}} minuuttia",
        futureTense: $743ee12d8cfb3dba$var$futureMinutes
    },
    aboutXHours: {
        one: "noin tunti",
        other: "noin {{count}} tuntia",
        futureTense: $743ee12d8cfb3dba$var$futureHours
    },
    xHours: {
        one: "tunti",
        other: "{{count}} tuntia",
        futureTense: $743ee12d8cfb3dba$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $743ee12d8cfb3dba$var$futureDays
    },
    aboutXWeeks: {
        one: "noin viikko",
        other: "noin {{count}} viikkoa",
        futureTense: $743ee12d8cfb3dba$var$futureWeeks
    },
    xWeeks: {
        one: "viikko",
        other: "{{count}} viikkoa",
        futureTense: $743ee12d8cfb3dba$var$futureWeeks
    },
    aboutXMonths: {
        one: "noin kuukausi",
        other: "noin {{count}} kuukautta",
        futureTense: $743ee12d8cfb3dba$var$futureMonths
    },
    xMonths: {
        one: "kuukausi",
        other: "{{count}} kuukautta",
        futureTense: $743ee12d8cfb3dba$var$futureMonths
    },
    aboutXYears: {
        one: "noin vuosi",
        other: "noin {{count}} vuotta",
        futureTense: $743ee12d8cfb3dba$var$futureYears
    },
    xYears: {
        one: "vuosi",
        other: "{{count}} vuotta",
        futureTense: $743ee12d8cfb3dba$var$futureYears
    },
    overXYears: {
        one: "yli vuosi",
        other: "yli {{count}} vuotta",
        futureTense: $743ee12d8cfb3dba$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $743ee12d8cfb3dba$var$futureYears
    }
};
const $743ee12d8cfb3dba$var$formatDistance = (token, count, options)=>{
    const tokenValue = $743ee12d8cfb3dba$var$formatDistanceLocale[token];
    const result = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + " kuluttua";
        else return result + " sitten";
    }
    return result;
};
$743ee12d8cfb3dba$export$2c14ff85d6318973 = $743ee12d8cfb3dba$var$formatDistance;


var $ad76fcc5e04ec771$export$cbf60ecb96cbb82f;
"use strict";
$ad76fcc5e04ec771$export$cbf60ecb96cbb82f = void 0;

const $ad76fcc5e04ec771$var$dateFormats = {
    full: "eeee d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "d.M.y"
};
const $ad76fcc5e04ec771$var$timeFormats = {
    full: "HH.mm.ss zzzz",
    long: "HH.mm.ss z",
    medium: "HH.mm.ss",
    short: "HH.mm"
};
const $ad76fcc5e04ec771$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $ad76fcc5e04ec771$var$formatLong = $ad76fcc5e04ec771$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ad76fcc5e04ec771$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ad76fcc5e04ec771$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ad76fcc5e04ec771$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $7a15d5b4cdb7709a$export$8fbbfd65594f46a0;
"use strict";
$7a15d5b4cdb7709a$export$8fbbfd65594f46a0 = void 0;
const $7a15d5b4cdb7709a$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: "P"
};
const $7a15d5b4cdb7709a$var$formatRelative = (token, _date, _baseDate, _options)=>$7a15d5b4cdb7709a$var$formatRelativeLocale[token];
$7a15d5b4cdb7709a$export$8fbbfd65594f46a0 = $7a15d5b4cdb7709a$var$formatRelative;


var $9bef4cd0031b26a7$export$b3bd0bc58e36cd63;
"use strict";
$9bef4cd0031b26a7$export$b3bd0bc58e36cd63 = void 0;

const $9bef4cd0031b26a7$var$eraValues = {
    narrow: [
        "eaa.",
        "jaa."
    ],
    abbreviated: [
        "eaa.",
        "jaa."
    ],
    wide: [
        "ennen ajanlaskun alkua",
        "j\xe4lkeen ajanlaskun alun"
    ]
};
const $9bef4cd0031b26a7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartaali",
        "2. kvartaali",
        "3. kvartaali",
        "4. kvartaali"
    ]
};
const $9bef4cd0031b26a7$var$monthValues = {
    narrow: [
        "T",
        "H",
        "M",
        "H",
        "T",
        "K",
        "H",
        "E",
        "S",
        "L",
        "M",
        "J"
    ],
    abbreviated: [
        "tammi",
        "helmi",
        "maalis",
        "huhti",
        "touko",
        "kes\xe4",
        "hein\xe4",
        "elo",
        "syys",
        "loka",
        "marras",
        "joulu"
    ],
    wide: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kes\xe4kuu",
        "hein\xe4kuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
    ]
};
const $9bef4cd0031b26a7$var$formattingMonthValues = {
    narrow: $9bef4cd0031b26a7$var$monthValues.narrow,
    abbreviated: $9bef4cd0031b26a7$var$monthValues.abbreviated,
    wide: [
        "tammikuuta",
        "helmikuuta",
        "maaliskuuta",
        "huhtikuuta",
        "toukokuuta",
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        "elokuuta",
        "syyskuuta",
        "lokakuuta",
        "marraskuuta",
        "joulukuuta"
    ]
};
const $9bef4cd0031b26a7$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "K",
        "T",
        "P",
        "L"
    ],
    short: [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
    ],
    abbreviated: [
        "sunn.",
        "maan.",
        "tiis.",
        "kesk.",
        "torst.",
        "perj.",
        "la"
    ],
    wide: [
        "sunnuntai",
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai"
    ]
};
const $9bef4cd0031b26a7$var$formattingDayValues = {
    narrow: $9bef4cd0031b26a7$var$dayValues.narrow,
    short: $9bef4cd0031b26a7$var$dayValues.short,
    abbreviated: $9bef4cd0031b26a7$var$dayValues.abbreviated,
    wide: [
        "sunnuntaina",
        "maanantaina",
        "tiistaina",
        "keskiviikkona",
        "torstaina",
        "perjantaina",
        "lauantaina"
    ]
};
const $9bef4cd0031b26a7$var$dayPeriodValues = {
    narrow: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    }
};
const $9bef4cd0031b26a7$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $9bef4cd0031b26a7$var$localize = $9bef4cd0031b26a7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9bef4cd0031b26a7$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9bef4cd0031b26a7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9bef4cd0031b26a7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9bef4cd0031b26a7$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $9bef4cd0031b26a7$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9bef4cd0031b26a7$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $9bef4cd0031b26a7$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9bef4cd0031b26a7$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $0b8b2311091a7581$export$4659b591c19bdf3d;
"use strict";
$0b8b2311091a7581$export$4659b591c19bdf3d = void 0;


const $0b8b2311091a7581$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
const $0b8b2311091a7581$var$parseOrdinalNumberPattern = /\d+/i;
const $0b8b2311091a7581$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
const $0b8b2311091a7581$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
const $0b8b2311091a7581$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
const $0b8b2311091a7581$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $0b8b2311091a7581$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
const $0b8b2311091a7581$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
const $0b8b2311091a7581$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
const $0b8b2311091a7581$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
const $0b8b2311091a7581$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
const $0b8b2311091a7581$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
const $0b8b2311091a7581$var$match = $0b8b2311091a7581$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $0b8b2311091a7581$var$matchOrdinalNumberPattern,
        parsePattern: $0b8b2311091a7581$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0b8b2311091a7581$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0b8b2311091a7581$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0b8b2311091a7581$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0b8b2311091a7581$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0b8b2311091a7581$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0b8b2311091a7581$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0b8b2311091a7581$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0b8b2311091a7581$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $0b8b2311091a7581$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0b8b2311091a7581$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe](https://github.com/Pyppe)
 * @author Edo Rivai [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Samu Juvonen [@sjuvonen](https://github.com/sjuvonen)
 */ const $af5c7676f1c9c755$var$fi = $af5c7676f1c9c755$export$ed5179c818622fb = {
    code: "fi",
    formatDistance: $743ee12d8cfb3dba$export$2c14ff85d6318973,
    formatLong: $ad76fcc5e04ec771$export$cbf60ecb96cbb82f,
    formatRelative: $7a15d5b4cdb7709a$export$8fbbfd65594f46a0,
    localize: $9bef4cd0031b26a7$export$b3bd0bc58e36cd63,
    match: $0b8b2311091a7581$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($af5c7676f1c9c755$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $af5c7676f1c9c755$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $af5c7676f1c9c755$exports[key];
        }
    });
});
var $13f394b2d5fcdc09$exports = {};

$parcel$export($13f394b2d5fcdc09$exports, "fr", () => $13f394b2d5fcdc09$export$acb2a88f7d552ebf, (v) => $13f394b2d5fcdc09$export$acb2a88f7d552ebf = v);
var $13f394b2d5fcdc09$export$acb2a88f7d552ebf;
"use strict";
$13f394b2d5fcdc09$export$acb2a88f7d552ebf = void 0;
var $94b6deb03d87dc4a$export$2c14ff85d6318973;
"use strict";
$94b6deb03d87dc4a$export$2c14ff85d6318973 = void 0;
const $94b6deb03d87dc4a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $94b6deb03d87dc4a$var$formatDistance = (token, count, options)=>{
    let result;
    const form = $94b6deb03d87dc4a$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
$94b6deb03d87dc4a$export$2c14ff85d6318973 = $94b6deb03d87dc4a$var$formatDistance;


var $a79a867ecfb7a685$export$cbf60ecb96cbb82f;
"use strict";
$a79a867ecfb7a685$export$cbf60ecb96cbb82f = void 0;

const $a79a867ecfb7a685$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $a79a867ecfb7a685$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a79a867ecfb7a685$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a79a867ecfb7a685$var$formatLong = $a79a867ecfb7a685$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a79a867ecfb7a685$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a79a867ecfb7a685$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a79a867ecfb7a685$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $5b59167d69db6aa3$export$8fbbfd65594f46a0;
"use strict";
$5b59167d69db6aa3$export$8fbbfd65594f46a0 = void 0;
const $5b59167d69db6aa3$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $5b59167d69db6aa3$var$formatRelative = (token, _date, _baseDate, _options)=>$5b59167d69db6aa3$var$formatRelativeLocale[token];
$5b59167d69db6aa3$export$8fbbfd65594f46a0 = $5b59167d69db6aa3$var$formatRelative;


var $fcbb52d6f308e2c6$export$b3bd0bc58e36cd63;
"use strict";
$fcbb52d6f308e2c6$export$b3bd0bc58e36cd63 = void 0;

const $fcbb52d6f308e2c6$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $fcbb52d6f308e2c6$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $fcbb52d6f308e2c6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $fcbb52d6f308e2c6$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $fcbb52d6f308e2c6$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $fcbb52d6f308e2c6$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $fcbb52d6f308e2c6$var$LONG_MONTHS_TOKENS = [
    "MMM",
    "MMMM"
];
const $fcbb52d6f308e2c6$var$localize = $fcbb52d6f308e2c6$export$b3bd0bc58e36cd63 = {
    preprocessor: (date, parts)=>{
        // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
        // Use case "do MMMM" => 1er août, 29 août
        // see https://github.com/date-fns/date-fns/issues/1391
        if (date.getDate() === 1) return parts;
        const hasLongMonthToken = parts.some((part)=>part.isToken && $fcbb52d6f308e2c6$var$LONG_MONTHS_TOKENS.includes(part.value));
        if (!hasLongMonthToken) return parts;
        return parts.map((part)=>part.isToken && part.value === "do" ? {
                isToken: true,
                value: "d"
            } : part);
    },
    ordinalNumber: $fcbb52d6f308e2c6$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fcbb52d6f308e2c6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fcbb52d6f308e2c6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fcbb52d6f308e2c6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fcbb52d6f308e2c6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fcbb52d6f308e2c6$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $4ecec78ade155dc8$export$4659b591c19bdf3d;
"use strict";
$4ecec78ade155dc8$export$4659b591c19bdf3d = void 0;


const $4ecec78ade155dc8$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $4ecec78ade155dc8$var$parseOrdinalNumberPattern = /\d+/i;
const $4ecec78ade155dc8$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $4ecec78ade155dc8$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $4ecec78ade155dc8$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $4ecec78ade155dc8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $4ecec78ade155dc8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $4ecec78ade155dc8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $4ecec78ade155dc8$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $4ecec78ade155dc8$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $4ecec78ade155dc8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $4ecec78ade155dc8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $4ecec78ade155dc8$var$match = $4ecec78ade155dc8$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $4ecec78ade155dc8$var$matchOrdinalNumberPattern,
        parsePattern: $4ecec78ade155dc8$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4ecec78ade155dc8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4ecec78ade155dc8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4ecec78ade155dc8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4ecec78ade155dc8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4ecec78ade155dc8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4ecec78ade155dc8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4ecec78ade155dc8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4ecec78ade155dc8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $4ecec78ade155dc8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4ecec78ade155dc8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 */ const $13f394b2d5fcdc09$var$fr = $13f394b2d5fcdc09$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: $94b6deb03d87dc4a$export$2c14ff85d6318973,
    formatLong: $a79a867ecfb7a685$export$cbf60ecb96cbb82f,
    formatRelative: $5b59167d69db6aa3$export$8fbbfd65594f46a0,
    localize: $fcbb52d6f308e2c6$export$b3bd0bc58e36cd63,
    match: $4ecec78ade155dc8$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($13f394b2d5fcdc09$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $13f394b2d5fcdc09$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $13f394b2d5fcdc09$exports[key];
        }
    });
});
var $f028e39b8eab0bdb$exports = {};

$parcel$export($f028e39b8eab0bdb$exports, "frCA", () => $f028e39b8eab0bdb$export$ba0a7939fd366aec, (v) => $f028e39b8eab0bdb$export$ba0a7939fd366aec = v);
var $f028e39b8eab0bdb$export$ba0a7939fd366aec;
"use strict";
$f028e39b8eab0bdb$export$ba0a7939fd366aec = void 0;




var $3354738f3e9d8734$export$cbf60ecb96cbb82f;
"use strict";
$3354738f3e9d8734$export$cbf60ecb96cbb82f = void 0;

const $3354738f3e9d8734$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "yy-MM-dd"
};
const $3354738f3e9d8734$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $3354738f3e9d8734$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $3354738f3e9d8734$var$formatLong = $3354738f3e9d8734$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3354738f3e9d8734$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3354738f3e9d8734$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3354738f3e9d8734$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


// Unique for fr-CA
/**
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Gabriele Petrioli [@gpetrioli](https://github.com/gpetrioli)
 */ const $f028e39b8eab0bdb$var$frCA = $f028e39b8eab0bdb$export$ba0a7939fd366aec = {
    code: "fr-CA",
    formatDistance: $94b6deb03d87dc4a$export$2c14ff85d6318973,
    formatLong: $3354738f3e9d8734$export$cbf60ecb96cbb82f,
    formatRelative: $5b59167d69db6aa3$export$8fbbfd65594f46a0,
    localize: $fcbb52d6f308e2c6$export$b3bd0bc58e36cd63,
    match: $4ecec78ade155dc8$export$4659b591c19bdf3d,
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($f028e39b8eab0bdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $f028e39b8eab0bdb$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $f028e39b8eab0bdb$exports[key];
        }
    });
});
var $93f3d29d7110bb17$exports = {};

$parcel$export($93f3d29d7110bb17$exports, "frCH", () => $93f3d29d7110bb17$export$5ca9c7dd526fb524, (v) => $93f3d29d7110bb17$export$5ca9c7dd526fb524 = v);
var $93f3d29d7110bb17$export$5ca9c7dd526fb524;
"use strict";
$93f3d29d7110bb17$export$5ca9c7dd526fb524 = void 0;



var $f2d4bb730fb5bb82$export$cbf60ecb96cbb82f;
"use strict";
$f2d4bb730fb5bb82$export$cbf60ecb96cbb82f = void 0;

const $f2d4bb730fb5bb82$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $f2d4bb730fb5bb82$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $f2d4bb730fb5bb82$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $f2d4bb730fb5bb82$var$formatLong = $f2d4bb730fb5bb82$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f2d4bb730fb5bb82$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f2d4bb730fb5bb82$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f2d4bb730fb5bb82$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $f29ee456a4159606$export$8fbbfd65594f46a0;
"use strict";
$f29ee456a4159606$export$8fbbfd65594f46a0 = void 0;
const $f29ee456a4159606$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: "P"
};
const $f29ee456a4159606$var$formatRelative = (token, _date, _baseDate, _options)=>$f29ee456a4159606$var$formatRelativeLocale[token];
$f29ee456a4159606$export$8fbbfd65594f46a0 = $f29ee456a4159606$var$formatRelative;


// Unique for fr-CH
/**
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */ const $93f3d29d7110bb17$var$frCH = $93f3d29d7110bb17$export$5ca9c7dd526fb524 = {
    code: "fr-CH",
    formatDistance: $94b6deb03d87dc4a$export$2c14ff85d6318973,
    formatLong: $f2d4bb730fb5bb82$export$cbf60ecb96cbb82f,
    formatRelative: $f29ee456a4159606$export$8fbbfd65594f46a0,
    localize: $fcbb52d6f308e2c6$export$b3bd0bc58e36cd63,
    match: $4ecec78ade155dc8$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($93f3d29d7110bb17$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $93f3d29d7110bb17$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $93f3d29d7110bb17$exports[key];
        }
    });
});
var $c13c135c19020378$exports = {};

$parcel$export($c13c135c19020378$exports, "fy", () => $c13c135c19020378$export$c0dcd1f2238f086d, (v) => $c13c135c19020378$export$c0dcd1f2238f086d = v);
var $c13c135c19020378$export$c0dcd1f2238f086d;
"use strict";
$c13c135c19020378$export$c0dcd1f2238f086d = void 0;
var $f1ad1810b4afd5bb$export$2c14ff85d6318973;
"use strict";
$f1ad1810b4afd5bb$export$2c14ff85d6318973 = void 0;
const $f1ad1810b4afd5bb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 1 sekonde",
        other: "minder as {{count}} sekonden"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekonden"
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: "minder as {{count}} minuten"
    },
    xMinutes: {
        one: "1 min\xfat",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "sawat 1 oere",
        other: "sawat {{count}} oere"
    },
    xHours: {
        one: "1 oere",
        other: "{{count}} oere"
    },
    xDays: {
        one: "1 dei",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "sawat 1 wike",
        other: "sawat {{count}} wiken"
    },
    xWeeks: {
        one: "1 wike",
        other: "{{count}} wiken"
    },
    aboutXMonths: {
        one: "sawat 1 moanne",
        other: "sawat {{count}} moannen"
    },
    xMonths: {
        one: "1 moanne",
        other: "{{count}} moannen"
    },
    aboutXYears: {
        one: "sawat 1 jier",
        other: "sawat {{count}} jier"
    },
    xYears: {
        one: "1 jier",
        other: "{{count}} jier"
    },
    overXYears: {
        one: "mear as 1 jier",
        other: "mear as {{count}}s jier"
    },
    almostXYears: {
        one: "hast 1 jier",
        other: "hast {{count}} jier"
    }
};
const $f1ad1810b4afd5bb$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $f1ad1810b4afd5bb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oer " + result;
        else return result + " lyn";
    }
    return result;
};
$f1ad1810b4afd5bb$export$2c14ff85d6318973 = $f1ad1810b4afd5bb$var$formatDistance;


var $262abadae32a4314$export$cbf60ecb96cbb82f;
"use strict";
$262abadae32a4314$export$cbf60ecb96cbb82f = void 0;

const $262abadae32a4314$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
const $262abadae32a4314$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $262abadae32a4314$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $262abadae32a4314$var$formatLong = $262abadae32a4314$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $262abadae32a4314$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $262abadae32a4314$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $262abadae32a4314$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $1b627719a0130acb$export$8fbbfd65594f46a0;
"use strict";
$1b627719a0130acb$export$8fbbfd65594f46a0 = void 0;
const $1b627719a0130acb$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $1b627719a0130acb$var$formatRelative = (token, _date, _baseDate, _options)=>$1b627719a0130acb$var$formatRelativeLocale[token];
$1b627719a0130acb$export$8fbbfd65594f46a0 = $1b627719a0130acb$var$formatRelative;


var $2354db418b464c61$export$b3bd0bc58e36cd63;
"use strict";
$2354db418b464c61$export$b3bd0bc58e36cd63 = void 0;

const $2354db418b464c61$var$eraValues = {
    narrow: [
        "f.K.",
        "n.K."
    ],
    abbreviated: [
        "f.Kr.",
        "n.Kr."
    ],
    wide: [
        "foar Kristus",
        "nei Kristus"
    ]
};
const $2354db418b464c61$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e fearnsjier",
        "2e fearnsjier",
        "3e fearnsjier",
        "4e fearnsjier"
    ]
};
const $2354db418b464c61$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mai.",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "jannewaris",
        "febrewaris",
        "maart",
        "april",
        "maaie",
        "juny",
        "july",
        "augustus",
        "septimber",
        "oktober",
        "novimber",
        "desimber"
    ]
};
const $2354db418b464c61$var$dayValues = {
    narrow: [
        "s",
        "m",
        "t",
        "w",
        "t",
        "f",
        "s"
    ],
    short: [
        "si",
        "mo",
        "ti",
        "wo",
        "to",
        "fr",
        "so"
    ],
    abbreviated: [
        "snein",
        "moa",
        "tii",
        "woa",
        "ton",
        "fre",
        "sneon"
    ],
    wide: [
        "snein",
        "moandei",
        "tiisdei",
        "woansdei",
        "tongersdei",
        "freed",
        "sneon"
    ]
};
const $2354db418b464c61$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    }
};
const $2354db418b464c61$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $2354db418b464c61$var$localize = $2354db418b464c61$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2354db418b464c61$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2354db418b464c61$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2354db418b464c61$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2354db418b464c61$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2354db418b464c61$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2354db418b464c61$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $93959a0198c22fc0$export$4659b591c19bdf3d;
"use strict";
$93959a0198c22fc0$export$4659b591c19bdf3d = void 0;


const $93959a0198c22fc0$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $93959a0198c22fc0$var$parseOrdinalNumberPattern = /\d+/i;
const $93959a0198c22fc0$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
const $93959a0198c22fc0$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
const $93959a0198c22fc0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
const $93959a0198c22fc0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $93959a0198c22fc0$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
const $93959a0198c22fc0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
const $93959a0198c22fc0$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
const $93959a0198c22fc0$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
const $93959a0198c22fc0$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
const $93959a0198c22fc0$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
const $93959a0198c22fc0$var$match = $93959a0198c22fc0$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $93959a0198c22fc0$var$matchOrdinalNumberPattern,
        parsePattern: $93959a0198c22fc0$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $93959a0198c22fc0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $93959a0198c22fc0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $93959a0198c22fc0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $93959a0198c22fc0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $93959a0198c22fc0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $93959a0198c22fc0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $93959a0198c22fc0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $93959a0198c22fc0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $93959a0198c22fc0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $93959a0198c22fc0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02](https://github.com/damon02)
 */ const $c13c135c19020378$var$fy = $c13c135c19020378$export$c0dcd1f2238f086d = {
    code: "fy",
    formatDistance: $f1ad1810b4afd5bb$export$2c14ff85d6318973,
    formatLong: $262abadae32a4314$export$cbf60ecb96cbb82f,
    formatRelative: $1b627719a0130acb$export$8fbbfd65594f46a0,
    localize: $2354db418b464c61$export$b3bd0bc58e36cd63,
    match: $93959a0198c22fc0$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($c13c135c19020378$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $c13c135c19020378$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $c13c135c19020378$exports[key];
        }
    });
});
var $16d80300e27238cf$exports = {};

$parcel$export($16d80300e27238cf$exports, "gd", () => $16d80300e27238cf$export$64ad7087a50b462f, (v) => $16d80300e27238cf$export$64ad7087a50b462f = v);
var $16d80300e27238cf$export$64ad7087a50b462f;
"use strict";
$16d80300e27238cf$export$64ad7087a50b462f = void 0;
var $e7508329cd1d7aab$export$2c14ff85d6318973;
"use strict";
$e7508329cd1d7aab$export$2c14ff85d6318973 = void 0;
const $e7508329cd1d7aab$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "nas lugha na diog",
        other: "nas lugha na {{count}} diogan"
    },
    xSeconds: {
        one: "1 diog",
        two: "2 dhiog",
        twenty: "20 diog",
        other: "{{count}} diogan"
    },
    halfAMinute: "leth mhionaid",
    lessThanXMinutes: {
        one: "nas lugha na mionaid",
        other: "nas lugha na {{count}} mionaidean"
    },
    xMinutes: {
        one: "1 mionaid",
        two: "2 mhionaid",
        twenty: "20 mionaid",
        other: "{{count}} mionaidean"
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: "mu 1 seachdain",
        other: "mu {{count}} seachdainean"
    },
    xWeeks: {
        one: "1 seachdain",
        other: "{{count}} seachdainean"
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: "mu bhliadhna",
        other: "mu {{count}} bliadhnaichean"
    },
    xYears: {
        one: "1 bhliadhna",
        other: "{{count}} bliadhna"
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
const $e7508329cd1d7aab$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $e7508329cd1d7aab$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "ann an " + result;
        else return "o chionn " + result;
    }
    return result;
};
$e7508329cd1d7aab$export$2c14ff85d6318973 = $e7508329cd1d7aab$var$formatDistance;


var $6972b839b86a47f2$export$cbf60ecb96cbb82f;
"use strict";
$6972b839b86a47f2$export$cbf60ecb96cbb82f = void 0;

const $6972b839b86a47f2$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $6972b839b86a47f2$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $6972b839b86a47f2$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6972b839b86a47f2$var$formatLong = $6972b839b86a47f2$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6972b839b86a47f2$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6972b839b86a47f2$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6972b839b86a47f2$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $4aba00371f17d734$export$8fbbfd65594f46a0;
"use strict";
$4aba00371f17d734$export$8fbbfd65594f46a0 = void 0;
const $4aba00371f17d734$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: "P"
};
const $4aba00371f17d734$var$formatRelative = (token, _date, _baseDate, _options)=>$4aba00371f17d734$var$formatRelativeLocale[token];
$4aba00371f17d734$export$8fbbfd65594f46a0 = $4aba00371f17d734$var$formatRelative;


var $3423000054d5b4e5$export$b3bd0bc58e36cd63;
"use strict";
$3423000054d5b4e5$export$b3bd0bc58e36cd63 = void 0;

const $3423000054d5b4e5$var$eraValues = {
    narrow: [
        "R",
        "A"
    ],
    abbreviated: [
        "RC",
        "AD"
    ],
    wide: [
        "ro Chr\xecosta",
        "anno domini"
    ]
};
const $3423000054d5b4e5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "C1",
        "C2",
        "C3",
        "C4"
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        "an treas cairteal",
        "an ceathramh cairteal"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $3423000054d5b4e5$var$monthValues = {
    narrow: [
        "F",
        "G",
        "M",
        "G",
        "C",
        "\xd2",
        "I",
        "L",
        "S",
        "D",
        "S",
        "D"
    ],
    abbreviated: [
        "Faoi",
        "Gear",
        "M\xe0rt",
        "Gibl",
        "C\xe8it",
        "\xd2gmh",
        "Iuch",
        "L\xf9n",
        "Sult",
        "D\xe0mh",
        "Samh",
        "D\xf9bh"
    ],
    wide: [
        "Am Faoilleach",
        "An Gearran",
        "Am M\xe0rt",
        "An Giblean",
        "An C\xe8itean",
        "An t-\xd2gmhios",
        "An t-Iuchar",
        "An L\xf9nastal",
        "An t-Sultain",
        "An D\xe0mhair",
        "An t-Samhain",
        "An D\xf9bhlachd"
    ]
};
const $3423000054d5b4e5$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "C",
        "A",
        "H",
        "S"
    ],
    short: [
        "D\xf2",
        "Lu",
        "M\xe0",
        "Ci",
        "Ar",
        "Ha",
        "Sa"
    ],
    abbreviated: [
        "Did",
        "Dil",
        "Dim",
        "Dic",
        "Dia",
        "Dih",
        "Dis"
    ],
    wide: [
        "Did\xf2mhnaich",
        "Diluain",
        "Dim\xe0irt",
        "Diciadain",
        "Diardaoin",
        "Dihaoine",
        "Disathairne"
    ]
};
const $3423000054d5b4e5$var$dayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    }
};
const $3423000054d5b4e5$var$formattingDayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    }
};
const $3423000054d5b4e5$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "d";
        case 2:
            return number + "na";
    }
    if (rem100 === 12) return number + "na";
    return number + "mh";
};
const $3423000054d5b4e5$var$localize = $3423000054d5b4e5$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3423000054d5b4e5$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3423000054d5b4e5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3423000054d5b4e5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3423000054d5b4e5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3423000054d5b4e5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3423000054d5b4e5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3423000054d5b4e5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $d7cf62ff6d06b3a7$export$4659b591c19bdf3d;
"use strict";
$d7cf62ff6d06b3a7$export$4659b591c19bdf3d = void 0;


const $d7cf62ff6d06b3a7$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
const $d7cf62ff6d06b3a7$var$parseOrdinalNumberPattern = /\d+/i;
const $d7cf62ff6d06b3a7$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
const $d7cf62ff6d06b3a7$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d7cf62ff6d06b3a7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
const $d7cf62ff6d06b3a7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d7cf62ff6d06b3a7$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
const $d7cf62ff6d06b3a7$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
const $d7cf62ff6d06b3a7$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
const $d7cf62ff6d06b3a7$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
const $d7cf62ff6d06b3a7$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
const $d7cf62ff6d06b3a7$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
const $d7cf62ff6d06b3a7$var$match = $d7cf62ff6d06b3a7$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $d7cf62ff6d06b3a7$var$matchOrdinalNumberPattern,
        parsePattern: $d7cf62ff6d06b3a7$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d7cf62ff6d06b3a7$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d7cf62ff6d06b3a7$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d7cf62ff6d06b3a7$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d7cf62ff6d06b3a7$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d7cf62ff6d06b3a7$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d7cf62ff6d06b3a7$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d7cf62ff6d06b3a7$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d7cf62ff6d06b3a7$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $d7cf62ff6d06b3a7$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d7cf62ff6d06b3a7$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll](https://github.com/leedriscoll)
 */ const $16d80300e27238cf$var$gd = $16d80300e27238cf$export$64ad7087a50b462f = {
    code: "gd",
    formatDistance: $e7508329cd1d7aab$export$2c14ff85d6318973,
    formatLong: $6972b839b86a47f2$export$cbf60ecb96cbb82f,
    formatRelative: $4aba00371f17d734$export$8fbbfd65594f46a0,
    localize: $3423000054d5b4e5$export$b3bd0bc58e36cd63,
    match: $d7cf62ff6d06b3a7$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($16d80300e27238cf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $16d80300e27238cf$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $16d80300e27238cf$exports[key];
        }
    });
});
var $b7aa88e8b5501233$exports = {};

$parcel$export($b7aa88e8b5501233$exports, "gl", () => $b7aa88e8b5501233$export$5822a9d0880a5d82, (v) => $b7aa88e8b5501233$export$5822a9d0880a5d82 = v);
var $b7aa88e8b5501233$export$5822a9d0880a5d82;
"use strict";
$b7aa88e8b5501233$export$5822a9d0880a5d82 = void 0;
var $08d78030042e1d58$export$2c14ff85d6318973;
"use strict";
$08d78030042e1d58$export$2c14ff85d6318973 = void 0;
const $08d78030042e1d58$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos dun segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos dun minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "arredor dunha hora",
        other: "arredor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "arredor dunha semana",
        other: "arredor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "arredor de 1 mes",
        other: "arredor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "arredor dun ano",
        other: "arredor de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: "case un ano",
        other: "case {{count}} anos"
    }
};
const $08d78030042e1d58$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $08d78030042e1d58$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hai " + result;
    }
    return result;
};
$08d78030042e1d58$export$2c14ff85d6318973 = $08d78030042e1d58$var$formatDistance;


var $fd04dfffe7a54365$export$cbf60ecb96cbb82f;
"use strict";
$fd04dfffe7a54365$export$cbf60ecb96cbb82f = void 0;

const $fd04dfffe7a54365$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $fd04dfffe7a54365$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $fd04dfffe7a54365$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $fd04dfffe7a54365$var$formatLong = $fd04dfffe7a54365$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fd04dfffe7a54365$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fd04dfffe7a54365$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fd04dfffe7a54365$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $945772ff10ea4cf0$export$8fbbfd65594f46a0;
"use strict";
$945772ff10ea4cf0$export$8fbbfd65594f46a0 = void 0;
const $945772ff10ea4cf0$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: "P"
};
const $945772ff10ea4cf0$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: "P"
};
const $945772ff10ea4cf0$var$formatRelative = (token, date, _baseDate, _options)=>{
    if (date.getHours() !== 1) return $945772ff10ea4cf0$var$formatRelativeLocalePlural[token];
    return $945772ff10ea4cf0$var$formatRelativeLocale[token];
};
$945772ff10ea4cf0$export$8fbbfd65594f46a0 = $945772ff10ea4cf0$var$formatRelative;


var $3f4c87af4ee4ddbd$export$b3bd0bc58e36cd63;
"use strict";
$3f4c87af4ee4ddbd$export$b3bd0bc58e36cd63 = void 0;

const $3f4c87af4ee4ddbd$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despois de cristo"
    ]
};
const $3f4c87af4ee4ddbd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $3f4c87af4ee4ddbd$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "xan",
        "feb",
        "mar",
        "abr",
        "mai",
        "xun",
        "xul",
        "ago",
        "set",
        "out",
        "nov",
        "dec"
    ],
    wide: [
        "xaneiro",
        "febreiro",
        "marzo",
        "abril",
        "maio",
        "xu\xf1o",
        "xullo",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "decembro"
    ]
};
const $3f4c87af4ee4ddbd$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "me",
        "xo",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "xov",
        "ven",
        "sab"
    ],
    wide: [
        "domingo",
        "luns",
        "martes",
        "m\xe9rcores",
        "xoves",
        "venres",
        "s\xe1bado"
    ]
};
const $3f4c87af4ee4ddbd$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    }
};
const $3f4c87af4ee4ddbd$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    }
};
const $3f4c87af4ee4ddbd$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $3f4c87af4ee4ddbd$var$localize = $3f4c87af4ee4ddbd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3f4c87af4ee4ddbd$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3f4c87af4ee4ddbd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3f4c87af4ee4ddbd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3f4c87af4ee4ddbd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3f4c87af4ee4ddbd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3f4c87af4ee4ddbd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3f4c87af4ee4ddbd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $072803ccd3b21a94$export$4659b591c19bdf3d;
"use strict";
$072803ccd3b21a94$export$4659b591c19bdf3d = void 0;


const $072803ccd3b21a94$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $072803ccd3b21a94$var$parseOrdinalNumberPattern = /\d+/i;
const $072803ccd3b21a94$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
const $072803ccd3b21a94$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
const $072803ccd3b21a94$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $072803ccd3b21a94$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $072803ccd3b21a94$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
const $072803ccd3b21a94$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
const $072803ccd3b21a94$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
const $072803ccd3b21a94$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
const $072803ccd3b21a94$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
const $072803ccd3b21a94$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
const $072803ccd3b21a94$var$match = $072803ccd3b21a94$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $072803ccd3b21a94$var$matchOrdinalNumberPattern,
        parsePattern: $072803ccd3b21a94$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $072803ccd3b21a94$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $072803ccd3b21a94$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $072803ccd3b21a94$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $072803ccd3b21a94$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $072803ccd3b21a94$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $072803ccd3b21a94$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $072803ccd3b21a94$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $072803ccd3b21a94$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $072803ccd3b21a94$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $072803ccd3b21a94$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech](https://github.com/cocodinTech)
 * @author Fidel Pita [@fidelpita](https://github.com/fidelpita)
 */ const $b7aa88e8b5501233$var$gl = $b7aa88e8b5501233$export$5822a9d0880a5d82 = {
    code: "gl",
    formatDistance: $08d78030042e1d58$export$2c14ff85d6318973,
    formatLong: $fd04dfffe7a54365$export$cbf60ecb96cbb82f,
    formatRelative: $945772ff10ea4cf0$export$8fbbfd65594f46a0,
    localize: $3f4c87af4ee4ddbd$export$b3bd0bc58e36cd63,
    match: $072803ccd3b21a94$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($b7aa88e8b5501233$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $b7aa88e8b5501233$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $b7aa88e8b5501233$exports[key];
        }
    });
});
var $5055cca34f30ceb5$exports = {};

$parcel$export($5055cca34f30ceb5$exports, "gu", () => $5055cca34f30ceb5$export$85e91b8206de11f6, (v) => $5055cca34f30ceb5$export$85e91b8206de11f6 = v);
var $5055cca34f30ceb5$export$85e91b8206de11f6;
"use strict";
$5055cca34f30ceb5$export$85e91b8206de11f6 = void 0;
var $ba7cfb67a48d3832$export$2c14ff85d6318973;
"use strict";
$ba7cfb67a48d3832$export$2c14ff85d6318973 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $ba7cfb67a48d3832$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
const $ba7cfb67a48d3832$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ba7cfb67a48d3832$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
$ba7cfb67a48d3832$export$2c14ff85d6318973 = $ba7cfb67a48d3832$var$formatDistance;


var $64d3293488b0a45b$export$cbf60ecb96cbb82f;
"use strict";
$64d3293488b0a45b$export$cbf60ecb96cbb82f = void 0;

//Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $64d3293488b0a45b$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
const $64d3293488b0a45b$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    long: "hh:mm:ss a z",
    medium: "hh:mm:ss a",
    short: "hh:mm a"
};
const $64d3293488b0a45b$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $64d3293488b0a45b$var$formatLong = $64d3293488b0a45b$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $64d3293488b0a45b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $64d3293488b0a45b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $64d3293488b0a45b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $1ca04ac30e7f4605$export$8fbbfd65594f46a0;
"use strict";
$1ca04ac30e7f4605$export$8fbbfd65594f46a0 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const $1ca04ac30e7f4605$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    today: "'\u0A86\u0A9C\u0AC7' p",
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    nextWeek: "eeee p",
    other: "P"
};
const $1ca04ac30e7f4605$var$formatRelative = (token, _date, _baseDate, _options)=>$1ca04ac30e7f4605$var$formatRelativeLocale[token];
$1ca04ac30e7f4605$export$8fbbfd65594f46a0 = $1ca04ac30e7f4605$var$formatRelative;


var $462d3c5512dbb52e$export$b3bd0bc58e36cd63;
"use strict";
$462d3c5512dbb52e$export$b3bd0bc58e36cd63 = void 0;

// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1621 - #1630
const $462d3c5512dbb52e$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
const $462d3c5512dbb52e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
const $462d3c5512dbb52e$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
const $462d3c5512dbb52e$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
const $462d3c5512dbb52e$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
const $462d3c5512dbb52e$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
const $462d3c5512dbb52e$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $462d3c5512dbb52e$var$localize = $462d3c5512dbb52e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $462d3c5512dbb52e$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $462d3c5512dbb52e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $462d3c5512dbb52e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $462d3c5512dbb52e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $462d3c5512dbb52e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $462d3c5512dbb52e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $462d3c5512dbb52e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $fccb305836e9eb53$export$4659b591c19bdf3d;
"use strict";
$fccb305836e9eb53$export$4659b591c19bdf3d = void 0;


const $fccb305836e9eb53$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
const $fccb305836e9eb53$var$parseOrdinalNumberPattern = /\d+/i;
const $fccb305836e9eb53$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
const $fccb305836e9eb53$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
const $fccb305836e9eb53$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
const $fccb305836e9eb53$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $fccb305836e9eb53$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
const $fccb305836e9eb53$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
const $fccb305836e9eb53$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
const $fccb305836e9eb53$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
const $fccb305836e9eb53$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
const $fccb305836e9eb53$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
const $fccb305836e9eb53$var$match = $fccb305836e9eb53$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $fccb305836e9eb53$var$matchOrdinalNumberPattern,
        parsePattern: $fccb305836e9eb53$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fccb305836e9eb53$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fccb305836e9eb53$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fccb305836e9eb53$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fccb305836e9eb53$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fccb305836e9eb53$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fccb305836e9eb53$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fccb305836e9eb53$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fccb305836e9eb53$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fccb305836e9eb53$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fccb305836e9eb53$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM](https://github.com/manadaym)
 */ const $5055cca34f30ceb5$var$gu = $5055cca34f30ceb5$export$85e91b8206de11f6 = {
    code: "gu",
    formatDistance: $ba7cfb67a48d3832$export$2c14ff85d6318973,
    formatLong: $64d3293488b0a45b$export$cbf60ecb96cbb82f,
    formatRelative: $1ca04ac30e7f4605$export$8fbbfd65594f46a0,
    localize: $462d3c5512dbb52e$export$b3bd0bc58e36cd63,
    match: $fccb305836e9eb53$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($5055cca34f30ceb5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $5055cca34f30ceb5$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $5055cca34f30ceb5$exports[key];
        }
    });
});
var $2e97f84e290230c3$exports = {};

$parcel$export($2e97f84e290230c3$exports, "he", () => $2e97f84e290230c3$export$10cc7d172bb7969, (v) => $2e97f84e290230c3$export$10cc7d172bb7969 = v);
var $2e97f84e290230c3$export$10cc7d172bb7969;
"use strict";
$2e97f84e290230c3$export$10cc7d172bb7969 = void 0;
var $6b1f1bff418b3156$export$2c14ff85d6318973;
"use strict";
$6b1f1bff418b3156$export$2c14ff85d6318973 = void 0;
const $6b1f1bff418b3156$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
const $6b1f1bff418b3156$var$formatDistance = (token, count, options)=>{
    // Return word instead of `in one day` or `one day ago`
    if (token === "xDays" && options?.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    let result;
    const tokenValue = $6b1f1bff418b3156$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
$6b1f1bff418b3156$export$2c14ff85d6318973 = $6b1f1bff418b3156$var$formatDistance;


var $6a9e2a9f44d365be$export$cbf60ecb96cbb82f;
"use strict";
$6a9e2a9f44d365be$export$cbf60ecb96cbb82f = void 0;

const $6a9e2a9f44d365be$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: "d.M.y"
};
const $6a9e2a9f44d365be$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $6a9e2a9f44d365be$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6a9e2a9f44d365be$var$formatLong = $6a9e2a9f44d365be$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6a9e2a9f44d365be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6a9e2a9f44d365be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6a9e2a9f44d365be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $d91c92e41f12a499$export$8fbbfd65594f46a0;
"use strict";
$d91c92e41f12a499$export$8fbbfd65594f46a0 = void 0;
const $d91c92e41f12a499$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: "P"
};
const $d91c92e41f12a499$var$formatRelative = (token, _date, _baseDate, _options)=>$d91c92e41f12a499$var$formatRelativeLocale[token];
$d91c92e41f12a499$export$8fbbfd65594f46a0 = $d91c92e41f12a499$var$formatRelative;


var $666fbe8e9de9f9f9$export$b3bd0bc58e36cd63;
"use strict";
$666fbe8e9de9f9f9$export$b3bd0bc58e36cd63 = void 0;

const $666fbe8e9de9f9f9$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
const $666fbe8e9de9f9f9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
const $666fbe8e9de9f9f9$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
const $666fbe8e9de9f9f9$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
const $666fbe8e9de9f9f9$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
const $666fbe8e9de9f9f9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
const $666fbe8e9de9f9f9$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    const unit = String(options?.unit);
    const isFemale = [
        "year",
        "hour",
        "minute",
        "second"
    ].indexOf(unit) >= 0;
    const male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    const female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    const index = number - 1;
    return isFemale ? female[index] : male[index];
};
const $666fbe8e9de9f9f9$var$localize = $666fbe8e9de9f9f9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $666fbe8e9de9f9f9$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $666fbe8e9de9f9f9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $666fbe8e9de9f9f9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $666fbe8e9de9f9f9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $666fbe8e9de9f9f9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $666fbe8e9de9f9f9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $666fbe8e9de9f9f9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $3814afd7b01d6fa2$export$4659b591c19bdf3d;
"use strict";
$3814afd7b01d6fa2$export$4659b591c19bdf3d = void 0;


const $3814afd7b01d6fa2$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
const $3814afd7b01d6fa2$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
const $3814afd7b01d6fa2$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
const $3814afd7b01d6fa2$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
const $3814afd7b01d6fa2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
const $3814afd7b01d6fa2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3814afd7b01d6fa2$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
const $3814afd7b01d6fa2$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
const $3814afd7b01d6fa2$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
const $3814afd7b01d6fa2$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
const $3814afd7b01d6fa2$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
const $3814afd7b01d6fa2$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
const $3814afd7b01d6fa2$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
const $3814afd7b01d6fa2$var$match = $3814afd7b01d6fa2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $3814afd7b01d6fa2$var$matchOrdinalNumberPattern,
        parsePattern: $3814afd7b01d6fa2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>{
            const number = parseInt(value, 10);
            return isNaN(number) ? $3814afd7b01d6fa2$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3814afd7b01d6fa2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3814afd7b01d6fa2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3814afd7b01d6fa2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3814afd7b01d6fa2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3814afd7b01d6fa2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3814afd7b01d6fa2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3814afd7b01d6fa2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3814afd7b01d6fa2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3814afd7b01d6fa2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3814afd7b01d6fa2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah](https://github.com/nirlah)
 */ const $2e97f84e290230c3$var$he = $2e97f84e290230c3$export$10cc7d172bb7969 = {
    code: "he",
    formatDistance: $6b1f1bff418b3156$export$2c14ff85d6318973,
    formatLong: $6a9e2a9f44d365be$export$cbf60ecb96cbb82f,
    formatRelative: $d91c92e41f12a499$export$8fbbfd65594f46a0,
    localize: $666fbe8e9de9f9f9$export$b3bd0bc58e36cd63,
    match: $3814afd7b01d6fa2$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($2e97f84e290230c3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $2e97f84e290230c3$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $2e97f84e290230c3$exports[key];
        }
    });
});
var $4dd8c66be6809b02$exports = {};

$parcel$export($4dd8c66be6809b02$exports, "hi", () => $4dd8c66be6809b02$export$43bde67df112d15b, (v) => $4dd8c66be6809b02$export$43bde67df112d15b = v);
var $4dd8c66be6809b02$export$43bde67df112d15b;
"use strict";
$4dd8c66be6809b02$export$43bde67df112d15b = void 0;
var $ca3d058cb1ae6d47$export$2c14ff85d6318973;
"use strict";
$ca3d058cb1ae6d47$export$2c14ff85d6318973 = void 0;
var $f07f2cc9c0edb0bf$export$b431cabd737c2a;
var $f07f2cc9c0edb0bf$export$b3bd0bc58e36cd63;
var $f07f2cc9c0edb0bf$export$3e1d599946644f03;
"use strict";
$f07f2cc9c0edb0bf$export$b431cabd737c2a = $f07f2cc9c0edb0bf$var$localeToNumber;
$f07f2cc9c0edb0bf$export$b3bd0bc58e36cd63 = void 0;
$f07f2cc9c0edb0bf$export$3e1d599946644f03 = $f07f2cc9c0edb0bf$var$numberToLocale;

const $f07f2cc9c0edb0bf$var$numberValues = {
    locale: {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096A",
        5: "\u096B",
        6: "\u096C",
        7: "\u096D",
        8: "\u096E",
        9: "\u096F",
        0: "\u0966"
    },
    number: {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
    }
};
// CLDR #1585 - #1592
const $f07f2cc9c0edb0bf$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
const $f07f2cc9c0edb0bf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
const $f07f2cc9c0edb0bf$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
const $f07f2cc9c0edb0bf$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
const $f07f2cc9c0edb0bf$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
const $f07f2cc9c0edb0bf$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
const $f07f2cc9c0edb0bf$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return $f07f2cc9c0edb0bf$var$numberToLocale(number);
};
function $f07f2cc9c0edb0bf$var$localeToNumber(locale) {
    const enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $f07f2cc9c0edb0bf$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $f07f2cc9c0edb0bf$var$numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $f07f2cc9c0edb0bf$var$numberValues.locale[match];
    });
}
const $f07f2cc9c0edb0bf$var$localize = $f07f2cc9c0edb0bf$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f07f2cc9c0edb0bf$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f07f2cc9c0edb0bf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f07f2cc9c0edb0bf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f07f2cc9c0edb0bf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f07f2cc9c0edb0bf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f07f2cc9c0edb0bf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f07f2cc9c0edb0bf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


// Source: https://www.unicode.org/cldr/charts/32/summary/hi.html
const $ca3d058cb1ae6d47$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        other: "{{count}} \u0918\u0902\u091F\u0947"
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
const $ca3d058cb1ae6d47$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ca3d058cb1ae6d47$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $f07f2cc9c0edb0bf$export$3e1d599946644f03)(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
$ca3d058cb1ae6d47$export$2c14ff85d6318973 = $ca3d058cb1ae6d47$var$formatDistance;


var $6bbab32c2528d152$export$cbf60ecb96cbb82f;
"use strict";
$6bbab32c2528d152$export$cbf60ecb96cbb82f = void 0;

const $6bbab32c2528d152$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $6bbab32c2528d152$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $6bbab32c2528d152$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    long: "{{date}} '\u0915\u094B' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6bbab32c2528d152$var$formatLong = $6bbab32c2528d152$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6bbab32c2528d152$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6bbab32c2528d152$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6bbab32c2528d152$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $1b0315b941bcde16$export$8fbbfd65594f46a0;
"use strict";
$1b0315b941bcde16$export$8fbbfd65594f46a0 = void 0;
const $1b0315b941bcde16$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: "P"
};
const $1b0315b941bcde16$var$formatRelative = (token, _date, _baseDate, _options)=>$1b0315b941bcde16$var$formatRelativeLocale[token];
$1b0315b941bcde16$export$8fbbfd65594f46a0 = $1b0315b941bcde16$var$formatRelative;



var $2e448b3819d8fe03$export$4659b591c19bdf3d;
"use strict";
$2e448b3819d8fe03$export$4659b591c19bdf3d = void 0;



const $2e448b3819d8fe03$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
const $2e448b3819d8fe03$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
const $2e448b3819d8fe03$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
const $2e448b3819d8fe03$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $2e448b3819d8fe03$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
const $2e448b3819d8fe03$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2e448b3819d8fe03$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
const $2e448b3819d8fe03$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
const $2e448b3819d8fe03$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
const $2e448b3819d8fe03$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
const $2e448b3819d8fe03$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
const $2e448b3819d8fe03$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
const $2e448b3819d8fe03$var$match = $2e448b3819d8fe03$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $2e448b3819d8fe03$var$matchOrdinalNumberPattern,
        parsePattern: $2e448b3819d8fe03$var$parseOrdinalNumberPattern,
        valueCallback: $f07f2cc9c0edb0bf$export$b431cabd737c2a
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2e448b3819d8fe03$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2e448b3819d8fe03$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2e448b3819d8fe03$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2e448b3819d8fe03$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2e448b3819d8fe03$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2e448b3819d8fe03$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2e448b3819d8fe03$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2e448b3819d8fe03$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2e448b3819d8fe03$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2e448b3819d8fe03$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal](https://github.com/mukeshmandiwal)
 */ const $4dd8c66be6809b02$var$hi = $4dd8c66be6809b02$export$43bde67df112d15b = {
    code: "hi",
    formatDistance: $ca3d058cb1ae6d47$export$2c14ff85d6318973,
    formatLong: $6bbab32c2528d152$export$cbf60ecb96cbb82f,
    formatRelative: $1b0315b941bcde16$export$8fbbfd65594f46a0,
    localize: $f07f2cc9c0edb0bf$export$b3bd0bc58e36cd63,
    match: $2e448b3819d8fe03$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($4dd8c66be6809b02$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $4dd8c66be6809b02$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $4dd8c66be6809b02$exports[key];
        }
    });
});
var $2c072b93a28f79cf$exports = {};

$parcel$export($2c072b93a28f79cf$exports, "hr", () => $2c072b93a28f79cf$export$b4adb3f464574dcf, (v) => $2c072b93a28f79cf$export$b4adb3f464574dcf = v);
var $2c072b93a28f79cf$export$b4adb3f464574dcf;
"use strict";
$2c072b93a28f79cf$export$b4adb3f464574dcf = void 0;
var $2c426e0a858c240a$export$2c14ff85d6318973;
"use strict";
$2c426e0a858c240a$export$2c14ff85d6318973 = void 0;
const $2c426e0a858c240a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 tjedan",
            withPrepositionAgo: "oko 1 tjedan",
            withPrepositionIn: "oko 1 tjedan"
        },
        dual: "oko {{count}} tjedna",
        other: "oko {{count}} tjedana"
    },
    xWeeks: {
        one: {
            standalone: "1 tjedan",
            withPrepositionAgo: "1 tjedan",
            withPrepositionIn: "1 tjedan"
        },
        dual: "{{count}} tjedna",
        other: "{{count}} tjedana"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $2c426e0a858c240a$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2c426e0a858c240a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
$2c426e0a858c240a$export$2c14ff85d6318973 = $2c426e0a858c240a$var$formatDistance;


var $e9d7ad008d8c5c43$export$cbf60ecb96cbb82f;
"use strict";
$e9d7ad008d8c5c43$export$cbf60ecb96cbb82f = void 0;

const $e9d7ad008d8c5c43$var$dateFormats = {
    full: "EEEE, d. MMMM y.",
    long: "d. MMMM y.",
    medium: "d. MMM y.",
    short: "dd. MM. y."
};
const $e9d7ad008d8c5c43$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $e9d7ad008d8c5c43$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $e9d7ad008d8c5c43$var$formatLong = $e9d7ad008d8c5c43$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e9d7ad008d8c5c43$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e9d7ad008d8c5c43$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $e9d7ad008d8c5c43$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $44f163c4170bce59$export$8fbbfd65594f46a0;
"use strict";
$44f163c4170bce59$export$8fbbfd65594f46a0 = void 0;
const $44f163c4170bce59$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: "P"
};
const $44f163c4170bce59$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $44f163c4170bce59$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$44f163c4170bce59$export$8fbbfd65594f46a0 = $44f163c4170bce59$var$formatRelative;


var $1f92b5d5c80a24fb$export$b3bd0bc58e36cd63;
"use strict";
$1f92b5d5c80a24fb$export$b3bd0bc58e36cd63 = void 0;

const $1f92b5d5c80a24fb$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Kr.",
        "po. Kr."
    ],
    wide: [
        "Prije Krista",
        "Poslije Krista"
    ]
};
const $1f92b5d5c80a24fb$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $1f92b5d5c80a24fb$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        "travanj",
        "svibanj",
        "lipanj",
        "srpanj",
        "kolovoz",
        "rujan",
        "listopad",
        "studeni",
        "prosinac"
    ]
};
const $1f92b5d5c80a24fb$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        "travnja",
        "svibnja",
        "lipnja",
        "srpnja",
        "kolovoza",
        "rujna",
        "listopada",
        "studenog",
        "prosinca"
    ]
};
const $1f92b5d5c80a24fb$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $1f92b5d5c80a24fb$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $1f92b5d5c80a24fb$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
const $1f92b5d5c80a24fb$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $1f92b5d5c80a24fb$var$localize = $1f92b5d5c80a24fb$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1f92b5d5c80a24fb$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1f92b5d5c80a24fb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1f92b5d5c80a24fb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1f92b5d5c80a24fb$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $1f92b5d5c80a24fb$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1f92b5d5c80a24fb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1f92b5d5c80a24fb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1f92b5d5c80a24fb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $37a85e0f639b33ca$export$4659b591c19bdf3d;
"use strict";
$37a85e0f639b33ca$export$4659b591c19bdf3d = void 0;


const $37a85e0f639b33ca$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $37a85e0f639b33ca$var$parseOrdinalNumberPattern = /\d+/i;
const $37a85e0f639b33ca$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
const $37a85e0f639b33ca$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $37a85e0f639b33ca$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $37a85e0f639b33ca$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $37a85e0f639b33ca$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
const $37a85e0f639b33ca$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
const $37a85e0f639b33ca$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $37a85e0f639b33ca$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $37a85e0f639b33ca$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
const $37a85e0f639b33ca$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
const $37a85e0f639b33ca$var$match = $37a85e0f639b33ca$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $37a85e0f639b33ca$var$matchOrdinalNumberPattern,
        parsePattern: $37a85e0f639b33ca$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $37a85e0f639b33ca$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $37a85e0f639b33ca$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $37a85e0f639b33ca$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $37a85e0f639b33ca$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $37a85e0f639b33ca$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $37a85e0f639b33ca$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $37a85e0f639b33ca$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $37a85e0f639b33ca$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $37a85e0f639b33ca$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $37a85e0f639b33ca$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon](https://github.com/silvenon)
 * @author Manico [@manico](https://github.com/manico)
 * @author Ivan Jeržabek [@jerzabek](https://github.com/jerzabek)
 */ const $2c072b93a28f79cf$var$hr = $2c072b93a28f79cf$export$b4adb3f464574dcf = {
    code: "hr",
    formatDistance: $2c426e0a858c240a$export$2c14ff85d6318973,
    formatLong: $e9d7ad008d8c5c43$export$cbf60ecb96cbb82f,
    formatRelative: $44f163c4170bce59$export$8fbbfd65594f46a0,
    localize: $1f92b5d5c80a24fb$export$b3bd0bc58e36cd63,
    match: $37a85e0f639b33ca$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($2c072b93a28f79cf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $2c072b93a28f79cf$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $2c072b93a28f79cf$exports[key];
        }
    });
});
var $6dfc33c20ff174a4$exports = {};

$parcel$export($6dfc33c20ff174a4$exports, "ht", () => $6dfc33c20ff174a4$export$f1db1a98c1e73c14, (v) => $6dfc33c20ff174a4$export$f1db1a98c1e73c14 = v);
var $6dfc33c20ff174a4$export$f1db1a98c1e73c14;
"use strict";
$6dfc33c20ff174a4$export$f1db1a98c1e73c14 = void 0;
var $0dc12156e8eafb09$export$2c14ff85d6318973;
"use strict";
$0dc12156e8eafb09$export$2c14ff85d6318973 = void 0;
const $0dc12156e8eafb09$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mwens pase yon segond",
        other: "mwens pase {{count}} segond"
    },
    xSeconds: {
        one: "1 segond",
        other: "{{count}} segond"
    },
    halfAMinute: "30 segond",
    lessThanXMinutes: {
        one: "mwens pase yon minit",
        other: "mwens pase {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: "1 jou",
        other: "{{count}} jou"
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: "anviwon 1 mwa",
        other: "anviwon {{count}} mwa"
    },
    xMonths: {
        one: "1 mwa",
        other: "{{count}} mwa"
    },
    aboutXYears: {
        one: "anviwon 1 an",
        other: "anviwon {{count}} an"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} an"
    },
    overXYears: {
        one: "plis pase 1 an",
        other: "plis pase {{count}} an"
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
const $0dc12156e8eafb09$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $0dc12156e8eafb09$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "nan " + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
$0dc12156e8eafb09$export$2c14ff85d6318973 = $0dc12156e8eafb09$var$formatDistance;


var $7cb1e67012a41d57$export$cbf60ecb96cbb82f;
"use strict";
$7cb1e67012a41d57$export$cbf60ecb96cbb82f = void 0;

const $7cb1e67012a41d57$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $7cb1e67012a41d57$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $7cb1e67012a41d57$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $7cb1e67012a41d57$var$formatLong = $7cb1e67012a41d57$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7cb1e67012a41d57$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7cb1e67012a41d57$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $7cb1e67012a41d57$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $69c8ac9f1bb76ca5$export$8fbbfd65594f46a0;
"use strict";
$69c8ac9f1bb76ca5$export$8fbbfd65594f46a0 = void 0;
const $69c8ac9f1bb76ca5$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: "P"
};
const $69c8ac9f1bb76ca5$var$formatRelative = (token, _date, _baseDate, _options)=>$69c8ac9f1bb76ca5$var$formatRelativeLocale[token];
$69c8ac9f1bb76ca5$export$8fbbfd65594f46a0 = $69c8ac9f1bb76ca5$var$formatRelative;


var $312d387b8bc83bc1$export$b3bd0bc58e36cd63;
"use strict";
$312d387b8bc83bc1$export$b3bd0bc58e36cd63 = void 0;

const $312d387b8bc83bc1$var$eraValues = {
    narrow: [
        "av. J.-K",
        "ap. J.-K"
    ],
    abbreviated: [
        "av. J.-K",
        "ap. J.-K"
    ],
    wide: [
        "anvan Jezi Kris",
        "apre Jezi Kris"
    ]
};
const $312d387b8bc83bc1$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1ye trim.",
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
const $312d387b8bc83bc1$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "fevr.",
        "mas",
        "avr.",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "sept.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "janvye",
        "fevrye",
        "mas",
        "avril",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "septanm",
        "okt\xf2b",
        "novanm",
        "desanm"
    ]
};
const $312d387b8bc83bc1$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "le",
        "ma",
        "m\xe8",
        "je",
        "va",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "len.",
        "mad.",
        "m\xe8k.",
        "jed.",
        "van.",
        "sam."
    ],
    wide: [
        "dimanch",
        "lendi",
        "madi",
        "m\xe8kredi",
        "jedi",
        "vandredi",
        "samdi"
    ]
};
const $312d387b8bc83bc1$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "swa",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "maten",
        afternoon: "apr\xe8midi",
        evening: "swa",
        night: "maten"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "nan maten",
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: "nan maten"
    }
};
const $312d387b8bc83bc1$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    if (number === 0) return String(number);
    const suffix = number === 1 ? "ye" : "y\xe8m";
    return number + suffix;
};
const $312d387b8bc83bc1$var$localize = $312d387b8bc83bc1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $312d387b8bc83bc1$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $312d387b8bc83bc1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $312d387b8bc83bc1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $312d387b8bc83bc1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $312d387b8bc83bc1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $312d387b8bc83bc1$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $470785fd3685ceea$export$4659b591c19bdf3d;
"use strict";
$470785fd3685ceea$export$4659b591c19bdf3d = void 0;


const $470785fd3685ceea$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
const $470785fd3685ceea$var$parseOrdinalNumberPattern = /\d+/i;
const $470785fd3685ceea$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
const $470785fd3685ceea$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $470785fd3685ceea$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
const $470785fd3685ceea$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $470785fd3685ceea$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
const $470785fd3685ceea$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
const $470785fd3685ceea$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
const $470785fd3685ceea$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
const $470785fd3685ceea$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
const $470785fd3685ceea$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
const $470785fd3685ceea$var$match = $470785fd3685ceea$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $470785fd3685ceea$var$matchOrdinalNumberPattern,
        parsePattern: $470785fd3685ceea$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $470785fd3685ceea$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $470785fd3685ceea$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $470785fd3685ceea$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $470785fd3685ceea$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $470785fd3685ceea$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $470785fd3685ceea$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $470785fd3685ceea$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $470785fd3685ceea$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $470785fd3685ceea$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $470785fd3685ceea$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo](https://github.com/rmariuzzo)
 * @author Watson Marcelain [@watsongm24](https://github.com/watsongm24)
 */ const $6dfc33c20ff174a4$var$ht = $6dfc33c20ff174a4$export$f1db1a98c1e73c14 = {
    code: "ht",
    formatDistance: $0dc12156e8eafb09$export$2c14ff85d6318973,
    formatLong: $7cb1e67012a41d57$export$cbf60ecb96cbb82f,
    formatRelative: $69c8ac9f1bb76ca5$export$8fbbfd65594f46a0,
    localize: $312d387b8bc83bc1$export$b3bd0bc58e36cd63,
    match: $470785fd3685ceea$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($6dfc33c20ff174a4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $6dfc33c20ff174a4$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $6dfc33c20ff174a4$exports[key];
        }
    });
});
var $ffb644ef9becdb92$exports = {};

$parcel$export($ffb644ef9becdb92$exports, "hu", () => $ffb644ef9becdb92$export$9901d21957972d53, (v) => $ffb644ef9becdb92$export$9901d21957972d53 = v);
var $ffb644ef9becdb92$export$9901d21957972d53;
"use strict";
$ffb644ef9becdb92$export$9901d21957972d53 = void 0;
var $803b0392369044a1$export$2c14ff85d6318973;
"use strict";
$803b0392369044a1$export$2c14ff85d6318973 = void 0;
const $803b0392369044a1$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: "majdnem",
    lessthan: "kevesebb mint"
};
const $803b0392369044a1$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: " perc",
    xhours: " \xf3ra",
    xdays: " nap",
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
const $803b0392369044a1$var$withSuffixes = {
    xseconds: {
        "-1": " m\xe1sodperccel ezel\u0151tt",
        1: " m\xe1sodperc m\xfalva",
        0: " m\xe1sodperce"
    },
    halfaminute: {
        "-1": "f\xe9l perccel ezel\u0151tt",
        1: "f\xe9l perc m\xfalva",
        0: "f\xe9l perce"
    },
    xminutes: {
        "-1": " perccel ezel\u0151tt",
        1: " perc m\xfalva",
        0: " perce"
    },
    xhours: {
        "-1": " \xf3r\xe1val ezel\u0151tt",
        1: " \xf3ra m\xfalva",
        0: " \xf3r\xe1ja"
    },
    xdays: {
        "-1": " nappal ezel\u0151tt",
        1: " nap m\xfalva",
        0: " napja"
    },
    xweeks: {
        "-1": " h\xe9ttel ezel\u0151tt",
        1: " h\xe9t m\xfalva",
        0: " hete"
    },
    xmonths: {
        "-1": " h\xf3nappal ezel\u0151tt",
        1: " h\xf3nap m\xfalva",
        0: " h\xf3napja"
    },
    xyears: {
        "-1": " \xe9vvel ezel\u0151tt",
        1: " \xe9v m\xfalva",
        0: " \xe9ve"
    }
};
const $803b0392369044a1$var$formatDistance = (token, count, options)=>{
    const adverb = token.match(/about|over|almost|lessthan/i);
    const unit = adverb ? token.replace(adverb[0], "") : token;
    const addSuffix = options?.addSuffix === true;
    const key = unit.toLowerCase();
    const comparison = options?.comparison || 0;
    const translated = addSuffix ? $803b0392369044a1$var$withSuffixes[key][comparison] : $803b0392369044a1$var$withoutSuffixes[key];
    let result = key === "halfaminute" ? translated : count + translated;
    if (adverb) {
        const adv = adverb[0].toLowerCase();
        result = $803b0392369044a1$var$translations[adv] + " " + result;
    }
    return result;
};
$803b0392369044a1$export$2c14ff85d6318973 = $803b0392369044a1$var$formatDistance;


var $3dc5c815709c4de3$export$cbf60ecb96cbb82f;
"use strict";
$3dc5c815709c4de3$export$cbf60ecb96cbb82f = void 0;

const $3dc5c815709c4de3$var$dateFormats = {
    full: "y. MMMM d., EEEE",
    long: "y. MMMM d.",
    medium: "y. MMM d.",
    short: "y. MM. dd."
};
const $3dc5c815709c4de3$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $3dc5c815709c4de3$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $3dc5c815709c4de3$var$formatLong = $3dc5c815709c4de3$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3dc5c815709c4de3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3dc5c815709c4de3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $3dc5c815709c4de3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $163a901c54d93960$export$8fbbfd65594f46a0;
"use strict";
$163a901c54d93960$export$8fbbfd65594f46a0 = void 0;
const $163a901c54d93960$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    "kedden",
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    "szombaton"
];
function $163a901c54d93960$var$week(isFuture) {
    return (date)=>{
        const weekday = $163a901c54d93960$var$accusativeWeekdays[date.getDay()];
        const prefix = isFuture ? "" : "'m\xfalt' ";
        return `${prefix}'${weekday}' p'-kor'`;
    };
}
const $163a901c54d93960$var$formatRelativeLocale = {
    lastWeek: $163a901c54d93960$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $163a901c54d93960$var$week(true),
    other: "P"
};
const $163a901c54d93960$var$formatRelative = (token, date)=>{
    const format = $163a901c54d93960$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$163a901c54d93960$export$8fbbfd65594f46a0 = $163a901c54d93960$var$formatRelative;


var $0a9172c10a2cb8c9$export$b3bd0bc58e36cd63;
"use strict";
$0a9172c10a2cb8c9$export$b3bd0bc58e36cd63 = void 0;

const $0a9172c10a2cb8c9$var$eraValues = {
    narrow: [
        "ie.",
        "isz."
    ],
    abbreviated: [
        "i. e.",
        "i. sz."
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
const $0a9172c10a2cb8c9$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
const $0a9172c10a2cb8c9$var$formattingQuarterValues = {
    narrow: [
        "I.",
        "II.",
        "III.",
        "IV."
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
const $0a9172c10a2cb8c9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "\xc1",
        "M",
        "J",
        "J",
        "A",
        "Sz",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "febr.",
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        "aug.",
        "szept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        "augusztus",
        "szeptember",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
const $0a9172c10a2cb8c9$var$dayValues = {
    narrow: [
        "V",
        "H",
        "K",
        "Sz",
        "Cs",
        "P",
        "Sz"
    ],
    short: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    abbreviated: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        "kedd",
        "szerda",
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        "szombat"
    ]
};
const $0a9172c10a2cb8c9$var$dayPeriodValues = {
    narrow: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    abbreviated: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    wide: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "d\xe9lut\xe1n",
        evening: "este",
        night: "\xe9jjel"
    }
};
const $0a9172c10a2cb8c9$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $0a9172c10a2cb8c9$var$localize = $0a9172c10a2cb8c9$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0a9172c10a2cb8c9$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a9172c10a2cb8c9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a9172c10a2cb8c9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1,
        formattingValues: $0a9172c10a2cb8c9$var$formattingQuarterValues,
        defaultFormattingWidth: "wide"
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a9172c10a2cb8c9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a9172c10a2cb8c9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a9172c10a2cb8c9$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $baf05eedb650b791$export$4659b591c19bdf3d;
"use strict";
$baf05eedb650b791$export$4659b591c19bdf3d = void 0;


const $baf05eedb650b791$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $baf05eedb650b791$var$parseOrdinalNumberPattern = /\d+/i;
const $baf05eedb650b791$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
const $baf05eedb650b791$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
const $baf05eedb650b791$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
const $baf05eedb650b791$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
const $baf05eedb650b791$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
const $baf05eedb650b791$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $baf05eedb650b791$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
const $baf05eedb650b791$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
const $baf05eedb650b791$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
const $baf05eedb650b791$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
const $baf05eedb650b791$var$match = $baf05eedb650b791$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $baf05eedb650b791$var$matchOrdinalNumberPattern,
        parsePattern: $baf05eedb650b791$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $baf05eedb650b791$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $baf05eedb650b791$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $baf05eedb650b791$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $baf05eedb650b791$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $baf05eedb650b791$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $baf05eedb650b791$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $baf05eedb650b791$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $baf05eedb650b791$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $baf05eedb650b791$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $baf05eedb650b791$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 * @author Zoltan Szepesi [@twodcube](https://github.com/twodcube)
 */ const $ffb644ef9becdb92$var$hu = $ffb644ef9becdb92$export$9901d21957972d53 = {
    code: "hu",
    formatDistance: $803b0392369044a1$export$2c14ff85d6318973,
    formatLong: $3dc5c815709c4de3$export$cbf60ecb96cbb82f,
    formatRelative: $163a901c54d93960$export$8fbbfd65594f46a0,
    localize: $0a9172c10a2cb8c9$export$b3bd0bc58e36cd63,
    match: $baf05eedb650b791$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($ffb644ef9becdb92$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $ffb644ef9becdb92$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $ffb644ef9becdb92$exports[key];
        }
    });
});
var $afb6ce146c61a55a$exports = {};

$parcel$export($afb6ce146c61a55a$exports, "hy", () => $afb6ce146c61a55a$export$2fe4a56bcaea74cb, (v) => $afb6ce146c61a55a$export$2fe4a56bcaea74cb = v);
var $afb6ce146c61a55a$export$2fe4a56bcaea74cb;
"use strict";
$afb6ce146c61a55a$export$2fe4a56bcaea74cb = void 0;
var $2b30fdea6bd1afe0$export$2c14ff85d6318973;
"use strict";
$2b30fdea6bd1afe0$export$2c14ff85d6318973 = void 0;
const $2b30fdea6bd1afe0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
const $2b30fdea6bd1afe0$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2b30fdea6bd1afe0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
$2b30fdea6bd1afe0$export$2c14ff85d6318973 = $2b30fdea6bd1afe0$var$formatDistance;


var $83a5a1316343fa80$export$cbf60ecb96cbb82f;
"use strict";
$83a5a1316343fa80$export$cbf60ecb96cbb82f = void 0;

const $83a5a1316343fa80$var$dateFormats = {
    full: "d MMMM, y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd.MM.yyyy"
};
const $83a5a1316343fa80$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $83a5a1316343fa80$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $83a5a1316343fa80$var$formatLong = $83a5a1316343fa80$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $83a5a1316343fa80$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $83a5a1316343fa80$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $83a5a1316343fa80$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $c574006ba2892868$export$8fbbfd65594f46a0;
"use strict";
$c574006ba2892868$export$8fbbfd65594f46a0 = void 0;
const $c574006ba2892868$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: "P"
};
const $c574006ba2892868$var$formatRelative = (token, _date, _baseDate, _options)=>$c574006ba2892868$var$formatRelativeLocale[token];
$c574006ba2892868$export$8fbbfd65594f46a0 = $c574006ba2892868$var$formatRelative;


var $147412261dea893f$export$b3bd0bc58e36cd63;
"use strict";
$147412261dea893f$export$b3bd0bc58e36cd63 = void 0;

const $147412261dea893f$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
const $147412261dea893f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
const $147412261dea893f$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
const $147412261dea893f$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
const $147412261dea893f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
const $147412261dea893f$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
const $147412261dea893f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
const $147412261dea893f$var$localize = $147412261dea893f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $147412261dea893f$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $147412261dea893f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $147412261dea893f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $147412261dea893f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $147412261dea893f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $147412261dea893f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $147412261dea893f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $79067cb2598c145c$export$4659b591c19bdf3d;
"use strict";
$79067cb2598c145c$export$4659b591c19bdf3d = void 0;


const $79067cb2598c145c$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
const $79067cb2598c145c$var$parseOrdinalNumberPattern = /\d+/i;
const $79067cb2598c145c$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
const $79067cb2598c145c$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
const $79067cb2598c145c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
const $79067cb2598c145c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $79067cb2598c145c$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
const $79067cb2598c145c$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
const $79067cb2598c145c$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
const $79067cb2598c145c$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
const $79067cb2598c145c$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
const $79067cb2598c145c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
const $79067cb2598c145c$var$match = $79067cb2598c145c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $79067cb2598c145c$var$matchOrdinalNumberPattern,
        parsePattern: $79067cb2598c145c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $79067cb2598c145c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79067cb2598c145c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $79067cb2598c145c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79067cb2598c145c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $79067cb2598c145c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79067cb2598c145c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $79067cb2598c145c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $79067cb2598c145c$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $79067cb2598c145c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $79067cb2598c145c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan](https://github.com/alexigityan)
 */ const $afb6ce146c61a55a$var$hy = $afb6ce146c61a55a$export$2fe4a56bcaea74cb = {
    code: "hy",
    formatDistance: $2b30fdea6bd1afe0$export$2c14ff85d6318973,
    formatLong: $83a5a1316343fa80$export$cbf60ecb96cbb82f,
    formatRelative: $c574006ba2892868$export$8fbbfd65594f46a0,
    localize: $147412261dea893f$export$b3bd0bc58e36cd63,
    match: $79067cb2598c145c$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($afb6ce146c61a55a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $afb6ce146c61a55a$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $afb6ce146c61a55a$exports[key];
        }
    });
});
var $2bb67e781aeb519b$exports = {};

$parcel$export($2bb67e781aeb519b$exports, "id", () => $2bb67e781aeb519b$export$d560c7e4a29451c2, (v) => $2bb67e781aeb519b$export$d560c7e4a29451c2 = v);
var $2bb67e781aeb519b$export$d560c7e4a29451c2;
"use strict";
$2bb67e781aeb519b$export$d560c7e4a29451c2 = void 0;
var $b6f7c8d87bd579e1$export$2c14ff85d6318973;
"use strict";
$b6f7c8d87bd579e1$export$2c14ff85d6318973 = void 0;
const $b6f7c8d87bd579e1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 detik",
        other: "kurang dari {{count}} detik"
    },
    xSeconds: {
        one: "1 detik",
        other: "{{count}} detik"
    },
    halfAMinute: "setengah menit",
    lessThanXMinutes: {
        one: "kurang dari 1 menit",
        other: "kurang dari {{count}} menit"
    },
    xMinutes: {
        one: "1 menit",
        other: "{{count}} menit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
const $b6f7c8d87bd579e1$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $b6f7c8d87bd579e1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam waktu " + result;
        else return result + " yang lalu";
    }
    return result;
};
$b6f7c8d87bd579e1$export$2c14ff85d6318973 = $b6f7c8d87bd579e1$var$formatDistance;


var $ecf629663975859e$export$cbf60ecb96cbb82f;
"use strict";
$ecf629663975859e$export$cbf60ecb96cbb82f = void 0;

const $ecf629663975859e$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
const $ecf629663975859e$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
const $ecf629663975859e$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $ecf629663975859e$var$formatLong = $ecf629663975859e$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ecf629663975859e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ecf629663975859e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ecf629663975859e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $9270aabbec49da3d$export$8fbbfd65594f46a0;
"use strict";
$9270aabbec49da3d$export$8fbbfd65594f46a0 = void 0;
const $9270aabbec49da3d$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: "P"
};
const $9270aabbec49da3d$var$formatRelative = (token, _date, _baseDate, _options)=>$9270aabbec49da3d$var$formatRelativeLocale[token];
$9270aabbec49da3d$export$8fbbfd65594f46a0 = $9270aabbec49da3d$var$formatRelative;


var $b5aa17c2c283a12b$export$b3bd0bc58e36cd63;
"use strict";
$b5aa17c2c283a12b$export$b3bd0bc58e36cd63 = void 0;

// All data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/id.html
const $b5aa17c2c283a12b$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masehi",
        "Masehi"
    ]
};
const $b5aa17c2c283a12b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "Kuartal ke-1",
        "Kuartal ke-2",
        "Kuartal ke-3",
        "Kuartal ke-4"
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $b5aa17c2c283a12b$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agt",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
const $b5aa17c2c283a12b$var$dayValues = {
    narrow: [
        "M",
        "S",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    wide: [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
    ]
};
const $b5aa17c2c283a12b$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
const $b5aa17c2c283a12b$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
const $b5aa17c2c283a12b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + number;
};
const $b5aa17c2c283a12b$var$localize = $b5aa17c2c283a12b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b5aa17c2c283a12b$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b5aa17c2c283a12b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b5aa17c2c283a12b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b5aa17c2c283a12b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b5aa17c2c283a12b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b5aa17c2c283a12b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b5aa17c2c283a12b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $e023f6a4a8f6596a$export$4659b591c19bdf3d;
"use strict";
$e023f6a4a8f6596a$export$4659b591c19bdf3d = void 0;


const $e023f6a4a8f6596a$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
const $e023f6a4a8f6596a$var$parseOrdinalNumberPattern = /\d+/i;
const $e023f6a4a8f6596a$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
const $e023f6a4a8f6596a$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
const $e023f6a4a8f6596a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
const $e023f6a4a8f6596a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e023f6a4a8f6596a$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
const $e023f6a4a8f6596a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $e023f6a4a8f6596a$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
const $e023f6a4a8f6596a$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
const $e023f6a4a8f6596a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
const $e023f6a4a8f6596a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
const $e023f6a4a8f6596a$var$match = $e023f6a4a8f6596a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $e023f6a4a8f6596a$var$matchOrdinalNumberPattern,
        parsePattern: $e023f6a4a8f6596a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e023f6a4a8f6596a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e023f6a4a8f6596a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e023f6a4a8f6596a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e023f6a4a8f6596a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e023f6a4a8f6596a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e023f6a4a8f6596a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e023f6a4a8f6596a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e023f6a4a8f6596a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e023f6a4a8f6596a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e023f6a4a8f6596a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso](https://github.com/rbudiharso)
 * @author Benget Nata [@bentinata](https://github.com/bentinata)
 * @author Budi Irawan [@deerawan](https://github.com/deerawan)
 * @author Try Ajitiono [@imballinst](https://github.com/imballinst)
 */ const $2bb67e781aeb519b$var$id = $2bb67e781aeb519b$export$d560c7e4a29451c2 = {
    code: "id",
    formatDistance: $b6f7c8d87bd579e1$export$2c14ff85d6318973,
    formatLong: $ecf629663975859e$export$cbf60ecb96cbb82f,
    formatRelative: $9270aabbec49da3d$export$8fbbfd65594f46a0,
    localize: $b5aa17c2c283a12b$export$b3bd0bc58e36cd63,
    match: $e023f6a4a8f6596a$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($2bb67e781aeb519b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $2bb67e781aeb519b$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $2bb67e781aeb519b$exports[key];
        }
    });
});
var $740cb022f7e34cfd$exports = {};

$parcel$export($740cb022f7e34cfd$exports, "is", () => $740cb022f7e34cfd$export$226b3eccf92c9ed9, (v) => $740cb022f7e34cfd$export$226b3eccf92c9ed9 = v);
var $740cb022f7e34cfd$export$226b3eccf92c9ed9;
"use strict";
$740cb022f7e34cfd$export$226b3eccf92c9ed9 = void 0;
var $6aa04ae69c01eb28$export$2c14ff85d6318973;
"use strict";
$6aa04ae69c01eb28$export$2c14ff85d6318973 = void 0;
const $6aa04ae69c01eb28$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: "1 klukkustund",
        other: "{{count}} klukkustundir"
    },
    xDays: {
        one: "1 dagur",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "um viku",
        other: "um {{count}} vikur"
    },
    xWeeks: {
        one: "1 viku",
        other: "{{count}} vikur"
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
const $6aa04ae69c01eb28$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $6aa04ae69c01eb28$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
$6aa04ae69c01eb28$export$2c14ff85d6318973 = $6aa04ae69c01eb28$var$formatDistance;


var $a9939973ee90e2ea$export$cbf60ecb96cbb82f;
"use strict";
$a9939973ee90e2ea$export$cbf60ecb96cbb82f = void 0;

const $a9939973ee90e2ea$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "d.MM.y"
};
const $a9939973ee90e2ea$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a9939973ee90e2ea$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $a9939973ee90e2ea$var$formatLong = $a9939973ee90e2ea$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a9939973ee90e2ea$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a9939973ee90e2ea$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a9939973ee90e2ea$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $dab774f1ed18a042$export$8fbbfd65594f46a0;
"use strict";
$dab774f1ed18a042$export$8fbbfd65594f46a0 = void 0;
const $dab774f1ed18a042$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: "P"
};
const $dab774f1ed18a042$var$formatRelative = (token, _date, _baseDate, _options)=>$dab774f1ed18a042$var$formatRelativeLocale[token];
$dab774f1ed18a042$export$8fbbfd65594f46a0 = $dab774f1ed18a042$var$formatRelative;


var $7da65d9d4611becb$export$b3bd0bc58e36cd63;
"use strict";
$7da65d9d4611becb$export$b3bd0bc58e36cd63 = void 0;

const $7da65d9d4611becb$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "fyrir Krist",
        "eftir Krist"
    ]
};
const $7da65d9d4611becb$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1F",
        "2F",
        "3F",
        "4F"
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
const $7da65d9d4611becb$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "\xc1",
        "S",
        "\xd3",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "sept.",
        "okt.",
        "n\xf3v.",
        "des."
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "september",
        "okt\xf3ber",
        "n\xf3vember",
        "desember"
    ]
};
const $7da65d9d4611becb$var$dayValues = {
    narrow: [
        "S",
        "M",
        "\xde",
        "M",
        "F",
        "F",
        "L"
    ],
    short: [
        "Su",
        "M\xe1",
        "\xder",
        "Mi",
        "Fi",
        "F\xf6",
        "La"
    ],
    abbreviated: [
        "sun.",
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        "fim.",
        "f\xf6s.",
        "lau."
    ],
    wide: [
        "sunnudagur",
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        "fimmtudagur",
        "f\xf6studagur",
        "laugardagur"
    ]
};
const $7da65d9d4611becb$var$dayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
const $7da65d9d4611becb$var$formattingDayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
const $7da65d9d4611becb$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $7da65d9d4611becb$var$localize = $7da65d9d4611becb$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7da65d9d4611becb$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7da65d9d4611becb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7da65d9d4611becb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7da65d9d4611becb$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7da65d9d4611becb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7da65d9d4611becb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7da65d9d4611becb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $80f70ee722ae8372$export$4659b591c19bdf3d;
"use strict";
$80f70ee722ae8372$export$4659b591c19bdf3d = void 0;


const $80f70ee722ae8372$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $80f70ee722ae8372$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
const $80f70ee722ae8372$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
const $80f70ee722ae8372$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
const $80f70ee722ae8372$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
const $80f70ee722ae8372$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
const $80f70ee722ae8372$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
const $80f70ee722ae8372$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
const $80f70ee722ae8372$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
const $80f70ee722ae8372$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
const $80f70ee722ae8372$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
const $80f70ee722ae8372$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
const $80f70ee722ae8372$var$match = $80f70ee722ae8372$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $80f70ee722ae8372$var$matchOrdinalNumberPattern,
        parsePattern: $80f70ee722ae8372$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f70ee722ae8372$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f70ee722ae8372$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f70ee722ae8372$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f70ee722ae8372$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f70ee722ae8372$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f70ee722ae8372$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f70ee722ae8372$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $80f70ee722ae8372$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $80f70ee722ae8372$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $80f70ee722ae8372$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank](https://github.com/derekblank)
 * @author Arnór Ýmir [@lamayg](https://github.com/lamayg)
 */ const $740cb022f7e34cfd$var$is = $740cb022f7e34cfd$export$226b3eccf92c9ed9 = {
    code: "is",
    formatDistance: $6aa04ae69c01eb28$export$2c14ff85d6318973,
    formatLong: $a9939973ee90e2ea$export$cbf60ecb96cbb82f,
    formatRelative: $dab774f1ed18a042$export$8fbbfd65594f46a0,
    localize: $7da65d9d4611becb$export$b3bd0bc58e36cd63,
    match: $80f70ee722ae8372$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($740cb022f7e34cfd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $740cb022f7e34cfd$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $740cb022f7e34cfd$exports[key];
        }
    });
});
var $b9d904f5e0c07a1d$exports = {};

$parcel$export($b9d904f5e0c07a1d$exports, "it", () => $b9d904f5e0c07a1d$export$3486a10f30cf1ee4, (v) => $b9d904f5e0c07a1d$export$3486a10f30cf1ee4 = v);
var $b9d904f5e0c07a1d$export$3486a10f30cf1ee4;
"use strict";
$b9d904f5e0c07a1d$export$3486a10f30cf1ee4 = void 0;
var $fc6f39ad3352ef94$export$2c14ff85d6318973;
"use strict";
$fc6f39ad3352ef94$export$2c14ff85d6318973 = void 0;
const $fc6f39ad3352ef94$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
const $fc6f39ad3352ef94$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $fc6f39ad3352ef94$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};
$fc6f39ad3352ef94$export$2c14ff85d6318973 = $fc6f39ad3352ef94$var$formatDistance;


var $9ca178cb3cbda2ef$export$cbf60ecb96cbb82f;
"use strict";
$9ca178cb3cbda2ef$export$cbf60ecb96cbb82f = void 0;

const $9ca178cb3cbda2ef$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $9ca178cb3cbda2ef$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $9ca178cb3cbda2ef$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $9ca178cb3cbda2ef$var$formatLong = $9ca178cb3cbda2ef$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9ca178cb3cbda2ef$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9ca178cb3cbda2ef$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9ca178cb3cbda2ef$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $d14fc81075c5407b$export$8fbbfd65594f46a0;
"use strict";
$d14fc81075c5407b$export$8fbbfd65594f46a0 = void 0;

const $d14fc81075c5407b$var$weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function $d14fc81075c5407b$var$lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $d14fc81075c5407b$var$weekdays[day] + " scorso alle' p";
    }
}
function $d14fc81075c5407b$var$thisWeek(day) {
    return "'" + $d14fc81075c5407b$var$weekdays[day] + " alle' p";
}
function $d14fc81075c5407b$var$nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $d14fc81075c5407b$var$weekdays[day] + " prossimo alle' p";
    }
}
const $d14fc81075c5407b$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $d14fc81075c5407b$var$thisWeek(day);
        else return $d14fc81075c5407b$var$lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $d14fc81075c5407b$var$thisWeek(day);
        else return $d14fc81075c5407b$var$nextWeek(day);
    },
    other: "P"
};
const $d14fc81075c5407b$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $d14fc81075c5407b$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$d14fc81075c5407b$export$8fbbfd65594f46a0 = $d14fc81075c5407b$var$formatRelative;


var $2855516dc0e3d029$export$b3bd0bc58e36cd63;
"use strict";
$2855516dc0e3d029$export$b3bd0bc58e36cd63 = void 0;

const $2855516dc0e3d029$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
const $2855516dc0e3d029$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $2855516dc0e3d029$var$monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
const $2855516dc0e3d029$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
const $2855516dc0e3d029$var$dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
const $2855516dc0e3d029$var$formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
const $2855516dc0e3d029$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return String(number);
};
const $2855516dc0e3d029$var$localize = $2855516dc0e3d029$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2855516dc0e3d029$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2855516dc0e3d029$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2855516dc0e3d029$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2855516dc0e3d029$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2855516dc0e3d029$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2855516dc0e3d029$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2855516dc0e3d029$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $120c68da6ca7b0d8$export$4659b591c19bdf3d;
"use strict";
$120c68da6ca7b0d8$export$4659b591c19bdf3d = void 0;


const $120c68da6ca7b0d8$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $120c68da6ca7b0d8$var$parseOrdinalNumberPattern = /\d+/i;
const $120c68da6ca7b0d8$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
const $120c68da6ca7b0d8$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
const $120c68da6ca7b0d8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $120c68da6ca7b0d8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $120c68da6ca7b0d8$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
const $120c68da6ca7b0d8$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $120c68da6ca7b0d8$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
const $120c68da6ca7b0d8$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
const $120c68da6ca7b0d8$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
const $120c68da6ca7b0d8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
const $120c68da6ca7b0d8$var$match = $120c68da6ca7b0d8$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $120c68da6ca7b0d8$var$matchOrdinalNumberPattern,
        parsePattern: $120c68da6ca7b0d8$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $120c68da6ca7b0d8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120c68da6ca7b0d8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $120c68da6ca7b0d8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120c68da6ca7b0d8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $120c68da6ca7b0d8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120c68da6ca7b0d8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $120c68da6ca7b0d8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120c68da6ca7b0d8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $120c68da6ca7b0d8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $120c68da6ca7b0d8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo](https://github.com/albertorestifo)
 * @author Giovanni Polimeni [@giofilo](https://github.com/giofilo)
 * @author Vincenzo Carrese [@vin-car](https://github.com/vin-car)
 */ const $b9d904f5e0c07a1d$var$it = $b9d904f5e0c07a1d$export$3486a10f30cf1ee4 = {
    code: "it",
    formatDistance: $fc6f39ad3352ef94$export$2c14ff85d6318973,
    formatLong: $9ca178cb3cbda2ef$export$cbf60ecb96cbb82f,
    formatRelative: $d14fc81075c5407b$export$8fbbfd65594f46a0,
    localize: $2855516dc0e3d029$export$b3bd0bc58e36cd63,
    match: $120c68da6ca7b0d8$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($b9d904f5e0c07a1d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $b9d904f5e0c07a1d$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $b9d904f5e0c07a1d$exports[key];
        }
    });
});
var $a19b534d697b8873$exports = {};

$parcel$export($a19b534d697b8873$exports, "itCH", () => $a19b534d697b8873$export$a3f860f37034c31a, (v) => $a19b534d697b8873$export$a3f860f37034c31a = v);
var $a19b534d697b8873$export$a3f860f37034c31a;
"use strict";
$a19b534d697b8873$export$a3f860f37034c31a = void 0;




var $69aef85ebe5bb83b$export$cbf60ecb96cbb82f;
"use strict";
$69aef85ebe5bb83b$export$cbf60ecb96cbb82f = void 0;

const $69aef85ebe5bb83b$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $69aef85ebe5bb83b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $69aef85ebe5bb83b$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $69aef85ebe5bb83b$var$formatLong = $69aef85ebe5bb83b$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $69aef85ebe5bb83b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $69aef85ebe5bb83b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $69aef85ebe5bb83b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


/**
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66](https://github.com/maic66)
 */ const $a19b534d697b8873$var$itCH = $a19b534d697b8873$export$a3f860f37034c31a = {
    code: "it-CH",
    formatDistance: $fc6f39ad3352ef94$export$2c14ff85d6318973,
    formatLong: $69aef85ebe5bb83b$export$cbf60ecb96cbb82f,
    formatRelative: $d14fc81075c5407b$export$8fbbfd65594f46a0,
    localize: $2855516dc0e3d029$export$b3bd0bc58e36cd63,
    match: $120c68da6ca7b0d8$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($a19b534d697b8873$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $a19b534d697b8873$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $a19b534d697b8873$exports[key];
        }
    });
});
var $bde5f91ca08bde8e$exports = {};

$parcel$export($bde5f91ca08bde8e$exports, "ja", () => $bde5f91ca08bde8e$export$8c6f505e9474ce90, (v) => $bde5f91ca08bde8e$export$8c6f505e9474ce90 = v);
var $bde5f91ca08bde8e$export$8c6f505e9474ce90;
"use strict";
$bde5f91ca08bde8e$export$8c6f505e9474ce90 = void 0;
var $194114d1112c2f4e$export$2c14ff85d6318973;
"use strict";
$194114d1112c2f4e$export$2c14ff85d6318973 = void 0;
const $194114d1112c2f4e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
const $194114d1112c2f4e$var$formatDistance = (token, count, options)=>{
    options = options || {};
    let result;
    const tokenValue = $194114d1112c2f4e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
$194114d1112c2f4e$export$2c14ff85d6318973 = $194114d1112c2f4e$var$formatDistance;


var $c507fe1a191b98df$export$cbf60ecb96cbb82f;
"use strict";
$c507fe1a191b98df$export$cbf60ecb96cbb82f = void 0;

const $c507fe1a191b98df$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
const $c507fe1a191b98df$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $c507fe1a191b98df$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $c507fe1a191b98df$var$formatLong = $c507fe1a191b98df$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c507fe1a191b98df$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c507fe1a191b98df$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c507fe1a191b98df$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $43ea8901cf36bac0$export$8fbbfd65594f46a0;
"use strict";
$43ea8901cf36bac0$export$8fbbfd65594f46a0 = void 0;
const $43ea8901cf36bac0$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: "P"
};
const $43ea8901cf36bac0$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $43ea8901cf36bac0$var$formatRelativeLocale[token];
};
$43ea8901cf36bac0$export$8fbbfd65594f46a0 = $43ea8901cf36bac0$var$formatRelative;


var $203797dcb04f7c7f$export$b3bd0bc58e36cd63;
"use strict";
$203797dcb04f7c7f$export$b3bd0bc58e36cd63 = void 0;

const $203797dcb04f7c7f$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
const $203797dcb04f7c7f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
const $203797dcb04f7c7f$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
const $203797dcb04f7c7f$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
const $203797dcb04f7c7f$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
const $203797dcb04f7c7f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
const $203797dcb04f7c7f$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "year":
            return `${number}\u{5E74}`;
        case "quarter":
            return `\u{7B2C}${number}\u{56DB}\u{534A}\u{671F}`;
        case "month":
            return `${number}\u{6708}`;
        case "week":
            return `\u{7B2C}${number}\u{9031}`;
        case "date":
            return `${number}\u{65E5}`;
        case "hour":
            return `${number}\u{6642}`;
        case "minute":
            return `${number}\u{5206}`;
        case "second":
            return `${number}\u{79D2}`;
        default:
            return `${number}`;
    }
};
const $203797dcb04f7c7f$var$localize = $203797dcb04f7c7f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $203797dcb04f7c7f$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $203797dcb04f7c7f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $203797dcb04f7c7f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $203797dcb04f7c7f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $203797dcb04f7c7f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $203797dcb04f7c7f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $203797dcb04f7c7f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $e911d96a773f0f78$export$4659b591c19bdf3d;
"use strict";
$e911d96a773f0f78$export$4659b591c19bdf3d = void 0;


const $e911d96a773f0f78$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
const $e911d96a773f0f78$var$parseOrdinalNumberPattern = /\d+/i;
const $e911d96a773f0f78$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
const $e911d96a773f0f78$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
const $e911d96a773f0f78$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
const $e911d96a773f0f78$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
const $e911d96a773f0f78$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
const $e911d96a773f0f78$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $e911d96a773f0f78$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
const $e911d96a773f0f78$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
const $e911d96a773f0f78$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
const $e911d96a773f0f78$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
const $e911d96a773f0f78$var$match = $e911d96a773f0f78$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $e911d96a773f0f78$var$matchOrdinalNumberPattern,
        parsePattern: $e911d96a773f0f78$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e911d96a773f0f78$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e911d96a773f0f78$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e911d96a773f0f78$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e911d96a773f0f78$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e911d96a773f0f78$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e911d96a773f0f78$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e911d96a773f0f78$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e911d96a773f0f78$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e911d96a773f0f78$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e911d96a773f0f78$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Yamagishi Kazutoshi [@ykzts](https://github.com/ykzts)
 * @author Luca Ban [@mesqueeb](https://github.com/mesqueeb)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */ const $bde5f91ca08bde8e$var$ja = $bde5f91ca08bde8e$export$8c6f505e9474ce90 = {
    code: "ja",
    formatDistance: $194114d1112c2f4e$export$2c14ff85d6318973,
    formatLong: $c507fe1a191b98df$export$cbf60ecb96cbb82f,
    formatRelative: $43ea8901cf36bac0$export$8fbbfd65594f46a0,
    localize: $203797dcb04f7c7f$export$b3bd0bc58e36cd63,
    match: $e911d96a773f0f78$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($bde5f91ca08bde8e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $bde5f91ca08bde8e$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $bde5f91ca08bde8e$exports[key];
        }
    });
});
var $5116ddba24f17815$exports = {};

$parcel$export($5116ddba24f17815$exports, "jaHira", () => $5116ddba24f17815$export$f0ae70b1ccde4a97, (v) => $5116ddba24f17815$export$f0ae70b1ccde4a97 = v);
var $5116ddba24f17815$export$f0ae70b1ccde4a97;
"use strict";
$5116ddba24f17815$export$f0ae70b1ccde4a97 = void 0;
var $e0f69e96c286542e$export$2c14ff85d6318973;
"use strict";
$e0f69e96c286542e$export$2c14ff85d6318973 = void 0;
const $e0f69e96c286542e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
const $e0f69e96c286542e$var$formatDistance = (token, count, options)=>{
    options = options || {};
    let result;
    const tokenValue = $e0f69e96c286542e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
$e0f69e96c286542e$export$2c14ff85d6318973 = $e0f69e96c286542e$var$formatDistance;


var $cbc05dfe63b85b09$export$cbf60ecb96cbb82f;
"use strict";
$cbc05dfe63b85b09$export$cbf60ecb96cbb82f = void 0;

const $cbc05dfe63b85b09$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
const $cbc05dfe63b85b09$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $cbc05dfe63b85b09$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $cbc05dfe63b85b09$var$formatLong = $cbc05dfe63b85b09$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $cbc05dfe63b85b09$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $cbc05dfe63b85b09$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $cbc05dfe63b85b09$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $7c4ed15a08b14ad1$export$8fbbfd65594f46a0;
"use strict";
$7c4ed15a08b14ad1$export$8fbbfd65594f46a0 = void 0;
const $7c4ed15a08b14ad1$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: "P"
};
const $7c4ed15a08b14ad1$var$formatRelative = (token, _date, _baseDate, _options)=>{
    return $7c4ed15a08b14ad1$var$formatRelativeLocale[token];
};
$7c4ed15a08b14ad1$export$8fbbfd65594f46a0 = $7c4ed15a08b14ad1$var$formatRelative;


var $0a91ef138ff908fb$export$b3bd0bc58e36cd63;
"use strict";
$0a91ef138ff908fb$export$b3bd0bc58e36cd63 = void 0;

const $0a91ef138ff908fb$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
const $0a91ef138ff908fb$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
const $0a91ef138ff908fb$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
const $0a91ef138ff908fb$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
const $0a91ef138ff908fb$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
const $0a91ef138ff908fb$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
const $0a91ef138ff908fb$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "year":
            return `${number}\u{306D}\u{3093}`;
        case "quarter":
            return `\u{3060}\u{3044}${number}\u{3057}\u{306F}\u{3093}\u{304D}`;
        case "month":
            return `${number}\u{304C}\u{3064}`;
        case "week":
            return `\u{3060}\u{3044}${number}\u{3057}\u{3085}\u{3046}`;
        case "date":
            return `${number}\u{306B}\u{3061}`;
        case "hour":
            return `${number}\u{3058}`;
        case "minute":
            return `${number}\u{3075}\u{3093}`;
        case "second":
            return `${number}\u{3073}\u{3087}\u{3046}`;
        default:
            return `${number}`;
    }
};
const $0a91ef138ff908fb$var$localize = $0a91ef138ff908fb$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0a91ef138ff908fb$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a91ef138ff908fb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a91ef138ff908fb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a91ef138ff908fb$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a91ef138ff908fb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0a91ef138ff908fb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0a91ef138ff908fb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $7603317233b36fde$export$4659b591c19bdf3d;
"use strict";
$7603317233b36fde$export$4659b591c19bdf3d = void 0;


const $7603317233b36fde$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
const $7603317233b36fde$var$parseOrdinalNumberPattern = /\d+/i;
const $7603317233b36fde$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
const $7603317233b36fde$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
const $7603317233b36fde$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
const $7603317233b36fde$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
const $7603317233b36fde$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
const $7603317233b36fde$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $7603317233b36fde$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
const $7603317233b36fde$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
const $7603317233b36fde$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
const $7603317233b36fde$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
const $7603317233b36fde$var$match = $7603317233b36fde$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $7603317233b36fde$var$matchOrdinalNumberPattern,
        parsePattern: $7603317233b36fde$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7603317233b36fde$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7603317233b36fde$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7603317233b36fde$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7603317233b36fde$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7603317233b36fde$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7603317233b36fde$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7603317233b36fde$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7603317233b36fde$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7603317233b36fde$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7603317233b36fde$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo](https://github.com/Eritutteo)
 */ const $5116ddba24f17815$var$jaHira = $5116ddba24f17815$export$f0ae70b1ccde4a97 = {
    code: "ja-Hira",
    formatDistance: $e0f69e96c286542e$export$2c14ff85d6318973,
    formatLong: $cbc05dfe63b85b09$export$cbf60ecb96cbb82f,
    formatRelative: $7c4ed15a08b14ad1$export$8fbbfd65594f46a0,
    localize: $0a91ef138ff908fb$export$b3bd0bc58e36cd63,
    match: $7603317233b36fde$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($5116ddba24f17815$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $5116ddba24f17815$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $5116ddba24f17815$exports[key];
        }
    });
});
var $fbcd824e2e6dd738$exports = {};

$parcel$export($fbcd824e2e6dd738$exports, "ka", () => $fbcd824e2e6dd738$export$b20f780fa2c7402, (v) => $fbcd824e2e6dd738$export$b20f780fa2c7402 = v);
var $fbcd824e2e6dd738$export$b20f780fa2c7402;
"use strict";
$fbcd824e2e6dd738$export$b20f780fa2c7402 = void 0;
var $be8651a1e54763ae$export$2c14ff85d6318973;
"use strict";
$be8651a1e54763ae$export$2c14ff85d6318973 = void 0;
const $be8651a1e54763ae$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
const $be8651a1e54763ae$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $be8651a1e54763ae$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (options?.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace("{{count}}", String(count));
    else if (options?.addSuffix) result = tokenValue.past.replace("{{count}}", String(count));
    else result = tokenValue.present.replace("{{count}}", String(count));
    return result;
};
$be8651a1e54763ae$export$2c14ff85d6318973 = $be8651a1e54763ae$var$formatDistance;


var $b4632e56e0c4ec16$export$cbf60ecb96cbb82f;
"use strict";
$b4632e56e0c4ec16$export$cbf60ecb96cbb82f = void 0;

const $b4632e56e0c4ec16$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do, MMMM, y",
    medium: "d, MMM, y",
    short: "dd/MM/yyyy"
};
const $b4632e56e0c4ec16$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $b4632e56e0c4ec16$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $b4632e56e0c4ec16$var$formatLong = $b4632e56e0c4ec16$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $b4632e56e0c4ec16$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $b4632e56e0c4ec16$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $b4632e56e0c4ec16$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $6bbffe9887712967$export$8fbbfd65594f46a0;
"use strict";
$6bbffe9887712967$export$8fbbfd65594f46a0 = void 0;
const $6bbffe9887712967$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: "P"
};
const $6bbffe9887712967$var$formatRelative = (token, _date, _baseDate, _options)=>$6bbffe9887712967$var$formatRelativeLocale[token];
$6bbffe9887712967$export$8fbbfd65594f46a0 = $6bbffe9887712967$var$formatRelative;


var $cb38f01537a2ac30$export$b3bd0bc58e36cd63;
"use strict";
$cb38f01537a2ac30$export$b3bd0bc58e36cd63 = void 0;

const $cb38f01537a2ac30$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
const $cb38f01537a2ac30$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $cb38f01537a2ac30$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
const $cb38f01537a2ac30$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
const $cb38f01537a2ac30$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
const $cb38f01537a2ac30$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
const $cb38f01537a2ac30$var$ordinalNumber = (dirtyNumber)=>{
    const number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
const $cb38f01537a2ac30$var$localize = $cb38f01537a2ac30$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $cb38f01537a2ac30$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $cb38f01537a2ac30$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $cb38f01537a2ac30$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $cb38f01537a2ac30$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $cb38f01537a2ac30$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $cb38f01537a2ac30$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $cb38f01537a2ac30$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $ac1cac641a61d75e$export$4659b591c19bdf3d;
"use strict";
$ac1cac641a61d75e$export$4659b591c19bdf3d = void 0;


const $ac1cac641a61d75e$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
const $ac1cac641a61d75e$var$parseOrdinalNumberPattern = /\d+/i;
const $ac1cac641a61d75e$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
const $ac1cac641a61d75e$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
const $ac1cac641a61d75e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
const $ac1cac641a61d75e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ac1cac641a61d75e$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
const $ac1cac641a61d75e$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
const $ac1cac641a61d75e$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
const $ac1cac641a61d75e$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
const $ac1cac641a61d75e$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
const $ac1cac641a61d75e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
const $ac1cac641a61d75e$var$match = $ac1cac641a61d75e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $ac1cac641a61d75e$var$matchOrdinalNumberPattern,
        parsePattern: $ac1cac641a61d75e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ac1cac641a61d75e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac1cac641a61d75e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ac1cac641a61d75e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac1cac641a61d75e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ac1cac641a61d75e$var$matchMonthPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ac1cac641a61d75e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ac1cac641a61d75e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac1cac641a61d75e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ac1cac641a61d75e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ac1cac641a61d75e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish](https://github.com/Landish)
 * @author Nick Shvelidze [@shvelo](https://github.com/shvelo)
 */ const $fbcd824e2e6dd738$var$ka = $fbcd824e2e6dd738$export$b20f780fa2c7402 = {
    code: "ka",
    formatDistance: $be8651a1e54763ae$export$2c14ff85d6318973,
    formatLong: $b4632e56e0c4ec16$export$cbf60ecb96cbb82f,
    formatRelative: $6bbffe9887712967$export$8fbbfd65594f46a0,
    localize: $cb38f01537a2ac30$export$b3bd0bc58e36cd63,
    match: $ac1cac641a61d75e$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($fbcd824e2e6dd738$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $fbcd824e2e6dd738$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $fbcd824e2e6dd738$exports[key];
        }
    });
});
var $8b69880132883faf$exports = {};

$parcel$export($8b69880132883faf$exports, "kk", () => $8b69880132883faf$export$4b04b6f14f77e727, (v) => $8b69880132883faf$export$4b04b6f14f77e727 = v);
var $8b69880132883faf$export$4b04b6f14f77e727;
"use strict";
$8b69880132883faf$export$4b04b6f14f77e727 = void 0;
var $21bbcb45058afabe$export$2c14ff85d6318973;
"use strict";
$21bbcb45058afabe$export$2c14ff85d6318973 = void 0;
const $21bbcb45058afabe$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: (options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: "weeks",
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: "weeks",
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $21bbcb45058afabe$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
const $21bbcb45058afabe$var$formatDistance = (token, count, options)=>{
    const tokenValue = $21bbcb45058afabe$var$formatDistanceLocale[token];
    if (typeof tokenValue === "function") return tokenValue(options);
    if (tokenValue.type === "weeks") return count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $21bbcb45058afabe$var$declension(tokenValue.future, count);
            else return $21bbcb45058afabe$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $21bbcb45058afabe$var$declension(tokenValue.past, count);
            else return $21bbcb45058afabe$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $21bbcb45058afabe$var$declension(tokenValue.regular, count);
};
$21bbcb45058afabe$export$2c14ff85d6318973 = $21bbcb45058afabe$var$formatDistance;


var $b77fa717f74fd5d5$export$cbf60ecb96cbb82f;
"use strict";
$b77fa717f74fd5d5$export$cbf60ecb96cbb82f = void 0;

const $b77fa717f74fd5d5$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: "dd.MM.yyyy"
};
const $b77fa717f74fd5d5$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $b77fa717f74fd5d5$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $b77fa717f74fd5d5$var$formatLong = $b77fa717f74fd5d5$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $b77fa717f74fd5d5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $b77fa717f74fd5d5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $b77fa717f74fd5d5$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $a8e6ac96c9850311$export$8fbbfd65594f46a0;
"use strict";
$a8e6ac96c9850311$export$8fbbfd65594f46a0 = void 0;

const $a8e6ac96c9850311$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $a8e6ac96c9850311$var$lastWeek(day) {
    const weekday = $a8e6ac96c9850311$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $a8e6ac96c9850311$var$thisWeek(day) {
    const weekday = $a8e6ac96c9850311$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $a8e6ac96c9850311$var$nextWeek(day) {
    const weekday = $a8e6ac96c9850311$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
const $a8e6ac96c9850311$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $a8e6ac96c9850311$var$thisWeek(day);
        else return $a8e6ac96c9850311$var$lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $a8e6ac96c9850311$var$thisWeek(day);
        else return $a8e6ac96c9850311$var$nextWeek(day);
    },
    other: "P"
};
const $a8e6ac96c9850311$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $a8e6ac96c9850311$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$a8e6ac96c9850311$export$8fbbfd65594f46a0 = $a8e6ac96c9850311$var$formatRelative;


var $6347ff4c3ec83c21$export$b3bd0bc58e36cd63;
"use strict";
$6347ff4c3ec83c21$export$b3bd0bc58e36cd63 = void 0;

const $6347ff4c3ec83c21$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
const $6347ff4c3ec83c21$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $6347ff4c3ec83c21$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $6347ff4c3ec83c21$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
const $6347ff4c3ec83c21$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
const $6347ff4c3ec83c21$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
const $6347ff4c3ec83c21$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
const $6347ff4c3ec83c21$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
const $6347ff4c3ec83c21$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const mod10 = number % 10;
    const b = number >= 100 ? 100 : null;
    const suffix = $6347ff4c3ec83c21$var$suffixes[number] || $6347ff4c3ec83c21$var$suffixes[mod10] || b && $6347ff4c3ec83c21$var$suffixes[b] || "";
    return number + suffix;
};
const $6347ff4c3ec83c21$var$localize = $6347ff4c3ec83c21$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6347ff4c3ec83c21$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6347ff4c3ec83c21$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6347ff4c3ec83c21$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6347ff4c3ec83c21$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $6347ff4c3ec83c21$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6347ff4c3ec83c21$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6347ff4c3ec83c21$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $6347ff4c3ec83c21$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $978a926ef4747933$export$4659b591c19bdf3d;
"use strict";
$978a926ef4747933$export$4659b591c19bdf3d = void 0;


const $978a926ef4747933$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
const $978a926ef4747933$var$parseOrdinalNumberPattern = /\d+/i;
const $978a926ef4747933$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
const $978a926ef4747933$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
const $978a926ef4747933$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
const $978a926ef4747933$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $978a926ef4747933$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
const $978a926ef4747933$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
const $978a926ef4747933$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
const $978a926ef4747933$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
const $978a926ef4747933$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
const $978a926ef4747933$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
const $978a926ef4747933$var$match = $978a926ef4747933$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $978a926ef4747933$var$matchOrdinalNumberPattern,
        parsePattern: $978a926ef4747933$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $978a926ef4747933$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $978a926ef4747933$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $978a926ef4747933$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $978a926ef4747933$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $978a926ef4747933$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $978a926ef4747933$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $978a926ef4747933$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $978a926ef4747933$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $978a926ef4747933$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $978a926ef4747933$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi](https://github.com/drugoi)
 */ const $8b69880132883faf$var$kk = $8b69880132883faf$export$4b04b6f14f77e727 = {
    code: "kk",
    formatDistance: $21bbcb45058afabe$export$2c14ff85d6318973,
    formatLong: $b77fa717f74fd5d5$export$cbf60ecb96cbb82f,
    formatRelative: $a8e6ac96c9850311$export$8fbbfd65594f46a0,
    localize: $6347ff4c3ec83c21$export$b3bd0bc58e36cd63,
    match: $978a926ef4747933$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($8b69880132883faf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $8b69880132883faf$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $8b69880132883faf$exports[key];
        }
    });
});
var $16c003e886cd2d78$exports = {};

$parcel$export($16c003e886cd2d78$exports, "km", () => $16c003e886cd2d78$export$476a5568f36fcaf3, (v) => $16c003e886cd2d78$export$476a5568f36fcaf3 = v);
var $16c003e886cd2d78$export$476a5568f36fcaf3;
"use strict";
$16c003e886cd2d78$export$476a5568f36fcaf3 = void 0;
var $d162221e516abb6c$export$2c14ff85d6318973;
"use strict";
$d162221e516abb6c$export$2c14ff85d6318973 = void 0;
const $d162221e516abb6c$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
const $d162221e516abb6c$var$formatDistance = (token, count, options)=>{
    const tokenValue = $d162221e516abb6c$var$formatDistanceLocale[token];
    let result = tokenValue;
    if (typeof count === "number") result = result.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
$d162221e516abb6c$export$2c14ff85d6318973 = $d162221e516abb6c$var$formatDistance;


var $962a6ec772be9f93$export$cbf60ecb96cbb82f;
"use strict";
$962a6ec772be9f93$export$cbf60ecb96cbb82f = void 0;

const $962a6ec772be9f93$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $962a6ec772be9f93$var$timeFormats = {
    full: "h:mm:ss a",
    long: "h:mm:ss a",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $962a6ec772be9f93$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $962a6ec772be9f93$var$formatLong = $962a6ec772be9f93$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $962a6ec772be9f93$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $962a6ec772be9f93$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $962a6ec772be9f93$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $8b982f1826b96060$export$8fbbfd65594f46a0;
"use strict";
$8b982f1826b96060$export$8fbbfd65594f46a0 = void 0;
const $8b982f1826b96060$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: "P"
};
const $8b982f1826b96060$var$formatRelative = (token, _date, _baseDate, _options)=>$8b982f1826b96060$var$formatRelativeLocale[token];
$8b982f1826b96060$export$8fbbfd65594f46a0 = $8b982f1826b96060$var$formatRelative;


var $acbe159cfda89ca1$export$b3bd0bc58e36cd63;
"use strict";
$acbe159cfda89ca1$export$b3bd0bc58e36cd63 = void 0;

const $acbe159cfda89ca1$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
const $acbe159cfda89ca1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
const $acbe159cfda89ca1$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
const $acbe159cfda89ca1$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
const $acbe159cfda89ca1$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
const $acbe159cfda89ca1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
const $acbe159cfda89ca1$var$ordinalNumber = (dirtyNumber, _)=>{
    const number = Number(dirtyNumber);
    return number.toString();
};
const $acbe159cfda89ca1$var$localize = $acbe159cfda89ca1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $acbe159cfda89ca1$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $acbe159cfda89ca1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $acbe159cfda89ca1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $acbe159cfda89ca1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $acbe159cfda89ca1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $acbe159cfda89ca1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $acbe159cfda89ca1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $5f98fd5d125696f6$export$4659b591c19bdf3d;
"use strict";
$5f98fd5d125696f6$export$4659b591c19bdf3d = void 0;


const $5f98fd5d125696f6$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $5f98fd5d125696f6$var$parseOrdinalNumberPattern = /\d+/i;
const $5f98fd5d125696f6$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
const $5f98fd5d125696f6$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
const $5f98fd5d125696f6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
const $5f98fd5d125696f6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5f98fd5d125696f6$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
const $5f98fd5d125696f6$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
const $5f98fd5d125696f6$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
const $5f98fd5d125696f6$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
const $5f98fd5d125696f6$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
const $5f98fd5d125696f6$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
const $5f98fd5d125696f6$var$match = $5f98fd5d125696f6$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $5f98fd5d125696f6$var$matchOrdinalNumberPattern,
        parsePattern: $5f98fd5d125696f6$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5f98fd5d125696f6$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f98fd5d125696f6$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5f98fd5d125696f6$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f98fd5d125696f6$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5f98fd5d125696f6$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f98fd5d125696f6$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5f98fd5d125696f6$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f98fd5d125696f6$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5f98fd5d125696f6$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5f98fd5d125696f6$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay](https://github.com/seanghay)
 */ const $16c003e886cd2d78$var$km = $16c003e886cd2d78$export$476a5568f36fcaf3 = {
    code: "km",
    formatDistance: $d162221e516abb6c$export$2c14ff85d6318973,
    formatLong: $962a6ec772be9f93$export$cbf60ecb96cbb82f,
    formatRelative: $8b982f1826b96060$export$8fbbfd65594f46a0,
    localize: $acbe159cfda89ca1$export$b3bd0bc58e36cd63,
    match: $5f98fd5d125696f6$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($16c003e886cd2d78$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $16c003e886cd2d78$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $16c003e886cd2d78$exports[key];
        }
    });
});
var $e349c23230397485$exports = {};

$parcel$export($e349c23230397485$exports, "kn", () => $e349c23230397485$export$85d70026956e40a0, (v) => $e349c23230397485$export$85d70026956e40a0 = v);
var $e349c23230397485$export$85d70026956e40a0;
"use strict";
$e349c23230397485$export$85d70026956e40a0 = void 0;
var $862c6a7703db54df$export$2c14ff85d6318973;
"use strict";
$862c6a7703db54df$export$2c14ff85d6318973 = void 0;
// note: no implementation for weeks
const $862c6a7703db54df$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $862c6a7703db54df$var$getResultByTense(parentToken, options) {
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
const $862c6a7703db54df$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $862c6a7703db54df$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $862c6a7703db54df$var$getResultByTense(tokenValue.one, options);
    else result = $862c6a7703db54df$var$getResultByTense(tokenValue.other, options);
    return result.replace("{{count}}", String(count));
};
$862c6a7703db54df$export$2c14ff85d6318973 = $862c6a7703db54df$var$formatDistance;


var $30d046be5bd15fc4$export$cbf60ecb96cbb82f;
"use strict";
$30d046be5bd15fc4$export$cbf60ecb96cbb82f = void 0;

// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
const $30d046be5bd15fc4$var$dateFormats = {
    full: "EEEE, MMMM d, y",
    long: "MMMM d, y",
    medium: "MMM d, y",
    short: "d/M/yy"
};
const $30d046be5bd15fc4$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    long: "hh:mm:ss a z",
    medium: "hh:mm:ss a",
    short: "hh:mm a"
};
const $30d046be5bd15fc4$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $30d046be5bd15fc4$var$formatLong = $30d046be5bd15fc4$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $30d046be5bd15fc4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $30d046be5bd15fc4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $30d046be5bd15fc4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $c9e3c8b05e36d419$export$8fbbfd65594f46a0;
"use strict";
$c9e3c8b05e36d419$export$8fbbfd65594f46a0 = void 0;
const $c9e3c8b05e36d419$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: "P"
};
const $c9e3c8b05e36d419$var$formatRelative = (token, _date, _baseDate, _options)=>$c9e3c8b05e36d419$var$formatRelativeLocale[token];
$c9e3c8b05e36d419$export$8fbbfd65594f46a0 = $c9e3c8b05e36d419$var$formatRelative;


var $2a93c88c29e14c55$export$b3bd0bc58e36cd63;
"use strict";
$2a93c88c29e14c55$export$b3bd0bc58e36cd63 = void 0;

// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
const $2a93c88c29e14c55$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ]
};
const $2a93c88c29e14c55$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ]
};
// CLDR #1646 - #1717
const $2a93c88c29e14c55$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
const $2a93c88c29e14c55$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
const $2a93c88c29e14c55$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
const $2a93c88c29e14c55$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
const $2a93c88c29e14c55$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
const $2a93c88c29e14c55$var$localize = $2a93c88c29e14c55$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2a93c88c29e14c55$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a93c88c29e14c55$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a93c88c29e14c55$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a93c88c29e14c55$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a93c88c29e14c55$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a93c88c29e14c55$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2a93c88c29e14c55$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $c8233f6eef7b5ceb$export$4659b591c19bdf3d;
"use strict";
$c8233f6eef7b5ceb$export$4659b591c19bdf3d = void 0;


const $c8233f6eef7b5ceb$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
const $c8233f6eef7b5ceb$var$parseOrdinalNumberPattern = /\d+/i;
const $c8233f6eef7b5ceb$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
const $c8233f6eef7b5ceb$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
const $c8233f6eef7b5ceb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
const $c8233f6eef7b5ceb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $c8233f6eef7b5ceb$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
const $c8233f6eef7b5ceb$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
const $c8233f6eef7b5ceb$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
const $c8233f6eef7b5ceb$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
const $c8233f6eef7b5ceb$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
const $c8233f6eef7b5ceb$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
const $c8233f6eef7b5ceb$var$match = $c8233f6eef7b5ceb$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $c8233f6eef7b5ceb$var$matchOrdinalNumberPattern,
        parsePattern: $c8233f6eef7b5ceb$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c8233f6eef7b5ceb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c8233f6eef7b5ceb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c8233f6eef7b5ceb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c8233f6eef7b5ceb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c8233f6eef7b5ceb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c8233f6eef7b5ceb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c8233f6eef7b5ceb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c8233f6eef7b5ceb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c8233f6eef7b5ceb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c8233f6eef7b5ceb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli](https://github.com/developergouli)
 */ const $e349c23230397485$var$kn = $e349c23230397485$export$85d70026956e40a0 = {
    code: "kn",
    formatDistance: $862c6a7703db54df$export$2c14ff85d6318973,
    formatLong: $30d046be5bd15fc4$export$cbf60ecb96cbb82f,
    formatRelative: $c9e3c8b05e36d419$export$8fbbfd65594f46a0,
    localize: $2a93c88c29e14c55$export$b3bd0bc58e36cd63,
    match: $c8233f6eef7b5ceb$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($e349c23230397485$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $e349c23230397485$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $e349c23230397485$exports[key];
        }
    });
});
var $e1c40e319c27f34a$exports = {};

$parcel$export($e1c40e319c27f34a$exports, "ko", () => $e1c40e319c27f34a$export$798cf677954c9533, (v) => $e1c40e319c27f34a$export$798cf677954c9533 = v);
var $e1c40e319c27f34a$export$798cf677954c9533;
"use strict";
$e1c40e319c27f34a$export$798cf677954c9533 = void 0;
var $c97b631996ac87cd$export$2c14ff85d6318973;
"use strict";
$c97b631996ac87cd$export$2c14ff85d6318973 = void 0;
const $c97b631996ac87cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
const $c97b631996ac87cd$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c97b631996ac87cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
$c97b631996ac87cd$export$2c14ff85d6318973 = $c97b631996ac87cd$var$formatDistance;


var $9091504fc6a4d0bc$export$cbf60ecb96cbb82f;
"use strict";
$9091504fc6a4d0bc$export$cbf60ecb96cbb82f = void 0;

const $9091504fc6a4d0bc$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: "y.MM.dd",
    short: "y.MM.dd"
};
const $9091504fc6a4d0bc$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: "a H:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $9091504fc6a4d0bc$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $9091504fc6a4d0bc$var$formatLong = $9091504fc6a4d0bc$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9091504fc6a4d0bc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9091504fc6a4d0bc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9091504fc6a4d0bc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $66d8f7fd63f48f84$export$8fbbfd65594f46a0;
"use strict";
$66d8f7fd63f48f84$export$8fbbfd65594f46a0 = void 0;
const $66d8f7fd63f48f84$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: "P"
};
const $66d8f7fd63f48f84$var$formatRelative = (token, _date, _baseDate, _options)=>$66d8f7fd63f48f84$var$formatRelativeLocale[token];
$66d8f7fd63f48f84$export$8fbbfd65594f46a0 = $66d8f7fd63f48f84$var$formatRelative;


var $a0d0ec346f65524e$export$b3bd0bc58e36cd63;
"use strict";
$a0d0ec346f65524e$export$b3bd0bc58e36cd63 = void 0;

const $a0d0ec346f65524e$var$eraValues = {
    narrow: [
        "BC",
        "AD"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
const $a0d0ec346f65524e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
const $a0d0ec346f65524e$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
const $a0d0ec346f65524e$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
const $a0d0ec346f65524e$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
const $a0d0ec346f65524e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
const $a0d0ec346f65524e$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = String(options?.unit);
    switch(unit){
        case "minute":
        case "second":
            return String(number);
        case "date":
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
const $a0d0ec346f65524e$var$localize = $a0d0ec346f65524e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a0d0ec346f65524e$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a0d0ec346f65524e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a0d0ec346f65524e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a0d0ec346f65524e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a0d0ec346f65524e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a0d0ec346f65524e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a0d0ec346f65524e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $55a80d3121a53e9b$export$4659b591c19bdf3d;
"use strict";
$55a80d3121a53e9b$export$4659b591c19bdf3d = void 0;


const $55a80d3121a53e9b$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
const $55a80d3121a53e9b$var$parseOrdinalNumberPattern = /\d+/i;
const $55a80d3121a53e9b$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
const $55a80d3121a53e9b$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
const $55a80d3121a53e9b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
const $55a80d3121a53e9b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $55a80d3121a53e9b$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
const $55a80d3121a53e9b$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
const $55a80d3121a53e9b$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
const $55a80d3121a53e9b$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
const $55a80d3121a53e9b$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
const $55a80d3121a53e9b$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
const $55a80d3121a53e9b$var$match = $55a80d3121a53e9b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $55a80d3121a53e9b$var$matchOrdinalNumberPattern,
        parsePattern: $55a80d3121a53e9b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $55a80d3121a53e9b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55a80d3121a53e9b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $55a80d3121a53e9b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55a80d3121a53e9b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $55a80d3121a53e9b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55a80d3121a53e9b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $55a80d3121a53e9b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $55a80d3121a53e9b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $55a80d3121a53e9b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $55a80d3121a53e9b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev](https://github.com/angdev)
 * @author Lee Seoyoen [@iamssen](https://github.com/iamssen)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */ const $e1c40e319c27f34a$var$ko = $e1c40e319c27f34a$export$798cf677954c9533 = {
    code: "ko",
    formatDistance: $c97b631996ac87cd$export$2c14ff85d6318973,
    formatLong: $9091504fc6a4d0bc$export$cbf60ecb96cbb82f,
    formatRelative: $66d8f7fd63f48f84$export$8fbbfd65594f46a0,
    localize: $a0d0ec346f65524e$export$b3bd0bc58e36cd63,
    match: $55a80d3121a53e9b$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($e1c40e319c27f34a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $e1c40e319c27f34a$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $e1c40e319c27f34a$exports[key];
        }
    });
});
var $e2ce8a29520e6954$exports = {};

$parcel$export($e2ce8a29520e6954$exports, "lb", () => $e2ce8a29520e6954$export$736eba5cc491e759, (v) => $e2ce8a29520e6954$export$736eba5cc491e759 = v);
var $e2ce8a29520e6954$export$736eba5cc491e759;
"use strict";
$e2ce8a29520e6954$export$736eba5cc491e759 = void 0;
var $8ebe7ed666e64afa$export$2c14ff85d6318973;
"use strict";
$8ebe7ed666e64afa$export$2c14ff85d6318973 = void 0;
const $8ebe7ed666e64afa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: "eng Sekonn",
            other: "{{count}} Sekonnen"
        },
        withPreposition: {
            one: "enger Sekonn",
            other: "{{count}} Sekonnen"
        }
    },
    halfAMinute: {
        standalone: "eng hallef Minutt",
        withPreposition: "enger hallwer Minutt"
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: "eng Minutt",
            other: "{{count}} Minutten"
        },
        withPreposition: {
            one: "enger Minutt",
            other: "{{count}} Minutten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: "eng Stonn",
            other: "{{count}} Stonnen"
        },
        withPreposition: {
            one: "enger Stonn",
            other: "{{count}} Stonnen"
        }
    },
    xDays: {
        standalone: {
            one: "een Dag",
            other: "{{count}} Deeg"
        },
        withPreposition: {
            one: "engem Dag",
            other: "{{count}} Deeg"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "eng Woch",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "enger Woch",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: "ee Mount",
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: "engem Mount",
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: "ee Joer",
            other: "{{count}} Joer"
        },
        withPreposition: {
            one: "engem Joer",
            other: "{{count}} Joer"
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: "bal ee Joer",
            other: "bal {{count}} Joer"
        },
        withPreposition: {
            one: "bal engem Joer",
            other: "bal {{count}} Joer"
        }
    }
};
const $8ebe7ed666e64afa$var$EXCEPTION_CONSONANTS = [
    "d",
    "h",
    "n",
    "t",
    "z"
];
const $8ebe7ed666e64afa$var$VOWELS = [
    "a,",
    "e",
    "i",
    "o",
    "u"
];
const $8ebe7ed666e64afa$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
const $8ebe7ed666e64afa$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $8ebe7ed666e64afa$var$isFinalNNeeded(nextWords) {
    const firstLetter = nextWords.charAt(0).toLowerCase();
    if ($8ebe7ed666e64afa$var$VOWELS.indexOf(firstLetter) != -1 || $8ebe7ed666e64afa$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    const firstWord = nextWords.split(" ")[0];
    const number = parseInt(firstWord);
    if (!isNaN(number) && $8ebe7ed666e64afa$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $8ebe7ed666e64afa$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
const $8ebe7ed666e64afa$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8ebe7ed666e64afa$var$formatDistanceLocale[token];
    const usageGroup = options?.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "a" + ($8ebe7ed666e64afa$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
        else return "viru" + ($8ebe7ed666e64afa$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
    }
    return result;
};
$8ebe7ed666e64afa$export$2c14ff85d6318973 = $8ebe7ed666e64afa$var$formatDistance;


var $fccf012f10773229$export$cbf60ecb96cbb82f;
"use strict";
$fccf012f10773229$export$cbf60ecb96cbb82f = void 0;

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const $fccf012f10773229$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.yy"
};
const $fccf012f10773229$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $fccf012f10773229$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $fccf012f10773229$var$formatLong = $fccf012f10773229$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fccf012f10773229$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fccf012f10773229$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $fccf012f10773229$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $0a12666cb56a1ff3$export$8fbbfd65594f46a0;
"use strict";
$0a12666cb56a1ff3$export$8fbbfd65594f46a0 = void 0;
const $0a12666cb56a1ff3$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        let result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += "n";
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
const $0a12666cb56a1ff3$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $0a12666cb56a1ff3$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$0a12666cb56a1ff3$export$8fbbfd65594f46a0 = $0a12666cb56a1ff3$var$formatRelative;


var $8aef47f06342d29d$export$b3bd0bc58e36cd63;
"use strict";
$8aef47f06342d29d$export$b3bd0bc58e36cd63 = void 0;

const $8aef47f06342d29d$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "viru Christus",
        "no Christus"
    ]
};
const $8aef47f06342d29d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
const $8aef47f06342d29d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4e",
        "Abr",
        "Mee",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4erz",
        "Abr\xebll",
        "Mee",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
const $8aef47f06342d29d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "M\xe9",
        "D\xeb",
        "M\xeb",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonndeg",
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        "Donneschdeg",
        "Freideg",
        "Samschdeg"
    ]
};
const $8aef47f06342d29d$var$dayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    }
};
const $8aef47f06342d29d$var$formattingDayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom.",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    }
};
const $8aef47f06342d29d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $8aef47f06342d29d$var$localize = $8aef47f06342d29d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8aef47f06342d29d$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8aef47f06342d29d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8aef47f06342d29d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8aef47f06342d29d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8aef47f06342d29d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8aef47f06342d29d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8aef47f06342d29d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $ed50190deeeef599$export$4659b591c19bdf3d;
"use strict";
$ed50190deeeef599$export$4659b591c19bdf3d = void 0;


const $ed50190deeeef599$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $ed50190deeeef599$var$parseOrdinalNumberPattern = /\d+/i;
const $ed50190deeeef599$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
const $ed50190deeeef599$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
const $ed50190deeeef599$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
const $ed50190deeeef599$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ed50190deeeef599$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
const $ed50190deeeef599$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ed50190deeeef599$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
const $ed50190deeeef599$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
const $ed50190deeeef599$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
const $ed50190deeeef599$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        evening: /owes/i,
        night: /nuets/i
    }
};
const $ed50190deeeef599$var$match = $ed50190deeeef599$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $ed50190deeeef599$var$matchOrdinalNumberPattern,
        parsePattern: $ed50190deeeef599$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed50190deeeef599$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed50190deeeef599$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed50190deeeef599$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed50190deeeef599$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed50190deeeef599$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed50190deeeef599$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed50190deeeef599$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed50190deeeef599$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed50190deeeef599$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed50190deeeef599$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler](https://github.com/dwaxweiler)
 */ const $e2ce8a29520e6954$var$lb = $e2ce8a29520e6954$export$736eba5cc491e759 = {
    code: "lb",
    formatDistance: $8ebe7ed666e64afa$export$2c14ff85d6318973,
    formatLong: $fccf012f10773229$export$cbf60ecb96cbb82f,
    formatRelative: $0a12666cb56a1ff3$export$8fbbfd65594f46a0,
    localize: $8aef47f06342d29d$export$b3bd0bc58e36cd63,
    match: $ed50190deeeef599$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($e2ce8a29520e6954$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $e2ce8a29520e6954$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $e2ce8a29520e6954$exports[key];
        }
    });
});
var $79fc50854e2b3fe8$exports = {};

$parcel$export($79fc50854e2b3fe8$exports, "lt", () => $79fc50854e2b3fe8$export$b961576059b7aeb6, (v) => $79fc50854e2b3fe8$export$b961576059b7aeb6 = v);
var $79fc50854e2b3fe8$export$b961576059b7aeb6;
"use strict";
$79fc50854e2b3fe8$export$b961576059b7aeb6 = void 0;
var $cdb8c090fb885595$export$2c14ff85d6318973;
"use strict";
$cdb8c090fb885595$export$2c14ff85d6318973 = void 0;
const $cdb8c090fb885595$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: "apie",
    over: "daugiau nei",
    almost: "beveik",
    lessthan: "ma\u017Eiau nei"
};
const $cdb8c090fb885595$var$translateSeconds = (_number, addSuffix, _key, isFuture)=>{
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
};
const $cdb8c090fb885595$var$translateSingular = (_number, addSuffix, key, isFuture)=>{
    return !addSuffix ? $cdb8c090fb885595$var$forms(key)[0] : isFuture ? $cdb8c090fb885595$var$forms(key)[1] : $cdb8c090fb885595$var$forms(key)[2];
};
const $cdb8c090fb885595$var$translate = (number, addSuffix, key, isFuture)=>{
    const result = number + " ";
    if (number === 1) return result + $cdb8c090fb885595$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($cdb8c090fb885595$var$special(number) ? $cdb8c090fb885595$var$forms(key)[1] : $cdb8c090fb885595$var$forms(key)[0]);
    else {
        if (isFuture) return result + $cdb8c090fb885595$var$forms(key)[1];
        else return result + ($cdb8c090fb885595$var$special(number) ? $cdb8c090fb885595$var$forms(key)[1] : $cdb8c090fb885595$var$forms(key)[2]);
    }
};
function $cdb8c090fb885595$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $cdb8c090fb885595$var$forms(key) {
    return $cdb8c090fb885595$var$translations[key].split("_");
}
const $cdb8c090fb885595$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $cdb8c090fb885595$var$translateSeconds,
        other: $cdb8c090fb885595$var$translate
    },
    xSeconds: {
        one: $cdb8c090fb885595$var$translateSeconds,
        other: $cdb8c090fb885595$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    xMinutes: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    aboutXHours: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    xHours: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    xDays: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    aboutXWeeks: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    xWeeks: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    aboutXMonths: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    xMonths: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    aboutXYears: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    xYears: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    overXYears: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    },
    almostXYears: {
        one: $cdb8c090fb885595$var$translateSingular,
        other: $cdb8c090fb885595$var$translate
    }
};
const $cdb8c090fb885595$var$formatDistance = (token, count, options)=>{
    const adverb = token.match(/about|over|almost|lessthan/i);
    const unit = adverb ? token.replace(adverb[0], "") : token;
    const isFuture = options?.comparison !== undefined && options.comparison > 0;
    let result;
    const tokenValue = $cdb8c090fb885595$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, options?.addSuffix === true, unit.toLowerCase() + "_one", isFuture);
    else result = tokenValue.other(count, options?.addSuffix === true, unit.toLowerCase() + "_other", isFuture);
    if (adverb) {
        const key = adverb[0].toLowerCase();
        result = $cdb8c090fb885595$var$translations[key] + " " + result;
    }
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "po " + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
$cdb8c090fb885595$export$2c14ff85d6318973 = $cdb8c090fb885595$var$formatDistance;


var $9eb916e6171f4315$export$cbf60ecb96cbb82f;
"use strict";
$9eb916e6171f4315$export$cbf60ecb96cbb82f = void 0;

const $9eb916e6171f4315$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: "y-MM-dd",
    short: "y-MM-dd"
};
const $9eb916e6171f4315$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $9eb916e6171f4315$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $9eb916e6171f4315$var$formatLong = $9eb916e6171f4315$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9eb916e6171f4315$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9eb916e6171f4315$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $9eb916e6171f4315$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $0ae88a436941a375$export$8fbbfd65594f46a0;
"use strict";
$0ae88a436941a375$export$8fbbfd65594f46a0 = void 0;
const $0ae88a436941a375$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: "eeee p",
    other: "P"
};
const $0ae88a436941a375$var$formatRelative = (token, _date, _baseDate, _options)=>$0ae88a436941a375$var$formatRelativeLocale[token];
$0ae88a436941a375$export$8fbbfd65594f46a0 = $0ae88a436941a375$var$formatRelative;


var $ffcf182321181f66$export$b3bd0bc58e36cd63;
"use strict";
$ffcf182321181f66$export$b3bd0bc58e36cd63 = void 0;

const $ffcf182321181f66$var$eraValues = {
    narrow: [
        "pr. Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pr. Kr.",
        "po Kr."
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        "po Kristaus"
    ]
};
const $ffcf182321181f66$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I ketv.",
        "II ketv.",
        "III ketv.",
        "IV ketv."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
const $ffcf182321181f66$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I k.",
        "II k.",
        "III k.",
        "IV k."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
const $ffcf182321181f66$var$monthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausis",
        "vasaris",
        "kovas",
        "balandis",
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        "liepa",
        "rugpj\u016Btis",
        "rugs\u0117jis",
        "spalis",
        "lapkritis",
        "gruodis"
    ]
};
const $ffcf182321181f66$var$formattingMonthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausio",
        "vasario",
        "kovo",
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        "liepos",
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        "spalio",
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
const $ffcf182321181f66$var$dayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadienis",
        "pirmadienis",
        "antradienis",
        "tre\u010Diadienis",
        "ketvirtadienis",
        "penktadienis",
        "\u0161e\u0161tadienis"
    ]
};
const $ffcf182321181f66$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
const $ffcf182321181f66$var$dayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    }
};
const $ffcf182321181f66$var$formattingDayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    }
};
const $ffcf182321181f66$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "-oji";
};
const $ffcf182321181f66$var$localize = $ffcf182321181f66$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ffcf182321181f66$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ffcf182321181f66$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ffcf182321181f66$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $ffcf182321181f66$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ffcf182321181f66$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $ffcf182321181f66$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ffcf182321181f66$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $ffcf182321181f66$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ffcf182321181f66$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ffcf182321181f66$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $f0bc91c308c42bc7$export$4659b591c19bdf3d;
"use strict";
$f0bc91c308c42bc7$export$4659b591c19bdf3d = void 0;


const $f0bc91c308c42bc7$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
const $f0bc91c308c42bc7$var$parseOrdinalNumberPattern = /\d+/i;
const $f0bc91c308c42bc7$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
const $f0bc91c308c42bc7$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
const $f0bc91c308c42bc7$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
const $f0bc91c308c42bc7$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
const $f0bc91c308c42bc7$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
const $f0bc91c308c42bc7$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
const $f0bc91c308c42bc7$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
const $f0bc91c308c42bc7$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
const $f0bc91c308c42bc7$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
const $f0bc91c308c42bc7$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
const $f0bc91c308c42bc7$var$match = $f0bc91c308c42bc7$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $f0bc91c308c42bc7$var$matchOrdinalNumberPattern,
        parsePattern: $f0bc91c308c42bc7$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f0bc91c308c42bc7$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f0bc91c308c42bc7$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f0bc91c308c42bc7$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f0bc91c308c42bc7$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f0bc91c308c42bc7$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f0bc91c308c42bc7$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f0bc91c308c42bc7$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f0bc91c308c42bc7$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f0bc91c308c42bc7$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f0bc91c308c42bc7$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 */ const $79fc50854e2b3fe8$var$lt = $79fc50854e2b3fe8$export$b961576059b7aeb6 = {
    code: "lt",
    formatDistance: $cdb8c090fb885595$export$2c14ff85d6318973,
    formatLong: $9eb916e6171f4315$export$cbf60ecb96cbb82f,
    formatRelative: $0ae88a436941a375$export$8fbbfd65594f46a0,
    localize: $ffcf182321181f66$export$b3bd0bc58e36cd63,
    match: $f0bc91c308c42bc7$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($79fc50854e2b3fe8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $79fc50854e2b3fe8$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $79fc50854e2b3fe8$exports[key];
        }
    });
});
var $14995636d9348489$exports = {};

$parcel$export($14995636d9348489$exports, "lv", () => $14995636d9348489$export$54ca4d1eb7926f1, (v) => $14995636d9348489$export$54ca4d1eb7926f1 = v);
var $14995636d9348489$export$54ca4d1eb7926f1;
"use strict";
$14995636d9348489$export$54ca4d1eb7926f1 = void 0;
var $10305b5e4ce838a7$export$2c14ff85d6318973;
"use strict";
$10305b5e4ce838a7$export$2c14ff85d6318973 = void 0;
function $10305b5e4ce838a7$var$buildLocalizeTokenFn(schema) {
    return (count, options)=>{
        if (count === 1) {
            if (options?.addSuffix) return schema.one[0].replace("{{time}}", schema.one[2]);
            else return schema.one[0].replace("{{time}}", schema.one[1]);
        } else {
            const rem = count % 10 === 1 && count % 100 !== 11;
            if (options?.addSuffix) return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", String(count));
            else return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", String(count));
        }
    };
}
const $10305b5e4ce838a7$var$formatDistanceLocale = {
    lessThanXSeconds: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "sekundi",
            "sekundi"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    xSeconds: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "sekunde",
            "sekundes"
        ],
        other: [
            "{{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    halfAMinute: (_count, options)=>{
        if (options?.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            "{{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xHours: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "{{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xDays: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "diena",
            "dienas"
        ],
        other: [
            "{{count}} {{time}}",
            "diena",
            "dienas",
            "dienas",
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "{{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "{{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    xYears: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "{{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    overXYears: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            "gadu",
            "gadu"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    almostXYears: $10305b5e4ce838a7$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    })
};
const $10305b5e4ce838a7$var$formatDistance = (token, count, options)=>{
    const result = $10305b5e4ce838a7$var$formatDistanceLocale[token](count, options);
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return "pirms " + result;
    }
    return result;
};
$10305b5e4ce838a7$export$2c14ff85d6318973 = $10305b5e4ce838a7$var$formatDistance;


var $1f429443180ae020$export$cbf60ecb96cbb82f;
"use strict";
$1f429443180ae020$export$cbf60ecb96cbb82f = void 0;

const $1f429443180ae020$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: "dd.MM.y.",
    short: "dd.MM.y."
};
const $1f429443180ae020$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $1f429443180ae020$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $1f429443180ae020$var$formatLong = $1f429443180ae020$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1f429443180ae020$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1f429443180ae020$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $1f429443180ae020$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $3a6b29ac44a3428d$export$8fbbfd65594f46a0;
"use strict";
$3a6b29ac44a3428d$export$8fbbfd65594f46a0 = void 0;

const $3a6b29ac44a3428d$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
const $3a6b29ac44a3428d$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $3a6b29ac44a3428d$var$weekdays[date.getDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: (date, baseDate, options)=>{
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return "eeee 'plkst.' p";
        const weekday = $3a6b29ac44a3428d$var$weekdays[date.getDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: "P"
};
const $3a6b29ac44a3428d$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $3a6b29ac44a3428d$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$3a6b29ac44a3428d$export$8fbbfd65594f46a0 = $3a6b29ac44a3428d$var$formatRelative;


var $83181cc2ec0ce89b$export$b3bd0bc58e36cd63;
"use strict";
$83181cc2ec0ce89b$export$b3bd0bc58e36cd63 = void 0;

const $83181cc2ec0ce89b$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
const $83181cc2ec0ce89b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmais ceturksnis",
        "otrais ceturksnis",
        "tre\u0161ais ceturksnis",
        "ceturtais ceturksnis"
    ]
};
const $83181cc2ec0ce89b$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
const $83181cc2ec0ce89b$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "marts",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        "marts",
        "apr\u012Blis",
        "maijs",
        "j\u016Bnijs",
        "j\u016Blijs",
        "augusts",
        "septembris",
        "oktobris",
        "novembris",
        "decembris"
    ]
};
const $83181cc2ec0ce89b$var$formattingMonthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "mart\u0101",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
const $83181cc2ec0ce89b$var$dayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdiena",
        "pirmdiena",
        "otrdiena",
        "tre\u0161diena",
        "ceturtdiena",
        "piektdiena",
        "sestdiena"
    ]
};
const $83181cc2ec0ce89b$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
const $83181cc2ec0ce89b$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "diena",
        evening: "vakars",
        night: "nakts"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: "vakars",
        night: "nakts"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakts",
        noon: "pusdienlaiks",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: "vakars",
        night: "nakts"
    }
};
const $83181cc2ec0ce89b$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
const $83181cc2ec0ce89b$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $83181cc2ec0ce89b$var$localize = $83181cc2ec0ce89b$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $83181cc2ec0ce89b$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $83181cc2ec0ce89b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $83181cc2ec0ce89b$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $83181cc2ec0ce89b$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $83181cc2ec0ce89b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $83181cc2ec0ce89b$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $83181cc2ec0ce89b$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $83181cc2ec0ce89b$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $83181cc2ec0ce89b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $83181cc2ec0ce89b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $fa70bda17f899ab2$export$4659b591c19bdf3d;
"use strict";
$fa70bda17f899ab2$export$4659b591c19bdf3d = void 0;


const $fa70bda17f899ab2$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $fa70bda17f899ab2$var$parseOrdinalNumberPattern = /\d+/i;
const $fa70bda17f899ab2$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
const $fa70bda17f899ab2$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
const $fa70bda17f899ab2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
const $fa70bda17f899ab2$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
const $fa70bda17f899ab2$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
const $fa70bda17f899ab2$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $fa70bda17f899ab2$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
const $fa70bda17f899ab2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
const $fa70bda17f899ab2$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
const $fa70bda17f899ab2$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
const $fa70bda17f899ab2$var$match = $fa70bda17f899ab2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $fa70bda17f899ab2$var$matchOrdinalNumberPattern,
        parsePattern: $fa70bda17f899ab2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fa70bda17f899ab2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fa70bda17f899ab2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fa70bda17f899ab2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fa70bda17f899ab2$var$parseQuarterPatterns,
        defaultParseWidth: "wide",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fa70bda17f899ab2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fa70bda17f899ab2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fa70bda17f899ab2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fa70bda17f899ab2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fa70bda17f899ab2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fa70bda17f899ab2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs](https://github.com/prudolfs)
 */ const $14995636d9348489$var$lv = $14995636d9348489$export$54ca4d1eb7926f1 = {
    code: "lv",
    formatDistance: $10305b5e4ce838a7$export$2c14ff85d6318973,
    formatLong: $1f429443180ae020$export$cbf60ecb96cbb82f,
    formatRelative: $3a6b29ac44a3428d$export$8fbbfd65594f46a0,
    localize: $83181cc2ec0ce89b$export$b3bd0bc58e36cd63,
    match: $fa70bda17f899ab2$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($14995636d9348489$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $14995636d9348489$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $14995636d9348489$exports[key];
        }
    });
});
var $db2e6f6fb0e31937$exports = {};

$parcel$export($db2e6f6fb0e31937$exports, "mk", () => $db2e6f6fb0e31937$export$ad7cae49b56e2eb8, (v) => $db2e6f6fb0e31937$export$ad7cae49b56e2eb8 = v);
var $db2e6f6fb0e31937$export$ad7cae49b56e2eb8;
"use strict";
$db2e6f6fb0e31937$export$ad7cae49b56e2eb8 = void 0;
var $fa83f0218f72abb7$export$2c14ff85d6318973;
"use strict";
$fa83f0218f72abb7$export$2c14ff85d6318973 = void 0;
const $fa83f0218f72abb7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
const $fa83f0218f72abb7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $fa83f0218f72abb7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
$fa83f0218f72abb7$export$2c14ff85d6318973 = $fa83f0218f72abb7$var$formatDistance;


var $d7d43bcd11b7f0ce$export$cbf60ecb96cbb82f;
"use strict";
$d7d43bcd11b7f0ce$export$cbf60ecb96cbb82f = void 0;

const $d7d43bcd11b7f0ce$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
const $d7d43bcd11b7f0ce$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
const $d7d43bcd11b7f0ce$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
const $d7d43bcd11b7f0ce$var$formatLong = $d7d43bcd11b7f0ce$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $d7d43bcd11b7f0ce$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $d7d43bcd11b7f0ce$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $d7d43bcd11b7f0ce$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $c50bb926ded114b1$export$8fbbfd65594f46a0;
"use strict";
$c50bb926ded114b1$export$8fbbfd65594f46a0 = void 0;

const $c50bb926ded114b1$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $c50bb926ded114b1$var$lastWeek(day) {
    const weekday = $c50bb926ded114b1$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $c50bb926ded114b1$var$thisWeek(day) {
    const weekday = $c50bb926ded114b1$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $c50bb926ded114b1$var$nextWeek(day) {
    const weekday = $c50bb926ded114b1$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
const $c50bb926ded114b1$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $c50bb926ded114b1$var$thisWeek(day);
        else return $c50bb926ded114b1$var$lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $c50bb926ded114b1$var$thisWeek(day);
        else return $c50bb926ded114b1$var$nextWeek(day);
    },
    other: "P"
};
const $c50bb926ded114b1$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $c50bb926ded114b1$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$c50bb926ded114b1$export$8fbbfd65594f46a0 = $c50bb926ded114b1$var$formatRelative;


var $0fb7587891989126$export$b3bd0bc58e36cd63;
"use strict";
$0fb7587891989126$export$b3bd0bc58e36cd63 = void 0;

const $0fb7587891989126$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
const $0fb7587891989126$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $0fb7587891989126$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
const $0fb7587891989126$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
const $0fb7587891989126$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
const $0fb7587891989126$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
const $0fb7587891989126$var$localize = $0fb7587891989126$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0fb7587891989126$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0fb7587891989126$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0fb7587891989126$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0fb7587891989126$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0fb7587891989126$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0fb7587891989126$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $3e6c8a777967027d$export$4659b591c19bdf3d;
"use strict";
$3e6c8a777967027d$export$4659b591c19bdf3d = void 0;


const $3e6c8a777967027d$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
const $3e6c8a777967027d$var$parseOrdinalNumberPattern = /\d+/i;
const $3e6c8a777967027d$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
const $3e6c8a777967027d$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
const $3e6c8a777967027d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
const $3e6c8a777967027d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $3e6c8a777967027d$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
const $3e6c8a777967027d$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
const $3e6c8a777967027d$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
const $3e6c8a777967027d$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
const $3e6c8a777967027d$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
const $3e6c8a777967027d$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
const $3e6c8a777967027d$var$match = $3e6c8a777967027d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $3e6c8a777967027d$var$matchOrdinalNumberPattern,
        parsePattern: $3e6c8a777967027d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3e6c8a777967027d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3e6c8a777967027d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3e6c8a777967027d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3e6c8a777967027d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3e6c8a777967027d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3e6c8a777967027d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3e6c8a777967027d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3e6c8a777967027d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $3e6c8a777967027d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3e6c8a777967027d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar](https://github.com/vlahupetar)
 * @author Altrim Beqiri [@altrim](https://github.com/altrim)
 */ const $db2e6f6fb0e31937$var$mk = $db2e6f6fb0e31937$export$ad7cae49b56e2eb8 = {
    code: "mk",
    formatDistance: $fa83f0218f72abb7$export$2c14ff85d6318973,
    formatLong: $d7d43bcd11b7f0ce$export$cbf60ecb96cbb82f,
    formatRelative: $c50bb926ded114b1$export$8fbbfd65594f46a0,
    localize: $0fb7587891989126$export$b3bd0bc58e36cd63,
    match: $3e6c8a777967027d$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($db2e6f6fb0e31937$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $db2e6f6fb0e31937$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $db2e6f6fb0e31937$exports[key];
        }
    });
});
var $1a1a4a4f41bcfb9b$exports = {};

$parcel$export($1a1a4a4f41bcfb9b$exports, "mn", () => $1a1a4a4f41bcfb9b$export$e78c44be168181dc, (v) => $1a1a4a4f41bcfb9b$export$e78c44be168181dc = v);
var $1a1a4a4f41bcfb9b$export$e78c44be168181dc;
"use strict";
$1a1a4a4f41bcfb9b$export$e78c44be168181dc = void 0;
var $9d10c7ce507924ce$export$2c14ff85d6318973;
"use strict";
$9d10c7ce507924ce$export$2c14ff85d6318973 = void 0;
const $9d10c7ce507924ce$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
const $9d10c7ce507924ce$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $9d10c7ce507924ce$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        /**
     * Append genitive case
     */ const words = result.split(" ");
        const lastword = words.pop();
        result = words.join(" ");
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
$9d10c7ce507924ce$export$2c14ff85d6318973 = $9d10c7ce507924ce$var$formatDistance;


var $f6c78938a5d8b86a$export$cbf60ecb96cbb82f;
"use strict";
$f6c78938a5d8b86a$export$cbf60ecb96cbb82f = void 0;

const $f6c78938a5d8b86a$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: "y.MM.dd"
};
const $f6c78938a5d8b86a$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $f6c78938a5d8b86a$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $f6c78938a5d8b86a$var$formatLong = $f6c78938a5d8b86a$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f6c78938a5d8b86a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f6c78938a5d8b86a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f6c78938a5d8b86a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $66a1edbbfe4c208a$export$8fbbfd65594f46a0;
"use strict";
$66a1edbbfe4c208a$export$8fbbfd65594f46a0 = void 0;
const $66a1edbbfe4c208a$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: "P"
};
const $66a1edbbfe4c208a$var$formatRelative = (token, _date, _baseDate, _options)=>$66a1edbbfe4c208a$var$formatRelativeLocale[token];
$66a1edbbfe4c208a$export$8fbbfd65594f46a0 = $66a1edbbfe4c208a$var$formatRelative;


var $b1c99bf5d9a314b3$export$b3bd0bc58e36cd63;
"use strict";
$b1c99bf5d9a314b3$export$b3bd0bc58e36cd63 = void 0;

const $b1c99bf5d9a314b3$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
const $b1c99bf5d9a314b3$var$quarterValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV"
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $b1c99bf5d9a314b3$var$monthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
const $b1c99bf5d9a314b3$var$formattingMonthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
const $b1c99bf5d9a314b3$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
const $b1c99bf5d9a314b3$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
const $b1c99bf5d9a314b3$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
const $b1c99bf5d9a314b3$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $b1c99bf5d9a314b3$var$localize = $b1c99bf5d9a314b3$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b1c99bf5d9a314b3$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b1c99bf5d9a314b3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b1c99bf5d9a314b3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b1c99bf5d9a314b3$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b1c99bf5d9a314b3$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b1c99bf5d9a314b3$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $b1c99bf5d9a314b3$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b1c99bf5d9a314b3$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $e34923f9d8455c30$export$4659b591c19bdf3d;
"use strict";
$e34923f9d8455c30$export$4659b591c19bdf3d = void 0;


const $e34923f9d8455c30$var$matchOrdinalNumberPattern = /\d+/i;
const $e34923f9d8455c30$var$parseOrdinalNumberPattern = /\d+/i;
const $e34923f9d8455c30$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
const $e34923f9d8455c30$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
const $e34923f9d8455c30$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
const $e34923f9d8455c30$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
const $e34923f9d8455c30$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
const $e34923f9d8455c30$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
const $e34923f9d8455c30$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
const $e34923f9d8455c30$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
const $e34923f9d8455c30$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
const $e34923f9d8455c30$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
const $e34923f9d8455c30$var$match = $e34923f9d8455c30$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $e34923f9d8455c30$var$matchOrdinalNumberPattern,
        parsePattern: $e34923f9d8455c30$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e34923f9d8455c30$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e34923f9d8455c30$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e34923f9d8455c30$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e34923f9d8455c30$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e34923f9d8455c30$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e34923f9d8455c30$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e34923f9d8455c30$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e34923f9d8455c30$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e34923f9d8455c30$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e34923f9d8455c30$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203](https://github.com/bilguun0203)
 */ const $1a1a4a4f41bcfb9b$var$mn = $1a1a4a4f41bcfb9b$export$e78c44be168181dc = {
    code: "mn",
    formatDistance: $9d10c7ce507924ce$export$2c14ff85d6318973,
    formatLong: $f6c78938a5d8b86a$export$cbf60ecb96cbb82f,
    formatRelative: $66a1edbbfe4c208a$export$8fbbfd65594f46a0,
    localize: $b1c99bf5d9a314b3$export$b3bd0bc58e36cd63,
    match: $e34923f9d8455c30$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($1a1a4a4f41bcfb9b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $1a1a4a4f41bcfb9b$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $1a1a4a4f41bcfb9b$exports[key];
        }
    });
});
var $cedc87cb3339996f$exports = {};

$parcel$export($cedc87cb3339996f$exports, "ms", () => $cedc87cb3339996f$export$5dd2165da01bec80, (v) => $cedc87cb3339996f$export$5dd2165da01bec80 = v);
var $cedc87cb3339996f$export$5dd2165da01bec80;
"use strict";
$cedc87cb3339996f$export$5dd2165da01bec80 = void 0;
var $c55b901486f8e3fc$export$2c14ff85d6318973;
"use strict";
$c55b901486f8e3fc$export$2c14ff85d6318973 = void 0;
const $c55b901486f8e3fc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 saat",
        other: "kurang dari {{count}} saat"
    },
    xSeconds: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    halfAMinute: "setengah minit",
    lessThanXMinutes: {
        one: "kurang dari 1 minit",
        other: "kurang dari {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
const $c55b901486f8e3fc$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $c55b901486f8e3fc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam masa " + result;
        else return result + " yang lalu";
    }
    return result;
};
$c55b901486f8e3fc$export$2c14ff85d6318973 = $c55b901486f8e3fc$var$formatDistance;


var $576ab11b809a633c$export$cbf60ecb96cbb82f;
"use strict";
$576ab11b809a633c$export$cbf60ecb96cbb82f = void 0;

const $576ab11b809a633c$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
const $576ab11b809a633c$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
const $576ab11b809a633c$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $576ab11b809a633c$var$formatLong = $576ab11b809a633c$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $576ab11b809a633c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $576ab11b809a633c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $576ab11b809a633c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $017c2f5aaca51082$export$8fbbfd65594f46a0;
"use strict";
$017c2f5aaca51082$export$8fbbfd65594f46a0 = void 0;
const $017c2f5aaca51082$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: "P"
};
const $017c2f5aaca51082$var$formatRelative = (token, _date, _baseDate, _options)=>$017c2f5aaca51082$var$formatRelativeLocale[token];
$017c2f5aaca51082$export$8fbbfd65594f46a0 = $017c2f5aaca51082$var$formatRelative;


var $f1d6ad7693241c21$export$b3bd0bc58e36cd63;
"use strict";
$f1d6ad7693241c21$export$b3bd0bc58e36cd63 = void 0;

// Most data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/ms.html
const $f1d6ad7693241c21$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masihi",
        "Masihi"
    ]
};
const $f1d6ad7693241c21$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "S1",
        "S2",
        "S3",
        "S4"
    ],
    wide: [
        "Suku pertama",
        "Suku kedua",
        "Suku ketiga",
        "Suku keempat"
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $f1d6ad7693241c21$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mac",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ogo",
        "Sep",
        "Okt",
        "Nov",
        "Dis"
    ],
    wide: [
        "Januari",
        "Februari",
        "Mac",
        "April",
        "Mei",
        "Jun",
        "Julai",
        "Ogos",
        "September",
        "Oktober",
        "November",
        "Disember"
    ]
};
const $f1d6ad7693241c21$var$dayValues = {
    narrow: [
        "A",
        "I",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    wide: [
        "Ahad",
        "Isnin",
        "Selasa",
        "Rabu",
        "Khamis",
        "Jumaat",
        "Sabtu"
    ]
};
const $f1d6ad7693241c21$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tgh malam",
        noon: "tgh hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
const $f1d6ad7693241c21$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
const $f1d6ad7693241c21$var$ordinalNumber = (dirtyNumber, _options)=>{
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + Number(dirtyNumber);
};
const $f1d6ad7693241c21$var$localize = $f1d6ad7693241c21$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f1d6ad7693241c21$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f1d6ad7693241c21$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f1d6ad7693241c21$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f1d6ad7693241c21$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f1d6ad7693241c21$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f1d6ad7693241c21$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f1d6ad7693241c21$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $47c914305d1e5e0f$export$4659b591c19bdf3d;
"use strict";
$47c914305d1e5e0f$export$4659b591c19bdf3d = void 0;


const $47c914305d1e5e0f$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
const $47c914305d1e5e0f$var$parseOrdinalNumberPattern = /petama|\d+/i;
const $47c914305d1e5e0f$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
const $47c914305d1e5e0f$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
const $47c914305d1e5e0f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
const $47c914305d1e5e0f$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
const $47c914305d1e5e0f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
const $47c914305d1e5e0f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
const $47c914305d1e5e0f$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
const $47c914305d1e5e0f$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
const $47c914305d1e5e0f$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
const $47c914305d1e5e0f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
const $47c914305d1e5e0f$var$match = $47c914305d1e5e0f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $47c914305d1e5e0f$var$matchOrdinalNumberPattern,
        parsePattern: $47c914305d1e5e0f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $47c914305d1e5e0f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47c914305d1e5e0f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $47c914305d1e5e0f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47c914305d1e5e0f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $47c914305d1e5e0f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47c914305d1e5e0f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $47c914305d1e5e0f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47c914305d1e5e0f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $47c914305d1e5e0f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $47c914305d1e5e0f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten](https://github.com/Zyten)
 */ const $cedc87cb3339996f$var$ms = $cedc87cb3339996f$export$5dd2165da01bec80 = {
    code: "ms",
    formatDistance: $c55b901486f8e3fc$export$2c14ff85d6318973,
    formatLong: $576ab11b809a633c$export$cbf60ecb96cbb82f,
    formatRelative: $017c2f5aaca51082$export$8fbbfd65594f46a0,
    localize: $f1d6ad7693241c21$export$b3bd0bc58e36cd63,
    match: $47c914305d1e5e0f$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($cedc87cb3339996f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $cedc87cb3339996f$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $cedc87cb3339996f$exports[key];
        }
    });
});
var $1767091ea876269e$exports = {};

$parcel$export($1767091ea876269e$exports, "mt", () => $1767091ea876269e$export$f2a459ff55c00db5, (v) => $1767091ea876269e$export$f2a459ff55c00db5 = v);
var $1767091ea876269e$export$f2a459ff55c00db5;
"use strict";
$1767091ea876269e$export$f2a459ff55c00db5 = void 0;
var $75f266c66e79d48d$export$2c14ff85d6318973;
"use strict";
$75f266c66e79d48d$export$2c14ff85d6318973 = void 0;
const $75f266c66e79d48d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "inqas minn sekonda",
        other: "inqas minn {{count}} sekondi"
    },
    xSeconds: {
        one: "sekonda",
        other: "{{count}} sekondi"
    },
    halfAMinute: "nofs minuta",
    lessThanXMinutes: {
        one: "inqas minn minuta",
        other: "inqas minn {{count}} minuti"
    },
    xMinutes: {
        one: "minuta",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: "madwar xahar",
        other: "madwar {{count}} xhur"
    },
    xMonths: {
        one: "xahar",
        other: "{{count}} xhur"
    },
    aboutXYears: {
        one: "madwar sena",
        two: "madwar sentejn",
        other: "madwar {{count}} snin"
    },
    xYears: {
        one: "sena",
        two: "sentejn",
        other: "{{count}} snin"
    },
    overXYears: {
        one: "aktar minn sena",
        two: "aktar minn sentejn",
        other: "aktar minn {{count}} snin"
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
const $75f266c66e79d48d$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $75f266c66e79d48d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + " ilu";
    }
    return result;
};
$75f266c66e79d48d$export$2c14ff85d6318973 = $75f266c66e79d48d$var$formatDistance;


var $a0a83d0e4898a3c2$export$cbf60ecb96cbb82f;
"use strict";
$a0a83d0e4898a3c2$export$cbf60ecb96cbb82f = void 0;

const $a0a83d0e4898a3c2$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
const $a0a83d0e4898a3c2$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $a0a83d0e4898a3c2$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $a0a83d0e4898a3c2$var$formatLong = $a0a83d0e4898a3c2$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a0a83d0e4898a3c2$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a0a83d0e4898a3c2$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a0a83d0e4898a3c2$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $2e6c614f4de3c8d6$export$8fbbfd65594f46a0;
"use strict";
$2e6c614f4de3c8d6$export$8fbbfd65594f46a0 = void 0;
const $2e6c614f4de3c8d6$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: "P"
};
const $2e6c614f4de3c8d6$var$formatRelative = (token, _date, _baseDate, _options)=>$2e6c614f4de3c8d6$var$formatRelativeLocale[token];
$2e6c614f4de3c8d6$export$8fbbfd65594f46a0 = $2e6c614f4de3c8d6$var$formatRelative;


var $2b3a12db51c6cc32$export$b3bd0bc58e36cd63;
"use strict";
$2b3a12db51c6cc32$export$b3bd0bc58e36cd63 = void 0;

const $2b3a12db51c6cc32$var$eraValues = {
    narrow: [
        "Q",
        "W"
    ],
    abbreviated: [
        "QK",
        "WK"
    ],
    wide: [
        "qabel Kristu",
        "wara Kristu"
    ]
};
const $2b3a12db51c6cc32$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kwart",
        "2. kwart",
        "3. kwart",
        "4. kwart"
    ]
};
const $2b3a12db51c6cc32$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "\u0120",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Fra",
        "Mar",
        "Apr",
        "Mej",
        "\u0120un",
        "Lul",
        "Aww",
        "Set",
        "Ott",
        "Nov",
        "Di\u010B"
    ],
    wide: [
        "Jannar",
        "Frar",
        "Marzu",
        "April",
        "Mejju",
        "\u0120unju",
        "Lulju",
        "Awwissu",
        "Settembru",
        "Ottubru",
        "Novembru",
        "Di\u010Bembru"
    ]
};
const $2b3a12db51c6cc32$var$dayValues = {
    narrow: [
        "\u0126",
        "T",
        "T",
        "E",
        "\u0126",
        "\u0120",
        "S"
    ],
    short: [
        "\u0126a",
        "Tn",
        "Tl",
        "Er",
        "\u0126a",
        "\u0120i",
        "Si"
    ],
    abbreviated: [
        "\u0126ad",
        "Tne",
        "Tli",
        "Erb",
        "\u0126am",
        "\u0120im",
        "Sib"
    ],
    wide: [
        "Il-\u0126add",
        "It-Tnejn",
        "It-Tlieta",
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        "Is-Sibt"
    ]
};
const $2b3a12db51c6cc32$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    }
};
const $2b3a12db51c6cc32$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    }
};
const $2b3a12db51c6cc32$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $2b3a12db51c6cc32$var$localize = $2b3a12db51c6cc32$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2b3a12db51c6cc32$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2b3a12db51c6cc32$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2b3a12db51c6cc32$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2b3a12db51c6cc32$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2b3a12db51c6cc32$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2b3a12db51c6cc32$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2b3a12db51c6cc32$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $afa665bc6ec9933b$export$4659b591c19bdf3d;
"use strict";
$afa665bc6ec9933b$export$4659b591c19bdf3d = void 0;


const $afa665bc6ec9933b$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
const $afa665bc6ec9933b$var$parseOrdinalNumberPattern = /\d+/i;
const $afa665bc6ec9933b$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
const $afa665bc6ec9933b$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
const $afa665bc6ec9933b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
const $afa665bc6ec9933b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $afa665bc6ec9933b$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
const $afa665bc6ec9933b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $afa665bc6ec9933b$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
const $afa665bc6ec9933b$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
const $afa665bc6ec9933b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
const $afa665bc6ec9933b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
const $afa665bc6ec9933b$var$match = $afa665bc6ec9933b$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $afa665bc6ec9933b$var$matchOrdinalNumberPattern,
        parsePattern: $afa665bc6ec9933b$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $afa665bc6ec9933b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afa665bc6ec9933b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $afa665bc6ec9933b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afa665bc6ec9933b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $afa665bc6ec9933b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afa665bc6ec9933b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $afa665bc6ec9933b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $afa665bc6ec9933b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $afa665bc6ec9933b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $afa665bc6ec9933b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ const $1767091ea876269e$var$mt = $1767091ea876269e$export$f2a459ff55c00db5 = {
    code: "mt",
    formatDistance: $75f266c66e79d48d$export$2c14ff85d6318973,
    formatLong: $a0a83d0e4898a3c2$export$cbf60ecb96cbb82f,
    formatRelative: $2e6c614f4de3c8d6$export$8fbbfd65594f46a0,
    localize: $2b3a12db51c6cc32$export$b3bd0bc58e36cd63,
    match: $afa665bc6ec9933b$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($1767091ea876269e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $1767091ea876269e$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $1767091ea876269e$exports[key];
        }
    });
});
var $4b8bba06a66d70b3$exports = {};

$parcel$export($4b8bba06a66d70b3$exports, "nb", () => $4b8bba06a66d70b3$export$38ef0e3f791a121e, (v) => $4b8bba06a66d70b3$export$38ef0e3f791a121e = v);
var $4b8bba06a66d70b3$export$38ef0e3f791a121e;
"use strict";
$4b8bba06a66d70b3$export$38ef0e3f791a121e = void 0;
var $24b5da7c351d34d8$export$2c14ff85d6318973;
"use strict";
$24b5da7c351d34d8$export$2c14ff85d6318973 = void 0;
const $24b5da7c351d34d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $24b5da7c351d34d8$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $24b5da7c351d34d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
$24b5da7c351d34d8$export$2c14ff85d6318973 = $24b5da7c351d34d8$var$formatDistance;


var $ebb68446d560ae47$export$cbf60ecb96cbb82f;
"use strict";
$ebb68446d560ae47$export$cbf60ecb96cbb82f = void 0;

const $ebb68446d560ae47$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $ebb68446d560ae47$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $ebb68446d560ae47$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $ebb68446d560ae47$var$formatLong = $ebb68446d560ae47$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ebb68446d560ae47$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ebb68446d560ae47$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $ebb68446d560ae47$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $b079eb7439ffd49b$export$8fbbfd65594f46a0;
"use strict";
$b079eb7439ffd49b$export$8fbbfd65594f46a0 = void 0;
const $b079eb7439ffd49b$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $b079eb7439ffd49b$var$formatRelative = (token, _date, _baseDate, _options)=>$b079eb7439ffd49b$var$formatRelativeLocale[token];
$b079eb7439ffd49b$export$8fbbfd65594f46a0 = $b079eb7439ffd49b$var$formatRelative;


var $f6e664541bbf13a6$export$b3bd0bc58e36cd63;
"use strict";
$f6e664541bbf13a6$export$b3bd0bc58e36cd63 = void 0;

const $f6e664541bbf13a6$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $f6e664541bbf13a6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $f6e664541bbf13a6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $f6e664541bbf13a6$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
const $f6e664541bbf13a6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
const $f6e664541bbf13a6$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $f6e664541bbf13a6$var$localize = $f6e664541bbf13a6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f6e664541bbf13a6$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f6e664541bbf13a6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f6e664541bbf13a6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f6e664541bbf13a6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f6e664541bbf13a6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f6e664541bbf13a6$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $162c9213d36854c7$export$4659b591c19bdf3d;
"use strict";
$162c9213d36854c7$export$4659b591c19bdf3d = void 0;


const $162c9213d36854c7$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $162c9213d36854c7$var$parseOrdinalNumberPattern = /\d+/i;
const $162c9213d36854c7$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $162c9213d36854c7$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $162c9213d36854c7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $162c9213d36854c7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $162c9213d36854c7$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $162c9213d36854c7$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $162c9213d36854c7$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
const $162c9213d36854c7$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $162c9213d36854c7$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
const $162c9213d36854c7$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $162c9213d36854c7$var$match = $162c9213d36854c7$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $162c9213d36854c7$var$matchOrdinalNumberPattern,
        parsePattern: $162c9213d36854c7$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $162c9213d36854c7$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $162c9213d36854c7$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $162c9213d36854c7$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $162c9213d36854c7$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $162c9213d36854c7$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $162c9213d36854c7$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $162c9213d36854c7$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $162c9213d36854c7$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $162c9213d36854c7$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $162c9213d36854c7$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse](https://github.com/Hanse)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Dag Stuan [@dagstuan](https://github.com/dagstuan)
 */ const $4b8bba06a66d70b3$var$nb = $4b8bba06a66d70b3$export$38ef0e3f791a121e = {
    code: "nb",
    formatDistance: $24b5da7c351d34d8$export$2c14ff85d6318973,
    formatLong: $ebb68446d560ae47$export$cbf60ecb96cbb82f,
    formatRelative: $b079eb7439ffd49b$export$8fbbfd65594f46a0,
    localize: $f6e664541bbf13a6$export$b3bd0bc58e36cd63,
    match: $162c9213d36854c7$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($4b8bba06a66d70b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $4b8bba06a66d70b3$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $4b8bba06a66d70b3$exports[key];
        }
    });
});
var $2a5ae5ca81bdd8a5$exports = {};

$parcel$export($2a5ae5ca81bdd8a5$exports, "nl", () => $2a5ae5ca81bdd8a5$export$9c64ee4d84d79ce1, (v) => $2a5ae5ca81bdd8a5$export$9c64ee4d84d79ce1 = v);
var $2a5ae5ca81bdd8a5$export$9c64ee4d84d79ce1;
"use strict";
$2a5ae5ca81bdd8a5$export$9c64ee4d84d79ce1 = void 0;
var $17793bc374f06083$export$2c14ff85d6318973;
"use strict";
$17793bc374f06083$export$2c14ff85d6318973 = void 0;
const $17793bc374f06083$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
const $17793bc374f06083$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $17793bc374f06083$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
$17793bc374f06083$export$2c14ff85d6318973 = $17793bc374f06083$var$formatDistance;


var $75fbcfb5886f8270$export$cbf60ecb96cbb82f;
"use strict";
$75fbcfb5886f8270$export$cbf60ecb96cbb82f = void 0;

const $75fbcfb5886f8270$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
const $75fbcfb5886f8270$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $75fbcfb5886f8270$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $75fbcfb5886f8270$var$formatLong = $75fbcfb5886f8270$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $75fbcfb5886f8270$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $75fbcfb5886f8270$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $75fbcfb5886f8270$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $071e578351f801fe$export$8fbbfd65594f46a0;
"use strict";
$071e578351f801fe$export$8fbbfd65594f46a0 = void 0;
const $071e578351f801fe$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $071e578351f801fe$var$formatRelative = (token, _date, _baseDate, _options)=>$071e578351f801fe$var$formatRelativeLocale[token];
$071e578351f801fe$export$8fbbfd65594f46a0 = $071e578351f801fe$var$formatRelative;


var $3ba04c6e2c5faf80$export$b3bd0bc58e36cd63;
"use strict";
$3ba04c6e2c5faf80$export$b3bd0bc58e36cd63 = void 0;

const $3ba04c6e2c5faf80$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $3ba04c6e2c5faf80$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
const $3ba04c6e2c5faf80$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $3ba04c6e2c5faf80$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
const $3ba04c6e2c5faf80$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
const $3ba04c6e2c5faf80$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $3ba04c6e2c5faf80$var$localize = $3ba04c6e2c5faf80$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $3ba04c6e2c5faf80$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3ba04c6e2c5faf80$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3ba04c6e2c5faf80$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3ba04c6e2c5faf80$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3ba04c6e2c5faf80$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $3ba04c6e2c5faf80$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $9300940fd126fd59$export$4659b591c19bdf3d;
"use strict";
$9300940fd126fd59$export$4659b591c19bdf3d = void 0;


const $9300940fd126fd59$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $9300940fd126fd59$var$parseOrdinalNumberPattern = /\d+/i;
const $9300940fd126fd59$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
const $9300940fd126fd59$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $9300940fd126fd59$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
const $9300940fd126fd59$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9300940fd126fd59$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
const $9300940fd126fd59$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
const $9300940fd126fd59$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
const $9300940fd126fd59$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
const $9300940fd126fd59$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
const $9300940fd126fd59$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
const $9300940fd126fd59$var$match = $9300940fd126fd59$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $9300940fd126fd59$var$matchOrdinalNumberPattern,
        parsePattern: $9300940fd126fd59$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $9300940fd126fd59$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9300940fd126fd59$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $9300940fd126fd59$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9300940fd126fd59$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $9300940fd126fd59$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9300940fd126fd59$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $9300940fd126fd59$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9300940fd126fd59$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $9300940fd126fd59$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9300940fd126fd59$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Edo Rivai [@edorivai](https://github.com/edorivai)
 * @author Niels Keurentjes [@curry684](https://github.com/curry684)
 * @author Stefan Vermaas [@stefanvermaas](https://github.com/stefanvermaas)
 */ const $2a5ae5ca81bdd8a5$var$nl = $2a5ae5ca81bdd8a5$export$9c64ee4d84d79ce1 = {
    code: "nl",
    formatDistance: $17793bc374f06083$export$2c14ff85d6318973,
    formatLong: $75fbcfb5886f8270$export$cbf60ecb96cbb82f,
    formatRelative: $071e578351f801fe$export$8fbbfd65594f46a0,
    localize: $3ba04c6e2c5faf80$export$b3bd0bc58e36cd63,
    match: $9300940fd126fd59$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($2a5ae5ca81bdd8a5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $2a5ae5ca81bdd8a5$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $2a5ae5ca81bdd8a5$exports[key];
        }
    });
});
var $cead72653324d6f1$exports = {};

$parcel$export($cead72653324d6f1$exports, "nlBE", () => $cead72653324d6f1$export$3fc71760fcd6c40e, (v) => $cead72653324d6f1$export$3fc71760fcd6c40e = v);
var $cead72653324d6f1$export$3fc71760fcd6c40e;
"use strict";
$cead72653324d6f1$export$3fc71760fcd6c40e = void 0;
var $fd87dc4c2a1f4c75$export$2c14ff85d6318973;
"use strict";
$fd87dc4c2a1f4c75$export$2c14ff85d6318973 = void 0;
const $fd87dc4c2a1f4c75$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
const $fd87dc4c2a1f4c75$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $fd87dc4c2a1f4c75$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
$fd87dc4c2a1f4c75$export$2c14ff85d6318973 = $fd87dc4c2a1f4c75$var$formatDistance;


var $cb404885444ea00d$export$cbf60ecb96cbb82f;
"use strict";
$cb404885444ea00d$export$cbf60ecb96cbb82f = void 0;

const $cb404885444ea00d$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
const $cb404885444ea00d$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $cb404885444ea00d$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $cb404885444ea00d$var$formatLong = $cb404885444ea00d$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $cb404885444ea00d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $cb404885444ea00d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $cb404885444ea00d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $4d3296113fa69376$export$8fbbfd65594f46a0;
"use strict";
$4d3296113fa69376$export$8fbbfd65594f46a0 = void 0;
const $4d3296113fa69376$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
const $4d3296113fa69376$var$formatRelative = (token, _date, _baseDate, _options)=>$4d3296113fa69376$var$formatRelativeLocale[token];
$4d3296113fa69376$export$8fbbfd65594f46a0 = $4d3296113fa69376$var$formatRelative;


var $1aed487cd68ec4e2$export$b3bd0bc58e36cd63;
"use strict";
$1aed487cd68ec4e2$export$b3bd0bc58e36cd63 = void 0;

const $1aed487cd68ec4e2$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
const $1aed487cd68ec4e2$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
const $1aed487cd68ec4e2$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $1aed487cd68ec4e2$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
const $1aed487cd68ec4e2$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
const $1aed487cd68ec4e2$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "e";
};
const $1aed487cd68ec4e2$var$localize = $1aed487cd68ec4e2$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1aed487cd68ec4e2$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1aed487cd68ec4e2$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1aed487cd68ec4e2$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1aed487cd68ec4e2$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1aed487cd68ec4e2$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1aed487cd68ec4e2$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $6a69bdd1c0735005$export$4659b591c19bdf3d;
"use strict";
$6a69bdd1c0735005$export$4659b591c19bdf3d = void 0;


const $6a69bdd1c0735005$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
const $6a69bdd1c0735005$var$parseOrdinalNumberPattern = /\d+/i;
const $6a69bdd1c0735005$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
const $6a69bdd1c0735005$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
const $6a69bdd1c0735005$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
const $6a69bdd1c0735005$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6a69bdd1c0735005$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
const $6a69bdd1c0735005$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
const $6a69bdd1c0735005$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
const $6a69bdd1c0735005$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
const $6a69bdd1c0735005$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
const $6a69bdd1c0735005$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
const $6a69bdd1c0735005$var$match = $6a69bdd1c0735005$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $6a69bdd1c0735005$var$matchOrdinalNumberPattern,
        parsePattern: $6a69bdd1c0735005$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6a69bdd1c0735005$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a69bdd1c0735005$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6a69bdd1c0735005$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a69bdd1c0735005$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6a69bdd1c0735005$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a69bdd1c0735005$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6a69bdd1c0735005$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a69bdd1c0735005$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6a69bdd1c0735005$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6a69bdd1c0735005$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */ const $cead72653324d6f1$var$nlBE = $cead72653324d6f1$export$3fc71760fcd6c40e = {
    code: "nl-BE",
    formatDistance: $fd87dc4c2a1f4c75$export$2c14ff85d6318973,
    formatLong: $cb404885444ea00d$export$cbf60ecb96cbb82f,
    formatRelative: $4d3296113fa69376$export$8fbbfd65594f46a0,
    localize: $1aed487cd68ec4e2$export$b3bd0bc58e36cd63,
    match: $6a69bdd1c0735005$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($cead72653324d6f1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $cead72653324d6f1$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $cead72653324d6f1$exports[key];
        }
    });
});
var $8c6a3b31f967b82f$exports = {};

$parcel$export($8c6a3b31f967b82f$exports, "nn", () => $8c6a3b31f967b82f$export$5581105212343b35, (v) => $8c6a3b31f967b82f$export$5581105212343b35 = v);
var $8c6a3b31f967b82f$export$5581105212343b35;
"use strict";
$8c6a3b31f967b82f$export$5581105212343b35 = void 0;
var $2bf94c258ca217c4$export$2c14ff85d6318973;
"use strict";
$2bf94c258ca217c4$export$2c14ff85d6318973 = void 0;
const $2bf94c258ca217c4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn eitt sekund",
        other: "mindre enn {{count}} sekund"
    },
    xSeconds: {
        one: "eitt sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "eit halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn eitt minutt",
        other: "mindre enn {{count}} minutt"
    },
    xMinutes: {
        one: "eitt minutt",
        other: "{{count}} minutt"
    },
    aboutXHours: {
        one: "omtrent ein time",
        other: "omtrent {{count}} timar"
    },
    xHours: {
        one: "ein time",
        other: "{{count}} timar"
    },
    xDays: {
        one: "ein dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "omtrent ei veke",
        other: "omtrent {{count}} veker"
    },
    xWeeks: {
        one: "ei veke",
        other: "{{count}} veker"
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
const $2bf94c258ca217c4$var$wordMapping = [
    "null",
    "ein",
    "to",
    "tre",
    "fire",
    "fem",
    "seks",
    "sju",
    "\xe5tte",
    "ni",
    "ti",
    "elleve",
    "tolv"
];
const $2bf94c258ca217c4$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2bf94c258ca217c4$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $2bf94c258ca217c4$var$wordMapping[count] : String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sidan";
    }
    return result;
};
$2bf94c258ca217c4$export$2c14ff85d6318973 = $2bf94c258ca217c4$var$formatDistance;


var $f0e5b70b1f61e2d0$export$cbf60ecb96cbb82f;
"use strict";
$f0e5b70b1f61e2d0$export$cbf60ecb96cbb82f = void 0;

const $f0e5b70b1f61e2d0$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
const $f0e5b70b1f61e2d0$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $f0e5b70b1f61e2d0$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $f0e5b70b1f61e2d0$var$formatLong = $f0e5b70b1f61e2d0$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f0e5b70b1f61e2d0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f0e5b70b1f61e2d0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f0e5b70b1f61e2d0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $099b9b86f23cd344$export$8fbbfd65594f46a0;
"use strict";
$099b9b86f23cd344$export$8fbbfd65594f46a0 = void 0;
const $099b9b86f23cd344$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $099b9b86f23cd344$var$formatRelative = (token, _date, _baseDate, _options)=>$099b9b86f23cd344$var$formatRelativeLocale[token];
$099b9b86f23cd344$export$8fbbfd65594f46a0 = $099b9b86f23cd344$var$formatRelative;


var $79ba3b1aee99a169$export$b3bd0bc58e36cd63;
"use strict";
$79ba3b1aee99a169$export$b3bd0bc58e36cd63 = void 0;

const $79ba3b1aee99a169$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
const $79ba3b1aee99a169$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $79ba3b1aee99a169$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
const $79ba3b1aee99a169$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "su",
        "m\xe5",
        "ty",
        "on",
        "to",
        "fr",
        "lau"
    ],
    abbreviated: [
        "sun",
        "m\xe5n",
        "tys",
        "ons",
        "tor",
        "fre",
        "laur"
    ],
    wide: [
        "sundag",
        "m\xe5ndag",
        "tysdag",
        "onsdag",
        "torsdag",
        "fredag",
        "laurdag"
    ]
};
const $79ba3b1aee99a169$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
const $79ba3b1aee99a169$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $79ba3b1aee99a169$var$localize = $79ba3b1aee99a169$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $79ba3b1aee99a169$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $79ba3b1aee99a169$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $79ba3b1aee99a169$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $79ba3b1aee99a169$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $79ba3b1aee99a169$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $79ba3b1aee99a169$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $2b106ee17a38cdd5$export$4659b591c19bdf3d;
"use strict";
$2b106ee17a38cdd5$export$4659b591c19bdf3d = void 0;


const $2b106ee17a38cdd5$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $2b106ee17a38cdd5$var$parseOrdinalNumberPattern = /\d+/i;
const $2b106ee17a38cdd5$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
const $2b106ee17a38cdd5$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
const $2b106ee17a38cdd5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
const $2b106ee17a38cdd5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $2b106ee17a38cdd5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
const $2b106ee17a38cdd5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $2b106ee17a38cdd5$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
const $2b106ee17a38cdd5$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $2b106ee17a38cdd5$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
const $2b106ee17a38cdd5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
const $2b106ee17a38cdd5$var$match = $2b106ee17a38cdd5$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $2b106ee17a38cdd5$var$matchOrdinalNumberPattern,
        parsePattern: $2b106ee17a38cdd5$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2b106ee17a38cdd5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b106ee17a38cdd5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2b106ee17a38cdd5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b106ee17a38cdd5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2b106ee17a38cdd5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b106ee17a38cdd5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2b106ee17a38cdd5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2b106ee17a38cdd5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $2b106ee17a38cdd5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2b106ee17a38cdd5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner](https://github.com/draperunner)
 */ const $8c6a3b31f967b82f$var$nn = $8c6a3b31f967b82f$export$5581105212343b35 = {
    code: "nn",
    formatDistance: $2bf94c258ca217c4$export$2c14ff85d6318973,
    formatLong: $f0e5b70b1f61e2d0$export$cbf60ecb96cbb82f,
    formatRelative: $099b9b86f23cd344$export$8fbbfd65594f46a0,
    localize: $79ba3b1aee99a169$export$b3bd0bc58e36cd63,
    match: $2b106ee17a38cdd5$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($8c6a3b31f967b82f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $8c6a3b31f967b82f$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $8c6a3b31f967b82f$exports[key];
        }
    });
});
var $ed3cf26a33eaadd4$exports = {};

$parcel$export($ed3cf26a33eaadd4$exports, "oc", () => $ed3cf26a33eaadd4$export$35a3191dac31414, (v) => $ed3cf26a33eaadd4$export$35a3191dac31414 = v);
var $ed3cf26a33eaadd4$export$35a3191dac31414;
"use strict";
$ed3cf26a33eaadd4$export$35a3191dac31414 = void 0;
var $34f641fa896347c1$export$2c14ff85d6318973;
"use strict";
$34f641fa896347c1$export$2c14ff85d6318973 = void 0;
const $34f641fa896347c1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: "mens de {{count}} segondas"
    },
    xSeconds: {
        one: "1 segonda",
        other: "{{count}} segondas"
    },
    halfAMinute: "30 segondas",
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: "mens de {{count}} minutas"
    },
    xMinutes: {
        one: "1 minuta",
        other: "{{count}} minutas"
    },
    aboutXHours: {
        one: "environ 1 ora",
        other: "environ {{count}} oras"
    },
    xHours: {
        one: "1 ora",
        other: "{{count}} oras"
    },
    xDays: {
        one: "1 jorn",
        other: "{{count}} jorns"
    },
    aboutXWeeks: {
        one: "environ 1 setmana",
        other: "environ {{count}} setmanas"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanas"
    },
    aboutXMonths: {
        one: "environ 1 mes",
        other: "environ {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: "mai de {{count}} ans"
    },
    almostXYears: {
        one: "gaireben un an",
        other: "gaireben {{count}} ans"
    }
};
const $34f641fa896347c1$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $34f641fa896347c1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return "fa " + result;
    }
    return result;
};
$34f641fa896347c1$export$2c14ff85d6318973 = $34f641fa896347c1$var$formatDistance;


var $0e72c4d634ff9715$export$cbf60ecb96cbb82f;
"use strict";
$0e72c4d634ff9715$export$cbf60ecb96cbb82f = void 0;

const $0e72c4d634ff9715$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $0e72c4d634ff9715$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $0e72c4d634ff9715$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $0e72c4d634ff9715$var$formatLong = $0e72c4d634ff9715$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0e72c4d634ff9715$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0e72c4d634ff9715$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0e72c4d634ff9715$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $d20b5d57eefb2fc4$export$8fbbfd65594f46a0;
"use strict";
$d20b5d57eefb2fc4$export$8fbbfd65594f46a0 = void 0;
const $d20b5d57eefb2fc4$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: "P"
};
const $d20b5d57eefb2fc4$var$formatRelative = (token, _date, _baseDate, _options)=>$d20b5d57eefb2fc4$var$formatRelativeLocale[token];
$d20b5d57eefb2fc4$export$8fbbfd65594f46a0 = $d20b5d57eefb2fc4$var$formatRelative;


var $9a2bab50b8ca560e$export$b3bd0bc58e36cd63;
"use strict";
$9a2bab50b8ca560e$export$b3bd0bc58e36cd63 = void 0;

const $9a2bab50b8ca560e$var$eraValues = {
    narrow: [
        "ab. J.C.",
        "apr. J.C."
    ],
    abbreviated: [
        "ab. J.C.",
        "apr. J.C."
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
const $9a2bab50b8ca560e$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1\xe8r trim.",
        "2nd trim.",
        "3en trim.",
        "4en trim."
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
const $9a2bab50b8ca560e$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MA",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DC"
    ],
    abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "mai",
        "junh",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "dec."
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        "abril",
        "mai",
        "junh",
        "julhet",
        "agost",
        "setembre",
        "oct\xf2bre",
        "novembre",
        "decembre"
    ]
};
const $9a2bab50b8ca560e$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "dimenge",
        "diluns",
        "dimars",
        "dim\xe8cres",
        "dij\xf2us",
        "divendres",
        "dissabte"
    ]
};
const $9a2bab50b8ca560e$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
const $9a2bab50b8ca560e$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    }
};
const $9a2bab50b8ca560e$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = "nd";
            break;
        default:
            ordinal = "en";
    }
    // feminine for year, week, hour, minute, second
    if (unit === "year" || unit === "week" || unit === "hour" || unit === "minute" || unit === "second") ordinal += "a";
    return number + ordinal;
};
const $9a2bab50b8ca560e$var$localize = $9a2bab50b8ca560e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9a2bab50b8ca560e$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9a2bab50b8ca560e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9a2bab50b8ca560e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9a2bab50b8ca560e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9a2bab50b8ca560e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9a2bab50b8ca560e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9a2bab50b8ca560e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $5789ec545d454610$export$4659b591c19bdf3d;
"use strict";
$5789ec545d454610$export$4659b591c19bdf3d = void 0;


const $5789ec545d454610$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
const $5789ec545d454610$var$parseOrdinalNumberPattern = /\d+/i;
const $5789ec545d454610$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
const $5789ec545d454610$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
const $5789ec545d454610$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
const $5789ec545d454610$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5789ec545d454610$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
const $5789ec545d454610$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $5789ec545d454610$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
const $5789ec545d454610$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
const $5789ec545d454610$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
const $5789ec545d454610$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
const $5789ec545d454610$var$match = $5789ec545d454610$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $5789ec545d454610$var$matchOrdinalNumberPattern,
        parsePattern: $5789ec545d454610$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5789ec545d454610$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5789ec545d454610$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5789ec545d454610$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5789ec545d454610$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5789ec545d454610$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5789ec545d454610$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5789ec545d454610$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5789ec545d454610$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $5789ec545d454610$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5789ec545d454610$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ const $ed3cf26a33eaadd4$var$oc = $ed3cf26a33eaadd4$export$35a3191dac31414 = {
    code: "oc",
    formatDistance: $34f641fa896347c1$export$2c14ff85d6318973,
    formatLong: $0e72c4d634ff9715$export$cbf60ecb96cbb82f,
    formatRelative: $d20b5d57eefb2fc4$export$8fbbfd65594f46a0,
    localize: $9a2bab50b8ca560e$export$b3bd0bc58e36cd63,
    match: $5789ec545d454610$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($ed3cf26a33eaadd4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $ed3cf26a33eaadd4$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $ed3cf26a33eaadd4$exports[key];
        }
    });
});
var $b0b18823be645a57$exports = {};

$parcel$export($b0b18823be645a57$exports, "pl", () => $b0b18823be645a57$export$6ea5311eda92944f, (v) => $b0b18823be645a57$export$6ea5311eda92944f = v);
var $b0b18823be645a57$export$6ea5311eda92944f;
"use strict";
$b0b18823be645a57$export$6ea5311eda92944f = void 0;
var $1afa14216c73227c$export$2c14ff85d6318973;
"use strict";
$1afa14216c73227c$export$2c14ff85d6318973 = void 0;
const $1afa14216c73227c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: "godzina",
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
    },
    overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
    },
    almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
    }
};
function $1afa14216c73227c$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    const rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    const rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $1afa14216c73227c$var$declension(scheme, count, time) {
    const group = $1afa14216c73227c$var$declensionGroup(scheme, count);
    const finalText = typeof group === "string" ? group : group[time];
    return finalText.replace("{{count}}", String(count));
}
const $1afa14216c73227c$var$formatDistance = (token, count, options)=>{
    const scheme = $1afa14216c73227c$var$formatDistanceLocale[token];
    if (!options?.addSuffix) return $1afa14216c73227c$var$declension(scheme, count, "regular");
    if (options.comparison && options.comparison > 0) return "za " + $1afa14216c73227c$var$declension(scheme, count, "future");
    else return $1afa14216c73227c$var$declension(scheme, count, "past") + " temu";
};
$1afa14216c73227c$export$2c14ff85d6318973 = $1afa14216c73227c$var$formatDistance;


var $6c39c0feac018297$export$cbf60ecb96cbb82f;
"use strict";
$6c39c0feac018297$export$cbf60ecb96cbb82f = void 0;

const $6c39c0feac018297$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
const $6c39c0feac018297$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6c39c0feac018297$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6c39c0feac018297$var$formatLong = $6c39c0feac018297$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6c39c0feac018297$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6c39c0feac018297$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6c39c0feac018297$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $38e434854b9278df$export$8fbbfd65594f46a0;
"use strict";
$38e434854b9278df$export$8fbbfd65594f46a0 = void 0;

const $38e434854b9278df$var$adjectivesLastWeek = {
    masculine: "ostatni",
    feminine: "ostatnia"
};
const $38e434854b9278df$var$adjectivesThisWeek = {
    masculine: "ten",
    feminine: "ta"
};
const $38e434854b9278df$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
const $38e434854b9278df$var$dayGrammaticalGender = {
    0: "feminine",
    1: "masculine",
    2: "masculine",
    3: "feminine",
    4: "masculine",
    5: "masculine",
    6: "feminine"
};
function $38e434854b9278df$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    let adjectives;
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) adjectives = $38e434854b9278df$var$adjectivesThisWeek;
    else if (token === "lastWeek") adjectives = $38e434854b9278df$var$adjectivesLastWeek;
    else if (token === "nextWeek") adjectives = $38e434854b9278df$var$adjectivesNextWeek;
    else throw new Error(`Cannot determine adjectives for token ${token}`);
    const day = date.getDay();
    const grammaticalGender = $38e434854b9278df$var$dayGrammaticalGender[day];
    const adjective = adjectives[grammaticalGender];
    return `'${adjective}' eeee 'o' p`;
}
const $38e434854b9278df$var$formatRelativeLocale = {
    lastWeek: $38e434854b9278df$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $38e434854b9278df$var$dayAndTimeWithAdjective,
    other: "P"
};
const $38e434854b9278df$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $38e434854b9278df$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(token, date, baseDate, options);
    return format;
};
$38e434854b9278df$export$8fbbfd65594f46a0 = $38e434854b9278df$var$formatRelative;


var $683d0699e6a3eabe$export$b3bd0bc58e36cd63;
"use strict";
$683d0699e6a3eabe$export$b3bd0bc58e36cd63 = void 0;

const $683d0699e6a3eabe$var$eraValues = {
    narrow: [
        "p.n.e.",
        "n.e."
    ],
    abbreviated: [
        "p.n.e.",
        "n.e."
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        "naszej ery"
    ]
};
const $683d0699e6a3eabe$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I kw.",
        "II kw.",
        "III kw.",
        "IV kw."
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
const $683d0699e6a3eabe$var$monthValues = {
    narrow: [
        "S",
        "L",
        "M",
        "K",
        "M",
        "C",
        "L",
        "S",
        "W",
        "P",
        "L",
        "G"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycze\u0144",
        "luty",
        "marzec",
        "kwiecie\u0144",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        "listopad",
        "grudzie\u0144"
    ]
};
const $683d0699e6a3eabe$var$monthFormattingValues = {
    narrow: [
        "s",
        "l",
        "m",
        "k",
        "m",
        "c",
        "l",
        "s",
        "w",
        "p",
        "l",
        "g"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        "listopada",
        "grudnia"
    ]
};
const $683d0699e6a3eabe$var$dayValues = {
    narrow: [
        "N",
        "P",
        "W",
        "\u015A",
        "C",
        "P",
        "S"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $683d0699e6a3eabe$var$dayFormattingValues = {
    narrow: [
        "n",
        "p",
        "w",
        "\u015B",
        "c",
        "p",
        "s"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
const $683d0699e6a3eabe$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: "rano",
        afternoon: "popo\u0142.",
        evening: "wiecz.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    }
};
const $683d0699e6a3eabe$var$dayPeriodFormattingValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: "rano",
        afternoon: "po po\u0142.",
        evening: "wiecz.",
        night: "w nocy"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    }
};
const $683d0699e6a3eabe$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $683d0699e6a3eabe$var$localize = $683d0699e6a3eabe$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $683d0699e6a3eabe$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $683d0699e6a3eabe$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $683d0699e6a3eabe$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $683d0699e6a3eabe$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $683d0699e6a3eabe$var$monthFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $683d0699e6a3eabe$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $683d0699e6a3eabe$var$dayFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $683d0699e6a3eabe$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $683d0699e6a3eabe$var$dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
    })
};


var $eb2dbf7382c23e5e$export$4659b591c19bdf3d;
"use strict";
$eb2dbf7382c23e5e$export$4659b591c19bdf3d = void 0;


const $eb2dbf7382c23e5e$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $eb2dbf7382c23e5e$var$parseOrdinalNumberPattern = /\d+/i;
const $eb2dbf7382c23e5e$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
const $eb2dbf7382c23e5e$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
const $eb2dbf7382c23e5e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
const $eb2dbf7382c23e5e$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
const $eb2dbf7382c23e5e$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
const $eb2dbf7382c23e5e$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
const $eb2dbf7382c23e5e$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
const $eb2dbf7382c23e5e$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
const $eb2dbf7382c23e5e$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
const $eb2dbf7382c23e5e$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
const $eb2dbf7382c23e5e$var$match = $eb2dbf7382c23e5e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $eb2dbf7382c23e5e$var$matchOrdinalNumberPattern,
        parsePattern: $eb2dbf7382c23e5e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $eb2dbf7382c23e5e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eb2dbf7382c23e5e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $eb2dbf7382c23e5e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eb2dbf7382c23e5e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $eb2dbf7382c23e5e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eb2dbf7382c23e5e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $eb2dbf7382c23e5e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $eb2dbf7382c23e5e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $eb2dbf7382c23e5e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $eb2dbf7382c23e5e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks](https://github.com/ertrzyiks)
 * @author Just RAG [@justrag](https://github.com/justrag)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Mateusz Tokarski [@mutisz](https://github.com/mutisz)
 */ const $b0b18823be645a57$var$pl = $b0b18823be645a57$export$6ea5311eda92944f = {
    code: "pl",
    formatDistance: $1afa14216c73227c$export$2c14ff85d6318973,
    formatLong: $6c39c0feac018297$export$cbf60ecb96cbb82f,
    formatRelative: $38e434854b9278df$export$8fbbfd65594f46a0,
    localize: $683d0699e6a3eabe$export$b3bd0bc58e36cd63,
    match: $eb2dbf7382c23e5e$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($b0b18823be645a57$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $b0b18823be645a57$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $b0b18823be645a57$exports[key];
        }
    });
});
var $7564c32209137063$exports = {};

$parcel$export($7564c32209137063$exports, "pt", () => $7564c32209137063$export$84175d5f1cb4e39d, (v) => $7564c32209137063$export$84175d5f1cb4e39d = v);
var $7564c32209137063$export$84175d5f1cb4e39d;
"use strict";
$7564c32209137063$export$84175d5f1cb4e39d = void 0;
var $710bd796f0deaf48$export$2c14ff85d6318973;
"use strict";
$710bd796f0deaf48$export$2c14ff85d6318973 = void 0;
const $710bd796f0deaf48$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $710bd796f0deaf48$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $710bd796f0deaf48$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
$710bd796f0deaf48$export$2c14ff85d6318973 = $710bd796f0deaf48$var$formatDistance;


var $73873235a09cb094$export$cbf60ecb96cbb82f;
"use strict";
$73873235a09cb094$export$cbf60ecb96cbb82f = void 0;

const $73873235a09cb094$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
const $73873235a09cb094$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $73873235a09cb094$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $73873235a09cb094$var$formatLong = $73873235a09cb094$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $73873235a09cb094$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $73873235a09cb094$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $73873235a09cb094$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $a25bec6173dd17ef$export$8fbbfd65594f46a0;
"use strict";
$a25bec6173dd17ef$export$8fbbfd65594f46a0 = void 0;
const $a25bec6173dd17ef$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $a25bec6173dd17ef$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $a25bec6173dd17ef$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$a25bec6173dd17ef$export$8fbbfd65594f46a0 = $a25bec6173dd17ef$var$formatRelative;


var $5c7d3a9f7e54faf6$export$b3bd0bc58e36cd63;
"use strict";
$5c7d3a9f7e54faf6$export$b3bd0bc58e36cd63 = void 0;

const $5c7d3a9f7e54faf6$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
const $5c7d3a9f7e54faf6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $5c7d3a9f7e54faf6$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $5c7d3a9f7e54faf6$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $5c7d3a9f7e54faf6$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
const $5c7d3a9f7e54faf6$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
const $5c7d3a9f7e54faf6$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\xba";
};
const $5c7d3a9f7e54faf6$var$localize = $5c7d3a9f7e54faf6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5c7d3a9f7e54faf6$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5c7d3a9f7e54faf6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5c7d3a9f7e54faf6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5c7d3a9f7e54faf6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5c7d3a9f7e54faf6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5c7d3a9f7e54faf6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5c7d3a9f7e54faf6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $459b02de4352bba4$export$4659b591c19bdf3d;
"use strict";
$459b02de4352bba4$export$4659b591c19bdf3d = void 0;


const $459b02de4352bba4$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
const $459b02de4352bba4$var$parseOrdinalNumberPattern = /\d+/i;
const $459b02de4352bba4$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
const $459b02de4352bba4$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
const $459b02de4352bba4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
const $459b02de4352bba4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $459b02de4352bba4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $459b02de4352bba4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $459b02de4352bba4$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
const $459b02de4352bba4$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
const $459b02de4352bba4$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
const $459b02de4352bba4$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
const $459b02de4352bba4$var$match = $459b02de4352bba4$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $459b02de4352bba4$var$matchOrdinalNumberPattern,
        parsePattern: $459b02de4352bba4$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $459b02de4352bba4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b02de4352bba4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $459b02de4352bba4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b02de4352bba4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $459b02de4352bba4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b02de4352bba4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $459b02de4352bba4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $459b02de4352bba4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $459b02de4352bba4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $459b02de4352bba4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire](https://github.com/dfreire)
 * @author Adrián de la Rosa [@adrm](https://github.com/adrm)
 */ const $7564c32209137063$var$pt = $7564c32209137063$export$84175d5f1cb4e39d = {
    code: "pt",
    formatDistance: $710bd796f0deaf48$export$2c14ff85d6318973,
    formatLong: $73873235a09cb094$export$cbf60ecb96cbb82f,
    formatRelative: $a25bec6173dd17ef$export$8fbbfd65594f46a0,
    localize: $5c7d3a9f7e54faf6$export$b3bd0bc58e36cd63,
    match: $459b02de4352bba4$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($7564c32209137063$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $7564c32209137063$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $7564c32209137063$exports[key];
        }
    });
});
var $63c284978e0a70f9$exports = {};

$parcel$export($63c284978e0a70f9$exports, "ptBR", () => $63c284978e0a70f9$export$93dd81123f5ddbcd, (v) => $63c284978e0a70f9$export$93dd81123f5ddbcd = v);
var $63c284978e0a70f9$export$93dd81123f5ddbcd;
"use strict";
$63c284978e0a70f9$export$93dd81123f5ddbcd = void 0;
var $12769eeeda569b3a$export$2c14ff85d6318973;
"use strict";
$12769eeeda569b3a$export$2c14ff85d6318973 = void 0;
const $12769eeeda569b3a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "cerca de 1 hora",
        other: "cerca de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "cerca de 1 semana",
        other: "cerca de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: "cerca de {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "cerca de 1 ano",
        other: "cerca de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
const $12769eeeda569b3a$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $12769eeeda569b3a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "em " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
$12769eeeda569b3a$export$2c14ff85d6318973 = $12769eeeda569b3a$var$formatDistance;


var $4bfc312cafad856c$export$cbf60ecb96cbb82f;
"use strict";
$4bfc312cafad856c$export$cbf60ecb96cbb82f = void 0;

const $4bfc312cafad856c$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $4bfc312cafad856c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $4bfc312cafad856c$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $4bfc312cafad856c$var$formatLong = $4bfc312cafad856c$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $4bfc312cafad856c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $4bfc312cafad856c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $4bfc312cafad856c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $8a895a843ce52a17$export$8fbbfd65594f46a0;
"use strict";
$8a895a843ce52a17$export$8fbbfd65594f46a0 = void 0;
const $8a895a843ce52a17$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const weekday = date.getDay();
        const last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
const $8a895a843ce52a17$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $8a895a843ce52a17$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$8a895a843ce52a17$export$8fbbfd65594f46a0 = $8a895a843ce52a17$var$formatRelative;


var $d8003cbeb818fd26$export$b3bd0bc58e36cd63;
"use strict";
$d8003cbeb818fd26$export$b3bd0bc58e36cd63 = void 0;

const $d8003cbeb818fd26$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "depois de cristo"
    ]
};
const $d8003cbeb818fd26$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
const $d8003cbeb818fd26$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
const $d8003cbeb818fd26$var$dayValues = {
    narrow: [
        "D",
        "S",
        "T",
        "Q",
        "Q",
        "S",
        "S"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sab"
    ],
    abbreviated: [
        "domingo",
        "segunda",
        "ter\xe7a",
        "quarta",
        "quinta",
        "sexta",
        "s\xe1bado"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
const $d8003cbeb818fd26$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    }
};
const $d8003cbeb818fd26$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    }
};
const $d8003cbeb818fd26$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    if (options?.unit === "week") return number + "\xaa";
    return number + "\xba";
};
const $d8003cbeb818fd26$var$localize = $d8003cbeb818fd26$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $d8003cbeb818fd26$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d8003cbeb818fd26$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d8003cbeb818fd26$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d8003cbeb818fd26$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d8003cbeb818fd26$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $d8003cbeb818fd26$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d8003cbeb818fd26$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $00c6f292ab8389fe$export$4659b591c19bdf3d;
"use strict";
$00c6f292ab8389fe$export$4659b591c19bdf3d = void 0;


const $00c6f292ab8389fe$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
const $00c6f292ab8389fe$var$parseOrdinalNumberPattern = /\d+/i;
const $00c6f292ab8389fe$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
const $00c6f292ab8389fe$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
const $00c6f292ab8389fe$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
const $00c6f292ab8389fe$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $00c6f292ab8389fe$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
const $00c6f292ab8389fe$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
const $00c6f292ab8389fe$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
const $00c6f292ab8389fe$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
const $00c6f292ab8389fe$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
const $00c6f292ab8389fe$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
const $00c6f292ab8389fe$var$match = $00c6f292ab8389fe$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $00c6f292ab8389fe$var$matchOrdinalNumberPattern,
        parsePattern: $00c6f292ab8389fe$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $00c6f292ab8389fe$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $00c6f292ab8389fe$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $00c6f292ab8389fe$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $00c6f292ab8389fe$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $00c6f292ab8389fe$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $00c6f292ab8389fe$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $00c6f292ab8389fe$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $00c6f292ab8389fe$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $00c6f292ab8389fe$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $00c6f292ab8389fe$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe](https://github.com/duailibe)
 * @author Yago Carballo [@yagocarballo](https://github.com/YagoCarballo)
 */ const $63c284978e0a70f9$var$ptBR = $63c284978e0a70f9$export$93dd81123f5ddbcd = {
    code: "pt-BR",
    formatDistance: $12769eeeda569b3a$export$2c14ff85d6318973,
    formatLong: $4bfc312cafad856c$export$cbf60ecb96cbb82f,
    formatRelative: $8a895a843ce52a17$export$8fbbfd65594f46a0,
    localize: $d8003cbeb818fd26$export$b3bd0bc58e36cd63,
    match: $00c6f292ab8389fe$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($63c284978e0a70f9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $63c284978e0a70f9$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $63c284978e0a70f9$exports[key];
        }
    });
});
var $3dfffbc32cc8b1be$exports = {};

$parcel$export($3dfffbc32cc8b1be$exports, "ro", () => $3dfffbc32cc8b1be$export$ea30ec7f37fb148d, (v) => $3dfffbc32cc8b1be$export$ea30ec7f37fb148d = v);
var $3dfffbc32cc8b1be$export$ea30ec7f37fb148d;
"use strict";
$3dfffbc32cc8b1be$export$ea30ec7f37fb148d = void 0;
var $757298c77a7c8bc7$export$2c14ff85d6318973;
"use strict";
$757298c77a7c8bc7$export$2c14ff85d6318973 = void 0;
const $757298c77a7c8bc7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: "{{count}} secunde"
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "1 or\u0103",
        other: "{{count}} ore"
    },
    xDays: {
        one: "1 zi",
        other: "{{count}} zile"
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: "circa {{count}} luni"
    },
    xMonths: {
        one: "1 lun\u0103",
        other: "{{count}} luni"
    },
    aboutXYears: {
        one: "circa 1 an",
        other: "circa {{count}} ani"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ani"
    },
    overXYears: {
        one: "peste 1 an",
        other: "peste {{count}} ani"
    },
    almostXYears: {
        one: "aproape 1 an",
        other: "aproape {{count}} ani"
    }
};
const $757298c77a7c8bc7$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $757298c77a7c8bc7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
$757298c77a7c8bc7$export$2c14ff85d6318973 = $757298c77a7c8bc7$var$formatDistance;


var $722d0989eacc22a9$export$cbf60ecb96cbb82f;
"use strict";
$722d0989eacc22a9$export$cbf60ecb96cbb82f = void 0;

const $722d0989eacc22a9$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd.MM.yyyy"
};
const $722d0989eacc22a9$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $722d0989eacc22a9$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $722d0989eacc22a9$var$formatLong = $722d0989eacc22a9$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $722d0989eacc22a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $722d0989eacc22a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $722d0989eacc22a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $f0eabb9e335d660b$export$8fbbfd65594f46a0;
"use strict";
$f0eabb9e335d660b$export$8fbbfd65594f46a0 = void 0;
const $f0eabb9e335d660b$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: "P"
};
const $f0eabb9e335d660b$var$formatRelative = (token, _date, _baseDate, _options)=>$f0eabb9e335d660b$var$formatRelativeLocale[token];
$f0eabb9e335d660b$export$8fbbfd65594f46a0 = $f0eabb9e335d660b$var$formatRelative;


var $fa1a31b72f6d7a38$export$b3bd0bc58e36cd63;
"use strict";
$fa1a31b72f6d7a38$export$b3bd0bc58e36cd63 = void 0;

const $fa1a31b72f6d7a38$var$eraValues = {
    narrow: [
        "\xce",
        "D"
    ],
    abbreviated: [
        "\xce.d.C.",
        "D.C."
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
const $fa1a31b72f6d7a38$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "primul trimestru",
        "al doilea trimestru",
        "al treilea trimestru",
        "al patrulea trimestru"
    ]
};
const $fa1a31b72f6d7a38$var$monthValues = {
    narrow: [
        "I",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
    ],
    wide: [
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
    ]
};
const $fa1a31b72f6d7a38$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "du",
        "lu",
        "ma",
        "mi",
        "jo",
        "vi",
        "s\xe2"
    ],
    abbreviated: [
        "dum",
        "lun",
        "mar",
        "mie",
        "joi",
        "vin",
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        "luni",
        "mar\u021Bi",
        "miercuri",
        "joi",
        "vineri",
        "s\xe2mb\u0103t\u0103"
    ]
};
const $fa1a31b72f6d7a38$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "ami",
        morning: "dim",
        afternoon: "da",
        evening: "s",
        night: "n"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $fa1a31b72f6d7a38$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
const $fa1a31b72f6d7a38$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $fa1a31b72f6d7a38$var$localize = $fa1a31b72f6d7a38$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $fa1a31b72f6d7a38$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fa1a31b72f6d7a38$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fa1a31b72f6d7a38$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fa1a31b72f6d7a38$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fa1a31b72f6d7a38$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $fa1a31b72f6d7a38$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $fa1a31b72f6d7a38$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $a1911086c19873ea$export$4659b591c19bdf3d;
"use strict";
$a1911086c19873ea$export$4659b591c19bdf3d = void 0;


const $a1911086c19873ea$var$matchOrdinalNumberPattern = /^(\d+)?/i;
const $a1911086c19873ea$var$parseOrdinalNumberPattern = /\d+/i;
const $a1911086c19873ea$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
const $a1911086c19873ea$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
const $a1911086c19873ea$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
const $a1911086c19873ea$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a1911086c19873ea$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
const $a1911086c19873ea$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $a1911086c19873ea$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
const $a1911086c19873ea$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
const $a1911086c19873ea$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
const $a1911086c19873ea$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
const $a1911086c19873ea$var$match = $a1911086c19873ea$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $a1911086c19873ea$var$matchOrdinalNumberPattern,
        parsePattern: $a1911086c19873ea$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a1911086c19873ea$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1911086c19873ea$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a1911086c19873ea$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1911086c19873ea$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a1911086c19873ea$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1911086c19873ea$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a1911086c19873ea$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a1911086c19873ea$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a1911086c19873ea$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a1911086c19873ea$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu](https://github.com/jsergiu)
 * @author Adrian Ocneanu [@aocneanu](https://github.com/aocneanu)
 * @author Mihai Ocneanu [@gandesc](https://github.com/gandesc)
 */ const $3dfffbc32cc8b1be$var$ro = $3dfffbc32cc8b1be$export$ea30ec7f37fb148d = {
    code: "ro",
    formatDistance: $757298c77a7c8bc7$export$2c14ff85d6318973,
    formatLong: $722d0989eacc22a9$export$cbf60ecb96cbb82f,
    formatRelative: $f0eabb9e335d660b$export$8fbbfd65594f46a0,
    localize: $fa1a31b72f6d7a38$export$b3bd0bc58e36cd63,
    match: $a1911086c19873ea$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($3dfffbc32cc8b1be$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $3dfffbc32cc8b1be$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $3dfffbc32cc8b1be$exports[key];
        }
    });
});
var $6f15e12c22828b00$exports = {};

$parcel$export($6f15e12c22828b00$exports, "ru", () => $6f15e12c22828b00$export$cf48009033a0126b, (v) => $6f15e12c22828b00$export$cf48009033a0126b = v);
var $6f15e12c22828b00$export$cf48009033a0126b;
"use strict";
$6f15e12c22828b00$export$cf48009033a0126b = void 0;
var $82c56e259a188c60$export$2c14ff85d6318973;
"use strict";
$82c56e259a188c60$export$2c14ff85d6318973 = void 0;
function $82c56e259a188c60$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $82c56e259a188c60$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $82c56e259a188c60$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $82c56e259a188c60$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $82c56e259a188c60$var$declension(scheme.past, count);
                else return $82c56e259a188c60$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $82c56e259a188c60$var$declension(scheme.regular, count);
    };
}
const $82c56e259a188c60$var$formatDistanceLocale = {
    lessThanXSeconds: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: (_count, options)=>{
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $82c56e259a188c60$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
const $82c56e259a188c60$var$formatDistance = (token, count, options)=>{
    return $82c56e259a188c60$var$formatDistanceLocale[token](count, options);
};
$82c56e259a188c60$export$2c14ff85d6318973 = $82c56e259a188c60$var$formatDistance;


var $0d44460c25f08b91$export$cbf60ecb96cbb82f;
"use strict";
$0d44460c25f08b91$export$cbf60ecb96cbb82f = void 0;

const $0d44460c25f08b91$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
const $0d44460c25f08b91$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $0d44460c25f08b91$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $0d44460c25f08b91$var$formatLong = $0d44460c25f08b91$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0d44460c25f08b91$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0d44460c25f08b91$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $0d44460c25f08b91$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $404cf5d7ccb45bff$export$8fbbfd65594f46a0;
"use strict";
$404cf5d7ccb45bff$export$8fbbfd65594f46a0 = void 0;

const $404cf5d7ccb45bff$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $404cf5d7ccb45bff$var$lastWeek(day) {
    const weekday = $404cf5d7ccb45bff$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $404cf5d7ccb45bff$var$thisWeek(day) {
    const weekday = $404cf5d7ccb45bff$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $404cf5d7ccb45bff$var$nextWeek(day) {
    const weekday = $404cf5d7ccb45bff$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
const $404cf5d7ccb45bff$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $404cf5d7ccb45bff$var$thisWeek(day);
        else return $404cf5d7ccb45bff$var$lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $404cf5d7ccb45bff$var$thisWeek(day);
        else return $404cf5d7ccb45bff$var$nextWeek(day);
    },
    other: "P"
};
const $404cf5d7ccb45bff$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $404cf5d7ccb45bff$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$404cf5d7ccb45bff$export$8fbbfd65594f46a0 = $404cf5d7ccb45bff$var$formatRelative;


var $7867d8f6d07270ed$export$b3bd0bc58e36cd63;
"use strict";
$7867d8f6d07270ed$export$b3bd0bc58e36cd63 = void 0;

const $7867d8f6d07270ed$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
const $7867d8f6d07270ed$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $7867d8f6d07270ed$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
const $7867d8f6d07270ed$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
const $7867d8f6d07270ed$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
const $7867d8f6d07270ed$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
const $7867d8f6d07270ed$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
const $7867d8f6d07270ed$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    let suffix;
    if (unit === "date") suffix = "-\u0435";
    else if (unit === "week" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
const $7867d8f6d07270ed$var$localize = $7867d8f6d07270ed$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7867d8f6d07270ed$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7867d8f6d07270ed$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7867d8f6d07270ed$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7867d8f6d07270ed$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $7867d8f6d07270ed$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7867d8f6d07270ed$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $7867d8f6d07270ed$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $7867d8f6d07270ed$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $6c26fc40dbdea4bb$export$4659b591c19bdf3d;
"use strict";
$6c26fc40dbdea4bb$export$4659b591c19bdf3d = void 0;


const $6c26fc40dbdea4bb$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
const $6c26fc40dbdea4bb$var$parseOrdinalNumberPattern = /\d+/i;
const $6c26fc40dbdea4bb$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
const $6c26fc40dbdea4bb$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $6c26fc40dbdea4bb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
const $6c26fc40dbdea4bb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6c26fc40dbdea4bb$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
const $6c26fc40dbdea4bb$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $6c26fc40dbdea4bb$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
const $6c26fc40dbdea4bb$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
const $6c26fc40dbdea4bb$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
const $6c26fc40dbdea4bb$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $6c26fc40dbdea4bb$var$match = $6c26fc40dbdea4bb$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $6c26fc40dbdea4bb$var$matchOrdinalNumberPattern,
        parsePattern: $6c26fc40dbdea4bb$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c26fc40dbdea4bb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c26fc40dbdea4bb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c26fc40dbdea4bb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c26fc40dbdea4bb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c26fc40dbdea4bb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c26fc40dbdea4bb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c26fc40dbdea4bb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c26fc40dbdea4bb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c26fc40dbdea4bb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c26fc40dbdea4bb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $6f15e12c22828b00$var$ru = $6f15e12c22828b00$export$cf48009033a0126b = {
    code: "ru",
    formatDistance: $82c56e259a188c60$export$2c14ff85d6318973,
    formatLong: $0d44460c25f08b91$export$cbf60ecb96cbb82f,
    formatRelative: $404cf5d7ccb45bff$export$8fbbfd65594f46a0,
    localize: $7867d8f6d07270ed$export$b3bd0bc58e36cd63,
    match: $6c26fc40dbdea4bb$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($6f15e12c22828b00$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $6f15e12c22828b00$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $6f15e12c22828b00$exports[key];
        }
    });
});
var $900e3ce3c3239028$exports = {};

$parcel$export($900e3ce3c3239028$exports, "se", () => $900e3ce3c3239028$export$6362df887b441e93, (v) => $900e3ce3c3239028$export$6362df887b441e93 = v);
var $900e3ce3c3239028$export$6362df887b441e93;
"use strict";
$900e3ce3c3239028$export$6362df887b441e93 = void 0;
var $ff25fa8304919727$export$2c14ff85d6318973;
"use strict";
$ff25fa8304919727$export$2c14ff85d6318973 = void 0;
const $ff25fa8304919727$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "unnit go ovtta sekundda",
        other: "unnit go {{count}} sekundda"
    },
    xSeconds: {
        one: "sekundda",
        other: "{{count}} sekundda"
    },
    halfAMinute: "bealle minuhta",
    lessThanXMinutes: {
        one: "unnit go bealle minuhta",
        other: "unnit go {{count}} minuhta"
    },
    xMinutes: {
        one: "minuhta",
        other: "{{count}} minuhta"
    },
    aboutXHours: {
        one: "sullii ovtta diimmu",
        other: "sullii {{count}} diimmu"
    },
    xHours: {
        one: "diimmu",
        other: "{{count}} diimmu"
    },
    xDays: {
        one: "beaivvi",
        other: "{{count}} beaivvi"
    },
    aboutXWeeks: {
        one: "sullii ovtta vahku",
        other: "sullii {{count}} vahku"
    },
    xWeeks: {
        one: "vahku",
        other: "{{count}} vahku"
    },
    aboutXMonths: {
        one: "sullii ovtta m\xe1nu",
        other: "sullii {{count}} m\xe1nu"
    },
    xMonths: {
        one: "m\xe1nu",
        other: "{{count}} m\xe1nu"
    },
    aboutXYears: {
        one: "sullii ovtta jagi",
        other: "sullii {{count}} jagi"
    },
    xYears: {
        one: "jagi",
        other: "{{count}} jagi"
    },
    overXYears: {
        one: "guhkit go jagi",
        other: "guhkit go {{count}} jagi"
    },
    almostXYears: {
        one: "measta jagi",
        other: "measta {{count}} jagi"
    }
};
const $ff25fa8304919727$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ff25fa8304919727$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "geah\u010Den " + result;
        else return result + " \xe1igi";
    }
    return result;
};
$ff25fa8304919727$export$2c14ff85d6318973 = $ff25fa8304919727$var$formatDistance;


var $29120e2fe6b3774b$export$cbf60ecb96cbb82f;
"use strict";
$29120e2fe6b3774b$export$cbf60ecb96cbb82f = void 0;

const $29120e2fe6b3774b$var$dateFormats = {
    full: "EEEE MMMM d. 'b.' y",
    long: "MMMM d. 'b.' y",
    medium: "MMM d. 'b.' y",
    short: "dd.MM.y"
};
const $29120e2fe6b3774b$var$timeFormats = {
    full: "'dii.' HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $29120e2fe6b3774b$var$dateTimeFormats = {
    full: "{{date}} 'dii.' {{time}}",
    long: "{{date}} 'dii.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $29120e2fe6b3774b$var$formatLong = $29120e2fe6b3774b$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $29120e2fe6b3774b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $29120e2fe6b3774b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $29120e2fe6b3774b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $18404188ff214181$export$8fbbfd65594f46a0;
"use strict";
$18404188ff214181$export$8fbbfd65594f46a0 = void 0;
const $18404188ff214181$var$formatRelativeLocale = {
    lastWeek: "'ovddit' eeee 'dii.' p",
    yesterday: "'ikte dii.' p",
    today: "'odne dii.' p",
    tomorrow: "'ihtin dii.' p",
    nextWeek: "EEEE 'dii.' p",
    other: "P"
};
const $18404188ff214181$var$formatRelative = (token, _date, _baseDate, _options)=>$18404188ff214181$var$formatRelativeLocale[token];
$18404188ff214181$export$8fbbfd65594f46a0 = $18404188ff214181$var$formatRelative;


var $f89e3dc1c8da3aeb$export$b3bd0bc58e36cd63;
"use strict";
$f89e3dc1c8da3aeb$export$b3bd0bc58e36cd63 = void 0;

const $f89e3dc1c8da3aeb$var$eraValues = {
    narrow: [
        "o.Kr.",
        "m.Kr."
    ],
    abbreviated: [
        "o.Kr.",
        "m.Kr."
    ],
    wide: [
        "ovdal Kristusa",
        "ma\u014B\u014Bel Kristusa"
    ]
};
const $f89e3dc1c8da3aeb$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvart\xe1la",
        "2. kvart\xe1la",
        "3. kvart\xe1la",
        "4. kvart\xe1la"
    ]
};
const $f89e3dc1c8da3aeb$var$monthValues = {
    narrow: [
        "O",
        "G",
        "N",
        "C",
        "M",
        "G",
        "S",
        "B",
        "\u010C",
        "G",
        "S",
        "J"
    ],
    abbreviated: [
        "o\u0111\u0111a",
        "guov",
        "njuk",
        "cuo",
        "mies",
        "geas",
        "suoi",
        "borg",
        "\u010Dak\u010D",
        "golg",
        "sk\xe1b",
        "juov"
    ],
    wide: [
        "o\u0111\u0111ajagem\xe1nnu",
        "guovvam\xe1nnu",
        "njuk\u010Dam\xe1nnu",
        "cuo\u014Bom\xe1nnu",
        "miessem\xe1nnu",
        "geassem\xe1nnu",
        "suoidnem\xe1nnu",
        "borgem\xe1nnu",
        "\u010Dak\u010Dam\xe1nnu",
        "golggotm\xe1nnu",
        "sk\xe1bmam\xe1nnu",
        "juovlam\xe1nnu"
    ]
};
const $f89e3dc1c8da3aeb$var$dayValues = {
    narrow: [
        "S",
        "V",
        "M",
        "G",
        "D",
        "B",
        "L"
    ],
    short: [
        "sotn",
        "vuos",
        "ma\u014B",
        "gask",
        "duor",
        "bear",
        "l\xe1v"
    ],
    abbreviated: [
        "sotn",
        "vuos",
        "ma\u014B",
        "gask",
        "duor",
        "bear",
        "l\xe1v"
    ],
    wide: [
        "sotnabeaivi",
        "vuoss\xe1rga",
        "ma\u014B\u014Beb\xe1rga",
        "gaskavahkku",
        "duorastat",
        "bearjadat",
        "l\xe1vvardat"
    ]
};
const $f89e3dc1c8da3aeb$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gaskaidja",
        noon: "gaskabeaivi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaska.",
        evening: "eahkes",
        night: "ihkku"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gaskaidja",
        noon: "gaskabeaivvi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaskabea.",
        evening: "eahkes",
        night: "ihkku"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gaskaidja",
        noon: "gaskabeavvi",
        morning: "i\u0111\u0111es",
        afternoon: "ma\u014B\u014Bel gaskabeaivvi",
        evening: "eahkes",
        night: "ihkku"
    }
};
const $f89e3dc1c8da3aeb$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $f89e3dc1c8da3aeb$var$localize = $f89e3dc1c8da3aeb$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f89e3dc1c8da3aeb$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f89e3dc1c8da3aeb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f89e3dc1c8da3aeb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f89e3dc1c8da3aeb$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f89e3dc1c8da3aeb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f89e3dc1c8da3aeb$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};


var $1378019bf6f6e425$export$4659b591c19bdf3d;
"use strict";
$1378019bf6f6e425$export$4659b591c19bdf3d = void 0;


const $1378019bf6f6e425$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $1378019bf6f6e425$var$parseOrdinalNumberPattern = /\d+/i;
const $1378019bf6f6e425$var$matchEraPatterns = {
    narrow: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
    abbreviated: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
    wide: /^(ovdal Kristusa|ovdal min áiggi|maŋŋel Kristusa|min áigi)/i
};
const $1378019bf6f6e425$var$parseEraPatterns = {
    any: [
        /^o/i,
        /^m/i
    ]
};
const $1378019bf6f6e425$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartála/i
};
const $1378019bf6f6e425$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $1378019bf6f6e425$var$matchMonthPatterns = {
    narrow: /^[ogncmsbčj]/i,
    abbreviated: /^(ođđa|guov|njuk|cuo|mies|geas|suoi|borg|čakč|golg|skáb|juov)\.?/i,
    wide: /^(ođđajagemánnu|guovvamánnu|njukčamánnu|cuoŋománnu|miessemánnu|geassemánnu|suoidnemánnu|borgemánnu|čakčamánnu|golggotmánnu|skábmamánnu|juovlamánnu)/i
};
const $1378019bf6f6e425$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^g/i,
        /^n/i,
        /^c/i,
        /^m/i,
        /^g/i,
        /^s/i,
        /^b/i,
        /^č/i,
        /^g/i,
        /^s/i,
        /^j/i
    ],
    any: [
        /^o/i,
        /^gu/i,
        /^n/i,
        /^c/i,
        /^m/i,
        /^ge/i,
        /^su/i,
        /^b/i,
        /^č/i,
        /^go/i,
        /^sk/i,
        /^j/i
    ]
};
const $1378019bf6f6e425$var$matchDayPatterns = {
    narrow: /^[svmgdbl]/i,
    short: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
    abbreviated: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
    wide: /^(sotnabeaivi|vuossárga|maŋŋebárga|gaskavahkku|duorastat|bearjadat|lávvardat)/i
};
const $1378019bf6f6e425$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^v/i,
        /^m/i,
        /^g/i,
        /^d/i,
        /^b/i,
        /^l/i
    ]
};
const $1378019bf6f6e425$var$matchDayPeriodPatterns = {
    narrow: /^(gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku))/i
};
const $1378019bf6f6e425$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^gaskai/i,
        noon: /^gaskab/i,
        morning: /iđđes/i,
        afternoon: /maŋŋel gaskabeaivvi/i,
        evening: /eahkes/i,
        night: /ihkku/i
    }
};
const $1378019bf6f6e425$var$match = $1378019bf6f6e425$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $1378019bf6f6e425$var$matchOrdinalNumberPattern,
        parsePattern: $1378019bf6f6e425$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $1378019bf6f6e425$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1378019bf6f6e425$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $1378019bf6f6e425$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1378019bf6f6e425$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $1378019bf6f6e425$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1378019bf6f6e425$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $1378019bf6f6e425$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1378019bf6f6e425$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $1378019bf6f6e425$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1378019bf6f6e425$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Northern Sámi locale.
 * @language Northern Sámi
 * @iso-639-2 sme
 * @author Audun Rundberg [@audunru](https://github.com/audunru)
 */ const $900e3ce3c3239028$var$se = $900e3ce3c3239028$export$6362df887b441e93 = {
    code: "se",
    formatDistance: $ff25fa8304919727$export$2c14ff85d6318973,
    formatLong: $29120e2fe6b3774b$export$cbf60ecb96cbb82f,
    formatRelative: $18404188ff214181$export$8fbbfd65594f46a0,
    localize: $f89e3dc1c8da3aeb$export$b3bd0bc58e36cd63,
    match: $1378019bf6f6e425$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($900e3ce3c3239028$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $900e3ce3c3239028$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $900e3ce3c3239028$exports[key];
        }
    });
});
var $aa387ff56e9eb58c$exports = {};

$parcel$export($aa387ff56e9eb58c$exports, "sk", () => $aa387ff56e9eb58c$export$d608fa5b5bfd2021, (v) => $aa387ff56e9eb58c$export$d608fa5b5bfd2021 = v);
var $aa387ff56e9eb58c$export$d608fa5b5bfd2021;
"use strict";
$aa387ff56e9eb58c$export$d608fa5b5bfd2021 = void 0;
var $16ae195b335c3984$export$2c14ff85d6318973;
"use strict";
$16ae195b335c3984$export$2c14ff85d6318973 = void 0;
function $16ae195b335c3984$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $16ae195b335c3984$var$declension(scheme, count, time) {
    const group = $16ae195b335c3984$var$declensionGroup(scheme, count);
    const finalText = group[time];
    return finalText.replace("{{count}}", String(count));
}
function $16ae195b335c3984$var$extractPreposition(token) {
    const result = [
        "lessThan",
        "about",
        "over",
        "almost"
    ].filter(function(preposition) {
        return !!token.match(new RegExp("^" + preposition));
    });
    return result[0];
}
function $16ae195b335c3984$var$prefixPreposition(preposition) {
    let translation = "";
    if (preposition === "almost") translation = "takmer";
    if (preposition === "about") translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + " " : "";
}
function $16ae195b335c3984$var$suffixPreposition(preposition) {
    let translation = "";
    if (preposition === "lessThan") translation = "menej ne\u017E";
    if (preposition === "over") translation = "viac ne\u017E";
    return translation.length > 0 ? translation + " " : "";
}
function $16ae195b335c3984$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
const $16ae195b335c3984$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: "sekunda",
            past: "sekundou",
            future: "sekundu"
        },
        twoFour: {
            present: "{{count}} sekundy",
            past: "{{count}} sekundami",
            future: "{{count}} sekundy"
        },
        other: {
            present: "{{count}} sek\xfand",
            past: "{{count}} sekundami",
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: "hodina",
            past: "hodinou",
            future: "hodinu"
        },
        twoFour: {
            present: "{{count}} hodiny",
            past: "{{count}} hodinami",
            future: "{{count}} hodiny"
        },
        other: {
            present: "{{count}} hod\xedn",
            past: "{{count}} hodinami",
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: "{{count}} dni",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dni"
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: "mesiac",
            past: "mesiacom",
            future: "mesiac"
        },
        twoFour: {
            present: "{{count}} mesiace",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiace"
        },
        other: {
            present: "{{count}} mesiacov",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiacov"
        }
    },
    xYears: {
        one: {
            present: "rok",
            past: "rokom",
            future: "rok"
        },
        twoFour: {
            present: "{{count}} roky",
            past: "{{count}} rokmi",
            future: "{{count}} roky"
        },
        other: {
            present: "{{count}} rokov",
            past: "{{count}} rokmi",
            future: "{{count}} rokov"
        }
    }
};
const $16ae195b335c3984$var$formatDistance = (token, count, options)=>{
    const preposition = $16ae195b335c3984$var$extractPreposition(token) || "";
    const key = $16ae195b335c3984$var$lowercaseFirstLetter(token.substring(preposition.length));
    const scheme = $16ae195b335c3984$var$formatDistanceLocale[key];
    if (!options?.addSuffix) return $16ae195b335c3984$var$prefixPreposition(preposition) + $16ae195b335c3984$var$suffixPreposition(preposition) + $16ae195b335c3984$var$declension(scheme, count, "present");
    if (options.comparison && options.comparison > 0) return $16ae195b335c3984$var$prefixPreposition(preposition) + "o " + $16ae195b335c3984$var$suffixPreposition(preposition) + $16ae195b335c3984$var$declension(scheme, count, "future");
    else return $16ae195b335c3984$var$prefixPreposition(preposition) + "pred " + $16ae195b335c3984$var$suffixPreposition(preposition) + $16ae195b335c3984$var$declension(scheme, count, "past");
};
$16ae195b335c3984$export$2c14ff85d6318973 = $16ae195b335c3984$var$formatDistance;


var $c5397aac9482879a$export$cbf60ecb96cbb82f;
"use strict";
$c5397aac9482879a$export$cbf60ecb96cbb82f = void 0;

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
const $c5397aac9482879a$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. M. y",
    short: "d. M. y"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
const $c5397aac9482879a$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
const $c5397aac9482879a$var$dateTimeFormats = {
    full: "{{date}}, {{time}}",
    long: "{{date}}, {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}} {{time}}"
};
const $c5397aac9482879a$var$formatLong = $c5397aac9482879a$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c5397aac9482879a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c5397aac9482879a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c5397aac9482879a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $cdaeac864995f4f3$export$8fbbfd65594f46a0;
"use strict";
$cdaeac864995f4f3$export$8fbbfd65594f46a0 = void 0;

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
const $cdaeac864995f4f3$var$accusativeWeekdays = [
    "nede\u013Eu",
    "pondelok",
    "utorok",
    "stredu",
    "\u0161tvrtok",
    "piatok",
    "sobotu"
];
function $cdaeac864995f4f3$var$lastWeek(day) {
    const weekday = $cdaeac864995f4f3$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $cdaeac864995f4f3$var$thisWeek(day) {
    const weekday = $cdaeac864995f4f3$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $cdaeac864995f4f3$var$nextWeek(day) {
    const weekday = $cdaeac864995f4f3$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
const $cdaeac864995f4f3$var$formatRelativeLocale = {
    lastWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $cdaeac864995f4f3$var$thisWeek(day);
        else return $cdaeac864995f4f3$var$lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: (date, baseDate, options)=>{
        const day = date.getDay();
        if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $cdaeac864995f4f3$var$thisWeek(day);
        else return $cdaeac864995f4f3$var$nextWeek(day);
    },
    other: "P"
};
const $cdaeac864995f4f3$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $cdaeac864995f4f3$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$cdaeac864995f4f3$export$8fbbfd65594f46a0 = $cdaeac864995f4f3$var$formatRelative;


var $a96a054eed0c3a11$export$b3bd0bc58e36cd63;
"use strict";
$a96a054eed0c3a11$export$b3bd0bc58e36cd63 = void 0;

// https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
const $a96a054eed0c3a11$var$eraValues = {
    narrow: [
        "pred Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pred Kr.",
        "po Kr."
    ],
    wide: [
        "pred Kristom",
        "po Kristovi"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
const $a96a054eed0c3a11$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
const $a96a054eed0c3a11$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "marec",
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "august",
        "september",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
const $a96a054eed0c3a11$var$formattingMonthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        "marca",
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        "augusta",
        "septembra",
        "okt\xf3bra",
        "novembra",
        "decembra"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
const $a96a054eed0c3a11$var$dayValues = {
    narrow: [
        "n",
        "p",
        "u",
        "s",
        "\u0161",
        "p",
        "s"
    ],
    short: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    abbreviated: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    wide: [
        "nede\u013Ea",
        "pondelok",
        "utorok",
        "streda",
        "\u0161tvrtok",
        "piatok",
        "sobota"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
const $a96a054eed0c3a11$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "polnoc",
        noon: "poludnie",
        morning: "r\xe1no",
        afternoon: "popoludnie",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $a96a054eed0c3a11$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "nap.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "v n."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "napol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "v noci"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o polnoci",
        noon: "napoludnie",
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: "v noci"
    }
};
const $a96a054eed0c3a11$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $a96a054eed0c3a11$var$localize = $a96a054eed0c3a11$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a96a054eed0c3a11$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a96a054eed0c3a11$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a96a054eed0c3a11$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a96a054eed0c3a11$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $a96a054eed0c3a11$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a96a054eed0c3a11$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $a96a054eed0c3a11$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a96a054eed0c3a11$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $ba7665a898fa5279$export$4659b591c19bdf3d;
"use strict";
$ba7665a898fa5279$export$4659b591c19bdf3d = void 0;


const $ba7665a898fa5279$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $ba7665a898fa5279$var$parseOrdinalNumberPattern = /\d+/i;
const $ba7665a898fa5279$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
const $ba7665a898fa5279$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
const $ba7665a898fa5279$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
const $ba7665a898fa5279$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ba7665a898fa5279$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
const $ba7665a898fa5279$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ba7665a898fa5279$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
const $ba7665a898fa5279$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
const $ba7665a898fa5279$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
const $ba7665a898fa5279$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
const $ba7665a898fa5279$var$match = $ba7665a898fa5279$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $ba7665a898fa5279$var$matchOrdinalNumberPattern,
        parsePattern: $ba7665a898fa5279$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ba7665a898fa5279$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7665a898fa5279$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ba7665a898fa5279$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7665a898fa5279$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ba7665a898fa5279$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7665a898fa5279$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ba7665a898fa5279$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7665a898fa5279$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ba7665a898fa5279$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ba7665a898fa5279$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak](https://github.com/mareksuscak)
 */ const $aa387ff56e9eb58c$var$sk = $aa387ff56e9eb58c$export$d608fa5b5bfd2021 = {
    code: "sk",
    formatDistance: $16ae195b335c3984$export$2c14ff85d6318973,
    formatLong: $c5397aac9482879a$export$cbf60ecb96cbb82f,
    formatRelative: $cdaeac864995f4f3$export$8fbbfd65594f46a0,
    localize: $a96a054eed0c3a11$export$b3bd0bc58e36cd63,
    match: $ba7665a898fa5279$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($aa387ff56e9eb58c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $aa387ff56e9eb58c$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $aa387ff56e9eb58c$exports[key];
        }
    });
});
var $f399c0bf26684ad9$exports = {};

$parcel$export($f399c0bf26684ad9$exports, "sl", () => $f399c0bf26684ad9$export$c48c9775cb5125a6, (v) => $f399c0bf26684ad9$export$c48c9775cb5125a6 = v);
var $f399c0bf26684ad9$export$c48c9775cb5125a6;
"use strict";
$f399c0bf26684ad9$export$c48c9775cb5125a6 = void 0;
var $05959fa5dd310905$export$2c14ff85d6318973;
"use strict";
$05959fa5dd310905$export$2c14ff85d6318973 = void 0;
function $05959fa5dd310905$var$isPluralType(val) {
    return val.one !== undefined;
}
const $05959fa5dd310905$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: "manj kot {{count}} sekunda",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        },
        past: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundama",
            few: "manj kot {{count}} sekundami",
            other: "manj kot {{count}} sekundami"
        },
        future: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        }
    },
    xSeconds: {
        present: {
            one: "{{count}} sekunda",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        },
        past: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundama",
            few: "{{count}} sekundami",
            other: "{{count}} sekundami"
        },
        future: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        }
    },
    halfAMinute: "pol minute",
    lessThanXMinutes: {
        present: {
            one: "manj kot {{count}} minuta",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        },
        past: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minutama",
            few: "manj kot {{count}} minutami",
            other: "manj kot {{count}} minutami"
        },
        future: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        }
    },
    xMinutes: {
        present: {
            one: "{{count}} minuta",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        },
        past: {
            one: "{{count}} minuto",
            two: "{{count}} minutama",
            few: "{{count}} minutami",
            other: "{{count}} minutami"
        },
        future: {
            one: "{{count}} minuto",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: "{{count}} ura",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        },
        past: {
            one: "{{count}} uro",
            two: "{{count}} urama",
            few: "{{count}} urami",
            other: "{{count}} urami"
        },
        future: {
            one: "{{count}} uro",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        }
    },
    xDays: {
        present: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        },
        past: {
            one: "{{count}} dnem",
            two: "{{count}} dnevoma",
            few: "{{count}} dnevi",
            other: "{{count}} dnevi"
        },
        future: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: "{{count}} teden",
        two: "{{count}} tedna",
        few: "{{count}} tedne",
        other: "{{count}} tednov"
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} meseci",
            other: "{{count}} mesecev"
        },
        past: {
            one: "{{count}} mesecem",
            two: "{{count}} mesecema",
            few: "{{count}} meseci",
            other: "{{count}} meseci"
        },
        future: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} mesece",
            other: "{{count}} mesecev"
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        },
        past: {
            one: "{{count}} letom",
            two: "{{count}} letoma",
            few: "{{count}} leti",
            other: "{{count}} leti"
        },
        future: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        },
        past: {
            one: "skoraj {{count}} letom",
            two: "skoraj {{count}} letoma",
            few: "skoraj {{count}} leti",
            other: "skoraj {{count}} leti"
        },
        future: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        }
    }
};
function $05959fa5dd310905$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return "one";
        case 2:
            return "two";
        case 3:
        case 4:
            return "few";
        default:
            return "other";
    }
}
const $05959fa5dd310905$var$formatDistance = (token, count, options)=>{
    let result = "";
    let tense = "present";
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = "future";
            result = "\u010Dez ";
        } else {
            tense = "past";
            result = "pred ";
        }
    }
    const tokenValue = $05959fa5dd310905$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result += tokenValue;
    else {
        const form = $05959fa5dd310905$var$getFormFromCount(count);
        if ($05959fa5dd310905$var$isPluralType(tokenValue)) result += tokenValue[form].replace("{{count}}", String(count));
        else result += tokenValue[tense][form].replace("{{count}}", String(count));
    }
    return result;
};
$05959fa5dd310905$export$2c14ff85d6318973 = $05959fa5dd310905$var$formatDistance;


var $144c725b57061b6e$export$cbf60ecb96cbb82f;
"use strict";
$144c725b57061b6e$export$cbf60ecb96cbb82f = void 0;

const $144c725b57061b6e$var$dateFormats = {
    full: "EEEE, dd. MMMM y",
    long: "dd. MMMM y",
    medium: "d. MMM y",
    short: "d. MM. yy"
};
const $144c725b57061b6e$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $144c725b57061b6e$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $144c725b57061b6e$var$formatLong = $144c725b57061b6e$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $144c725b57061b6e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $144c725b57061b6e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $144c725b57061b6e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $0e1059732f6e3990$export$8fbbfd65594f46a0;
"use strict";
$0e1059732f6e3990$export$8fbbfd65594f46a0 = void 0;
const $0e1059732f6e3990$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: "P"
};
const $0e1059732f6e3990$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $0e1059732f6e3990$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$0e1059732f6e3990$export$8fbbfd65594f46a0 = $0e1059732f6e3990$var$formatRelative;


var $0859595677c58b5d$export$b3bd0bc58e36cd63;
"use strict";
$0859595677c58b5d$export$b3bd0bc58e36cd63 = void 0;

const $0859595677c58b5d$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
const $0859595677c58b5d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
const $0859595677c58b5d$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "avg.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marec",
        "april",
        "maj",
        "junij",
        "julij",
        "avgust",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $0859595677c58b5d$var$dayValues = {
    narrow: [
        "n",
        "p",
        "t",
        "s",
        "\u010D",
        "p",
        "s"
    ],
    short: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    abbreviated: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    wide: [
        "nedelja",
        "ponedeljek",
        "torek",
        "sreda",
        "\u010Detrtek",
        "petek",
        "sobota"
    ]
};
const $0859595677c58b5d$var$dayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "j",
        afternoon: "p",
        evening: "v",
        night: "n"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "poln.",
        noon: "pold.",
        morning: "jut.",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "polno\u010D",
        noon: "poldne",
        morning: "jutro",
        afternoon: "popoldne",
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
const $0859595677c58b5d$var$formattingDayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "zj",
        afternoon: "p",
        evening: "zv",
        night: "po"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "opoln.",
        noon: "opold.",
        morning: "zjut.",
        afternoon: "pop.",
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "opolno\u010Di",
        noon: "opoldne",
        morning: "zjutraj",
        afternoon: "popoldan",
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
const $0859595677c58b5d$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $0859595677c58b5d$var$localize = $0859595677c58b5d$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $0859595677c58b5d$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0859595677c58b5d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0859595677c58b5d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0859595677c58b5d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0859595677c58b5d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $0859595677c58b5d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0859595677c58b5d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $7577db203f06d851$export$4659b591c19bdf3d;
"use strict";
$7577db203f06d851$export$4659b591c19bdf3d = void 0;


const $7577db203f06d851$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $7577db203f06d851$var$parseOrdinalNumberPattern = /\d+/i;
const $7577db203f06d851$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
const $7577db203f06d851$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
const $7577db203f06d851$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
const $7577db203f06d851$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7577db203f06d851$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
const $7577db203f06d851$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $7577db203f06d851$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
const $7577db203f06d851$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
const $7577db203f06d851$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
const $7577db203f06d851$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
const $7577db203f06d851$var$match = $7577db203f06d851$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $7577db203f06d851$var$matchOrdinalNumberPattern,
        parsePattern: $7577db203f06d851$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7577db203f06d851$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7577db203f06d851$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7577db203f06d851$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7577db203f06d851$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7577db203f06d851$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7577db203f06d851$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7577db203f06d851$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7577db203f06d851$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7577db203f06d851$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7577db203f06d851$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph](https://github.com/Neoglyph)
 * @author Mato Žgajner [@mzgajner](https://github.com/mzgajner)
 */ const $f399c0bf26684ad9$var$sl = $f399c0bf26684ad9$export$c48c9775cb5125a6 = {
    code: "sl",
    formatDistance: $05959fa5dd310905$export$2c14ff85d6318973,
    formatLong: $144c725b57061b6e$export$cbf60ecb96cbb82f,
    formatRelative: $0e1059732f6e3990$export$8fbbfd65594f46a0,
    localize: $0859595677c58b5d$export$b3bd0bc58e36cd63,
    match: $7577db203f06d851$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($f399c0bf26684ad9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $f399c0bf26684ad9$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $f399c0bf26684ad9$exports[key];
        }
    });
});
var $a81e6502cf890c1e$exports = {};

$parcel$export($a81e6502cf890c1e$exports, "sq", () => $a81e6502cf890c1e$export$a8157a6a5eefedbe, (v) => $a81e6502cf890c1e$export$a8157a6a5eefedbe = v);
var $a81e6502cf890c1e$export$a8157a6a5eefedbe;
"use strict";
$a81e6502cf890c1e$export$a8157a6a5eefedbe = void 0;
var $86487ae92521b59c$export$2c14ff85d6318973;
"use strict";
$86487ae92521b59c$export$2c14ff85d6318973 = void 0;
const $86487ae92521b59c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: "{{count}} sekonda"
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: "rreth 1 muaj",
        other: "rreth {{count}} muaj"
    },
    xMonths: {
        one: "1 muaj",
        other: "{{count}} muaj"
    },
    aboutXYears: {
        one: "rreth 1 vit",
        other: "rreth {{count}} vite"
    },
    xYears: {
        one: "1 vit",
        other: "{{count}} vite"
    },
    overXYears: {
        one: "mbi 1 vit",
        other: "mbi {{count}} vite"
    },
    almostXYears: {
        one: "pothuajse 1 vit",
        other: "pothuajse {{count}} vite"
    }
};
const $86487ae92521b59c$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $86487ae92521b59c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
$86487ae92521b59c$export$2c14ff85d6318973 = $86487ae92521b59c$var$formatDistance;


var $83941ff615dcc637$export$cbf60ecb96cbb82f;
"use strict";
$83941ff615dcc637$export$cbf60ecb96cbb82f = void 0;

const $83941ff615dcc637$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $83941ff615dcc637$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $83941ff615dcc637$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $83941ff615dcc637$var$formatLong = $83941ff615dcc637$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $83941ff615dcc637$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $83941ff615dcc637$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $83941ff615dcc637$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $24b13fa303375274$export$8fbbfd65594f46a0;
"use strict";
$24b13fa303375274$export$8fbbfd65594f46a0 = void 0;
const $24b13fa303375274$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $24b13fa303375274$var$formatRelative = (token, _date, _baseDate, _options)=>$24b13fa303375274$var$formatRelativeLocale[token];
$24b13fa303375274$export$8fbbfd65594f46a0 = $24b13fa303375274$var$formatRelative;


var $9fd88ee1583dba18$export$b3bd0bc58e36cd63;
"use strict";
$9fd88ee1583dba18$export$b3bd0bc58e36cd63 = void 0;

const $9fd88ee1583dba18$var$eraValues = {
    narrow: [
        "P",
        "M"
    ],
    abbreviated: [
        "PK",
        "MK"
    ],
    wide: [
        "Para Krishtit",
        "Mbas Krishtit"
    ]
};
const $9fd88ee1583dba18$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "4-mujori I",
        "4-mujori II",
        "4-mujori III",
        "4-mujori IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $9fd88ee1583dba18$var$monthValues = {
    narrow: [
        "J",
        "S",
        "M",
        "P",
        "M",
        "Q",
        "K",
        "G",
        "S",
        "T",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Shk",
        "Mar",
        "Pri",
        "Maj",
        "Qer",
        "Kor",
        "Gus",
        "Sht",
        "Tet",
        "N\xebn",
        "Dhj"
    ],
    wide: [
        "Janar",
        "Shkurt",
        "Mars",
        "Prill",
        "Maj",
        "Qershor",
        "Korrik",
        "Gusht",
        "Shtator",
        "Tetor",
        "N\xebntor",
        "Dhjetor"
    ]
};
const $9fd88ee1583dba18$var$dayValues = {
    narrow: [
        "D",
        "H",
        "M",
        "M",
        "E",
        "P",
        "S"
    ],
    short: [
        "Di",
        "H\xeb",
        "Ma",
        "M\xeb",
        "En",
        "Pr",
        "Sh"
    ],
    abbreviated: [
        "Die",
        "H\xebn",
        "Mar",
        "M\xebr",
        "Enj",
        "Pre",
        "Sht"
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        "Enjte",
        "Premte",
        "Shtun\xeb"
    ]
};
const $9fd88ee1583dba18$var$dayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "m\xebngjes",
        afternoon: "dite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
const $9fd88ee1583dba18$var$formattingDayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
const $9fd88ee1583dba18$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    if (options?.unit === "hour") return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + "t";
    return number + "-t\xeb";
};
const $9fd88ee1583dba18$var$localize = $9fd88ee1583dba18$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $9fd88ee1583dba18$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9fd88ee1583dba18$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9fd88ee1583dba18$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9fd88ee1583dba18$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9fd88ee1583dba18$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $9fd88ee1583dba18$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9fd88ee1583dba18$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $f910a82adfb5c86d$export$4659b591c19bdf3d;
"use strict";
$f910a82adfb5c86d$export$4659b591c19bdf3d = void 0;


const $f910a82adfb5c86d$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
const $f910a82adfb5c86d$var$parseOrdinalNumberPattern = /\d+/i;
const $f910a82adfb5c86d$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
const $f910a82adfb5c86d$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
const $f910a82adfb5c86d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
const $f910a82adfb5c86d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $f910a82adfb5c86d$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
const $f910a82adfb5c86d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
const $f910a82adfb5c86d$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
const $f910a82adfb5c86d$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
const $f910a82adfb5c86d$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
const $f910a82adfb5c86d$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
const $f910a82adfb5c86d$var$match = $f910a82adfb5c86d$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $f910a82adfb5c86d$var$matchOrdinalNumberPattern,
        parsePattern: $f910a82adfb5c86d$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f910a82adfb5c86d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f910a82adfb5c86d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f910a82adfb5c86d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f910a82adfb5c86d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f910a82adfb5c86d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f910a82adfb5c86d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f910a82adfb5c86d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f910a82adfb5c86d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $f910a82adfb5c86d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f910a82adfb5c86d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine](https://github.com/arditdine)
 */ const $a81e6502cf890c1e$var$sq = $a81e6502cf890c1e$export$a8157a6a5eefedbe = {
    code: "sq",
    formatDistance: $86487ae92521b59c$export$2c14ff85d6318973,
    formatLong: $83941ff615dcc637$export$cbf60ecb96cbb82f,
    formatRelative: $24b13fa303375274$export$8fbbfd65594f46a0,
    localize: $9fd88ee1583dba18$export$b3bd0bc58e36cd63,
    match: $f910a82adfb5c86d$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($a81e6502cf890c1e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $a81e6502cf890c1e$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $a81e6502cf890c1e$exports[key];
        }
    });
});
var $225fa3c2955f7cba$exports = {};

$parcel$export($225fa3c2955f7cba$exports, "sr", () => $225fa3c2955f7cba$export$187592e8a03966af, (v) => $225fa3c2955f7cba$export$187592e8a03966af = v);
var $225fa3c2955f7cba$export$187592e8a03966af;
"use strict";
$225fa3c2955f7cba$export$187592e8a03966af = void 0;
var $1990738f9367a28b$export$2c14ff85d6318973;
"use strict";
$1990738f9367a28b$export$2c14ff85d6318973 = void 0;
const $1990738f9367a28b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
const $1990738f9367a28b$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $1990738f9367a28b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
$1990738f9367a28b$export$2c14ff85d6318973 = $1990738f9367a28b$var$formatDistance;


var $4131722dd45a126e$export$cbf60ecb96cbb82f;
"use strict";
$4131722dd45a126e$export$cbf60ecb96cbb82f = void 0;

const $4131722dd45a126e$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $4131722dd45a126e$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $4131722dd45a126e$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $4131722dd45a126e$var$formatLong = $4131722dd45a126e$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $4131722dd45a126e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $4131722dd45a126e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $4131722dd45a126e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $27de76ebfd5f3430$export$8fbbfd65594f46a0;
"use strict";
$27de76ebfd5f3430$export$8fbbfd65594f46a0 = void 0;
const $27de76ebfd5f3430$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: "P"
};
const $27de76ebfd5f3430$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $27de76ebfd5f3430$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$27de76ebfd5f3430$export$8fbbfd65594f46a0 = $27de76ebfd5f3430$var$formatRelative;


var $f3678e8b33101825$export$b3bd0bc58e36cd63;
"use strict";
$f3678e8b33101825$export$b3bd0bc58e36cd63 = void 0;

const $f3678e8b33101825$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
const $f3678e8b33101825$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $f3678e8b33101825$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
const $f3678e8b33101825$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
const $f3678e8b33101825$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $f3678e8b33101825$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
const $f3678e8b33101825$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
const $f3678e8b33101825$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $f3678e8b33101825$var$localize = $f3678e8b33101825$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f3678e8b33101825$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f3678e8b33101825$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f3678e8b33101825$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f3678e8b33101825$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $f3678e8b33101825$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f3678e8b33101825$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $f3678e8b33101825$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f3678e8b33101825$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $fd833ce03247fe47$export$4659b591c19bdf3d;
"use strict";
$fd833ce03247fe47$export$4659b591c19bdf3d = void 0;


const $fd833ce03247fe47$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $fd833ce03247fe47$var$parseOrdinalNumberPattern = /\d+/i;
const $fd833ce03247fe47$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
const $fd833ce03247fe47$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
const $fd833ce03247fe47$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
const $fd833ce03247fe47$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $fd833ce03247fe47$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
const $fd833ce03247fe47$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $fd833ce03247fe47$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
const $fd833ce03247fe47$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
const $fd833ce03247fe47$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
const $fd833ce03247fe47$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
const $fd833ce03247fe47$var$match = $fd833ce03247fe47$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $fd833ce03247fe47$var$matchOrdinalNumberPattern,
        parsePattern: $fd833ce03247fe47$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd833ce03247fe47$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd833ce03247fe47$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd833ce03247fe47$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd833ce03247fe47$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd833ce03247fe47$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd833ce03247fe47$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd833ce03247fe47$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd833ce03247fe47$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd833ce03247fe47$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fd833ce03247fe47$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */ const $225fa3c2955f7cba$var$sr = $225fa3c2955f7cba$export$187592e8a03966af = {
    code: "sr",
    formatDistance: $1990738f9367a28b$export$2c14ff85d6318973,
    formatLong: $4131722dd45a126e$export$cbf60ecb96cbb82f,
    formatRelative: $27de76ebfd5f3430$export$8fbbfd65594f46a0,
    localize: $f3678e8b33101825$export$b3bd0bc58e36cd63,
    match: $fd833ce03247fe47$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($225fa3c2955f7cba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $225fa3c2955f7cba$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $225fa3c2955f7cba$exports[key];
        }
    });
});
var $55289315f11c98c9$exports = {};

$parcel$export($55289315f11c98c9$exports, "srLatn", () => $55289315f11c98c9$export$dd0ad751d91f231a, (v) => $55289315f11c98c9$export$dd0ad751d91f231a = v);
var $55289315f11c98c9$export$dd0ad751d91f231a;
"use strict";
$55289315f11c98c9$export$dd0ad751d91f231a = void 0;
var $799339cb744bbe5a$export$2c14ff85d6318973;
"use strict";
$799339cb744bbe5a$export$2c14ff85d6318973 = void 0;
const $799339cb744bbe5a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 nedelju",
            withPrepositionAgo: "oko 1 nedelju",
            withPrepositionIn: "oko 1 nedelju"
        },
        dual: "oko {{count}} nedelje",
        other: "oko {{count}} nedelje"
    },
    xWeeks: {
        one: {
            standalone: "1 nedelju",
            withPrepositionAgo: "1 nedelju",
            withPrepositionIn: "1 nedelju"
        },
        dual: "{{count}} nedelje",
        other: "{{count}} nedelje"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mesec",
            withPrepositionAgo: "oko 1 mesec",
            withPrepositionIn: "oko 1 mesec"
        },
        dual: "oko {{count}} meseca",
        other: "oko {{count}} meseci"
    },
    xMonths: {
        one: {
            standalone: "1 mesec",
            withPrepositionAgo: "1 mesec",
            withPrepositionIn: "1 mesec"
        },
        dual: "{{count}} meseca",
        other: "{{count}} meseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
const $799339cb744bbe5a$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $799339cb744bbe5a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options?.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "pre " + result;
    }
    return result;
};
$799339cb744bbe5a$export$2c14ff85d6318973 = $799339cb744bbe5a$var$formatDistance;


var $6cbd3a16e3787e10$export$cbf60ecb96cbb82f;
"use strict";
$6cbd3a16e3787e10$export$cbf60ecb96cbb82f = void 0;

const $6cbd3a16e3787e10$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
const $6cbd3a16e3787e10$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6cbd3a16e3787e10$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $6cbd3a16e3787e10$var$formatLong = $6cbd3a16e3787e10$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6cbd3a16e3787e10$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6cbd3a16e3787e10$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6cbd3a16e3787e10$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $45f6c6528fa8f8e9$export$8fbbfd65594f46a0;
"use strict";
$45f6c6528fa8f8e9$export$8fbbfd65594f46a0 = void 0;
const $45f6c6528fa8f8e9$var$formatRelativeLocale = {
    lastWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: (date)=>{
        switch(date.getDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
const $45f6c6528fa8f8e9$var$formatRelative = (token, date, _baseDate, _options)=>{
    const format = $45f6c6528fa8f8e9$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
$45f6c6528fa8f8e9$export$8fbbfd65594f46a0 = $45f6c6528fa8f8e9$var$formatRelative;


var $1bbaf3cf6820d2db$export$b3bd0bc58e36cd63;
"use strict";
$1bbaf3cf6820d2db$export$b3bd0bc58e36cd63 = void 0;

const $1bbaf3cf6820d2db$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Pre Hrista",
        "Posle Hrista"
    ]
};
const $1bbaf3cf6820d2db$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
const $1bbaf3cf6820d2db$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $1bbaf3cf6820d2db$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
const $1bbaf3cf6820d2db$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedelja",
        "ponedeljak",
        "utorak",
        "sreda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
const $1bbaf3cf6820d2db$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $1bbaf3cf6820d2db$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
const $1bbaf3cf6820d2db$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $1bbaf3cf6820d2db$var$localize = $1bbaf3cf6820d2db$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1bbaf3cf6820d2db$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1bbaf3cf6820d2db$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1bbaf3cf6820d2db$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1bbaf3cf6820d2db$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $1bbaf3cf6820d2db$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1bbaf3cf6820d2db$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $1bbaf3cf6820d2db$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1bbaf3cf6820d2db$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $415aa286e4f4f1b1$export$4659b591c19bdf3d;
"use strict";
$415aa286e4f4f1b1$export$4659b591c19bdf3d = void 0;


const $415aa286e4f4f1b1$var$matchOrdinalNumberPattern = /^(\d+)\./i;
const $415aa286e4f4f1b1$var$parseOrdinalNumberPattern = /\d+/i;
const $415aa286e4f4f1b1$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
const $415aa286e4f4f1b1$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
const $415aa286e4f4f1b1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
const $415aa286e4f4f1b1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $415aa286e4f4f1b1$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
const $415aa286e4f4f1b1$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $415aa286e4f4f1b1$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
const $415aa286e4f4f1b1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $415aa286e4f4f1b1$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
const $415aa286e4f4f1b1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
const $415aa286e4f4f1b1$var$match = $415aa286e4f4f1b1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $415aa286e4f4f1b1$var$matchOrdinalNumberPattern,
        parsePattern: $415aa286e4f4f1b1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $415aa286e4f4f1b1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $415aa286e4f4f1b1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $415aa286e4f4f1b1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $415aa286e4f4f1b1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $415aa286e4f4f1b1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $415aa286e4f4f1b1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $415aa286e4f4f1b1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $415aa286e4f4f1b1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $415aa286e4f4f1b1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $415aa286e4f4f1b1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */ const $55289315f11c98c9$var$srLatn = $55289315f11c98c9$export$dd0ad751d91f231a = {
    code: "sr-Latn",
    formatDistance: $799339cb744bbe5a$export$2c14ff85d6318973,
    formatLong: $6cbd3a16e3787e10$export$cbf60ecb96cbb82f,
    formatRelative: $45f6c6528fa8f8e9$export$8fbbfd65594f46a0,
    localize: $1bbaf3cf6820d2db$export$b3bd0bc58e36cd63,
    match: $415aa286e4f4f1b1$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($55289315f11c98c9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $55289315f11c98c9$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $55289315f11c98c9$exports[key];
        }
    });
});
var $ec56cd1462f74126$exports = {};

$parcel$export($ec56cd1462f74126$exports, "sv", () => $ec56cd1462f74126$export$65540e5f7f6e7dce, (v) => $ec56cd1462f74126$export$65540e5f7f6e7dce = v);
var $ec56cd1462f74126$export$65540e5f7f6e7dce;
"use strict";
$ec56cd1462f74126$export$65540e5f7f6e7dce = void 0;
var $ecb22356bc08bcaa$export$2c14ff85d6318973;
"use strict";
$ecb22356bc08bcaa$export$2c14ff85d6318973 = void 0;
const $ecb22356bc08bcaa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: "en sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: "en minut",
        other: "{{count}} minuter"
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: "en timme",
        other: "{{count}} timmar"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} veckor"
    },
    xWeeks: {
        one: "en vecka",
        other: "{{count}} veckor"
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
const $ecb22356bc08bcaa$var$wordMapping = [
    "noll",
    "en",
    "tv\xe5",
    "tre",
    "fyra",
    "fem",
    "sex",
    "sju",
    "\xe5tta",
    "nio",
    "tio",
    "elva",
    "tolv"
];
const $ecb22356bc08bcaa$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $ecb22356bc08bcaa$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $ecb22356bc08bcaa$var$wordMapping[count] : String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sedan";
    }
    return result;
};
$ecb22356bc08bcaa$export$2c14ff85d6318973 = $ecb22356bc08bcaa$var$formatDistance;


var $6e64615f0a1dbeb3$export$cbf60ecb96cbb82f;
"use strict";
$6e64615f0a1dbeb3$export$cbf60ecb96cbb82f = void 0;

const $6e64615f0a1dbeb3$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
};
const $6e64615f0a1dbeb3$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6e64615f0a1dbeb3$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $6e64615f0a1dbeb3$var$formatLong = $6e64615f0a1dbeb3$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6e64615f0a1dbeb3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6e64615f0a1dbeb3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6e64615f0a1dbeb3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $a52ceb1125b4cb30$export$8fbbfd65594f46a0;
"use strict";
$a52ceb1125b4cb30$export$8fbbfd65594f46a0 = void 0;
const $a52ceb1125b4cb30$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
const $a52ceb1125b4cb30$var$formatRelative = (token, _date, _baseDate, _options)=>$a52ceb1125b4cb30$var$formatRelativeLocale[token];
$a52ceb1125b4cb30$export$8fbbfd65594f46a0 = $a52ceb1125b4cb30$var$formatRelative;


var $719a8f29b2304698$export$b3bd0bc58e36cd63;
"use strict";
$719a8f29b2304698$export$b3bd0bc58e36cd63 = void 0;

const $719a8f29b2304698$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf6re Kristus",
        "efter Kristus"
    ]
};
const $719a8f29b2304698$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1:a kvartalet",
        "2:a kvartalet",
        "3:e kvartalet",
        "4:e kvartalet"
    ]
};
const $719a8f29b2304698$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "maj",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
const $719a8f29b2304698$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf6",
        "m\xe5",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        "tis",
        "ons",
        "tors",
        "fre",
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
const $719a8f29b2304698$var$dayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "morg.",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    abbreviated: {
        am: "f.m.",
        pm: "e.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: "eftermiddag",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "eftermiddag",
        evening: "kv\xe4ll",
        night: "natt"
    }
};
const $719a8f29b2304698$var$formattingDayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
const $719a8f29b2304698$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ":a";
    }
    return number + ":e";
};
const $719a8f29b2304698$var$localize = $719a8f29b2304698$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $719a8f29b2304698$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $719a8f29b2304698$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $719a8f29b2304698$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $719a8f29b2304698$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $719a8f29b2304698$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $719a8f29b2304698$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $719a8f29b2304698$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $061f8e9450040d3c$export$4659b591c19bdf3d;
"use strict";
$061f8e9450040d3c$export$4659b591c19bdf3d = void 0;


const $061f8e9450040d3c$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
const $061f8e9450040d3c$var$parseOrdinalNumberPattern = /\d+/i;
const $061f8e9450040d3c$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
const $061f8e9450040d3c$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
const $061f8e9450040d3c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
const $061f8e9450040d3c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $061f8e9450040d3c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
const $061f8e9450040d3c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $061f8e9450040d3c$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
const $061f8e9450040d3c$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
const $061f8e9450040d3c$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
const $061f8e9450040d3c$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
const $061f8e9450040d3c$var$match = $061f8e9450040d3c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $061f8e9450040d3c$var$matchOrdinalNumberPattern,
        parsePattern: $061f8e9450040d3c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $061f8e9450040d3c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $061f8e9450040d3c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $061f8e9450040d3c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $061f8e9450040d3c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $061f8e9450040d3c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $061f8e9450040d3c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $061f8e9450040d3c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $061f8e9450040d3c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $061f8e9450040d3c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $061f8e9450040d3c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen](https://github.com/ejulen)
 * @author Alexander Nanberg [@alexandernanberg](https://github.com/alexandernanberg)
 * @author Henrik Andersson [@limelights](https://github.com/limelights)
 */ const $ec56cd1462f74126$var$sv = $ec56cd1462f74126$export$65540e5f7f6e7dce = {
    code: "sv",
    formatDistance: $ecb22356bc08bcaa$export$2c14ff85d6318973,
    formatLong: $6e64615f0a1dbeb3$export$cbf60ecb96cbb82f,
    formatRelative: $a52ceb1125b4cb30$export$8fbbfd65594f46a0,
    localize: $719a8f29b2304698$export$b3bd0bc58e36cd63,
    match: $061f8e9450040d3c$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($ec56cd1462f74126$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $ec56cd1462f74126$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $ec56cd1462f74126$exports[key];
        }
    });
});
var $5cd9f4ae9581aef6$exports = {};

$parcel$export($5cd9f4ae9581aef6$exports, "ta", () => $5cd9f4ae9581aef6$export$d4b02e284d602eb2, (v) => $5cd9f4ae9581aef6$export$d4b02e284d602eb2 = v);
var $5cd9f4ae9581aef6$export$d4b02e284d602eb2;
"use strict";
$5cd9f4ae9581aef6$export$d4b02e284d602eb2 = void 0;
var $a723e8b5bab69ed9$export$2c14ff85d6318973;
"use strict";
$a723e8b5bab69ed9$export$2c14ff85d6318973 = void 0;
function $a723e8b5bab69ed9$var$isPluralType(val) {
    return val.one !== undefined;
}
const $a723e8b5bab69ed9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
const $a723e8b5bab69ed9$var$formatDistance = (token, count, options)=>{
    const tense = options?.addSuffix ? options.comparison && options.comparison > 0 ? "in" : "ago" : "default";
    const tokenValue = $a723e8b5bab69ed9$var$formatDistanceLocale[token];
    if (!$a723e8b5bab69ed9$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace("{{count}}", String(count));
};
$a723e8b5bab69ed9$export$2c14ff85d6318973 = $a723e8b5bab69ed9$var$formatDistance;


var $a6266dfc832fbb45$export$cbf60ecb96cbb82f;
"use strict";
$a6266dfc832fbb45$export$cbf60ecb96cbb82f = void 0;

// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
// CLDR #1846 - #1849
const $a6266dfc832fbb45$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
// CLDR #1850 - #1853
const $a6266dfc832fbb45$var$timeFormats = {
    full: "a h:mm:ss zzzz",
    long: "a h:mm:ss z",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $a6266dfc832fbb45$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a6266dfc832fbb45$var$formatLong = $a6266dfc832fbb45$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a6266dfc832fbb45$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a6266dfc832fbb45$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a6266dfc832fbb45$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $0b871c9e8eb5734a$export$8fbbfd65594f46a0;
"use strict";
$0b871c9e8eb5734a$export$8fbbfd65594f46a0 = void 0;
const $0b871c9e8eb5734a$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: "P"
};
const $0b871c9e8eb5734a$var$formatRelative = (token, _date, _baseDate, _options)=>$0b871c9e8eb5734a$var$formatRelativeLocale[token];
$0b871c9e8eb5734a$export$8fbbfd65594f46a0 = $0b871c9e8eb5734a$var$formatRelative;


var $23523a5df7a265cd$export$b3bd0bc58e36cd63;
"use strict";
$23523a5df7a265cd$export$b3bd0bc58e36cd63 = void 0;

// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
const $23523a5df7a265cd$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ]
};
const $23523a5df7a265cd$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
const $23523a5df7a265cd$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"
    ]
};
const $23523a5df7a265cd$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        "\u0B9A\u0BA9\u0BBF"
    ]
};
// CLDR #1780 - #1845
const $23523a5df7a265cd$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
const $23523a5df7a265cd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
const $23523a5df7a265cd$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $23523a5df7a265cd$var$localize = $23523a5df7a265cd$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $23523a5df7a265cd$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $23523a5df7a265cd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $23523a5df7a265cd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $23523a5df7a265cd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $23523a5df7a265cd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $23523a5df7a265cd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $23523a5df7a265cd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $e6094ef9f960e419$export$4659b591c19bdf3d;
"use strict";
$e6094ef9f960e419$export$4659b591c19bdf3d = void 0;


const $e6094ef9f960e419$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
const $e6094ef9f960e419$var$parseOrdinalNumberPattern = /\d+/i;
const $e6094ef9f960e419$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
const $e6094ef9f960e419$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
const $e6094ef9f960e419$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
const $e6094ef9f960e419$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
const $e6094ef9f960e419$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
const $e6094ef9f960e419$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
const $e6094ef9f960e419$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
const $e6094ef9f960e419$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
const $e6094ef9f960e419$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
const $e6094ef9f960e419$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
const $e6094ef9f960e419$var$match = $e6094ef9f960e419$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $e6094ef9f960e419$var$matchOrdinalNumberPattern,
        parsePattern: $e6094ef9f960e419$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e6094ef9f960e419$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e6094ef9f960e419$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e6094ef9f960e419$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e6094ef9f960e419$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e6094ef9f960e419$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e6094ef9f960e419$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e6094ef9f960e419$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e6094ef9f960e419$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e6094ef9f960e419$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e6094ef9f960e419$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s](https://github.com/sibiraj-s)
 */ const $5cd9f4ae9581aef6$var$ta = $5cd9f4ae9581aef6$export$d4b02e284d602eb2 = {
    code: "ta",
    formatDistance: $a723e8b5bab69ed9$export$2c14ff85d6318973,
    formatLong: $a6266dfc832fbb45$export$cbf60ecb96cbb82f,
    formatRelative: $0b871c9e8eb5734a$export$8fbbfd65594f46a0,
    localize: $23523a5df7a265cd$export$b3bd0bc58e36cd63,
    match: $e6094ef9f960e419$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($5cd9f4ae9581aef6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $5cd9f4ae9581aef6$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $5cd9f4ae9581aef6$exports[key];
        }
    });
});
var $85a874e9f9ff1be8$exports = {};

$parcel$export($85a874e9f9ff1be8$exports, "te", () => $85a874e9f9ff1be8$export$dfb0c08939807f45, (v) => $85a874e9f9ff1be8$export$dfb0c08939807f45 = v);
var $85a874e9f9ff1be8$export$dfb0c08939807f45;
"use strict";
$85a874e9f9ff1be8$export$dfb0c08939807f45 = void 0;
var $8d646031441f14ed$export$2c14ff85d6318973;
"use strict";
$8d646031441f14ed$export$2c14ff85d6318973 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
const $8d646031441f14ed$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
const $8d646031441f14ed$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = options?.addSuffix ? $8d646031441f14ed$var$formatDistanceLocale[token].withPreposition : $8d646031441f14ed$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
$8d646031441f14ed$export$2c14ff85d6318973 = $8d646031441f14ed$var$formatDistance;


var $be9347ee6150b206$export$cbf60ecb96cbb82f;
"use strict";
$be9347ee6150b206$export$cbf60ecb96cbb82f = void 0;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
// CLDR #1807 - #1811
const $be9347ee6150b206$var$dateFormats = {
    full: "d, MMMM y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd-MM-yy"
};
// CLDR #1807 - #1811
const $be9347ee6150b206$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
// CLDR #1815 - #1818
const $be9347ee6150b206$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $be9347ee6150b206$var$formatLong = $be9347ee6150b206$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $be9347ee6150b206$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $be9347ee6150b206$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $be9347ee6150b206$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $3966046eb8abae80$export$8fbbfd65594f46a0;
"use strict";
$3966046eb8abae80$export$8fbbfd65594f46a0 = void 0;
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
const $3966046eb8abae80$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    other: "P"
};
const $3966046eb8abae80$var$formatRelative = (token, _date, _baseDate, _options)=>$3966046eb8abae80$var$formatRelativeLocale[token];
$3966046eb8abae80$export$8fbbfd65594f46a0 = $3966046eb8abae80$var$formatRelative;


var $70de22c0cb1169c1$export$b3bd0bc58e36cd63;
"use strict";
$70de22c0cb1169c1$export$b3bd0bc58e36cd63 = void 0;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
const $70de22c0cb1169c1$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
const $70de22c0cb1169c1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
const $70de22c0cb1169c1$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
const $70de22c0cb1169c1$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
const $70de22c0cb1169c1$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
const $70de22c0cb1169c1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
const $70de22c0cb1169c1$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "\u0C35";
};
const $70de22c0cb1169c1$var$localize = $70de22c0cb1169c1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $70de22c0cb1169c1$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $70de22c0cb1169c1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $70de22c0cb1169c1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $70de22c0cb1169c1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $70de22c0cb1169c1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $70de22c0cb1169c1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $70de22c0cb1169c1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $e3e24776c2fa5809$export$4659b591c19bdf3d;
"use strict";
$e3e24776c2fa5809$export$4659b591c19bdf3d = void 0;


const $e3e24776c2fa5809$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
const $e3e24776c2fa5809$var$parseOrdinalNumberPattern = /\d+/i;
const $e3e24776c2fa5809$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
const $e3e24776c2fa5809$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
const $e3e24776c2fa5809$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
const $e3e24776c2fa5809$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e3e24776c2fa5809$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
const $e3e24776c2fa5809$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
const $e3e24776c2fa5809$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
const $e3e24776c2fa5809$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
const $e3e24776c2fa5809$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
const $e3e24776c2fa5809$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
const $e3e24776c2fa5809$var$match = $e3e24776c2fa5809$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $e3e24776c2fa5809$var$matchOrdinalNumberPattern,
        parsePattern: $e3e24776c2fa5809$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3e24776c2fa5809$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3e24776c2fa5809$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3e24776c2fa5809$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3e24776c2fa5809$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3e24776c2fa5809$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3e24776c2fa5809$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3e24776c2fa5809$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3e24776c2fa5809$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e3e24776c2fa5809$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e3e24776c2fa5809$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum](https://github.com/kranthilakum)
 */ const $85a874e9f9ff1be8$var$te = $85a874e9f9ff1be8$export$dfb0c08939807f45 = {
    code: "te",
    formatDistance: $8d646031441f14ed$export$2c14ff85d6318973,
    formatLong: $be9347ee6150b206$export$cbf60ecb96cbb82f,
    formatRelative: $3966046eb8abae80$export$8fbbfd65594f46a0,
    localize: $70de22c0cb1169c1$export$b3bd0bc58e36cd63,
    match: $e3e24776c2fa5809$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($85a874e9f9ff1be8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $85a874e9f9ff1be8$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $85a874e9f9ff1be8$exports[key];
        }
    });
});
var $830e8c3f76cfea8c$exports = {};

$parcel$export($830e8c3f76cfea8c$exports, "th", () => $830e8c3f76cfea8c$export$d657bc098992a431, (v) => $830e8c3f76cfea8c$export$d657bc098992a431 = v);
var $830e8c3f76cfea8c$export$d657bc098992a431;
"use strict";
$830e8c3f76cfea8c$export$d657bc098992a431 = void 0;
var $567c6474517687d2$export$2c14ff85d6318973;
"use strict";
$567c6474517687d2$export$2c14ff85d6318973 = void 0;
const $567c6474517687d2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
const $567c6474517687d2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $567c6474517687d2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === "halfAMinute") return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
$567c6474517687d2$export$2c14ff85d6318973 = $567c6474517687d2$var$formatDistance;


var $c1b4bbae615683a4$export$cbf60ecb96cbb82f;
"use strict";
$c1b4bbae615683a4$export$cbf60ecb96cbb82f = void 0;

const $c1b4bbae615683a4$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
const $c1b4bbae615683a4$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
const $c1b4bbae615683a4$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $c1b4bbae615683a4$var$formatLong = $c1b4bbae615683a4$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c1b4bbae615683a4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c1b4bbae615683a4$var$timeFormats,
        defaultWidth: "medium"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c1b4bbae615683a4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $d14465c4c944d238$export$8fbbfd65594f46a0;
"use strict";
$d14465c4c944d238$export$8fbbfd65594f46a0 = void 0;
const $d14465c4c944d238$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: "P"
};
const $d14465c4c944d238$var$formatRelative = (token, _date, _baseDate, _options)=>$d14465c4c944d238$var$formatRelativeLocale[token];
$d14465c4c944d238$export$8fbbfd65594f46a0 = $d14465c4c944d238$var$formatRelative;


var $bc949e695fb92d16$export$b3bd0bc58e36cd63;
"use strict";
$bc949e695fb92d16$export$b3bd0bc58e36cd63 = void 0;

const $bc949e695fb92d16$var$eraValues = {
    narrow: [
        "B",
        "\u0E04\u0E28"
    ],
    abbreviated: [
        "BC",
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
const $bc949e695fb92d16$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
const $bc949e695fb92d16$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
const $bc949e695fb92d16$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
const $bc949e695fb92d16$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
const $bc949e695fb92d16$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
const $bc949e695fb92d16$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $bc949e695fb92d16$var$localize = $bc949e695fb92d16$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bc949e695fb92d16$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $bc949e695fb92d16$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $bc949e695fb92d16$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $bc949e695fb92d16$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $bc949e695fb92d16$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $bc949e695fb92d16$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bc949e695fb92d16$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $ed1d062793ad6fe3$export$4659b591c19bdf3d;
"use strict";
$ed1d062793ad6fe3$export$4659b591c19bdf3d = void 0;


const $ed1d062793ad6fe3$var$matchOrdinalNumberPattern = /^\d+/i;
const $ed1d062793ad6fe3$var$parseOrdinalNumberPattern = /\d+/i;
const $ed1d062793ad6fe3$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
const $ed1d062793ad6fe3$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
const $ed1d062793ad6fe3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
const $ed1d062793ad6fe3$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
const $ed1d062793ad6fe3$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
const $ed1d062793ad6fe3$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
const $ed1d062793ad6fe3$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
const $ed1d062793ad6fe3$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
const $ed1d062793ad6fe3$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
const $ed1d062793ad6fe3$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
const $ed1d062793ad6fe3$var$match = $ed1d062793ad6fe3$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $ed1d062793ad6fe3$var$matchOrdinalNumberPattern,
        parsePattern: $ed1d062793ad6fe3$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed1d062793ad6fe3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1d062793ad6fe3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed1d062793ad6fe3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1d062793ad6fe3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed1d062793ad6fe3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1d062793ad6fe3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed1d062793ad6fe3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ed1d062793ad6fe3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $ed1d062793ad6fe3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ed1d062793ad6fe3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat](https://github.com/athivvat)
 * @author [@hawkup](https://github.com/hawkup)
 * @author  Jirawat I. [@nodtem66](https://github.com/nodtem66)
 */ const $830e8c3f76cfea8c$var$th = $830e8c3f76cfea8c$export$d657bc098992a431 = {
    code: "th",
    formatDistance: $567c6474517687d2$export$2c14ff85d6318973,
    formatLong: $c1b4bbae615683a4$export$cbf60ecb96cbb82f,
    formatRelative: $d14465c4c944d238$export$8fbbfd65594f46a0,
    localize: $bc949e695fb92d16$export$b3bd0bc58e36cd63,
    match: $ed1d062793ad6fe3$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($830e8c3f76cfea8c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $830e8c3f76cfea8c$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $830e8c3f76cfea8c$exports[key];
        }
    });
});
var $e5f021dab25becb6$exports = {};

$parcel$export($e5f021dab25becb6$exports, "tr", () => $e5f021dab25becb6$export$72451b88a72ad9c2, (v) => $e5f021dab25becb6$export$72451b88a72ad9c2 = v);
var $e5f021dab25becb6$export$72451b88a72ad9c2;
"use strict";
$e5f021dab25becb6$export$72451b88a72ad9c2 = void 0;
var $5c123241cd55027c$export$2c14ff85d6318973;
"use strict";
$5c123241cd55027c$export$2c14ff85d6318973 = void 0;
const $5c123241cd55027c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniyeden az",
        other: "{{count}} saniyeden az"
    },
    xSeconds: {
        one: "1 saniye",
        other: "{{count}} saniye"
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: "bir dakikadan az",
        other: "{{count}} dakikadan az"
    },
    xMinutes: {
        one: "1 dakika",
        other: "{{count}} dakika"
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
const $5c123241cd55027c$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $5c123241cd55027c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \xf6nce";
    }
    return result;
};
$5c123241cd55027c$export$2c14ff85d6318973 = $5c123241cd55027c$var$formatDistance;


var $6d9d2ac5aea94fc3$export$cbf60ecb96cbb82f;
"use strict";
$6d9d2ac5aea94fc3$export$cbf60ecb96cbb82f = void 0;

const $6d9d2ac5aea94fc3$var$dateFormats = {
    full: "d MMMM y EEEE",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.yyyy"
};
const $6d9d2ac5aea94fc3$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $6d9d2ac5aea94fc3$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6d9d2ac5aea94fc3$var$formatLong = $6d9d2ac5aea94fc3$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6d9d2ac5aea94fc3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6d9d2ac5aea94fc3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6d9d2ac5aea94fc3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $a17efc2ce759d460$export$8fbbfd65594f46a0;
"use strict";
$a17efc2ce759d460$export$8fbbfd65594f46a0 = void 0;
const $a17efc2ce759d460$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: "P"
};
const $a17efc2ce759d460$var$formatRelative = (token, _date, _baseDate, _options)=>$a17efc2ce759d460$var$formatRelativeLocale[token];
$a17efc2ce759d460$export$8fbbfd65594f46a0 = $a17efc2ce759d460$var$formatRelative;


var $b20b2b60b5523746$export$b3bd0bc58e36cd63;
"use strict";
$b20b2b60b5523746$export$b3bd0bc58e36cd63 = void 0;

const $b20b2b60b5523746$var$eraValues = {
    narrow: [
        "M\xd6",
        "MS"
    ],
    abbreviated: [
        "M\xd6",
        "MS"
    ],
    wide: [
        "Milattan \xd6nce",
        "Milattan Sonra"
    ]
};
const $b20b2b60b5523746$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
const $b20b2b60b5523746$var$monthValues = {
    narrow: [
        "O",
        "\u015E",
        "M",
        "N",
        "M",
        "H",
        "T",
        "A",
        "E",
        "E",
        "K",
        "A"
    ],
    abbreviated: [
        "Oca",
        "\u015Eub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "A\u011Fu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
    ],
    wide: [
        "Ocak",
        "\u015Eubat",
        "Mart",
        "Nisan",
        "May\u0131s",
        "Haziran",
        "Temmuz",
        "A\u011Fustos",
        "Eyl\xfcl",
        "Ekim",
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
const $b20b2b60b5523746$var$dayValues = {
    narrow: [
        "P",
        "P",
        "S",
        "\xc7",
        "P",
        "C",
        "C"
    ],
    short: [
        "Pz",
        "Pt",
        "Sa",
        "\xc7a",
        "Pe",
        "Cu",
        "Ct"
    ],
    abbreviated: [
        "Paz",
        "Pzt",
        "Sal",
        "\xc7ar",
        "Per",
        "Cum",
        "Cts"
    ],
    wide: [
        "Pazar",
        "Pazartesi",
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        "Cuma",
        "Cumartesi"
    ]
};
const $b20b2b60b5523746$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    }
};
const $b20b2b60b5523746$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    }
};
const $b20b2b60b5523746$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $b20b2b60b5523746$var$localize = $b20b2b60b5523746$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b20b2b60b5523746$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b20b2b60b5523746$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b20b2b60b5523746$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>Number(quarter) - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b20b2b60b5523746$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b20b2b60b5523746$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $b20b2b60b5523746$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b20b2b60b5523746$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $7769cb8b601ca7fa$export$4659b591c19bdf3d;
"use strict";
$7769cb8b601ca7fa$export$4659b591c19bdf3d = void 0;


const $7769cb8b601ca7fa$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
const $7769cb8b601ca7fa$var$parseOrdinalNumberPattern = /\d+/i;
const $7769cb8b601ca7fa$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
const $7769cb8b601ca7fa$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
const $7769cb8b601ca7fa$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
const $7769cb8b601ca7fa$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
const $7769cb8b601ca7fa$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
const $7769cb8b601ca7fa$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
const $7769cb8b601ca7fa$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
const $7769cb8b601ca7fa$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
const $7769cb8b601ca7fa$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
const $7769cb8b601ca7fa$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
const $7769cb8b601ca7fa$var$match = $7769cb8b601ca7fa$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $7769cb8b601ca7fa$var$matchOrdinalNumberPattern,
        parsePattern: $7769cb8b601ca7fa$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7769cb8b601ca7fa$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7769cb8b601ca7fa$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7769cb8b601ca7fa$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7769cb8b601ca7fa$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7769cb8b601ca7fa$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7769cb8b601ca7fa$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7769cb8b601ca7fa$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7769cb8b601ca7fa$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $7769cb8b601ca7fa$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7769cb8b601ca7fa$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin](https://github.com/alpcanaydin)
 * @author Berkay Sargın [@berkaey](https://github.com/berkaey)
 * @author Fatih Bulut [@bulutfatih](https://github.com/bulutfatih)
 * @author Ismail Demirbilek [@dbtek](https://github.com/dbtek)
 * @author İsmail Kayar [@ikayar](https://github.com/ikayar)
 *
 *
 */ const $e5f021dab25becb6$var$tr = $e5f021dab25becb6$export$72451b88a72ad9c2 = {
    code: "tr",
    formatDistance: $5c123241cd55027c$export$2c14ff85d6318973,
    formatLong: $6d9d2ac5aea94fc3$export$cbf60ecb96cbb82f,
    formatRelative: $a17efc2ce759d460$export$8fbbfd65594f46a0,
    localize: $b20b2b60b5523746$export$b3bd0bc58e36cd63,
    match: $7769cb8b601ca7fa$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($e5f021dab25becb6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $e5f021dab25becb6$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $e5f021dab25becb6$exports[key];
        }
    });
});
var $00e775a1fad12d80$exports = {};

$parcel$export($00e775a1fad12d80$exports, "ug", () => $00e775a1fad12d80$export$9ba1309004beb64a, (v) => $00e775a1fad12d80$export$9ba1309004beb64a = v);
var $00e775a1fad12d80$export$9ba1309004beb64a;
"use strict";
$00e775a1fad12d80$export$9ba1309004beb64a = void 0;
var $15e6c436d49447fb$export$2c14ff85d6318973;
"use strict";
$15e6c436d49447fb$export$2c14ff85d6318973 = void 0;
const $15e6c436d49447fb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
const $15e6c436d49447fb$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $15e6c436d49447fb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
$15e6c436d49447fb$export$2c14ff85d6318973 = $15e6c436d49447fb$var$formatDistance;


var $013d5dcb031e72c9$export$cbf60ecb96cbb82f;
"use strict";
$013d5dcb031e72c9$export$cbf60ecb96cbb82f = void 0;

const $013d5dcb031e72c9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $013d5dcb031e72c9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $013d5dcb031e72c9$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $013d5dcb031e72c9$var$formatLong = $013d5dcb031e72c9$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $013d5dcb031e72c9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $013d5dcb031e72c9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $013d5dcb031e72c9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $7ee916a892bd3cf7$export$8fbbfd65594f46a0;
"use strict";
$7ee916a892bd3cf7$export$8fbbfd65594f46a0 = void 0;
const $7ee916a892bd3cf7$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: "P"
};
const $7ee916a892bd3cf7$var$formatRelative = (token, _date, _baseDate, _options)=>$7ee916a892bd3cf7$var$formatRelativeLocale[token];
$7ee916a892bd3cf7$export$8fbbfd65594f46a0 = $7ee916a892bd3cf7$var$formatRelative;


var $6432ecf17f00a87c$export$b3bd0bc58e36cd63;
"use strict";
$6432ecf17f00a87c$export$b3bd0bc58e36cd63 = void 0;

const $6432ecf17f00a87c$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
const $6432ecf17f00a87c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1",
        "2",
        "3",
        "4"
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $6432ecf17f00a87c$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
const $6432ecf17f00a87c$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
const $6432ecf17f00a87c$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
const $6432ecf17f00a87c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
const $6432ecf17f00a87c$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $6432ecf17f00a87c$var$localize = $6432ecf17f00a87c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $6432ecf17f00a87c$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6432ecf17f00a87c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6432ecf17f00a87c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6432ecf17f00a87c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6432ecf17f00a87c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $6432ecf17f00a87c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6432ecf17f00a87c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $a4ab3fa30d835252$export$4659b591c19bdf3d;
"use strict";
$a4ab3fa30d835252$export$4659b591c19bdf3d = void 0;


const $a4ab3fa30d835252$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $a4ab3fa30d835252$var$parseOrdinalNumberPattern = /\d+/i;
const $a4ab3fa30d835252$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
const $a4ab3fa30d835252$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
const $a4ab3fa30d835252$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
const $a4ab3fa30d835252$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a4ab3fa30d835252$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
const $a4ab3fa30d835252$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
const $a4ab3fa30d835252$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
const $a4ab3fa30d835252$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
const $a4ab3fa30d835252$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
const $a4ab3fa30d835252$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
const $a4ab3fa30d835252$var$match = $a4ab3fa30d835252$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $a4ab3fa30d835252$var$matchOrdinalNumberPattern,
        parsePattern: $a4ab3fa30d835252$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a4ab3fa30d835252$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a4ab3fa30d835252$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a4ab3fa30d835252$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a4ab3fa30d835252$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a4ab3fa30d835252$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a4ab3fa30d835252$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a4ab3fa30d835252$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a4ab3fa30d835252$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a4ab3fa30d835252$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a4ab3fa30d835252$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly](https://github.com/abduwaly)
 */ const $00e775a1fad12d80$var$ug = $00e775a1fad12d80$export$9ba1309004beb64a = {
    code: "ug",
    formatDistance: $15e6c436d49447fb$export$2c14ff85d6318973,
    formatLong: $013d5dcb031e72c9$export$cbf60ecb96cbb82f,
    formatRelative: $7ee916a892bd3cf7$export$8fbbfd65594f46a0,
    localize: $6432ecf17f00a87c$export$b3bd0bc58e36cd63,
    match: $a4ab3fa30d835252$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($00e775a1fad12d80$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $00e775a1fad12d80$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $00e775a1fad12d80$exports[key];
        }
    });
});
var $809a46f04d3f809b$exports = {};

$parcel$export($809a46f04d3f809b$exports, "uk", () => $809a46f04d3f809b$export$312745a8a3013c00, (v) => $809a46f04d3f809b$export$312745a8a3013c00 = v);
var $809a46f04d3f809b$export$312745a8a3013c00;
"use strict";
$809a46f04d3f809b$export$312745a8a3013c00 = void 0;
var $87bcd5ba9217aa6a$export$2c14ff85d6318973;
"use strict";
$87bcd5ba9217aa6a$export$2c14ff85d6318973 = void 0;
function $87bcd5ba9217aa6a$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    const rem10 = count % 10;
    const rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $87bcd5ba9217aa6a$var$buildLocalizeTokenFn(scheme) {
    return (count, options)=>{
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $87bcd5ba9217aa6a$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $87bcd5ba9217aa6a$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $87bcd5ba9217aa6a$var$declension(scheme.past, count);
                else return $87bcd5ba9217aa6a$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $87bcd5ba9217aa6a$var$declension(scheme.regular, count);
    };
}
const $87bcd5ba9217aa6a$var$halfAtMinute = (_, options)=>{
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
const $87bcd5ba9217aa6a$var$formatDistanceLocale = {
    lessThanXSeconds: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $87bcd5ba9217aa6a$var$halfAtMinute,
    lessThanXMinutes: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $87bcd5ba9217aa6a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
const $87bcd5ba9217aa6a$var$formatDistance = (token, count, options)=>{
    options = options || {};
    return $87bcd5ba9217aa6a$var$formatDistanceLocale[token](count, options);
};
$87bcd5ba9217aa6a$export$2c14ff85d6318973 = $87bcd5ba9217aa6a$var$formatDistance;


var $63672d4880fa35f9$export$cbf60ecb96cbb82f;
"use strict";
$63672d4880fa35f9$export$cbf60ecb96cbb82f = void 0;

const $63672d4880fa35f9$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: "dd.MM.y"
};
const $63672d4880fa35f9$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $63672d4880fa35f9$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63672d4880fa35f9$var$formatLong = $63672d4880fa35f9$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $63672d4880fa35f9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $63672d4880fa35f9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $63672d4880fa35f9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $8ccd85c8daea6806$export$8fbbfd65594f46a0;
"use strict";
$8ccd85c8daea6806$export$8fbbfd65594f46a0 = void 0;


const $8ccd85c8daea6806$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $8ccd85c8daea6806$var$lastWeek(day) {
    const weekday = $8ccd85c8daea6806$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $8ccd85c8daea6806$var$thisWeek(day) {
    const weekday = $8ccd85c8daea6806$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $8ccd85c8daea6806$var$nextWeek(day) {
    const weekday = $8ccd85c8daea6806$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
const $8ccd85c8daea6806$var$lastWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $8ccd85c8daea6806$var$thisWeek(day);
    else return $8ccd85c8daea6806$var$lastWeek(day);
};
const $8ccd85c8daea6806$var$nextWeekFormat = (dirtyDate, baseDate, options)=>{
    const date = (0, $ce0fc8830a11c560$export$e67a095c620b86fe)(dirtyDate);
    const day = date.getDay();
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return $8ccd85c8daea6806$var$thisWeek(day);
    else return $8ccd85c8daea6806$var$nextWeek(day);
};
const $8ccd85c8daea6806$var$formatRelativeLocale = {
    lastWeek: $8ccd85c8daea6806$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $8ccd85c8daea6806$var$nextWeekFormat,
    other: "P"
};
const $8ccd85c8daea6806$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $8ccd85c8daea6806$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$8ccd85c8daea6806$export$8fbbfd65594f46a0 = $8ccd85c8daea6806$var$formatRelative;


var $5f5f24de3763de39$export$b3bd0bc58e36cd63;
"use strict";
$5f5f24de3763de39$export$b3bd0bc58e36cd63 = void 0;

const $5f5f24de3763de39$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
const $5f5f24de3763de39$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
const $5f5f24de3763de39$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
const $5f5f24de3763de39$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
const $5f5f24de3763de39$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
const $5f5f24de3763de39$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
const $5f5f24de3763de39$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
const $5f5f24de3763de39$var$ordinalNumber = (dirtyNumber, options)=>{
    const unit = String(options?.unit);
    const number = Number(dirtyNumber);
    let suffix;
    if (unit === "date") {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === "minute" || unit === "second" || unit === "hour") suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
const $5f5f24de3763de39$var$localize = $5f5f24de3763de39$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5f5f24de3763de39$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5f5f24de3763de39$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5f5f24de3763de39$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5f5f24de3763de39$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $5f5f24de3763de39$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5f5f24de3763de39$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5f5f24de3763de39$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $5f5f24de3763de39$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $6c2323ceb6d7b670$export$4659b591c19bdf3d;
"use strict";
$6c2323ceb6d7b670$export$4659b591c19bdf3d = void 0;


const $6c2323ceb6d7b670$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
const $6c2323ceb6d7b670$var$parseOrdinalNumberPattern = /\d+/i;
const $6c2323ceb6d7b670$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
const $6c2323ceb6d7b670$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
const $6c2323ceb6d7b670$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
const $6c2323ceb6d7b670$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6c2323ceb6d7b670$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
const $6c2323ceb6d7b670$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
const $6c2323ceb6d7b670$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
const $6c2323ceb6d7b670$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
const $6c2323ceb6d7b670$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
const $6c2323ceb6d7b670$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
const $6c2323ceb6d7b670$var$match = $6c2323ceb6d7b670$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $6c2323ceb6d7b670$var$matchOrdinalNumberPattern,
        parsePattern: $6c2323ceb6d7b670$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c2323ceb6d7b670$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c2323ceb6d7b670$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c2323ceb6d7b670$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c2323ceb6d7b670$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c2323ceb6d7b670$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c2323ceb6d7b670$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c2323ceb6d7b670$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c2323ceb6d7b670$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $6c2323ceb6d7b670$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6c2323ceb6d7b670$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk](https://github.com/korzhyk)
 * @author Andriy Shcherbyak [@shcherbyakdev](https://github.com/shcherbyakdev)
 */ const $809a46f04d3f809b$var$uk = $809a46f04d3f809b$export$312745a8a3013c00 = {
    code: "uk",
    formatDistance: $87bcd5ba9217aa6a$export$2c14ff85d6318973,
    formatLong: $63672d4880fa35f9$export$cbf60ecb96cbb82f,
    formatRelative: $8ccd85c8daea6806$export$8fbbfd65594f46a0,
    localize: $5f5f24de3763de39$export$b3bd0bc58e36cd63,
    match: $6c2323ceb6d7b670$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($809a46f04d3f809b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $809a46f04d3f809b$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $809a46f04d3f809b$exports[key];
        }
    });
});
var $b88df4c6fe2551db$exports = {};

$parcel$export($b88df4c6fe2551db$exports, "uz", () => $b88df4c6fe2551db$export$461e3962c82dff4f, (v) => $b88df4c6fe2551db$export$461e3962c82dff4f = v);
var $b88df4c6fe2551db$export$461e3962c82dff4f;
"use strict";
$b88df4c6fe2551db$export$461e3962c82dff4f = void 0;
var $d681ca273fc7f453$export$2c14ff85d6318973;
"use strict";
$d681ca273fc7f453$export$2c14ff85d6318973 = void 0;
const $d681ca273fc7f453$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "sekunddan kam",
        other: "{{count}} sekunddan kam"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "yarim minut",
    lessThanXMinutes: {
        one: "bir minutdan kam",
        other: "{{count}} minutdan kam"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: "tahminan 1 soat",
        other: "tahminan {{count}} soat"
    },
    xHours: {
        one: "1 soat",
        other: "{{count}} soat"
    },
    xDays: {
        one: "1 kun",
        other: "{{count}} kun"
    },
    aboutXWeeks: {
        one: "tahminan 1 hafta",
        other: "tahminan {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "tahminan 1 oy",
        other: "tahminan {{count}} oy"
    },
    xMonths: {
        one: "1 oy",
        other: "{{count}} oy"
    },
    aboutXYears: {
        one: "tahminan 1 yil",
        other: "tahminan {{count}} yil"
    },
    xYears: {
        one: "1 yil",
        other: "{{count}} yil"
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: "deyarli 1 yil",
        other: "deyarli {{count}} yil"
    }
};
const $d681ca273fc7f453$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $d681ca273fc7f453$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " dan keyin";
        else return result + " oldin";
    }
    return result;
};
$d681ca273fc7f453$export$2c14ff85d6318973 = $d681ca273fc7f453$var$formatDistance;


var $a64f1c3c1aec9e43$export$cbf60ecb96cbb82f;
"use strict";
$a64f1c3c1aec9e43$export$cbf60ecb96cbb82f = void 0;

const $a64f1c3c1aec9e43$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $a64f1c3c1aec9e43$var$timeFormats = {
    full: "h:mm:ss zzzz",
    long: "h:mm:ss z",
    medium: "h:mm:ss",
    short: "h:mm"
};
const $a64f1c3c1aec9e43$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $a64f1c3c1aec9e43$var$formatLong = $a64f1c3c1aec9e43$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a64f1c3c1aec9e43$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a64f1c3c1aec9e43$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $a64f1c3c1aec9e43$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $a50694c9e4a77169$export$8fbbfd65594f46a0;
"use strict";
$a50694c9e4a77169$export$8fbbfd65594f46a0 = void 0;
const $a50694c9e4a77169$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: "P"
};
const $a50694c9e4a77169$var$formatRelative = (token, _date, _baseDate, _options)=>$a50694c9e4a77169$var$formatRelativeLocale[token];
$a50694c9e4a77169$export$8fbbfd65594f46a0 = $a50694c9e4a77169$var$formatRelative;


var $ab4ee359a0e23d4a$export$b3bd0bc58e36cd63;
"use strict";
$ab4ee359a0e23d4a$export$b3bd0bc58e36cd63 = void 0;

const $ab4ee359a0e23d4a$var$eraValues = {
    narrow: [
        "M.A",
        "M."
    ],
    abbreviated: [
        "M.A",
        "M."
    ],
    wide: [
        "Miloddan Avvalgi",
        "Milodiy"
    ]
};
const $ab4ee359a0e23d4a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "CH.1",
        "CH.2",
        "CH.3",
        "CH.4"
    ],
    wide: [
        "1-chi chorak",
        "2-chi chorak",
        "3-chi chorak",
        "4-chi chorak"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $ab4ee359a0e23d4a$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "Iyun",
        "Iyul",
        "Avg",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "Iyun",
        "Iyul",
        "Avgust",
        "Sentabr",
        "Oktabr",
        "Noyabr",
        "Dekabr"
    ]
};
const $ab4ee359a0e23d4a$var$dayValues = {
    narrow: [
        "Y",
        "D",
        "S",
        "CH",
        "P",
        "J",
        "SH"
    ],
    short: [
        "Ya",
        "Du",
        "Se",
        "Cho",
        "Pa",
        "Ju",
        "Sha"
    ],
    abbreviated: [
        "Yak",
        "Dush",
        "Sesh",
        "Chor",
        "Pay",
        "Jum",
        "Shan"
    ],
    wide: [
        "Yakshanba",
        "Dushanba",
        "Seshanba",
        "Chorshanba",
        "Payshanba",
        "Juma",
        "Shanba"
    ]
};
const $ab4ee359a0e23d4a$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
const $ab4ee359a0e23d4a$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
const $ab4ee359a0e23d4a$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $ab4ee359a0e23d4a$var$localize = $ab4ee359a0e23d4a$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ab4ee359a0e23d4a$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ab4ee359a0e23d4a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ab4ee359a0e23d4a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ab4ee359a0e23d4a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ab4ee359a0e23d4a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $ab4ee359a0e23d4a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ab4ee359a0e23d4a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $a9a6a3495d3ae058$export$4659b591c19bdf3d;
"use strict";
$a9a6a3495d3ae058$export$4659b591c19bdf3d = void 0;


const $a9a6a3495d3ae058$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
const $a9a6a3495d3ae058$var$parseOrdinalNumberPattern = /\d+/i;
const $a9a6a3495d3ae058$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
const $a9a6a3495d3ae058$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $a9a6a3495d3ae058$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
const $a9a6a3495d3ae058$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $a9a6a3495d3ae058$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
const $a9a6a3495d3ae058$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $a9a6a3495d3ae058$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
const $a9a6a3495d3ae058$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
const $a9a6a3495d3ae058$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
const $a9a6a3495d3ae058$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
const $a9a6a3495d3ae058$var$match = $a9a6a3495d3ae058$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $a9a6a3495d3ae058$var$matchOrdinalNumberPattern,
        parsePattern: $a9a6a3495d3ae058$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a9a6a3495d3ae058$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9a6a3495d3ae058$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a9a6a3495d3ae058$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9a6a3495d3ae058$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a9a6a3495d3ae058$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9a6a3495d3ae058$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a9a6a3495d3ae058$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9a6a3495d3ae058$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a9a6a3495d3ae058$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a9a6a3495d3ae058$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali](https://github.com/Mukhammadali)
 */ const $b88df4c6fe2551db$var$uz = $b88df4c6fe2551db$export$461e3962c82dff4f = {
    code: "uz",
    formatDistance: $d681ca273fc7f453$export$2c14ff85d6318973,
    formatLong: $a64f1c3c1aec9e43$export$cbf60ecb96cbb82f,
    formatRelative: $a50694c9e4a77169$export$8fbbfd65594f46a0,
    localize: $ab4ee359a0e23d4a$export$b3bd0bc58e36cd63,
    match: $a9a6a3495d3ae058$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($b88df4c6fe2551db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $b88df4c6fe2551db$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $b88df4c6fe2551db$exports[key];
        }
    });
});
var $89b932aee11fa5b8$exports = {};

$parcel$export($89b932aee11fa5b8$exports, "uzCyrl", () => $89b932aee11fa5b8$export$fe32212c9efceff7, (v) => $89b932aee11fa5b8$export$fe32212c9efceff7 = v);
var $89b932aee11fa5b8$export$fe32212c9efceff7;
"use strict";
$89b932aee11fa5b8$export$fe32212c9efceff7 = void 0;
var $e8452e362c781da6$export$2c14ff85d6318973;
"use strict";
$e8452e362c781da6$export$2c14ff85d6318973 = void 0;
const $e8452e362c781da6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
const $e8452e362c781da6$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $e8452e362c781da6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
$e8452e362c781da6$export$2c14ff85d6318973 = $e8452e362c781da6$var$formatDistance;


var $39450b1fa8585959$export$cbf60ecb96cbb82f;
"use strict";
$39450b1fa8585959$export$cbf60ecb96cbb82f = void 0;

const $39450b1fa8585959$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
const $39450b1fa8585959$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $39450b1fa8585959$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
const $39450b1fa8585959$var$formatLong = $39450b1fa8585959$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $39450b1fa8585959$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $39450b1fa8585959$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $39450b1fa8585959$var$dateTimeFormats,
        defaultWidth: "any"
    })
};


var $15a868dc1e4bf1e9$export$8fbbfd65594f46a0;
"use strict";
$15a868dc1e4bf1e9$export$8fbbfd65594f46a0 = void 0;
const $15a868dc1e4bf1e9$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: "P"
};
const $15a868dc1e4bf1e9$var$formatRelative = (token, _date, _baseDate, _options)=>$15a868dc1e4bf1e9$var$formatRelativeLocale[token];
$15a868dc1e4bf1e9$export$8fbbfd65594f46a0 = $15a868dc1e4bf1e9$var$formatRelative;


var $2a57197abb4dff08$export$b3bd0bc58e36cd63;
"use strict";
$2a57197abb4dff08$export$b3bd0bc58e36cd63 = void 0;

const $2a57197abb4dff08$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
const $2a57197abb4dff08$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
const $2a57197abb4dff08$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
const $2a57197abb4dff08$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
const $2a57197abb4dff08$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
const $2a57197abb4dff08$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
const $2a57197abb4dff08$var$ordinalNumber = (dirtyNumber, _options)=>{
    return String(dirtyNumber);
};
const $2a57197abb4dff08$var$localize = $2a57197abb4dff08$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2a57197abb4dff08$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a57197abb4dff08$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a57197abb4dff08$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a57197abb4dff08$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a57197abb4dff08$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2a57197abb4dff08$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $2a57197abb4dff08$var$formattingDayPeriodValues,
        defaultFormattingWidth: "any"
    })
};


var $e155bf8a093ed452$export$4659b591c19bdf3d;
"use strict";
$e155bf8a093ed452$export$4659b591c19bdf3d = void 0;


const $e155bf8a093ed452$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
const $e155bf8a093ed452$var$parseOrdinalNumberPattern = /\d+/i;
const $e155bf8a093ed452$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
const $e155bf8a093ed452$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
const $e155bf8a093ed452$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
const $e155bf8a093ed452$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e155bf8a093ed452$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
const $e155bf8a093ed452$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
const $e155bf8a093ed452$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
const $e155bf8a093ed452$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
const $e155bf8a093ed452$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
const $e155bf8a093ed452$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
const $e155bf8a093ed452$var$match = $e155bf8a093ed452$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $e155bf8a093ed452$var$matchOrdinalNumberPattern,
        parsePattern: $e155bf8a093ed452$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e155bf8a093ed452$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e155bf8a093ed452$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e155bf8a093ed452$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e155bf8a093ed452$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e155bf8a093ed452$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e155bf8a093ed452$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e155bf8a093ed452$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e155bf8a093ed452$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $e155bf8a093ed452$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e155bf8a093ed452$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28](https://github.com/kamronbek28)
 */ const $89b932aee11fa5b8$var$uzCyrl = $89b932aee11fa5b8$export$fe32212c9efceff7 = {
    code: "uz-Cyrl",
    formatDistance: $e8452e362c781da6$export$2c14ff85d6318973,
    formatLong: $39450b1fa8585959$export$cbf60ecb96cbb82f,
    formatRelative: $15a868dc1e4bf1e9$export$8fbbfd65594f46a0,
    localize: $2a57197abb4dff08$export$b3bd0bc58e36cd63,
    match: $e155bf8a093ed452$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($89b932aee11fa5b8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $89b932aee11fa5b8$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $89b932aee11fa5b8$exports[key];
        }
    });
});
var $ccd886b91dca4cf0$exports = {};

$parcel$export($ccd886b91dca4cf0$exports, "vi", () => $ccd886b91dca4cf0$export$e3786bf10a8abdf2, (v) => $ccd886b91dca4cf0$export$e3786bf10a8abdf2 = v);
var $ccd886b91dca4cf0$export$e3786bf10a8abdf2;
"use strict";
$ccd886b91dca4cf0$export$e3786bf10a8abdf2 = void 0;
var $2c7d70d616e6807b$export$2c14ff85d6318973;
"use strict";
$2c7d70d616e6807b$export$2c14ff85d6318973 = void 0;
const $2c7d70d616e6807b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
const $2c7d70d616e6807b$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2c7d70d616e6807b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
$2c7d70d616e6807b$export$2c14ff85d6318973 = $2c7d70d616e6807b$var$formatDistance;


var $2982569bbba132db$export$cbf60ecb96cbb82f;
"use strict";
$2982569bbba132db$export$cbf60ecb96cbb82f = void 0;

const $2982569bbba132db$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: "dd/MM/y"
};
const $2982569bbba132db$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $2982569bbba132db$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: "{{date}} {{time}}",
    // ngày 25 tháng 08 năm 2017 23:25
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $2982569bbba132db$var$formatLong = $2982569bbba132db$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $2982569bbba132db$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $2982569bbba132db$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $2982569bbba132db$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $0e1db40943eb9300$export$8fbbfd65594f46a0;
"use strict";
$0e1db40943eb9300$export$8fbbfd65594f46a0 = void 0;
const $0e1db40943eb9300$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: "P"
};
const $0e1db40943eb9300$var$formatRelative = (token, _date, _baseDate, _options)=>$0e1db40943eb9300$var$formatRelativeLocale[token];
$0e1db40943eb9300$export$8fbbfd65594f46a0 = $0e1db40943eb9300$var$formatRelative;


var $2273d6e77cf7d1a6$export$b3bd0bc58e36cd63;
"use strict";
$2273d6e77cf7d1a6$export$b3bd0bc58e36cd63 = void 0;

// Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
const $2273d6e77cf7d1a6$var$eraValues = {
    narrow: [
        "TCN",
        "SCN"
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        "sau CN"
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
const $2273d6e77cf7d1a6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
const $2273d6e77cf7d1a6$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $2273d6e77cf7d1a6$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "Thg 1",
        "Thg 2",
        "Thg 3",
        "Thg 4",
        "Thg 5",
        "Thg 6",
        "Thg 7",
        "Thg 8",
        "Thg 9",
        "Thg 10",
        "Thg 11",
        "Thg 12"
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
const $2273d6e77cf7d1a6$var$formattingMonthValues = {
    narrow: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "thg 1",
        "thg 2",
        "thg 3",
        "thg 4",
        "thg 5",
        "thg 6",
        "thg 7",
        "thg 8",
        "thg 9",
        "thg 10",
        "thg 11",
        "thg 12"
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
const $2273d6e77cf7d1a6$var$dayValues = {
    narrow: [
        "CN",
        "T2",
        "T3",
        "T4",
        "T5",
        "T6",
        "T7"
    ],
    short: [
        "CN",
        "Th 2",
        "Th 3",
        "Th 4",
        "Th 5",
        "Th 6",
        "Th 7"
    ],
    abbreviated: [
        "CN",
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
const $2273d6e77cf7d1a6$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
const $2273d6e77cf7d1a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
const $2273d6e77cf7d1a6$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (unit === "quarter") // many news outlets use "quý I"...
    switch(number){
        case 1:
            return "I";
        case 2:
            return "II";
        case 3:
            return "III";
        case 4:
            return "IV";
    }
    else if (unit === "day") // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2"; // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3"; // meaning 3rd day
        case 3:
            return "th\u1EE9 4"; // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt"; // meaning Sunday, there's no 8th day :D
    }
    else if (unit === "week") {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === "dayOfYear") {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
const $2273d6e77cf7d1a6$var$localize = $2273d6e77cf7d1a6$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $2273d6e77cf7d1a6$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2273d6e77cf7d1a6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2273d6e77cf7d1a6$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $2273d6e77cf7d1a6$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2273d6e77cf7d1a6$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $2273d6e77cf7d1a6$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2273d6e77cf7d1a6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $2273d6e77cf7d1a6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2273d6e77cf7d1a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $a267da1d6ca94805$export$4659b591c19bdf3d;
"use strict";
$a267da1d6ca94805$export$4659b591c19bdf3d = void 0;


const $a267da1d6ca94805$var$matchOrdinalNumberPattern = /^(\d+)/i;
const $a267da1d6ca94805$var$parseOrdinalNumberPattern = /\d+/i;
const $a267da1d6ca94805$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
const $a267da1d6ca94805$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
const $a267da1d6ca94805$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
const $a267da1d6ca94805$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
const $a267da1d6ca94805$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
const $a267da1d6ca94805$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
const $a267da1d6ca94805$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
const $a267da1d6ca94805$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
const $a267da1d6ca94805$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
const $a267da1d6ca94805$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
const $a267da1d6ca94805$var$match = $a267da1d6ca94805$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $a267da1d6ca94805$var$matchOrdinalNumberPattern,
        parsePattern: $a267da1d6ca94805$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a267da1d6ca94805$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a267da1d6ca94805$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a267da1d6ca94805$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a267da1d6ca94805$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a267da1d6ca94805$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a267da1d6ca94805$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a267da1d6ca94805$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a267da1d6ca94805$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $a267da1d6ca94805$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a267da1d6ca94805$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh](https://github.com/trongthanh)
 * @author Leroy Hopson [@lihop](https://github.com/lihop)
 */ const $ccd886b91dca4cf0$var$vi = $ccd886b91dca4cf0$export$e3786bf10a8abdf2 = {
    code: "vi",
    formatDistance: $2c7d70d616e6807b$export$2c14ff85d6318973,
    formatLong: $2982569bbba132db$export$cbf60ecb96cbb82f,
    formatRelative: $0e1db40943eb9300$export$8fbbfd65594f46a0,
    localize: $2273d6e77cf7d1a6$export$b3bd0bc58e36cd63,
    match: $a267da1d6ca94805$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};


Object.keys($ccd886b91dca4cf0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $ccd886b91dca4cf0$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $ccd886b91dca4cf0$exports[key];
        }
    });
});
var $85e917112841d516$exports = {};

$parcel$export($85e917112841d516$exports, "zhCN", () => $85e917112841d516$export$836e793ad054f4a7, (v) => $85e917112841d516$export$836e793ad054f4a7 = v);
var $85e917112841d516$export$836e793ad054f4a7;
"use strict";
$85e917112841d516$export$836e793ad054f4a7 = void 0;
var $2a647c817402c2f3$export$2c14ff85d6318973;
"use strict";
$2a647c817402c2f3$export$2c14ff85d6318973 = void 0;
const $2a647c817402c2f3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
const $2a647c817402c2f3$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $2a647c817402c2f3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
$2a647c817402c2f3$export$2c14ff85d6318973 = $2a647c817402c2f3$var$formatDistance;


var $f8435ba234100672$export$cbf60ecb96cbb82f;
"use strict";
$f8435ba234100672$export$cbf60ecb96cbb82f = void 0;

const $f8435ba234100672$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $f8435ba234100672$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $f8435ba234100672$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $f8435ba234100672$var$formatLong = $f8435ba234100672$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f8435ba234100672$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f8435ba234100672$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $f8435ba234100672$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $56436c76b2a856e7$export$8fbbfd65594f46a0;
"use strict";
$56436c76b2a856e7$export$8fbbfd65594f46a0 = void 0;

function $56436c76b2a856e7$var$checkWeek(date, baseDate, options) {
    const baseFormat = "eeee p";
    if ((0, $797b36256ddc073d$export$6ea683876c36b8d2)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
const $56436c76b2a856e7$var$formatRelativeLocale = {
    lastWeek: $56436c76b2a856e7$var$checkWeek,
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $56436c76b2a856e7$var$checkWeek,
    other: "PP p"
};
const $56436c76b2a856e7$var$formatRelative = (token, date, baseDate, options)=>{
    const format = $56436c76b2a856e7$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
$56436c76b2a856e7$export$8fbbfd65594f46a0 = $56436c76b2a856e7$var$formatRelative;


var $5a08551e8073d5e7$export$b3bd0bc58e36cd63;
"use strict";
$5a08551e8073d5e7$export$b3bd0bc58e36cd63 = void 0;

const $5a08551e8073d5e7$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $5a08551e8073d5e7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
const $5a08551e8073d5e7$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $5a08551e8073d5e7$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $5a08551e8073d5e7$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
const $5a08551e8073d5e7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
const $5a08551e8073d5e7$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number.toString() + "\u65E5";
        case "hour":
            return number.toString() + "\u65F6";
        case "minute":
            return number.toString() + "\u5206";
        case "second":
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
const $5a08551e8073d5e7$var$localize = $5a08551e8073d5e7$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $5a08551e8073d5e7$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5a08551e8073d5e7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5a08551e8073d5e7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5a08551e8073d5e7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5a08551e8073d5e7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $5a08551e8073d5e7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5a08551e8073d5e7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $51fcf7fe8dafe231$export$4659b591c19bdf3d;
"use strict";
$51fcf7fe8dafe231$export$4659b591c19bdf3d = void 0;


const $51fcf7fe8dafe231$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
const $51fcf7fe8dafe231$var$parseOrdinalNumberPattern = /\d+/i;
const $51fcf7fe8dafe231$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $51fcf7fe8dafe231$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $51fcf7fe8dafe231$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
const $51fcf7fe8dafe231$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $51fcf7fe8dafe231$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $51fcf7fe8dafe231$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $51fcf7fe8dafe231$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $51fcf7fe8dafe231$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $51fcf7fe8dafe231$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
const $51fcf7fe8dafe231$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $51fcf7fe8dafe231$var$match = $51fcf7fe8dafe231$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $51fcf7fe8dafe231$var$matchOrdinalNumberPattern,
        parsePattern: $51fcf7fe8dafe231$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $51fcf7fe8dafe231$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51fcf7fe8dafe231$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $51fcf7fe8dafe231$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51fcf7fe8dafe231$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $51fcf7fe8dafe231$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51fcf7fe8dafe231$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $51fcf7fe8dafe231$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51fcf7fe8dafe231$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $51fcf7fe8dafe231$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $51fcf7fe8dafe231$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario](https://github.com/KingMario)
 * @author Song Shuoyun [@fnlctrl](https://github.com/fnlctrl)
 * @author sabrinaM [@sabrinamiao](https://github.com/sabrinamiao)
 * @author Carney Wu [@cubicwork](https://github.com/cubicwork)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */ const $85e917112841d516$var$zhCN = $85e917112841d516$export$836e793ad054f4a7 = {
    code: "zh-CN",
    formatDistance: $2a647c817402c2f3$export$2c14ff85d6318973,
    formatLong: $f8435ba234100672$export$cbf60ecb96cbb82f,
    formatRelative: $56436c76b2a856e7$export$8fbbfd65594f46a0,
    localize: $5a08551e8073d5e7$export$b3bd0bc58e36cd63,
    match: $51fcf7fe8dafe231$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($85e917112841d516$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $85e917112841d516$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $85e917112841d516$exports[key];
        }
    });
});
var $3d57979fc3641654$exports = {};

$parcel$export($3d57979fc3641654$exports, "zhHK", () => $3d57979fc3641654$export$2099e693528da242, (v) => $3d57979fc3641654$export$2099e693528da242 = v);
var $3d57979fc3641654$export$2099e693528da242;
"use strict";
$3d57979fc3641654$export$2099e693528da242 = void 0;
var $a39142a80a0412b2$export$2c14ff85d6318973;
"use strict";
$a39142a80a0412b2$export$2c14ff85d6318973 = void 0;
const $a39142a80a0412b2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
const $a39142a80a0412b2$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $a39142a80a0412b2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
$a39142a80a0412b2$export$2c14ff85d6318973 = $a39142a80a0412b2$var$formatDistance;


var $c47f227a8a748a55$export$cbf60ecb96cbb82f;
"use strict";
$c47f227a8a748a55$export$cbf60ecb96cbb82f = void 0;

const $c47f227a8a748a55$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $c47f227a8a748a55$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $c47f227a8a748a55$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $c47f227a8a748a55$var$formatLong = $c47f227a8a748a55$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c47f227a8a748a55$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c47f227a8a748a55$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $c47f227a8a748a55$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $4a93d67940c4a5db$export$8fbbfd65594f46a0;
"use strict";
$4a93d67940c4a5db$export$8fbbfd65594f46a0 = void 0;
const $4a93d67940c4a5db$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
const $4a93d67940c4a5db$var$formatRelative = (token, _date, _baseDate, _options)=>$4a93d67940c4a5db$var$formatRelativeLocale[token];
$4a93d67940c4a5db$export$8fbbfd65594f46a0 = $4a93d67940c4a5db$var$formatRelative;


var $8f551a3043158b27$export$b3bd0bc58e36cd63;
"use strict";
$8f551a3043158b27$export$b3bd0bc58e36cd63 = void 0;

const $8f551a3043158b27$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $8f551a3043158b27$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
const $8f551a3043158b27$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $8f551a3043158b27$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $8f551a3043158b27$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
const $8f551a3043158b27$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
const $8f551a3043158b27$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
const $8f551a3043158b27$var$localize = $8f551a3043158b27$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $8f551a3043158b27$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8f551a3043158b27$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8f551a3043158b27$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8f551a3043158b27$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8f551a3043158b27$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $8f551a3043158b27$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8f551a3043158b27$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $c98e2109af9a6f2e$export$4659b591c19bdf3d;
"use strict";
$c98e2109af9a6f2e$export$4659b591c19bdf3d = void 0;


const $c98e2109af9a6f2e$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
const $c98e2109af9a6f2e$var$parseOrdinalNumberPattern = /\d+/i;
const $c98e2109af9a6f2e$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $c98e2109af9a6f2e$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $c98e2109af9a6f2e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
const $c98e2109af9a6f2e$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $c98e2109af9a6f2e$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $c98e2109af9a6f2e$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $c98e2109af9a6f2e$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $c98e2109af9a6f2e$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $c98e2109af9a6f2e$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
const $c98e2109af9a6f2e$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $c98e2109af9a6f2e$var$match = $c98e2109af9a6f2e$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $c98e2109af9a6f2e$var$matchOrdinalNumberPattern,
        parsePattern: $c98e2109af9a6f2e$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c98e2109af9a6f2e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c98e2109af9a6f2e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c98e2109af9a6f2e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c98e2109af9a6f2e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c98e2109af9a6f2e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c98e2109af9a6f2e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c98e2109af9a6f2e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c98e2109af9a6f2e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $c98e2109af9a6f2e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c98e2109af9a6f2e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo](https://github.com/gaplo)
 */ const $3d57979fc3641654$var$zhHK = $3d57979fc3641654$export$2099e693528da242 = {
    code: "zh-HK",
    formatDistance: $a39142a80a0412b2$export$2c14ff85d6318973,
    formatLong: $c47f227a8a748a55$export$cbf60ecb96cbb82f,
    formatRelative: $4a93d67940c4a5db$export$8fbbfd65594f46a0,
    localize: $8f551a3043158b27$export$b3bd0bc58e36cd63,
    match: $c98e2109af9a6f2e$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};


Object.keys($3d57979fc3641654$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $3d57979fc3641654$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $3d57979fc3641654$exports[key];
        }
    });
});
var $f3061cdb1e8785da$exports = {};

$parcel$export($f3061cdb1e8785da$exports, "zhTW", () => $f3061cdb1e8785da$export$3991fdf1bb6f66b9, (v) => $f3061cdb1e8785da$export$3991fdf1bb6f66b9 = v);
var $f3061cdb1e8785da$export$3991fdf1bb6f66b9;
"use strict";
$f3061cdb1e8785da$export$3991fdf1bb6f66b9 = void 0;
var $8c17746537880705$export$2c14ff85d6318973;
"use strict";
$8c17746537880705$export$2c14ff85d6318973 = void 0;
const $8c17746537880705$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
const $8c17746537880705$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8c17746537880705$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
$8c17746537880705$export$2c14ff85d6318973 = $8c17746537880705$var$formatDistance;


var $6967d02feee3f098$export$cbf60ecb96cbb82f;
"use strict";
$6967d02feee3f098$export$cbf60ecb96cbb82f = void 0;

const $6967d02feee3f098$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
const $6967d02feee3f098$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
const $6967d02feee3f098$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
const $6967d02feee3f098$var$formatLong = $6967d02feee3f098$export$cbf60ecb96cbb82f = {
    date: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6967d02feee3f098$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6967d02feee3f098$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $8debed4d8224b686$export$38e44e97ce4dbb7d)({
        formats: $6967d02feee3f098$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $4785e174a5e66f11$export$8fbbfd65594f46a0;
"use strict";
$4785e174a5e66f11$export$8fbbfd65594f46a0 = void 0;
const $4785e174a5e66f11$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
const $4785e174a5e66f11$var$formatRelative = (token, _date, _baseDate, _options)=>$4785e174a5e66f11$var$formatRelativeLocale[token];
$4785e174a5e66f11$export$8fbbfd65594f46a0 = $4785e174a5e66f11$var$formatRelative;


var $29def828c59aaa51$export$b3bd0bc58e36cd63;
"use strict";
$29def828c59aaa51$export$b3bd0bc58e36cd63 = void 0;

const $29def828c59aaa51$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
const $29def828c59aaa51$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
const $29def828c59aaa51$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
const $29def828c59aaa51$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
const $29def828c59aaa51$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
const $29def828c59aaa51$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
const $29def828c59aaa51$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    switch(options?.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
const $29def828c59aaa51$var$localize = $29def828c59aaa51$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $29def828c59aaa51$var$ordinalNumber,
    era: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $29def828c59aaa51$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $29def828c59aaa51$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $29def828c59aaa51$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $29def828c59aaa51$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $70754fa1f3ab9ab1$export$63596d6ee8878b25)({
        values: $29def828c59aaa51$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $29def828c59aaa51$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $fd7471e1afe2e722$export$4659b591c19bdf3d;
"use strict";
$fd7471e1afe2e722$export$4659b591c19bdf3d = void 0;


const $fd7471e1afe2e722$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
const $fd7471e1afe2e722$var$parseOrdinalNumberPattern = /\d+/i;
const $fd7471e1afe2e722$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
const $fd7471e1afe2e722$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
const $fd7471e1afe2e722$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
const $fd7471e1afe2e722$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
const $fd7471e1afe2e722$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
const $fd7471e1afe2e722$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
const $fd7471e1afe2e722$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
const $fd7471e1afe2e722$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
const $fd7471e1afe2e722$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
const $fd7471e1afe2e722$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
const $fd7471e1afe2e722$var$match = $fd7471e1afe2e722$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $8b0286364b664829$export$fdaf2fd6d7edde95)({
        matchPattern: $fd7471e1afe2e722$var$matchOrdinalNumberPattern,
        parsePattern: $fd7471e1afe2e722$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7471e1afe2e722$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7471e1afe2e722$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7471e1afe2e722$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7471e1afe2e722$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7471e1afe2e722$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7471e1afe2e722$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7471e1afe2e722$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fd7471e1afe2e722$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c7bab40ce41055a9$export$1430a0f35710914d)({
        matchPatterns: $fd7471e1afe2e722$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fd7471e1afe2e722$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai](https://github.com/tpai)
 * @author Jack Hsu [@jackhsu978](https://github.com/jackhsu978)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */ const $f3061cdb1e8785da$var$zhTW = $f3061cdb1e8785da$export$3991fdf1bb6f66b9 = {
    code: "zh-TW",
    formatDistance: $8c17746537880705$export$2c14ff85d6318973,
    formatLong: $6967d02feee3f098$export$cbf60ecb96cbb82f,
    formatRelative: $4785e174a5e66f11$export$8fbbfd65594f46a0,
    localize: $29def828c59aaa51$export$b3bd0bc58e36cd63,
    match: $fd7471e1afe2e722$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};


Object.keys($f3061cdb1e8785da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $2650d1a625c02db9$exports && $2650d1a625c02db9$exports[key] === $f3061cdb1e8785da$exports[key]) return;
    Object.defineProperty($2650d1a625c02db9$exports, key, {
        enumerable: true,
        get: function() {
            return $f3061cdb1e8785da$exports[key];
        }
    });
});


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $d39a889c3bbcd0b2$var$__assign = function() {
    $d39a889c3bbcd0b2$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d39a889c3bbcd0b2$var$__assign.apply(this, arguments);
};
function $d39a889c3bbcd0b2$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d39a889c3bbcd0b2$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function $d39a889c3bbcd0b2$export$2d8c2b43ec0e528(props) {
    return props.mode === "multiple";
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function $d39a889c3bbcd0b2$export$f7b9f96866ec1964(props) {
    return props.mode === "range";
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function $d39a889c3bbcd0b2$export$e659ce9b264ea61(props) {
    return props.mode === "single";
}
/**
 * The name of the default CSS classes.
 */ var $d39a889c3bbcd0b2$var$defaultClassNames = {
    root: "rdp",
    multiple_months: "rdp-multiple_months",
    with_weeknumber: "rdp-with_weeknumber",
    vhidden: "rdp-vhidden",
    button_reset: "rdp-button_reset",
    button: "rdp-button",
    caption: "rdp-caption",
    caption_start: "rdp-caption_start",
    caption_end: "rdp-caption_end",
    caption_between: "rdp-caption_between",
    caption_label: "rdp-caption_label",
    caption_dropdowns: "rdp-caption_dropdowns",
    dropdown: "rdp-dropdown",
    dropdown_month: "rdp-dropdown_month",
    dropdown_year: "rdp-dropdown_year",
    dropdown_icon: "rdp-dropdown_icon",
    months: "rdp-months",
    month: "rdp-month",
    table: "rdp-table",
    tbody: "rdp-tbody",
    tfoot: "rdp-tfoot",
    head: "rdp-head",
    head_row: "rdp-head_row",
    head_cell: "rdp-head_cell",
    nav: "rdp-nav",
    nav_button: "rdp-nav_button",
    nav_button_previous: "rdp-nav_button_previous",
    nav_button_next: "rdp-nav_button_next",
    nav_icon: "rdp-nav_icon",
    row: "rdp-row",
    weeknumber: "rdp-weeknumber",
    cell: "rdp-cell",
    day: "rdp-day",
    day_today: "rdp-day_today",
    day_outside: "rdp-day_outside",
    day_selected: "rdp-day_selected",
    day_disabled: "rdp-day_disabled",
    day_hidden: "rdp-day_hidden",
    day_range_start: "rdp-day_range_start",
    day_range_end: "rdp-day_range_end",
    day_range_middle: "rdp-day_range_middle"
};
/**
 * The default formatter for the caption.
 */ function $d39a889c3bbcd0b2$var$formatCaption(month, options) {
    return (0, $4a2650a25edc3aa6$exports.format)(month, "LLLL y", options);
}
/**
 * The default formatter for the Day button.
 */ function $d39a889c3bbcd0b2$var$formatDay(day, options) {
    return (0, $4a2650a25edc3aa6$exports.format)(day, "d", options);
}
/**
 * The default formatter for the Month caption.
 */ function $d39a889c3bbcd0b2$var$formatMonthCaption(month, options) {
    return (0, $4a2650a25edc3aa6$exports.format)(month, "LLLL", options);
}
/**
 * The default formatter for the week number.
 */ function $d39a889c3bbcd0b2$var$formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function $d39a889c3bbcd0b2$var$formatWeekdayName(weekday, options) {
    return (0, $4a2650a25edc3aa6$exports.format)(weekday, "cccccc", options);
}
/**
 * The default formatter for the Year caption.
 */ function $d39a889c3bbcd0b2$var$formatYearCaption(year, options) {
    return (0, $4a2650a25edc3aa6$exports.format)(year, "yyyy", options);
}
var $d39a889c3bbcd0b2$var$formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: $d39a889c3bbcd0b2$var$formatCaption,
    formatDay: $d39a889c3bbcd0b2$var$formatDay,
    formatMonthCaption: $d39a889c3bbcd0b2$var$formatMonthCaption,
    formatWeekNumber: $d39a889c3bbcd0b2$var$formatWeekNumber,
    formatWeekdayName: $d39a889c3bbcd0b2$var$formatWeekdayName,
    formatYearCaption: $d39a889c3bbcd0b2$var$formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var $d39a889c3bbcd0b2$var$labelDay = function(day, activeModifiers, options) {
    return (0, $4a2650a25edc3aa6$exports.format)(day, "do MMMM (EEEE)", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $d39a889c3bbcd0b2$var$labelMonthDropdown = function() {
    return "Month: ";
};
/**
 * The default ARIA label for next month button in navigation
 */ var $d39a889c3bbcd0b2$var$labelNext = function() {
    return "Go to next month";
};
/**
 * The default ARIA label for previous month button in navigation
 */ var $d39a889c3bbcd0b2$var$labelPrevious = function() {
    return "Go to previous month";
};
/**
 * The default ARIA label for the Weekday element.
 */ var $d39a889c3bbcd0b2$var$labelWeekday = function(day, options) {
    return (0, $4a2650a25edc3aa6$exports.format)(day, "cccc", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $d39a889c3bbcd0b2$var$labelWeekNumber = function(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $d39a889c3bbcd0b2$var$labelYearDropdown = function() {
    return "Year: ";
};
var $d39a889c3bbcd0b2$var$labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: $d39a889c3bbcd0b2$var$labelDay,
    labelMonthDropdown: $d39a889c3bbcd0b2$var$labelMonthDropdown,
    labelNext: $d39a889c3bbcd0b2$var$labelNext,
    labelPrevious: $d39a889c3bbcd0b2$var$labelPrevious,
    labelWeekNumber: $d39a889c3bbcd0b2$var$labelWeekNumber,
    labelWeekday: $d39a889c3bbcd0b2$var$labelWeekday,
    labelYearDropdown: $d39a889c3bbcd0b2$var$labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function $d39a889c3bbcd0b2$var$getDefaultContextValues() {
    var captionLayout = "buttons";
    var classNames = $d39a889c3bbcd0b2$var$defaultClassNames;
    var locale = (0, $2650d1a625c02db9$exports.enUS);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: $d39a889c3bbcd0b2$var$formatters,
        labels: $d39a889c3bbcd0b2$var$labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: "default"
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function $d39a889c3bbcd0b2$var$parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, $4a2650a25edc3aa6$exports.startOfMonth)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, $4a2650a25edc3aa6$exports.endOfMonth)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, $4a2650a25edc3aa6$exports.startOfDay)(fromDate) : undefined,
        toDate: toDate ? (0, $4a2650a25edc3aa6$exports.startOfDay)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var $d39a889c3bbcd0b2$export$5e463664ac32e9a9 = (0, $eFMZj.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function $d39a889c3bbcd0b2$export$a84f964d022d25c(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = $d39a889c3bbcd0b2$var$getDefaultContextValues();
    var _b = $d39a889c3bbcd0b2$var$parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== "buttons" && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = "buttons";
    var onSelect;
    if ($d39a889c3bbcd0b2$export$e659ce9b264ea61(initialProps) || $d39a889c3bbcd0b2$export$2d8c2b43ec0e528(initialProps) || $d39a889c3bbcd0b2$export$f7b9f96866ec1964(initialProps)) onSelect = initialProps.onSelect;
    var value = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: $d39a889c3bbcd0b2$var$__assign({}, initialProps.components),
        formatters: $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$5e463664ac32e9a9.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function $d39a889c3bbcd0b2$export$332e9e0d64b1f294() {
    var context = (0, $eFMZj.useContext)($d39a889c3bbcd0b2$export$5e463664ac32e9a9);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function $d39a889c3bbcd0b2$export$5b9f95302ae85eba(props) {
    var _a = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (0, $fe00083af124a348$exports.jsx)("div", {
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id,
        children: formatCaption(props.displayMonth, {
            locale: locale
        })
    });
}
/**
 * Render the icon in the styled drop-down.
 */ function $d39a889c3bbcd0b2$export$eaf28e65c2d9267c(props) {
    return (0, $fe00083af124a348$exports.jsx)("svg", $d39a889c3bbcd0b2$var$__assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props, {
        children: (0, $fe00083af124a348$exports.jsx)("path", {
            d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function $d39a889c3bbcd0b2$export$931cbfb6bfb85fc(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : $d39a889c3bbcd0b2$export$eaf28e65c2d9267c;
    return (0, $fe00083af124a348$exports.jsxs)("div", {
        className: className,
        style: style,
        children: [
            (0, $fe00083af124a348$exports.jsx)("span", {
                className: dayPicker.classNames.vhidden,
                children: props["aria-label"]
            }),
            (0, $fe00083af124a348$exports.jsx)("select", {
                name: props.name,
                "aria-label": props["aria-label"],
                className: dayPicker.classNames.dropdown,
                style: dayPicker.styles.dropdown,
                value: value,
                onChange: onChange,
                children: children
            }),
            (0, $fe00083af124a348$exports.jsxs)("div", {
                className: dayPicker.classNames.caption_label,
                style: dayPicker.styles.caption_label,
                "aria-hidden": "true",
                children: [
                    caption,
                    (0, $fe00083af124a348$exports.jsx)(IconDropdownComponent, {
                        className: dayPicker.classNames.dropdown_icon,
                        style: dayPicker.styles.dropdown_icon
                    })
                ]
            })
        ]
    });
}
/** Render the dropdown to navigate between months. */ function $d39a889c3bbcd0b2$var$MonthsDropdown(props) {
    var _a;
    var _b = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $fe00083af124a348$exports.jsx)((0, $fe00083af124a348$exports.Fragment), {});
    if (!toDate) return (0, $fe00083af124a348$exports.jsx)((0, $fe00083af124a348$exports.Fragment), {});
    var dropdownMonths = [];
    if ((0, $4a2650a25edc3aa6$exports.isSameYear)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, $4a2650a25edc3aa6$exports.startOfMonth)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, $4a2650a25edc3aa6$exports.setMonth)(date, month));
    } else {
        // display all the 12 months
        var date = (0, $4a2650a25edc3aa6$exports.startOfMonth)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, $4a2650a25edc3aa6$exports.setMonth)(date, month));
    }
    var handleChange = function(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, $4a2650a25edc3aa6$exports.setMonth)((0, $4a2650a25edc3aa6$exports.startOfMonth)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$931cbfb6bfb85fc;
    return (0, $fe00083af124a348$exports.jsx)(DropdownComponent, {
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: formatMonthCaption(props.displayMonth, {
            locale: locale
        }),
        children: dropdownMonths.map(function(m) {
            return (0, $fe00083af124a348$exports.jsx)("option", {
                value: m.getMonth(),
                children: formatMonthCaption(m, {
                    locale: locale
                })
            }, m.getMonth());
        })
    });
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function $d39a889c3bbcd0b2$var$YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $fe00083af124a348$exports.jsx)((0, $fe00083af124a348$exports.Fragment), {});
    if (!toDate) return (0, $fe00083af124a348$exports.jsx)((0, $fe00083af124a348$exports.Fragment), {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, $4a2650a25edc3aa6$exports.setYear)((0, $4a2650a25edc3aa6$exports.startOfYear)(new Date()), year));
    var handleChange = function(e) {
        var newMonth = (0, $4a2650a25edc3aa6$exports.setYear)((0, $4a2650a25edc3aa6$exports.startOfMonth)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$931cbfb6bfb85fc;
    return (0, $fe00083af124a348$exports.jsx)(DropdownComponent, {
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: formatYearCaption(displayMonth, {
            locale: locale
        }),
        children: years.map(function(year) {
            return (0, $fe00083af124a348$exports.jsx)("option", {
                value: year.getFullYear(),
                children: formatYearCaption(year, {
                    locale: locale
                })
            }, year.getFullYear());
        })
    });
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function $d39a889c3bbcd0b2$var$useControlledValue(defaultValue, controlledValue) {
    var _a = (0, $eFMZj.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function $d39a889c3bbcd0b2$var$getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, $4a2650a25edc3aa6$exports.differenceInCalendarMonths)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, $4a2650a25edc3aa6$exports.addMonths)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, $4a2650a25edc3aa6$exports.differenceInCalendarMonths)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, $4a2650a25edc3aa6$exports.startOfMonth)(initialMonth);
}
/** Controls the navigation state. */ function $d39a889c3bbcd0b2$var$useNavigationState() {
    var context = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var initialMonth = $d39a889c3bbcd0b2$var$getInitialMonth(context);
    var _a = $d39a889c3bbcd0b2$var$useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, $4a2650a25edc3aa6$exports.startOfMonth)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function $d39a889c3bbcd0b2$var$getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, $4a2650a25edc3aa6$exports.startOfMonth)(month);
    var end = (0, $4a2650a25edc3aa6$exports.startOfMonth)((0, $4a2650a25edc3aa6$exports.addMonths)(start, numberOfMonths));
    var monthsDiff = (0, $4a2650a25edc3aa6$exports.differenceInCalendarMonths)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, $4a2650a25edc3aa6$exports.addMonths)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function $d39a889c3bbcd0b2$var$getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $4a2650a25edc3aa6$exports.startOfMonth)(startingMonth);
    if (!toDate) return (0, $4a2650a25edc3aa6$exports.addMonths)(month, offset);
    var monthsDiff = (0, $4a2650a25edc3aa6$exports.differenceInCalendarMonths)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, $4a2650a25edc3aa6$exports.addMonths)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function $d39a889c3bbcd0b2$var$getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $4a2650a25edc3aa6$exports.startOfMonth)(startingMonth);
    if (!fromDate) return (0, $4a2650a25edc3aa6$exports.addMonths)(month, -offset);
    var monthsDiff = (0, $4a2650a25edc3aa6$exports.differenceInCalendarMonths)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, $4a2650a25edc3aa6$exports.addMonths)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var $d39a889c3bbcd0b2$export$3044ab7fdabeaee6 = (0, $eFMZj.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function $d39a889c3bbcd0b2$export$d91daf425539f32f(props) {
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var _a = $d39a889c3bbcd0b2$var$useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = $d39a889c3bbcd0b2$var$getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = $d39a889c3bbcd0b2$var$getNextMonth(currentMonth, dayPicker);
    var previousMonth = $d39a889c3bbcd0b2$var$getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, $4a2650a25edc3aa6$exports.isSameMonth)(date, displayMonth);
        });
    };
    var goToDate = function(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, $4a2650a25edc3aa6$exports.isBefore)(date, refDate)) goToMonth((0, $4a2650a25edc3aa6$exports.addMonths)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$3044ab7fdabeaee6.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $d39a889c3bbcd0b2$export$d0fd4b7106de2769() {
    var context = (0, $eFMZj.useContext)($d39a889c3bbcd0b2$export$3044ab7fdabeaee6);
    if (!context) throw new Error("useNavigation must be used within a NavigationProvider");
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function $d39a889c3bbcd0b2$export$6a3605aba74bcb3d(props) {
    var _a;
    var _b = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = $d39a889c3bbcd0b2$export$d0fd4b7106de2769().goToMonth;
    var handleMonthChange = function(newMonth) {
        goToMonth((0, $4a2650a25edc3aa6$exports.addMonths)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$5b9f95302ae85eba;
    var captionLabel = (0, $fe00083af124a348$exports.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return (0, $fe00083af124a348$exports.jsxs)("div", {
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns,
        children: [
            (0, $fe00083af124a348$exports.jsx)("div", {
                className: classNames.vhidden,
                children: captionLabel
            }),
            (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$MonthsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            }),
            (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$YearsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            })
        ]
    });
}
/**
 * Render the "previous month" button in the navigation.
 */ function $d39a889c3bbcd0b2$export$fac286bb0d0d0385(props) {
    return (0, $fe00083af124a348$exports.jsx)("svg", $d39a889c3bbcd0b2$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $fe00083af124a348$exports.jsx)("path", {
            d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function $d39a889c3bbcd0b2$export$142e5a7835580ff5(props) {
    return (0, $fe00083af124a348$exports.jsx)("svg", $d39a889c3bbcd0b2$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $fe00083af124a348$exports.jsx)("path", {
            d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
            fill: "currentColor"
        })
    }));
}
/** Render a button HTML element applying the reset class name. */ var $d39a889c3bbcd0b2$export$353f5b6fc5456de1 = (0, $eFMZj.forwardRef)(function(props, ref) {
    var _a = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(" ");
    var style = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return (0, $fe00083af124a348$exports.jsx)("button", $d39a889c3bbcd0b2$var$__assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function $d39a889c3bbcd0b2$var$Navigation(props) {
    var _a, _b;
    var _c = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return (0, $fe00083af124a348$exports.jsx)((0, $fe00083af124a348$exports.Fragment), {});
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(" ");
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(" ");
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$142e5a7835580ff5;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : $d39a889c3bbcd0b2$export$fac286bb0d0d0385;
    return (0, $fe00083af124a348$exports.jsxs)("div", {
        className: classNames.nav,
        style: styles.nav,
        children: [
            !props.hidePrevious && (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$353f5b6fc5456de1, {
                name: "previous-month",
                "aria-label": previousLabel,
                className: previousClassName,
                style: styles.nav_button_previous,
                disabled: !props.previousMonth,
                onClick: props.onPreviousClick,
                children: dir === "rtl" ? (0, $fe00083af124a348$exports.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $fe00083af124a348$exports.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            }),
            !props.hideNext && (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$353f5b6fc5456de1, {
                name: "next-month",
                "aria-label": nextLabel,
                className: nextClassName,
                style: styles.nav_button_next,
                disabled: !props.nextMonth,
                onClick: props.onNextClick,
                children: dir === "rtl" ? (0, $fe00083af124a348$exports.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $fe00083af124a348$exports.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            })
        ]
    });
}
/**
 * Render a caption with a button-based navigation.
 */ function $d39a889c3bbcd0b2$export$f6e46da460a028c1(props) {
    var numberOfMonths = $d39a889c3bbcd0b2$export$332e9e0d64b1f294().numberOfMonths;
    var _a = $d39a889c3bbcd0b2$export$d0fd4b7106de2769(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, $4a2650a25edc3aa6$exports.isSameMonth)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function $d39a889c3bbcd0b2$export$32fbfacc5d962e0c(props) {
    var _a;
    var _b = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$5b9f95302ae85eba;
    var caption;
    if (disableNavigation) caption = (0, $fe00083af124a348$exports.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === "dropdown") caption = (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$6a3605aba74bcb3d, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === "dropdown-buttons") caption = (0, $fe00083af124a348$exports.jsxs)((0, $fe00083af124a348$exports.Fragment), {
        children: [
            (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$6a3605aba74bcb3d, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            }),
            (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            })
        ]
    });
    else caption = (0, $fe00083af124a348$exports.jsxs)((0, $fe00083af124a348$exports.Fragment), {
        children: [
            (0, $fe00083af124a348$exports.jsx)(CaptionLabelComponent, {
                id: props.id,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                id: props.id
            })
        ]
    });
    return (0, $fe00083af124a348$exports.jsx)("div", {
        className: classNames.caption,
        style: styles.caption,
        children: caption
    });
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $d39a889c3bbcd0b2$export$a06f1c675e846f6f(props) {
    var _a = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return (0, $fe00083af124a348$exports.jsx)((0, $fe00083af124a348$exports.Fragment), {});
    return (0, $fe00083af124a348$exports.jsx)("tfoot", {
        className: tfoot,
        style: styles.tfoot,
        children: (0, $fe00083af124a348$exports.jsx)("tr", {
            children: (0, $fe00083af124a348$exports.jsx)("td", {
                colSpan: 8,
                children: footer
            })
        })
    });
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function $d39a889c3bbcd0b2$var$getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, $4a2650a25edc3aa6$exports.startOfISOWeek)(new Date()) : (0, $4a2650a25edc3aa6$exports.startOfWeek)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, $4a2650a25edc3aa6$exports.addDays)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function $d39a889c3bbcd0b2$export$b008e842a2213343() {
    var _a = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = $d39a889c3bbcd0b2$var$getWeekdays(locale, weekStartsOn, ISOWeek);
    return (0, $fe00083af124a348$exports.jsxs)("tr", {
        style: styles.head_row,
        className: classNames.head_row,
        children: [
            showWeekNumber && (0, $fe00083af124a348$exports.jsx)("td", {
                style: styles.head_cell,
                className: classNames.head_cell
            }),
            weekdays.map(function(weekday, i) {
                return (0, $fe00083af124a348$exports.jsx)("th", {
                    scope: "col",
                    className: classNames.head_cell,
                    style: styles.head_cell,
                    "aria-label": labelWeekday(weekday, {
                        locale: locale
                    }),
                    children: formatWeekdayName(weekday, {
                        locale: locale
                    })
                }, i);
            })
        ]
    });
}
/** Render the table head. */ function $d39a889c3bbcd0b2$export$e93312b7773dfcac() {
    var _a;
    var _b = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$b008e842a2213343;
    return (0, $fe00083af124a348$exports.jsx)("thead", {
        style: styles.head,
        className: classNames.head,
        children: (0, $fe00083af124a348$exports.jsx)(HeadRowComponent, {})
    });
}
/** Render the content of the day cell. */ function $d39a889c3bbcd0b2$export$16d0634337daf8ec(props) {
    var _a = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return (0, $fe00083af124a348$exports.jsx)((0, $fe00083af124a348$exports.Fragment), {
        children: formatDay(props.date, {
            locale: locale
        })
    });
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var $d39a889c3bbcd0b2$export$26e3e4d6f601d4d6 = (0, $eFMZj.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function $d39a889c3bbcd0b2$export$913827019032c8d4(props) {
    if (!$d39a889c3bbcd0b2$export$2d8c2b43ec0e528(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$26e3e4d6f601d4d6.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$91128e1c5ca64a0d, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $d39a889c3bbcd0b2$export$91128e1c5ca64a0d(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? $d39a889c3bbcd0b2$var$__spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, $4a2650a25edc3aa6$exports.isSameDay)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, $4a2650a25edc3aa6$exports.isSameDay)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$26e3e4d6f601d4d6.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $d39a889c3bbcd0b2$export$458361db477d8ed0() {
    var context = (0, $eFMZj.useContext)($d39a889c3bbcd0b2$export$26e3e4d6f601d4d6);
    if (!context) throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function $d39a889c3bbcd0b2$export$27ef550b4e6acc0c(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if ((0, $4a2650a25edc3aa6$exports.isSameDay)(to, day) && (0, $4a2650a25edc3aa6$exports.isSameDay)(from, day)) return undefined;
        if ((0, $4a2650a25edc3aa6$exports.isSameDay)(to, day)) return {
            from: to,
            to: undefined
        };
        if ((0, $4a2650a25edc3aa6$exports.isSameDay)(from, day)) return undefined;
        if ((0, $4a2650a25edc3aa6$exports.isAfter)(from, day)) return {
            from: day,
            to: to
        };
        return {
            from: from,
            to: day
        };
    }
    if (to) {
        if ((0, $4a2650a25edc3aa6$exports.isAfter)(day, to)) return {
            from: to,
            to: day
        };
        return {
            from: day,
            to: to
        };
    }
    if (from) {
        if ((0, $4a2650a25edc3aa6$exports.isBefore)(day, from)) return {
            from: day,
            to: from
        };
        return {
            from: from,
            to: day
        };
    }
    return {
        from: day,
        to: undefined
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var $d39a889c3bbcd0b2$export$49c734aed8c840bb = (0, $eFMZj.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function $d39a889c3bbcd0b2$export$deb49a47c7ee5fdf(props) {
    if (!$d39a889c3bbcd0b2$export$f7b9f96866ec1964(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$49c734aed8c840bb.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$cca59e032fbbe71f, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $d39a889c3bbcd0b2$export$cca59e032fbbe71f(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var newRange = $d39a889c3bbcd0b2$export$27ef550b4e6acc0c(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, $4a2650a25edc3aa6$exports.isSameDay)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    } else if (selectedTo) {
        modifiers.range_start = [
            selectedTo
        ];
        modifiers.range_end = [
            selectedTo
        ];
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, $4a2650a25edc3aa6$exports.subDays)(selectedFrom, min - 1),
            before: (0, $4a2650a25edc3aa6$exports.addDays)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, $4a2650a25edc3aa6$exports.addDays)(selectedFrom, min - 1)
        });
        if (!selectedFrom && selectedTo) modifiers.disabled.push({
            after: (0, $4a2650a25edc3aa6$exports.subDays)(selectedTo, min - 1),
            before: (0, $4a2650a25edc3aa6$exports.addDays)(selectedTo, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, $4a2650a25edc3aa6$exports.addDays)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $4a2650a25edc3aa6$exports.addDays)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, $4a2650a25edc3aa6$exports.subDays)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, $4a2650a25edc3aa6$exports.addDays)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0, $4a2650a25edc3aa6$exports.addDays)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $4a2650a25edc3aa6$exports.addDays)(selectedTo, max - 1)
            });
        }
    }
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$49c734aed8c840bb.Provider, {
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        },
        children: children
    });
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $d39a889c3bbcd0b2$export$ad0998138eb321e7() {
    var context = (0, $eFMZj.useContext)($d39a889c3bbcd0b2$export$49c734aed8c840bb);
    if (!context) throw new Error("useSelectRange must be used within a SelectRangeProvider");
    return context;
}
/** Normalize to array a matcher input. */ function $d39a889c3bbcd0b2$var$matcherToArray(matcher) {
    if (Array.isArray(matcher)) return $d39a889c3bbcd0b2$var$__spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function $d39a889c3bbcd0b2$var$getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = $d39a889c3bbcd0b2$var$matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})($d39a889c3bbcd0b2$export$7652a4f8ecc53eb5 || ($d39a889c3bbcd0b2$export$7652a4f8ecc53eb5 = {}));
var $d39a889c3bbcd0b2$var$Selected = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.Selected, $d39a889c3bbcd0b2$var$Disabled = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.Disabled, $d39a889c3bbcd0b2$var$Hidden = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.Hidden, $d39a889c3bbcd0b2$var$Today = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.Today, $d39a889c3bbcd0b2$var$RangeEnd = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.RangeEnd, $d39a889c3bbcd0b2$var$RangeMiddle = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.RangeMiddle, $d39a889c3bbcd0b2$var$RangeStart = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.RangeStart, $d39a889c3bbcd0b2$var$Outside = $d39a889c3bbcd0b2$export$7652a4f8ecc53eb5.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function $d39a889c3bbcd0b2$var$getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[$d39a889c3bbcd0b2$var$Selected] = $d39a889c3bbcd0b2$var$matcherToArray(dayPicker.selected), _a[$d39a889c3bbcd0b2$var$Disabled] = $d39a889c3bbcd0b2$var$matcherToArray(dayPicker.disabled), _a[$d39a889c3bbcd0b2$var$Hidden] = $d39a889c3bbcd0b2$var$matcherToArray(dayPicker.hidden), _a[$d39a889c3bbcd0b2$var$Today] = [
        dayPicker.today
    ], _a[$d39a889c3bbcd0b2$var$RangeEnd] = [], _a[$d39a889c3bbcd0b2$var$RangeMiddle] = [], _a[$d39a889c3bbcd0b2$var$RangeStart] = [], _a[$d39a889c3bbcd0b2$var$Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[$d39a889c3bbcd0b2$var$Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[$d39a889c3bbcd0b2$var$Disabled].push({
        after: dayPicker.toDate
    });
    if ($d39a889c3bbcd0b2$export$2d8c2b43ec0e528(dayPicker)) internalModifiers[$d39a889c3bbcd0b2$var$Disabled] = internalModifiers[$d39a889c3bbcd0b2$var$Disabled].concat(selectMultiple.modifiers[$d39a889c3bbcd0b2$var$Disabled]);
    else if ($d39a889c3bbcd0b2$export$f7b9f96866ec1964(dayPicker)) {
        internalModifiers[$d39a889c3bbcd0b2$var$Disabled] = internalModifiers[$d39a889c3bbcd0b2$var$Disabled].concat(selectRange.modifiers[$d39a889c3bbcd0b2$var$Disabled]);
        internalModifiers[$d39a889c3bbcd0b2$var$RangeStart] = selectRange.modifiers[$d39a889c3bbcd0b2$var$RangeStart];
        internalModifiers[$d39a889c3bbcd0b2$var$RangeMiddle] = selectRange.modifiers[$d39a889c3bbcd0b2$var$RangeMiddle];
        internalModifiers[$d39a889c3bbcd0b2$var$RangeEnd] = selectRange.modifiers[$d39a889c3bbcd0b2$var$RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var $d39a889c3bbcd0b2$var$ModifiersContext = (0, $eFMZj.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function $d39a889c3bbcd0b2$var$ModifiersProvider(props) {
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var selectMultiple = $d39a889c3bbcd0b2$export$458361db477d8ed0();
    var selectRange = $d39a889c3bbcd0b2$export$ad0998138eb321e7();
    var internalModifiers = $d39a889c3bbcd0b2$var$getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = $d39a889c3bbcd0b2$var$getCustomModifiers(dayPicker.modifiers);
    var modifiers = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, internalModifiers), customModifiers);
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$ModifiersContext.Provider, {
        value: modifiers,
        children: props.children
    });
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function $d39a889c3bbcd0b2$var$useModifiers() {
    var context = (0, $eFMZj.useContext)($d39a889c3bbcd0b2$var$ModifiersContext);
    if (!context) throw new Error("useModifiers must be used within a ModifiersProvider");
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function $d39a889c3bbcd0b2$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function $d39a889c3bbcd0b2$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function $d39a889c3bbcd0b2$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function $d39a889c3bbcd0b2$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function $d39a889c3bbcd0b2$export$483c833837970a3(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
/** Return `true` whether `date` is inside `range`. */ function $d39a889c3bbcd0b2$var$isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(to, from) < 0;
        if (isRangeInverted) _a = [
            to,
            from
        ], from = _a[0], to = _a[1];
        var isInRange = (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(date, from) >= 0 && (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(to, date) >= 0;
        return isInRange;
    }
    if (to) return (0, $4a2650a25edc3aa6$exports.isSameDay)(to, date);
    if (from) return (0, $4a2650a25edc3aa6$exports.isSameDay)(from, date);
    return false;
}
/** Returns true if `value` is a Date type. */ function $d39a889c3bbcd0b2$var$isDateType(value) {
    return (0, $4a2650a25edc3aa6$exports.isDate)(value);
}
/** Returns true if `value` is an array of valid dates. */ function $d39a889c3bbcd0b2$var$isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, $4a2650a25edc3aa6$exports.isDate));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function $d39a889c3bbcd0b2$export$b74c33566721f70f(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === "boolean") return matcher;
        if ($d39a889c3bbcd0b2$var$isDateType(matcher)) return (0, $4a2650a25edc3aa6$exports.isSameDay)(day, matcher);
        if ($d39a889c3bbcd0b2$var$isArrayOfDates(matcher)) return matcher.includes(day);
        if ($d39a889c3bbcd0b2$export$dd455b9c98fea187(matcher)) return $d39a889c3bbcd0b2$var$isDateInRange(day, matcher);
        if ($d39a889c3bbcd0b2$export$483c833837970a3(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if ($d39a889c3bbcd0b2$export$654311eaff47f3cd(matcher)) {
            var diffBefore = (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(matcher.before, day);
            var diffAfter = (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, $4a2650a25edc3aa6$exports.isAfter)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ($d39a889c3bbcd0b2$export$4760905e07020cd4(matcher)) return (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(day, matcher.after) > 0;
        if ($d39a889c3bbcd0b2$export$a3bef2c4e855ef4e(matcher)) return (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(matcher.before, day) > 0;
        if (typeof matcher === "function") return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function $d39a889c3bbcd0b2$var$getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if ($d39a889c3bbcd0b2$export$b74c33566721f70f(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, $4a2650a25edc3aa6$exports.isSameMonth)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function $d39a889c3bbcd0b2$var$getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, $4a2650a25edc3aa6$exports.startOfMonth)(displayMonths[0]);
    var lastDayInMonth = (0, $4a2650a25edc3aa6$exports.endOfMonth)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = $d39a889c3bbcd0b2$var$getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, $4a2650a25edc3aa6$exports.addDays)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, $4a2650a25edc3aa6$exports.addDays)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var $d39a889c3bbcd0b2$var$MAX_RETRY = 365;
/** Return the next date to be focused. */ function $d39a889c3bbcd0b2$var$getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, $4a2650a25edc3aa6$exports.addDays),
        week: (0, $4a2650a25edc3aa6$exports.addWeeks),
        month: (0, $4a2650a25edc3aa6$exports.addMonths),
        year: (0, $4a2650a25edc3aa6$exports.addYears),
        startOfWeek: function(date) {
            return context.ISOWeek ? (0, $4a2650a25edc3aa6$exports.startOfISOWeek)(date) : (0, $4a2650a25edc3aa6$exports.startOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function(date) {
            return context.ISOWeek ? (0, $4a2650a25edc3aa6$exports.endOfISOWeek)(date) : (0, $4a2650a25edc3aa6$exports.endOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === "after" ? 1 : -1);
    if (direction === "before" && fromDate) newFocusedDay = (0, $4a2650a25edc3aa6$exports.max)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === "after" && toDate) newFocusedDay = (0, $4a2650a25edc3aa6$exports.min)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = $d39a889c3bbcd0b2$var$getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > $d39a889c3bbcd0b2$var$MAX_RETRY) return retry.lastFocused;
        return $d39a889c3bbcd0b2$var$getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var $d39a889c3bbcd0b2$export$e1f21ba6aeca320f = (0, $eFMZj.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function $d39a889c3bbcd0b2$export$97cf4ab9b312b61a(props) {
    var navigation = $d39a889c3bbcd0b2$export$d0fd4b7106de2769();
    var modifiers = $d39a889c3bbcd0b2$var$useModifiers();
    var _a = (0, $eFMZj.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, $eFMZj.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = $d39a889c3bbcd0b2$var$getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function(date) {
        setFocusedDay(date);
    };
    var context = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var moveFocus = function(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = $d39a889c3bbcd0b2$var$getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, $4a2650a25edc3aa6$exports.isSameDay)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function() {
            return moveFocus("day", "after");
        },
        focusDayBefore: function() {
            return moveFocus("day", "before");
        },
        focusWeekAfter: function() {
            return moveFocus("week", "after");
        },
        focusWeekBefore: function() {
            return moveFocus("week", "before");
        },
        focusMonthBefore: function() {
            return moveFocus("month", "before");
        },
        focusMonthAfter: function() {
            return moveFocus("month", "after");
        },
        focusYearBefore: function() {
            return moveFocus("year", "before");
        },
        focusYearAfter: function() {
            return moveFocus("year", "after");
        },
        focusStartOfWeek: function() {
            return moveFocus("startOfWeek", "before");
        },
        focusEndOfWeek: function() {
            return moveFocus("endOfWeek", "after");
        }
    };
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$e1f21ba6aeca320f.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $d39a889c3bbcd0b2$export$69130071837c676e() {
    var context = (0, $eFMZj.useContext)($d39a889c3bbcd0b2$export$e1f21ba6aeca320f);
    if (!context) throw new Error("useFocusContext must be used within a FocusProvider");
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function $d39a889c3bbcd0b2$export$174df9b23ec1eb4b(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = $d39a889c3bbcd0b2$var$useModifiers();
    var activeModifiers = $d39a889c3bbcd0b2$var$getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var $d39a889c3bbcd0b2$export$9632b0427d86eff3 = (0, $eFMZj.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function $d39a889c3bbcd0b2$export$d40a11a5bbe785ba(props) {
    if (!$d39a889c3bbcd0b2$export$e659ce9b264ea61(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$9632b0427d86eff3.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$37bf09040cff7c3b, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $d39a889c3bbcd0b2$export$37bf09040cff7c3b(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$9632b0427d86eff3.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $d39a889c3bbcd0b2$export$2d75d772c98e4b05() {
    var context = (0, $eFMZj.useContext)($d39a889c3bbcd0b2$export$9632b0427d86eff3);
    if (!context) throw new Error("useSelectSingle must be used within a SelectSingleProvider");
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function $d39a889c3bbcd0b2$var$useDayEventHandlers(date, activeModifiers) {
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var single = $d39a889c3bbcd0b2$export$2d75d772c98e4b05();
    var multiple = $d39a889c3bbcd0b2$export$458361db477d8ed0();
    var range = $d39a889c3bbcd0b2$export$ad0998138eb321e7();
    var _a = $d39a889c3bbcd0b2$export$69130071837c676e(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function(e) {
        var _a, _b, _c, _d;
        if ($d39a889c3bbcd0b2$export$e659ce9b264ea61(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if ($d39a889c3bbcd0b2$export$2d8c2b43ec0e528(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if ($d39a889c3bbcd0b2$export$f7b9f96866ec1964(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function(e) {
        var _a;
        switch(e.key){
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayAfter() : focusDayBefore();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayBefore() : focusDayAfter();
                break;
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case "PageUp":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case "PageDown":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case "Home":
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case "End":
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function $d39a889c3bbcd0b2$var$useSelectedDays() {
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var single = $d39a889c3bbcd0b2$export$2d75d772c98e4b05();
    var multiple = $d39a889c3bbcd0b2$export$458361db477d8ed0();
    var range = $d39a889c3bbcd0b2$export$ad0998138eb321e7();
    var selectedDays = $d39a889c3bbcd0b2$export$e659ce9b264ea61(dayPicker) ? single.selected : $d39a889c3bbcd0b2$export$2d8c2b43ec0e528(dayPicker) ? multiple.selected : $d39a889c3bbcd0b2$export$f7b9f96866ec1964(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function $d39a889c3bbcd0b2$var$isInternalModifier(modifier) {
    return Object.values($d39a889c3bbcd0b2$export$7652a4f8ecc53eb5).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function $d39a889c3bbcd0b2$var$getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if ($d39a889c3bbcd0b2$var$isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function $d39a889c3bbcd0b2$var$getDayStyle(dayPicker, activeModifiers) {
    var style = $d39a889c3bbcd0b2$var$__assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function $d39a889c3bbcd0b2$export$634dab6d85b953fc(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var focusContext = $d39a889c3bbcd0b2$export$69130071837c676e();
    var activeModifiers = $d39a889c3bbcd0b2$export$174df9b23ec1eb4b(day, displayMonth);
    var eventHandlers = $d39a889c3bbcd0b2$var$useDayEventHandlers(day, activeModifiers);
    var selectedDays = $d39a889c3bbcd0b2$var$useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== "default");
    // Focus the button if the day is focused according to the focus context
    (0, $eFMZj.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, $4a2650a25edc3aa6$exports.isSameDay)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = $d39a889c3bbcd0b2$var$getDayClassNames(dayPicker, activeModifiers).join(" ");
    var style = $d39a889c3bbcd0b2$var$getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : $d39a889c3bbcd0b2$export$16d0634337daf8ec;
    var children = (0, $fe00083af124a348$exports.jsx)(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: "gridcell"
    };
    var isFocusTarget = focusContext.focusTarget && (0, $4a2650a25edc3aa6$exports.isSameDay)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, $4a2650a25edc3aa6$exports.isSameDay)(focusContext.focusedDay, day);
    var buttonProps = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: "gridcell"
    }, _a["aria-selected"] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function $d39a889c3bbcd0b2$export$7a9a31a911eb9a20(props) {
    var buttonRef = (0, $eFMZj.useRef)(null);
    var dayRender = $d39a889c3bbcd0b2$export$634dab6d85b953fc(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return (0, $fe00083af124a348$exports.jsx)("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return (0, $fe00083af124a348$exports.jsx)("div", $d39a889c3bbcd0b2$var$__assign({}, dayRender.divProps));
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$353f5b6fc5456de1, $d39a889c3bbcd0b2$var$__assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function $d39a889c3bbcd0b2$export$f52f5e0fedb732da(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return (0, $fe00083af124a348$exports.jsx)("span", {
        className: classNames.weeknumber,
        style: styles.weeknumber,
        children: content
    });
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$353f5b6fc5456de1, {
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick,
        children: content
    });
}
/** Render a row in the calendar, with the days and the week number. */ function $d39a889c3bbcd0b2$export$b59bdbef9ce70de2(props) {
    var _a, _b;
    var _c = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$7a9a31a911eb9a20;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : $d39a889c3bbcd0b2$export$f52f5e0fedb732da;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = (0, $fe00083af124a348$exports.jsx)("td", {
        className: classNames.cell,
        style: styles.cell,
        children: (0, $fe00083af124a348$exports.jsx)(WeeknumberComponent, {
            number: props.weekNumber,
            dates: props.dates
        })
    });
    return (0, $fe00083af124a348$exports.jsxs)("tr", {
        className: classNames.row,
        style: styles.row,
        children: [
            weekNumberCell,
            props.dates.map(function(date) {
                return (0, $fe00083af124a348$exports.jsx)("td", {
                    className: classNames.cell,
                    style: styles.cell,
                    role: "presentation",
                    children: (0, $fe00083af124a348$exports.jsx)(DayComponent, {
                        displayMonth: props.displayMonth,
                        date: date
                    })
                }, (0, $4a2650a25edc3aa6$exports.getUnixTime)(date));
            })
        ]
    });
}
/** Return the weeks between two dates.  */ function $d39a889c3bbcd0b2$var$daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $4a2650a25edc3aa6$exports.endOfISOWeek)(toDate) : (0, $4a2650a25edc3aa6$exports.endOfWeek)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $4a2650a25edc3aa6$exports.startOfISOWeek)(fromDate) : (0, $4a2650a25edc3aa6$exports.startOfWeek)(fromDate, options);
    var nOfDays = (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, $4a2650a25edc3aa6$exports.addDays)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $4a2650a25edc3aa6$exports.getISOWeek)(date) : (0, $4a2650a25edc3aa6$exports.getWeek)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function $d39a889c3bbcd0b2$var$getMonthWeeks(month, options) {
    var weeksInMonth = $d39a889c3bbcd0b2$var$daysToMonthWeeks((0, $4a2650a25edc3aa6$exports.startOfMonth)(month), (0, $4a2650a25edc3aa6$exports.endOfMonth)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, $4a2650a25edc3aa6$exports.getWeeksInMonth)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, $4a2650a25edc3aa6$exports.addWeeks)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = $d39a889c3bbcd0b2$var$daysToMonthWeeks((0, $4a2650a25edc3aa6$exports.addWeeks)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function $d39a889c3bbcd0b2$var$Table(props) {
    var _a, _b, _c;
    var _d = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = $d39a889c3bbcd0b2$var$getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : $d39a889c3bbcd0b2$export$e93312b7773dfcac;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : $d39a889c3bbcd0b2$export$b59bdbef9ce70de2;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : $d39a889c3bbcd0b2$export$a06f1c675e846f6f;
    return (0, $fe00083af124a348$exports.jsxs)("table", {
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props["aria-labelledby"],
        children: [
            !hideHead && (0, $fe00083af124a348$exports.jsx)(HeadComponent, {}),
            (0, $fe00083af124a348$exports.jsx)("tbody", {
                className: classNames.tbody,
                style: styles.tbody,
                children: weeks.map(function(week) {
                    return (0, $fe00083af124a348$exports.jsx)(RowComponent, {
                        displayMonth: props.displayMonth,
                        dates: week.dates,
                        weekNumber: week.weekNumber
                    }, week.weekNumber);
                })
            }),
            (0, $fe00083af124a348$exports.jsx)(FooterComponent, {
                displayMonth: props.displayMonth
            })
        ]
    });
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /* eslint-disable prefer-const */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ function $d39a889c3bbcd0b2$var$canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $d39a889c3bbcd0b2$var$useIsomorphicLayoutEffect = $d39a889c3bbcd0b2$var$canUseDOM() ? (0, $eFMZj.useLayoutEffect) : (0, $eFMZj.useEffect);
var $d39a889c3bbcd0b2$var$serverHandoffComplete = false;
var $d39a889c3bbcd0b2$var$id = 0;
function $d39a889c3bbcd0b2$var$genId() {
    return "react-day-picker-".concat(++$d39a889c3bbcd0b2$var$id);
}
function $d39a889c3bbcd0b2$var$useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : $d39a889c3bbcd0b2$var$serverHandoffComplete ? $d39a889c3bbcd0b2$var$genId() : null;
    var _b = (0, $eFMZj.useState)(initialId), id = _b[0], setId = _b[1];
    $d39a889c3bbcd0b2$var$useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId($d39a889c3bbcd0b2$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eFMZj.useEffect)(function() {
        if ($d39a889c3bbcd0b2$var$serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        $d39a889c3bbcd0b2$var$serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function $d39a889c3bbcd0b2$var$Month(props) {
    var _a;
    var _b;
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = $d39a889c3bbcd0b2$export$d0fd4b7106de2769().displayMonths;
    var captionId = $d39a889c3bbcd0b2$var$useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === "rtl") _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : $d39a889c3bbcd0b2$export$32fbfacc5d962e0c;
    return (0, $fe00083af124a348$exports.jsxs)("div", {
        className: className.join(" "),
        style: style,
        children: [
            (0, $fe00083af124a348$exports.jsx)(CaptionComponent, {
                id: captionId,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$Table, {
                id: tableId,
                "aria-labelledby": captionId,
                displayMonth: props.displayMonth
            })
        ]
    }, props.displayIndex);
}
/**
 * Render the wrapper for the month grids.
 */ function $d39a889c3bbcd0b2$export$a0ec4efdb90fa181(props) {
    var _a = $d39a889c3bbcd0b2$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    return (0, $fe00083af124a348$exports.jsx)("div", {
        className: classNames.months,
        style: styles.months,
        children: props.children
    });
}
/** Render the container with the months according to the number of months to display. */ function $d39a889c3bbcd0b2$var$Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = $d39a889c3bbcd0b2$export$332e9e0d64b1f294();
    var focusContext = $d39a889c3bbcd0b2$export$69130071837c676e();
    var navigation = $d39a889c3bbcd0b2$export$d0fd4b7106de2769();
    var _d = (0, $eFMZj.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0, $eFMZj.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith("data-");
    }).reduce(function(attrs, key) {
        var _a;
        return $d39a889c3bbcd0b2$var$__assign($d39a889c3bbcd0b2$var$__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : $d39a889c3bbcd0b2$export$a0ec4efdb90fa181;
    return (0, $fe00083af124a348$exports.jsx)("div", $d39a889c3bbcd0b2$var$__assign({
        className: classNames.join(" "),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id,
        nonce: initialProps.nonce,
        title: initialProps.title,
        lang: initialProps.lang
    }, dataAttributes, {
        children: (0, $fe00083af124a348$exports.jsx)(MonthsComponent, {
            children: navigation.displayMonths.map(function(month, i) {
                return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$Month, {
                    displayIndex: i,
                    displayMonth: month
                }, i);
            })
        })
    }));
}
/** Provide the value for all the context providers. */ function $d39a889c3bbcd0b2$export$8f349d07558f59c4(props) {
    var children = props.children, initialProps = $d39a889c3bbcd0b2$var$__rest(props, [
        "children"
    ]);
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$a84f964d022d25c, {
        initialProps: initialProps,
        children: (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$d91daf425539f32f, {
            children: (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$d40a11a5bbe785ba, {
                initialProps: initialProps,
                children: (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$913827019032c8d4, {
                    initialProps: initialProps,
                    children: (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$deb49a47c7ee5fdf, {
                        initialProps: initialProps,
                        children: (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$ModifiersProvider, {
                            children: (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$97cf4ab9b312b61a, {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function $d39a889c3bbcd0b2$export$97e6db89a86ff7ab(props) {
    return (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$export$8f349d07558f59c4, $d39a889c3bbcd0b2$var$__assign({}, props, {
        children: (0, $fe00083af124a348$exports.jsx)($d39a889c3bbcd0b2$var$Root, {
            initialProps: props
        })
    }));
}
/** @private */ function $d39a889c3bbcd0b2$var$isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function $d39a889c3bbcd0b2$export$1e36b9f257eee5fa(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, $2650d1a625c02db9$exports.enUS) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? "PP" : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = $d39a889c3bbcd0b2$var$parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function(value) {
        return (0, $4a2650a25edc3aa6$exports.parse)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, $eFMZj.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, $eFMZj.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, $4a2650a25edc3aa6$exports.format)(defaultSelected, format$1, {
        locale: locale
    }) : "";
    var _g = (0, $eFMZj.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : "");
    };
    var setSelected = function(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, $4a2650a25edc3aa6$exports.format)(date, format$1, {
            locale: locale
        }) : "");
    };
    var handleDayClick = function(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue("");
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, $4a2650a25edc3aa6$exports.format)(day, format$1, {
            locale: locale
        }) : "");
    };
    var handleMonthChange = function(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(fromDate, day) > 0;
        var isAfter = toDate && (0, $4a2650a25edc3aa6$exports.differenceInCalendarDays)(day, toDate) > 0;
        if (!$d39a889c3bbcd0b2$var$isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function(e) {
        var day = parseValue(e.target.value);
        if (!$d39a889c3bbcd0b2$var$isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if ($d39a889c3bbcd0b2$var$isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, $4a2650a25edc3aa6$exports.format)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function $d39a889c3bbcd0b2$export$92cab9761365b1ec(props) {
    return props.mode === undefined || props.mode === "default";
}



const $8f3a95bfa37cc076$var$BookDetails = ()=>{
    const location = (0, $72fa3923970c35a7$export$45d76561a5302f2b)();
    const [book, setBook] = (0, $eFMZj.useState)(undefined);
    const [bookPrices, setBookPrices] = (0, $eFMZj.useState)(null);
    const [sellers, setSellers] = (0, $eFMZj.useState)(Array());
    const [labels, setLabels] = (0, $eFMZj.useState)([]);
    const [data, setData] = (0, $eFMZj.useState)(null);
    const initialRange = {
        from: new Date(),
        to: (0, $f9cba28c27e4fe95$export$dd412b56f1e4d8aa)(new Date(), 4)
    };
    const [range, setRange] = (0, $eFMZj.useState)(initialRange);
    console.log("range", range);
    const book_id = (0, $eFMZj.useMemo)(()=>{
        return location.pathname.substring(location.pathname.lastIndexOf("_") + 1);
    }, [
        location
    ]);
    (0, $eFMZj.useEffect)(()=>{
        const fetchBooks = async ()=>{
            const response = await (0, $a64b320130750adf$export$be7c2acc48adceee)(book_id);
            setBook(response.data);
        };
        if (location.state) setBook(location.state.book);
        else fetchBooks();
    }, []);
    (0, $eFMZj.useEffect)(()=>{
        const fetchBookPrices = async ()=>{
            const response = await (0, $a64b320130750adf$export$c6bbc0ad86b096be)(book_id);
            setBookPrices(response.data);
        };
        fetchBookPrices();
    }, []);
    (0, $eFMZj.useMemo)(()=>{
        if (bookPrices) {
            async function fetchSellers() {
                const sellers = new Set(bookPrices.map((price)=>price.seller));
                const sellersString = String([
                    ...sellers
                ].join(","));
                const response = await (0, $8d9070921b077ed1$export$b24c985f13a29127)(sellersString);
                const BookSeller = response.data.map((seller)=>{
                    return {
                        id: seller[0],
                        name: seller[1],
                        show: true,
                        color: `#${Math.floor(Math.random() * 16777215).toString(16)}`
                    };
                });
                // setLabels(Array.from(new Set(bookPrices.map(price => price.date))))
                setSellers(BookSeller);
            }
            fetchSellers();
        }
    }, [
        bookPrices
    ]);
    // let labels = []
    (0, $eFMZj.useMemo)(()=>{
        if (!range) {
            const labels = bookPrices?.map((price)=>price.date);
            setLabels([
                ...new Set(labels)
            ]);
        } else {
            const labels = bookPrices?.filter((price)=>{
                const newDate = new Date(price.date);
                return newDate >= range.from && newDate <= range.to;
            }).map((price)=>price.date);
            setLabels([
                ...new Set(labels)
            ]);
        }
    }, [
        range,
        bookPrices
    ]);
    // const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July']
    // console.log("new date", new Date(bookPrices?.[0]?.date))
    (0, $eFMZj.useEffect)(()=>{
        const data = [];
        sellers.map((seller)=>{
            if (!seller.show) return;
            data.push({
                label: seller.name,
                // data: labels.map(() => Math.floor(Math.random() * 10)),
                data: labels.map((label)=>{
                    const price = bookPrices.find((price)=>price.date === label && price.seller === seller.id);
                    console.log("price", price);
                    return price ? price.price : null;
                }),
                borderColor: seller.color,
                backgroundColor: `${seller.color}50`
            });
        });
        setData(data);
    }, [
        labels,
        sellers
    ]);
    if (!data) return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
        children: "Loading..."
    });
    console.log("data", data);
    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
        className: "book-details container",
        children: [
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                className: "back-link",
                children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)((0, $b019c3b4a8678a9e$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: [
                        /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8a5fbc940731a38b$exports))),
                            alt: "back"
                        }),
                        "Back"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
                className: "data-and-actions",
                children: [
                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
                        className: "book-data",
                        children: [
                            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                                className: "book-tile",
                                children: book.title
                            }),
                            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
                                className: "book-des",
                                children: [
                                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("p", {
                                        children: [
                                            "Tltle: ",
                                            book.title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("p", {
                                        children: [
                                            "Authors: ",
                                            book.authors
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("p", {
                                        children: [
                                            "ISBN: ",
                                            book.isbn
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("p", {
                                        children: "Recent price: "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                        className: "book-actions",
                        children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                            className: "time-period",
                            children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
                                children: [
                                    "Choose time period",
                                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $d39a889c3bbcd0b2$export$97e6db89a86ff7ab), {
                                        mode: "range",
                                        selected: range,
                                        onSelect: setRange
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                        className: "download-excel",
                        onClick: ()=>$8f3a95bfa37cc076$var$downloadExcel(book, range, sellers),
                        children: "excel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                className: "checkboxes",
                children: sellers.map((seller)=>{
                    return /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("input", {
                                type: "checkbox",
                                id: seller.id,
                                name: seller.name,
                                checked: seller.show,
                                onChange: ()=>{
                                    const newSellers = sellers.map((s)=>{
                                        if (s.id === seller.id) return {
                                            ...s,
                                            show: !s.show
                                        };
                                        return s;
                                    });
                                    setSellers(newSellers);
                                }
                            }),
                            seller.name
                        ]
                    }, seller.id);
                })
            }),
            /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
                className: "chart",
                children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $6acc28114d203e0f$export$2e2bcd8739ae039), {
                    labels: labels,
                    datasets: data
                })
            })
        ]
    });
};
const $8f3a95bfa37cc076$var$downloadExcel = (book, dateRange, sellers)=>{
    if (!dateRange) {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        (0, $a64b320130750adf$export$1dfe6134a9c18c04)(book, `1900-01-01^${formattedDate}`, sellers);
    } else {
        const dateFrom = new Date(dateRange.from);
        const finalDateFrom = `${dateFrom.getFullYear()}-${dateFrom.getMonth() + 1}-${dateFrom.getDate()}`;
        const dateTo = new Date(dateRange.to);
        const getFinalDateTo = `${dateTo.getFullYear()}-${dateTo.getMonth() + 1}-${dateTo.getDate()}`;
        const finalDate = `${finalDateFrom}^${getFinalDateTo}`;
        (0, $a64b320130750adf$export$1dfe6134a9c18c04)(book, finalDate, sellers);
    }
};
var $8f3a95bfa37cc076$export$2e2bcd8739ae039 // https://react-day-picker.js.org/advanced-guides/custom-selections
 = $8f3a95bfa37cc076$var$BookDetails;




const $cd93687958c8007e$export$86fbec116b87613f = ()=>/*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)((0, $b019c3b4a8678a9e$export$9ba4e89fdfa1fc54), {
            children: [
                /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $193714fcc8f30367$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $fe00083af124a348$exports.jsxs)((0, $72fa3923970c35a7$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $72fa3923970c35a7$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $cfbb0f1268b8f04e$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $72fa3923970c35a7$export$e7b0ac011bb776c6), {
                            path: "addNewBooks",
                            element: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $e61a02728d045410$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $72fa3923970c35a7$export$e7b0ac011bb776c6), {
                            path: "myBookstores",
                            element: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $ffce6c52262ee78e$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $72fa3923970c35a7$export$e7b0ac011bb776c6), {
                            path: "bookDetails/:id",
                            element: /*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $8f3a95bfa37cc076$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });


const $70fc9a727fa662ae$var$root = (0, $ee2623c680381be0$export$882461b6382ed46c)(document.getElementById("app"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $fe00083af124a348$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.da5f6b0c.js.map
